/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: number; output: number; }
  Long: { input: number; output: number; }
  Void: { input: any; output: any; }
};

export type AccessConstraint = {
  partyRole?: InputMaybe<PartyRole>;
};

/** Report Options */
export enum AccountNumbersDisplay {
  Auto = 'Auto',
  Hidden = 'Hidden'
}

export type AccountReconciliation = {
  category: EntityCategory;
  categoryId: Scalars['String']['output'];
  chartOfAccountsId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** creator and updater are nullable when system opened the reconciliation */
  creator?: Maybe<EntityUser>;
  endDate: Date;
  reconciliationId: Scalars['String']['output'];
  startDate: Date;
  status: AccountReconciliationStatus;
  updatedAt: Scalars['DateTime']['output'];
  updater?: Maybe<EntityUser>;
};

export enum AccountReconciliationStatus {
  Draft = 'Draft',
  Finalized = 'Finalized',
  ManualReopened = 'ManualReopened',
  SystemDraft = 'SystemDraft',
  SystemFinalized = 'SystemFinalized',
  SystemReopened = 'SystemReopened',
  Unknown = 'Unknown'
}

export type AccountReconciliations = {
  account: EntityCategory;
  earliestOpenReconciliation?: Maybe<AccountReconciliation>;
  mostRecentFinalizedReconciliation?: Maybe<AccountReconciliation>;
  reconciliations: Array<AccountReconciliation>;
};

export enum AccountingBasis {
  AccrualBasis = 'AccrualBasis',
  CashBasis = 'CashBasis',
  UnknownAccountingBasis = 'UnknownAccountingBasis'
}

export type ActionItem = {
  action: ActionItemAction;
  author?: Maybe<EntityUser>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  flaggedObjectKinds?: Maybe<Array<ObjectKind>>;
  id: Scalars['String']['output'];
  objectTimestamp?: Maybe<Scalars['DateTime']['output']>;
  organizationAssigneeIds: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userAssignees: Array<EntityUser>;
  value: ActionItemValue;
};

export enum ActionItemAction {
  ConnectionInvestmentUpgrade = 'ConnectionInvestmentUpgrade',
  ConnectionLoginRequired = 'ConnectionLoginRequired',
  FinalizeDraftReport = 'FinalizeDraftReport',
  FixReconciliation = 'FixReconciliation',
  QualityControl = 'QualityControl',
  ReviewDraftSchedule = 'ReviewDraftSchedule',
  UnknownAction = 'UnknownAction',
  UploadStatement = 'UploadStatement',
  ViewPublishedReport = 'ViewPublishedReport'
}

export enum ActionItemActionType {
  Approve = 'Approve',
  Pay = 'Pay',
  Review = 'Review',
  Submit = 'Submit',
  UnknownActionType = 'UnknownActionType'
}

export type ActionItemBillApproval = {
  bill: EntityBill;
};

export type ActionItemCategory = {
  category: EntityCategory;
};

export type ActionItemConnection = {
  connection: EntityConnection;
  dataSource: EntityDataSource;
};

export type ActionItemFilter = {
  betaActions?: InputMaybe<Array<ActionItemAction>>;
  externalKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  groups?: InputMaybe<Array<ActionItemGroup>>;
  includeMode?: InputMaybe<Array<ActionItemTargetMode>>;
  objectIdentifiers?: InputMaybe<Array<InputObjectIdentifier>>;
  objectKinds?: InputMaybe<Array<ObjectKind>>;
  status: Array<ActionItemStatus>;
  targetOrganizationIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum ActionItemGroup {
  BillsAndInvoices = 'BillsAndInvoices',
  Book = 'Book',
  Collaboration = 'Collaboration',
  Reconcile = 'Reconcile',
  Report = 'Report',
  Review = 'Review',
  Schedule = 'Schedule',
  Setup = 'Setup',
  UnknownGroup = 'UnknownGroup',
  Urgent = 'Urgent'
}

export enum ActionItemKind {
  Bill = 'Bill',
  Comment = 'Comment',
  Onboarding = 'Onboarding',
  Report = 'Report',
  TransactionReview = 'TransactionReview',
  UnknownActionItemKind = 'UnknownActionItemKind',
  WorkItem = 'WorkItem'
}

export type ActionItemPublishedReport = {
  package: EntityReportPackage;
};

export type ActionItemReconciliation = {
  category: EntityCategory;
  flags: Array<ActionItemReconciliationFlag>;
  reconciliation: EntityReconciliation;
};

export type ActionItemReconciliationFlag = {
  createdAt: Scalars['DateTime']['output'];
  flagId: Scalars['String']['output'];
  flagType: ReconciliationFlagType;
  reconciliationIntentId: Scalars['String']['output'];
  resolutionType?: Maybe<ReconciliationFlagResolutionType>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ActionItemReviewDraftSchedule = {
  transaction: EntityTransaction;
};

export enum ActionItemStatus {
  Closed = 'Closed',
  Completed = 'Completed',
  Created = 'Created',
  Invalidated = 'Invalidated',
  Unknown = 'Unknown'
}

export type ActionItemStatusChange = {
  actionItemId: Scalars['String']['input'];
  status: ActionItemStatus;
};

export type ActionItemSummary = {
  count: Scalars['Long']['output'];
  period: Period;
};

export enum ActionItemTargetMode {
  Assign = 'Assign',
  UnknownTargetMode = 'UnknownTargetMode',
  Watch = 'Watch'
}

export type ActionItemThread = {
  targetEntity: ObjectEntity;
  threadId: Scalars['String']['output'];
};

export type ActionItemTransaction = {
  categorySuggestions?: Maybe<Array<CategorySuggestion>>;
  transaction: EntityTransaction;
};

export type ActionItemUploadStatement = {
  category: EntityCategory;
};

export type ActionItemValue = ActionItemBillApproval | ActionItemCategory | ActionItemConnection | ActionItemPublishedReport | ActionItemReconciliation | ActionItemReviewDraftSchedule | ActionItemThread | ActionItemTransaction | ActionItemUploadStatement;

export type ActionItemsExternalKeySummary = {
  count: Scalars['Long']['output'];
  externalKey: Scalars['String']['output'];
};

export type ActionItemsGroupSummary = {
  count: Scalars['Long']['output'];
  group: ActionItemGroup;
};

export type ActionItemsObjectKindSummary = {
  count: Scalars['Long']['output'];
  objectKind: ObjectKind;
};

/**
 * ActivityEvent represents one event in an ActivityFeed.
 * Note: The objects represented by subject, target and actor_user_id
 *       will be available externally to this message type.
 */
export type ActivityEvent = {
  computedEvent?: Maybe<ComputedEvent>;
  discreteEvent?: Maybe<DiscreteEvent>;
  id: Scalars['String']['output'];
  legalEntityId: Scalars['String']['output'];
  occurredAt: Scalars['DateTime']['output'];
};

export enum ActivityEventInterval {
  AllTime = 'AllTime',
  Day = 'Day',
  Hour = 'Hour',
  Minute = 'Minute',
  Month = 'Month',
  None = 'None',
  Week = 'Week',
  Year = 'Year'
}

/**
 * Activity Feed
 * ActivityFeed contains a sequence of ActivityEvents
 * and a separate structure describing the hydrated form
 * of the object entities referenced by the author/subject/target
 * of the feed's events.
 */
export type ActivityFeed = {
  entities: ObjectEntities;
  events: Array<ActivityEvent>;
};

export type ActivityObjectIdentifier = {
  context?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  kind: ObjectKind;
};

export type AddedFeature = {
  featureId: Scalars['String']['output'];
  invalid: Scalars['Boolean']['output'];
};

export type Address = {
  /** city is used for the city/town/village of the address */
  city?: Maybe<Scalars['String']['output']>;
  /** ISO country code */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** Latitude */
  lat?: Maybe<Scalars['Float']['output']>;
  /** Longitude */
  long?: Maybe<Scalars['Float']['output']>;
  /** postal identifier for the address */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** region is the state, region, or any other subdivision of the country */
  region?: Maybe<Scalars['String']['output']>;
  /** street contains the housing number and street name */
  street?: Maybe<Scalars['String']['output']>;
  /** street_additional is used for any other additional street identifying information */
  streetAdditional?: Maybe<Scalars['String']['output']>;
};

export type AddressFeatureValue = {
  addressValue: Address;
};

export type AddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  long?: InputMaybe<Scalars['Float']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetAdditional?: InputMaybe<Scalars['String']['input']>;
};

export type AdjacentObjectPermission = {
  legalEntity: EntityLegalEntity;
  object: ObjectIdentifier;
  organizationPreview: OrganizationPreview;
  viewType: ViewType;
};

/** Connector Credentials */
export type AdminAppCredential = {
  clientId: Scalars['String']['output'];
  environment: AppEnvironment;
};

export type AdminBillingProduct = {
  isOrganizationEnabled: Scalars['Boolean']['output'];
  product: BillingProduct;
};

export type AdminCategory = {
  category: Category;
  chartOfAccountsDisplayNumber?: Maybe<Scalars['String']['output']>;
  externalAccountSubtype?: Maybe<Scalars['String']['output']>;
  externalAccountType?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  subtype?: Maybe<CategorySubtype>;
  synthesized: Scalars['Boolean']['output'];
};

export type AdminCategoryClassification = {
  category: Category;
  classification: AdminClassification;
  entryType: Scalars['String']['output'];
  transactionFactId: Scalars['String']['output'];
};

export type AdminChartOfAccounts = {
  chart: ChartOfAccounts;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AdminChartOfAccountsFilter = {
  accountingBasis?: InputMaybe<AccountingBasis>;
  global?: InputMaybe<Scalars['Boolean']['input']>;
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
};

export type AdminClassification = {
  createdAt: Scalars['DateTime']['output'];
  legalEntityId: Scalars['String']['output'];
  rule?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['String']['output'];
};

export type AdminConnection = {
  accounts?: Maybe<Array<AdminConnectionAccount>>;
  connectorClassName?: Maybe<Scalars['String']['output']>;
  connectorId: Scalars['String']['output'];
  consentedScopes?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  dataSourceId: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  legalEntityId: Scalars['String']['output'];
  sourceName: Scalars['String']['output'];
  status: ConnectionStatus;
  supportedScopes?: Maybe<Array<Scalars['String']['output']>>;
  sync?: Maybe<ConnectionSyncState>;
};

export type AdminConnectionAccount = {
  connectionId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deleted: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  mask?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sourceAccountId: Scalars['String']['output'];
  status: ConnectionAccountStatus;
  subtype?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type AdminConnectionEvent = {
  affectedCount?: Maybe<Scalars['Long']['output']>;
  connectionEventRef?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dataStatus?: Maybe<Scalars['String']['output']>;
  dataUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  failureReason?: Maybe<ConnectionEventFailureReason>;
  id: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  newestSeen?: Maybe<Scalars['Long']['output']>;
  oldestSeen?: Maybe<Scalars['Long']['output']>;
  source: ConnectionEventSource;
  status: ConnectionEventStatus;
  superUserId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type AdminConnectionList = {
  connections: Array<AdminConnection>;
};

export type AdminConnectionTemplate = {
  connector: Connector;
  externalId?: Maybe<Scalars['String']['output']>;
  institution: ProductInstitution;
};

export type AdminConnector = {
  connector: Connector;
  installCount?: Maybe<Scalars['Long']['output']>;
};

/** Connector Installs */
export type AdminConnectorInstall = {
  connectionId: Scalars['String']['output'];
  connectorId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  legalEntityId: Scalars['String']['output'];
  sourceName: Scalars['String']['output'];
  status: ConnectionStatus;
};

/** Billing */
export type AdminCoupon = {
  amountOff?: Maybe<MonetaryValue>;
  coupon_id: Scalars['String']['output'];
  discountLevel: DiscountLevel;
  duration: CouponDuration;
  durationInMonths: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  percentOff?: Maybe<Scalars['Float']['output']>;
  stripe_coupon_id: Scalars['String']['output'];
  valid: Scalars['Boolean']['output'];
};

export type AdminDoppelgangerPermit = {
  authorizer: Superuser;
  doppelgangerPermit: DoppelgangerPermit;
  justification?: Maybe<Scalars['String']['output']>;
  sessionEndedAt?: Maybe<Scalars['DateTime']['output']>;
  sessionStartedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AdminEmployee = {
  createdAt: Scalars['DateTime']['output'];
  employee: Employee;
  externalId?: Maybe<Scalars['String']['output']>;
  origin: EmployeeOrigin;
  provider?: Maybe<OAuthService>;
};

export type AdminGlobalParty = {
  aliases?: Maybe<Array<Scalars['String']['output']>>;
  lastReviewedAt?: Maybe<Scalars['DateTime']['output']>;
  party: Party;
  prefixes?: Maybe<Array<Scalars['String']['output']>>;
  transactionsCount: Scalars['Long']['output'];
};

export type AdminGlobalVanityStats = {
  activeLegalEntitiesCount: Scalars['Int']['output'];
  activeLegalEntitiesWithDataIssuesCount: Scalars['Int']['output'];
  activeLegalEntitiesWithPlaidConnectionIssuesCount: Scalars['Int']['output'];
  activeLegalEntitiesWithQuickBooksConnectionIssuesCount: Scalars['Int']['output'];
  activeUsersCount: Scalars['Int']['output'];
  appliedSignupsCount: Scalars['Int']['output'];
  approvedSignupsLast30Count: Scalars['Int']['output'];
  averageSignupAppliedAt?: Maybe<Scalars['DateTime']['output']>;
  averageSignupInvitedAt?: Maybe<Scalars['DateTime']['output']>;
  averageSignupPrimedAt?: Maybe<Scalars['DateTime']['output']>;
  averageSignupQualifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated agency party hydration code removed */
  dailyDesignationsCreatedLast30Count: Scalars['Int']['output'];
  /** @deprecated agency party hydration code removed */
  dailyDesignationsModeratedLast30: Scalars['Int']['output'];
  /** @deprecated agency party hydration code removed */
  dailyHydrationsCreatedLast30: Scalars['Int']['output'];
  /** @deprecated agency party hydration code removed */
  dailyHydrationsModeratedLast30: Scalars['Int']['output'];
  /** @deprecated agency party hydration code removed */
  dailyUnlinkedPartiesLast30: Scalars['Int']['output'];
  dayOfInterest?: Maybe<Scalars['DateTime']['output']>;
  globalPartiesCount: Scalars['Int']['output'];
  globalPartiesLast30Count: Scalars['Int']['output'];
  /** @deprecated agency party hydration code removed */
  globalPartiesViaDesignationLast30Count: Scalars['Int']['output'];
  globalPartyTransactionsCount: Scalars['Int']['output'];
  hydratableUnlinkedPartiesCount: Scalars['Int']['output'];
  hydratableUnlinkedRepeatPartiesCount: Scalars['Int']['output'];
  invitedSignupsCount: Scalars['Int']['output'];
  lastSignupApprovedAt?: Maybe<Scalars['DateTime']['output']>;
  legalEntitiesWithDataIssuesCount: Scalars['Int']['output'];
  legalEntitiesWithEngineeringRequiredCount: Scalars['Int']['output'];
  legalEntitiesWithQuickBooksConnectionIssuesCount: Scalars['Int']['output'];
  /** Data Quality */
  legalEntitiesWithValidQuickBooksCount: Scalars['Int']['output'];
  linkedPartiesCount: Scalars['Int']['output'];
  /** @deprecated agency party hydration code removed */
  linkedPartiesLast30Count: Scalars['Int']['output'];
  pendingLegalEntitiesCount: Scalars['Int']['output'];
  primedSignupsCount: Scalars['Int']['output'];
  qualifiedSignupsCount: Scalars['Int']['output'];
  /** Report Validation */
  reportValidations: Array<ReportValidationGlobalPeriodSummary>;
  /** Superseding Rate */
  supersedingRate: Scalars['Int']['output'];
  /**
   * Profile Hydration Throughput
   * @deprecated agency party hydration code removed
   */
  totalHydrationsProcessedCount: Scalars['Int']['output'];
  /** Legal Entities */
  totalLegalEntitiesCount: Scalars['Int']['output'];
  /** Parties */
  totalPartiesCount: Scalars['Int']['output'];
  /** Signups */
  totalSignupsCount: Scalars['Int']['output'];
  totalSignupsLast30Count: Scalars['Int']['output'];
  /** Transactions */
  totalTransactionsCount: Scalars['Int']['output'];
  totalTransactionsValue: MonetaryValue;
  /** @deprecated agency party hydration code removed */
  totalUnmoderatedDesignationsCount: Scalars['Int']['output'];
  /** @deprecated agency party hydration code removed */
  totalUnmoderatedHydrationsCount: Scalars['Int']['output'];
  /** Users */
  totalUsersCount: Scalars['Int']['output'];
  unlinkedPartiesCount: Scalars['Int']['output'];
  /**
   * Designation Throughput
   * @deprecated agency party hydration code removed
   */
  unlinkedPartiesLast30Count: Scalars['Int']['output'];
  unlinkedRepeatPartiesCount: Scalars['Int']['output'];
};

/**
 * Documents
 * Institutions
 */
export type AdminInstitution = {
  id: Scalars['String']['output'];
  institution: Institution;
  party?: Maybe<Party>;
  products: Array<InstitutionProduct>;
};

/** Invitations */
export type AdminInvitation = {
  emailStatus?: Maybe<EmailStatus>;
  invitation: Invitation;
  senderSuperuser?: Maybe<Superuser>;
};

export type AdminLayout = {
  layout: Layout;
  layoutId: Scalars['String']['output'];
  layoutJson: Scalars['String']['output'];
  viewKey: ViewIdentifier;
};

export type AdminLayoutVersion = {
  authorId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  layoutId: Scalars['String']['output'];
  versionId: Scalars['String']['output'];
  viewKey: ViewIdentifier;
};

/** Layouts */
export type AdminLayoutVersions = {
  layoutVersions: Array<AdminLayoutVersion>;
};

export type AdminLegalEntity = {
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  legalEntity: LegalEntity;
  userCount: Scalars['Long']['output'];
};

export type AdminMatchConfiguration = {
  ledgerTransactionIds: Array<Scalars['String']['output']>;
  matchId: Scalars['String']['output'];
  matchType: ManualMatchType;
};

export type AdminOrganization = {
  affiliateLegalEntities: Array<AdminLegalEntity>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  legalEntities: Array<AdminLegalEntity>;
  organization: Organization;
  userCount: Scalars['Long']['output'];
};

export type AdminOrganizationPackage = {
  customProducts: Scalars['Boolean']['output'];
  hasPackage: Scalars['Boolean']['output'];
  packageId: Scalars['String']['output'];
  products: Array<AdminOrganizationPackageProduct>;
};

export type AdminOrganizationPackageProduct = {
  billable: Scalars['Boolean']['output'];
  productDisplayName: Scalars['String']['output'];
  productId: Scalars['String']['output'];
  productName: Scalars['String']['output'];
};

/** Parties */
export type AdminParty = {
  lastTransactionOccurredAt?: Maybe<Scalars['DateTime']['output']>;
  party: Party;
  transactionsCount: Scalars['Long']['output'];
};

export type AdminPartyClassification = {
  classification: AdminClassification;
  overlayName?: Maybe<Scalars['String']['output']>;
  party: Party;
  prefix?: Maybe<Scalars['String']['output']>;
  prefixDescription?: Maybe<Scalars['String']['output']>;
  role: PartyRole;
};

export type AdminPartyExtraction = {
  legalEntityId: Scalars['String']['output'];
  party?: Maybe<Party>;
  partyExtractionId: Scalars['String']['output'];
  partyExtractionKey: Scalars['String']['output'];
  transactionFactId?: Maybe<Scalars['String']['output']>;
};

export type AdminReportPackageDocumentMetadata = {
  documentObjectId: Scalars['String']['output'];
  documentObjectVersionId: Scalars['String']['output'];
  generationHistory?: Maybe<ReportGenerationHistory>;
  id: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  reportFile?: Maybe<ReportFileMetadata>;
  status: ReportPackageDocumentStatus;
  title: Scalars['String']['output'];
  type: ReportPackageDocumentType;
  validationHistories: Array<ReportValidationHistory>;
};

export type AdminReportPackageMetadata = {
  author?: Maybe<Contact>;
  coverUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  documents: Array<AdminReportPackageDocumentMetadata>;
  endedAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  interval: Interval;
  publishedAsDraft: Scalars['Boolean']['output'];
  startedAt: Scalars['DateTime']['output'];
  status: ReportPackageStatus;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  versionId: Scalars['String']['output'];
  viewKey: ViewIdentifier;
};

export type AdminScheduleCategoryHint = {
  excludeNames: Array<Scalars['String']['output']>;
  hint: Scalars['String']['output'];
  names: Array<Scalars['String']['output']>;
  resolved: Scalars['Boolean']['output'];
  strictSubtype: Scalars['Boolean']['output'];
  subtype: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type AdminScheduleCategoryHintBinding = {
  eventDisplayName: Scalars['String']['output'];
  eventTemplateId: Scalars['String']['output'];
  hint: AdminScheduleCategoryHint;
  variableDisplayName: Scalars['String']['output'];
  variableTemplateId: Scalars['String']['output'];
};

export type AdminScheduleEventTemplate = {
  dateSource: Scalars['String']['output'];
  description: Scalars['String']['output'];
  displayKey: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  eventTemplateId: Scalars['String']['output'];
  generatedEventTemplateId: Scalars['String']['output'];
  generatorType: Scalars['String']['output'];
  inCreateFlow: Scalars['Boolean']['output'];
  isInstantiating: Scalars['Boolean']['output'];
  isSingleton: Scalars['Boolean']['output'];
  isTerminating: Scalars['Boolean']['output'];
  journalEntry?: Maybe<AdminScheduleJournalEntryTemplate>;
  name: Scalars['String']['output'];
  ordinal: Scalars['Int']['output'];
  skipConditionExpr: Scalars['String']['output'];
  skipConditionName: Scalars['String']['output'];
  supportedFormulas: Array<AdminScheduleFormulaBinding>;
  variables: Array<AdminScheduleEventVariableTemplate>;
};

export type AdminScheduleEventVariableTemplate = {
  applyExpr: Scalars['String']['output'];
  defaultValue?: Maybe<AdminScheduleVariableDefault>;
  displayMode: ScheduleEventVariableDisplayMode;
  displayName: Scalars['String']['output'];
  ordinal: Scalars['Int']['output'];
  required: Scalars['Boolean']['output'];
  specializable: Scalars['Boolean']['output'];
  validationExpr: Scalars['String']['output'];
  validationMessage: Scalars['String']['output'];
  variableName: Scalars['String']['output'];
  variableTemplateId: Scalars['String']['output'];
  variableType: ScheduleEventVariableType;
};

export type AdminScheduleFormula = {
  displayName: Scalars['String']['output'];
  expression: Scalars['String']['output'];
  formulaId: Scalars['String']['output'];
};

export type AdminScheduleFormulaBinding = {
  displayName: Scalars['String']['output'];
  formulaId: Scalars['String']['output'];
  ordinal: Scalars['Int']['output'];
};

export type AdminScheduleJournalEntryLineTemplate = {
  amountVariable: Scalars['String']['output'];
  categoryVariable: Scalars['String']['output'];
  description: Scalars['String']['output'];
  entryType: Scalars['String']['output'];
  entryTypeExpression: Scalars['String']['output'];
  lineTemplateId: Scalars['String']['output'];
  ordinal: Scalars['Int']['output'];
  skipCondition: Scalars['String']['output'];
};

export type AdminScheduleJournalEntryTemplate = {
  journalEntryTemplateId: Scalars['String']['output'];
  lines: Array<AdminScheduleJournalEntryLineTemplate>;
  memo: Scalars['String']['output'];
  skipCondition: Scalars['String']['output'];
};

export type AdminScheduleSpecialization = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  displayKey: Scalars['String']['output'];
  legalEntityId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  ownerOrganizationId: Scalars['String']['output'];
  scheduleTemplateId: Scalars['String']['output'];
  specializationId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AdminScheduleSpecializationDetail = {
  overrides: Array<AdminScheduleSpecializationVariableOverride>;
  specialization: AdminScheduleSpecialization;
  template: AdminScheduleTemplate;
};

export type AdminScheduleSpecializationVariableOverride = {
  eventTemplateId: Scalars['String']['output'];
  value: AdminScheduleVariableDefault;
  variableTemplateId: Scalars['String']['output'];
};

export type AdminScheduleTemplate = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  displayKey: Scalars['String']['output'];
  events: Array<AdminScheduleEventTemplate>;
  formulas: Array<AdminScheduleFormula>;
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  scheduleTemplateId: Scalars['String']['output'];
  type: ScheduleType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Schedule Templates (Admin) */
export type AdminScheduleTemplateSummary = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  displayKey: Scalars['String']['output'];
  eventCount: Scalars['Int']['output'];
  formulaCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  scheduleTemplateId: Scalars['String']['output'];
  specializationCount: Scalars['Int']['output'];
  type: ScheduleType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  variableCount: Scalars['Int']['output'];
};

export type AdminScheduleVariableDefault = {
  amountValue?: Maybe<MonetaryValue>;
  boolValue: Scalars['Boolean']['output'];
  categoryHint: Scalars['String']['output'];
  dateValue?: Maybe<Scalars['DateTime']['output']>;
  floatValue: Scalars['Float']['output'];
  formulaDisplayName: Scalars['String']['output'];
  formulaId: Scalars['String']['output'];
  intValue: Scalars['Long']['output'];
  intervalValue: Scalars['String']['output'];
  source: Scalars['String']['output'];
  stringValue: Scalars['String']['output'];
};

/** Signups */
export type AdminSignup = {
  createdAt: Scalars['DateTime']['output'];
  signup: Signup;
  timezone?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AdminTransactionEntityExtraction = {
  classificationVersionId: Scalars['String']['output'];
  creditCard?: Maybe<Scalars['String']['output']>;
  creditCardScore?: Maybe<Scalars['Long']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  dateScore?: Maybe<Scalars['Long']['output']>;
  institution?: Maybe<Scalars['String']['output']>;
  institutionScore?: Maybe<Scalars['Long']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  locationScore?: Maybe<Scalars['Long']['output']>;
  party: Scalars['String']['output'];
  partyScore: Scalars['Long']['output'];
  person?: Maybe<Scalars['String']['output']>;
  personScore?: Maybe<Scalars['Long']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneScore?: Maybe<Scalars['Long']['output']>;
  proxy?: Maybe<Scalars['String']['output']>;
  proxyScore?: Maybe<Scalars['Long']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  urlScore?: Maybe<Scalars['Long']['output']>;
};

export type AdminTransactionFact = {
  checkMetadata?: Maybe<AdminTransactionFactCheckMetadata>;
  createdAt: Scalars['DateTime']['output'];
  dataSource: EnrichedDataSource;
  externalCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  externalDescription?: Maybe<Scalars['String']['output']>;
  externalId: Scalars['String']['output'];
  externalModifiedAt?: Maybe<Scalars['DateTime']['output']>;
  externalName: Scalars['String']['output'];
  externalTimestamp: Scalars['DateTime']['output'];
  ledgerTransactionId?: Maybe<Scalars['String']['output']>;
  legalEntityId: Scalars['String']['output'];
  pending: Scalars['Boolean']['output'];
  sourceAccount?: Maybe<SourceAccount>;
  supersededLedgerTransactionIds?: Maybe<Array<Scalars['String']['output']>>;
  supersedingLedgerTransactionId?: Maybe<Scalars['String']['output']>;
  transactionFactId: Scalars['String']['output'];
  transactionType: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AdminTransactionFactCheckMetadata = {
  memo: Scalars['String']['output'];
  payee: Scalars['String']['output'];
  payer: Scalars['String']['output'];
};

export type AdminTransactionFactsWithMatchInfo = {
  matchAlgorithmDescription: Scalars['String']['output'];
  matchSetId: Scalars['String']['output'];
  transactionFacts: Array<AdminTransactionFact>;
};

export type AdminTransactionPair = {
  ledgerTransactionId: Scalars['String']['output'];
  transactionFactId: Scalars['String']['output'];
};

export type AdminTransferSummary = {
  amount: MonetaryValue;
  billOrInvoiceId: Scalars['String']['output'];
  billOrInvoiceType: Scalars['String']['output'];
  category: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  direction: Scalars['String']['output'];
  paymentId: Scalars['String']['output'];
  paymentIntentId: Scalars['String']['output'];
  paymentStatus: Scalars['String']['output'];
  platformPaymentType: Scalars['String']['output'];
  pspReference: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  status: Scalars['String']['output'];
  transferId: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type AdminUser = {
  accountLocked: Scalars['Boolean']['output'];
  affiliations?: Maybe<Array<AdminUserAffiliation>>;
  banned: Scalars['Boolean']['output'];
  employments?: Maybe<Array<AdminUserEmployment>>;
  invitationId?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type AdminUserAffiliation = {
  affiliatedTo?: Maybe<LegalEntity>;
  role: Role;
  userOrganization?: Maybe<Organization>;
};

export type AdminUserEmployment = {
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  employeeId: Scalars['String']['output'];
  legalEntityRoles?: Maybe<Array<EmployeeLegalEntityRole>>;
  organization: Organization;
  role: Role;
  status: EmployeeStatus;
};

/** Vanity */
export type AdminVanityStats = {
  categoriesCount: Scalars['Int']['output'];
  linkedPartiesCount: Scalars['Int']['output'];
  partiesCount: Scalars['Int']['output'];
  totalCalculations: Scalars['Int']['output'];
  totalValue: MonetaryValue;
  transactionsCount: Scalars['Int']['output'];
  usersCount: Scalars['Int']['output'];
};

export type AdminWorkItem = {
  actionable: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  defaultState: WorkItemState;
  generatedQuestions: Array<WorkItemGeneratedQuestion>;
  itemState: WorkItemState;
  itemType: WorkItemType;
  ledgerType: LedgerType;
  legalEntityId: Scalars['String']['output'];
  pushes: Array<WorkItemPush>;
  time: Scalars['DateTime']['output'];
  /** Admin-specific fields. */
  transactionFactId?: Maybe<Scalars['String']['output']>;
  transactionGcsUrl?: Maybe<Scalars['String']['output']>;
  transactions: Array<AdminWorkItemTransaction>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** TODO: Hydrate user. */
  updatedBy?: Maybe<Scalars['String']['output']>;
  userState?: Maybe<WorkItemState>;
  workItemId: Scalars['String']['output'];
};

/** NOTE: This type is not allowed to return amounts because it is used in sensitive areas. */
export type AdminWorkItemTransaction = {
  creditCategory?: Maybe<EntityCategory>;
  dataSourceId?: Maybe<Scalars['String']['output']>;
  debitCategory?: Maybe<EntityCategory>;
  description?: Maybe<Scalars['String']['output']>;
  displayCategory?: Maybe<EntityCategory>;
  /** NOTE: This type is not allowed to return amounts because it is used in sensitive areas. */
  displayEntry: DisplayEntry;
  externalTransactionId: Scalars['String']['output'];
  externalTransactionLineId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  occurredAt?: Maybe<Scalars['DateTime']['output']>;
  party?: Maybe<EntityParty>;
  quickbooksAppName?: Maybe<Scalars['String']['output']>;
  supportType: WorkItemSupportType;
};

export type AdyenAccountHolderStatus = {
  accountHolderStatus?: Maybe<Scalars['String']['output']>;
  checkbookStatus?: Maybe<Scalars['String']['output']>;
  overallStatus: BusinessVerificationStatus;
};

export type AdyenCapabilityStatus = {
  allowed: Scalars['Boolean']['output'];
  capabilityName: Scalars['String']['output'];
  requested: Scalars['Boolean']['output'];
  verificationStatus: Scalars['String']['output'];
};

export type AdyenDocumentDetail = {
  active: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  documentType: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modificationDate?: Maybe<Scalars['DateTime']['output']>;
};

export type AdyenEntityVerification = {
  entityId: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  problems: Array<AdyenVerificationProblem>;
  status: Scalars['String']['output'];
};

export type AdyenEntityVerificationStatus = {
  entityType: Scalars['String']['output'];
  externalLegalEntityId: Scalars['String']['output'];
  verificationStatus: Scalars['String']['output'];
};

export type AdyenLegalEntityStatus = {
  accountHolderStatus?: Maybe<Scalars['String']['output']>;
  checkbookStatus?: Maybe<Scalars['String']['output']>;
  entityStatuses: Array<AdyenEntityVerificationStatus>;
  hasUpcomingDeadlines: Scalars['Boolean']['output'];
  hasVerificationErrors: Scalars['Boolean']['output'];
  legalEntityId: Scalars['String']['output'];
  legalEntityName: Scalars['String']['output'];
  overallStatus: BusinessVerificationStatus;
  statusAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AdyenVerificationDeadline = {
  capability: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
};

export type AdyenVerificationError = {
  code: Scalars['String']['output'];
  entityType?: Maybe<Scalars['String']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  remediationMessage?: Maybe<Scalars['String']['output']>;
};

export type AdyenVerificationProblem = {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  remediationMessage?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type AffiliateOrganization = {
  affiliatedUsers: Array<AffiliateUser>;
  organization: Organization;
  type: AffiliateType;
};

export type AffiliateOrganizations = {
  inviteProposals: Array<InvitationProposal>;
  organizations: Array<AffiliateOrganization>;
};

export enum AffiliateType {
  Accounting = 'Accounting',
  Investment = 'Investment'
}

export type AffiliateUser = {
  role: Role;
  user: User;
};

export type Affiliation = {
  legalEntity: EntityLegalEntity;
  organization: EntityOrganization;
  role: Role;
};

export type AgentEvent = {
  message?: Maybe<Scalars['String']['output']>;
  runStatus: AgentEventStatus;
};

export enum AgentEventStatus {
  Completed = 'Completed',
  InProgress = 'InProgress',
  Queued = 'Queued',
  RequiresAction = 'RequiresAction',
  UnknownRunStatus = 'UnknownRunStatus'
}

export type AgingDimension = {
  by: DimensionSummary;
  summary: TransactionSummary;
};

export type AgingSummary = {
  dimensionSummary: DimensionSummary;
  label: Scalars['String']['output'];
};

export type AgingSummaryChartConfig = {
  /** @deprecated Unused */
  categoryId?: Maybe<Scalars['String']['output']>;
  dimensions: Array<SummaryDimension>;
  kind: ReportKind;
  masks?: Maybe<Array<Array<SummaryDimension>>>;
  origin: ArchiveIntervalOrigin;
};

export type AgingSummaryChartConfigInput = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  dimensions: Array<SummaryDimension>;
  kind: ReportKind;
  masks?: InputMaybe<Array<Array<SummaryDimension>>>;
  origin: IntervalOrigin;
};

export type AmountRuleFilter = {
  amount: MonetaryValue;
  amountRuleFilterId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  operator: ComparisonOperator;
};

export type App = {
  description?: Maybe<Scalars['String']['output']>;
  developerEmail?: Maybe<Scalars['String']['output']>;
  homepageURL?: Maybe<Scalars['String']['output']>;
  iconObjectName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  privacyPolicyURL?: Maybe<Scalars['String']['output']>;
  supportEmail?: Maybe<Scalars['String']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
  termsOfServiceURL?: Maybe<Scalars['String']['output']>;
  visibility: ConnectorVisibility;
};

export type AppAuthorization = {
  app: App;
  eligibleLegalEntities?: Maybe<Array<EntityLegalEntity>>;
  environment: AppEnvironment;
  ineligibleLegalEntities?: Maybe<Array<EntityLegalEntity>>;
};

export type AppConnectorProperties = {
  developerEmail: Scalars['String']['output'];
  homepageURL: Scalars['String']['output'];
  iconObjectName?: Maybe<Scalars['String']['output']>;
  installUri?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['String']['output'];
  privacyPolicyURL?: Maybe<Scalars['String']['output']>;
  redirectUris?: Maybe<Array<Scalars['String']['output']>>;
  scopes?: Maybe<Array<Scalars['String']['output']>>;
  supportEmail: Scalars['String']['output'];
  termsOfServiceURL?: Maybe<Scalars['String']['output']>;
  visibility: ConnectorVisibility;
};

export type AppCredential = {
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  environment: AppEnvironment;
};

export enum AppEnvironment {
  Development = 'Development',
  Production = 'Production'
}

export type AppInstanceProfile = {
  appBundleId: Scalars['String']['input'];
  appName: Scalars['String']['input'];
  appVersion: Scalars['String']['input'];
  deviceModel: Scalars['String']['input'];
  deviceName: Scalars['String']['input'];
  deviceOs: Scalars['String']['input'];
  deviceOsVersion: Scalars['String']['input'];
};

export type AppRedirect = {
  uri: Scalars['String']['output'];
};

export type ApprovalEligibility = {
  legalEntityId: Scalars['String']['output'];
  status: ApprovalEligibilityStatus;
};

export enum ApprovalEligibilityStatus {
  BelowRequiredTransactionCount = 'BelowRequiredTransactionCount',
  DataValidationHealthNotComputed = 'DataValidationHealthNotComputed',
  DataValidationUnhealthy = 'DataValidationUnhealthy',
  /** Error statuses */
  Error = 'Error',
  InvalidQBOLink = 'InvalidQBOLink',
  LedgerViewError = 'LedgerViewError',
  /** Pending i.e. still computing */
  LedgerViewNotComputed = 'LedgerViewNotComputed',
  NoTransactionCount = 'NoTransactionCount',
  Ready = 'Ready',
  ReportValidationNotComputed = 'ReportValidationNotComputed',
  ReportValidationUnhealthy = 'ReportValidationUnhealthy',
  Unknown = 'Unknown'
}

/**
 * TYPES
 *
 */
export type ArchiveIntervalOrigin = {
  index: Scalars['Long']['output'];
  interval: Interval;
  intervalCount?: Maybe<Scalars['Long']['output']>;
  maxTime?: Maybe<Scalars['DateTime']['output']>;
  year: Scalars['Long']['output'];
};

export type ArchivedComponent = {
  data: ComponentData;
  viewId: ViewIdentifier;
};

export enum ArrivalContext {
  ClientPays = 'ClientPays',
  ReportsBuilder = 'ReportsBuilder',
  ResetClientPays = 'ResetClientPays',
  TransactionReview = 'TransactionReview'
}

export type Aspect = {
  admin?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  defaultStatus: AspectStatusValue;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  oneWay?: Maybe<Scalars['Boolean']['output']>;
  propagation: AspectPropagation;
  updatedAt: Scalars['DateTime']['output'];
  visibility: AspectVisibility;
};

export type AspectDataHealth = {
  closedViewDataStatus: HealthStatus;
  importedDataStatus: HealthStatus;
  overallDataStatus: HealthStatus;
};

export type AspectFilter = {
  propagation?: InputMaybe<AspectPropagation>;
  visibility?: InputMaybe<AspectVisibility>;
};

export enum AspectPropagation {
  Employed = 'Employed',
  Grant = 'Grant',
  None = 'None',
  UnknownPropagation = 'UnknownPropagation'
}

export type AspectRequest = {
  aspect: Aspect;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  legalEntityId: Scalars['String']['output'];
  legalEntityName: Scalars['String']['output'];
};

export type AspectRequestMeta = {
  createdAt: Scalars['DateTime']['output'];
  requestor: EntityUser;
};

export type AspectStatus = {
  aspect: Aspect;
  source: AspectStatusSource;
  status: AspectStatusValue;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum AspectStatusSource {
  Admin = 'Admin',
  Billing = 'Billing',
  Internal = 'Internal',
  Invitation = 'Invitation',
  Migration = 'Migration',
  Package = 'Package',
  UnknownSource = 'UnknownSource'
}

export enum AspectStatusValue {
  Disabled = 'Disabled',
  Enabled = 'Enabled'
}

export enum AspectVisibility {
  All = 'All',
  LegalEntityLevel = 'LegalEntityLevel',
  OrganizationLevel = 'OrganizationLevel',
  UnknownVisibility = 'UnknownVisibility'
}

export type Assignee = {
  organization?: InputMaybe<OrganizationAssignee>;
  user?: InputMaybe<UserAssignee>;
};

export type AssistantEvent = {
  comment: Comment;
  kind: AssistantEventKind;
  layout?: Maybe<Layout>;
  suggestions?: Maybe<Array<Scalars['String']['output']>>;
  threadId?: Maybe<Scalars['String']['output']>;
};

export enum AssistantEventKind {
  Complete = 'Complete',
  Error = 'Error',
  Unknown = 'Unknown',
  Update = 'Update'
}

export type AssistantMessage = {
  authorId: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type AssistantThread = {
  messages: Array<AssistantMessage>;
};

export type AssociationHistory = {
  associationIdentifier: AssociationIdentifier;
  documentInfo?: Maybe<DocumentInfo>;
  events: Array<AssociationHistoryEvent>;
};

export type AssociationHistoryEvent = {
  eventTime: Scalars['DateTime']['output'];
  eventType: AssociationHistoryEventType;
  user?: Maybe<EntityUser>;
};

export enum AssociationHistoryEventType {
  Create = 'Create',
  Delete = 'Delete',
  UnknownAssociationHistoryEventType = 'UnknownAssociationHistoryEventType',
  Unlink = 'Unlink',
  Update = 'Update'
}

export type AssociationIdentifier = {
  documentIdentifier: DocumentIdentifier;
  objectIdentifier: ObjectIdentifier;
};

export enum AssociationSource {
  Onboarding = 'Onboarding',
  UnknownSource = 'UnknownSource'
}

export enum AsyncProcessingStatus {
  AsyncProcessingDone = 'AsyncProcessingDone',
  AsyncProcessingError = 'AsyncProcessingError',
  AsyncProcessingStarted = 'AsyncProcessingStarted',
  UnknownAsyncProcessingStatus = 'UnknownAsyncProcessingStatus'
}

export type AuditRule = {
  action: AuditRuleAction;
  amountFilters?: Maybe<Array<AmountRuleFilter>>;
  auditRuleId: Scalars['String']['output'];
  categoryFilters?: Maybe<Array<CategoryRuleFilter>>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  partyFilters?: Maybe<Array<PartyRuleFilter>>;
  ruleState: AuditRuleState;
  type: AuditRuleType;
};

export enum AuditRuleAction {
  CreateBoost = 'CreateBoost',
  SendClientEmail = 'SendClientEmail',
  SendSelfEmail = 'SendSelfEmail',
  UnknownAction = 'UnknownAction'
}

export enum AuditRuleState {
  Disabled = 'Disabled',
  Enabled = 'Enabled',
  UnknownState = 'UnknownState'
}

export type AuditRuleStatus = {
  recentlyUpdated: Scalars['Boolean']['output'];
  type: AuditRuleType;
  updaterType: AuditRuleUpdaterType;
};

export enum AuditRuleType {
  CategorySuggestion = 'CategorySuggestion',
  InParentCategory = 'InParentCategory',
  NewTransaction = 'NewTransaction',
  SensitiveDataSuggestion = 'SensitiveDataSuggestion',
  UnassignedCategorySuggestion = 'UnassignedCategorySuggestion',
  UnassignedVendorSuggestion = 'UnassignedVendorSuggestion',
  UnknownType = 'UnknownType',
  VendorSuggestion = 'VendorSuggestion'
}

export enum AuditRuleUpdaterType {
  System = 'System',
  UnknownUpdaterType = 'UnknownUpdaterType',
  User = 'User'
}

/** Action item */
export enum BackfillActionItemKind {
  ThreadWorkItem = 'ThreadWorkItem',
  Transaction = 'Transaction'
}

export type BadgeCount = {
  count: Scalars['Long']['output'];
};

export type BalanceSummary = {
  period: Period;
  total: PeriodMonetaryValue;
};

export type BankAccount = {
  accountIdMask: Scalars['String']['output'];
  iconObjectName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  institutionName: Scalars['String']['output'];
  isAutoPayout: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nickname: Scalars['String']['output'];
};

export type BankFeedEntry = {
  amount: InputMonetaryValue;
  departmentName?: InputMaybe<Scalars['String']['input']>;
  locationName?: InputMaybe<Scalars['String']['input']>;
  memo: Scalars['String']['input'];
  timestamp: Scalars['DateTime']['input'];
};

export type BillAccess = {
  objectId: Scalars['String']['output'];
  objectKind: BillAccessKind;
  role: BillAccessRole;
};

export enum BillAccessKind {
  UnknownBillAccessKind = 'UnknownBillAccessKind',
  User = 'User'
}

export enum BillAccessRole {
  Approver = 'Approver',
  Payer = 'Payer',
  UnknownBillAccessRole = 'UnknownBillAccessRole',
  Uploader = 'Uploader'
}

export type BillConnectorProperties = {
  /** Bill.com requires manual entry of the credentials so we will not have anything here */
  empty?: Maybe<Scalars['Boolean']['output']>;
};

export type BillEdit = {
  dataSourceBillId: Scalars['String']['input'];
  dataSourceId: Scalars['String']['input'];
  dueDate: Scalars['DateTime']['input'];
};

export enum BillStatus {
  Approved = 'Approved',
  Assigned = 'Assigned',
  Draft = 'Draft',
  MarkedAsPaid = 'MarkedAsPaid',
  New = 'New',
  OnHold = 'OnHold',
  Paid = 'Paid',
  PaymentCanceled = 'PaymentCanceled',
  PaymentCreated = 'PaymentCreated',
  PaymentRejected = 'PaymentRejected',
  PaymentRequiresAttention = 'PaymentRequiresAttention',
  PaymentReturned = 'PaymentReturned',
  Pending = 'Pending',
  Refunded = 'Refunded',
  Rejected = 'Rejected',
  Settled = 'Settled',
  /**
   * Bill_Status proto zero value stringifies to "Unknown"; the resolver emits it
   * verbatim via .String(). A populated bill should never be status 0, but accepting
   * the value keeps a stray status-0 bill from erroring the whole non-null status
   * field. Kept distinct from UnknownBillStatus, which can't be removed (it's a
   * protected mobile enum value).
   */
  Unknown = 'Unknown',
  UnknownBillStatus = 'UnknownBillStatus'
}

export type Billing = BillingAccountingFirm | BillingLegacyFirm | BillingNone | BillingOperator;

export type BillingAccountingFirm = {
  activeSubscription: Scalars['Boolean']['output'];
  /** @deprecated Use firmPaidClients instead. Retained for backwards compatibility with old clients. */
  affiliated: Array<BillingAffiliated>;
  firmPaidClients: Array<BillingFirmPayer>;
  organizationId: Scalars['String']['output'];
  product: BillingProduct;
  selfPaidClients: Array<BillingClientPayer>;
  subscriptionId: Scalars['String']['output'];
};

export type BillingAddress = {
  billingAddress?: Maybe<Address>;
  fullName?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['String']['output'];
};

/** Deprecated: Use BillingFirmPayer instead. Retained for backwards compatibility with old clients. */
export type BillingAffiliated = {
  availablePlans: Array<SubscriptionPlan>;
  legalEntityId: Scalars['String']['output'];
  product: BillingProduct;
};

export type BillingArrangement = {
  legalEntities: Array<BillingArrangementLegalEntityBilling>;
  organizationId: Scalars['String']['output'];
  subscription?: Maybe<BillingArrangementSubscription>;
};

export type BillingArrangementContributor = {
  id: Scalars['String']['output'];
  type: BillingArrangementContributorType;
};

export enum BillingArrangementContributorType {
  LegalEntity = 'LegalEntity',
  Organization = 'Organization',
  UnknownType = 'UnknownType'
}

export type BillingArrangementLegalEntityBilling = {
  eligiblePlans: Array<SubscriptionPlan>;
  legalEntityId: Scalars['String']['output'];
  payerOrganizationId: Scalars['String']['output'];
  payerSubscriptionStatus: BillingArrangementSubscriptionStatus;
  plan?: Maybe<SubscriptionPlan>;
  viewerOrganizationIds: Array<Scalars['String']['output']>;
};

export type BillingArrangementSubscription = {
  items: Array<BillingArrangementSubscriptionItem>;
  stripe?: Maybe<BillingArrangementSubscriptionStripe>;
  subscriptionId: Scalars['String']['output'];
};

export type BillingArrangementSubscriptionItem = {
  contributors: Array<BillingArrangementContributor>;
  plan?: Maybe<SubscriptionPlan>;
};

/** --- Billing Arrangement types --- */
export enum BillingArrangementSubscriptionStatus {
  Active = 'Active',
  Canceled = 'Canceled',
  PastDue = 'PastDue',
  Trialing = 'Trialing',
  UnknownStatus = 'UnknownStatus',
  Unpaid = 'Unpaid'
}

export type BillingArrangementSubscriptionStripe = {
  billingCycleEnd?: Maybe<Scalars['DateTime']['output']>;
  billingCycleStart?: Maybe<Scalars['DateTime']['output']>;
  cancelAt?: Maybe<Scalars['DateTime']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: BillingArrangementSubscriptionStatus;
  trial?: Maybe<BillingTrial>;
};

export type BillingCardDetails = {
  brand: Scalars['String']['output'];
  country: Scalars['String']['output'];
  expMonth: Scalars['Int']['output'];
  expYear: Scalars['Int']['output'];
  last4: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type BillingClientPayer = {
  legalEntityId: Scalars['String']['output'];
  operator: BillingOperator;
};

export type BillingCustomerProfile = {
  cardDetails: BillingCardDetails;
  subscription: BillingSubscription;
};

export type BillingFirmPayer = {
  availablePlans: Array<SubscriptionPlan>;
  /**
   * Whether the firm is currently being charged for this affiliate.
   * Sourced from organization_subscription_affiliation_prices.billed.
   * Reflects whether the price increments the firm's Stripe subscription, not whether the
   * product is intrinsically billable in the catalog.
   */
  billed: Scalars['Boolean']['output'];
  legalEntityId: Scalars['String']['output'];
  product: BillingProduct;
};

export type BillingLegacyFirm = {
  activeSubscription: Scalars['Boolean']['output'];
  organizationId: Scalars['String']['output'];
  product: BillingProduct;
  subscriptionId: Scalars['String']['output'];
};

export type BillingLegalEntityLimit = {
  id: Scalars['String']['output'];
  maxLegalEntityLimit?: Maybe<Scalars['Int']['output']>;
  minLegalEntityLimit: Scalars['Int']['output'];
};

export type BillingNone = {
  /**
   * No known billing plan found
   * Placeholder field required for GraphQL compatibility
   * This field is always ignored and should not be set
   */
  unused: Scalars['Boolean']['output'];
};

export type BillingOperator = {
  activeSubscription: Scalars['Boolean']['output'];
  availableCoupons: Array<Coupon>;
  availablePlans: Array<SubscriptionPlan>;
  organizationId: Scalars['String']['output'];
  product: BillingProduct;
  subscriptionDetails?: Maybe<SubscriptionDetails>;
  subscriptionId: Scalars['String']['output'];
  trial?: Maybe<BillingTrial>;
};

export enum BillingPaymentIntentStatus {
  Cancelled = 'Cancelled',
  Failed = 'Failed',
  Paid = 'Paid',
  UnknownStatus = 'UnknownStatus',
  Upcoming = 'Upcoming'
}

export type BillingPlan = {
  legalEntityLimit?: Maybe<BillingLegalEntityLimit>;
  price: BillingPrice;
  product: BillingProduct;
};

export type BillingPreview = {
  amountDue: MonetaryValue;
  monthlyBillingDay: Scalars['Long']['output'];
  proratedAmount: MonetaryValue;
  subscriptionCoupons?: Maybe<Array<Coupon>>;
};

export type BillingPrice = {
  amount: MonetaryValue;
  id: Scalars['String']['output'];
  interval: Interval;
  intervalCount?: Maybe<Scalars['Int']['output']>;
};

export type BillingProduct = {
  availability: BillingProductAvailability;
  billable: Scalars['Boolean']['output'];
  callout?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  listing: ProductListing;
  name: BillingProductName;
  trialPeriodDays?: Maybe<Scalars['Int']['output']>;
};

export enum BillingProductAvailability {
  Default = 'Default',
  None = 'None',
  Optional = 'Optional',
  UnknownAvailability = 'UnknownAvailability'
}

export enum BillingProductName {
  AIAccounting = 'AIAccounting',
  AffiliatedAIAccounting = 'AffiliatedAIAccounting',
  AffiliatedEssentials = 'AffiliatedEssentials',
  AffiliatedFirmBooks = 'AffiliatedFirmBooks',
  AffiliatedLedgerOnly = 'AffiliatedLedgerOnly',
  AffiliatedLowVolume = 'AffiliatedLowVolume',
  AffiliatedReportsOnly = 'AffiliatedReportsOnly',
  AffiliatedStarter = 'AffiliatedStarter',
  Essentials = 'Essentials',
  Free = 'Free',
  FreeForever = 'FreeForever',
  Growth = 'Growth',
  Premium = 'Premium',
  ProspectFirm = 'ProspectFirm',
  UnknownName = 'UnknownName'
}

export type BillingSubscription = {
  id: Scalars['String']['output'];
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
};

export type BillingSubscriptionHistory = {
  cardDetails?: Maybe<BillingCardDetails>;
  createdAt: Scalars['DateTime']['output'];
  invoiceURL: Scalars['String']['output'];
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  prorationAmount: MonetaryValue;
  recurringAmount: MonetaryValue;
  status: BillingPaymentIntentStatus;
  totalAmount: MonetaryValue;
};

export enum BillingSubscriptionStatus {
  Active = 'Active',
  All = 'All',
  Canceled = 'Canceled',
  Incomplete = 'Incomplete',
  IncompleteExpired = 'IncompleteExpired',
  PastDue = 'PastDue',
  Trialing = 'Trialing',
  Unknown = 'Unknown',
  Unpaid = 'Unpaid'
}

export type BillingSubscriptionWithoutStatus = {
  id: Scalars['String']['output'];
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
};

export type BillingTrial = {
  end: Scalars['DateTime']['output'];
  start: Scalars['DateTime']['output'];
};

export type BooksClosedDate = {
  latestBooksClosedDateFact?: Maybe<Scalars['DateTime']['output']>;
  legalEntityId: Scalars['String']['output'];
  user?: Maybe<EntityUser>;
  /** @deprecated unused */
  viewBooksClosedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type BooksClosedFact = {
  booksClosedDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dataSourceId?: Maybe<Scalars['String']['output']>;
  legalEntityId: Scalars['String']['output'];
  superUserId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** Business Verification (KYBC) */
export enum BusinessVerificationStatus {
  Expired = 'Expired',
  InProgress = 'InProgress',
  Pending = 'Pending',
  Rejected = 'Rejected',
  Unknown = 'Unknown',
  Unverified = 'Unverified',
  Verified = 'Verified',
  VerifiedInGracePeriod = 'VerifiedInGracePeriod'
}

export type BusinessVerificationStatusResult = {
  status: BusinessVerificationStatus;
  statusAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CsvColumnMappingInput = {
  columns: Array<ColumnAssignmentInput>;
  options?: InputMaybe<CsvParseOptionsInput>;
};

export enum CsvFieldType {
  Amount = 'Amount',
  Credit = 'Credit',
  Date = 'Date',
  Debit = 'Debit',
  Department = 'Department',
  Description = 'Description',
  Location = 'Location'
}

export type CsvParseOptionsInput = {
  dateFormat?: InputMaybe<Scalars['String']['input']>;
  invertSign?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CanonicalCategoryType {
  Cash = 'Cash',
  CashNoClearing = 'CashNoClearing',
  Unknown = 'Unknown'
}

export type CardHolder = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CashSummary = {
  cashChange: DimensionSummary;
  cashTotal: DimensionSummary;
};

export type CashSummaryChartConfig = {
  origin: ArchiveIntervalOrigin;
};

export type CashSummaryChartConfigInput = {
  origin: IntervalOrigin;
};

/** Categories */
export type Category = {
  active: Scalars['Boolean']['output'];
  ancestors?: Maybe<Array<EntityCategory>>;
  categoryState: CategoryState;
  description: Scalars['String']['output'];
  displayKey: Scalars['String']['output'];
  displayNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentCategoryId?: Maybe<Scalars['String']['output']>;
  productArea?: Maybe<ProductArea>;
  subtype: CategorySubtype;
  synthesized?: Maybe<Scalars['Boolean']['output']>;
  type: CategoryType;
};

/** Balances */
export type CategoryBalanceFilter = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  categoryType?: InputMaybe<CategoryType>;
  includeCategoryChildren?: InputMaybe<Scalars['Boolean']['input']>;
  legalEntityId: Scalars['String']['input'];
  productArea?: InputMaybe<ProductArea>;
  viewVersion?: InputMaybe<Scalars['String']['input']>;
};

export type CategoryByDepartmentChartConfig = {
  categoryId: Scalars['String']['output'];
  departmentIds: Array<Scalars['String']['output']>;
  origin: ArchiveIntervalOrigin;
};

export type CategoryByDepartmentChartConfigInput = {
  categoryId: Scalars['String']['input'];
  departmentIds: Array<Scalars['String']['input']>;
  origin: IntervalOrigin;
};

export type CategoryByDepartmentOptions = {
  departmentIds?: Maybe<Array<Scalars['String']['output']>>;
  departments?: Maybe<Array<DepartmentOption>>;
  showOther?: Maybe<Scalars['Boolean']['output']>;
  showUnassigned?: Maybe<Scalars['Boolean']['output']>;
};

export type CategoryByDepartmentOptionsInput = {
  departmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  departments?: InputMaybe<Array<DepartmentOptionInput>>;
  showOther?: InputMaybe<Scalars['Boolean']['input']>;
  showUnassigned?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CategoryByLocationChartConfig = {
  categoryId: Scalars['String']['output'];
  locationIds: Array<Scalars['String']['output']>;
  origin: ArchiveIntervalOrigin;
};

export type CategoryByLocationChartConfigInput = {
  categoryId: Scalars['String']['input'];
  locationIds: Array<Scalars['String']['input']>;
  origin: IntervalOrigin;
};

export type CategoryByLocationOptions = {
  locationIds?: Maybe<Array<Scalars['String']['output']>>;
  locations?: Maybe<Array<LocationOption>>;
  showOther?: Maybe<Scalars['Boolean']['output']>;
  showUnassigned?: Maybe<Scalars['Boolean']['output']>;
};

export type CategoryByLocationOptionsInput = {
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  locations?: InputMaybe<Array<LocationOptionInput>>;
  showOther?: InputMaybe<Scalars['Boolean']['input']>;
  showUnassigned?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CategoryChartConfig = {
  asPermanent?: Maybe<Scalars['Boolean']['output']>;
  categoryId: Scalars['String']['output'];
  origin: ArchiveIntervalOrigin;
  withoutCategoryAncestors?: Maybe<Scalars['Boolean']['output']>;
};

export type CategoryChartConfigInput = {
  asPermanent?: InputMaybe<Scalars['Boolean']['input']>;
  categoryId: Scalars['String']['input'];
  origin: IntervalOrigin;
  withoutCategoryAncestors?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CategoryDimension = {
  by: DimensionSummary;
  categoryId: Scalars['String']['output'];
  categoryObject: EntityCategory;
  summary: TransactionSummary;
};

export type CategoryFacet = {
  categoryObject: EntityCategory;
  count: Scalars['Int']['output'];
};

export type CategoryHover = {
  balance?: Maybe<Scalars['Boolean']['output']>;
  context?: Maybe<DimensionSummary>;
  entity: EntityCategory;
  history: DimensionSummary;
  missingClass?: Maybe<DimensionSummary>;
  otherClass?: Maybe<DimensionSummary>;
  topTransactions?: Maybe<Array<EntityTransaction>>;
};

export type CategoryIntegrations = {
  categoryId: Scalars['String']['output'];
  connect: Array<ConnectionCategoryIntegrations>;
  pay?: Maybe<PayCategoryIntegrations>;
};

/** Inputs */
export type CategoryLabelInput = {
  categoryId: Scalars['String']['input'];
  label: Scalars['String']['input'];
};

/** Category Mappings */
export type CategoryMapping = {
  category: EntityCategory;
  mappingType: CategoryToLabelMappingType;
  mappingValue: Scalars['String']['output'];
  product: CategoryToLabelMappingProduct;
};

export type CategoryParams = {
  categoryIcon?: InputMaybe<Scalars['String']['input']>;
  categoryId: Scalars['String']['input'];
  categoryName: Scalars['String']['input'];
};

export type CategoryRef = {
  id: Scalars['String']['output'];
};

export type CategoryRuleFilter = {
  categories: Array<CategoryRuleFilterCategory>;
  categoryRuleFilterId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  operation: Operation;
};

export type CategoryRuleFilterCategory = {
  categoryId: Scalars['String']['output'];
  categoryName: Scalars['String']['output'];
};

export enum CategoryState {
  CategoryActive = 'CategoryActive',
  CategoryDisabled = 'CategoryDisabled',
  CategoryInactive = 'CategoryInactive',
  UnknownCategoryState = 'UnknownCategoryState'
}

export enum CategorySubtype {
  AccountsPayable = 'AccountsPayable',
  AccountsReceivable = 'AccountsReceivable',
  AccruedExpenses = 'AccruedExpenses',
  AccruedRevenue = 'AccruedRevenue',
  AdditionalPaidInCapital = 'AdditionalPaidInCapital',
  AssetClearing = 'AssetClearing',
  BadDebtExpense = 'BadDebtExpense',
  BankAccounts = 'BankAccounts',
  BusinessApplicationsAndSoftware = 'BusinessApplicationsAndSoftware',
  CommonStock = 'CommonStock',
  ConvertibleNotes = 'ConvertibleNotes',
  CostOfGoods = 'CostOfGoods',
  CostOfLabor = 'CostOfLabor',
  CreditCardRewards = 'CreditCardRewards',
  CreditCards = 'CreditCards',
  DeferredRevenue = 'DeferredRevenue',
  DepreciationAndAmortization = 'DepreciationAndAmortization',
  Facilities = 'Facilities',
  FixedAssets = 'FixedAssets',
  GeneralOperations = 'GeneralOperations',
  Goodwill = 'Goodwill',
  HostingFees = 'HostingFees',
  IntangibleAssets = 'IntangibleAssets',
  InterestAndDividends = 'InterestAndDividends',
  InterestExpense = 'InterestExpense',
  Inventory = 'Inventory',
  Investments = 'Investments',
  LiabilityClearing = 'LiabilityClearing',
  LongTermDebt = 'LongTermDebt',
  None = 'None',
  Other = 'Other',
  OtherComprehensiveIncome = 'OtherComprehensiveIncome',
  OtherCostOfRevenue = 'OtherCostOfRevenue',
  OtherCurrentAssets = 'OtherCurrentAssets',
  OtherCurrentLiabilities = 'OtherCurrentLiabilities',
  OtherLongTermAssets = 'OtherLongTermAssets',
  OtherLongTermLiabilities = 'OtherLongTermLiabilities',
  OtherMiscellaneousExpenses = 'OtherMiscellaneousExpenses',
  OtherMiscellaneousIncome = 'OtherMiscellaneousIncome',
  OwnersEquity = 'OwnersEquity',
  PartnerRevenue = 'PartnerRevenue',
  PaymentProcessingFees = 'PaymentProcessingFees',
  Payroll = 'Payroll',
  PayrollExpenses = 'PayrollExpenses',
  Pending = 'Pending',
  PreferredStock = 'PreferredStock',
  PrepaidExpenses = 'PrepaidExpenses',
  ProfessionalFees = 'ProfessionalFees',
  RefundsAndDiscounts = 'RefundsAndDiscounts',
  RetainedEarnings = 'RetainedEarnings',
  Safes = 'Safes',
  SalesAndMarketing = 'SalesAndMarketing',
  SalesRevenue = 'SalesRevenue',
  ShareholderLoans = 'ShareholderLoans',
  ShortTermDebt = 'ShortTermDebt',
  SubscriptionRevenue = 'SubscriptionRevenue',
  SuppliesAndMaterials = 'SuppliesAndMaterials',
  Taxes = 'Taxes',
  TransactionRevenue = 'TransactionRevenue',
  TravelAndEntertainment = 'TravelAndEntertainment',
  TreasuryStock = 'TreasuryStock',
  UncategorizedAssets = 'UncategorizedAssets',
  UncategorizedEquity = 'UncategorizedEquity',
  UncategorizedExpense = 'UncategorizedExpense',
  UncategorizedIncome = 'UncategorizedIncome',
  /**
   * Prior values
   * UnknownSubtype
   * Payroll
   * Pending
   * Current values
   */
  UnknownSubtype = 'UnknownSubtype'
}

/** Category Suggestions */
export type CategorySuggestion = {
  categoryId: Scalars['String']['output'];
  classificationVersionId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  dataSourceId: Scalars['String']['output'];
  modelConfidence?: Maybe<Scalars['Long']['output']>;
  modelVersionId?: Maybe<Scalars['String']['output']>;
  priority: Scalars['Long']['output'];
  transactionFactId: Scalars['String']['output'];
  type: EntryType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum CategoryToLabelMappingLabel {
  AccountsPayable = 'AccountsPayable',
  AccountsReceivable = 'AccountsReceivable',
  CashAccount = 'CashAccount',
  ClearingAccount = 'ClearingAccount',
  ContraRevenue = 'ContraRevenue',
  Fees = 'Fees',
  SalesRevenue = 'SalesRevenue',
  UncategorizedExpenses = 'UncategorizedExpenses',
  UnknownLabel = 'UnknownLabel'
}

export enum CategoryToLabelMappingProduct {
  DigitsPayAP = 'DigitsPayAP',
  DigitsPayAR = 'DigitsPayAR',
  UnknownProduct = 'UnknownProduct'
}

export enum CategoryToLabelMappingType {
  CategoryLabel = 'CategoryLabel',
  PaymentInstrument = 'PaymentInstrument',
  UnknownType = 'UnknownType'
}

export enum CategoryType {
  Assets = 'Assets',
  CostOfGoodsSold = 'CostOfGoodsSold',
  Equity = 'Equity',
  Expenses = 'Expenses',
  Income = 'Income',
  Liabilities = 'Liabilities',
  OtherExpenses = 'OtherExpenses',
  OtherIncome = 'OtherIncome',
  UnknownType = 'UnknownType'
}

export type CategoryTypeDimension = {
  by: DimensionSummary;
  summary: TransactionSummary;
};

export type ChangeDateFlagDetails = {
  statementLineItem: StatementLineItem;
  suggestedDate: Scalars['DateTime']['output'];
  transaction: Transaction;
  transactionFactId: Scalars['String']['output'];
};

export type Chart = {
  entity: ObjectEntity;
  summary: DimensionSummary;
};

/** Chart of Accounts */
export type ChartOfAccounts = {
  accountingBasis: AccountingBasis;
  categories: Array<Category>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ChartOfAccountsListEntry = {
  accountingBasis: AccountingBasis;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  legalEntityId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type ChartOfAccountsTemplate = {
  categories: Array<TemplateCategory>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  templateId: Scalars['String']['output'];
};

export type ChartOfAccountsTemplateSummary = {
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  templateId: Scalars['String']['output'];
};

export type CheckAffiliatedSubscriptionProduct = {
  exists: Scalars['Boolean']['output'];
  product?: Maybe<BillingProduct>;
};

export type CheckBillingCustomerProfile = {
  billingCustomerProfile?: Maybe<BillingCustomerProfile>;
  exists: Scalars['Boolean']['output'];
};

export type CheckBillingPlan = {
  billingPlan?: Maybe<BillingPlan>;
  exists: Scalars['Boolean']['output'];
  subscriptionDetails?: Maybe<SubscriptionDetails>;
  trial?: Maybe<BillingTrial>;
};

/** Checks */
export enum CheckbookStatus {
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  IN_PROCESS = 'IN_PROCESS',
  MAILED = 'MAILED',
  PAID = 'PAID',
  PRINTED = 'PRINTED',
  VOID = 'VOID'
}

export enum ClassificationConfidenceLevel {
  Default = 'Default',
  Low = 'Low',
  Unspecified = 'Unspecified'
}

export type ClassificationManifestSummary = {
  boundaryDate?: Maybe<Scalars['DateTime']['output']>;
  classifiedCount: Scalars['Int']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  legalEntityId: Scalars['String']['output'];
  manifestId: Scalars['String']['output'];
  skipReasonSummaries: Array<SkipReasonSummary>;
  skippedCount: Scalars['Int']['output'];
  transactionCount: Scalars['Int']['output'];
  trigger: Scalars['String']['output'];
};

export type ClassificationProvenance = {
  changedAt?: Maybe<Scalars['DateTime']['output']>;
  confidenceLevel: ClassificationConfidenceLevel;
  settingsName?: Maybe<Scalars['String']['output']>;
  source?: Maybe<TransactionSource>;
  type: ClassificationProvenanceType;
};

export enum ClassificationProvenanceType {
  AICompanyModel = 'AICompanyModel',
  AIFallbackMapping = 'AIFallbackMapping',
  AIFirmModel = 'AIFirmModel',
  AIGlobalModel = 'AIGlobalModel',
  AILLMFallthrough = 'AILLMFallthrough',
  Manual = 'Manual',
  StaticMapping = 'StaticMapping',
  Unknown = 'Unknown'
}

export enum ClassificationSource {
  Digits = 'Digits',
  Manual = 'Manual',
  None = 'None',
  QuickBooks = 'QuickBooks'
}

export type ClassificationValidation = {
  creditCategoryName?: Maybe<Scalars['String']['output']>;
  debitCategoryName?: Maybe<Scalars['String']['output']>;
  employeeOwnerName?: Maybe<Scalars['String']['output']>;
  expectationId?: Maybe<Scalars['String']['output']>;
  facts: Array<ClassificationValidationExpectationFact>;
  legalEntityId: Scalars['String']['output'];
  partyIconUrl?: Maybe<Scalars['String']['output']>;
  partyName?: Maybe<Scalars['String']['output']>;
  partyRole?: Maybe<PartyRole>;
  status: ExpectationStatus;
};

export type ClassificationValidationExpectationFact = {
  dataSourceId: Scalars['String']['output'];
  transactionFactId: Scalars['String']['output'];
};

export type ClassificationValidationFailure = {
  expectation: ClassificationValidation;
  failureDetails: Array<ClassificationValidationFailureDetail>;
};

export type ClassificationValidationFailureDetail = {
  actualValue?: Maybe<Scalars['String']['output']>;
  expectationType?: Maybe<ExpectationType>;
  expectedValue?: Maybe<Scalars['String']['output']>;
};

export type ClassificationValidationSummary = {
  numberOfLegalEntities?: Maybe<Scalars['Long']['output']>;
  passingValidations?: Maybe<Scalars['Long']['output']>;
  totalValidations?: Maybe<Scalars['Long']['output']>;
};

export type ClosedWorkItem = {
  ignoredFields: Array<WorkItemPushFieldType>;
  workItemId: Scalars['String']['input'];
};

export type ClusteredPrefix = {
  prefix: Scalars['String']['output'];
  transactionCount: Scalars['Long']['output'];
};

export type CollapsedSections = {
  sections: Array<Scalars['String']['output']>;
};

export type CollapsedSectionsInput = {
  sections: Array<Scalars['String']['input']>;
};

export type ColumnAssignmentInput = {
  field: CsvFieldType;
  headerName: Scalars['String']['input'];
};

/**
 * Comment represents a single thread comment, with additional
 * properties resolved by the backend.
 */
export type Comment = {
  authorId: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  layoutAttachment?: Maybe<LayoutAttachment>;
  reactions?: Maybe<Array<CommentReaction>>;
  text: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export enum CommentReaction {
  Dislike = 'Dislike',
  Like = 'Like',
  UnknownReaction = 'UnknownReaction'
}

export type CommentWithEntities = {
  comment: Comment;
  entities?: Maybe<ObjectEntities>;
};

export type CompanyDetails = {
  address?: Maybe<Address>;
  categories?: Maybe<Array<Scalars['String']['output']>>;
  companyName: Scalars['String']['output'];
  companySize?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  foreignSubsidiaryCount?: Maybe<Scalars['String']['output']>;
  incorporationState?: Maybe<Scalars['String']['output']>;
  incorporationYear?: Maybe<Scalars['String']['output']>;
  lastTaxFiling?: Maybe<Scalars['String']['output']>;
  subsidiaryCount?: Maybe<Scalars['String']['output']>;
  websiteURL?: Maybe<Scalars['String']['output']>;
};

export type CompanyDetailsInput = {
  address?: InputMaybe<AddressInput>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  companyName: Scalars['String']['input'];
  companySize?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  foreignSubsidiaryCount?: InputMaybe<Scalars['String']['input']>;
  incorporationState?: InputMaybe<Scalars['String']['input']>;
  incorporationYear?: InputMaybe<Scalars['String']['input']>;
  lastTaxFiling?: InputMaybe<Scalars['String']['input']>;
  subsidiaryCount?: InputMaybe<Scalars['String']['input']>;
  websiteURL?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyFinancialValue = {
  institutionId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type CompanyFinancialValueInput = {
  institutionId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CompanyFinancials = {
  product: InstitutionProduct;
  values: Array<CompanyFinancialValue>;
};

export type CompanyFinancialsInput = {
  product: InstitutionProduct;
  values: Array<CompanyFinancialValueInput>;
};

export enum ComparisonOperator {
  EqualTo = 'EqualTo',
  GreaterThan = 'GreaterThan',
  LessThan = 'LessThan',
  UnknownComparisonOperator = 'UnknownComparisonOperator'
}

export enum CompileSource {
  SpeedLayer = 'SpeedLayer',
  UnknownCompileSource = 'UnknownCompileSource',
  ViewGeneration = 'ViewGeneration',
  ViewGenerationIncomplete = 'ViewGenerationIncomplete'
}

export type ComponentData = CashSummary | Chart | DimensionSummary | EntitiesList | EntityHovers | InsightComponent | LocationSummary | Runway | SourceAccountMetric | Statement | TopEntities | TopTransactions;

/**
 * ComputedEvent represents batches of activity feed events
 * that are counted over a given interval
 */
export type ComputedEvent = {
  eventInterval: ActivityEventInterval;
  kind: ComputedEventKind;
  priority?: Maybe<Scalars['Float']['output']>;
  value: Scalars['Float']['output'];
};

export enum ComputedEventKind {
  AssetInsights = 'AssetInsights',
  ClassifiedCategory = 'ClassifiedCategory',
  ClassifiedCustomer = 'ClassifiedCustomer',
  ClassifiedSupplier = 'ClassifiedSupplier',
  ClassifiedVendor = 'ClassifiedVendor',
  EquityInsights = 'EquityInsights',
  ExpenseInsights = 'ExpenseInsights',
  LiabilityInsights = 'LiabilityInsights',
  MatchedTransactions = 'MatchedTransactions',
  NewRecurringTransactions = 'NewRecurringTransactions',
  NewTransactions = 'NewTransactions',
  NewVendors = 'NewVendors',
  PerformedCalculations = 'PerformedCalculations',
  RevenueInsights = 'RevenueInsights',
  UpdatedVendors = 'UpdatedVendors',
  VendorTransactions = 'VendorTransactions'
}

export type ConnectCredentialInput = {
  password?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectInstitutionInput = {
  kind: InstitutionKind;
  name: Scalars['String']['input'];
};

export type ConnectToken = {
  token: Scalars['String']['output'];
};

export type Connection = {
  accounts?: Maybe<Array<ConnectionAccount>>;
  authorizationDescription?: Maybe<Scalars['String']['output']>;
  authorizationReason?: Maybe<Scalars['String']['output']>;
  authorizationRequired?: Maybe<Scalars['Boolean']['output']>;
  connector?: Maybe<Connector>;
  connectorClassName?: Maybe<Scalars['String']['output']>;
  connectorUpgrade?: Maybe<Connector>;
  dataSourceId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  scopes?: Maybe<Array<Scalars['String']['output']>>;
  settings?: Maybe<ConnectionSettings>;
  sourceIconURL?: Maybe<Scalars['String']['output']>;
  sourceName: Scalars['String']['output'];
  /** stripe, plaid */
  status: ConnectionStatus;
  sync?: Maybe<ConnectionSyncState>;
  upgradedFromConnectionId?: Maybe<Scalars['String']['output']>;
};

export type ConnectionAccount = {
  cardHolders?: Maybe<Array<CardHolder>>;
  connectionId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  mask?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<ConnectionAccountSettings>;
  sourceAccountId: Scalars['String']['output'];
  status: ConnectionAccountStatus;
  statusUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ConnectionAccountInput = {
  connectionAccountId: Scalars['String']['input'];
  settings: ConnectionAccountSettingsInput;
};

export type ConnectionAccountSettings = {
  cutoverDate?: Maybe<Scalars['DateTime']['output']>;
  labelCategories?: Maybe<Array<LabelCategory>>;
};

export type ConnectionAccountSettingsInput = {
  categoryLabels?: InputMaybe<Array<CategoryLabelInput>>;
  cutoverDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum ConnectionAccountStatus {
  Active = 'Active',
  Archived = 'Archived',
  Pending = 'Pending',
  Removed = 'Removed',
  UnknownAccountStatus = 'UnknownAccountStatus'
}

export type ConnectionAccountSummary = {
  cardHolders?: Maybe<Array<CardHolder>>;
  connectionId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  mask?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sourceAccountId: Scalars['String']['output'];
  status: ConnectionAccountStatus;
  statusUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ConnectionBadgeCountFilter = {
  authorizationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  connectionStatuses?: InputMaybe<Array<ConnectionStatus>>;
  legalEntityIds: Array<Scalars['String']['input']>;
  syncStatuses?: InputMaybe<Array<ConnectionSyncStatus>>;
};

export type ConnectionCategoryIntegrations = {
  connectionAccountSummaries: Array<ConnectionAccountSummary>;
  party?: Maybe<EntityParty>;
};

export enum ConnectionEventFailureReason {
  AuthenticationError = 'AuthenticationError',
  InternalError = 'InternalError',
  RemoteError = 'RemoteError'
}

export enum ConnectionEventSource {
  API = 'API',
  Admin = 'Admin',
  Runner = 'Runner',
  Scheduler = 'Scheduler',
  User = 'User'
}

export enum ConnectionEventStatus {
  Archived = 'Archived',
  Authenticated = 'Authenticated',
  BillPaymentsProgress = 'BillPaymentsProgress',
  BillsProgress = 'BillsProgress',
  Configured = 'Configured',
  ContractorsProgress = 'ContractorsProgress',
  Created = 'Created',
  CustomersProgress = 'CustomersProgress',
  Deleted = 'Deleted',
  Disabled = 'Disabled',
  Enabled = 'Enabled',
  Failed = 'Failed',
  InvestmentsProgress = 'InvestmentsProgress',
  InvoicePaymentsProgress = 'InvoicePaymentsProgress',
  InvoicesProgress = 'InvoicesProgress',
  PartialSuccess = 'PartialSuccess',
  PartiesProgress = 'PartiesProgress',
  ProductsProgress = 'ProductsProgress',
  Reset = 'Reset',
  StatementsProgress = 'StatementsProgress',
  Succeeded = 'Succeeded',
  SyncNow = 'SyncNow',
  SystemDisabled = 'SystemDisabled',
  TransactionsProgress = 'TransactionsProgress',
  Triggered = 'Triggered',
  VendorsProgress = 'VendorsProgress'
}

export type ConnectionFeatureFlag = {
  code: Scalars['String']['output'];
  connectionId: Scalars['String']['output'];
  connectorId: Scalars['String']['output'];
  description: Scalars['String']['output'];
  featureFlagId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: ConnectionFeatureFlagStatusValue;
};

export enum ConnectionFeatureFlagStatusValue {
  Disabled = 'Disabled',
  Enabled = 'Enabled'
}

export type ConnectionSettings = {
  cutoverDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ConnectionSettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ConnectionStatus {
  AccountsPending = 'AccountsPending',
  ActivationPending = 'ActivationPending',
  Archived = 'Archived',
  ConfigurationPending = 'ConfigurationPending',
  DelayedActivation = 'DelayedActivation',
  Disabled = 'Disabled',
  Enabled = 'Enabled',
  SystemDisabled = 'SystemDisabled',
  Unknown = 'Unknown',
  Upgraded = 'Upgraded'
}

export type ConnectionSummary = {
  accounts?: Maybe<Array<ConnectionAccountSummary>>;
  authorizationDescription?: Maybe<Scalars['String']['output']>;
  authorizationReason?: Maybe<Scalars['String']['output']>;
  authorizationRequired?: Maybe<Scalars['Boolean']['output']>;
  connector?: Maybe<Connector>;
  connectorClassName?: Maybe<Scalars['String']['output']>;
  connectorUpgrade?: Maybe<Connector>;
  dataSourceId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  scopes?: Maybe<Array<Scalars['String']['output']>>;
  sourceIconURL?: Maybe<Scalars['String']['output']>;
  sourceName: Scalars['String']['output'];
  /** stripe, plaid */
  status: ConnectionStatus;
  sync?: Maybe<ConnectionSyncState>;
  upgradeAvailable?: Maybe<Scalars['Boolean']['output']>;
};

export type ConnectionSyncState = {
  lastEventAt?: Maybe<Scalars['DateTime']['output']>;
  lastSuccessAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<ConnectionSyncStatus>;
};

export enum ConnectionSyncStatus {
  Configured = 'Configured',
  Delayed = 'Delayed',
  Failed = 'Failed',
  LoginRequired = 'LoginRequired',
  Success = 'Success'
}

export type ConnectionTemplate = {
  connector: Connector;
  externalId?: Maybe<Scalars['String']['output']>;
  institution: ProductInstitution;
};

export type Connector = {
  canInstall: Scalars['Boolean']['output'];
  category: ConnectorCategory;
  className?: Maybe<Scalars['String']['output']>;
  connectorProperties?: Maybe<ConnectorProperties>;
  description?: Maybe<Scalars['String']['output']>;
  iconObjectName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  tagline?: Maybe<Scalars['String']['output']>;
};

export enum ConnectorCategory {
  BanksAndCards = 'BanksAndCards',
  CategoryUnspecified = 'CategoryUnspecified',
  Ecommerce = 'Ecommerce',
  ExpenseManagement = 'ExpenseManagement',
  Payment = 'Payment',
  Payroll = 'Payroll'
}

export type ConnectorProperties = AppConnectorProperties | BillConnectorProperties | EmptyConnectorProperties | FinchConnectorProperties | GustoConnectorProperties | PlaidConnectorProperties | RampConnectorProperties | StripeConnectorProperties;

export enum ConnectorVisibility {
  Approved = 'Approved',
  Internal = 'Internal',
  Published = 'Published',
  UnknownVisibility = 'UnknownVisibility'
}

export type Contact = {
  avatarUrl?: Maybe<Scalars['String']['output']>;
  emailAddress: Scalars['String']['output'];
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
};

export type ContactInput = {
  emailAddress: Scalars['String']['input'];
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
};

export type ContractLineItemInput = {
  amount: InputMonetaryValue;
  recurrence: ProductRecurrence;
  stripeProductId: Scalars['String']['input'];
};

export type Coupon = {
  amountOff?: Maybe<MonetaryValue>;
  duration: CouponDuration;
  durationInMonths: Scalars['Long']['output'];
  end?: Maybe<Scalars['DateTime']['output']>;
  percentOff?: Maybe<Scalars['Float']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
  stripePromoCodeId: Scalars['String']['output'];
  valid: Scalars['Boolean']['output'];
};

export enum CouponDuration {
  Forever = 'Forever',
  Once = 'Once',
  Repeating = 'Repeating',
  UnknownDuration = 'UnknownDuration'
}

export enum CoverLogoSource {
  AccountingFirm = 'AccountingFirm',
  Client = 'Client'
}

export type CreateCategoryResponse = {
  categoryId: Scalars['String']['output'];
};

export type CreateClientPaysBillingSubscription = {
  customerId: Scalars['String']['output'];
  productId: Scalars['String']['output'];
  stripeClientSecret: Scalars['String']['output'];
};

export type CreateConnectionResponse = {
  connection: Connection;
};

export type CreateDepartmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayKey?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDepartmentResponse = {
  departmentId: Scalars['String']['output'];
};

export type CreateEnterpriseOrganizationResponse = {
  organizationId: Scalars['String']['output'];
  organizationName: Scalars['String']['output'];
  packageId: Scalars['String']['output'];
};

export type CreateLocationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayKey?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLocationResponse = {
  locationId: Scalars['String']['output'];
};

export type CreateManyTransactionsResponse = {
  createdTransactions: Array<CreateTransactionResponse>;
};

export type CreateNewTransactionFlagDetails = {
  statementLineItem: StatementLineItem;
};

export type CreateReconciliationFlagsTransactionsInput = {
  flagId: Scalars['String']['input'];
  statementLineItem: StatementLineItemInput;
};

export type CreateReconciliationIntentResponse = {
  reconciliationIntentId: Scalars['String']['output'];
  state: ReconciliationIntentState;
};

export type CreateReconciliationIntentsResponse = {
  createReconciliationIntentResponses: Array<CreateReconciliationIntentResponse>;
};

export type CreateStatementImportIntentResponse = {
  statementImportIntentId: Scalars['String']['output'];
};

export type CreateTransactionResponse = {
  ledgerTransactionId?: Maybe<Scalars['String']['output']>;
  transactionFactIds: Array<Scalars['String']['output']>;
};

export type CreatedLegalEntity = {
  legalEntity?: Maybe<LegalEntity>;
  quickBooksCompany?: Maybe<QuickBooksCompany>;
};

export type CreatedQuickBooksDataSource = {
  dataSource?: Maybe<EnrichedDataSource>;
  quickBooksCompany?: Maybe<QuickBooksCompany>;
};

export enum CreationMethod {
  Auto = 'Auto',
  Manual = 'Manual',
  Unknown = 'Unknown',
  Validation = 'Validation'
}

export type CreditCard = {
  /** Card brand (e.g., visa, mastercard, amex) */
  cardBrand?: Maybe<Scalars['String']['output']>;
  /** Expiration month (1-12) */
  cardExpiryMonth?: Maybe<Scalars['Long']['output']>;
  /** Expiration year (e.g., 2025) */
  cardExpiryYear?: Maybe<Scalars['Long']['output']>;
  /** Last 4 digits of the card number */
  cardLastFour?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  nickname: Scalars['String']['output'];
};

export type CsvExportField = {
  fieldName: CsvExportFieldName;
  label?: InputMaybe<Scalars['String']['input']>;
};

export enum CsvExportFieldName {
  CategoryName = 'CategoryName',
  CategoryNumber = 'CategoryNumber',
  DepartmentName = 'DepartmentName',
  LocationName = 'LocationName',
  Memo = 'Memo',
  Party1099Status = 'Party1099Status',
  PartyEntityType = 'PartyEntityType',
  PartyName = 'PartyName',
  PartyW9Status = 'PartyW9Status',
  SplitCategoryName = 'SplitCategoryName',
  SplitCategoryNumber = 'SplitCategoryNumber',
  TaxStatus = 'TaxStatus',
  TransactionAmount = 'TransactionAmount',
  TransactionCreditAmount = 'TransactionCreditAmount',
  TransactionDate = 'TransactionDate',
  TransactionDebitAmount = 'TransactionDebitAmount'
}

export type CsvImport = {
  createdAt: Scalars['DateTime']['output'];
  csvImportId: Scalars['String']['output'];
  dataSourceId: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  fileName: Scalars['String']['output'];
  source: Scalars['String']['output'];
  transactionCount: Scalars['Long']['output'];
};

export type CsvImportSort = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<CsvImportSortOrderBy>;
};

export enum CsvImportSortOrderBy {
  CreatedAt = 'CreatedAt',
  FileName = 'FileName',
  TransactionCount = 'TransactionCount'
}

export type Customer = {
  address?: Maybe<CustomerAddress>;
  email: Scalars['String']['output'];
  finalized?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  providerType: ProviderType;
};

export type CustomerAddress = {
  address?: Maybe<Address>;
  id: Scalars['String']['output'];
};

/** Customer Events (Logs) */
export type CustomerEvent = {
  eventId: Scalars['String']['input'];
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  occurredAt: Scalars['DateTime']['input'];
  payload: CustomerEventPayload;
};

export type CustomerEventPayload = {
  marketingEvent?: InputMaybe<MarketingEvent>;
  pageView?: InputMaybe<PageView>;
  reportAction?: InputMaybe<ReportActionEvent>;
  signUpEvent?: InputMaybe<SignUpEvent>;
};

export type CustomerSummary = {
  email: Scalars['String']['output'];
  finalized?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type DataHealthStatus = {
  allDataSourcesHaveTransactions: Scalars['Boolean']['output'];
  allDataSourcesLinked: Scalars['Boolean']['output'];
  anyDataSourceRequiresEngineering: Scalars['Boolean']['output'];
  hasPlaidDataSource: Scalars['Boolean']['output'];
  validationStatus: ValidationHealthStatus;
};

export type DataSource = {
  accountAlias?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  institution: Institution;
  legalEntityId: Scalars['String']['output'];
  providerType: ProviderType;
  status: DataSourceStatus;
  statusReason?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type DataSourceFetchCountSummary = {
  institutionName: Scalars['String']['output'];
  statTimeBuckets?: Maybe<StatisticByTimeBuckets>;
  success: Scalars['Boolean']['output'];
};

export type DataSourceFetchStats = {
  summaries?: Maybe<Array<DataSourceFetchCountSummary>>;
};

export enum DataSourceJobType {
  QBO_AppendMemo = 'QBO_AppendMemo',
  QBO_AssignVendor = 'QBO_AssignVendor',
  QBO_ChangeCategory = 'QBO_ChangeCategory',
  QBO_RenameVendor = 'QBO_RenameVendor',
  QBO_UpdateDepartment = 'QBO_UpdateDepartment',
  QBO_UpdateLineClass = 'QBO_UpdateLineClass',
  QBO_UpdateTransactionDescription = 'QBO_UpdateTransactionDescription',
  UnknownType = 'UnknownType'
}

export type DataSourceManualRefresh = {
  dataSourceId: Scalars['String']['output'];
  earliestViewVersion?: Maybe<Scalars['String']['output']>;
  errors: Array<DataSourceManualRefreshError>;
  requestedAt: Scalars['DateTime']['output'];
  syncCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  viewFinishedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DataSourceManualRefreshError = {
  erroredAt: Scalars['DateTime']['output'];
};

export type DataSourcePreference = {
  accountingBasis: AccountingBasis;
  dataSourceId: Scalars['String']['output'];
  departmentTerminology?: Maybe<Scalars['String']['output']>;
  providerType: ProviderType;
  taxForm: TaxForm;
};

export enum DataSourceStatus {
  Archived = 'Archived',
  Deleted = 'Deleted',
  EngineeringRequired = 'EngineeringRequired',
  Linked = 'Linked',
  LogInRequired = 'LogInRequired',
  Unknown = 'Unknown',
  Unsupported = 'Unsupported'
}

export type DataSources = {
  legalEntityId: Scalars['String']['output'];
  sources: Array<EnrichedDataSource>;
};

export type Date = {
  day: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type DateFeatureValue = {
  dateValue: Date;
};

export type DateInput = {
  day?: InputMaybe<Scalars['Int']['input']>;
  month?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** DayOfMonth */
export enum DayOfMonth {
  Fifteenth = 'Fifteenth',
  First = 'First',
  Last = 'Last'
}

/** DayOfWeek */
export enum DayOfWeek {
  Friday = 'Friday',
  Monday = 'Monday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}

export type DeletePotentialDuplicateFlagTransactionsInput = {
  deleteUnsettled: Scalars['Boolean']['input'];
  documentFeatureGroupId: Scalars['String']['input'];
  flagId: Scalars['String']['input'];
  reconciledLedgerTransactionId: Scalars['String']['input'];
  unsettledLedgerTransactionId: Scalars['String']['input'];
};

export type DeletedAmountFilter = {
  amountRuleFilterId: Scalars['String']['input'];
  operator: ComparisonOperator;
};

export type DeletedCategory = {
  categoryId: Scalars['String']['input'];
  operation: Operation;
};

export type DeletedCategoryFilter = {
  categoryRuleFilterId: Scalars['String']['input'];
  operation: Operation;
};

export type DenormalizedViewStatus = {
  activeViewCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  legalEntityId: Scalars['String']['output'];
  ongoingViewStartedAt?: Maybe<Scalars['DateTime']['output']>;
  viewType: ViewType;
};

export type DenormalizedViewStatusSummary = {
  entries: Array<DenormalizedViewStatus>;
};

export type Department = {
  active: Scalars['Boolean']['output'];
  ancestors: Array<EntityDepartment>;
  dataSource?: Maybe<EntityDataSource>;
  /** @deprecated Use data source instead */
  dataSourceId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  matches: Array<MatchedDepartment>;
  name: Scalars['String']['output'];
  /** @deprecated Use parentId instead */
  parentDepartmentId?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
};

export type DepartmentChartConfig = {
  departmentId: Scalars['String']['output'];
  origin: ArchiveIntervalOrigin;
};

export type DepartmentChartConfigInput = {
  departmentId: Scalars['String']['input'];
  origin: IntervalOrigin;
};

export type DepartmentDimension = {
  by: DimensionSummary;
  departmentId: Scalars['String']['output'];
  departmentObject: EntityDepartment;
  summary: TransactionSummary;
};

export type DepartmentFacet = {
  count: Scalars['Int']['output'];
  departmentObject: EntityDepartment;
};

export type DepartmentOption = {
  departmentId: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type DepartmentOptionInput = {
  departmentId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export enum DepartmentStatus {
  Active = 'Active',
  Disabled = 'Disabled',
  Unknown = 'Unknown'
}

export type DetailedAdyenStatus = {
  accountHolderId?: Maybe<Scalars['String']['output']>;
  accountHolderStatus?: Maybe<Scalars['String']['output']>;
  capabilities: Array<AdyenCapabilityStatus>;
  checkbookStatus?: Maybe<Scalars['String']['output']>;
  companyVerification?: Maybe<AdyenEntityVerification>;
  deadlines: Array<AdyenVerificationDeadline>;
  documents: Array<AdyenDocumentDetail>;
  externalOrganizationLegalEntityId?: Maybe<Scalars['String']['output']>;
  externalPrimaryLegalEntityId?: Maybe<Scalars['String']['output']>;
  identityVerifications: Array<AdyenEntityVerification>;
  overallStatus: BusinessVerificationStatus;
  statusAt?: Maybe<Scalars['DateTime']['output']>;
  verificationErrors: Array<AdyenVerificationError>;
};

export type DigitsWorkItemPushParams = {
  categoryParams?: InputMaybe<CategoryParams>;
  partyParams?: InputMaybe<PartyParams>;
  skipClose?: InputMaybe<Scalars['Boolean']['input']>;
  workItemId: Scalars['String']['input'];
};

export type DimensionFacetField = {
  kind: DimensionFacetKind;
  type: FacetType;
};

export enum DimensionFacetKind {
  UnknownDimensionKind = 'UnknownDimensionKind'
}

export type DimensionPaginationInput = {
  page: Pagination;
  sortBy: DimensionalSortBy;
  sortDirection: SortDirection;
};

export enum DimensionSortMode {
  Active = 'Active',
  Growing = 'Growing',
  Shrinking = 'Shrinking',
  Total = 'Total'
}

export type DimensionSummary = {
  aggregateFacetCount?: Maybe<Scalars['Int']['output']>;
  aging: Array<AgingDimension>;
  category: Array<CategoryDimension>;
  categoryType: Array<CategoryTypeDimension>;
  department: Array<DepartmentDimension>;
  location: Array<LocationDimension>;
  partialData: Scalars['Boolean']['output'];
  party: Array<PartyDimension>;
  schedule: Array<ScheduleDimension>;
  /**
   * Summary implements dimensionless top-level summaries.
   * All other summaries are in the dimension fields above.
   */
  summary: TransactionSummary;
  /**
   * Each below Dimension field allows queries to organize their output
   * by specifying each field in the structural order desired.
   */
  time: Array<TimeDimension>;
};


export type DimensionSummaryAgingArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DimensionSortMode>;
};


export type DimensionSummaryCategoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DimensionSortMode>;
};


export type DimensionSummaryCategoryTypeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DimensionSortMode>;
};


export type DimensionSummaryDepartmentArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DimensionSortMode>;
};


export type DimensionSummaryLocationArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DimensionSortMode>;
};


export type DimensionSummaryPartyArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DimensionSortMode>;
};


export type DimensionSummaryScheduleArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DimensionSortMode>;
};


export type DimensionSummaryTimeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DimensionSortMode>;
};

export enum DimensionalSortBy {
  Amount = 'Amount',
  Count = 'Count',
  Name = 'Name'
}

export enum DirectionFromOrigin {
  Future = 'Future',
  Past = 'Past'
}

export type Discount = {
  categoryId?: Maybe<Scalars['String']['output']>;
  discountId: Scalars['String']['output'];
  fixedDiscountAmount?: Maybe<MonetaryValue>;
  name: Scalars['String']['output'];
  providerType: ProviderType;
  variablePercentage?: Maybe<Scalars['Float']['output']>;
};

export enum DiscountLevel {
  LineItem = 'LineItem',
  Subscription = 'Subscription',
  UnknownDiscountLevel = 'UnknownDiscountLevel'
}

/**
 * DiscreteEvent represents one-time activity feed events
 * that are created via our go-services APIs
 */
export type DiscreteEvent = {
  actorUserId?: Maybe<Scalars['String']['output']>;
  kind: DiscreteEventKind;
  subject: ActivityObjectIdentifier;
  target: ActivityObjectIdentifier;
  targetEmailAddress?: Maybe<Scalars['String']['output']>;
};

export enum DiscreteEventKind {
  CreatedGrant = 'CreatedGrant',
  CreatedIntent = 'CreatedIntent',
  /**
   * DisabledLink
   * RejectedRequest
   */
  CreatedReportPackage = 'CreatedReportPackage',
  /** RegeneratedReportPackage */
  DeletedReportPackage = 'DeletedReportPackage',
  IntegrationFixed = 'IntegrationFixed',
  NewComment = 'NewComment',
  NewIntegration = 'NewIntegration',
  NewReport = 'NewReport',
  NewUser = 'NewUser',
  /**
   * CreatedReport
   * ViewedReport
   * UpdatedReport
   * RegeneratedReport
   */
  PublishedDraftReportPackage = 'PublishedDraftReportPackage',
  PublishedFinalReportPackage = 'PublishedFinalReportPackage',
  /**
   * FixedIntegration
   * CreatedIntegration
   * CreatedUser
   * CreatedThread
   * CreatedComment
   */
  ResolvedThread = 'ResolvedThread',
  RevokedGrant = 'RevokedGrant',
  /**
   * UpdatedLink
   * AcceptedRequest
   */
  RevokedIntent = 'RevokedIntent',
  UpdatedGrant = 'UpdatedGrant',
  /**
   * CreatedLink
   * CreatedRequest
   */
  UpdatedIntent = 'UpdatedIntent',
  UpdatedReportPackage = 'UpdatedReportPackage',
  VendorEdited = 'VendorEdited',
  ViewedReportPackage = 'ViewedReportPackage'
}

export enum DisplayEntry {
  Credit = 'Credit',
  Debit = 'Debit',
  TransferCredit = 'TransferCredit',
  TransferDebit = 'TransferDebit',
  Unknown = 'Unknown'
}

export type DocumentCollectionConfig = {
  collectionId: Scalars['String']['output'];
};

export type DocumentCollectionConfigInput = {
  collectionId: Scalars['String']['input'];
};

export type DocumentDownload = {
  url: Scalars['String']['output'];
};

export type DocumentDownloadUrls = {
  urls: Array<Scalars['String']['output']>;
};

export type DocumentFilter = {
  creatorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  documentCollectionId?: InputMaybe<Scalars['String']['input']>;
  documentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  documentTypes?: InputMaybe<Array<DocumentType>>;
  featureKinds?: InputMaybe<Array<FeatureKind>>;
  mimeTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DocumentIdentifier = {
  collectionId: Scalars['String']['output'];
  documentId: Scalars['String']['output'];
};

export type DocumentInfo = {
  creator?: Maybe<EntityUser>;
  dataSource?: Maybe<EntityDataSource>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type DocumentInitialSegment = {
  collectionId: Scalars['String']['output'];
  documentId: Scalars['String']['output'];
  downloadUrl?: Maybe<Scalars['String']['output']>;
};

export type DocumentLineItem = {
  amount: MonetaryValue;
  categoryId?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  position: Scalars['Long']['output'];
  quantity: Scalars['Long']['output'];
  rate: MonetaryValue;
};

export type DocumentSort = {
  direction?: InputMaybe<SortDirection>;
  field: DocumentSortBy;
};

export enum DocumentSortBy {
  CreatedAt = 'CreatedAt',
  DocumentType = 'DocumentType',
  FileName = 'FileName',
  FileSize = 'FileSize',
  Title = 'Title'
}

export enum DocumentStatus {
  Done = 'Done',
  New = 'New',
  Processing = 'Processing',
  UnknownStatus = 'UnknownStatus'
}

export enum DocumentType {
  AdyenStatement = 'AdyenStatement',
  Bill = 'Bill',
  Check = 'Check',
  Compliance = 'Compliance',
  Contract = 'Contract',
  Equity = 'Equity',
  Form1099 = 'Form1099',
  FormW9 = 'FormW9',
  Invoice = 'Invoice',
  K1 = 'K1',
  LoanAgreement = 'LoanAgreement',
  Payroll = 'Payroll',
  Receipt = 'Receipt',
  Schedule = 'Schedule',
  Statement = 'Statement',
  TaxID = 'TaxID',
  TaxReturn = 'TaxReturn',
  UnknownType = 'UnknownType',
  Valuation = 'Valuation'
}

export type DocumentsSummary = {
  count: Scalars['Long']['output'];
};

export type DoppelgangerPermit = {
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  user: User;
};

export type DoubleEntry = {
  firstEntryCategoryId: Scalars['String']['input'];
  secondEntryCategoryId: Scalars['String']['input'];
  withoutFirstEntryAncestors?: InputMaybe<Scalars['Boolean']['input']>;
  withoutSecondEntryAncestors?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmailStatus = {
  rawStatus: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type EmbeddingResponse = {
  deployedIndexId: Scalars['String']['output'];
  embeddingValue?: Maybe<Array<Scalars['Float']['output']>>;
};

export type Employee = {
  avatarUrl?: Maybe<Scalars['String']['output']>;
  defaultEntityRole?: Maybe<Role>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  hiddenAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  invitation?: Maybe<Invitation>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastActivityAt?: Maybe<Scalars['DateTime']['output']>;
  legalEntityRoles?: Maybe<Array<EmployeeLegalEntityRole>>;
  organizationId: Scalars['String']['output'];
  role?: Maybe<Role>;
  status: EmployeeStatus;
  user?: Maybe<User>;
};

export type EmployeeAffiliations = {
  affiliations: Array<Affiliation>;
  employee: Employee;
};

export type EmployeeFilter = {
  employeeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<EmployeeStatus>>;
  visibility?: InputMaybe<EmployeeVisibility>;
};

export type EmployeeIdentifier = {
  employeeId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export type EmployeeLegalEntityRole = {
  legalEntityId: Scalars['String']['output'];
  role?: Maybe<Role>;
};

export enum EmployeeOrigin {
  Bootstrapped = 'Bootstrapped',
  External = 'External',
  Invitation = 'Invitation',
  Manual = 'Manual',
  Synthesized = 'Synthesized',
  UnknownOrigin = 'UnknownOrigin'
}

export type EmployeeSort = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<EmployeeSortOrderBy>;
};

export enum EmployeeSortOrderBy {
  Name = 'Name',
  Status = 'Status'
}

export enum EmployeeStatus {
  Activated = 'Activated',
  Deactivated = 'Deactivated',
  Initialized = 'Initialized',
  UnknownStatus = 'UnknownStatus'
}

export enum EmployeeVisibility {
  Active = 'Active',
  All = 'All',
  Hidden = 'Hidden'
}

export type EmptyConnectorProperties = {
  empty?: Maybe<Scalars['Boolean']['output']>;
};

export type EnqueueStatementImportWorkflowResponse = {
  statementImportIntentId: Scalars['String']['output'];
};

export type EnrichedDataSource = {
  accountAlias?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  hasTransactions: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  institution: Party;
  lastActivityAt?: Maybe<Scalars['DateTime']['output']>;
  legalEntityId: Scalars['String']['output'];
  plaidConfig?: Maybe<PlaidConfig>;
  providerType: ProviderType;
  quickBooksConfig?: Maybe<QuickBooksConfig>;
  sourceAccounts?: Maybe<Array<SourceAccount>>;
  status: DataSourceStatus;
  statusReason?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type EntitiesList = {
  entities: ObjectEntities;
};

export type EntitiesListConfig = {
  entities: ObjectEntities;
  origin: ArchiveIntervalOrigin;
};

export type EntityBill = {
  approvalAccess?: Maybe<BillAccess>;
  billDescription: Scalars['String']['output'];
  billStatus: BillStatus;
  dueDate?: Maybe<Date>;
  format: Format;
  id: Scalars['String']['output'];
  totalAmount: EntityMonetaryValue;
  vendorName: Scalars['String']['output'];
};

export type EntityCategory = {
  active: Scalars['Boolean']['output'];
  chartOfAccountsDisplayNumber?: Maybe<Scalars['String']['output']>;
  displayKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentCategoryId?: Maybe<Scalars['String']['output']>;
  productArea?: Maybe<ProductArea>;
  subtype: CategorySubtype;
  type: CategoryType;
};

/** Comments */
export type EntityComment = {
  authorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type EntityConnection = {
  connectorId: Scalars['String']['output'];
  dataSourceId: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type EntityDataSource = {
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type EntityDepartment = {
  active: Scalars['Boolean']['output'];
  displayKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** @deprecated Use parentId */
  parentDepartmentId?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
};

/** Employees */
export type EntityEmployee = {
  avatarUrl?: Maybe<Scalars['String']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
};

export type EntityHovers = {
  hovers: Array<Hover>;
};

export type EntityIdentityVerification = {
  legalEntityId: Scalars['String']['output'];
  status: IdentityVerificationStatus;
};

export type EntityInstitution = {
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Invoices */
export type EntityInvoice = {
  amount: EntityMonetaryValue;
  createdAt: Scalars['DateTime']['output'];
  customer: EntityInvoiceCustomer;
  dueAt?: Maybe<Scalars['DateTime']['output']>;
  externalDisplayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type EntityInvoiceCustomer = {
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  party: EntityParty;
  phone?: Maybe<Scalars['String']['output']>;
};

export type EntityLedgerTransaction = {
  factIds?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parties: Array<EntityParty>;
  referenceNumber: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  totalAmount: EntityMonetaryValue;
};

export type EntityLegalEntity = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type EntityLocation = {
  active: Scalars['Boolean']['output'];
  displayKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
};

export type EntityMonetaryValue = {
  amount: Scalars['Long']['output'];
  currencyMultiplier: Scalars['Long']['output'];
  iso4217CurrencyCode: Scalars['String']['output'];
};

export type EntityOrganization = {
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

/** Parties */
export type EntityParty = {
  designation: PartyDesignation;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  roles?: Maybe<Array<PartyRole>>;
  shortDescription?: Maybe<Scalars['String']['output']>;
};

export type EntityReconciliation = {
  categoryId: Scalars['String']['output'];
  endDate: Date;
  id: Scalars['String']['output'];
  reconciliationStatus: AccountReconciliationStatus;
  startDate: Date;
};

/** Reports */
export type EntityReport = {
  authorId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  reportFor: Date;
  title: Scalars['String']['output'];
};

export type EntityReportPackage = {
  authorId: Scalars['String']['output'];
  coverUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  documents: Array<SharedReportDocumentMetadata>;
  id: Scalars['String']['output'];
  interval: Interval;
  periodEndedAt: Scalars['DateTime']['output'];
  periodStartedAt: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EntitySchedule = {
  amount?: Maybe<MonetaryValue>;
  categoryId: Scalars['String']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  partyId?: Maybe<Scalars['String']['output']>;
  relatedCategoryId?: Maybe<Scalars['String']['output']>;
  scheduleNumber: Scalars['String']['output'];
  scheduleTemplateId: Scalars['String']['output'];
  scheduleType: ScheduleType;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated No longer used */
  status?: Maybe<ScheduleStatus>;
};

export type EntityThread = {
  id: Scalars['String']['output'];
  resolvedAt: Scalars['DateTime']['output'];
};

/**
 * ObjectEntities
 * Note: some definitions exist in shared/common/
 * Transactions
 */
export type EntityTransaction = {
  description?: Maybe<Scalars['String']['output']>;
  displayCategory: EntityCategory;
  displayEntry: DisplayEntry;
  /** @deprecated Use moneyFlow */
  displayValue?: Maybe<EntityMonetaryValue>;
  externalId?: Maybe<Scalars['String']['output']>;
  factId?: Maybe<Scalars['String']['output']>;
  moneyFlow: MoneyFlow;
  name?: Maybe<Scalars['String']['output']>;
  party?: Maybe<EntityParty>;
  splitCategory?: Maybe<EntityCategory>;
  timestamp: Scalars['DateTime']['output'];
  viewId: Scalars['String']['output'];
};

export type EntityUser = {
  avatarUrl?: Maybe<Scalars['String']['output']>;
  emailAddress: Scalars['String']['output'];
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

/** Work Items */
export type EntityWorkItem = {
  id: Scalars['String']['output'];
  ledgerType: LedgerType;
  objectTransaction: EntityTransaction;
  reviewCreatedById: Scalars['String']['output'];
  reviewState?: Maybe<WorkItemReviewState>;
  time: Scalars['DateTime']['output'];
  workItemState: WorkItemState;
  workItemType: WorkItemType;
};

export enum EntryType {
  Credit = 'Credit',
  Debit = 'Debit',
  Unknown = 'Unknown'
}

export enum EventType {
  /** Invitations */
  AffiliateLegalEntityInvitation = 'AffiliateLegalEntityInvitation',
  AffiliationsCreated = 'AffiliationsCreated',
  AffiliationsInvitationCreated = 'AffiliationsInvitationCreated',
  ApplicationApproved = 'ApplicationApproved',
  ApplicationSubmitted = 'ApplicationSubmitted',
  /** Signups */
  ApplicationSubmittedByInvitee = 'ApplicationSubmittedByInvitee',
  /** Bills */
  BillAssigned = 'BillAssigned',
  BillAssignedReminder = 'BillAssignedReminder',
  BillPaymentCreated = 'BillPaymentCreated',
  BillPaymentCreatedAch = 'BillPaymentCreatedAch',
  BillPaymentCreatedAutoDepositBankAccount = 'BillPaymentCreatedAutoDepositBankAccount',
  BillPaymentCreatedAutoDepositCheck = 'BillPaymentCreatedAutoDepositCheck',
  BillPaymentCreatedCheck = 'BillPaymentCreatedCheck',
  BillPaymentCreatedDigitsPay = 'BillPaymentCreatedDigitsPay',
  BillPaymentError = 'BillPaymentError',
  BillRejected = 'BillRejected',
  BoostSummary = 'BoostSummary',
  CashBalanceAlert = 'CashBalanceAlert',
  ConfirmEmail = 'ConfirmEmail',
  ConfirmPasswordReset = 'ConfirmPasswordReset',
  /** Password Management */
  CreatePasswordReset = 'CreatePasswordReset',
  InitialInvitation = 'InitialInvitation',
  InstructionsAffiliateInvitation = 'InstructionsAffiliateInvitation',
  InstructionsInvitation = 'InstructionsInvitation',
  InvoicePaid = 'InvoicePaid',
  InvoicePaidSender = 'InvoicePaidSender',
  InvoicePaymentFailed = 'InvoicePaymentFailed',
  InvoicePaymentFailedSender = 'InvoicePaymentFailedSender',
  InvoiceResent = 'InvoiceResent',
  /** Invoices */
  InvoiceSent = 'InvoiceSent',
  LedgerTransactionComment = 'LedgerTransactionComment',
  LedgerTransactionMention = 'LedgerTransactionMention',
  ObjectAccessAccepted = 'ObjectAccessAccepted',
  ObjectAccessApproved = 'ObjectAccessApproved',
  ObjectAccessRequested = 'ObjectAccessRequested',
  ObjectBulkComment = 'ObjectBulkComment',
  ObjectComment = 'ObjectComment',
  /** Sharing */
  ObjectGrantCreated = 'ObjectGrantCreated',
  ObjectMention = 'ObjectMention',
  PlanInvitation = 'PlanInvitation',
  ReportComment = 'ReportComment',
  ReportCommentThreadResolved = 'ReportCommentThreadResolved',
  ReportMention = 'ReportMention',
  ReportsCreated = 'ReportsCreated',
  SystemReportCreated = 'SystemReportCreated',
  TransactionMention = 'TransactionMention',
  TransactionQuestionsAsked = 'TransactionQuestionsAsked',
  TransactionQuestionsReminder = 'TransactionQuestionsReminder',
  UnclaimedBill = 'UnclaimedBill',
  UnclaimedBillReminder = 'UnclaimedBillReminder',
  UnknownEvent = 'UnknownEvent',
  UserInvitation = 'UserInvitation',
  UserLockedOut = 'UserLockedOut',
  WorkItemComment = 'WorkItemComment'
}

export type ExistingReportAttachment = {
  position: Scalars['Int']['input'];
  reportId: Scalars['String']['input'];
  title: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
};

export enum ExpectationStatus {
  Active = 'Active',
  AutomaticallyUpdated = 'AutomaticallyUpdated',
  Unknown = 'Unknown'
}

export enum ExpectationType {
  CreditCategory = 'CreditCategory',
  DebitCategory = 'DebitCategory',
  MatchSet = 'MatchSet',
  Owner = 'Owner',
  PartyIcon = 'PartyIcon',
  PartyName = 'PartyName',
  PartyRole = 'PartyRole',
  Unknown = 'Unknown'
}

/** Facet output types */
export type Facet = {
  aggregate: Scalars['Int']['output'];
  department: Array<DepartmentFacet>;
  institution: Array<InstitutionFacet>;
  location: Array<LocationFacet>;
  matchedStatus: Array<MatchedStatusFacet>;
  party: Array<PartyFacet>;
  /**
   * Each field below allows queries to organize their output
   * by specifying which facet is being requested.
   */
  user: Array<UserFacet>;
};

export type FacetFilter = {
  facetFilterTerm?: InputMaybe<Scalars['String']['input']>;
  transactionFilter: TransactionFilter;
};

export enum FacetType {
  AggregateCount = 'AggregateCount',
  CountPerValue = 'CountPerValue',
  UnknownFacetType = 'UnknownFacetType'
}

/** View Data Explorer */
export type FbqQueryResult = {
  resultJson: Scalars['String']['output'];
};

export type Feature = {
  featurePage: Scalars['Long']['output'];
  /**
   * Restored after #3327 removed it: stale iOS and web clients still in
   * the wild select this field. Server populates it from `groups`,
   * picking the LineItem-kind group for line-item features and the first
   * group otherwise. New code should use `groups` and filter by kind;
   * this field will be removed again once the long-tail clients migrate.
   * @deprecated Use `groups` and filter by kind.
   */
  group?: Maybe<FeatureGroup>;
  /**
   * A feature may be a member of more than one group (e.g. LineItem +
   * AccountGroup on multi-account bank statements). Readers iterate
   * `groups` and filter by kind.
   */
  groups?: Maybe<Array<FeatureGroup>>;
  height: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  invalid: Scalars['Boolean']['output'];
  kind: FeatureKind;
  originX: Scalars['Float']['output'];
  originY: Scalars['Float']['output'];
  value: FeatureValue;
  width: Scalars['Float']['output'];
};

export type FeatureGroup = {
  featureGroupId: Scalars['String']['output'];
  kind: FeatureKind;
  position: Scalars['Long']['output'];
};

export enum FeatureKind {
  AccountExternalId = 'AccountExternalId',
  /**
   * feature-group kinds used when a feature is a member of a grouping
   * (e.g. per-account groups on multi-account bank statements)
   */
  AccountGroup = 'AccountGroup',
  AccountNumber = 'AccountNumber',
  AccountType = 'AccountType',
  AmountDue = 'AmountDue',
  BankStatementLineItem = 'BankStatementLineItem',
  BillCategory = 'BillCategory',
  BusinessAddress = 'BusinessAddress',
  /** W9 feature kinds */
  BusinessName = 'BusinessName',
  CheckInfo = 'CheckInfo',
  /** check feature kinds */
  CheckNumber = 'CheckNumber',
  CheckPayee = 'CheckPayee',
  DocumentCustomer = 'DocumentCustomer',
  DocumentDate = 'DocumentDate',
  DocumentKeyword = 'DocumentKeyword',
  DocumentParty = 'DocumentParty',
  /** generic document feature kinds */
  DocumentRawText = 'DocumentRawText',
  DocumentReference = 'DocumentReference',
  DocumentSummary = 'DocumentSummary',
  DocumentType = 'DocumentType',
  DocumentVendor = 'DocumentVendor',
  DueDate = 'DueDate',
  EndingBalance = 'EndingBalance',
  EndingDate = 'EndingDate',
  InstitutionAccountNumber = 'InstitutionAccountNumber',
  /** bank statement feature kinds */
  InstitutionName = 'InstitutionName',
  InvoiceDate = 'InvoiceDate',
  InvoiceId = 'InvoiceId',
  LineItem = 'LineItem',
  LineItemAmount = 'LineItemAmount',
  LineItemDate = 'LineItemDate',
  LineItemDescription = 'LineItemDescription',
  Memo = 'Memo',
  Other = 'Other',
  OtherPaymentInfo = 'OtherPaymentInfo',
  PayerAddress = 'PayerAddress',
  PayerCompanyName = 'PayerCompanyName',
  PayerEmail = 'PayerEmail',
  PayerName = 'PayerName',
  PayerPhoneNumber = 'PayerPhoneNumber',
  PaymentInstructions = 'PaymentInstructions',
  ReceiptNumber = 'ReceiptNumber',
  /** receipt feature kinds */
  ReceiptPaymentProcessor = 'ReceiptPaymentProcessor',
  RemittanceAddress = 'RemittanceAddress',
  RemittanceInformation = 'RemittanceInformation',
  /** contract feature kinds */
  Schedule = 'Schedule',
  StartingBalance = 'StartingBalance',
  StartingDate = 'StartingDate',
  TaxNumber = 'TaxNumber',
  Terms = 'Terms',
  Title = 'Title',
  TotalAmount = 'TotalAmount',
  TotalCashback = 'TotalCashback',
  TotalCredits = 'TotalCredits',
  TotalDebits = 'TotalDebits',
  TotalDeposits = 'TotalDeposits',
  TotalDividends = 'TotalDividends',
  TotalFees = 'TotalFees',
  TotalInterestCharged = 'TotalInterestCharged',
  TotalInterestEarned = 'TotalInterestEarned',
  TotalWithdrawals = 'TotalWithdrawals',
  UnknownKind = 'UnknownKind',
  VendorAddress = 'VendorAddress',
  VendorEmail = 'VendorEmail',
  VendorName = 'VendorName',
  VendorPhoneNumber = 'VendorPhoneNumber',
  VendorWebsite = 'VendorWebsite',
  WireInfo = 'WireInfo'
}

export type FeatureValue = AddressFeatureValue | DateFeatureValue | LineItemFeatureValue | MonetaryFeatureValue | NumericFeatureValue | RemittanceFeatureValue | TextFeatureValue;

export enum FetchType {
  Backfill = 'Backfill',
  ChangeDataCapture = 'ChangeDataCapture',
  Onboard = 'Onboard',
  Refresh = 'Refresh'
}

export type FieldFilterTermInput = {
  field: TermField;
  term: Scalars['String']['input'];
};

export type FinchConnectToken = {
  sessionId: Scalars['String']['output'];
};

export type FinchConnectorProperties = {
  /**
   * Finch uses Finch Connect embedded widget which is initiated via createFinchSession
   * No authorization URL needed as the token is used directly by the frontend widget
   */
  empty?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * FirmClient is a row in the Firm Work Management dashboard.
 * `id` mirrors legalEntity.id so Apollo can normalize and surgically
 * update a row without refetching the whole list.
 */
export type FirmClient = {
  billingPlan?: Maybe<BillingProduct>;
  counts: Array<ActionItemsGroupSummary>;
  id: Scalars['String']['output'];
  legalEntity: EntityLegalEntity;
  /**
   * Ids reference FirmClientList.entities.users (EntityUser), keeping
   * member lookups deduped across rows.
   */
  memberUserIds: Array<Scalars['String']['output']>;
  organization: EntityOrganization;
  /**
   * payerOrganizationId tells the frontend who pays for this client's
   * subscription. Compare against the firm org id (firm pays) vs the
   * client's organizationId (client pays); null = unknown.
   * Mirrors BillingArrangementLegalEntityBilling.payerOrganizationId.
   */
  payerOrganizationId?: Maybe<Scalars['String']['output']>;
  status: LegalEntityStatus;
};

export type FirmClientFilter = {
  firmOrganizationId: Scalars['String']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<LegalEntityStatus>>;
};

export type FirmClientList = {
  clients: Array<FirmClient>;
  /** Deduped lookup tables for ids referenced by rows */
  entities?: Maybe<ObjectEntities>;
  totalCount: Scalars['Int']['output'];
};

export type FirmClientSort = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<FirmClientSortField>;
};

export enum FirmClientSortField {
  Book = 'Book',
  Comments = 'Comments',
  Name = 'Name',
  Reconcile = 'Reconcile',
  Report = 'Report',
  Review = 'Review',
  Schedule = 'Schedule',
  Setup = 'Setup',
  Status = 'Status'
}

export type FirstTransactionOccurrence = {
  firstTransactionOccurredAt: Scalars['DateTime']['output'];
};

export enum Flow {
  Inbound = 'Inbound',
  Outbound = 'Outbound',
  UnknownFlow = 'UnknownFlow'
}

export type Format = {
  formatClass?: Maybe<FormatClass>;
  id: Scalars['String']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  segments: Array<Segment>;
};

export enum FormatClass {
  AnnotatedTableJson = 'AnnotatedTableJson',
  CSV = 'CSV',
  Email = 'Email',
  ImageDocument = 'ImageDocument',
  ImageLarge = 'ImageLarge',
  ImageSmall = 'ImageSmall',
  ImageThumbnail = 'ImageThumbnail',
  LabelJson = 'LabelJson',
  OcrJson = 'OcrJson',
  OcrProto = 'OcrProto',
  PDF = 'PDF',
  RawMIME = 'RawMIME'
}

export type FraudCheckResult = {
  hasResult: Scalars['Boolean']['output'];
  legalEntityId: Scalars['String']['output'];
  reasonsJson?: Maybe<Scalars['String']['output']>;
  riskFlag?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum FutureKind {
  Retry = 'Retry',
  Signal = 'Signal',
  Timer = 'Timer',
  Unspecified = 'Unspecified'
}

export enum FutureStatus {
  Cancelled = 'Cancelled',
  Delivered = 'Delivered',
  Pending = 'Pending',
  Resolved = 'Resolved',
  StatusUnspecified = 'StatusUnspecified'
}

export enum GenerationStatus {
  Failed = 'Failed',
  InProgress = 'InProgress',
  Success = 'Success',
  UnknownStatus = 'UnknownStatus'
}

export type GlobalPartyAlias = {
  alias: Scalars['String']['output'];
  partyId: Scalars['String']['output'];
};

export type GlobalPartyFilter = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GlobalPartySort = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<GlobalPartySortOrderBy>;
};

export enum GlobalPartySortOrderBy {
  CreatedAt = 'CreatedAt',
  Name = 'Name',
  NameLength = 'NameLength',
  TransactionCount = 'TransactionCount',
  UpdatedAt = 'UpdatedAt'
}

export enum GrantPolicy {
  Allow = 'Allow',
  Deny = 'Deny'
}

export type GustoConnectorProperties = {
  authorizationURL: Scalars['String']['output'];
};

export enum HandleNone {
  Both = 'Both',
  Either = 'Either',
  Ignore = 'Ignore'
}

export enum HealthStatus {
  Healthy = 'Healthy',
  NotYetComputed = 'NotYetComputed',
  Unhealthy = 'Unhealthy'
}

export type HighlightedToken = {
  score: Scalars['Long']['output'];
  token: Scalars['String']['output'];
};

export type HighlightedTokens = {
  description?: Maybe<Array<HighlightedToken>>;
  name?: Maybe<Array<HighlightedToken>>;
};

/**
 * Highlight describes the positional offsets of a search term
 * within the result document, which will allow clients to highlight
 * that term during presentation of the result.
 */
export type HitHighlight = {
  end: Scalars['Long']['output'];
  field: Scalars['String']['output'];
  start: Scalars['Long']['output'];
  term: Scalars['String']['output'];
};

export type Hover = CategoryHover | PartyHover | SummaryLineItemHover;

export type HttpResponse = {
  metadata?: Maybe<HttpResponseMetadata>;
  rawBody: Scalars['String']['output'];
};

export type HttpResponseArchive = {
  responses: Array<HttpResponse>;
};

export type HttpResponseMetadata = {
  request_id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  status_code?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/**
 * HydrateIdentifier is a (kind, id) pair for HydrateEntities requests.
 * legal_entity_id is not included here because it's carried by the request's
 * ViewKey — all identifiers in a single call resolve under the same view.
 */
export type HydrateIdentifier = {
  id: Scalars['String']['input'];
  kind: ObjectKind;
};

export type HydratedParty = {
  agentEvent?: Maybe<AgentEvent>;
};

/** IdentifiersByKind represents a kind, legalEntityId and list of object ids */
export type IdentifiersByKind = {
  ids: Array<Scalars['String']['input']>;
  kind: ObjectKind;
  legalEntityId: Scalars['String']['input'];
};

export type Identity = {
  domain?: Maybe<Scalars['String']['output']>;
  identifier: Scalars['String']['output'];
  provider: OAuthService;
};

export enum IdentityVerificationStatus {
  ApplicationReview = 'ApplicationReview',
  Approved = 'Approved',
  Denied = 'Denied',
  IdentityVerificationStatusUnknown = 'IdentityVerificationStatusUnknown',
  Ineligible = 'Ineligible',
  Pending = 'Pending'
}

export type IdentityVerificationStatusResult = {
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  status: IdentityVerificationStatus;
};

export type ImportedEmployees = {
  employees: Array<Employee>;
  newEmployeeCount: Scalars['Int']['output'];
};

export enum IngestSource {
  BankStatementUpload = 'BankStatementUpload',
  BillPayEmail = 'BillPayEmail',
  BillPayUpload = 'BillPayUpload',
  Ledger = 'Ledger',
  Report = 'Report',
  StatementImport = 'StatementImport',
  Vault = 'Vault'
}

export type InputAccountReconciliation = {
  abnormalTotal?: InputMaybe<InputMonetaryValue>;
  categoryId: Scalars['String']['input'];
  closingBalance: InputMonetaryValue;
  endDate: DateInput;
  normalTotal?: InputMaybe<InputMonetaryValue>;
};

export type InputAccountReconciliationUpdate = {
  abnormalTotal?: InputMaybe<InputReconciliationAmount>;
  closingBalance?: InputMaybe<InputMonetaryValue>;
  /** fields used for reconfiguring a reconciliation */
  endDate?: InputMaybe<DateInput>;
  /** fields used for reconfiguring or updating a reconciliation */
  normalTotal?: InputMaybe<InputReconciliationAmount>;
};

export type InputAccountReconciliationsFilter = {
  direction: DirectionFromOrigin;
  hasActivity: Scalars['Boolean']['input'];
  origin: IntervalOrigin;
};

export type InputAmountRuleFilter = {
  amount: InputMonetaryValue;
  amountRuleFilterId?: InputMaybe<Scalars['String']['input']>;
  operator: ComparisonOperator;
};

export type InputAssociationIdentifier = {
  documentIdentifier: InputDocumentIdentifier;
  objectIdentifier: InputObjectIdentifier;
};

export type InputCategoryRuleFilter = {
  categories: Array<InputCategoryRuleFilterCategory>;
  categoryRuleFilterId?: InputMaybe<Scalars['String']['input']>;
  operation: Operation;
};

export type InputCategoryRuleFilterCategory = {
  categoryId: Scalars['String']['input'];
  categoryName: Scalars['String']['input'];
};

export type InputDocumentIdentifier = {
  collectionId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
};

export type InputMonetaryValue = {
  amount: Scalars['Long']['input'];
  currencyMultiplier: Scalars['Long']['input'];
  iso4217CurrencyCode: Scalars['String']['input'];
};

/**
 * ObjectIdentifier is a generic identifier with an enumerated kind.
 * It can be used to identify different Digits' core objects.
 */
export type InputObjectIdentifier = {
  id: Scalars['String']['input'];
  kind: ObjectKind;
  legalEntityId: Scalars['String']['input'];
};

export type InputPartyRuleFilter = {
  operation: Operation;
  parties: Array<InputPartyRuleFilterParty>;
  partyRuleFilterId?: InputMaybe<Scalars['String']['input']>;
};

export type InputPartyRuleFilterParty = {
  partyId: Scalars['String']['input'];
  partyName: Scalars['String']['input'];
};

export type InputQuantityValue = {
  quantity: Scalars['Long']['input'];
  quantityMultiplier: Scalars['Long']['input'];
};

export type InputReconciliationAmount = {
  amount?: InputMaybe<InputMonetaryValue>;
  delete: Scalars['Boolean']['input'];
};

export type InputStatusUpdate = {
  categoryId: Scalars['String']['input'];
  reconciliationId: Scalars['String']['input'];
  status: TransactionReconciliationStatus;
  transactionFactId: Scalars['String']['input'];
};

/** # input types */
export type InputTransaction = {
  bill?: InputMaybe<BillEdit>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  invoice?: InputMaybe<InvoiceEdit>;
  lines: Array<InputTransactionLine>;
  memo: Scalars['String']['input'];
  /** Fact IDs of lines that existed before editing. Used to derive the data source. */
  originalFactIds?: InputMaybe<Array<Scalars['String']['input']>>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  timestamp: Scalars['DateTime']['input'];
  type: TransactionType;
};

export type InputTransactionLine = {
  amount: InputMonetaryValue;
  categoryId: Scalars['String']['input'];
  /** department ID is optional */
  departmentId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  entryType: EntryType;
  id: Scalars['String']['input'];
  lineItemId: Scalars['String']['input'];
  /** location ID is optional */
  locationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * newDepartment is optional
   * if provided (and departmentId is blank) a new department will be created and associated with the transaction line
   */
  newDepartment?: InputMaybe<Scalars['String']['input']>;
  /**
   * newLocation is optional
   * if provided (and locationId is blank) a new location will be created and associated with the transaction line
   */
  newLocation?: InputMaybe<Scalars['String']['input']>;
  /**
   * newParty is optional
   * if provided (and partyId is blank) a new party will be created and associated with the transaction line
   */
  newParty?: InputMaybe<Scalars['String']['input']>;
  /** party classification is optional */
  partyId?: InputMaybe<Scalars['String']['input']>;
};

export type InputUpdateFields = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  departmentId?: InputMaybe<Scalars['String']['input']>;
  digitsTransactionType: TransactionType;
  entryType: EntryType;
  locationId?: InputMaybe<Scalars['String']['input']>;
  /** optional fields to update */
  partyId?: InputMaybe<Scalars['String']['input']>;
  splitCategoryId?: InputMaybe<Scalars['String']['input']>;
  splitDepartmentId?: InputMaybe<Scalars['String']['input']>;
  splitLocationId?: InputMaybe<Scalars['String']['input']>;
  taxStatus?: InputMaybe<TaxStatus>;
  transactionFactId: Scalars['String']['input'];
};

export type InputUpdatePartyFields = {
  entityType?: InputMaybe<PartyEntityType>;
  partyId: Scalars['String']['input'];
  /** optional fields to update */
  taxpayerIdentification?: InputMaybe<TaxpayerIdentification>;
};

export type Insight = {
  absoluteDelta?: Maybe<MonetaryValue>;
  comparisonIntervalOffset: Scalars['Long']['output'];
  comparisonPeriodValue?: Maybe<MonetaryValue>;
  designation?: Maybe<PartyDesignation>;
  globalScore?: Maybe<Scalars['Float']['output']>;
  periodValue?: Maybe<MonetaryValue>;
  productArea?: Maybe<ProductArea>;
  ruleType: InsightRuleType;
  score: Scalars['Long']['output'];
  sentence?: Maybe<Scalars['String']['output']>;
  subjectDisplayKey: Scalars['String']['output'];
  subjectIconUrl?: Maybe<Scalars['String']['output']>;
  subjectId: Scalars['String']['output'];
  subjectType: InsightSubjectType;
  type: InsightType;
};

export type InsightComponent = {
  hovers: Array<Hover>;
  sentence: Scalars['String']['output'];
};

export type InsightComponentConfig = {
  lookback: ArchiveIntervalOrigin;
  objectId: ObjectIdentifier;
  options?: Maybe<InsightComponentConfigOptions>;
  origin: ArchiveIntervalOrigin;
};

export type InsightComponentConfigOptions = {
  partyRole?: Maybe<PartyRole>;
};

export type InsightConfigInput = {
  lookback: IntervalOrigin;
  objectId: InputObjectIdentifier;
  origin: IntervalOrigin;
  partyRole?: InputMaybe<PartyRole>;
};

export type InsightFilter = {
  categoryTypes?: InputMaybe<Array<CategoryType>>;
  insightTypes?: InputMaybe<Array<InsightType>>;
  insightVisibility?: InputMaybe<InsightVisibility>;
  objectId?: InputMaybe<InputObjectIdentifier>;
  partyRole?: InputMaybe<PartyRole>;
  productArea?: InputMaybe<ProductArea>;
  scoreType?: InputMaybe<InsightScoreType>;
  subjectId?: InputMaybe<Scalars['String']['input']>;
  subjectTypes?: InputMaybe<Array<InsightSubjectType>>;
  topLevelOnly?: InputMaybe<Scalars['Boolean']['input']>;
  viewKey: ViewKey;
};

export enum InsightRuleType {
  Delta = 'Delta',
  Growth = 'Growth',
  Inconsistent = 'Inconsistent',
  New = 'New',
  Outlier = 'Outlier',
  Regression = 'Regression',
  UnspecifiedRuleType = 'UnspecifiedRuleType'
}

export enum InsightScoreType {
  Global = 'Global',
  Local = 'Local',
  UnknownScoreType = 'UnknownScoreType'
}

export enum InsightSubjectType {
  Category = 'Category',
  Department = 'Department',
  LegalEntity = 'LegalEntity',
  Location = 'Location',
  Party = 'Party',
  Recurring = 'Recurring',
  TransactionFact = 'TransactionFact',
  UnspecifiedSubjectType = 'UnspecifiedSubjectType'
}

export enum InsightType {
  AssetsPrepaid = 'AssetsPrepaid',
  AssetsReceivable = 'AssetsReceivable',
  Cash = 'Cash',
  CostOfGoodsSold = 'CostOfGoodsSold',
  Equity = 'Equity',
  Expenses = 'Expenses',
  Income = 'Income',
  LiabilitiesLongTerm = 'LiabilitiesLongTerm',
  LiabilitiesPayable = 'LiabilitiesPayable',
  UnspecifiedInsightType = 'UnspecifiedInsightType'
}

export enum InsightVisibility {
  DuplicateVisibility = 'DuplicateVisibility',
  FullVisibility = 'FullVisibility',
  UnspecifiedInsightVisibility = 'UnspecifiedInsightVisibility'
}

export type Institution = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  partyId?: Maybe<Scalars['String']['output']>;
  routingNumber?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type InstitutionFacet = {
  count: Scalars['Int']['output'];
  institutionObject: EntityInstitution;
};

export type InstitutionFilter = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<InstitutionProduct>>;
};

export enum InstitutionKind {
  Bank = 'Bank',
  Expense = 'Expense',
  Ledger = 'Ledger',
  Payment = 'Payment',
  Payroll = 'Payroll'
}

export enum InstitutionProduct {
  BankAccount = 'BankAccount',
  BillPay = 'BillPay',
  CapTable = 'CapTable',
  CreditDebitCard = 'CreditDebitCard',
  Invoicing = 'Invoicing',
  PayrollProvider = 'PayrollProvider',
  Revenue = 'Revenue',
  UnknownProduct = 'UnknownProduct'
}

export enum Interval {
  Biweek = 'Biweek',
  Day = 'Day',
  Hour = 'Hour',
  IntervalNone = 'IntervalNone',
  Minute = 'Minute',
  Month = 'Month',
  Quarter = 'Quarter',
  Week = 'Week',
  Year = 'Year'
}

/** Intervals */
export type IntervalOrigin = {
  index: Scalars['Int']['input'];
  interval: Interval;
  intervalCount?: InputMaybe<Scalars['Int']['input']>;
  maxTime?: InputMaybe<Scalars['DateTime']['input']>;
  year: Scalars['Int']['input'];
};

export type IntervalPartition = {
  origin: IntervalPartitionOrigin;
  step: IntervalPartitionStep;
};

export type IntervalPartitionOrigin = {
  index: Scalars['Int']['input'];
  interval: Interval;
  intervalCount: Scalars['Int']['input'];
};

export type IntervalPartitionStep = {
  interval: Interval;
};

export type Invitation = {
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  invitationType: InvitationType;
  legalEntityRoles?: Maybe<Array<EmployeeLegalEntityRole>>;
  notifiedAt?: Maybe<Scalars['DateTime']['output']>;
  organization?: Maybe<Organization>;
  organizationTemplateId?: Maybe<Scalars['String']['output']>;
  recipient: Contact;
  role?: Maybe<Role>;
  sender?: Maybe<Contact>;
  service?: Maybe<OAuthService>;
  signupId?: Maybe<Scalars['String']['output']>;
  status: InvitationStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type InvitationProposal = {
  createdAt: Scalars['DateTime']['output'];
  invitationId: Scalars['String']['output'];
  legalEntity?: Maybe<EntityLegalEntity>;
  organization?: Maybe<EntityOrganization>;
  organizationTemplateId?: Maybe<Scalars['String']['output']>;
  proposalId: Scalars['String']['output'];
  proposalType: ProposalType;
  recipient?: Maybe<Contact>;
  sender?: Maybe<EntityUser>;
  status: InvitationProposalStatus;
};

export enum InvitationProposalStatus {
  Accepted = 'Accepted',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Rejected = 'Rejected',
  Sent = 'Sent',
  Unknown = 'Unknown'
}

export enum InvitationStatus {
  Accepted = 'Accepted',
  Active = 'Active',
  Cancelled = 'Cancelled',
  Unknown = 'Unknown'
}

export type InvitationToken = {
  token: Scalars['String']['output'];
};

export enum InvitationType {
  Accountant = 'Accountant',
  Operator = 'Operator',
  Passwordless = 'Passwordless',
  UnknownType = 'UnknownType'
}

export type Invoice = {
  branding: InvoiceBranding;
  customer?: Maybe<Customer>;
  discounts?: Maybe<Array<InvoiceDiscount>>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  files?: Maybe<Array<InvoiceFile>>;
  id: Scalars['String']['output'];
  invoiceDate?: Maybe<Scalars['DateTime']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  invoicingProfile?: Maybe<InvoicingProfile>;
  legalEntityId: Scalars['String']['output'];
  lineItems: Array<InvoiceLineItem>;
  memo?: Maybe<Scalars['String']['output']>;
  receivableInvoiceId: Scalars['String']['output'];
  status: InvoiceStatus;
  statusSummary?: Maybe<InvoiceStatusSummary>;
  subtotal?: Maybe<MonetaryValue>;
  taxPercent?: Maybe<Scalars['Float']['output']>;
  totalAmount?: Maybe<MonetaryValue>;
  totalTax?: Maybe<MonetaryValue>;
};

export type InvoiceBranding = {
  backgroundColor?: Maybe<Scalars['String']['output']>;
  coverURL?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

export type InvoiceDiscount = {
  amount: MonetaryValue;
  discount: Discount;
  discountAmount?: Maybe<MonetaryValue>;
  invoiceDiscountId: Scalars['String']['output'];
};

export type InvoiceEdit = {
  dataSourceId: Scalars['String']['input'];
  dataSourceInvoiceId: Scalars['String']['input'];
  dueDate: Scalars['DateTime']['input'];
};

export type InvoiceFile = {
  documentId: Scalars['String']['output'];
  fileType?: Maybe<InvoiceFileType>;
};

export enum InvoiceFileType {
  InvoicePDF = 'InvoicePDF',
  Unknown = 'Unknown'
}

export type InvoiceLineItem = {
  amount: MonetaryValue;
  description?: Maybe<Scalars['String']['output']>;
  discounts?: Maybe<Array<InvoiceDiscount>>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Long']['output'];
  productId?: Maybe<Scalars['String']['output']>;
  quantityValue?: Maybe<QuantityValue>;
  taxable: Scalars['Boolean']['output'];
  unitPrice: MonetaryValue;
};

export type InvoiceMigrationReport = {
  markdown: Scalars['String']['output'];
  summary: InvoiceMigrationReportSummary;
};

export type InvoiceMigrationReportSummary = {
  gcsObjectKey: Scalars['String']['output'];
  legalEntityId: Scalars['String']['output'];
  sizeBytes: Scalars['Long']['output'];
  timestamp: Scalars['String']['output'];
  type: InvoiceMigrationReportType;
};

export enum InvoiceMigrationReportType {
  DryRun = 'DryRun',
  Live = 'Live',
  UnknownInvoiceMigrationReportType = 'UnknownInvoiceMigrationReportType'
}

export type InvoiceNumber = {
  invoiceNumber: Scalars['String']['output'];
};

export type InvoicePaymentDetails = {
  paymentAmount: MonetaryValue;
  paymentConfirmationId: Scalars['String']['output'];
  paymentDate: Scalars['DateTime']['output'];
  paymentInstrument: PaymentInstrument;
};

export enum InvoiceStatus {
  Cancelled = 'Cancelled',
  Created = 'Created',
  /** adding this temporarily to fix an ops issue */
  Draft = 'Draft',
  Failed = 'Failed',
  ManuallySent = 'ManuallySent',
  MarkedAsPaid = 'MarkedAsPaid',
  OnHold = 'OnHold',
  Paid = 'Paid',
  PaymentCanceled = 'PaymentCanceled',
  PaymentProcessing = 'PaymentProcessing',
  PaymentRejected = 'PaymentRejected',
  PaymentRequiresAttention = 'PaymentRequiresAttention',
  PaymentReturned = 'PaymentReturned',
  Pending = 'Pending',
  Refunded = 'Refunded',
  Sent = 'Sent',
  Settled = 'Settled',
  Submitted = 'Submitted',
  Unknown = 'Unknown',
  UnspecifiedBillStatus = 'UnspecifiedBillStatus',
  Voided = 'Voided'
}

export type InvoiceStatusSummary = {
  internalNoteForStatus?: Maybe<Scalars['String']['output']>;
  invoiceSentDate: Scalars['DateTime']['output'];
  status: InvoiceStatus;
  statusAt: Scalars['DateTime']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type InvoicingAddress = {
  address: Address;
  id: Scalars['String']['output'];
};

export type InvoicingProfile = {
  companyAddress: InvoicingAddress;
  companyEmail: Scalars['String']['output'];
  companyIcon?: Maybe<Scalars['String']['output']>;
  companyName: Scalars['String']['output'];
  finalized?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  invoiceNumberFormat?: Maybe<Scalars['String']['output']>;
  invoiceNumberFormatDefault: Scalars['String']['output'];
  payoutInstrumentID: Scalars['String']['output'];
};

export type JobError = {
  createdAt: Scalars['DateTime']['output'];
  errorMessage: Scalars['String']['output'];
  jobMetadata: JobMetadata;
  jobOwner: JobOwner;
  jobType: DataSourceJobType;
};

export type JobMetadata = {
  consumer: Scalars['String']['output'];
  requestObjectId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type JobOwner = {
  dataSourceId: Scalars['String']['output'];
  legalEntityId: Scalars['String']['output'];
};

export type JournalCategoryEntry = {
  accountingType: Scalars['String']['output'];
  canonicalCategoryLabel: Scalars['String']['output'];
  categoryName: Scalars['String']['output'];
  creditAmount?: Maybe<MonetaryValue>;
  debitAmount?: Maybe<MonetaryValue>;
  entryType: Scalars['String']['output'];
};

export type JournalEntriesColumnMappingInput = {
  /**
   * At least one of accountNameColumn / accountNumberColumn must be set.
   * When both are mapped, the workflow resolves accounts via a combined
   * name+number lookup, falling back to number-only then name-only.
   */
  accountNameColumn?: InputMaybe<Scalars['String']['input']>;
  accountNumberColumn?: InputMaybe<Scalars['String']['input']>;
  creditColumn: Scalars['String']['input'];
  dateColumn: Scalars['String']['input'];
  debitColumn: Scalars['String']['input'];
  departmentColumn?: InputMaybe<Scalars['String']['input']>;
  descriptionColumn?: InputMaybe<Scalars['String']['input']>;
  entryIdColumn: Scalars['String']['input'];
  locationColumn?: InputMaybe<Scalars['String']['input']>;
  memoColumn?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<JournalEntriesParseOptionsInput>;
  partyColumn?: InputMaybe<Scalars['String']['input']>;
};

export type JournalEntriesParseOptionsInput = {
  dateFormat?: InputMaybe<Scalars['String']['input']>;
};

export type JournalEntryTag = {
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type LabelCategory = {
  category?: Maybe<EntityCategory>;
  digitsAi?: Maybe<Scalars['Boolean']['output']>;
  displayName: Scalars['String']['output'];
  label: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  tooltip?: Maybe<Scalars['String']['output']>;
  /**
   * This contains a exhaustive list of all of the valid category types
   * that can be assigned to this label for the given connector.
   */
  validCategoryTypes: Array<CategoryType>;
};

export type Layout = {
  layoutId: Scalars['String']['output'];
  layoutVersionId?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<LayoutSection>>;
  viewKey: ViewIdentifier;
};

export type LayoutAttachment = {
  layoutId: Scalars['String']['output'];
  legalEntityId: Scalars['String']['output'];
};

export type LayoutComponent = {
  componentId: Scalars['String']['output'];
  config: LayoutComponentConfig;
  dataId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type LayoutComponentConfig = {
  agingSummaryChart?: Maybe<AgingSummaryChartConfig>;
  cashSummaryChart?: Maybe<CashSummaryChartConfig>;
  categoryByDepartmentChart?: Maybe<CategoryByDepartmentChartConfig>;
  categoryByLocationChart?: Maybe<CategoryByLocationChartConfig>;
  categoryChart?: Maybe<CategoryChartConfig>;
  departmentChart?: Maybe<DepartmentChartConfig>;
  documentCollection?: Maybe<DocumentCollectionConfig>;
  entitiesList?: Maybe<EntitiesListConfig>;
  insight?: Maybe<InsightComponentConfig>;
  locationChart?: Maybe<LocationChartConfig>;
  metricChart?: Maybe<MetricChartConfig>;
  partyChart?: Maybe<PartyChartConfig>;
  portalMetric?: Maybe<PortalMetricConfig>;
  runwayChart?: Maybe<RunwayChartConfig>;
  sourceAccountMetric?: Maybe<SourceAccountMetricConfig>;
  statement?: Maybe<StatementConfig>;
  staticMetric?: Maybe<StaticMetricConfig>;
  summaryLineItem?: Maybe<SummaryLineItemConfig>;
  text?: Maybe<TextComponentConfig>;
  topEntities?: Maybe<TopEntitiesConfig>;
  topTransactions?: Maybe<TopTransactionsConfig>;
  type: LayoutComponentType;
};

export type LayoutComponentConfigInput = {
  agingSummaryChart?: InputMaybe<AgingSummaryChartConfigInput>;
  cashSummaryChart?: InputMaybe<CashSummaryChartConfigInput>;
  categoryByDepartmentChart?: InputMaybe<CategoryByDepartmentChartConfigInput>;
  categoryByLocationChart?: InputMaybe<CategoryByLocationChartConfigInput>;
  categoryChart?: InputMaybe<CategoryChartConfigInput>;
  departmentChart?: InputMaybe<DepartmentChartConfigInput>;
  documentCollection?: InputMaybe<DocumentCollectionConfigInput>;
  insight?: InputMaybe<InsightConfigInput>;
  locationChart?: InputMaybe<LocationChartConfigInput>;
  metricChart?: InputMaybe<MetricChartConfigInput>;
  partyChart?: InputMaybe<PartyChartConfigInput>;
  portalMetric?: InputMaybe<PortalMetricConfigInput>;
  runwayChart?: InputMaybe<RunwayChartConfigInput>;
  sourceAccountMetric?: InputMaybe<SourceAccountMetricConfigInput>;
  statement?: InputMaybe<StatementConfigInput>;
  staticMetric?: InputMaybe<StaticMetricConfigInput>;
  summaryLineItem?: InputMaybe<SummaryLineItemConfigInput>;
  text?: InputMaybe<TextComponentConfigInput>;
  topEntities?: InputMaybe<TopEntitiesConfigInput>;
  topTransactions?: InputMaybe<TopTransactionsConfigInput>;
  type: LayoutComponentType;
};

export type LayoutComponentInput = {
  componentId: Scalars['String']['input'];
  config: LayoutComponentConfigInput;
  dataId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum LayoutComponentType {
  AgingSummaryChart = 'AgingSummaryChart',
  CashSummaryChart = 'CashSummaryChart',
  CategoryBalanceSummaryChart = 'CategoryBalanceSummaryChart',
  CategoryByDepartmentChart = 'CategoryByDepartmentChart',
  CategoryByLocationChart = 'CategoryByLocationChart',
  CategoryTransactionSummaryChart = 'CategoryTransactionSummaryChart',
  DepartmentChart = 'DepartmentChart',
  DocumentCollection = 'DocumentCollection',
  EntitiesList = 'EntitiesList',
  Insight = 'Insight',
  LocationChart = 'LocationChart',
  MetricSummaryChart = 'MetricSummaryChart',
  PartyRoleBalanceSummaryChart = 'PartyRoleBalanceSummaryChart',
  PartyTransactionSummaryChart = 'PartyTransactionSummaryChart',
  PortalMetric = 'PortalMetric',
  RunwayChart = 'RunwayChart',
  SourceAccountMetric = 'SourceAccountMetric',
  Statement = 'Statement',
  StaticMetric = 'StaticMetric',
  SummaryLineItemChart = 'SummaryLineItemChart',
  Text = 'Text',
  TopEntities = 'TopEntities',
  TopTransactions = 'TopTransactions'
}

export type LayoutDocument = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  layoutId: Scalars['String']['output'];
  status: ReportPackageDocumentStatus;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LayoutInput = {
  layoutId: Scalars['String']['input'];
  sections?: InputMaybe<Array<LayoutSectionInput>>;
};

export type LayoutRow = {
  components?: Maybe<Array<LayoutComponent>>;
  rowId: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type LayoutRowInput = {
  components?: InputMaybe<Array<LayoutComponentInput>>;
  rowId: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type LayoutSection = {
  rows?: Maybe<Array<LayoutRow>>;
  sectionId: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type LayoutSectionInput = {
  rows?: InputMaybe<Array<LayoutRowInput>>;
  sectionId: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type LeafAgingSummary = {
  amounts: Array<LeafAgingSummaryAmount>;
  /** @deprecated Use `amounts` instead */
  dimensionSummary: DimensionSummary;
  dueDate: Scalars['DateTime']['output'];
  invoiceDate: Scalars['DateTime']['output'];
  link: LeafAgingSummaryLink;
  referenceNumber?: Maybe<Scalars['String']['output']>;
};

export type LeafAgingSummaryAmount = {
  column: LeafAgingSummaryAmountColumn;
  moneyFlow: MoneyFlow;
};

export enum LeafAgingSummaryAmountColumn {
  Current = 'Current',
  Older = 'Older',
  OneToThirty = 'OneToThirty',
  SixtyOneToNinety = 'SixtyOneToNinety',
  ThirtyOneToSixty = 'ThirtyOneToSixty'
}

export type LeafAgingSummaryLink = {
  hasLink: Scalars['Boolean']['output'];
};

export type LedgerAccountDifferences = {
  creditDifference?: Maybe<MoneyFlow>;
  debitDifference?: Maybe<MoneyFlow>;
  unreconciledDifference: MoneyFlow;
};

export type LedgerBalances = {
  closingBalance: MoneyFlow;
  creditTotal: MoneyFlow;
  debitTotal: MoneyFlow;
  netTotal: MoneyFlow;
  unsettledTotal: MoneyFlow;
};

export type LedgerCategoryInput = {
  canonicalLabel: Scalars['String']['input'];
  categoryName: Scalars['String']['input'];
  categoryType: Scalars['String']['input'];
  description: Scalars['String']['input'];
  nonNegativeBalanceInvariant?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LedgerCustomerDetail = {
  billingAddress?: Maybe<CustomerAddress>;
  contactName?: Maybe<Scalars['String']['output']>;
  customerId: Scalars['String']['output'];
  dataSourcePartyId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  party?: Maybe<EntityParty>;
  paymentTerms?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  providerType: ProviderType;
  secondaryEmail?: Maybe<Scalars['String']['output']>;
  shippingAddress?: Maybe<CustomerAddress>;
};

/**
 * # output types
 * LedgerTransaction is a transaction with multiple lines that are in balance
 */
export type LedgerTransaction = {
  compileSource?: Maybe<CompileSource>;
  externalId: Scalars['String']['output'];
  isMetadataEditable: Scalars['Boolean']['output'];
  isSupersedingLedgerTransaction: Scalars['Boolean']['output'];
  ledgerTransactionId: Scalars['String']['output'];
  lines: Array<TransactionLine>;
  linkedBill?: Maybe<LinkedBill>;
  linkedInvoice?: Maybe<LinkedInvoice>;
  matchedLedgerTransactionIds: Array<Scalars['String']['output']>;
  memo: Scalars['String']['output'];
  providerTypes: Array<ProviderType>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  sources: Array<TransactionSource>;
  supersededLedgerTransactionIds: Array<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
  type: TransactionType;
};

export type LedgerTransactionStale = {
  newViewAvailable: Scalars['Boolean']['output'];
  stale: Scalars['Boolean']['output'];
};

export enum LedgerType {
  Digits = 'Digits',
  QuickBooks = 'QuickBooks',
  Unspecified = 'Unspecified'
}

export type LegalEntity = {
  address: Address;
  fiscalYearNumberOffset: Scalars['Long']['output'];
  fiscalYearStartMonth: Scalars['Long']['output'];
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  incorporatedOn?: Maybe<Date>;
  industry?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  sensitive: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  status: LegalEntityStatus;
  timezone?: Maybe<Scalars['String']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type LegalEntityAspectStatus = {
  legalEntityId: Scalars['String']['output'];
  legalEntityName: Scalars['String']['output'];
  statuses: Array<AspectStatus>;
};

export type LegalEntityBadgeCount = {
  count: Scalars['Long']['output'];
  legalEntityId: Scalars['String']['output'];
};

export type LegalEntityPermission = {
  canManageTransactions: Scalars['Boolean']['input'];
  legalEntityId: Scalars['String']['input'];
};

export type LegalEntityPreferences = {
  bookkeeperAiCutoverAt?: Maybe<Scalars['DateTime']['output']>;
  isCogsInExpenses: Scalars['Boolean']['output'];
  legalEntityId: Scalars['String']['output'];
  lineClassDisplayName: Scalars['String']['output'];
  lineClassPluralDisplayName: Scalars['String']['output'];
  showAgingReports: Scalars['Boolean']['output'];
};

export type LegalEntityRole = {
  legalEntityId: Scalars['String']['input'];
  role: Scalars['String']['input'];
};

export type LegalEntityRoleOptions = {
  legalEntityId: Scalars['String']['output'];
  legalEntityRoles: Array<Role>;
  organizationRoles: Array<Role>;
};

export enum LegalEntityStatus {
  Active = 'Active',
  Approved = 'Approved',
  New = 'New',
  Pending = 'Pending',
  PendingHold = 'PendingHold',
  Removed = 'Removed',
  Unknown = 'Unknown'
}

export type LegalEntityTransfersResult = {
  accountHolderId: Scalars['String']['output'];
  transfers: Array<AdminTransferSummary>;
};

export type LegalEntityUserInfo = {
  legalEntity: LegalEntity;
  userInfo: UserInfo;
};

export type LegalEntityValidationProgress = {
  mlProcessedTransactionsStatus: Array<MlProcessedTransactionsStatus>;
};

export type LineItemFeatureValue = {
  lineItemValue: DocumentLineItem;
};

export type LinkedBill = {
  billDate: Scalars['DateTime']['output'];
  dataSourceId: Scalars['String']['output'];
  dueDate: Scalars['DateTime']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  invoiceNumber: Scalars['String']['output'];
  party?: Maybe<EntityParty>;
  providerType: ProviderType;
};

export type LinkedInvoice = {
  customerDetail?: Maybe<LedgerCustomerDetail>;
  dataSourceId: Scalars['String']['output'];
  dueDate: Scalars['DateTime']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  invoiceDate: Scalars['DateTime']['output'];
  invoiceNumber: Scalars['String']['output'];
  party?: Maybe<EntityParty>;
  providerType: ProviderType;
  referenceNumber: Scalars['String']['output'];
  status: InvoiceStatus;
};

export type LinkedObjectDetails = {
  linkedTransactions: Array<Maybe<Transaction>>;
  paid: Scalars['Boolean']['output'];
  paidDate?: Maybe<Scalars['DateTime']['output']>;
  reversed?: Maybe<Scalars['Boolean']['output']>;
  sourceTransaction?: Maybe<Transaction>;
};

export enum LinkedObjectType {
  Bill = 'Bill',
  Invoice = 'Invoice'
}

export type ListBulkCategorySuggestionsResponse = {
  transactionCategorySuggestions: Array<TransactionCategorySuggestions>;
};

export type ListConnectionsFilter = {
  statusFilter?: InputMaybe<Array<ConnectionStatus>>;
};

export enum ListSignupRequestStatus {
  AllSignups = 'AllSignups',
  Applied = 'Applied',
  Ignored = 'Ignored',
  InviteAccepted = 'InviteAccepted',
  Invited = 'Invited',
  PrimerSent = 'PrimerSent',
  Qualified = 'Qualified',
  Unknown = 'Unknown',
  Unqualified = 'Unqualified',
  Waitlisted = 'Waitlisted'
}

/** TODO: deprecate */
export type ListSimilarTransactionsItem = {
  id: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type Location = {
  active: Scalars['Boolean']['output'];
  ancestors: Array<EntityLocation>;
  dataSource?: Maybe<EntityDataSource>;
  description?: Maybe<Scalars['String']['output']>;
  displayKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use parentId instead */
  parentLocationId?: Maybe<Scalars['String']['output']>;
};

export type LocationChartConfig = {
  locationId: Scalars['String']['output'];
  origin: ArchiveIntervalOrigin;
};

export type LocationChartConfigInput = {
  locationId: Scalars['String']['input'];
  origin: IntervalOrigin;
};

export type LocationDimension = {
  by: DimensionSummary;
  locationId: Scalars['String']['output'];
  locationObject: EntityLocation;
  summary: TransactionSummary;
};

export type LocationFacet = {
  count: Scalars['Int']['output'];
  locationObject: EntityLocation;
};

export type LocationOption = {
  locationId: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type LocationOptionInput = {
  locationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export enum LocationStatus {
  Active = 'Active',
  Disabled = 'Disabled',
  Unknown = 'Unknown'
}

export type LocationSummary = {
  cogsChange: DimensionSummary;
  expensesChange: DimensionSummary;
  incomeChange: DimensionSummary;
  location: EntityLocation;
  otherExpensesChange: DimensionSummary;
  otherIncomeChange: DimensionSummary;
  total: DimensionSummary;
};

export enum ManualMatchType {
  Match = 'Match',
  Unmatch = 'Unmatch'
}

export type MappedCategory = {
  fromCategory?: Maybe<AdminCategory>;
  toCategory?: Maybe<AdminCategory>;
};

export type MappedChartOfAccounts = {
  accountingBasis: AccountingBasis;
  categories: Array<MappedCategory>;
  description?: Maybe<Scalars['String']['output']>;
  fromUUID: Scalars['String']['output'];
  legalEntityId: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  toUUID: Scalars['String']['output'];
};

export enum MappingValidity {
  Invalid = 'Invalid',
  PartiallyValid = 'PartiallyValid',
  Valid = 'Valid'
}

export type MarketingEvent = {
  attributes?: InputMaybe<MarketingEventAttributes>;
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  persona?: InputMaybe<MarketingEventPersona>;
  state?: InputMaybe<Scalars['String']['input']>;
  type: MarketingEventType;
};

export type MarketingEventAttributes = {
  accountState?: InputMaybe<Scalars['String']['input']>;
  accountantCount?: InputMaybe<Scalars['String']['input']>;
  affiliationCount?: InputMaybe<Scalars['String']['input']>;
  clientCount?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  createAt?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formerProvider?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  ledger?: InputMaybe<Scalars['String']['input']>;
  planName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export enum MarketingEventPersona {
  Accountant = 'Accountant',
  Developer = 'Developer',
  Operator = 'Operator',
  UnknownPersona = 'UnknownPersona'
}

export enum MarketingEventType {
  OnboardingAccountDetailsComplete = 'OnboardingAccountDetailsComplete',
  OnboardingAccountSetupComplete = 'OnboardingAccountSetupComplete',
  OnboardingAddCC = 'OnboardingAddCC',
  OnboardingAddClient = 'OnboardingAddClient',
  OnboardingAddClientInviteSent = 'OnboardingAddClientInviteSent',
  OnboardingConnectQBO = 'OnboardingConnectQBO',
  OnboardingConnectionAdded = 'OnboardingConnectionAdded',
  OnboardingFormerProvider = 'OnboardingFormerProvider',
  OnboardingSelectBank = 'OnboardingSelectBank',
  OnboardingSelectFinanceTools = 'OnboardingSelectFinanceTools',
  OnboardingSelfPaidClientBillingAddressComplete = 'OnboardingSelfPaidClientBillingAddressComplete',
  OnboardingSelfPaidClientConnectionsComplete = 'OnboardingSelfPaidClientConnectionsComplete',
  OnboardingSelfPaidClientPaymentMethodAdded = 'OnboardingSelfPaidClientPaymentMethodAdded',
  OnboardingSelfPaidClientRequiredConnectionMet = 'OnboardingSelfPaidClientRequiredConnectionMet',
  OnboardingSelfPaidClientSignIn = 'OnboardingSelfPaidClientSignIn',
  OnboardingSelfPaidClientSignUp = 'OnboardingSelfPaidClientSignUp',
  OnboardingSignIn = 'OnboardingSignIn',
  OnboardingSignUp = 'OnboardingSignUp',
  PlanManagementAddUser = 'PlanManagementAddUser',
  PlanManagementPaymentComplete = 'PlanManagementPaymentComplete',
  PlanManagementPlanCancelled = 'PlanManagementPlanCancelled',
  PlanManagementPlanDowngrade = 'PlanManagementPlanDowngrade',
  PlanManagementPlanUpgrade = 'PlanManagementPlanUpgrade',
  PlanManagementTrialCancel = 'PlanManagementTrialCancel',
  TrialEnd = 'TrialEnd',
  TrialStart = 'TrialStart',
  UnknownType = 'UnknownType',
  UsageActivateLegalEntity = 'UsageActivateLegalEntity',
  UsageAddUser = 'UsageAddUser',
  UsageBillPayed = 'UsageBillPayed',
  UsageCreateReport = 'UsageCreateReport',
  UsageRecategorizeTransaction = 'UsageRecategorizeTransaction',
  UsageSendInvoice = 'UsageSendInvoice',
  UsageShareReport = 'UsageShareReport',
  UsageSignIn = 'UsageSignIn'
}

export type MatchPotentialDuplicateFlagTransactionsInput = {
  documentFeatureGroupId: Scalars['String']['input'];
  flagId: Scalars['String']['input'];
  reconciledLedgerTransactionId: Scalars['String']['input'];
  unsettledLedgerTransactionId: Scalars['String']['input'];
};

export type MatchResponse = {
  neighbor: Array<Neighbor>;
};

export type MatchSetEntry = {
  createdAt: Scalars['DateTime']['output'];
  dataSourceId: Scalars['String']['output'];
  entryType: MatchedSetRowType;
  id: Scalars['String']['output'];
  legalEntityId: Scalars['String']['output'];
  matchSetId: Scalars['String']['output'];
  transactionFactId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** ## */
export enum MatchType {
  Heuristic = 'Heuristic',
  Manual = 'Manual',
  SourceLinked = 'SourceLinked',
  Unknown = 'Unknown'
}

export type MatchedDepartment = {
  dataSourceId: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export enum MatchedSetRowType {
  JournalEntry = 'JournalEntry',
  Recorded = 'Recorded',
  SourceCredit = 'SourceCredit',
  SourceDebit = 'SourceDebit',
  Unknown = 'Unknown'
}

export enum MatchedStatus {
  Matched = 'Matched',
  UnknownMatchedStatus = 'UnknownMatchedStatus',
  Unmatched = 'Unmatched'
}

export type MatchedStatusFacet = {
  count: Scalars['Int']['output'];
  status: MatchedStatus;
};

export enum Matcher {
  Category = 'Category',
  CategoryType = 'CategoryType',
  PartyRole = 'PartyRole',
  ProductArea = 'ProductArea'
}

export enum MergeableStatus {
  Behind = 'Behind',
  Blocked = 'Blocked',
  Clean = 'Clean',
  Dirty = 'Dirty',
  Draft = 'Draft',
  HasHooks = 'HasHooks',
  UnknownMergeableStatus = 'UnknownMergeableStatus',
  Unstable = 'Unstable'
}

export type MetricCategoriesOperand = {
  categories: Array<EntityCategory>;
  defaultCategoryType: CategoryType;
  isBalance: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  naturalFlow: Flow;
  period?: Maybe<Period>;
};

export type MetricChartConfig = {
  item: MetricSummaryItem;
  origin: ArchiveIntervalOrigin;
};

export type MetricChartConfigInput = {
  item: MetricSummaryItem;
  origin: IntervalOrigin;
};

export type MetricEquation = {
  terms: Array<MetricTerm>;
};

export type MetricOperation = {
  symbol: MetricSymbol;
};

export enum MetricSummaryItem {
  GrossBurn = 'GrossBurn',
  GrossIncome = 'GrossIncome',
  NetBurn = 'NetBurn',
  UnknownMetricType = 'UnknownMetricType'
}

export type MetricSummaryTypeOperand = {
  defaultCategoryType: CategoryType;
  isBalance: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  naturalFlow: Flow;
  period?: Maybe<Period>;
  type: MetricSummaryItem;
};

export enum MetricSymbol {
  Add = 'Add',
  Divide = 'Divide',
  Subtract = 'Subtract'
}

export type MetricTerm = MetricCategoriesOperand | MetricOperation | MetricSummaryTypeOperand;

export enum MetricType {
  COGS = 'COGS',
  Expenses = 'Expenses',
  GrossProfit = 'GrossProfit',
  Income = 'Income',
  NetIncome = 'NetIncome',
  NetOperatingIncome = 'NetOperatingIncome',
  ProfitPercentage = 'ProfitPercentage'
}

export enum MetricValidationType {
  GrossBurn = 'GrossBurn',
  GrossIncome = 'GrossIncome',
  NetBurn = 'NetBurn',
  Runway = 'Runway'
}

export enum MfaMethod {
  RecoveryCode = 'RecoveryCode',
  TOTP = 'TOTP',
  UnknownMfaMethod = 'UnknownMfaMethod'
}

export type MigrationFileSummary = {
  file: PullRequestFile;
  hasRun: Scalars['Boolean']['output'];
};

export type MigrationPullRequest = {
  fileSummaries: Array<MigrationFileSummary>;
  pullRequestSummary: PullRequestSummary;
};

export type MinMaxAmount = {
  maxAmount: MonetaryValue;
  minAmount: MonetaryValue;
};

export type MismatchedQuickbooksBalanceSheetCategory = {
  categoryName: Scalars['String']['output'];
  categoryType: Scalars['String']['output'];
  digitsEndingBalance: Scalars['Long']['output'];
  digitsStartingBalance: Scalars['Long']['output'];
  endingDelta: Scalars['Long']['output'];
  externalEndingBalance: Scalars['Long']['output'];
  externalStartingBalance: Scalars['Long']['output'];
  period: Period;
  startingDelta: Scalars['Long']['output'];
};

export type MismatchedQuickbooksCategory = {
  categoryName: Scalars['String']['output'];
  categoryType: Scalars['String']['output'];
  difference: Scalars['Long']['output'];
  digitsValue: Scalars['Long']['output'];
  externalValue: Scalars['Long']['output'];
  period: Period;
};

export enum MissingObject {
  Exclude = 'Exclude',
  Include = 'Include',
  Unknown = 'Unknown'
}

export type MlProcessedTransactionsStatus = {
  dataSourceId: Scalars['String']['output'];
  mlProcessedTransactionsCount: Scalars['Long']['output'];
  totalTransactionsCount: Scalars['Long']['output'];
};

export type MonetaryFeatureValue = {
  monetaryValue: MonetaryValue;
};

/** MonetaryValue */
export type MonetaryValue = {
  amount: Scalars['Long']['output'];
  currencyMultiplier: Scalars['Long']['output'];
  iso4217CurrencyCode: Scalars['String']['output'];
};

export type MoneyFlow = {
  businessFlow: Flow;
  isNormal: Scalars['Boolean']['output'];
  value: MonetaryValue;
};

export type MoneyFlowInput = {
  businessFlow: Flow;
  isNormal: Scalars['Boolean']['input'];
  value: InputMonetaryValue;
};

export type Mutation = {
  addAffiliatedSubscriptionPrice?: Maybe<Scalars['Void']['output']>;
  /**
   * Adds an aspect to an organization's package and unconditionally upserts
   * organization_aspect_statuses with (source=Package, status=Enabled). The
   * upsert overrides any prior source — "Package always wins". Refuses to
   * violate the catalog OneWay invariant.
   */
  addOrganizationPackageAspect?: Maybe<Scalars['Void']['output']>;
  addReportValidationMetric?: Maybe<Scalars['Void']['output']>;
  /** Aspects */
  approveRequest?: Maybe<Scalars['Void']['output']>;
  attachClientPaysLegalEntity?: Maybe<Scalars['Void']['output']>;
  attachLegalEntity?: Maybe<Scalars['Void']['output']>;
  backfillActionItemAssociations?: Maybe<Scalars['Void']['output']>;
  backfillConnectionAccountType?: Maybe<Scalars['Void']['output']>;
  backfillPlaidConnection?: Maybe<Scalars['Void']['output']>;
  backfillRampConnection?: Maybe<Scalars['Void']['output']>;
  banUser?: Maybe<Scalars['Void']['output']>;
  blockPayments?: Maybe<Scalars['Void']['output']>;
  bootstrapSandboxAccountingOrganization?: Maybe<Scalars['Void']['output']>;
  cancelInvitation?: Maybe<Scalars['Void']['output']>;
  claimFundsForLE?: Maybe<Scalars['Void']['output']>;
  closeAdyenAccountHolder?: Maybe<Scalars['Void']['output']>;
  createAlias: GlobalPartyAlias;
  createConnection: AdminConnection;
  createConnectionTemplate?: Maybe<Scalars['Void']['output']>;
  /** Doppelganger */
  createDoppelgangerPermit: AdminDoppelgangerPermit;
  /**
   * createEnterpriseOrganization creates an org in identity and provisions a billing package with a
   * ProspectFirm subscription. If userId is provided, the user is added as OrgAdmin.
   * comment and contextUrl are optional and recorded on the package row + billing
   * organization_package_history row for audit purposes.
   */
  createEnterpriseOrganization: CreateEnterpriseOrganizationResponse;
  createGlobalParty: AdminParty;
  /** Institutions */
  createInstitution: AdminInstitution;
  createMatchConfiguration: Scalars['String']['output'];
  /**
   * createOrganizationPackage attaches a new package to an existing accounting firm.
   * The comment is required and recorded on the package row for audit purposes.
   */
  createOrganizationPackage?: Maybe<Scalars['Void']['output']>;
  createOrganizationPackageProduct?: Maybe<Scalars['Void']['output']>;
  createOrganizationProduct?: Maybe<Scalars['Void']['output']>;
  /** Billing */
  createOrganizationTier?: Maybe<Scalars['Void']['output']>;
  createPrefixMapping: PrefixMapping;
  /** Report Packages */
  createReportPackage: ReportPackageMetadata;
  /** Superusers */
  createSuperuser: Superuser;
  /** Data Sources */
  deleteAdminDataSource?: Maybe<Scalars['Void']['output']>;
  deleteAlias?: Maybe<Scalars['Void']['output']>;
  deleteAspectStatus?: Maybe<Scalars['Void']['output']>;
  /** Connect */
  deleteConnection?: Maybe<Scalars['Void']['output']>;
  deleteConnectionTemplate?: Maybe<Scalars['Void']['output']>;
  deleteCsvImportTransactions?: Maybe<Scalars['Void']['output']>;
  deleteGlobalParty?: Maybe<Scalars['Void']['output']>;
  deleteMatchConfiguration?: Maybe<Scalars['Void']['output']>;
  deleteOrganizationAspectStatus?: Maybe<Scalars['Void']['output']>;
  deleteOrganizationPackageProduct?: Maybe<Scalars['Void']['output']>;
  deleteOrganizationProduct?: Maybe<Scalars['Void']['output']>;
  deleteOrganizationTier?: Maybe<Scalars['Void']['output']>;
  deletePartyExtraction?: Maybe<Scalars['Void']['output']>;
  /** Prefixes */
  deletePrefixMapping?: Maybe<Scalars['Void']['output']>;
  deleteReportPackage?: Maybe<Scalars['Void']['output']>;
  deleteReportValidationMetric?: Maybe<Scalars['Void']['output']>;
  /** Parties */
  designateParty?: Maybe<Scalars['Void']['output']>;
  detachClientPaysClient?: Maybe<Scalars['Void']['output']>;
  detachFirmClient?: Maybe<Scalars['Void']['output']>;
  disableConnection?: Maybe<Scalars['Void']['output']>;
  disconnectPlaidItem?: Maybe<Scalars['Void']['output']>;
  enableCategoryManager?: Maybe<Scalars['Void']['output']>;
  enableConnection?: Maybe<Scalars['Void']['output']>;
  /** Secrets */
  encryptSecret: Scalars['String']['output'];
  enqueuePaymentCapture?: Maybe<Scalars['Void']['output']>;
  exportSandboxData?: Maybe<Scalars['Void']['output']>;
  ignorePrefix?: Maybe<Scalars['Void']['output']>;
  ledgerBackfillCategories?: Maybe<Scalars['Void']['output']>;
  ledgerCreateCategory: Scalars['String']['output'];
  ledgerCreateJournalEntry: Scalars['String']['output'];
  mergeMigrationPullRequest?: Maybe<Scalars['Void']['output']>;
  migrateFirmClient?: Maybe<Scalars['Void']['output']>;
  migrateFirmPaidClientsToPrice?: Maybe<Scalars['Void']['output']>;
  migrateOperatorSubscription: OrganizationSubscriptionMigrationReport;
  onboard?: Maybe<Scalars['Void']['output']>;
  plaidRefreshStatements?: Maybe<RawResponse>;
  plaidTriggerRefresh?: Maybe<Scalars['Void']['output']>;
  /** Charts of Accounts */
  populateLERoots: Scalars['Void']['output'];
  provisionOperatorSubscription?: Maybe<Scalars['Void']['output']>;
  reactivateAdyenAccountHolder?: Maybe<Scalars['Void']['output']>;
  /** Documents */
  regenerateFingerprints: Scalars['Int']['output'];
  regenerateInvoicePDFs?: Maybe<Scalars['Void']['output']>;
  removeAffiliateEmployment?: Maybe<Scalars['Void']['output']>;
  /**
   * Removes an aspect from an organization's package and unconditionally
   * upserts organization_aspect_statuses with (source=Package,
   * status=Disabled). Comment is required and recorded in the package aspect
   * history.
   */
  removeOrganizationPackageAspect?: Maybe<Scalars['Void']['output']>;
  replayActionItemEventDLQ?: Maybe<Scalars['Void']['output']>;
  /** Action Item */
  replayObjectEventActionItemDLQ?: Maybe<Scalars['Void']['output']>;
  republishPubSubMessages?: Maybe<Scalars['Void']['output']>;
  /** Invoices */
  resaveInvoices?: Maybe<Scalars['Void']['output']>;
  researchParty?: Maybe<Scalars['Void']['output']>;
  resendActivationEmail?: Maybe<Scalars['Void']['output']>;
  resendClientPaysInvitationByOrganization?: Maybe<Scalars['Void']['output']>;
  resendInvitation?: Maybe<Scalars['Void']['output']>;
  resetConnection?: Maybe<Scalars['Void']['output']>;
  resetLockout?: Maybe<Scalars['Void']['output']>;
  resetMfa?: Maybe<Scalars['Void']['output']>;
  resetWorkItem?: Maybe<Scalars['Void']['output']>;
  resumeSubscription?: Maybe<Scalars['Void']['output']>;
  reviveOperatorSubscription?: Maybe<Scalars['Void']['output']>;
  /** Migrations */
  runMigrationPullRequest?: Maybe<Scalars['Void']['output']>;
  sendInvitation?: Maybe<Scalars['Void']['output']>;
  sendInvoiceEmail?: Maybe<Scalars['Void']['output']>;
  sendManagedOperatorInvitation?: Maybe<Scalars['Void']['output']>;
  setAppVisibility?: Maybe<Scalars['Void']['output']>;
  setConnectionActionItem?: Maybe<Scalars['Void']['output']>;
  setFailoverSetting?: Maybe<Scalars['Void']['output']>;
  setLegalEntitySlug?: Maybe<Scalars['Void']['output']>;
  setOrganizationSlug?: Maybe<Scalars['Void']['output']>;
  /** Payment Settlement Config */
  setPaymentSettlementConfig: PaymentSettlementConfig;
  /** Soft Delete */
  softDeleteOrganization?: Maybe<Scalars['Void']['output']>;
  syncConnection?: Maybe<Scalars['Void']['output']>;
  testBillingError?: Maybe<Scalars['Void']['output']>;
  /** Checks */
  testCheckbookStatusUpdate?: Maybe<Scalars['Void']['output']>;
  /** Restricted Capabilities */
  toggleRestrictedCapability: RestrictedCapabilityToggleResult;
  triggerClassificationManifest?: Maybe<TriggerClassificationManifestResponse>;
  triggerCustomAccountingCorrection?: Maybe<Scalars['Void']['output']>;
  triggerCustomLedgerCorrection?: Maybe<Scalars['Void']['output']>;
  triggerCustomPaymentsCorrection?: Maybe<Scalars['Void']['output']>;
  triggerDataSourceClassification?: Maybe<Scalars['Void']['output']>;
  triggerDebugTransactionExport: EntityLegalEntity;
  /** Supports developer CLI tool for debugging data exports */
  triggerDebugViewExport: EntityLegalEntity;
  /** Data Processing */
  triggerDenormalizedViewGeneration?: Maybe<Scalars['Void']['output']>;
  /** Transaction Review */
  triggerDigitsLedgerReview?: Maybe<Scalars['Void']['output']>;
  triggerFraudCheckAccounting?: Maybe<Scalars['Void']['output']>;
  triggerReportValidation?: Maybe<Scalars['Void']['output']>;
  /** Transaction Facts */
  triggerSourceDataClassification?: Maybe<Scalars['Void']['output']>;
  /** Work Items */
  triggerTransactionAuditCheck?: Maybe<Scalars['Void']['output']>;
  unbanUser?: Maybe<Scalars['Void']['output']>;
  unignorePrefix?: Maybe<Scalars['Void']['output']>;
  updateAffiliatedSubscriptionPrice?: Maybe<Scalars['Void']['output']>;
  updateAspectStatus?: Maybe<Scalars['Void']['output']>;
  /** Feature Flags */
  updateConnectionFeatureFlagStatus?: Maybe<Scalars['Void']['output']>;
  updateConnectionTemplate?: Maybe<Scalars['Void']['output']>;
  /** Notifications */
  updateEmailDeliveryPreferences?: Maybe<Scalars['Void']['output']>;
  /** Employees */
  updateEmployeeHidden?: Maybe<Scalars['Void']['output']>;
  updateEmployeeRole?: Maybe<Scalars['Void']['output']>;
  updateEmployeeStatus: AdminEmployee;
  updateGlobalParty?: Maybe<Scalars['Void']['output']>;
  updateInstitution?: Maybe<Scalars['Void']['output']>;
  updateInstitutionParty?: Maybe<Scalars['Void']['output']>;
  updateInstitutionProducts?: Maybe<Scalars['Void']['output']>;
  /** Legal Entities */
  updateLegalEntityStatus?: Maybe<Scalars['Void']['output']>;
  updateOperatorSubscription?: Maybe<Scalars['Void']['output']>;
  updateOrganizationAspectStatus?: Maybe<Scalars['Void']['output']>;
  updateOrganizationPackageProduct?: Maybe<Scalars['Void']['output']>;
  updateOrganizationPackageProductMode?: Maybe<Scalars['Void']['output']>;
  updateOrganizationTier?: Maybe<Scalars['Void']['output']>;
  updateParty?: Maybe<Scalars['Void']['output']>;
  /** Pipeline Definitions */
  updatePipelineDefinitionStatus?: Maybe<Scalars['Void']['output']>;
  /** Signups */
  updateSignupStatus?: Maybe<Scalars['Void']['output']>;
  /** Users and Invitations */
  updateUser?: Maybe<Scalars['Void']['output']>;
  uploadAdyenDocument?: Maybe<Scalars['Boolean']['output']>;
};


export type MutationAddAffiliatedSubscriptionPriceArgs = {
  affiliatedLegalEntityId: Scalars['String']['input'];
  affiliatedOrganizationId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
};


export type MutationAddOrganizationPackageAspectArgs = {
  aspectId: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  contextUrl?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  packageId: Scalars['String']['input'];
};


export type MutationAddReportValidationMetricArgs = {
  cashOutDate?: InputMaybe<Scalars['DateTime']['input']>;
  interval: Interval;
  legalEntityId: Scalars['String']['input'];
  moneyFlow: MoneyFlowInput;
  period: PeriodInput;
  type: MetricValidationType;
};


export type MutationApproveRequestArgs = {
  id: Scalars['String']['input'];
};


export type MutationAttachClientPaysLegalEntityArgs = {
  attachmentOrganizationId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationAttachLegalEntityArgs = {
  attachmentOrganizationId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationBackfillActionItemAssociationsArgs = {
  kind: BackfillActionItemKind;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationBackfillConnectionAccountTypeArgs = {
  connectionId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationBackfillPlaidConnectionArgs = {
  id: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationBackfillRampConnectionArgs = {
  id: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationBanUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationBlockPaymentsArgs = {
  description: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationBootstrapSandboxAccountingOrganizationArgs = {
  userId: Scalars['String']['input'];
};


export type MutationCancelInvitationArgs = {
  token: Scalars['String']['input'];
};


export type MutationClaimFundsForLeArgs = {
  amount: InputMonetaryValue;
  billPaymentId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  payerCompanyName: Scalars['String']['input'];
  recipientEmailAddress: Scalars['String']['input'];
};


export type MutationCloseAdyenAccountHolderArgs = {
  description: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationCreateAliasArgs = {
  alias: Scalars['String']['input'];
  partyId: Scalars['String']['input'];
};


export type MutationCreateConnectionArgs = {
  connection: NewAdminConnection;
  status: ConnectionStatus;
  userId: Scalars['String']['input'];
};


export type MutationCreateConnectionTemplateArgs = {
  connectorId: Scalars['String']['input'];
  institutionId: Scalars['String']['input'];
};


export type MutationCreateDoppelgangerPermitArgs = {
  justification?: InputMaybe<Scalars['String']['input']>;
  targetUserId: Scalars['String']['input'];
};


export type MutationCreateEnterpriseOrganizationArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  contextUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateGlobalPartyArgs = {
  aliases: Array<Scalars['String']['input']>;
  fields: NewParty;
  prefixes: Array<Scalars['String']['input']>;
};


export type MutationCreateInstitutionArgs = {
  kind: InstitutionKind;
  name: Scalars['String']['input'];
  partyId: Scalars['String']['input'];
  routingNumber: Scalars['String']['input'];
  url: Scalars['String']['input'];
};


export type MutationCreateMatchConfigurationArgs = {
  ledgerTransactionIds: Array<Scalars['String']['input']>;
  manualMatchType: ManualMatchType;
};


export type MutationCreateOrganizationPackageArgs = {
  comment: Scalars['String']['input'];
  contextUrl?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
};


export type MutationCreateOrganizationPackageProductArgs = {
  billable: Scalars['Boolean']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  contextUrl?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  packageId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};


export type MutationCreateOrganizationProductArgs = {
  organizationId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};


export type MutationCreateOrganizationTierArgs = {
  couponId: Scalars['String']['input'];
  discountLevel: DiscountLevel;
  organizationId: Scalars['String']['input'];
};


export type MutationCreatePrefixMappingArgs = {
  partyId: Scalars['String']['input'];
  prefix: Scalars['String']['input'];
};


export type MutationCreateReportPackageArgs = {
  attachments: NewReportAttachments;
  interval: Interval;
  periodEndAt: DateInput;
  periodStartAt: DateInput;
  title: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type MutationCreateSuperuserArgs = {
  emailAddress: Scalars['String']['input'];
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  roleIdentifiers: Array<Scalars['String']['input']>;
};


export type MutationDeleteAdminDataSourceArgs = {
  dataSourceId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  providerType: ProviderType;
};


export type MutationDeleteAliasArgs = {
  alias: Scalars['String']['input'];
  partyId: Scalars['String']['input'];
};


export type MutationDeleteAspectStatusArgs = {
  aspectId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationDeleteConnectionArgs = {
  id: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationDeleteConnectionTemplateArgs = {
  connectorId: Scalars['String']['input'];
  institutionId: Scalars['String']['input'];
};


export type MutationDeleteCsvImportTransactionsArgs = {
  csvImportId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationDeleteGlobalPartyArgs = {
  partyId: Scalars['String']['input'];
};


export type MutationDeleteMatchConfigurationArgs = {
  manualMatchType: ManualMatchType;
  matchId: Scalars['String']['input'];
};


export type MutationDeleteOrganizationAspectStatusArgs = {
  aspectId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationDeleteOrganizationPackageProductArgs = {
  comment: Scalars['String']['input'];
  contextUrl?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  packageId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};


export type MutationDeleteOrganizationProductArgs = {
  organizationId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};


export type MutationDeleteOrganizationTierArgs = {
  couponId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationDeletePartyExtractionArgs = {
  legalEntityId: Scalars['String']['input'];
  partyExtractionId: Scalars['String']['input'];
};


export type MutationDeletePrefixMappingArgs = {
  partyId: Scalars['String']['input'];
  prefix: Scalars['String']['input'];
};


export type MutationDeleteReportPackageArgs = {
  legalEntityId: Scalars['String']['input'];
  packageId: Scalars['String']['input'];
};


export type MutationDeleteReportValidationMetricArgs = {
  interval: Interval;
  legalEntityId: Scalars['String']['input'];
  period: PeriodInput;
  type: MetricValidationType;
};


export type MutationDesignatePartyArgs = {
  designation: PartyDesignation;
  legalEntityId: Scalars['String']['input'];
  partyId: Scalars['String']['input'];
};


export type MutationDetachClientPaysClientArgs = {
  clientLegalEntityId: Scalars['String']['input'];
  clientOrganizationId: Scalars['String']['input'];
  firmOrganizationId: Scalars['String']['input'];
};


export type MutationDetachFirmClientArgs = {
  clientLegalEntityId: Scalars['String']['input'];
  firmOrganizationId: Scalars['String']['input'];
};


export type MutationDisableConnectionArgs = {
  id: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationDisconnectPlaidItemArgs = {
  accessToken: Scalars['String']['input'];
};


export type MutationEnableCategoryManagerArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type MutationEnableConnectionArgs = {
  id: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationEncryptSecretArgs = {
  data: Scalars['String']['input'];
};


export type MutationEnqueuePaymentCaptureArgs = {
  paymentIntentId: Scalars['String']['input'];
  topic: Scalars['String']['input'];
};


export type MutationExportSandboxDataArgs = {
  industry: SandboxIndustry;
  sandboxType: SandboxType;
};


export type MutationIgnorePrefixArgs = {
  prefix: Scalars['String']['input'];
};


export type MutationLedgerBackfillCategoriesArgs = {
  category: LedgerCategoryInput;
  chartOfAccountsID: Scalars['String']['input'];
};


export type MutationLedgerCreateCategoryArgs = {
  category: LedgerCategoryInput;
  legalEntityId: Scalars['String']['input'];
};


export type MutationLedgerCreateJournalEntryArgs = {
  amount: Scalars['Long']['input'];
  creditCanonicalCategoryLabel: Scalars['String']['input'];
  debitCanonicalCategoryLabel: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationMergeMigrationPullRequestArgs = {
  prNumber: Scalars['Int']['input'];
  repo: Scalars['String']['input'];
};


export type MutationMigrateFirmClientArgs = {
  clientLegalEntityId: Scalars['String']['input'];
  sourceFirmOrganizationId: Scalars['String']['input'];
  targetFirmOrganizationId: Scalars['String']['input'];
};


export type MutationMigrateFirmPaidClientsToPriceArgs = {
  fromStripePriceId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  toStripePriceId: Scalars['String']['input'];
};


export type MutationMigrateOperatorSubscriptionArgs = {
  dryRun: Scalars['Boolean']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationOnboardArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type MutationPlaidRefreshStatementsArgs = {
  endDate: Scalars['String']['input'];
  id: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type MutationPlaidTriggerRefreshArgs = {
  id: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationPopulateLeRootsArgs = {
  id: Scalars['String']['input'];
};


export type MutationProvisionOperatorSubscriptionArgs = {
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationReactivateAdyenAccountHolderArgs = {
  description: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationRegenerateFingerprintsArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type MutationRegenerateInvoicePdFsArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type MutationRemoveAffiliateEmploymentArgs = {
  employeeId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationRemoveOrganizationPackageAspectArgs = {
  aspectId: Scalars['String']['input'];
  comment: Scalars['String']['input'];
  contextUrl?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  packageId: Scalars['String']['input'];
};


export type MutationRepublishPubSubMessagesArgs = {
  destinationTopic: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  sourceSubscription: Scalars['String']['input'];
};


export type MutationResearchPartyArgs = {
  legalEntityId: Scalars['String']['input'];
  partyId: Scalars['String']['input'];
  partyName: Scalars['String']['input'];
};


export type MutationResendActivationEmailArgs = {
  legalEntityId: Scalars['String']['input'];
  recipientId: Scalars['String']['input'];
};


export type MutationResendClientPaysInvitationByOrganizationArgs = {
  firmOrganizationId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationResendInvitationArgs = {
  token: Scalars['String']['input'];
};


export type MutationResetConnectionArgs = {
  id: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationResetLockoutArgs = {
  justification: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationResetMfaArgs = {
  justification: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationResetWorkItemArgs = {
  workItemId: Scalars['String']['input'];
};


export type MutationResumeSubscriptionArgs = {
  comment: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  ticketLink: Scalars['String']['input'];
};


export type MutationReviveOperatorSubscriptionArgs = {
  comment: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  ticketLink: Scalars['String']['input'];
};


export type MutationRunMigrationPullRequestArgs = {
  filename: Scalars['String']['input'];
  isPartitionableDML: Scalars['Boolean']['input'];
  overrideMigrationRecord?: InputMaybe<Scalars['Boolean']['input']>;
  prNumber: Scalars['Int']['input'];
  repo: Scalars['String']['input'];
};


export type MutationSendInvitationArgs = {
  defaultEntityRole?: InputMaybe<Scalars['String']['input']>;
  destinationOrganizationId?: InputMaybe<Scalars['String']['input']>;
  destinationOrganizationRole?: InputMaybe<Scalars['String']['input']>;
  invitationType: Scalars['String']['input'];
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  newOrganizationIcon?: InputMaybe<Scalars['String']['input']>;
  newOrganizationName?: InputMaybe<Scalars['String']['input']>;
  newOrganizationWebsiteUrl?: InputMaybe<Scalars['String']['input']>;
  proposalType?: InputMaybe<ProposalType>;
  recipient: ContactInput;
  signupId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendInvoiceEmailArgs = {
  invoiceId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationSendManagedOperatorInvitationArgs = {
  affiliateOrganizationId: Scalars['String']['input'];
  affiliateUserId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  recipient: ContactInput;
  redirectPath?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetAppVisibilityArgs = {
  connectorId: Scalars['String']['input'];
  visibility: ConnectorVisibility;
};


export type MutationSetConnectionActionItemArgs = {
  action: ActionItemAction;
  id: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  status: ActionItemStatus;
};


export type MutationSetFailoverSettingArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type MutationSetLegalEntitySlugArgs = {
  legalEntityId: Scalars['String']['input'];
  newSlug: Scalars['String']['input'];
  updateOrganizationSlug: Scalars['Boolean']['input'];
};


export type MutationSetOrganizationSlugArgs = {
  newSlug: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationSetPaymentSettlementConfigArgs = {
  additionalPaymentSettlementDays: Scalars['Int']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationSoftDeleteOrganizationArgs = {
  deleteUsers: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  kind: OrganizationKind;
};


export type MutationSyncConnectionArgs = {
  id: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationTestCheckbookStatusUpdateArgs = {
  checkId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  status: CheckbookStatus;
};


export type MutationToggleRestrictedCapabilityArgs = {
  capability: RestrictedCapabilityName;
  enabled: Scalars['Boolean']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationTriggerClassificationManifestArgs = {
  boundaryDate?: InputMaybe<Scalars['DateTime']['input']>;
  legalEntityId: Scalars['String']['input'];
};


export type MutationTriggerCustomAccountingCorrectionArgs = {
  backfillPdfRequestIds?: InputMaybe<Scalars['Boolean']['input']>;
  batchId: Scalars['String']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  legalEntityIds: Array<Scalars['String']['input']>;
};


export type MutationTriggerCustomPaymentsCorrectionArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  trusted?: InputMaybe<Scalars['Boolean']['input']>;
  verifiedAfter?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTriggerDataSourceClassificationArgs = {
  dataSourceId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationTriggerDebugTransactionExportArgs = {
  dstLegalEntityId: Scalars['String']['input'];
  secret: Scalars['String']['input'];
  secretId: Scalars['String']['input'];
  srcLegalEntityId: Scalars['String']['input'];
  srcTransactionFactId: Scalars['String']['input'];
};


export type MutationTriggerDebugViewExportArgs = {
  dstLegalEntityId: Scalars['String']['input'];
  dstViewVersion: Scalars['String']['input'];
  secret: Scalars['String']['input'];
  secretId: Scalars['String']['input'];
  srcLegalEntityId: Scalars['String']['input'];
  srcViewVersion?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTriggerDenormalizedViewGenerationArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type MutationTriggerDigitsLedgerReviewArgs = {
  ledgerType: LedgerType;
  legalEntityId: Scalars['String']['input'];
};


export type MutationTriggerFraudCheckAccountingArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type MutationTriggerReportValidationArgs = {
  legalEntityIds: Array<Scalars['String']['input']>;
  period: PeriodInput;
};


export type MutationTriggerSourceDataClassificationArgs = {
  dataSourceId: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationTriggerTransactionAuditCheckArgs = {
  transactionFactId: Scalars['String']['input'];
};


export type MutationUnbanUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationUnignorePrefixArgs = {
  prefix: Scalars['String']['input'];
};


export type MutationUpdateAffiliatedSubscriptionPriceArgs = {
  affiliatedLegalEntityId: Scalars['String']['input'];
  affiliatedOrganizationId: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  ticketLink?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateAspectStatusArgs = {
  aspectId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  status: AspectStatusValue;
};


export type MutationUpdateConnectionFeatureFlagStatusArgs = {
  connectionId: Scalars['String']['input'];
  connectorId: Scalars['String']['input'];
  featureFlagId: Scalars['String']['input'];
  status: ConnectionFeatureFlagStatusValue;
};


export type MutationUpdateConnectionTemplateArgs = {
  connectorId: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
  institutionId: Scalars['String']['input'];
};


export type MutationUpdateEmailDeliveryPreferencesArgs = {
  emailAddress: Scalars['String']['input'];
  receiveEmails: Scalars['Boolean']['input'];
};


export type MutationUpdateEmployeeHiddenArgs = {
  employeeId: Scalars['String']['input'];
  isHidden: Scalars['Boolean']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationUpdateEmployeeRoleArgs = {
  defaultEntityRole: Scalars['String']['input'];
  employeeId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  role: Scalars['String']['input'];
};


export type MutationUpdateEmployeeStatusArgs = {
  employeeId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  status: EmployeeStatus;
};


export type MutationUpdateGlobalPartyArgs = {
  fields: NewParty;
  partyId: Scalars['String']['input'];
};


export type MutationUpdateInstitutionArgs = {
  institution_id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  routingNumber: Scalars['String']['input'];
  url: Scalars['String']['input'];
};


export type MutationUpdateInstitutionPartyArgs = {
  institutionId: Scalars['String']['input'];
  partyId: Scalars['String']['input'];
};


export type MutationUpdateInstitutionProductsArgs = {
  institutionId: Scalars['String']['input'];
  products: Array<InstitutionProduct>;
};


export type MutationUpdateLegalEntityStatusArgs = {
  id: Scalars['String']['input'];
  status: LegalEntityStatus;
};


export type MutationUpdateOperatorSubscriptionArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  ticketLink?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateOrganizationAspectStatusArgs = {
  aspectId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  status: AspectStatusValue;
};


export type MutationUpdateOrganizationPackageProductArgs = {
  billable: Scalars['Boolean']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  contextUrl?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  packageId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};


export type MutationUpdateOrganizationPackageProductModeArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  contextUrl?: InputMaybe<Scalars['String']['input']>;
  customProducts: Scalars['Boolean']['input'];
  organizationId: Scalars['String']['input'];
  packageId: Scalars['String']['input'];
};


export type MutationUpdateOrganizationTierArgs = {
  discountLevel: DiscountLevel;
  fromCouponId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  toCouponId: Scalars['String']['input'];
};


export type MutationUpdatePartyArgs = {
  details: NewParty;
  legalEntityId: Scalars['String']['input'];
  partyId: Scalars['String']['input'];
};


export type MutationUpdatePipelineDefinitionStatusArgs = {
  isActive: Scalars['Boolean']['input'];
  pipelineName: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateSignupStatusArgs = {
  id: Scalars['String']['input'];
  status: SignupStatus;
  statusReason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserArgs = {
  familyName: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationUploadAdyenDocumentArgs = {
  accountHolderId: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  description: Scalars['String']['input'];
  documentType: Scalars['String']['input'];
  fileContent: Scalars['String']['input'];
  fileName?: InputMaybe<Scalars['String']['input']>;
};

export type Namespace = {
  allowTokens?: InputMaybe<Array<Scalars['String']['input']>>;
  denyTokens?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
};

export type Neighbor = {
  distance: Scalars['Float']['output'];
  id: Scalars['String']['output'];
};

export type NewAiBookkeeperLegalEntity = {
  legalEntity: LegalEntity;
  quotePackage: QuotePackage;
  userInfo: UserInfo;
};

/** Connect */
export type NewAdminConnection = {
  Accounts: Array<NewAdminConnectionAccount>;
  Institution: ConnectInstitutionInput;
  connectorId: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};

export type NewAdminConnectionAccount = {
  accountId: Scalars['String']['input'];
  mask?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  subtype?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type NewAffiliatedBillingSubscription = {
  customerId: Scalars['String']['output'];
  productId: Scalars['String']['output'];
  stripeClientSecret: Scalars['String']['output'];
};

export type NewBillingSubscription = {
  customerId: Scalars['String']['output'];
  stripeClientSecret: Scalars['String']['output'];
};

/** NewComment represents an input comment. */
export type NewComment = {
  text: Scalars['String']['input'];
};

export type NewDocumentFeature = {
  kind: FeatureKind;
  value: NewDocumentFeatureValue;
};

export type NewDocumentFeatureValue = {
  textValue?: InputMaybe<Scalars['String']['input']>;
};

export type NewLayoutDocument = {
  initialText?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
  tags?: InputMaybe<Array<TextComponentConfigTagInput>>;
  title: Scalars['String']['input'];
};

export type NewObjectGrant = {
  object: InputObjectIdentifier;
  permission?: InputMaybe<Permission>;
  policy?: InputMaybe<GrantPolicy>;
};

export type NewParty = {
  designation?: InputMaybe<PartyDesignation>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  iconUrl: Scalars['String']['input'];
  instagramUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  shortDescription: Scalars['String']['input'];
  supportEmail?: InputMaybe<Scalars['String']['input']>;
  supportPhone?: InputMaybe<Scalars['String']['input']>;
  supportUrl?: InputMaybe<Scalars['String']['input']>;
  twitterUrl?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  yelpUrl?: InputMaybe<Scalars['String']['input']>;
};

export type NewReportAttachments = {
  existing: Array<ExistingReportAttachment>;
  insightObjectIds?: InputMaybe<Array<InputObjectIdentifier>>;
  layout: Array<NewLayoutDocument>;
  statementKinds: Array<ReportKind>;
  text: Array<NewTextDocument>;
};

export type NewReportUpload = {
  fileId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  interval: Interval;
  mimeType: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  reportFor: DateInput;
  title: Scalars['String']['input'];
};

export type NewTextDocument = {
  position: Scalars['Int']['input'];
  summary: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type NewTrialBillingSubscription = {
  customerId: Scalars['String']['output'];
  productId: Scalars['String']['output'];
};

export type NewUserGrant = {
  emailAddress: Scalars['String']['input'];
  permission: Permission;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationSetting = {
  displayKey: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  eventType: EventType;
  legalEntityId: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type NumericFeatureValue = {
  numericValue: Scalars['Long']['output'];
};

export type OAuthCredentialFields = {
  code: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  service: OAuthService;
};

export enum OAuthService {
  Google = 'Google',
  LinkedIn = 'LinkedIn',
  QuickBooks = 'QuickBooks',
  Unknown = 'Unknown'
}

export type ObjectAcl = {
  entities: ObjectEntities;
  grants: Array<UserGrant>;
  intents: Array<UserIntent>;
  link?: Maybe<Permission>;
  object: ObjectIdentifier;
  requests: Array<UserRequest>;
};

/**
 * ObjectEntities is a structure to thread through populated objects
 * indicated by ObjectIdentifiers to clients.
 */
export type ObjectEntities = {
  bills?: Maybe<Array<EntityBill>>;
  categories?: Maybe<Array<EntityCategory>>;
  comments?: Maybe<Array<EntityComment>>;
  datasources?: Maybe<Array<EntityDataSource>>;
  departments?: Maybe<Array<EntityDepartment>>;
  identityVerifications?: Maybe<Array<EntityIdentityVerification>>;
  invoices?: Maybe<Array<EntityInvoice>>;
  ledgerTransactions?: Maybe<Array<EntityLedgerTransaction>>;
  legalEntities?: Maybe<Array<EntityLegalEntity>>;
  locations?: Maybe<Array<EntityLocation>>;
  parties?: Maybe<Array<EntityParty>>;
  reconciliations?: Maybe<Array<EntityReconciliation>>;
  reportPackages?: Maybe<Array<EntityReportPackage>>;
  reports?: Maybe<Array<EntityReport>>;
  schedules?: Maybe<Array<EntitySchedule>>;
  threads?: Maybe<Array<EntityThread>>;
  transactions?: Maybe<Array<EntityTransaction>>;
  users?: Maybe<Array<EntityUser>>;
  workItems?: Maybe<Array<EntityWorkItem>>;
};

export type ObjectEntity = EntityBill | EntityCategory | EntityComment | EntityDataSource | EntityDepartment | EntityIdentityVerification | EntityInvoice | EntityLedgerTransaction | EntityLegalEntity | EntityLocation | EntityParty | EntityReconciliation | EntityReport | EntityReportPackage | EntitySchedule | EntityThread | EntityTransaction | EntityUser | EntityWorkItem;

export type ObjectGrant = {
  createdAt: Scalars['DateTime']['output'];
  grantId: Scalars['String']['output'];
  object: ObjectIdentifier;
  permission: Permission;
  viewType?: Maybe<ViewType>;
};

/**
 * ObjectIdentifier is a generic identifier with an enumerated kind.
 * It can be used to identify different Digits' core objects.
 */
export type ObjectIdentifier = {
  id: Scalars['String']['output'];
  kind: ObjectKind;
  legalEntityId: Scalars['String']['output'];
};

export type ObjectIntent = {
  creatorUserId: Scalars['String']['output'];
  intentId: Scalars['String']['output'];
  object: ObjectIdentifier;
  permission: Permission;
};

export enum ObjectKind {
  Bill = 'Bill',
  Category = 'Category',
  Comment = 'Comment',
  Connection = 'Connection',
  DataSource = 'DataSource',
  Department = 'Department',
  Invoice = 'Invoice',
  LedgerTransaction = 'LedgerTransaction',
  LegalEntity = 'LegalEntity',
  Location = 'Location',
  Party = 'Party',
  Portal = 'Portal',
  Reconciliation = 'Reconciliation',
  Report = 'Report',
  ReportPackage = 'ReportPackage',
  Schedule = 'Schedule',
  Thread = 'Thread',
  Transaction = 'Transaction',
  User = 'User',
  WorkItem = 'WorkItem'
}

export type ObjectKindFacet = {
  count: Scalars['Long']['output'];
  kind: ObjectKind;
};

export type ObjectMappingHierarchies = {
  departmentHierarchy: Array<ObjectMappingHierarchyNode>;
  lineClassHierarchy: Array<ObjectMappingHierarchyNode>;
};

export type ObjectMappingHierarchyNode = {
  active: Scalars['Boolean']['output'];
  depth: Scalars['Long']['output'];
  factId: Scalars['String']['output'];
  fullyQualifiedName: Scalars['String']['output'];
  mappedTo?: Maybe<ObjectKind>;
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  transactionCount: Scalars['Long']['output'];
};

export type ObjectPermission = {
  action: ShareAction;
  legalEntity: EntityLegalEntity;
  object: ObjectIdentifier;
  organizationPreview: OrganizationPreview;
  permission?: Maybe<Permission>;
  viewType: ViewType;
};

export type ObjectRequest = {
  object: ObjectIdentifier;
  requestId: Scalars['String']['output'];
};

export enum Operation {
  Contains = 'Contains',
  Excludes = 'Excludes',
  UnknownOperation = 'UnknownOperation'
}

export type Organization = {
  branding?: Maybe<OrganizationBranding>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  kind?: Maybe<OrganizationKind>;
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type OrganizationAffiliation = {
  legalEntity: EntityLegalEntity;
  organization: EntityOrganization;
};

export type OrganizationAssignee = {
  organizationId: Scalars['String']['input'];
};

export type OrganizationBillingPlan = {
  plan: BillingPlan;
  trial?: Maybe<BillingTrial>;
};

export type OrganizationBranding = {
  headerColor: Scalars['String']['output'];
  headerTextColor: Scalars['String']['output'];
  id: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
};

export type OrganizationEmployment = {
  employeeId: Scalars['String']['output'];
  legalEntityRoles?: Maybe<Array<EmployeeLegalEntityRole>>;
  organization: Organization;
  role: Role;
};

export enum OrganizationKind {
  AccountingFirm = 'AccountingFirm',
  Developer = 'Developer',
  Operator = 'Operator',
  SandboxAccountingFirm = 'SandboxAccountingFirm',
  SandboxOperator = 'SandboxOperator',
  UnknownKind = 'UnknownKind'
}

export type OrganizationPackageAspect = {
  aspect: Aspect;
};

export type OrganizationPreferences = {
  anonymizeEmployees: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
};

export type OrganizationPreview = {
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type OrganizationSubscriptionMigrationFlag = {
  detail: Scalars['String']['output'];
  kind: OrganizationSubscriptionMigrationFlagKind;
  severity: OrganizationSubscriptionMigrationFlagSeverity;
};

export enum OrganizationSubscriptionMigrationFlagKind {
  ContributorMismatch = 'ContributorMismatch',
  MissingSourcePriceItemWithOthers = 'MissingSourcePriceItemWithOthers',
  PriceIDMismatch = 'PriceIDMismatch',
  UnknownKind = 'UnknownKind'
}

export enum OrganizationSubscriptionMigrationFlagSeverity {
  Error = 'Error',
  UnknownSeverity = 'UnknownSeverity',
  Warn = 'Warn'
}

export type OrganizationSubscriptionMigrationInfo = {
  detail: Scalars['String']['output'];
  kind: OrganizationSubscriptionMigrationInfoKind;
};

export enum OrganizationSubscriptionMigrationInfoKind {
  MultipleOrganizationSubscriptions = 'MultipleOrganizationSubscriptions',
  NoSourceSubscriptionPriceID = 'NoSourceSubscriptionPriceID',
  NoStripeSubscription = 'NoStripeSubscription',
  SourceSubscriptionTargeted = 'SourceSubscriptionTargeted',
  StripeItemNotFoundForSourceSubscriptionPrice = 'StripeItemNotFoundForSourceSubscriptionPrice',
  UnknownKind = 'UnknownKind'
}

export type OrganizationSubscriptionMigrationPlannedWrite = {
  action: Scalars['String']['output'];
  detail: Scalars['String']['output'];
  table: Scalars['String']['output'];
};

export type OrganizationSubscriptionMigrationReport = {
  applied: Scalars['Boolean']['output'];
  dryRun: Scalars['Boolean']['output'];
  flags: Array<OrganizationSubscriptionMigrationFlag>;
  info: Array<OrganizationSubscriptionMigrationInfo>;
  legalEntityId: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  plannedWrites: Array<OrganizationSubscriptionMigrationPlannedWrite>;
  skips: Array<OrganizationSubscriptionMigrationSkip>;
  sourceSubscriptionPriceId?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionId: Scalars['String']['output'];
};

export type OrganizationSubscriptionMigrationSkip = {
  detail: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  table: Scalars['String']['output'];
};

export type OrganizationTemplate = {
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type OwnedDataSource = {
  dataSource: EnrichedDataSource;
  dataSourcePreference?: Maybe<DataSourcePreference>;
  ownedSourceAccounts?: Maybe<Array<OwnedSourceAccount>>;
};

export type OwnedSourceAccount = {
  owner?: Maybe<Employee>;
  sourceAccount: SourceAccount;
};

export type PackageCount = {
  interval: Interval;
  total: Scalars['Long']['output'];
};

export type PackageCounts = {
  counts: Array<PackageCount>;
  total: Scalars['Long']['output'];
};

export type PackagesFilter = {
  hideDrafts?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Interval>;
};

export type PackagesSort = {
  direction?: InputMaybe<SortDirection>;
  orderBy?: InputMaybe<PackagesSortOrderBy>;
};

export enum PackagesSortOrderBy {
  UpdatedAt = 'UpdatedAt'
}

export type PageView = {
  url: Scalars['String']['input'];
};

export type Pagination = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

/** Parties */
export type Party = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  designation: PartyDesignation;
  facebookUrl?: Maybe<Scalars['String']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  legalEntityId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  shortDescription?: Maybe<Scalars['String']['output']>;
  supportEmail?: Maybe<Scalars['String']['output']>;
  supportPhone?: Maybe<Scalars['String']['output']>;
  supportUrl?: Maybe<Scalars['String']['output']>;
  twitterUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  yelpUrl?: Maybe<Scalars['String']['output']>;
};

export type PartyAndRoleBalanceFilter = {
  legalEntityId: Scalars['String']['input'];
  partyId: Scalars['String']['input'];
  partyRole: PartyRole;
  viewVersion?: InputMaybe<Scalars['String']['input']>;
};

export type PartyChartConfig = {
  asPermanent?: Maybe<Scalars['Boolean']['output']>;
  origin: ArchiveIntervalOrigin;
  partyId: Scalars['String']['output'];
  partyRole?: Maybe<PartyRole>;
};

export type PartyChartConfigInput = {
  asPermanent?: InputMaybe<Scalars['Boolean']['input']>;
  origin: IntervalOrigin;
  partyId: Scalars['String']['input'];
  partyRole?: InputMaybe<PartyRole>;
};

export enum PartyDesignation {
  BusinessDesignation = 'BusinessDesignation',
  IgnoredDesignation = 'IgnoredDesignation',
  InvalidDesignation = 'InvalidDesignation',
  PeopleDesignation = 'PeopleDesignation',
  SMBMealsDesignation = 'SMBMealsDesignation',
  SMBOtherDesignation = 'SMBOtherDesignation',
  UnknownDesignation = 'UnknownDesignation'
}

export type PartyDimension = {
  by: DimensionSummary;
  partyId: Scalars['String']['output'];
  partyObject: EntityParty;
  summary: TransactionSummary;
};

export enum PartyEntityType {
  Corporation = 'Corporation',
  ForeignEntities = 'ForeignEntities',
  Individual = 'Individual',
  LimitedLiabilityCompany = 'LimitedLiabilityCompany',
  Other = 'Other',
  Partnerships = 'Partnerships',
  SoleProprietorship = 'SoleProprietorship',
  TrustsAndEstates = 'TrustsAndEstates',
  Undetermined = 'Undetermined',
  UnknownEntityType = 'UnknownEntityType'
}

export type PartyFacet = {
  count: Scalars['Int']['output'];
  partyObject: EntityParty;
};

export type PartyHistory = {
  entityTypeClassification: PartyHistoryEntry;
  partyId: Scalars['String']['output'];
  taxpayerIdentificationClassification: PartyHistoryEntry;
};

export type PartyHistoryEntry = {
  iconUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type PartyHover = {
  context?: Maybe<DimensionSummary>;
  entity: EntityParty;
  history: DimensionSummary;
  topTransactions?: Maybe<Array<EntityTransaction>>;
};

export type PartyIconMetadata = {
  iconUrl: Scalars['String']['output'];
};

export type PartyParams = {
  action: PushAction;
  partyID?: InputMaybe<Scalars['String']['input']>;
  partyIconUrl?: InputMaybe<Scalars['String']['input']>;
  partyName: Scalars['String']['input'];
};

export type PartyRef = {
  id: Scalars['String']['output'];
};

export enum PartyRole {
  EntityAssetRole = 'EntityAssetRole',
  EntityAssetSupplierRole = 'EntityAssetSupplierRole',
  EntityAssetVendorRole = 'EntityAssetVendorRole',
  EntityBanksRole = 'EntityBanksRole',
  EntityCreditCardsRole = 'EntityCreditCardsRole',
  EntityCustomerRole = 'EntityCustomerRole',
  EntityDebtorRole = 'EntityDebtorRole',
  EntityInvesteeRole = 'EntityInvesteeRole',
  EntityLenderRole = 'EntityLenderRole',
  EntityLiabilitiesRole = 'EntityLiabilitiesRole',
  EntityOtherExpensesRole = 'EntityOtherExpensesRole',
  EntityOtherIncomeRole = 'EntityOtherIncomeRole',
  EntityOtherLiabilitiesRole = 'EntityOtherLiabilitiesRole',
  EntityOwedVendorRole = 'EntityOwedVendorRole',
  EntityPrepaidVendorRole = 'EntityPrepaidVendorRole',
  EntityProcessorRole = 'EntityProcessorRole',
  EntityRevenuePartnerRole = 'EntityRevenuePartnerRole',
  EntityShareholderRole = 'EntityShareholderRole',
  EntitySupplierRole = 'EntitySupplierRole',
  EntityUnpaidCustomerRole = 'EntityUnpaidCustomerRole',
  EntityUnspecifiedRole = 'EntityUnspecifiedRole',
  EntityVendorRole = 'EntityVendorRole',
  FacilitatorRole = 'FacilitatorRole',
  InstitutionCreditRole = 'InstitutionCreditRole',
  InstitutionDebitRole = 'InstitutionDebitRole',
  OwnerRole = 'OwnerRole',
  PaymentProcessorRole = 'PaymentProcessorRole',
  UnknownRole = 'UnknownRole'
}

export type PartyRuleFilter = {
  createdAt: Scalars['DateTime']['output'];
  operation: Operation;
  parties: Array<PartyRuleFilterParty>;
  partyRuleFilterId: Scalars['String']['output'];
};

export type PartyRuleFilterParty = {
  partyId: Scalars['String']['output'];
  partyName: Scalars['String']['output'];
};

export enum PartyType {
  Global = 'Global',
  Implied = 'Implied',
  Imported = 'Imported',
  Synthesized = 'Synthesized',
  Unknown = 'Unknown',
  UserCreated = 'UserCreated',
  WireImplied = 'WireImplied'
}

export type PayCategoryIntegrations = {
  party?: Maybe<EntityParty>;
  products: Array<CategoryToLabelMappingProduct>;
};

export type PayInvoiceSummary = {
  invoicePaymentDetails: InvoicePaymentDetails;
  status: InvoiceStatus;
};

export type PaymentChainDetail = {
  createdAt: Scalars['Float']['output'];
  currencyMultiplier: Scalars['Long']['output'];
  digitsTransactionId: Scalars['String']['output'];
  externalPaymentId: Scalars['String']['output'];
  externalPaymentSource: Scalars['String']['output'];
  isoCurrencyCode: Scalars['String']['output'];
  ownerId: Scalars['String']['output'];
  ownerType: Scalars['String']['output'];
  paymentId: Scalars['String']['output'];
  paymentIntentId: Scalars['String']['output'];
  paymentType: Scalars['String']['output'];
  recipientId: Scalars['String']['output'];
  recipientName: Scalars['String']['output'];
  recipientType: Scalars['String']['output'];
  referenceId: Scalars['String']['output'];
  referenceType: Scalars['String']['output'];
  states: Array<PaymentStateDetail>;
  totalAmount: Scalars['Long']['output'];
};

export type PaymentInstrument = BankAccount | CreditCard;

export type PaymentIntentChainDetail = {
  createdAt: Scalars['Float']['output'];
  currencyMultiplier: Scalars['Long']['output'];
  externalPaymentSource: Scalars['String']['output'];
  isoCurrencyCode: Scalars['String']['output'];
  ownerId: Scalars['String']['output'];
  ownerType: Scalars['String']['output'];
  paymentIntentId: Scalars['String']['output'];
  paymentType: Scalars['String']['output'];
  recipientId: Scalars['String']['output'];
  recipientName: Scalars['String']['output'];
  recipientType: Scalars['String']['output'];
  referenceId: Scalars['String']['output'];
  referenceType: Scalars['String']['output'];
  states: Array<PaymentIntentStateDetail>;
  totalAmount: Scalars['Long']['output'];
};

export type PaymentIntentStateDetail = {
  createdAt: Scalars['Float']['output'];
  paymentIntentState: Scalars['String']['output'];
  paymentIntentStateId: Scalars['String']['output'];
};

export type PaymentJournalEntriesResult = {
  journalEntries: Array<PaymentJournalEntry>;
};

export type PaymentJournalEntry = {
  categoryEntries: Array<JournalCategoryEntry>;
  chartOfAccountsId: Scalars['String']['output'];
  commitTime: Scalars['Float']['output'];
  idempotenceKey: Scalars['String']['output'];
  journalEntryId: Scalars['String']['output'];
  ownerId: Scalars['String']['output'];
  ownerType: Scalars['String']['output'];
  tags: Array<JournalEntryTag>;
};

/** Payment Journal Entries */
export type PaymentLifecycleResult = {
  digitsLegalEntityId: Scalars['String']['output'];
  ownerType: Scalars['String']['output'];
  payerLegalEntityId: Scalars['String']['output'];
  paymentIntentId: Scalars['String']['output'];
  recipientType: Scalars['String']['output'];
  stages: Array<PaymentLifecycleStage>;
  vendorLegalEntityId: Scalars['String']['output'];
};

export type PaymentLifecycleStage = {
  entityId: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
  journalEntries: Array<PaymentJournalEntry>;
  stage: Scalars['String']['output'];
};

/** Payment Payout Chain */
export type PaymentPayoutChainResult = {
  paymentIntents: Array<PaymentIntentChainDetail>;
  payments: Array<PaymentChainDetail>;
  payoutIntents: Array<PayoutIntentChainDetail>;
  payouts: Array<PayoutChainDetail>;
};

/** Payment Settlement Config */
export type PaymentSettlementConfig = {
  additionalPaymentSettlementDays: Scalars['Int']['output'];
  legalEntityId: Scalars['String']['output'];
};

export type PaymentStateDetail = {
  createdAt: Scalars['Float']['output'];
  paymentState: Scalars['String']['output'];
  paymentStateId: Scalars['String']['output'];
};

export enum PaymentStatus {
  Blocked = 'Blocked',
  Canceled = 'Canceled',
  Created = 'Created',
  Deposited = 'Deposited',
  Held = 'Held',
  Mailed = 'Mailed',
  OnHold = 'OnHold',
  Paid = 'Paid',
  Pending = 'Pending',
  PendingApproval = 'PendingApproval',
  PendingIncreaseReview = 'PendingIncreaseReview',
  PendingMailing = 'PendingMailing',
  PendingSubmission = 'PendingSubmission',
  ProcessingReturn = 'ProcessingReturn',
  ProcessingSettlement = 'ProcessingSettlement',
  Refunded = 'Refunded',
  Rejected = 'Rejected',
  RequiresAttention = 'RequiresAttention',
  Returned = 'Returned',
  Settled = 'Settled',
  Stopped = 'Stopped',
  Submitted = 'Submitted',
  Unknown = 'Unknown'
}

export type PaymentsLedgerCategory = {
  accountingType: Scalars['String']['output'];
  canonicalCategoryLabel: Scalars['String']['output'];
  categoryId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nonNegativeBalanceInvariant: Scalars['Boolean']['output'];
  sumCredit: MonetaryValue;
  sumDebit: MonetaryValue;
  version: Scalars['Long']['output'];
};

export type PaymentsLedgerCoA = {
  categories: Array<PaymentsLedgerCategory>;
  chartOfAccountsId: Scalars['String']['output'];
  ownerId: Scalars['String']['output'];
  ownerType: Scalars['String']['output'];
};

export type PayoutChainDetail = {
  createdAt: Scalars['Float']['output'];
  currencyMultiplier: Scalars['Long']['output'];
  digitsTransactionId: Scalars['String']['output'];
  externalPayoutId: Scalars['String']['output'];
  externalSource: Scalars['String']['output'];
  isoCurrencyCode: Scalars['String']['output'];
  linkedPaymentIds: Array<Scalars['String']['output']>;
  ownerId: Scalars['String']['output'];
  ownerType: Scalars['String']['output'];
  payoutId: Scalars['String']['output'];
  payoutIntentId: Scalars['String']['output'];
  payoutType: Scalars['String']['output'];
  statuses: Array<PayoutStatusDetail>;
  totalAmount: Scalars['Long']['output'];
};

export type PayoutIntentChainDetail = {
  createdAt: Scalars['Float']['output'];
  currencyMultiplier: Scalars['Long']['output'];
  directPaymentId: Scalars['String']['output'];
  isoCurrencyCode: Scalars['String']['output'];
  ownerId: Scalars['String']['output'];
  ownerType: Scalars['String']['output'];
  payoutIntentId: Scalars['String']['output'];
  payoutType: Scalars['String']['output'];
  states: Array<PayoutIntentStateDetail>;
  totalAmount: Scalars['Long']['output'];
};

export type PayoutIntentStateDetail = {
  createdAt: Scalars['Float']['output'];
  payoutIntentState: Scalars['String']['output'];
  payoutIntentStateId: Scalars['String']['output'];
};

export type PayoutStatusDetail = {
  createdAt: Scalars['Float']['output'];
  payoutStatus: Scalars['String']['output'];
};

export type PayrollProvider = {
  legalEntityId: Scalars['String']['output'];
  partyId: Scalars['String']['output'];
  partyName: Scalars['String']['output'];
  payrollProviderType: PayrollProviderType;
  rangeEndedAt?: Maybe<Scalars['DateTime']['output']>;
  rangeStartedAt: Scalars['DateTime']['output'];
};

export enum PayrollProviderType {
  Primary = 'Primary',
  UnknownPayrollProvider = 'UnknownPayrollProvider'
}

export type Period = {
  endedAt: Scalars['DateTime']['output'];
  interval: Interval;
  name: Scalars['String']['output'];
  startedAt: Scalars['DateTime']['output'];
};

export type PeriodInput = {
  endedAt: Scalars['DateTime']['input'];
  interval: Interval;
  name: Scalars['String']['input'];
  startedAt: Scalars['DateTime']['input'];
};

/** Insights */
export type PeriodInsights = {
  entities?: Maybe<ObjectEntities>;
  insights: Array<Insight>;
  period: Period;
};

/** Periods */
export type PeriodMonetaryValue = {
  current?: Maybe<SummaryTotal>;
  deltaPrevious?: Maybe<Scalars['Float']['output']>;
  /** @deprecated unpopulated */
  deltaYearAgo?: Maybe<Scalars['Float']['output']>;
  /** @deprecated unpopulated */
  isFirstOccurrencePeriod?: Maybe<Scalars['Boolean']['output']>;
  moneyFlow?: Maybe<MoneyFlow>;
  prior?: Maybe<SummaryTotal>;
  transactionsCount: Scalars['Long']['output'];
  value: MonetaryValue;
};

export type PeriodReport = {
  author?: Maybe<Contact>;
  createdAt: Scalars['DateTime']['output'];
  generationHistory?: Maybe<ReportGenerationHistory>;
  id: Scalars['String']['output'];
  interval: Interval;
  reportFile: ReportFileMetadata;
  reportFor?: Maybe<Date>;
  status: ReportPackageDocumentStatus;
  threadDetails?: Maybe<Array<ThreadDetails>>;
  title: Scalars['String']['output'];
};

export enum Permission {
  CommentRead = 'CommentRead',
  CommentShare = 'CommentShare',
  FullAccess = 'FullAccess',
  None = 'None',
  ReadOnly = 'ReadOnly',
  SensitiveFullAccess = 'SensitiveFullAccess'
}

export enum Persona {
  AccountingLarge = 'AccountingLarge',
  AccountingMedium = 'AccountingMedium',
  AccountingSmall = 'AccountingSmall',
  Business = 'Business',
  BusinessAndSubsidiaries = 'BusinessAndSubsidiaries',
  InvestmentMedium = 'InvestmentMedium',
  InvestmentSmall = 'InvestmentSmall',
  MailingList = 'MailingList',
  UnknownPersona = 'UnknownPersona'
}

/** Pipeline Definitions */
export type PipelineDefinition = {
  isActive: Scalars['Boolean']['output'];
  pipelineName: Scalars['String']['output'];
  updatedAt: Scalars['Float']['output'];
};

export type PlaidAccount = {
  id: Scalars['String']['input'];
  mask?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  subtype?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type PlaidConfig = {
  createdAt: Scalars['DateTime']['output'];
  externalInstitutionId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PlaidConnectionAuth = {
  connectionId: Scalars['String']['output'];
  response: Scalars['String']['output'];
};

export type PlaidConnectorProperties = {
  /**
   * For the initial implementation, we wont have anything special here
   * however in the future we may use this to add things like filters
   * for specific account types, icons for different banks, etc
   */
  empty?: Maybe<Scalars['Boolean']['output']>;
};

export type PlaidLinkToken = {
  token: Scalars['String']['output'];
};

export type Portal = {
  backgroundUrl?: Maybe<Scalars['String']['output']>;
  layoutId: Scalars['String']['output'];
  legalEntityId: Scalars['String']['output'];
  portalId: Scalars['String']['output'];
};

export type PortalLayout = {
  hasPortal: Scalars['Boolean']['output'];
  layout?: Maybe<Layout>;
  portalId?: Maybe<Scalars['String']['output']>;
};

export type PortalMetricConfig = {
  metricType: MetricType;
  origin: ArchiveIntervalOrigin;
};

export type PortalMetricConfigInput = {
  metricType: MetricType;
  origin: IntervalOrigin;
};

export type PotentialDuplicateFlagDetails = {
  potentialDuplicateTransaction: Transaction;
  potentialDuplicateTransactionFactId: Scalars['String']['output'];
  statementLineItem: StatementLineItem;
  transaction: Transaction;
  transactionFactId: Scalars['String']['output'];
};

export type PotentialMismatchFlagDetails = {
  statementLineItem: StatementLineItem;
  transaction: Transaction;
  transactionFactId: Scalars['String']['output'];
};

export type PredictedDataSource = {
  institution: Party;
  providerType: ProviderType;
  type: PredictedDataSourceType;
};

export enum PredictedDataSourceType {
  BankAccount = 'BankAccount',
  BankAccountAndCreditCard = 'BankAccountAndCreditCard',
  CreditCard = 'CreditCard',
  UnknownType = 'UnknownType'
}

export type PrefixFilter = {
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type PrefixMapping = {
  partyId: Scalars['String']['output'];
  prefix: Scalars['String']['output'];
};

export type PrefixMappingSummary = {
  party: Party;
  prefix: Scalars['String']['output'];
  transactionCount: Scalars['Long']['output'];
};

export type PricePreview = {
  coupons?: Maybe<Array<Coupon>>;
  total: MonetaryValue;
};

export type Product = {
  active?: Maybe<Scalars['Boolean']['output']>;
  assetCategoryId?: Maybe<Scalars['String']['output']>;
  buy?: Maybe<ProductBuyDetails>;
  chartOfAccountsId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customIconObjectName?: Maybe<Scalars['String']['output']>;
  dataSourceId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  iconDisplayKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productGroupId?: Maybe<Scalars['String']['output']>;
  sell?: Maybe<ProductSellDetails>;
  sku?: Maybe<Scalars['String']['output']>;
  taxable?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum ProductArea {
  All = 'All',
  Cash = 'Cash',
  Expenses = 'Expenses',
  None = 'None',
  Revenue = 'Revenue'
}

export type ProductBuyDetails = {
  departmentId?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  expenseCategoryId?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['String']['output']>;
  unitPrice?: Maybe<MonetaryValue>;
};

export type ProductBuyDetailsInput = {
  departmentId?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  expenseCategoryId?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  unitPrice?: InputMaybe<InputMonetaryValue>;
};

export type ProductGroup = {
  createdAt: Scalars['DateTime']['output'];
  customIconObjectName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  iconDisplayKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductGroupInput = {
  customIconObjectName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  iconDisplayKey?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type ProductInput = {
  active: Scalars['Boolean']['input'];
  assetCategoryId?: InputMaybe<Scalars['String']['input']>;
  buy?: InputMaybe<ProductBuyDetailsInput>;
  chartOfAccountsId?: InputMaybe<Scalars['String']['input']>;
  customIconObjectName?: InputMaybe<Scalars['String']['input']>;
  dataSourceId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  iconDisplayKey?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  productGroupId?: InputMaybe<Scalars['String']['input']>;
  sell?: InputMaybe<ProductSellDetailsInput>;
  sku?: InputMaybe<Scalars['String']['input']>;
  taxable: Scalars['Boolean']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ProductInstitution = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  party?: Maybe<Party>;
  products?: Maybe<Array<InstitutionProduct>>;
  routingNumber?: Maybe<Scalars['String']['output']>;
};

export enum ProductListing {
  Partner = 'Partner',
  Public = 'Public',
  UnknownListing = 'UnknownListing',
  Unlisted = 'Unlisted'
}

export enum ProductRecurrence {
  Monthly = 'Monthly',
  OneTime = 'OneTime',
  UnknownRecurrence = 'UnknownRecurrence',
  Yearly = 'Yearly'
}

export type ProductSellDetails = {
  departmentId?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  incomeCategoryId?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['String']['output']>;
  taxCategoryId?: Maybe<Scalars['String']['output']>;
  unitPrice?: Maybe<MonetaryValue>;
};

export type ProductSellDetailsInput = {
  departmentId?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  incomeCategoryId?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  taxCategoryId?: InputMaybe<Scalars['String']['input']>;
  unitPrice?: InputMaybe<InputMonetaryValue>;
};

export enum ProposalType {
  AffiliateInviteManagedOperator = 'AffiliateInviteManagedOperator',
  AffiliationAssistClient = 'AffiliationAssistClient',
  AffiliationCreateClient = 'AffiliationCreateClient',
  AffiliationJoinClient = 'AffiliationJoinClient',
  CreateOrganization = 'CreateOrganization',
  EmploymentAssistOperator = 'EmploymentAssistOperator',
  EmploymentJoinOrg = 'EmploymentJoinOrg',
  EnterprisePackageInvite = 'EnterprisePackageInvite',
  OperatorAssistAffiliate = 'OperatorAssistAffiliate',
  UnknownProposalType = 'UnknownProposalType'
}

export type ProposedGlobalParty = {
  designation: PartyDesignation;
  iconUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  shortDescription: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type Provider = {
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export enum ProviderType {
  CSVImport = 'CSVImport',
  Connect = 'Connect',
  DigitsInvoicing = 'DigitsInvoicing',
  DigitsLedgerInvoicing = 'DigitsLedgerInvoicing',
  DigitsLedgerPay = 'DigitsLedgerPay',
  DigitsPay = 'DigitsPay',
  DigitsPaymentsLedger = 'DigitsPaymentsLedger',
  DigitsSchedule = 'DigitsSchedule',
  Manual = 'Manual',
  Plaid = 'Plaid',
  QuickBooks = 'QuickBooks',
  UnknownProvider = 'UnknownProvider',
  Xero = 'Xero'
}

export type PublicInvoice = {
  branding: InvoiceBranding;
  customer?: Maybe<Customer>;
  discounts?: Maybe<Array<InvoiceDiscount>>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  files?: Maybe<Array<InvoiceFile>>;
  id: Scalars['String']['output'];
  invoiceDate?: Maybe<Scalars['DateTime']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  invoicingProfile?: Maybe<InvoicingProfile>;
  legalEntityId: Scalars['String']['output'];
  lineItems: Array<InvoiceLineItem>;
  memo?: Maybe<Scalars['String']['output']>;
  receivableInvoiceId: Scalars['String']['output'];
  referenceNumber?: Maybe<Scalars['String']['output']>;
  status: InvoiceStatus;
  subtotal?: Maybe<MonetaryValue>;
  taxPercent?: Maybe<Scalars['Float']['output']>;
  totalAmount?: Maybe<MonetaryValue>;
  totalTax?: Maybe<MonetaryValue>;
};

export type PullRequest = {
  author: PullRequestAuthor;
  branch: Scalars['String']['output'];
  labels?: Maybe<Array<PullRequestLabel>>;
  number: Scalars['Int']['output'];
  prState: PullRequestState;
  repo: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PullRequestAuthor = {
  avatarUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  login: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PullRequestFile = {
  contents: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum PullRequestFilterState {
  All = 'All',
  Closed = 'Closed',
  Open = 'Open'
}

export type PullRequestLabel = {
  hexColor: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum PullRequestState {
  Closed = 'Closed',
  Open = 'Open'
}

export type PullRequestSummary = {
  mergeableStatus: MergeableStatus;
  merged: Scalars['Boolean']['output'];
  pullRequest: PullRequest;
  reviewStatus: ReviewStatus;
};

export enum PushAction {
  Reassign = 'Reassign',
  Rename = 'Rename',
  UnknownPushAction = 'UnknownPushAction'
}

export type QualityCheck = {
  description: Scalars['String']['output'];
  /**
   * Effective on/off state for the caller's legal entity: the LE's override
   * if present, otherwise the per-check global default.
   */
  enabled: Scalars['Boolean']['output'];
  flaggedObjectKinds: Array<ObjectKind>;
  id: Scalars['String']['output'];
  /** Created timestamp of the latest trigger for this check in the caller's legal entity. */
  lastRunAt?: Maybe<Scalars['DateTime']['output']>;
  legalEntityId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  objectKind: ObjectKind;
  organizationId?: Maybe<Scalars['String']['output']>;
  owner: QualityCheckOwner;
  /** Latest trigger status for this check in the caller's legal entity. */
  status: QualityCheckStatus;
};

/**
 * Result of readQualityCheckDryRun. Flagged results are returned as the same
 * ActionItems the dashboard renders elsewhere, with each flagged object hydrated
 * inline on its item — so no separate entities bag is needed.
 */
export type QualityCheckDryRun = {
  flaggedCount: Scalars['Long']['output'];
  results: Array<ActionItem>;
  status: QualityCheckDryRunStatus;
  timeRangeEndedAt?: Maybe<Scalars['DateTime']['output']>;
  timeRangeStartedAt?: Maybe<Scalars['DateTime']['output']>;
  triggerId: Scalars['String']['output'];
};

/**
 * Dry-run lifecycle status. A non-terminal value (incl. UnknownStatus) means the
 * run is still in flight and the caller should keep polling readQualityCheckDryRun.
 */
export enum QualityCheckDryRunStatus {
  Failed = 'Failed',
  InProgress = 'InProgress',
  Pending = 'Pending',
  Succeeded = 'Succeeded',
  UnknownStatus = 'UnknownStatus'
}

export type QualityCheckGroup = {
  checks: Array<QualityCheck>;
  name: ActionItemGroup;
};

/**
 * A confirmed customization. Each confirmed save is a new immutable version;
 * drafts (awaiting confirmation) are never surfaced and don't shift version
 * numbers.
 *
 * `userInstruction` and `summary` carry inline entity markup in the
 * `<Kind|UUIDv4|Title>` format used by Comment.text, parsed by the shared
 * objectentities parser. The response-level `entities` bag hydrates `*Tags`.
 */
export type QualityCheckInstruction = {
  authorId: Scalars['String']['output'];
  checkId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  /**
   * True only for draft-authoring responses. Read paths return confirmed
   * instructions with isDraft = false.
   */
  isDraft: Scalars['Boolean']['output'];
  summary: Scalars['String']['output'];
  summaryTags: Array<ObjectIdentifier>;
  updatedAt: Scalars['DateTime']['output'];
  userInstruction: Scalars['String']['output'];
  userInstructionTags: Array<ObjectIdentifier>;
  /**
   * Confirmed instruction edit timestamp. Draft-authoring responses use 0
   * because drafts are not effective versions.
   */
  versionNumber: Scalars['Long']['output'];
};

export enum QualityCheckOwner {
  Digits = 'Digits',
  Firm = 'Firm',
  LegalEntity = 'LegalEntity',
  UnknownOwner = 'UnknownOwner'
}

export enum QualityCheckStatus {
  Failed = 'Failed',
  InProgress = 'InProgress',
  Pending = 'Pending',
  Succeeded = 'Succeeded',
  UnknownStatus = 'UnknownStatus'
}

/** Response wrapper carries hydrated entities, mirroring CommentWithEntities. */
export type QualityCheckWithEntities = {
  check: QualityCheck;
  entities?: Maybe<ObjectEntities>;
  /**
   * The latest confirmed instruction for this check. Null until the LE has
   * authored any confirmed instruction.
   */
  instruction?: Maybe<QualityCheckInstruction>;
};

export type QuantityValue = {
  quantity: Scalars['Long']['output'];
  quantityMultiplier: Scalars['Long']['output'];
};

export type Query = {
  billFetchBill?: Maybe<RawResponse>;
  /** BILL */
  billFetchV2Invoice?: Maybe<RawResponse>;
  billFetchV3Invoice?: Maybe<RawResponse>;
  billListBills?: Maybe<RawResponse>;
  documentSegments: Array<Format>;
  executeFbqQuery: FbqQueryResult;
  /** PLAID */
  fetchPlaidConnectionAuth: PlaidConnectionAuth;
  findMatchConfiguration: Array<AdminMatchConfiguration>;
  generateConnectToken: ConnectToken;
  getEmbedding: EmbeddingResponse;
  /** Fraud Check */
  getFraudCheckResult: FraudCheckResult;
  getInstitution: AdminInstitution;
  getNeighbors: MatchResponse;
  getPaymentLifecycleJournalEntries: PaymentLifecycleResult;
  /** Payment Payout Chain */
  getPaymentPayoutChain: PaymentPayoutChainResult;
  /** Payment Settlement Config */
  getPaymentSettlementConfig: PaymentSettlementConfig;
  getTextEmbedding: EmbeddingResponse;
  getWorkflow: WorkflowDetail;
  getWorkflowHistory: Array<WorkflowLogEntry>;
  getWorkflowInput: WorkflowPayload;
  getWorkflowOutput: WorkflowPayload;
  getWorkflowStepResult: WorkflowPayload;
  gustoFetchContractorPayments?: Maybe<RawResponse>;
  /** GUSTO */
  gustoFetchPayroll: Scalars['String']['output'];
  gustoFetchPayrolls?: Maybe<RawResponse>;
  gustoFetchReport?: Maybe<RawResponse>;
  gustoListContractors?: Maybe<RawResponse>;
  highlightWorkItem: HighlightedTokens;
  invoiceMigrationReport: InvoiceMigrationReport;
  legalEntityValidationProgress?: Maybe<LegalEntityValidationProgress>;
  listAdminBooksClosedFacts: Array<BooksClosedFact>;
  /** Data Sources */
  listAdminOwnedDataSources: Array<OwnedDataSource>;
  listAdminScheduleCategoryHintCatalog: Array<AdminScheduleCategoryHint>;
  listAdminScheduleCategoryHints: Array<AdminScheduleCategoryHintBinding>;
  listAdminScheduleSpecializations: Array<AdminScheduleSpecialization>;
  /** Schedule Templates */
  listAdminScheduleTemplates: Array<AdminScheduleTemplateSummary>;
  listAdyenVerificationStatuses: Array<AdyenLegalEntityStatus>;
  listAffiliatedOrganizations: Array<AdminOrganization>;
  listAgentParties: Array<Party>;
  listAllDataProcessingStatuses: DenormalizedViewStatusSummary;
  listAllWorkflows: Array<Workflow>;
  listAspectRequests: Array<AspectRequest>;
  /** List aspect statuses for a legal entity. */
  listAspectStatuses: Array<LegalEntityAspectStatus>;
  /** List aspects from the catalog. */
  listAspects: Array<Aspect>;
  listAssociatedTransactionFacts: Array<AdminTransactionFact>;
  listAvailablePlans: Array<SubscriptionPlan>;
  listBillingSubscriptionHistory: Array<BillingSubscriptionHistory>;
  listChartOfAccountsTemplates: Array<ChartOfAccountsTemplateSummary>;
  /** Charts of Accounts */
  listChartsOfAccounts: Array<ChartOfAccountsListEntry>;
  /** Classification Manifests */
  listClassificationManifests: Array<ClassificationManifestSummary>;
  /** Prefixes */
  listClusteredPrefixes: Array<ClusteredPrefix>;
  listConnectionEvents: Array<AdminConnectionEvent>;
  /** Feature Flags */
  listConnectionFeatureFlags: Array<ConnectionFeatureFlag>;
  listConnectionTemplates: Array<AdminConnectionTemplate>;
  /** Connect */
  listConnections: AdminConnectionList;
  listConnectorInstalls: Array<AdminConnectorInstall>;
  listConnectors: Array<AdminConnector>;
  listCsvImportTransactionFacts: Array<Scalars['String']['output']>;
  /** CSV Import */
  listCsvImports: Array<CsvImport>;
  listDataSourceJobErrors?: Maybe<Array<JobError>>;
  listDepartmentFactHierarchy: Array<ObjectMappingHierarchyNode>;
  /** Doppelganger */
  listDoppelgangerPermits: Array<Maybe<AdminDoppelgangerPermit>>;
  /** Employees */
  listEmployees: Array<AdminEmployee>;
  listFailingClassificationValidations: Array<ClassificationValidationFailure>;
  /** Parties */
  listGlobalParties: Array<AdminGlobalParty>;
  listGlobalPartiesWithSummaries: Array<AdminGlobalParty>;
  listIgnoredPrefixes: Array<Scalars['String']['output']>;
  /** Institutions */
  listInstitutions: Array<AdminInstitution>;
  /** Invites */
  listInvitations: Array<AdminInvitation>;
  listInvitationsByOrganization: Array<AdminInvitation>;
  /** Invoice Migrations */
  listInvoiceMigrationReports: Array<InvoiceMigrationReportSummary>;
  /** Layouts */
  listLayoutVersions: AdminLayoutVersions;
  listLedgerTransactionFacts: Array<AdminTransactionFact>;
  /** Legal Entities */
  listLegalEntities: Array<AdminLegalEntity>;
  listLegalEntityTransfers: LegalEntityTransfersResult;
  /** Object Mapping */
  listLineClassFactHierarchy: Array<ObjectMappingHierarchyNode>;
  listMatchSetTransactionFacts: AdminTransactionFactsWithMatchInfo;
  /** Migrations */
  listMigrationPullRequests: Array<PullRequest>;
  listMismatchedQuickbooksBalanceSheetCategories: Array<MismatchedQuickbooksBalanceSheetCategory>;
  /** Validation */
  listMismatchedQuickbooksCategories: Array<MismatchedQuickbooksCategory>;
  listOrganizationAspectStatuses: Array<AspectStatus>;
  /** List aspects currently enabled by an organization's package. */
  listOrganizationPackageAspects: Array<OrganizationPackageAspect>;
  listOrganizationProducts: Array<AdminBillingProduct>;
  listOrganizationTiers: Array<AdminOrganization>;
  listOrganizations: Array<AdminOrganization>;
  listParties: Array<AdminParty>;
  listPartnerCoupons: Array<AdminCoupon>;
  listPartyExtractions: Array<AdminPartyExtraction>;
  /** Payment Journal Entries */
  listPaymentJournalEntries: PaymentJournalEntriesResult;
  listPaymentJournalEntriesByCoAAndTagValue: PaymentJournalEntriesResult;
  listPaymentsLedgerCategoryEntries: Array<PaymentJournalEntry>;
  listPayrollParties: Array<PayrollProvider>;
  /** Pipeline Definitions */
  listPipelineDefinitions: Array<PipelineDefinition>;
  listPrefixMappings: Array<PrefixMappingSummary>;
  /** Returns all Base products, optionally filtered by target (Firm, Operator, LegacyFirm). */
  listProducts: Array<BillingProduct>;
  /** Reconciliations */
  listReconciliationAccounts: Array<EntityCategory>;
  /** Report Packages */
  listReportPackages: Array<AdminReportPackageMetadata>;
  /** Restricted Capabilities */
  listRestrictedCapabilities: RestrictedCapabilitiesResult;
  listSanitizedDescriptions: Array<SanitizedDescription>;
  /** Signups */
  listSignups: Array<AdminSignup>;
  /** Superusers */
  listSuperusers: Array<Superuser>;
  listTransactionFactCategoryClassifications: Array<AdminCategoryClassification>;
  listTransactionFactLedgerPartyClassifications: Array<AdminPartyClassification>;
  listTransactionFactPartyClassifications: Array<AdminPartyClassification>;
  listUnsupportedTransactions: UnsupportedTransactions;
  /** Users */
  listUsers: Array<AdminUser>;
  /** Workflows */
  listWorkflows: Array<Workflow>;
  plaidFetchInstitution?: Maybe<RawResponse>;
  plaidListStatements?: Maybe<RawResponse>;
  /** View Data Explorer */
  readActiveViewVersion: ViewIdentifier;
  readAdminScheduleSpecializationDetail: AdminScheduleSpecializationDetail;
  readAdminScheduleTemplate: AdminScheduleTemplate;
  readAdyenAccountHolderStatus?: Maybe<AdyenAccountHolderStatus>;
  readAssociatedThreads: ThreadListWithEntities;
  readBilling: Billing;
  readBusinessVerificationStatus: BusinessVerificationStatusResult;
  readChartOfAccounts: AdminChartOfAccounts;
  readChartOfAccountsTemplate: ChartOfAccountsTemplate;
  readComponentData: ArchivedComponent;
  readComponentDataJson: Scalars['String']['output'];
  readConnectRecording: HttpResponseArchive;
  readConnection: AdminConnection;
  readConnector?: Maybe<AdminConnector>;
  readConnectorCredentials: Array<AdminAppCredential>;
  readDataHealth: DataHealthStatus;
  readDetailedAdyenStatus?: Maybe<DetailedAdyenStatus>;
  /** Notifications */
  readEmailHTML?: Maybe<Scalars['String']['output']>;
  /** Data Processing */
  readEntityDataProcessingStatuses: DenormalizedViewStatusSummary;
  readEntityExtractions: Array<AdminTransactionEntityExtraction>;
  /** Vanity */
  readGlobalVanityStats: AdminGlobalVanityStats;
  readInvitation: AdminInvitation;
  readInvitationByOrganization: AdminInvitation;
  readInvitationBySignup: AdminInvitation;
  readLayoutVersion: AdminLayout;
  readLedgerTransactionIds: Array<AdminTransactionPair>;
  readLegalEntity: AdminLegalEntity;
  readLegalEntityPreferences: LegalEntityPreferences;
  readMappedChartOfAccounts: MappedChartOfAccounts;
  readMigrationPullRequest: MigrationPullRequest;
  /** Organizations */
  readOrganization: AdminOrganization;
  /** Billing */
  readOrganizationBillingPlan: BillingPlan;
  readOrganizationPackage: AdminOrganizationPackage;
  readOrganizationTier?: Maybe<AdminCoupon>;
  /** Payments Ledger Chart of Accounts */
  readPaymentsLedgerCoA: PaymentsLedgerCoA;
  readPlaidConnection: RawResponse;
  readPlaidItem: RawResponse;
  readReconciliationDiffs: Array<ReconciliationDiff>;
  /** Report Package Validation */
  readReportValidationArchive?: Maybe<ReportValidationArchive>;
  readSignup: AdminSignup;
  readSourceRecordedMatchSummary: SourceRecordedMatchSummary;
  /** Threads */
  readThread: ThreadWithEntities;
  /** Transactions */
  readTransactionFact: AdminTransactionFact;
  readTransactionFactCheckMetadata?: Maybe<AdminTransactionFactCheckMetadata>;
  readUser: AdminUser;
  readValidationHistory?: Maybe<ValidationHistory>;
  readVanityStats: AdminVanityStats;
  /** Work Items */
  readWorkItem: AdminWorkItem;
  readWorkItemValidation: WorkItemValidation;
  reprocessDocument?: Maybe<Scalars['Void']['output']>;
  /** UUID Search */
  searchByUUID: Array<UuidSearchResult>;
  /** Documents */
  segmentURL: Scalars['String']['output'];
  summarizeClassificationValidations: ClassificationValidationSummary;
  summarizeDataSourceFetches: DataSourceFetchStats;
  summarizeViewGeneration: ViewGenerationSummary;
};


export type QueryBillFetchBillArgs = {
  billId: Scalars['String']['input'];
  connectionId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type QueryBillFetchV2InvoiceArgs = {
  connectionId: Scalars['String']['input'];
  invoiceId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type QueryBillFetchV3InvoiceArgs = {
  connectionId: Scalars['String']['input'];
  invoiceId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type QueryBillListBillsArgs = {
  connectionId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  nextPage?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDocumentSegmentsArgs = {
  documentId: Scalars['String']['input'];
};


export type QueryExecuteFbqQueryArgs = {
  expression: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type QueryFetchPlaidConnectionAuthArgs = {
  id: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type QueryFindMatchConfigurationArgs = {
  ledgerTransactionId: Scalars['String']['input'];
};


export type QueryGenerateConnectTokenArgs = {
  id: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type QueryGetEmbeddingArgs = {
  partyPrefix?: InputMaybe<Scalars['String']['input']>;
  transactionFactId: Scalars['String']['input'];
};


export type QueryGetFraudCheckResultArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryGetInstitutionArgs = {
  institutionId: Scalars['String']['input'];
};


export type QueryGetNeighborsArgs = {
  approxNumNeighbors?: InputMaybe<Scalars['Int']['input']>;
  deployedIndexId: Scalars['String']['input'];
  floatVal: Array<Scalars['Float']['input']>;
  leafNodesToSearchPercentOverride?: InputMaybe<Scalars['Int']['input']>;
  numNeighbors?: InputMaybe<Scalars['Int']['input']>;
  perCrowdingAttributeNumNeighbors?: InputMaybe<Scalars['Int']['input']>;
  restricts?: InputMaybe<Array<Namespace>>;
};


export type QueryGetPaymentLifecycleJournalEntriesArgs = {
  paymentId?: InputMaybe<Scalars['String']['input']>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  payoutId?: InputMaybe<Scalars['String']['input']>;
  payoutIntentId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPaymentPayoutChainArgs = {
  paymentId?: InputMaybe<Scalars['String']['input']>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  payoutId?: InputMaybe<Scalars['String']['input']>;
  payoutIntentId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPaymentSettlementConfigArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryGetTextEmbeddingArgs = {
  text: Scalars['String']['input'];
};


export type QueryGetWorkflowArgs = {
  legalEntityID: Scalars['String']['input'];
  workflowID: Scalars['String']['input'];
};


export type QueryGetWorkflowHistoryArgs = {
  legalEntityID: Scalars['String']['input'];
  workflowID: Scalars['String']['input'];
};


export type QueryGetWorkflowInputArgs = {
  legalEntityID: Scalars['String']['input'];
  workflowID: Scalars['String']['input'];
};


export type QueryGetWorkflowOutputArgs = {
  legalEntityID: Scalars['String']['input'];
  workflowID: Scalars['String']['input'];
};


export type QueryGetWorkflowStepResultArgs = {
  legalEntityID: Scalars['String']['input'];
  workflowID: Scalars['String']['input'];
  workflowLogID: Scalars['String']['input'];
};


export type QueryGustoFetchContractorPaymentsArgs = {
  connectionId: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryGustoFetchPayrollArgs = {
  connectionId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  payrollId: Scalars['String']['input'];
};


export type QueryGustoFetchPayrollsArgs = {
  connectionId: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryGustoFetchReportArgs = {
  connectionId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  payrollId: Scalars['String']['input'];
};


export type QueryGustoListContractorsArgs = {
  connectionId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type QueryHighlightWorkItemArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  similarityType: SimilarityType;
};


export type QueryInvoiceMigrationReportArgs = {
  legalEntityId: Scalars['String']['input'];
  timestamp: Scalars['String']['input'];
  type: InvoiceMigrationReportType;
};


export type QueryLegalEntityValidationProgressArgs = {
  id: Scalars['String']['input'];
};


export type QueryListAdminBooksClosedFactsArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryListAdminOwnedDataSourcesArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryListAdminScheduleCategoryHintsArgs = {
  organizationId: Scalars['String']['input'];
  specializationId: Scalars['String']['input'];
};


export type QueryListAdminScheduleSpecializationsArgs = {
  organizationId: Scalars['String']['input'];
  scheduleTemplateId: Scalars['String']['input'];
};


export type QueryListAdminScheduleTemplatesArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryListAdyenVerificationStatusesArgs = {
  statusFilter?: InputMaybe<BusinessVerificationStatus>;
};


export type QueryListAffiliatedOrganizationsArgs = {
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListAgentPartiesArgs = {
  legalEntityId: Scalars['String']['input'];
  pagination: Pagination;
};


export type QueryListAllWorkflowsArgs = {
  definitionName?: InputMaybe<Scalars['String']['input']>;
  pagination: Pagination;
  status?: InputMaybe<WorkflowStatus>;
};


export type QueryListAspectRequestsArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryListAspectStatusesArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryListAspectsArgs = {
  filter?: InputMaybe<Array<AspectFilter>>;
};


export type QueryListAssociatedTransactionFactsArgs = {
  dataSourceId: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
};


export type QueryListAvailablePlansArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryListBillingSubscriptionHistoryArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryListChartOfAccountsTemplatesArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryListChartsOfAccountsArgs = {
  filter?: InputMaybe<AdminChartOfAccountsFilter>;
};


export type QueryListClassificationManifestsArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryListClusteredPrefixesArgs = {
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListConnectionEventsArgs = {
  id: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  pagination: Pagination;
};


export type QueryListConnectionFeatureFlagsArgs = {
  connectionId: Scalars['String']['input'];
};


export type QueryListConnectionsArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryListConnectorInstallsArgs = {
  connectorId: Scalars['String']['input'];
};


export type QueryListConnectorsArgs = {
  className?: InputMaybe<Scalars['String']['input']>;
  institutionId?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<Pagination>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<ConnectorVisibility>;
};


export type QueryListCsvImportTransactionFactsArgs = {
  csvImportId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  pagination?: InputMaybe<Pagination>;
};


export type QueryListCsvImportsArgs = {
  legalEntityId: Scalars['String']['input'];
  order?: InputMaybe<CsvImportSort>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryListDataSourceJobErrorsArgs = {
  legalEntityId: Scalars['String']['input'];
  requestObjectId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListDepartmentFactHierarchyArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryListEmployeesArgs = {
  filter: EmployeeFilter;
  pagination: Pagination;
};


export type QueryListGlobalPartiesArgs = {
  filter?: InputMaybe<GlobalPartyFilter>;
  order?: InputMaybe<GlobalPartySort>;
  pagination: Pagination;
};


export type QueryListGlobalPartiesWithSummariesArgs = {
  filter?: InputMaybe<GlobalPartyFilter>;
  order?: InputMaybe<GlobalPartySort>;
  pagination: Pagination;
};


export type QueryListInstitutionsArgs = {
  pagination: Pagination;
};


export type QueryListInvitationsByOrganizationArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryListInvoiceMigrationReportsArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryListLayoutVersionsArgs = {
  layoutId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type QueryListLedgerTransactionFactsArgs = {
  ledgerTransactionIds: Array<Scalars['String']['input']>;
  legalEntityId: Scalars['String']['input'];
};


export type QueryListLegalEntitiesArgs = {
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  excludedBillingProductIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  excludedStatuses?: InputMaybe<Array<LegalEntityStatus>>;
  includedBillingProductIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  includedStatuses?: InputMaybe<Array<LegalEntityStatus>>;
  kind?: InputMaybe<OrganizationKind>;
  legalEntityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  noAffiliations?: InputMaybe<Scalars['Boolean']['input']>;
  noEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  pagination: Pagination;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListLegalEntityTransfersArgs = {
  createdSince?: InputMaybe<Scalars['String']['input']>;
  createdUntil?: InputMaybe<Scalars['String']['input']>;
  legalEntityId: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
};


export type QueryListLineClassFactHierarchyArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryListMatchSetTransactionFactsArgs = {
  legalEntityId: Scalars['String']['input'];
  transactionFactId: Scalars['String']['input'];
};


export type QueryListMigrationPullRequestsArgs = {
  anyLabel?: InputMaybe<Scalars['Boolean']['input']>;
  prState?: InputMaybe<PullRequestFilterState>;
  repo: Scalars['String']['input'];
};


export type QueryListMismatchedQuickbooksBalanceSheetCategoriesArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryListMismatchedQuickbooksCategoriesArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryListOrganizationAspectStatusesArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryListOrganizationPackageAspectsArgs = {
  organizationId: Scalars['String']['input'];
  packageId: Scalars['String']['input'];
};


export type QueryListOrganizationProductsArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryListOrganizationTiersArgs = {
  couponIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryListOrganizationsArgs = {
  affiliateType?: InputMaybe<AffiliateType>;
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  kind?: InputMaybe<OrganizationKind>;
  onlyWithEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  organizationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  pagination?: InputMaybe<Pagination>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListPartiesArgs = {
  designation?: InputMaybe<PartyDesignation>;
  legalEntityId: Scalars['String']['input'];
  pagination: Pagination;
  partyType?: InputMaybe<PartyType>;
  viewType: ViewType;
};


export type QueryListPartyExtractionsArgs = {
  legalEntityId: Scalars['String']['input'];
  pagination: Pagination;
};


export type QueryListPaymentJournalEntriesArgs = {
  tagName: Scalars['String']['input'];
  tagValue: Scalars['String']['input'];
};


export type QueryListPaymentJournalEntriesByCoAAndTagValueArgs = {
  chartOfAccountsId: Scalars['String']['input'];
  tagValue: Scalars['String']['input'];
};


export type QueryListPaymentsLedgerCategoryEntriesArgs = {
  canonicalCategoryLabel: Scalars['String']['input'];
  ownerId: Scalars['String']['input'];
  pagination: Pagination;
};


export type QueryListPayrollPartiesArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryListPrefixMappingsArgs = {
  filter: PrefixFilter;
};


export type QueryListProductsArgs = {
  target?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListReconciliationAccountsArgs = {
  legalEntityId: Scalars['String']['input'];
  reconciliationStates: Array<ReconciliationState>;
};


export type QueryListReportPackagesArgs = {
  legalEntityId: Scalars['String']['input'];
  origin: IntervalOrigin;
  pagination: Pagination;
};


export type QueryListRestrictedCapabilitiesArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryListSanitizedDescriptionsArgs = {
  prefix: Scalars['String']['input'];
};


export type QueryListSignupsArgs = {
  pagination: Pagination;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  status: ListSignupRequestStatus;
};


export type QueryListTransactionFactCategoryClassificationsArgs = {
  transactionFactId: Scalars['String']['input'];
};


export type QueryListTransactionFactLedgerPartyClassificationsArgs = {
  transactionFactId: Scalars['String']['input'];
};


export type QueryListTransactionFactPartyClassificationsArgs = {
  transactionFactId: Scalars['String']['input'];
};


export type QueryListUnsupportedTransactionsArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryListUsersArgs = {
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  noEmployments?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  pagination: Pagination;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListWorkflowsArgs = {
  definitionName?: InputMaybe<Scalars['String']['input']>;
  legalEntityID: Scalars['String']['input'];
  pagination: Pagination;
  status?: InputMaybe<WorkflowStatus>;
};


export type QueryPlaidFetchInstitutionArgs = {
  id: Scalars['String']['input'];
};


export type QueryPlaidListStatementsArgs = {
  id: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadActiveViewVersionArgs = {
  legalEntityId: Scalars['String']['input'];
  viewType: ViewType;
};


export type QueryReadAdminScheduleSpecializationDetailArgs = {
  organizationId: Scalars['String']['input'];
  specializationId: Scalars['String']['input'];
};


export type QueryReadAdminScheduleTemplateArgs = {
  organizationId: Scalars['String']['input'];
  scheduleTemplateId: Scalars['String']['input'];
};


export type QueryReadAdyenAccountHolderStatusArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadAssociatedThreadsArgs = {
  allowResolved?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  kind: ObjectKind;
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadBillingArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryReadBusinessVerificationStatusArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadChartOfAccountsArgs = {
  id: Scalars['String']['input'];
};


export type QueryReadChartOfAccountsTemplateArgs = {
  organizationId: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
};


export type QueryReadComponentDataArgs = {
  dataId: Scalars['String']['input'];
  layoutId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadComponentDataJsonArgs = {
  dataId: Scalars['String']['input'];
  layoutId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadConnectRecordingArgs = {
  connectionId: Scalars['String']['input'];
  eventId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadConnectionArgs = {
  id: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadConnectorArgs = {
  connectorId: Scalars['String']['input'];
};


export type QueryReadConnectorCredentialsArgs = {
  connectorId: Scalars['String']['input'];
};


export type QueryReadDataHealthArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadDetailedAdyenStatusArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadEmailHtmlArgs = {
  eventType: EventType;
};


export type QueryReadEntityDataProcessingStatusesArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadEntityExtractionsArgs = {
  transactionFactId: Scalars['String']['input'];
};


export type QueryReadInvitationArgs = {
  token: Scalars['String']['input'];
};


export type QueryReadInvitationByOrganizationArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryReadInvitationBySignupArgs = {
  signupId: Scalars['String']['input'];
};


export type QueryReadLayoutVersionArgs = {
  layoutId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
};


export type QueryReadLedgerTransactionIdsArgs = {
  transactionFactIds: Array<Scalars['String']['input']>;
};


export type QueryReadLegalEntityArgs = {
  id: Scalars['String']['input'];
};


export type QueryReadLegalEntityPreferencesArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadMappedChartOfAccountsArgs = {
  fromId: Scalars['String']['input'];
  toId: Scalars['String']['input'];
  viewType?: InputMaybe<ViewType>;
};


export type QueryReadMigrationPullRequestArgs = {
  prNumber: Scalars['Int']['input'];
  repo: Scalars['String']['input'];
};


export type QueryReadOrganizationArgs = {
  id: Scalars['String']['input'];
};


export type QueryReadOrganizationBillingPlanArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryReadOrganizationPackageArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryReadOrganizationTierArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryReadPaymentsLedgerCoAArgs = {
  ownerId: Scalars['String']['input'];
};


export type QueryReadPlaidConnectionArgs = {
  id: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadPlaidItemArgs = {
  accessToken: Scalars['String']['input'];
};


export type QueryReadReconciliationDiffsArgs = {
  accountId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadReportValidationArchiveArgs = {
  legalEntityId: Scalars['String']['input'];
  reportId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
};


export type QueryReadSignupArgs = {
  id: Scalars['String']['input'];
};


export type QueryReadSourceRecordedMatchSummaryArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadThreadArgs = {
  legalEntityId: Scalars['String']['input'];
  threadId: Scalars['String']['input'];
};


export type QueryReadTransactionFactArgs = {
  transactionFactId: Scalars['String']['input'];
};


export type QueryReadTransactionFactCheckMetadataArgs = {
  transactionFactId: Scalars['String']['input'];
};


export type QueryReadUserArgs = {
  id: Scalars['String']['input'];
};


export type QueryReadValidationHistoryArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadVanityStatsArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadWorkItemArgs = {
  workItemId: Scalars['String']['input'];
};


export type QueryReadWorkItemValidationArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryReprocessDocumentArgs = {
  documentId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type QuerySearchByUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QuerySegmentUrlArgs = {
  collectionId?: InputMaybe<Scalars['String']['input']>;
  fileId?: InputMaybe<Scalars['String']['input']>;
  segmentId?: InputMaybe<Scalars['String']['input']>;
};

export type QuickBooksAccountingInfoPreferences = {
  bookCloseDate?: Maybe<Date>;
};

export type QuickBooksCompany = {
  preferences?: Maybe<QuickBooksPreferences>;
};

export type QuickBooksConfig = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  realmId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type QuickBooksPreferences = {
  accountingInfo?: Maybe<QuickBooksAccountingInfoPreferences>;
};

export type QuotePackage = {
  companyDetails: CompanyDetails;
  contractDocumentId?: Maybe<Scalars['String']['output']>;
  financials?: Maybe<Array<CompanyFinancials>>;
  id: Scalars['String']['output'];
  recipient?: Maybe<Contact>;
  status: QuoteStatus;
};

export type QuotePackageId = {
  id: Scalars['String']['output'];
};

export enum QuoteStatus {
  Accepted = 'Accepted',
  Created = 'Created',
  CustomerReview = 'CustomerReview',
  Deferred = 'Deferred',
  New = 'New',
  UnknownQuoteStatus = 'UnknownQuoteStatus'
}

export type RampConnectorProperties = {
  authorizationURL: Scalars['String']['output'];
};

export type RawDocument = {
  asyncProcessingStatus: AsyncProcessingStatus;
  collectionId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<EntityUser>;
  dataSource?: Maybe<EntityDataSource>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  features: Array<Feature>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['Float']['output']>;
  formats: Array<Format>;
  id: Scalars['String']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  sourceFormat?: Maybe<Format>;
  sourceFormatId?: Maybe<Scalars['String']['output']>;
  status: DocumentStatus;
  thumbnail?: Maybe<Segment>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RawResponse = {
  rawBody?: Maybe<Scalars['String']['output']>;
};

/** ReadLedgerTransaction is the output type of readLedgerTransaction GraphQL query */
export type ReadLedgerTransaction = {
  transaction: LedgerTransaction;
};

export enum RealtimeHealthStatus {
  HasLoginRequired = 'HasLoginRequired',
  HasPredictions = 'HasPredictions',
  Healthy = 'Healthy',
  UnknownHealthStatus = 'UnknownHealthStatus'
}

export enum Reconciliation {
  Reconciled = 'Reconciled',
  Unreconciled = 'Unreconciled'
}

export type ReconciliationBalances = {
  ledgerAccountDifferences: LedgerAccountDifferences;
  ledgerBalances: LedgerBalances;
  statementBalances: StatementBalances;
};

export type ReconciliationDetails = {
  balances: ReconciliationBalances;
  maxClassificationUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  normalEntryType: EntryType;
  reconciledSystemClassificationsCount: Scalars['Int']['output'];
  reconciliation: AccountReconciliation;
  transactionCounts: TransactionCounts;
  unsettledSystemClassificationsCount: Scalars['Int']['output'];
};

export type ReconciliationDiff = {
  reconciliationId: Scalars['String']['output'];
  toEndDate: Date;
  toStartDate: Date;
  transactions: Array<ReconciliationDiffTransaction>;
};

export enum ReconciliationDiffReason {
  Added = 'Added',
  Amount = 'Amount',
  EntryType = 'EntryType',
  OccurredAt = 'OccurredAt',
  ReconciliationStatus = 'ReconciliationStatus',
  Removed = 'Removed',
  UnknownReason = 'UnknownReason'
}

export type ReconciliationDiffTransaction = {
  diffReasons: Array<ReconciliationDiffReason>;
  fromAmount?: Maybe<MonetaryValue>;
  fromEntryType?: Maybe<EntryType>;
  fromOccurredAt?: Maybe<Scalars['DateTime']['output']>;
  fromStatus?: Maybe<TransactionReconciliationStatus>;
  toAmount?: Maybe<MonetaryValue>;
  toEntryType?: Maybe<EntryType>;
  toOccurredAt?: Maybe<Scalars['DateTime']['output']>;
  toStatus?: Maybe<TransactionReconciliationStatus>;
  transaction?: Maybe<Transaction>;
  transactionFactId: Scalars['String']['output'];
};

export enum ReconciliationEventType {
  AutoCreatedReconciliation = 'AutoCreatedReconciliation',
  FinalizedReconciliation = 'FinalizedReconciliation',
  ManualCreatedReconciliation = 'ManualCreatedReconciliation',
  ReconfiguredReconciliation = 'ReconfiguredReconciliation',
  ReopenedReconciliation = 'ReopenedReconciliation',
  UnknownReconciliation = 'UnknownReconciliation'
}

export enum ReconciliationFilter {
  FindAll = 'FindAll',
  OccurredInPeriodReconciled = 'OccurredInPeriodReconciled',
  OccurredInPeriodUnreconciled = 'OccurredInPeriodUnreconciled',
  Reconciled = 'Reconciled',
  Unreconciled = 'Unreconciled',
  Unspecified = 'Unspecified'
}

export type ReconciliationFlag = {
  changeDateDetails?: Maybe<ChangeDateFlagDetails>;
  createNewTransactionDetails?: Maybe<CreateNewTransactionFlagDetails>;
  createdAt: Scalars['DateTime']['output'];
  flagId: Scalars['String']['output'];
  flagType: ReconciliationFlagType;
  /** Exactly one of these will be populated based on flagType */
  potentialDuplicateDetails?: Maybe<PotentialDuplicateFlagDetails>;
  potentialMismatchDetails?: Maybe<PotentialMismatchFlagDetails>;
  reconciliationIntentId: Scalars['String']['output'];
  resolutionType?: Maybe<ReconciliationFlagResolutionType>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  resolvedByUser?: Maybe<EntityUser>;
};

export enum ReconciliationFlagResolutionType {
  Dismissed = 'Dismissed',
  Resolved = 'Resolved',
  UnknownResolutionType = 'UnknownResolutionType'
}

export enum ReconciliationFlagType {
  ChangeDateFlagType = 'ChangeDateFlagType',
  CreateNewTransactionFlagType = 'CreateNewTransactionFlagType',
  PotentialDuplicateFlagType = 'PotentialDuplicateFlagType',
  PotentialMismatchFlagType = 'PotentialMismatchFlagType',
  UnknownFlagType = 'UnknownFlagType'
}

export type ReconciliationHistoryEvent = {
  eventType: ReconciliationEventType;
  reconciliationId: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  user?: Maybe<EntityUser>;
};

export type ReconciliationIntent = {
  actionItemId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  documentCollectionId?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['String']['output'];
  initiatedByUserId?: Maybe<Scalars['String']['output']>;
  intentCategoryId?: Maybe<Scalars['String']['output']>;
  intentChartOfAccountsId?: Maybe<Scalars['String']['output']>;
  legalEntityId: Scalars['String']['output'];
  /**
   * AccountGroup feature_group_id ABR resolved for this intent. When set,
   * FE callers scope feature-level rendering to features whose `groups`
   * include this id so a multi-account document surfaces only the
   * account that belongs to this intent's reconciliation. Empty for
   * single-account statements and legacy intents.
   */
  matchedAccountFeatureGroupId?: Maybe<Scalars['String']['output']>;
  processingEndedAt?: Maybe<Scalars['DateTime']['output']>;
  processingStartedAt?: Maybe<Scalars['DateTime']['output']>;
  reconciliationCategoryId?: Maybe<Scalars['String']['output']>;
  reconciliationChartOfAccountsId?: Maybe<Scalars['String']['output']>;
  reconciliationId?: Maybe<Scalars['String']['output']>;
  reconciliationIntentId: Scalars['String']['output'];
  state: ReconciliationIntentState;
};

export type ReconciliationIntentDetails = {
  actionItemId?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['String']['output'];
  initiatedByUserId?: Maybe<Scalars['String']['output']>;
  intentCategoryId?: Maybe<Scalars['String']['output']>;
  /**
   * AccountGroup feature_group_id ABR resolved for this intent. When set,
   * FE callers scope feature-level rendering (e.g. bounding boxes) to
   * features whose `groups` include this id.
   */
  matchedAccountFeatureGroupId?: Maybe<Scalars['String']['output']>;
  processingEndedAt?: Maybe<Scalars['DateTime']['output']>;
  reconciliationIntentId: Scalars['String']['output'];
  state: ReconciliationIntentState;
};

export enum ReconciliationIntentState {
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  DocumentProcessing = 'DocumentProcessing',
  Failed = 'Failed',
  InvalidCategory = 'InvalidCategory',
  InvalidDocument = 'InvalidDocument',
  ReconciliationProcessing = 'ReconciliationProcessing',
  UnknownState = 'UnknownState'
}

export type ReconciliationPeriodStats = {
  drafts: Scalars['Int']['output'];
  finalized: Scalars['Int']['output'];
  noActivity?: Maybe<Scalars['Int']['output']>;
  notStarted: Scalars['Int']['output'];
  totalCategories: Scalars['Int']['output'];
};

export enum ReconciliationState {
  Draft = 'Draft',
  Finalized = 'Finalized',
  ManualReopened = 'ManualReopened',
  SystemDraft = 'SystemDraft',
  SystemFinalized = 'SystemFinalized',
  SystemReopened = 'SystemReopened',
  Unknown = 'Unknown'
}

export enum ReconciliationsExportStatus {
  Completed = 'Completed',
  Pending = 'Pending',
  Unknown = 'Unknown'
}

export type ReconciliationsPdfs = {
  completedDocumentCount: Scalars['Long']['output'];
  documentCollectionId: Scalars['String']['output'];
  documentUrls: Array<Scalars['String']['output']>;
  status: ReconciliationsExportStatus;
  totalDocumentCount: Scalars['Long']['output'];
};

export type RemittanceFeatureValue = {
  remittanceValue: RemittanceItem;
};

export type RemittanceItem = {
  BankAccountName?: Maybe<Scalars['String']['output']>;
  BankAccountNumber: Scalars['String']['output'];
  BankName: Scalars['String']['output'];
  BankRoutingNumber: Scalars['String']['output'];
  RemittanceType: RemittanceType;
};

export enum RemittanceType {
  ACH = 'ACH',
  Unknown = 'Unknown',
  Wire = 'Wire'
}

export type Report = {
  author?: Maybe<Contact>;
  createdAt: Scalars['DateTime']['output'];
  generationHistory?: Maybe<ReportGenerationHistory>;
  id: Scalars['String']['output'];
  interval: Interval;
  options?: Maybe<ReportDocumentOptions>;
  reportFile: ReportFileMetadata;
  reportFor?: Maybe<Date>;
  status: ReportPackageDocumentStatus;
  title: Scalars['String']['output'];
  versionId: Scalars['String']['output'];
};

export enum ReportAction {
  Print = 'Print'
}

export type ReportActionEvent = {
  action: ReportAction;
  packageId: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

/** Report automation settings */
export type ReportAutomationSettings = {
  autoCreateDraft: Scalars['Boolean']['output'];
  autoPublishDraft: Scalars['Boolean']['output'];
  autoPublishDraftDay: Scalars['Long']['output'];
  autoPublishFinal: Scalars['Boolean']['output'];
  autoPublishFinalDay: Scalars['Long']['output'];
  interval: Interval;
  legalEntityId?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['String']['output'];
};

export enum ReportBreakdownByClass {
  Department = 'Department',
  InvalidBreakdown = 'InvalidBreakdown',
  Location = 'Location'
}

export type ReportDocumentOptions = {
  amountPrecision?: Maybe<ReportNumberPrecision>;
  breakdownByClass?: Maybe<ReportBreakdownByClass>;
  categoryByDepartmentOptions?: Maybe<CategoryByDepartmentOptions>;
  categoryByLocationOptions?: Maybe<CategoryByLocationOptions>;
  collapsedSections?: Maybe<CollapsedSections>;
  comparedToIncome?: Maybe<ReportOptionComparison>;
  comparedToTotal?: Maybe<ReportOptionComparison>;
  deltaMonthOverMonth?: Maybe<ReportOptionComparison>;
  deltaMonthOverMonthPeriods?: Maybe<Scalars['Int']['output']>;
  deltaYearOverYear?: Maybe<ReportOptionComparison>;
  deltaYearToDate?: Maybe<ReportOptionComparison>;
  reportLookbackPeriods?: Maybe<Scalars['Int']['output']>;
  sparklineLookbackPeriods?: Maybe<Scalars['Int']['output']>;
  yearToDate?: Maybe<ReportOptionComparison>;
};

export type ReportDocumentOptionsInput = {
  amountPrecision?: InputMaybe<ReportNumberPrecision>;
  breakdownByClass?: InputMaybe<ReportBreakdownByClass>;
  categoryByDepartmentOptions?: InputMaybe<CategoryByDepartmentOptionsInput>;
  categoryByLocationOptions?: InputMaybe<CategoryByLocationOptionsInput>;
  collapsedSections?: InputMaybe<CollapsedSectionsInput>;
  comparedToIncome?: InputMaybe<ReportOptionComparison>;
  comparedToTotal?: InputMaybe<ReportOptionComparison>;
  deltaMonthOverMonth?: InputMaybe<ReportOptionComparison>;
  deltaMonthOverMonthPeriods?: InputMaybe<Scalars['Int']['input']>;
  deltaYearOverYear?: InputMaybe<ReportOptionComparison>;
  deltaYearToDate?: InputMaybe<ReportOptionComparison>;
  reportLookbackPeriods?: InputMaybe<Scalars['Int']['input']>;
  sparklineLookbackPeriods?: InputMaybe<Scalars['Int']['input']>;
  yearToDate?: InputMaybe<ReportOptionComparison>;
};

export type ReportDownload = {
  url: Scalars['String']['output'];
};

export type ReportFileMetadata = {
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  source: ReportFileSource;
};

export enum ReportFileSource {
  AVS = 'AVS',
  DataIngestion = 'DataIngestion',
  UnknownFileSource = 'UnknownFileSource',
  UserUploaded = 'UserUploaded'
}

export type ReportGenerationHistory = {
  authorId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  error?: Maybe<Scalars['String']['output']>;
  generationEndedAt?: Maybe<Scalars['DateTime']['output']>;
  generationStartedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  kind: ReportKind;
  legalEntityId: Scalars['String']['output'];
  periodEndedAt: Scalars['DateTime']['output'];
  periodStartedAt: Scalars['DateTime']['output'];
  reportId: Scalars['String']['output'];
  requestId: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  versionId: Scalars['String']['output'];
  viewVersion: Scalars['Float']['output'];
};

export type ReportGenerationStatus = {
  reportId: Scalars['String']['output'];
  status: GenerationStatus;
  versionId: Scalars['String']['output'];
};

export enum ReportKind {
  APAging = 'APAging',
  ARAging = 'ARAging',
  BalanceSheet = 'BalanceSheet',
  CashFlow = 'CashFlow',
  ExpenseSummary = 'ExpenseSummary',
  ProfitAndLoss = 'ProfitAndLoss',
  Unknown = 'Unknown'
}

export type ReportKindValidationHistory = {
  history: ReportValidationHistory;
  kind: ReportKind;
};

export type ReportKindValidationPeriodHistory = {
  histories: Array<ReportKindValidationHistory>;
  period: Period;
};

export enum ReportNumberPrecision {
  Decimal = 'Decimal',
  InvalidNumberPrecision = 'InvalidNumberPrecision',
  Rounded = 'Rounded'
}

export enum ReportOptionComparison {
  Amount = 'Amount',
  DeltaPercent = 'DeltaPercent',
  InvalidComparison = 'InvalidComparison',
  Percent = 'Percent',
  Total = 'Total',
  TriPeriodDeltaPercent = 'TriPeriodDeltaPercent'
}

export enum ReportOptionTimelineInterval {
  InvalidInterval = 'InvalidInterval',
  Last3Months = 'Last3Months',
  Last6Months = 'Last6Months',
  Last12Months = 'Last12Months'
}

export type ReportPackage = {
  author?: Maybe<Contact>;
  authorOrganization?: Maybe<OrganizationPreview>;
  createdAt: Scalars['DateTime']['output'];
  documents: Array<ReportPackageDocumentDetails>;
  endedAt: Scalars['DateTime']['output'];
  entities: ObjectEntities;
  id: Scalars['String']['output'];
  interval: Interval;
  legalEntityOrganization?: Maybe<OrganizationPreview>;
  packageOptions?: Maybe<ReportPackageOptions>;
  startedAt: Scalars['DateTime']['output'];
  status: ReportPackageStatus;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  version: ReportPackageVersionMetadata;
  versionId: Scalars['String']['output'];
  viewKey: ViewIdentifier;
};

export type ReportPackageDocument = LayoutDocument | Report | TextDocument;

export type ReportPackageDocumentDetails = {
  document?: Maybe<ReportPackageDocument>;
  metadata: ReportPackageDocumentMetadata;
};

export type ReportPackageDocumentMetadata = {
  documentObjectId: Scalars['String']['output'];
  documentObjectVersionId: Scalars['String']['output'];
  generationHistory?: Maybe<ReportGenerationHistory>;
  id: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  reportFile?: Maybe<ReportFileMetadata>;
  status: ReportPackageDocumentStatus;
  title: Scalars['String']['output'];
  type: ReportPackageDocumentType;
};

export enum ReportPackageDocumentStatus {
  Complete = 'Complete',
  Failed = 'Failed',
  Pending = 'Pending',
  UnknownStatus = 'UnknownStatus'
}

export enum ReportPackageDocumentType {
  Layout = 'Layout',
  Report = 'Report',
  Text = 'Text'
}

export type ReportPackageMetadata = {
  author?: Maybe<Contact>;
  coverUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  creationMethod: CreationMethod;
  documents: Array<ReportPackageDocumentMetadata>;
  endedAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  interval: Interval;
  publishedAsDraft: Scalars['Boolean']['output'];
  startedAt: Scalars['DateTime']['output'];
  status: ReportPackageStatus;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  versionId: Scalars['String']['output'];
  versions: Array<ReportPackageVersionMetadata>;
  viewKey: ViewIdentifier;
};


export type ReportPackageMetadataVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ReportPackageStatus>;
};

export type ReportPackageOptions = {
  accountNumbersDisplay?: Maybe<AccountNumbersDisplay>;
  coverLogoSource?: Maybe<CoverLogoSource>;
  coverUrl?: Maybe<Scalars['String']['output']>;
  customFooter?: Maybe<Scalars['String']['output']>;
  preparedBy?: Maybe<Scalars['String']['output']>;
  publishedAsDraft?: Maybe<Scalars['Boolean']['output']>;
};

export enum ReportPackageStatus {
  Draft = 'Draft',
  Published = 'Published',
  Transient = 'Transient',
  Unknown = 'Unknown'
}

/** Reports */
export type ReportPackageSummary = {
  draftCount: Scalars['Long']['output'];
  packagesCount: Scalars['Long']['output'];
  period: Period;
  publishedCount: Scalars['Long']['output'];
};

export type ReportPackageVersionMetadata = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  status: ReportPackageStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ReportRefreshRequest = {
  requestId: Scalars['String']['output'];
};

export enum ReportSource {
  Digits = 'Digits',
  None = 'None',
  QuickBooks = 'QuickBooks'
}

export type ReportTemplate = {
  coverUrl: Scalars['String']['output'];
  hasBalanceSheet: Scalars['Boolean']['output'];
  hasCashFlow: Scalars['Boolean']['output'];
  hasExecutiveSummary: Scalars['Boolean']['output'];
  hasProfitAndLoss: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ReportValidationArchive = {
  avs?: Maybe<Scalars['String']['output']>;
  digits?: Maybe<Scalars['String']['output']>;
  quickbooks: Scalars['String']['output'];
};

export type ReportValidationByKind = {
  invalidCount: Scalars['Long']['output'];
  kind: ReportKind;
  validCount: Scalars['Long']['output'];
};

export type ReportValidationGlobalPeriodSummary = {
  byKind: Array<ReportValidationByKind>;
  packageInvalidCount: Scalars['Long']['output'];
  packageValidCount: Scalars['Long']['output'];
  period: Period;
};

export type ReportValidationHistory = {
  errorMessage?: Maybe<Scalars['String']['output']>;
  isValid: Scalars['Boolean']['output'];
  legalEntityId: Scalars['String']['output'];
  reportId: Scalars['String']['output'];
  source: ReportFileSource;
  validatedAt: Scalars['DateTime']['output'];
  versionId: Scalars['String']['output'];
};

export type RequestParameter = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ResolvePotentialMismatchInput = {
  documentFeatureGroupId: Scalars['String']['input'];
  flagId: Scalars['String']['input'];
  ledgerTransactionId: Scalars['String']['input'];
  transactionFactId: Scalars['String']['input'];
};

export type RestrictedCapabilitiesResult = {
  capabilities: Array<RestrictedCapabilityStatus>;
  legalEntityId: Scalars['String']['output'];
};

/** Restricted Capabilities */
export enum RestrictedCapabilityName {
  CompleteBlock = 'CompleteBlock',
  HighRiskFraud = 'HighRiskFraud',
  StallSettlements = 'StallSettlements'
}

export type RestrictedCapabilityStatus = {
  capability: RestrictedCapabilityName;
  enabled: Scalars['Boolean']['output'];
};

export type RestrictedCapabilityToggleResult = {
  capability: RestrictedCapabilityName;
  enabled: Scalars['Boolean']['output'];
  legalEntityId: Scalars['String']['output'];
};

export enum ReviewStatus {
  Approved = 'Approved',
  ChangesRequested = 'ChangesRequested',
  Commented = 'Commented',
  Dismissed = 'Dismissed',
  Pending = 'Pending'
}

export type RichComment = {
  comment: Comment;
  entities?: Maybe<ObjectEntities>;
  layout: Layout;
};

export type Role = {
  id: Scalars['String']['output'];
};

export type RoleIdentifier = {
  id: Scalars['String']['input'];
};

export type Runway = {
  cashOutDate?: Maybe<Scalars['DateTime']['output']>;
  current: DimensionSummary;
  future: DimensionSummary;
  previousCashOutDate?: Maybe<Scalars['DateTime']['output']>;
};

export type RunwayChartConfig = {
  netBurnLookback?: Maybe<ArchiveIntervalOrigin>;
  origin: ArchiveIntervalOrigin;
};

export type RunwayChartConfigInput = {
  netBurnLookback?: InputMaybe<IntervalOrigin>;
  origin: IntervalOrigin;
};

export enum SandboxIndustry {
  Retail = 'Retail',
  Technology = 'Technology',
  UnknownIndustry = 'UnknownIndustry'
}

export enum SandboxType {
  Accountant = 'Accountant',
  Operator = 'Operator',
  UnknownSandboxType = 'UnknownSandboxType'
}

export type SanitizedDescription = {
  exampleTransactionNameAndDescription?: Maybe<Scalars['String']['output']>;
  sanitizedDescription: Scalars['String']['output'];
  transactionCount: Scalars['Long']['output'];
};

export type Schedule = {
  createdAt: Scalars['DateTime']['output'];
  createdBy: EntityUser;
  description?: Maybe<Scalars['String']['output']>;
  events: Array<ScheduleEvent>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  party?: Maybe<EntityParty>;
  scheduleNumber: Scalars['String']['output'];
  scheduleTemplateId: Scalars['String']['output'];
  scheduleType: ScheduleType;
  sourceTransaction?: Maybe<EntityTransaction>;
  specializationId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: EntityUser;
};

export type ScheduleBooleanValue = {
  boolValue: Scalars['Boolean']['output'];
};

export type ScheduleBooleanValueInput = {
  boolValue: Scalars['Boolean']['input'];
};

export type ScheduleCandidate = {
  scheduleTemplate: ScheduleTemplate;
  scheduleType: ScheduleType;
  sourceRecategorizeCategory?: Maybe<EntityCategory>;
  sourceTransactionFactId: Scalars['String']['output'];
  specialization?: Maybe<ScheduleSpecialization>;
};

export type ScheduleCategoryValue = {
  category: EntityCategory;
};

export enum ScheduleColumnName {
  Category = 'Category',
  EndDate = 'EndDate',
  Name = 'Name',
  RelatedCategory = 'RelatedCategory',
  StartDate = 'StartDate',
  TotalAmount = 'TotalAmount'
}

export type ScheduleDashboardFilter = {
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  endDateMax?: InputMaybe<Scalars['DateTime']['input']>;
  endDateMin?: InputMaybe<Scalars['DateTime']['input']>;
  filterText?: InputMaybe<Scalars['String']['input']>;
  maxAmount?: InputMaybe<InputMonetaryValue>;
  minAmount?: InputMaybe<InputMonetaryValue>;
  partyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  relatedCategoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduleTypes?: InputMaybe<Array<ScheduleType>>;
  startDateMax?: InputMaybe<Scalars['DateTime']['input']>;
  startDateMin?: InputMaybe<Scalars['DateTime']['input']>;
  viewKey: ViewKey;
};

export type ScheduleDateValue = {
  dateValue: Scalars['DateTime']['output'];
};

export type ScheduleDateValueInput = {
  dateValue: Scalars['DateTime']['input'];
};

export type ScheduleDefaults = {
  eventTemplates: Array<ScheduleEventTemplate>;
  events: Array<ScheduleEvent>;
  specialization?: Maybe<ScheduleSpecialization>;
};

export type ScheduleDimension = {
  by: DimensionSummary;
  scheduleId: Scalars['String']['output'];
  scheduleObject?: Maybe<EntitySchedule>;
  summary: TransactionSummary;
};

export type ScheduleEditedObject = {
  action: ScheduleEditedObjectAction;
  id: Scalars['String']['output'];
  kind: ScheduleEditedObjectKind;
};

export enum ScheduleEditedObjectAction {
  Created = 'Created',
  Deleted = 'Deleted',
  Edited = 'Edited',
  UnknownAction = 'UnknownAction'
}

/** Schedule Editing History */
export enum ScheduleEditedObjectKind {
  Event = 'Event',
  Schedule = 'Schedule',
  UnknownKind = 'UnknownKind'
}

export type ScheduleEvent = {
  createdAt: Scalars['DateTime']['output'];
  createdBy: EntityUser;
  displayKey?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  eventDate: Scalars['DateTime']['output'];
  eventTemplateId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isGenerated: Scalars['Boolean']['output'];
  isInstantiating: Scalars['Boolean']['output'];
  isSingleton: Scalars['Boolean']['output'];
  isTerminating: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  skipReason?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: EntityUser;
  variables: Array<ScheduleEventVariable>;
};

export type ScheduleEventInput = {
  displayName: Scalars['String']['input'];
  eventDate: Scalars['DateTime']['input'];
  eventTemplateId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  variables: Array<ScheduleEventVariableInput>;
};

export type ScheduleEventTemplate = {
  description?: Maybe<Scalars['String']['output']>;
  displayKey?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  inCreateFlow: Scalars['Boolean']['output'];
  isInstantiating: Scalars['Boolean']['output'];
  isSingleton: Scalars['Boolean']['output'];
  isTerminating: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  ordinal: Scalars['Int']['output'];
  variables: Array<ScheduleEventVariableTemplate>;
};

export type ScheduleEventVariable = {
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  value: ScheduleVariableValue;
  variableName: Scalars['String']['output'];
  variableTemplateId: Scalars['String']['output'];
  variableType: ScheduleEventVariableType;
};

export enum ScheduleEventVariableDisplayMode {
  Editable = 'Editable',
  Hidden = 'Hidden',
  ReadOnly = 'ReadOnly',
  UnknownDisplayMode = 'UnknownDisplayMode'
}

export type ScheduleEventVariableInput = {
  displayName: Scalars['String']['input'];
  id: Scalars['String']['input'];
  value: ScheduleVariableValueInput;
  variableName: Scalars['String']['input'];
  variableTemplateId: Scalars['String']['input'];
  variableType: ScheduleEventVariableType;
};

export type ScheduleEventVariableTemplate = {
  displayMode: ScheduleEventVariableDisplayMode;
  displayName: Scalars['String']['output'];
  formulas?: Maybe<Array<ScheduleEventVariableTemplateFormula>>;
  id: Scalars['String']['output'];
  ordinal: Scalars['Int']['output'];
  required: Scalars['Boolean']['output'];
  variableName: Scalars['String']['output'];
  variableType: ScheduleEventVariableType;
};

export type ScheduleEventVariableTemplateFormula = {
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export enum ScheduleEventVariableType {
  Boolean = 'Boolean',
  CategoryId = 'CategoryId',
  Date = 'Date',
  Float = 'Float',
  Formula = 'Formula',
  Interval = 'Interval',
  Long = 'Long',
  MonetaryValue = 'MonetaryValue',
  PartyId = 'PartyId',
  String = 'String',
  Term = 'Term',
  TransactionId = 'TransactionId',
  UnknownType = 'UnknownType'
}

/** Schedule facet output types */
export type ScheduleFacet = {
  aggregate: Scalars['Int']['output'];
  category: Array<CategoryFacet>;
  party: Array<PartyFacet>;
  relatedCategory: Array<CategoryFacet>;
  scheduleType: Array<ScheduleTypeFacet>;
};

/** Schedule facets */
export type ScheduleFacetField = {
  kind: ScheduleFacetKind;
  type: FacetType;
};

export enum ScheduleFacetKind {
  ScheduleCategory = 'ScheduleCategory',
  ScheduleParty = 'ScheduleParty',
  ScheduleRelatedCategory = 'ScheduleRelatedCategory',
  ScheduleType = 'ScheduleType',
  UnknownScheduleKind = 'UnknownScheduleKind'
}

export type ScheduleFloatValue = {
  floatValue: Scalars['Float']['output'];
};

export type ScheduleFloatValueInput = {
  floatValue: Scalars['Float']['input'];
};

export type ScheduleFormulaValue = {
  formulaDisplayName: Scalars['String']['output'];
  formulaId: Scalars['String']['output'];
};

export type ScheduleFormulaValueInput = {
  formulaDisplayName: Scalars['String']['input'];
  formulaId: Scalars['String']['input'];
};

export type ScheduleHistoryEntry = {
  editedObjects: Array<ScheduleEditedObject>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<EntityUser>;
};

export type ScheduleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  events: Array<ScheduleEventInput>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  scheduleNumber: Scalars['String']['input'];
  scheduleTemplateId: Scalars['String']['input'];
  scheduleType: ScheduleType;
  sourceTransactionId?: InputMaybe<Scalars['String']['input']>;
  specializationId?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduleIntervalValue = {
  intervalValue: Interval;
};

export type ScheduleIntervalValueInput = {
  intervalValue: Interval;
};

export type ScheduleLongValue = {
  longValue: Scalars['Long']['output'];
};

export type ScheduleLongValueInput = {
  longValue: Scalars['Long']['input'];
};

export type ScheduleMonetaryValue = {
  monetaryValue: MonetaryValue;
};

export type ScheduleMonetaryValueInput = {
  amount: Scalars['Long']['input'];
  currencyCode: Scalars['String']['input'];
  currencyMultiplier: Scalars['Int']['input'];
};

export type ScheduleOrder = {
  scheduleOrderPairs: Array<ScheduleOrderPair>;
};

export type ScheduleOrderPair = {
  columnName: ScheduleColumnName;
  direction: SortDirection;
};

export type SchedulePartyValue = {
  party: EntityParty;
};

export enum ScheduleScope {
  AllScheduleTransactions = 'AllScheduleTransactions',
  ScheduleInitialization = 'ScheduleInitialization',
  ScheduleRecognition = 'ScheduleRecognition',
  UnknownScheduleScope = 'UnknownScheduleScope'
}

/** Schedule Dashboard */
export type ScheduleSnapshot = {
  amount: MonetaryValue;
  category?: Maybe<EntityCategory>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  party?: Maybe<EntityParty>;
  relatedCategory?: Maybe<EntityCategory>;
  remainingAmount: MonetaryValue;
  scheduleNumber: Scalars['String']['output'];
  scheduleType: ScheduleType;
  startDate: Scalars['DateTime']['output'];
};

export type ScheduleSpecialization = {
  description?: Maybe<Scalars['String']['output']>;
  displayKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  legalEntityId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  scheduleTemplateId: Scalars['String']['output'];
};

/** TODO: Remove this enum once backwards compatibility is no longer needed */
export enum ScheduleStatus {
  Active = 'Active',
  Closed = 'Closed',
  Draft = 'Draft'
}

export type ScheduleStringValue = {
  stringValue: Scalars['String']['output'];
};

export type ScheduleStringValueInput = {
  stringValue: Scalars['String']['input'];
};

export type ScheduleTemplate = {
  description?: Maybe<Scalars['String']['output']>;
  displayKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  scheduleType: ScheduleType;
};

export type ScheduleTermValue = {
  endDate?: Maybe<Scalars['DateTime']['output']>;
  intervalCount?: Maybe<Scalars['Long']['output']>;
};

export type ScheduleTermValueInput = {
  endDate: Scalars['DateTime']['input'];
};

export type ScheduleTransactionValue = {
  transaction: EntityTransaction;
};

export enum ScheduleType {
  FixedAsset = 'FixedAsset',
  PrepaidExpense = 'PrepaidExpense',
  UnknownType = 'UnknownType'
}

export type ScheduleTypeFacet = {
  count: Scalars['Int']['output'];
  scheduleType: ScheduleType;
};

export type ScheduleVariableValue = ScheduleBooleanValue | ScheduleCategoryValue | ScheduleDateValue | ScheduleFloatValue | ScheduleFormulaValue | ScheduleIntervalValue | ScheduleLongValue | ScheduleMonetaryValue | SchedulePartyValue | ScheduleStringValue | ScheduleTermValue | ScheduleTransactionValue;

export type ScheduleVariableValueInput = {
  boolValue?: InputMaybe<ScheduleBooleanValueInput>;
  dateValue?: InputMaybe<ScheduleDateValueInput>;
  floatValue?: InputMaybe<ScheduleFloatValueInput>;
  formulaValue?: InputMaybe<ScheduleFormulaValueInput>;
  intervalValue?: InputMaybe<ScheduleIntervalValueInput>;
  longValue?: InputMaybe<ScheduleLongValueInput>;
  monetaryValue?: InputMaybe<ScheduleMonetaryValueInput>;
  stringValue?: InputMaybe<ScheduleStringValueInput>;
  termValue?: InputMaybe<ScheduleTermValueInput>;
};

export enum SearchEntitiesField {
  Date = 'Date',
  DisplayNumber = 'DisplayNumber',
  Name = 'Name',
  Score = 'Score',
  Type = 'Type',
  Unspecified = 'Unspecified'
}

export type SearchEntitiesSort = {
  ascending: Scalars['Boolean']['input'];
  field: SearchEntitiesField;
};

/** Hit describes a single search result within a result set */
export type SearchHit = {
  /** The search-term highlight offsets within the result contents */
  highlights: Array<HitHighlight>;
  /** The object this search hit references */
  objectId: ObjectIdentifier;
  /** The bleve-assigned score of this result. Uses TDF-IF */
  score: Scalars['Float']['output'];
};

/**
 * Search
 * Result represents a customer-facing set of search results.
 */
export type SearchResult = {
  entities: ObjectEntities;
  kindCounts: Array<ObjectKindFacet>;
  results: Array<SearchHit>;
  tookSecs: Scalars['Float']['output'];
  total: Scalars['Long']['output'];
};

export type Segment = {
  collectionId: Scalars['String']['output'];
  fileId: Scalars['String']['output'];
  fileName?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['Long']['output']>;
  sequence: Scalars['Long']['output'];
  token: Scalars['String']['output'];
};

export type SentInvoiceUsers = {
  invoice: Invoice;
  users?: Maybe<Array<User>>;
};

export enum ShareAction {
  CreateGrant = 'CreateGrant',
  IntentRevoked = 'IntentRevoked',
  Proceed = 'Proceed',
  RequestAccess = 'RequestAccess',
  RequestPending = 'RequestPending',
  Unknown = 'Unknown'
}

export type SharedReportDocumentMetadata = {
  documentObjectId: Scalars['String']['output'];
  documentObjectVersionId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type SignUpEvent = {
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
};

export type Signup = {
  companyCurrency?: Maybe<Scalars['String']['output']>;
  companyLedger?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyUrl?: Maybe<Scalars['String']['output']>;
  contact: Contact;
  id: Scalars['String']['output'];
  industry?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  oAuthEmailAddress?: Maybe<Scalars['String']['output']>;
  oAuthService?: Maybe<Scalars['String']['output']>;
  persona: Persona;
  positionTitle?: Maybe<Scalars['String']['output']>;
  profileURL?: Maybe<Scalars['String']['output']>;
  status: SignupStatus;
  statusReason?: Maybe<Scalars['String']['output']>;
};

export enum SignupStatus {
  Applied = 'Applied',
  Approved = 'Approved',
  Ignored = 'Ignored',
  InviteAccepted = 'InviteAccepted',
  Invited = 'Invited',
  PrimerSent = 'PrimerSent',
  Qualified = 'Qualified',
  Unknown = 'Unknown',
  Unqualified = 'Unqualified',
  Waitlisted = 'Waitlisted'
}

export type SimilarActionItem = {
  id: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export enum SimilarityType {
  Category = 'Category',
  Party = 'Party',
  Unknown = 'Unknown'
}

export type SkipReasonSummary = {
  count: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
};

export enum SortDirection {
  Ascending = 'Ascending',
  Descending = 'Descending'
}

export type SourceAccount = {
  dataSource?: Maybe<EnrichedDataSource>;
  externalId: Scalars['String']['output'];
  externalName?: Maybe<Scalars['String']['output']>;
  externalOfficialName?: Maybe<Scalars['String']['output']>;
  externalOwnerName?: Maybe<Scalars['String']['output']>;
  externalSubtype?: Maybe<Scalars['String']['output']>;
  externalType?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  mask?: Maybe<Scalars['String']['output']>;
  ownerEmployeeId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<SourceAccountStatus>;
};

export type SourceAccountMetric = {
  metrics: Array<SourceAccountMetricSeriesData>;
};

export type SourceAccountMetricConfig = {
  dataSourceId: Scalars['String']['output'];
  key: SourceAccountMetricKey;
  origin: ArchiveIntervalOrigin;
  sourceAccountId: Scalars['String']['output'];
};

export type SourceAccountMetricConfigInput = {
  dataSourceId: Scalars['String']['input'];
  key: SourceAccountMetricKey;
  origin: IntervalOrigin;
  sourceAccountId: Scalars['String']['input'];
};

export type SourceAccountMetricIdentifier = {
  dataSourceId: Scalars['String']['output'];
  key: SourceAccountMetricKey;
  sourceAccountId: Scalars['String']['output'];
};

export enum SourceAccountMetricKey {
  AccountLimit = 'AccountLimit',
  AvailableBalance = 'AvailableBalance',
  CurrentBalance = 'CurrentBalance',
  Headcount = 'Headcount',
  Unknown = 'Unknown'
}

export type SourceAccountMetricPoint = {
  time: Scalars['DateTime']['output'];
  value: Scalars['Long']['output'];
};

export type SourceAccountMetricSeries = {
  identifier: SourceAccountMetricIdentifier;
  points: Array<SourceAccountMetricPoint>;
};

export type SourceAccountMetricSeriesData = {
  iconObjectName?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  series: SourceAccountMetricSeries;
};

export enum SourceAccountStatus {
  Deleted = 'Deleted',
  Disabled = 'Disabled',
  Enabled = 'Enabled',
  UnknownStatus = 'UnknownStatus'
}

/**
 * SourceRecategorizationInput recategorizes the source transaction's named
 * entry line as part of schedule creation. The digits transaction type is
 * read from the source fact server-side.
 */
export type SourceRecategorizationInput = {
  categoryId: Scalars['String']['input'];
  entryType: EntryType;
};

export type SourceRecordedMatchSummary = {
  entries: Array<SourceRecordedMatchSummaryEntry>;
};

export type SourceRecordedMatchSummaryEntry = {
  institution: Institution;
  matched: Scalars['Long']['output'];
  period: Period;
  total: Scalars['Long']['output'];
  unmatched: Scalars['Long']['output'];
  unmatchedAndUncategorized: Scalars['Long']['output'];
};

/** # Bulk CSV Import */
export type StartBulkCsvImportInput = {
  categoryId: Scalars['String']['input'];
  collectionId: Scalars['String']['input'];
  columnMapping: CsvColumnMappingInput;
  documentId: Scalars['String']['input'];
  fileId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};

export type StartBulkCsvImportPayload = {
  workflowId: Scalars['String']['output'];
};

/** # Journal Entries Async Import */
export type StartJournalEntriesImportInput = {
  collectionId: Scalars['String']['input'];
  columnMapping: JournalEntriesColumnMappingInput;
  documentId: Scalars['String']['input'];
  fileId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  /**
   * Client-generated key, one per submit attempt. A bare retry of a failed
   * mutation (same key, same payload) dedupes to the existing workflow.
   * Editing the CSV / column mapping and resubmitting generates a fresh key
   * and gets a new workflow.
   */
  idempotencyKey: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};

export type StartJournalEntriesImportPayload = {
  workflowId: Scalars['String']['output'];
};

export type Statement = {
  kind: ReportKind;
  rows: Array<StatementRow>;
};

export type StatementBalances = {
  closingBalance: MoneyFlow;
  creditTotal?: Maybe<MoneyFlow>;
  debitTotal?: Maybe<MoneyFlow>;
  netTotal: MoneyFlow;
  openingBalance: MoneyFlow;
};

export type StatementConfig = {
  /** @deprecated Unused */
  categoryId?: Maybe<Scalars['String']['output']>;
  kind: ReportKind;
  options?: Maybe<ReportDocumentOptions>;
  origin: ArchiveIntervalOrigin;
};

export type StatementConfigInput = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  kind: ReportKind;
  options?: InputMaybe<ReportDocumentOptionsInput>;
  origin: IntervalOrigin;
};

export type StatementDeltaValue = {
  moneyFlow: MoneyFlow;
  percentageOfAmount: Scalars['Float']['output'];
};

export type StatementDeltas = {
  percentageIncome?: Maybe<StatementDeltaValue>;
  percentageTotal?: Maybe<StatementDeltaValue>;
  previousPeriod?: Maybe<StatementDeltaValue>;
  previousYear?: Maybe<StatementDeltaValue>;
};

export type StatementDetails = {
  hover: Hover;
  insight?: Maybe<Insight>;
};

export type StatementImportIntent = {
  categoryId: Scalars['String']['output'];
  chartOfAccountsId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  documentCollectionId: Scalars['String']['output'];
  documentId: Scalars['String']['output'];
  legalEntityId: Scalars['String']['output'];
  processingEndedAt?: Maybe<Scalars['DateTime']['output']>;
  processingStartedAt?: Maybe<Scalars['DateTime']['output']>;
  state: StatementImportIntentState;
  statementImportIntentId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export enum StatementImportIntentState {
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  DocumentProcessing = 'DocumentProcessing',
  Failed = 'Failed',
  ImportProcessing = 'ImportProcessing',
  InvalidDocument = 'InvalidDocument',
  TransactionInClosedPeriod = 'TransactionInClosedPeriod',
  TransactionPrecutover = 'TransactionPrecutover',
  UnknownState = 'UnknownState'
}

export type StatementLineItem = {
  amount: MonetaryValue;
  date: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  entryType: EntryType;
  featureGroupId: Scalars['String']['output'];
  featureIds: Array<Scalars['String']['output']>;
};

export type StatementLineItemInput = {
  amount: InputMonetaryValue;
  date: Scalars['DateTime']['input'];
  description: Scalars['String']['input'];
  entryType: EntryType;
  featureGroupId: Scalars['String']['input'];
};

export type StatementRow = {
  agingSummary?: Maybe<AgingSummary>;
  agingTitle?: Maybe<StatementRowTitle>;
  deltas?: Maybe<StatementDeltas>;
  depth: Scalars['Int']['output'];
  details?: Maybe<StatementDetails>;
  leafAgingSummary?: Maybe<LeafAgingSummary>;
  leafCategorySummary?: Maybe<StatementRowSummary>;
  parentAgingSummary?: Maybe<AgingSummary>;
  parentAgingTitle?: Maybe<StatementRowTitle>;
  parentCategorySummary?: Maybe<StatementRowSummary>;
  parentCategoryTitle?: Maybe<StatementRowTitle>;
  rowId: Scalars['String']['output'];
  sectionSummary?: Maybe<StatementRowSummary>;
  sectionTitle?: Maybe<StatementRowTitle>;
  ytdDetails?: Maybe<StatementDetails>;
};

export type StatementRowSummary = {
  displayNumber?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  moneyFlow: MoneyFlow;
};

export type StatementRowTitle = {
  displayNumber?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type StatementSummary = {
  summaries: Array<Scalars['String']['output']>;
};

export type StaticMetricConfig = {
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['String']['output'];
};

export type StaticMetricConfigInput = {
  name: Scalars['String']['input'];
  updatedAt: Scalars['DateTime']['input'];
  value: Scalars['String']['input'];
};

/** ## */
export type StatisticByTimeBuckets = {
  bucketFour?: Maybe<Scalars['Long']['output']>;
  bucketOne?: Maybe<Scalars['Long']['output']>;
  bucketThree?: Maybe<Scalars['Long']['output']>;
  bucketTimeMins: Scalars['Long']['output'];
  bucketTwo?: Maybe<Scalars['Long']['output']>;
  name: Scalars['String']['output'];
  total: Scalars['Long']['output'];
};

export type StripeConnectorProperties = {
  appLinkURL: Scalars['String']['output'];
};

export type Subscription = {
  hydratePartyAgent: HydratedParty;
  workflowActivity: WorkflowLogEvent;
  workflowLogEvents: WorkflowLogEvent;
};


export type SubscriptionHydratePartyAgentArgs = {
  value: Scalars['String']['input'];
};


export type SubscriptionWorkflowActivityArgs = {
  legalEntityID: Scalars['String']['input'];
};


export type SubscriptionWorkflowLogEventsArgs = {
  legalEntityID: Scalars['String']['input'];
  workflowID: Scalars['String']['input'];
};

export type SubscriptionDetails = {
  billingCycleEnd: Scalars['DateTime']['output'];
  billingCycleStart: Scalars['DateTime']['output'];
  cancelAt?: Maybe<Scalars['DateTime']['output']>;
  startedAt: Scalars['DateTime']['output'];
  status: BillingSubscriptionStatus;
};

/**
 * Better names for this but are already taken...
 * - BillingPlan
 * - Subscription
 * - BillingSubscription
 *
 * This unfortunately leaves us having to be creative with our name since GQL is all one flat namespace.
 */
export type SubscriptionPlan = {
  price: BillingPrice;
  product: BillingProduct;
};

export type SuggestedConnection = {
  template: ConnectionTemplate;
};

export type SuggestedConnectionsFilter = {
  institutionIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SummarizeInput = {
  direction?: InputMaybe<DirectionFromOrigin>;
  filter: SummaryFilterInput;
  origin?: InputMaybe<IntervalOrigin>;
};

export enum SummaryDimension {
  Aging = 'Aging',
  Category = 'Category',
  CategoryType = 'CategoryType',
  Department = 'Department',
  Location = 'Location',
  Party = 'Party',
  Schedule = 'Schedule',
  Time = 'Time'
}

export type SummaryFilterInput = {
  categoryClassificationSources?: InputMaybe<Array<ClassificationSource>>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  categorySubtypes?: InputMaybe<Array<CategorySubtype>>;
  categoryType?: InputMaybe<CategoryType>;
  categoryTypes?: InputMaybe<Array<CategoryType>>;
  departmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  digitsTransactionTypes?: InputMaybe<Array<TransactionType>>;
  filterTerm?: InputMaybe<Scalars['String']['input']>;
  institutionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ledgerTransactionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  matchedStatuses?: InputMaybe<Array<MatchedStatus>>;
  maxValue?: InputMaybe<InputMonetaryValue>;
  minValue?: InputMaybe<InputMonetaryValue>;
  missingDepartment?: InputMaybe<MissingObject>;
  missingLocation?: InputMaybe<MissingObject>;
  missingParty?: InputMaybe<MissingObject>;
  missingSchedule?: InputMaybe<MissingObject>;
  ownerEmployeeId?: InputMaybe<Scalars['String']['input']>;
  partyEntityTypes?: InputMaybe<Array<PartyEntityType>>;
  partyId?: InputMaybe<Scalars['String']['input']>;
  partyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  partyName?: InputMaybe<Scalars['String']['input']>;
  partyRole?: InputMaybe<PartyRole>;
  partyRoles?: InputMaybe<Array<PartyRole>>;
  productArea?: InputMaybe<ProductArea>;
  reconciliationFilter?: InputMaybe<ReconciliationFilter>;
  scheduleCategoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduleEndDateMax?: InputMaybe<Scalars['DateTime']['input']>;
  scheduleEndDateMin?: InputMaybe<Scalars['DateTime']['input']>;
  scheduleId?: InputMaybe<Scalars['String']['input']>;
  scheduleMaxAmount?: InputMaybe<InputMonetaryValue>;
  scheduleMinAmount?: InputMaybe<InputMonetaryValue>;
  schedulePartyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduleRelatedCategoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduleScope?: InputMaybe<ScheduleScope>;
  scheduleStartDateMax?: InputMaybe<Scalars['DateTime']['input']>;
  scheduleStartDateMin?: InputMaybe<Scalars['DateTime']['input']>;
  scheduleTypes?: InputMaybe<Array<ScheduleType>>;
  taxStatuses?: InputMaybe<Array<TaxStatus>>;
  taxpayerIdentifications?: InputMaybe<Array<TaxpayerIdentification>>;
  useAbsAmount?: InputMaybe<Scalars['Boolean']['input']>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
  viewKey: ViewKey;
  withoutCategoryAncestors?: InputMaybe<Scalars['Boolean']['input']>;
  withoutDepartmentAncestors?: InputMaybe<Scalars['Boolean']['input']>;
  withoutLocationAncestors?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SummaryLineItem {
  GrossProfit = 'GrossProfit',
  NetIncome = 'NetIncome',
  NetOperatingIncome = 'NetOperatingIncome',
  NetOtherIncome = 'NetOtherIncome',
  TotalCash = 'TotalCash'
}

export type SummaryLineItemConfig = {
  item: SummaryLineItem;
  origin: ArchiveIntervalOrigin;
};

export type SummaryLineItemConfigInput = {
  item: SummaryLineItem;
  origin: IntervalOrigin;
};

export type SummaryLineItemHover = {
  history: DimensionSummary;
  lineType: SummaryLineItem;
  missingClass?: Maybe<DimensionSummary>;
  otherClass?: Maybe<DimensionSummary>;
};

export type SummaryTotal = {
  count: Scalars['Long']['output'];
  total: MoneyFlow;
};

export type Superuser = {
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** Not provided in all cases */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  emailAddress: Scalars['String']['output'];
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  /** Basic fields */
  id: Scalars['String']['output'];
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>;
  roles: Array<SuperuserRole>;
};

export type SuperuserRole = {
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  identifier: Scalars['String']['output'];
};

export enum TaxForm {
  Corporation = 'Corporation',
  LimitedLiability = 'LimitedLiability',
  NonprofitOrganization = 'NonprofitOrganization',
  Other = 'Other',
  PartnershipOrLimitedLiability = 'PartnershipOrLimitedLiability',
  SmallBusinessCorporation = 'SmallBusinessCorporation',
  SoleProprietor = 'SoleProprietor',
  UnknownTaxForm = 'UnknownTaxForm'
}

export enum TaxStatus {
  NonTaxable = 'NonTaxable',
  Taxable = 'Taxable',
  Undetermined = 'Undetermined',
  UnspecifiedTaxStatus = 'UnspecifiedTaxStatus'
}

export enum TaxpayerIdentification {
  Available = 'Available',
  NotRequired = 'NotRequired',
  Required = 'Required',
  Undetermined = 'Undetermined',
  UnknownTaxpayerIdentification = 'UnknownTaxpayerIdentification'
}

export type TaxpayerIdentificationInput = {
  partyId: Scalars['String']['input'];
  taxpayerIdentification: TaxpayerIdentification;
};

export type Team = {
  description?: Maybe<Scalars['String']['output']>;
  iconObjectName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  invites: Array<TeamMemberInvite>;
  members: Array<TeamMember>;
  name: Scalars['String']['output'];
};

export type TeamAcl = {
  entities: ObjectEntities;
  grants: Array<ObjectGrant>;
};

export type TeamMember = {
  role: TeamRole;
  user: EntityUser;
};

export type TeamMemberInvite = {
  emailAddress: Scalars['String']['output'];
  role: TeamRole;
};

export enum TeamRole {
  Manager = 'Manager',
  Member = 'Member'
}

export type TemplateCategory = {
  categoryId: Scalars['String']['output'];
  categoryState: CategoryState;
  chartOfAccountsDisplayNumber: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayKey?: Maybe<Scalars['String']['output']>;
  externalAccountSubtype?: Maybe<Scalars['String']['output']>;
  externalAccountType?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  parentCategoryId?: Maybe<Scalars['String']['output']>;
  subtype: CategorySubtype;
  templateId: Scalars['String']['output'];
  type: CategoryType;
};

export enum TermField {
  AmountTerm = 'AmountTerm',
  CanonicalCategoryName = 'CanonicalCategoryName',
  CategoryName = 'CategoryName',
  Description = 'Description',
  FacilitatorName = 'FacilitatorName',
  InstitutionName = 'InstitutionName',
  Name = 'Name',
  PartyName = 'PartyName',
  ProductName = 'ProductName'
}

export type TextComponentConfig = {
  body: Scalars['String']['output'];
  current?: Maybe<ArchiveIntervalOrigin>;
  lookback?: Maybe<ArchiveIntervalOrigin>;
  tags?: Maybe<Array<TextComponentConfigTag>>;
};

export type TextComponentConfigInput = {
  body: Scalars['String']['input'];
  current?: InputMaybe<IntervalOrigin>;
  lookback?: InputMaybe<IntervalOrigin>;
  tags?: InputMaybe<Array<TextComponentConfigTagInput>>;
};

export type TextComponentConfigTag = {
  displayText: Scalars['String']['output'];
  objectId: ObjectIdentifier;
  options?: Maybe<TextTagOptions>;
};

export type TextComponentConfigTagInput = {
  displayText: Scalars['String']['input'];
  objectId: InputObjectIdentifier;
  options?: InputMaybe<TextTagOptionsInput>;
};

export type TextDocument = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  status: ReportPackageDocumentStatus;
  summary: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TextFeatureValue = {
  textValue: Scalars['String']['output'];
};

export type TextTagOptions = {
  partyRole?: Maybe<PartyRole>;
};

export type TextTagOptionsInput = {
  partyRole?: InputMaybe<Scalars['String']['input']>;
};

/** Thread contains the ThreadDetails and associated Comments. */
export type Thread = {
  comments: Array<Comment>;
  details: ThreadDetails;
  id: Scalars['String']['output'];
};

/**
 * ThreadDetails represents metadata about a thread.
 * This type is intended to be read-only and resolved
 * by the backend.
 */
export type ThreadDetails = {
  authorId: Scalars['String']['output'];
  commentCount: Scalars['Long']['output'];
  commenterIds: Array<Scalars['String']['output']>;
  context?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  pending?: Maybe<Scalars['Boolean']['output']>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  tags: Array<ObjectIdentifier>;
  targetObject: ObjectIdentifier;
};

export type ThreadList = {
  targetObject: ObjectIdentifier;
  threads: Array<ThreadDetails>;
};

export type ThreadListWithEntities = {
  entities?: Maybe<ObjectEntities>;
  threads: Array<Thread>;
};

export type ThreadWithEntities = {
  entities?: Maybe<ObjectEntities>;
  thread: Thread;
};

export type Threads = {
  entities?: Maybe<ObjectEntities>;
  threads: Array<ThreadList>;
};

export type TimeDimension = {
  by: DimensionSummary;
  summary: TransactionSummary;
  timestamp: Scalars['Float']['output'];
};

export type TopEntities = {
  entities: DimensionSummary;
};

export type TopEntitiesConfig = {
  categoryType?: Maybe<CategoryType>;
  filteredBy?: Maybe<ObjectIdentifier>;
  kind: ObjectKind;
  limit: Scalars['Int']['output'];
  origin: ArchiveIntervalOrigin;
  partyRole?: Maybe<PartyRole>;
  sort: DimensionSortMode;
};

export type TopEntitiesConfigInput = {
  categoryType?: InputMaybe<CategoryType>;
  filteredBy?: InputMaybe<InputObjectIdentifier>;
  kind: ObjectKind;
  limit: Scalars['Int']['input'];
  origin: IntervalOrigin;
  partyRole?: InputMaybe<PartyRole>;
  sort: DimensionSortMode;
};

export type TopTransactions = {
  partialData: Scalars['Boolean']['output'];
  transactions: Array<EntityTransaction>;
};

export type TopTransactionsConfig = {
  categoryType?: Maybe<CategoryType>;
  filteredBy?: Maybe<ObjectIdentifier>;
  limit: Scalars['Int']['output'];
  origin: ArchiveIntervalOrigin;
  partyRole?: Maybe<PartyRole>;
};

/**
 * INPUTS
 *
 */
export type TopTransactionsConfigInput = {
  categoryType?: InputMaybe<CategoryType>;
  filteredBy?: InputMaybe<InputObjectIdentifier>;
  limit: Scalars['Int']['input'];
  origin: IntervalOrigin;
  partyRole?: InputMaybe<PartyRole>;
};

export type Transaction = {
  compileSource?: Maybe<CompileSource>;
  creditCategoryClassificationProvenance?: Maybe<ClassificationProvenance>;
  creditSources: Array<TransactionSource>;
  debitCategoryClassificationProvenance?: Maybe<ClassificationProvenance>;
  debitSources: Array<TransactionSource>;
  department?: Maybe<EntityDepartment>;
  description?: Maybe<Scalars['String']['output']>;
  digitsTransactionType?: Maybe<TransactionType>;
  displayCanonicalCategoryName?: Maybe<Scalars['String']['output']>;
  displayCategory: Category;
  displayCategoryClassificationProvenance?: Maybe<ClassificationProvenance>;
  displayCategorySource: ClassificationSource;
  /** display* fields for use when a single field is preferred over displaying both debit and credit. */
  displayEntry: DisplayEntry;
  displayInstitution?: Maybe<TransactionParty>;
  displayProductArea?: Maybe<ProductArea>;
  displayUncategorizedReason: UncategorizedReason;
  /** @deprecated Use moneyFlow */
  displayValue?: Maybe<MonetaryValue>;
  facilitatorParty?: Maybe<TransactionParty>;
  factId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use lineItem */
  invoiceLineItem?: Maybe<TransactionInvoiceLineItem>;
  isSupersedingLedgerTransaction: Scalars['Boolean']['output'];
  ledgerTransactionId: Scalars['String']['output'];
  lineItem?: Maybe<TransactionLineItem>;
  location?: Maybe<EntityLocation>;
  matchedLedgerTransactionIds: Array<Scalars['String']['output']>;
  moneyFlow: MoneyFlow;
  name?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<EntityEmployee>;
  ownerSource: ClassificationSource;
  party?: Maybe<TransactionParty>;
  partySource: ClassificationSource;
  product?: Maybe<Product>;
  providerTypes: Array<ProviderType>;
  providers: Array<Provider>;
  reconciliationStatus: TransactionReconciliationStatus;
  recordType: TransactionRecordType;
  recurrence?: Maybe<TransactionRecurrence>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  runningTotal?: Maybe<MoneyFlow>;
  schedule?: Maybe<EntitySchedule>;
  sources: Array<TransactionSource>;
  splitCategory?: Maybe<Category>;
  splitCategoryClassificationProvenance?: Maybe<ClassificationProvenance>;
  splitDepartment?: Maybe<EntityDepartment>;
  splitInstitution?: Maybe<TransactionParty>;
  splitLocation?: Maybe<EntityLocation>;
  splitSchedule?: Maybe<EntitySchedule>;
  supersededFactIds: Array<Scalars['String']['output']>;
  supersededLedgerTransactionIds: Array<Scalars['String']['output']>;
  taxStatus: TaxStatus;
  /** @deprecated unpopulated */
  threadDetails?: Maybe<Array<ThreadDetails>>;
  timestamp: Scalars['DateTime']['output'];
  transactionClassificationType?: Maybe<TransactionClassificationType>;
  viewId: Scalars['String']['output'];
};

export type TransactionCategorySuggestions = {
  categorySuggestions: Array<CategorySuggestion>;
  transactionFactId: Scalars['String']['output'];
};

export enum TransactionClassification {
  Credit = 'Credit',
  Debit = 'Debit'
}

export enum TransactionClassificationType {
  ACH = 'ACH',
  ATM = 'ATM',
  AccountsPayable = 'AccountsPayable',
  Charge = 'Charge',
  Check = 'Check',
  DebitCard = 'DebitCard',
  DirectDeposit = 'DirectDeposit',
  ExpenseReport = 'ExpenseReport',
  OnlineTransfer = 'OnlineTransfer',
  Transfer = 'Transfer',
  UnspecifiedTransactionClassificationType = 'UnspecifiedTransactionClassificationType',
  Wire = 'Wire'
}

export enum TransactionColumnName {
  AbsoluteAmount = 'AbsoluteAmount',
  Amount = 'Amount',
  Category = 'Category',
  Department = 'Department',
  Description = 'Description',
  FirstRecurredAt = 'FirstRecurredAt',
  Location = 'Location',
  Name = 'Name',
  OccurredAt = 'OccurredAt',
  Party = 'Party',
  ReconciliationStatus = 'ReconciliationStatus',
  RecurrenceInterval = 'RecurrenceInterval',
  SplitCategory = 'SplitCategory',
  SplitDepartment = 'SplitDepartment',
  SplitLocation = 'SplitLocation'
}

export type TransactionCounts = {
  reconciled: Scalars['Int']['output'];
  unsettled: Scalars['Int']['output'];
};

export type TransactionDiscountLineItem = {
  appliesToTransactionFactId: Scalars['String']['output'];
  description: Scalars['String']['output'];
  discount?: Maybe<TransactionInvoiceLineItemDiscount>;
  fixedAmount?: Maybe<MonetaryValue>;
  name: Scalars['String']['output'];
  variablePercentage: Scalars['Long']['output'];
};

export type TransactionEntry = {
  amount: MonetaryValue;
  description: Scalars['String']['output'];
  externalLineId: Scalars['String']['output'];
  factId: Scalars['String']['output'];
};

export type TransactionEntryLine = {
  category: Category;
  categoryClassificationProvenance?: Maybe<ClassificationProvenance>;
  description?: Maybe<Scalars['String']['output']>;
  factId?: Maybe<Scalars['String']['output']>;
  highlighted: Scalars['Boolean']['output'];
  isCredit: Scalars['Boolean']['output'];
  lineId: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  value: MonetaryValue;
};

/** Facet input types and enums */
export type TransactionFacetField = {
  kind: TransactionFacetKind;
  type: FacetType;
};

export enum TransactionFacetKind {
  TransactionDepartment = 'TransactionDepartment',
  TransactionLocation = 'TransactionLocation',
  TransactionMatchedStatus = 'TransactionMatchedStatus',
  TransactionNewParty = 'TransactionNewParty',
  TransactionParty = 'TransactionParty',
  TransactionSourceInstitution = 'TransactionSourceInstitution',
  TransactionSourceUser = 'TransactionSourceUser',
  UnknownTransactionKind = 'UnknownTransactionKind'
}

export type TransactionFactEntryType = {
  entryType: EntryType;
  transactionFactId: Scalars['String']['input'];
};

export type TransactionFilter = {
  canonicalCategoryType?: InputMaybe<CanonicalCategoryType>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryName?: InputMaybe<Scalars['String']['input']>;
  categorySubtypes?: InputMaybe<Array<CategorySubtype>>;
  categoryType?: InputMaybe<CategoryType>;
  categoryTypes?: InputMaybe<Array<CategoryType>>;
  classification?: InputMaybe<TransactionClassification>;
  dataSourceId?: InputMaybe<Scalars['String']['input']>;
  departmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  digitsTransactionTypes?: InputMaybe<Array<TransactionType>>;
  doubleEntry?: InputMaybe<DoubleEntry>;
  fieldFilterTerm?: InputMaybe<FieldFilterTermInput>;
  filterTerm?: InputMaybe<Scalars['String']['input']>;
  handleNone?: InputMaybe<HandleNone>;
  institutionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<TransactionKind>;
  ledgerTransactionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  linkedObjectId?: InputMaybe<Scalars['String']['input']>;
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  matchedStatuses?: InputMaybe<Array<MatchedStatus>>;
  maxValue?: InputMaybe<InputMonetaryValue>;
  minValue?: InputMaybe<InputMonetaryValue>;
  missingDepartment?: InputMaybe<MissingObject>;
  missingLocation?: InputMaybe<MissingObject>;
  missingParty?: InputMaybe<MissingObject>;
  missingSchedule?: InputMaybe<MissingObject>;
  occurredAfter?: InputMaybe<Scalars['Float']['input']>;
  occurredBefore?: InputMaybe<Scalars['Float']['input']>;
  ownerEmployeeId?: InputMaybe<Scalars['String']['input']>;
  partyEntityTypes?: InputMaybe<Array<PartyEntityType>>;
  partyId?: InputMaybe<Scalars['String']['input']>;
  partyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  partyName?: InputMaybe<Scalars['String']['input']>;
  partyRole?: InputMaybe<PartyRole>;
  partyRoles?: InputMaybe<Array<PartyRole>>;
  productArea?: InputMaybe<ProductArea>;
  reconciliation?: InputMaybe<Reconciliation>;
  reconciliationFilter?: InputMaybe<ReconciliationFilter>;
  recurrenceInterval?: InputMaybe<Interval>;
  recurrenceStatus?: InputMaybe<TransactionFilterRecurrenceStatus>;
  recurringThreadId?: InputMaybe<Scalars['String']['input']>;
  referenceTransactionId?: InputMaybe<Scalars['String']['input']>;
  scheduleId?: InputMaybe<Scalars['String']['input']>;
  scheduleTypes?: InputMaybe<Array<ScheduleType>>;
  sourceAccountId?: InputMaybe<Scalars['String']['input']>;
  taxStatuses?: InputMaybe<Array<TaxStatus>>;
  taxpayerIdentifications?: InputMaybe<Array<TaxpayerIdentification>>;
  useAbsAmount?: InputMaybe<Scalars['Boolean']['input']>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
  viewKey: ViewKey;
  withoutCategoryAncestors?: InputMaybe<Scalars['Boolean']['input']>;
  withoutDepartmentAncestors?: InputMaybe<Scalars['Boolean']['input']>;
  withoutLocationAncestors?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum TransactionFilterRecurrenceStatus {
  AllRecurring = 'AllRecurring',
  Occurred = 'Occurred'
}

export type TransactionGroup = {
  category: Category;
  description?: Maybe<Scalars['String']['output']>;
  groupId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  party?: Maybe<TransactionParty>;
  timestamp: Scalars['DateTime']['output'];
  totalAmount: MoneyFlow;
  transactions: Array<Transaction>;
};

export type TransactionInvoiceLineItem = {
  value: TransactionInvoiceLineItemKind;
};

export type TransactionInvoiceLineItemDiscount = {
  description: Scalars['String']['output'];
  discountId: Scalars['String']['output'];
  fixedAmount?: Maybe<MonetaryValue>;
  name: Scalars['String']['output'];
  variablePercentage: Scalars['Long']['output'];
};

export type TransactionInvoiceLineItemKind = TransactionDiscountLineItem | TransactionProductLineItem;

export type TransactionInvoiceLineItemProduct = {
  category?: Maybe<Category>;
  department?: Maybe<EntityDepartment>;
  description: Scalars['String']['output'];
  location?: Maybe<EntityLocation>;
  name: Scalars['String']['output'];
  productId: Scalars['String']['output'];
  unitPrice?: Maybe<MonetaryValue>;
};

export enum TransactionKind {
  Deposit = 'Deposit',
  Expense = 'Expense',
  Invoice = 'Invoice',
  Journal = 'Journal',
  Payment = 'Payment',
  Transfer = 'Transfer'
}

export type TransactionLine = {
  category: EntityCategory;
  categoryClassificationProvenance?: Maybe<ClassificationProvenance>;
  department?: Maybe<EntityDepartment>;
  entry: TransactionEntry;
  entryType: EntryType;
  location?: Maybe<EntityLocation>;
  party?: Maybe<EntityParty>;
  schedule?: Maybe<EntitySchedule>;
};

export type TransactionLineItem = {
  value: TransactionLineItemKind;
};

export type TransactionLineItemDiscount = {
  description: Scalars['String']['output'];
  discountId: Scalars['String']['output'];
  fixedAmount?: Maybe<MonetaryValue>;
  name: Scalars['String']['output'];
  variablePercentage: Scalars['Long']['output'];
};

export type TransactionLineItemKind = TransactionDiscountLineItem | TransactionProductLineItem;

export type TransactionLineItemProduct = {
  category?: Maybe<Category>;
  department?: Maybe<EntityDepartment>;
  description: Scalars['String']['output'];
  location?: Maybe<EntityLocation>;
  name: Scalars['String']['output'];
  productId: Scalars['String']['output'];
  unitPrice?: Maybe<MonetaryValue>;
};

/** Transactions */
export type TransactionOrder = {
  transactionOrderPairs: Array<TransactionOrderPair>;
};

export type TransactionOrderPair = {
  columnName: TransactionColumnName;
  direction: SortDirection;
};

export type TransactionParty = {
  designation: PartyDesignation;
  iconObjectName?: Maybe<Scalars['String']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  roles?: Maybe<Array<PartyRole>>;
};

export type TransactionProductLineItem = {
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  product?: Maybe<TransactionInvoiceLineItemProduct>;
  quantity: Scalars['Float']['output'];
  unitPrice?: Maybe<MonetaryValue>;
};

export type TransactionReconciliation = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** creator/created and updater/updatedAt are null when it was auto-reconciled/auto-unsettled */
  creator?: Maybe<EntityUser>;
  status: TransactionReconciliationStatus;
  transaction: Transaction;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updater?: Maybe<EntityUser>;
};

export type TransactionReconciliationClassification = {
  classificationVersion: TransactionReconciliationClassificationVersion;
  transactionFactId: Scalars['String']['output'];
  user: EntityUser;
};

export enum TransactionReconciliationClassificationVersion {
  DataSource = 'DataSource',
  PostStatementManual = 'PostStatementManual',
  PreStatementManual = 'PreStatementManual',
  SystemReconciliation = 'SystemReconciliation',
  Unknown = 'Unknown'
}

export enum TransactionReconciliationStatus {
  Reconciled = 'Reconciled',
  Unknown = 'Unknown',
  Unsettled = 'Unsettled'
}

export enum TransactionRecordType {
  ExpectedTransaction = 'ExpectedTransaction',
  Journal = 'Journal',
  MissedTransaction = 'MissedTransaction',
  Transaction = 'Transaction',
  UnknownRecordType = 'UnknownRecordType',
  UnreconciledSourceTransaction = 'UnreconciledSourceTransaction'
}

export type TransactionRecurrence = {
  firstOccurredAt: Scalars['DateTime']['output'];
  interval: Interval;
  intervalMultiplier: Scalars['Long']['output'];
  isHidden: Scalars['Boolean']['output'];
  lastOccurredAt: Scalars['DateTime']['output'];
  recurrenceThreadId: Scalars['String']['output'];
  threadIndex: Scalars['Long']['output'];
  totalThreadCount: Scalars['Long']['output'];
};

export type TransactionReviewQuestion = {
  createdAt: Scalars['DateTime']['output'];
  question: Scalars['String']['output'];
};

export type TransactionReviewReminderMessage = {
  legalEntityId: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type TransactionReviewSchedule = {
  daysOfMonth?: Maybe<Array<DayOfMonth>>;
  daysOfWeek?: Maybe<Array<DayOfWeek>>;
  enabled: Scalars['Boolean']['output'];
  legalEntityId: Scalars['String']['output'];
};

export type TransactionSource = {
  account?: Maybe<TransactionSourceAccount>;
  externalDisplayId?: Maybe<Scalars['String']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  type: TransactionSourceType;
};

export type TransactionSourceAccount = {
  externalName?: Maybe<Scalars['String']['output']>;
  externalOfficialName?: Maybe<Scalars['String']['output']>;
  externalOwnerName?: Maybe<Scalars['String']['output']>;
  mask?: Maybe<Scalars['String']['output']>;
  sourceAccountId: Scalars['String']['output'];
};

export enum TransactionSourceType {
  CSVImport = 'CSVImport',
  Institution = 'Institution',
  Unknown = 'Unknown',
  User = 'User'
}

export type TransactionSummary = {
  isPeriodBookClosed: Scalars['Boolean']['output'];
  period: Period;
  total: PeriodMonetaryValue;
};

/** Transaction Editing */
export enum TransactionType {
  BankTransfer = 'BankTransfer',
  Bill = 'Bill',
  Invoice = 'Invoice',
  JournalEntry = 'JournalEntry',
  PayIn = 'PayIn',
  PayOut = 'PayOut',
  Unknown = 'Unknown'
}

export type TransactionViewDetail = {
  creditAmount?: Maybe<MonetaryValue>;
  creditCategoryHierarchy: Array<Category>;
  debitAmount?: Maybe<MonetaryValue>;
  /** First node is the top most parent of the hierarchy */
  debitCategoryHierarchy: Array<Category>;
  description?: Maybe<Scalars['String']['output']>;
  /** First node is the top most parent of the hierarchy */
  entryLines: Array<TransactionEntryLine>;
  externalCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  externalDisplayId?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  factId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  institution: Institution;
  name?: Maybe<Scalars['String']['output']>;
  occurredAt: Scalars['DateTime']['output'];
  party?: Maybe<TransactionParty>;
  quickbooksAppName?: Maybe<Scalars['String']['output']>;
  recordType: TransactionRecordType;
  sourceAccount?: Maybe<SourceAccount>;
};

export type TransactionViewDetails = {
  details: Array<TransactionViewDetail>;
};

/** Transaction Details */
export type TransactionWithDetails = {
  details: Array<TransactionViewDetail>;
  isInBooksClosedPeriod?: Maybe<Scalars['Boolean']['output']>;
  transaction: Transaction;
};

export type TrialBalance = {
  categories: Array<EntityCategory>;
  rows: Array<TrialBalanceRow>;
};

export type TrialBalanceRow = {
  credits: MonetaryValue;
  debits: MonetaryValue;
  name: Scalars['String']['output'];
  rowId: Scalars['String']['output'];
};

export type TriggerClassificationManifestResponse = {
  manifestId: Scalars['String']['output'];
  transactionCount: Scalars['Int']['output'];
};

/** UUID Search */
export enum UuidEntityType {
  Connection = 'Connection',
  Connector = 'Connector',
  DataSource = 'DataSource',
  LegalEntity = 'LegalEntity',
  Organization = 'Organization',
  User = 'User'
}

export type UuidSearchResult = {
  connection?: Maybe<AdminConnection>;
  connector?: Maybe<AdminConnector>;
  dataSource?: Maybe<OwnedDataSource>;
  entityType: UuidEntityType;
  legalEntity?: Maybe<AdminLegalEntity>;
  organization?: Maybe<AdminOrganization>;
  user?: Maybe<AdminUser>;
};

export enum UncategorizedReason {
  New = 'New',
  None = 'None',
  /** @deprecated No longer used */
  Split = 'Split'
}

export type UnsupportedTransaction = {
  accountAlias: Scalars['String']['output'];
  dataType: Scalars['String']['output'];
  fetchId: Scalars['String']['output'];
  fetchType: FetchType;
  providerType: ProviderType;
  reason: Scalars['String']['output'];
  transactionCount: Scalars['Long']['output'];
};

export type UnsupportedTransactions = {
  onboardUnsupportedTransactions: Array<UnsupportedTransaction>;
  otherUnsupportedTransactions: Array<UnsupportedTransaction>;
};

export enum UpdatableEmployeeField {
  AvatarUrl = 'AvatarUrl',
  DefaultEntityRole = 'DefaultEntityRole',
  EmailAddress = 'EmailAddress',
  FamilyName = 'FamilyName',
  GivenName = 'GivenName',
  Hidden = 'Hidden',
  JobTitle = 'JobTitle',
  Role = 'Role'
}

export type UpdateAuditRule = {
  amountFilters?: InputMaybe<Array<InputAmountRuleFilter>>;
  auditRuleId: Scalars['String']['input'];
  auditRuleName: Scalars['String']['input'];
  categoryFilters?: InputMaybe<Array<InputCategoryRuleFilter>>;
  deletedAmountFilters?: InputMaybe<Array<DeletedAmountFilter>>;
  deletedCategories?: InputMaybe<Array<DeletedCategory>>;
  deletedCategoryFilters?: InputMaybe<Array<DeletedCategoryFilter>>;
  deletedPartyFilterIds?: InputMaybe<Array<Scalars['String']['input']>>;
  deletedPartyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  partyFilters?: InputMaybe<Array<InputPartyRuleFilter>>;
  ruleState: AuditRuleState;
};

export type UpdateDepartmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayKey?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentId: Scalars['String']['input'];
};

export type UpdateDepartmentResponse = {
  departmentId: Scalars['String']['output'];
};

export type UpdateLocationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayKey?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentId: Scalars['String']['input'];
};

export type UpdateLocationResponse = {
  locationId: Scalars['String']['output'];
};

export type UpdateReconciliationFlagTransactionDateInput = {
  date: Scalars['DateTime']['input'];
  featureGroupId: Scalars['String']['input'];
  flagId: Scalars['String']['input'];
  ledgerTransactionId: Scalars['String']['input'];
};

export type UpdateUserLegalEntityRoleEntry = {
  legalEntityId: Scalars['String']['input'];
  role: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UploadBankFeedResponse = {
  transactionFactIds: Array<Scalars['String']['output']>;
};

export type UploadJournalEntriesResponse = {
  transactionFactIds: Array<Scalars['String']['output']>;
};

export type User = {
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  employments?: Maybe<Array<OrganizationEmployment>>;
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  identities?: Maybe<Array<Identity>>;
  lastActivityAt: Scalars['DateTime']['output'];
  /** Timestamp when the user activated an MFA factor (e.g. TOTP). Null when no factor is enrolled. */
  mfaEnforcedAt?: Maybe<Scalars['DateTime']['output']>;
  passwordSet: Scalars['Boolean']['output'];
  primaryEmailAddress: Scalars['String']['output'];
};

export type UserAcl = {
  entities: ObjectEntities;
  grants: Array<ObjectGrant>;
  intents: Array<ObjectIntent>;
  requests: Array<ObjectRequest>;
};

export type UserAssignee = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type UserContact = {
  avatarUrl?: Maybe<Scalars['String']['output']>;
  emailAddress: Scalars['String']['output'];
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type UserFacet = {
  count: Scalars['Int']['output'];
  userObject: EntityUser;
};

export type UserGrant = {
  grantId: Scalars['String']['output'];
  permission: Permission;
  userId: Scalars['String']['output'];
};

export type UserInfo = {
  emailAddress: Scalars['String']['output'];
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
};

export type UserIntent = {
  emailAddress: Scalars['String']['output'];
  intentId: Scalars['String']['output'];
  permission: Permission;
};

export type UserLegalEntityRoleDelete = {
  legalEntityId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UserRequest = {
  requestId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type ValidationHealthStatus = {
  balanceSheetConsistent: HealthStatus;
  cashAspectHealth: AspectDataHealth;
  expenseAspectHealth: AspectDataHealth;
  revenueAspectHealth: AspectDataHealth;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ValidationHistory = {
  validationHistory: Array<ValidationHealthStatus>;
};

export type ValidationPeriodSummary = {
  matchedCategories: Scalars['Long']['output'];
  mismatchedCategories: Scalars['Long']['output'];
  noExternalValueMismatchedCategories: Scalars['Long']['output'];
  period: Period;
};

/** Validation */
export type ValidationSummary = {
  periodSummaries: Array<ValidationPeriodSummary>;
};

export enum VerificationRequestDestination {
  AIAccounting = 'AIAccounting',
  Bill = 'Bill',
  Developer = 'Developer',
  ProspectFirm = 'ProspectFirm',
  Share = 'Share',
  Unspecified = 'Unspecified'
}

export type ViewGenerationSummary = {
  bucketFour?: Maybe<Scalars['Long']['output']>;
  bucketOne?: Maybe<Scalars['Long']['output']>;
  bucketThree?: Maybe<Scalars['Long']['output']>;
  bucketTimeMins?: Maybe<Scalars['Long']['output']>;
  bucketTwo?: Maybe<Scalars['Long']['output']>;
};

export type ViewIdentifier = {
  legalEntityId: Scalars['String']['output'];
  mutationVersion?: Maybe<Scalars['String']['output']>;
  viewType: ViewType;
  viewVersion: Scalars['String']['output'];
};

export type ViewIdentifierInput = {
  legalEntityId: Scalars['String']['input'];
  mutationVersion?: InputMaybe<Scalars['String']['input']>;
  viewType: ViewType;
  viewVersion: Scalars['String']['input'];
};

export type ViewInvoiceSummary = {
  creditCardsEnabled: Scalars['Boolean']['output'];
  invoice: PublicInvoice;
  invoicePaymentDetails?: Maybe<InvoicePaymentDetails>;
  isPayable: Scalars['Boolean']['output'];
  useNewPaymentProvider: Scalars['Boolean']['output'];
};

export type ViewKey = {
  legalEntityId: Scalars['String']['input'];
  mutationVersion?: InputMaybe<Scalars['String']['input']>;
  viewType?: InputMaybe<ViewType>;
  viewVersion?: InputMaybe<Scalars['String']['input']>;
};

export type ViewMetadata = {
  firstTransactionTimestamp: Scalars['DateTime']['output'];
  latestTransactionTimestamp?: Maybe<Scalars['DateTime']['output']>;
  legalEntityId: Scalars['String']['output'];
  viewType?: Maybe<ViewType>;
  viewVersion?: Maybe<Scalars['String']['output']>;
};

export enum ViewType {
  AIBookkeeper = 'AIBookkeeper',
  Ledger = 'Ledger',
  Unknown = 'Unknown'
}

/** Notifications */
export type WebNotification = {
  assetLink?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  displayKey: Scalars['String']['output'];
  eventType: EventType;
  id: Scalars['String']['output'];
  legalEntityId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: WebNotificationStatus;
  targetAction: Scalars['String']['output'];
};

export enum WebNotificationStatus {
  DelayedDelivered = 'DelayedDelivered',
  Dismissed = 'Dismissed',
  Enqueued = 'Enqueued',
  Read = 'Read',
  Received = 'Received',
  UnknownStatus = 'UnknownStatus'
}

export type WorkItem = {
  actionable: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  generatedQuestions: Array<WorkItemGeneratedQuestion>;
  itemState: WorkItemState;
  itemType: WorkItemType;
  ledgerType: LedgerType;
  legalEntityId: Scalars['String']['output'];
  pushes: Array<WorkItemPush>;
  review?: Maybe<WorkItemReview>;
  reviewState?: Maybe<WorkItemReviewState>;
  time: Scalars['DateTime']['output'];
  transactions: Array<WorkItemTransaction>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** TODO: Hydrate user. */
  updatedBy?: Maybe<Scalars['String']['output']>;
  workItemId: Scalars['String']['output'];
};

export type WorkItemBadgeCountFilter = {
  itemStates?: InputMaybe<Array<WorkItemState>>;
  itemTypes?: InputMaybe<Array<WorkItemType>>;
  ledgerType?: InputMaybe<LedgerType>;
  legalEntityIds: Array<Scalars['String']['input']>;
  reviewStatesFilter?: InputMaybe<WorkItemReviewStatesFilter>;
};

export enum WorkItemErrorType {
  DuplicateVendor = 'DuplicateVendor',
  NoError = 'NoError',
  NotSupported = 'NotSupported',
  Other = 'Other',
  PeriodClosed = 'PeriodClosed'
}

export type WorkItemFilter = {
  excludedReviewStates?: InputMaybe<Array<WorkItemReviewState>>;
  itemStates?: InputMaybe<Array<WorkItemState>>;
  ledgerType?: InputMaybe<LedgerType>;
  legalEntityId: Scalars['String']['input'];
  reviewStates?: InputMaybe<Array<WorkItemReviewState>>;
  types?: InputMaybe<Array<WorkItemType>>;
};

export type WorkItemGeneratedQuestion = {
  active: Scalars['Boolean']['output'];
  contextType: WorkItemGeneratedQuestionContextType;
  question: Scalars['String']['output'];
};

export enum WorkItemGeneratedQuestionContextType {
  AccountantSpecific = 'AccountantSpecific',
  Direct = 'Direct',
  Friendly = 'Friendly'
}

export type WorkItemPush = {
  errorType?: Maybe<WorkItemErrorType>;
  field: WorkItemPushFieldType;
  pushState: WorkItemPushState;
  updatedAt: Scalars['DateTime']['output'];
};

export enum WorkItemPushFieldType {
  Category = 'Category',
  LineDescription = 'LineDescription',
  Memo = 'Memo',
  Party = 'Party',
  UnknownFieldType = 'UnknownFieldType'
}

export type WorkItemPushParams = {
  appendCommentsToQBO?: InputMaybe<Scalars['Boolean']['input']>;
  categoryParams?: InputMaybe<CategoryParams>;
  partyParams?: InputMaybe<PartyParams>;
  skipClose?: InputMaybe<Scalars['Boolean']['input']>;
  workItemId: Scalars['String']['input'];
};

export enum WorkItemPushState {
  Error = 'Error',
  Ignored = 'Ignored',
  Pushed = 'Pushed',
  UnknownState = 'UnknownState'
}

export type WorkItemResponse = {
  responseText?: InputMaybe<Scalars['String']['input']>;
  workItemId: Scalars['String']['input'];
};

export type WorkItemReview = {
  createdAt: Scalars['DateTime']['output'];
  creator: EntityUser;
  subject: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum WorkItemReviewState {
  ClientResponded = 'ClientResponded',
  PendingClientResponse = 'PendingClientResponse'
}

export type WorkItemReviewStatesFilter = {
  includeNullReviewState?: InputMaybe<Scalars['Boolean']['input']>;
  reviewStates?: InputMaybe<Array<WorkItemReviewState>>;
};

export enum WorkItemState {
  Accepted = 'Accepted',
  Active = 'Active',
  Completed = 'Completed',
  Invalidated = 'Invalidated',
  UnknownState = 'UnknownState'
}

export type WorkItemSubject = {
  saveAsTemplate: Scalars['Boolean']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  workItemId: Scalars['String']['input'];
};

export type WorkItemSummary = {
  count: Scalars['Long']['output'];
  period: Period;
};

export enum WorkItemSupportType {
  Context = 'Context',
  From = 'From',
  Object = 'Object',
  ObjectHighlight = 'ObjectHighlight',
  ResponseBasedPrediction = 'ResponseBasedPrediction',
  To = 'To',
  UnknownSupportType = 'UnknownSupportType',
  UserProvided = 'UserProvided'
}

export type WorkItemTransaction = {
  creditValue?: Maybe<MonetaryValue>;
  dataSourceId?: Maybe<Scalars['String']['output']>;
  debitValue?: Maybe<MonetaryValue>;
  description?: Maybe<Scalars['String']['output']>;
  displayCategory?: Maybe<EntityCategory>;
  displayEntry: DisplayEntry;
  displayPartyRole: PartyRole;
  /** @deprecated Use moneyFlow instead. */
  displayValue?: Maybe<MonetaryValue>;
  externalTransactionId: Scalars['String']['output'];
  externalTransactionLineId?: Maybe<Scalars['String']['output']>;
  ledgerTransactionId?: Maybe<Scalars['String']['output']>;
  moneyFlow?: Maybe<MoneyFlow>;
  name?: Maybe<Scalars['String']['output']>;
  occurredAt?: Maybe<Scalars['DateTime']['output']>;
  party?: Maybe<EntityParty>;
  quickbooksAppName?: Maybe<Scalars['String']['output']>;
  splitCategory?: Maybe<EntityCategory>;
  supportType: WorkItemSupportType;
};

export enum WorkItemType {
  HighConfidenceCategory = 'HighConfidenceCategory',
  HighConfidenceVendor = 'HighConfidenceVendor',
  InParentCategory = 'InParentCategory',
  PII = 'PII',
  UnassignedCategory = 'UnassignedCategory',
  UnassignedVendor = 'UnassignedVendor',
  UnknownType = 'UnknownType'
}

export type WorkItemValidation = {
  status: WorkItemValidationStatus;
  workItemCount: Scalars['Long']['output'];
};

export enum WorkItemValidationStatus {
  Pending = 'Pending',
  Unknown = 'Unknown',
  Valid = 'Valid'
}

export type Workflow = {
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  definitionName: Scalars['String']['output'];
  definitionVersion: Scalars['Int']['output'];
  error: Scalars['String']['output'];
  /**
   * null for rows that predate type-name persistence; callers should skip the
   * decode query for those rows since it will return a legacy-row decodeError.
   */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  legalEntityID: Scalars['String']['output'];
  outputTypeName?: Maybe<Scalars['String']['output']>;
  status: WorkflowStatus;
  updatedAt: Scalars['DateTime']['output'];
  workflowID: Scalars['String']['output'];
};

export type WorkflowDetail = {
  futures: Array<WorkflowFuture>;
  workflow: Workflow;
};

export type WorkflowFuture = {
  createdAt: Scalars['DateTime']['output'];
  deadline?: Maybe<Scalars['DateTime']['output']>;
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  futureID: Scalars['String']['output'];
  kind: FutureKind;
  regionPath: Scalars['String']['output'];
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  status: FutureStatus;
};

export type WorkflowLogEntry = {
  actionID: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  errorMessage: Scalars['String']['output'];
  eventKind: WorkflowLogEventKind;
  legalEntityID: Scalars['String']['output'];
  regionPath: Scalars['String']['output'];
  /** null for rows that predate type-name persistence; see Workflow.inputTypeName. */
  resultTypeName?: Maybe<Scalars['String']['output']>;
  workflowID: Scalars['String']['output'];
  workflowLogID: Scalars['String']['output'];
};

export type WorkflowLogEvent = {
  actionID: Scalars['String']['output'];
  definitionName: Scalars['String']['output'];
  errorMessage: Scalars['String']['output'];
  eventKind: WorkflowLogEventKind;
  legalEntityID: Scalars['String']['output'];
  regionPath: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  workflowID: Scalars['String']['output'];
  workflowLogID: Scalars['String']['output'];
};

export enum WorkflowLogEventKind {
  CompensationCompleted = 'CompensationCompleted',
  CompensationFailed = 'CompensationFailed',
  CompensationRequested = 'CompensationRequested',
  CompensationStarted = 'CompensationStarted',
  FutureCreated = 'FutureCreated',
  FutureRaced = 'FutureRaced',
  FutureResolved = 'FutureResolved',
  RegionCompleted = 'RegionCompleted',
  RegionFailed = 'RegionFailed',
  RegionStarted = 'RegionStarted',
  SignalRaced = 'SignalRaced',
  StepCompleted = 'StepCompleted',
  StepFailed = 'StepFailed',
  StepRetried = 'StepRetried',
  StepSkipped = 'StepSkipped',
  StepStarted = 'StepStarted',
  Unspecified = 'Unspecified',
  WorkflowCompensated = 'WorkflowCompensated',
  WorkflowCompensating = 'WorkflowCompensating',
  WorkflowCompleted = 'WorkflowCompleted',
  WorkflowFailed = 'WorkflowFailed',
  WorkflowPartiallyCompensated = 'WorkflowPartiallyCompensated',
  WorkflowStarted = 'WorkflowStarted',
  WorkflowSuspended = 'WorkflowSuspended'
}

/**
 * Workflow user notifications and status indicators.
 *
 * When `bearerUpdated` is true and the event carries no user-facing payload
 * (a pure bearer-reissue signal), `message`, `targetAction`, and
 * `workflowNotificationID` may all be empty strings / null. Clients that
 * render notifications should gate on a non-empty `message` before showing
 * a toast.
 */
export type WorkflowNotificationEvent = {
  /**
   * Signals that the client must reissue its bearer token. Transient —
   * carried only on the live event; not reconstructible from history.
   * May arrive with an empty `message` when no user-facing toast is
   * warranted (silent refresh).
   */
  bearerUpdated: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  definitionName: Scalars['String']['output'];
  kind: WorkflowNotificationKind;
  message: Scalars['String']['output'];
  notificationType: WorkflowNotificationType;
  targetAction?: Maybe<Scalars['String']['output']>;
  workflowID: Scalars['String']['output'];
  workflowNotificationID: Scalars['String']['output'];
};

export enum WorkflowNotificationKind {
  Error = 'Error',
  Info = 'Info',
  Success = 'Success',
  UnspecifiedKind = 'UnspecifiedKind',
  Warning = 'Warning'
}

export enum WorkflowNotificationType {
  Notification = 'Notification',
  Status = 'Status',
  UnspecifiedType = 'UnspecifiedType'
}

/**
 * WorkflowPayload is the shared shape returned by the on-demand decode RPCs.
 * On success, json is populated and decodeError is null; on failure (legacy row,
 * oversize, unknown type, unmarshal error) decodeError carries a human-readable
 * message and json is null. bytesSize is always set when the payload exists;
 * zero indicates an empty proto.
 */
export type WorkflowPayload = {
  bytesSize?: Maybe<Scalars['Int']['output']>;
  decodeError?: Maybe<Scalars['String']['output']>;
  json?: Maybe<Scalars['String']['output']>;
  typeName?: Maybe<Scalars['String']['output']>;
};

export enum WorkflowStatus {
  Compensated = 'Compensated',
  Compensating = 'Compensating',
  Completed = 'Completed',
  Failed = 'Failed',
  PartiallyCompensated = 'PartiallyCompensated',
  Pending = 'Pending',
  Running = 'Running',
  Suspended = 'Suspended',
  Unspecified = 'Unspecified'
}

export type AddAffiliatedSubscriptionPriceMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  affiliatedOrganizationId: Scalars['String']['input'];
  affiliatedLegalEntityId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
}>;


export type AddAffiliatedSubscriptionPriceMutation = Pick<Mutation, 'addAffiliatedSubscriptionPrice'>;

export type AttachClientPaysLegalEntityMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  attachmentOrganizationId: Scalars['String']['input'];
}>;


export type AttachClientPaysLegalEntityMutation = Pick<Mutation, 'attachClientPaysLegalEntity'>;

export type AttachLegalEntityMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  attachmentOrganizationId: Scalars['String']['input'];
}>;


export type AttachLegalEntityMutation = Pick<Mutation, 'attachLegalEntity'>;

export type DetachClientPaysClientMutationVariables = Exact<{
  firmOrganizationId: Scalars['String']['input'];
  clientLegalEntityId: Scalars['String']['input'];
  clientOrganizationId: Scalars['String']['input'];
}>;


export type DetachClientPaysClientMutation = Pick<Mutation, 'detachClientPaysClient'>;

export type DetachFirmClientMutationVariables = Exact<{
  firmOrganizationId: Scalars['String']['input'];
  clientLegalEntityId: Scalars['String']['input'];
}>;


export type DetachFirmClientMutation = Pick<Mutation, 'detachFirmClient'>;

export type MigrateFirmClientMutationVariables = Exact<{
  sourceFirmOrganizationId: Scalars['String']['input'];
  targetFirmOrganizationId: Scalars['String']['input'];
  clientLegalEntityId: Scalars['String']['input'];
}>;


export type MigrateFirmClientMutation = Pick<Mutation, 'migrateFirmClient'>;

export type ListAvailablePlansQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type ListAvailablePlansQuery = { listAvailablePlans: Array<{
      product: Pick<
          BillingProduct,
          | 'id'
          | 'name'
          | 'displayName'
          | 'billable'
        >,
      price: Pick<BillingPrice, 'id'>,
    }> };

export type HydratePartyAgentSubscriptionVariables = Exact<{
  value: Scalars['String']['input'];
}>;


export type HydratePartyAgentSubscription = { hydratePartyAgent: { agentEvent?: Maybe<Pick<AgentEvent, 'runStatus' | 'message'>> } };

export type AspectFieldsFragment = Pick<
    Aspect,
    | 'id'
    | 'code'
    | 'name'
    | 'description'
    | 'defaultStatus'
    | 'admin'
    | 'oneWay'
    | 'propagation'
    | 'visibility'
    | 'createdAt'
    | 'updatedAt'
  >;

export type AspectRequestFieldsFragment = (
  Pick<
    AspectRequest,
    | 'id'
    | 'legalEntityId'
    | 'legalEntityName'
    | 'createdAt'
  >
  & { aspect: Pick<
      Aspect,
      | 'id'
      | 'code'
      | 'name'
      | 'description'
      | 'defaultStatus'
      | 'admin'
      | 'oneWay'
      | 'propagation'
      | 'visibility'
      | 'createdAt'
      | 'updatedAt'
    > }
);

export type AspectStatusFieldsFragment = (
  Pick<AspectStatus, 'status' | 'source' | 'updatedAt'>
  & { aspect: Pick<
      Aspect,
      | 'id'
      | 'code'
      | 'name'
      | 'description'
      | 'defaultStatus'
      | 'admin'
      | 'oneWay'
      | 'propagation'
      | 'visibility'
      | 'createdAt'
      | 'updatedAt'
    > }
);

export type LegalEntityAspectStatusFieldsFragment = (
  Pick<LegalEntityAspectStatus, 'legalEntityId' | 'legalEntityName'>
  & { statuses: Array<(
    Pick<AspectStatus, 'status' | 'source' | 'updatedAt'>
    & { aspect: Pick<
        Aspect,
        | 'id'
        | 'code'
        | 'name'
        | 'description'
        | 'defaultStatus'
        | 'admin'
        | 'oneWay'
        | 'propagation'
        | 'visibility'
        | 'createdAt'
        | 'updatedAt'
      > }
  )> }
);

export type AddOrganizationPackageAspectMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  packageId: Scalars['String']['input'];
  aspectId: Scalars['String']['input'];
}>;


export type AddOrganizationPackageAspectMutation = Pick<Mutation, 'addOrganizationPackageAspect'>;

export type ApproveRequestMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ApproveRequestMutation = Pick<Mutation, 'approveRequest'>;

export type DeleteAspectStatusMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  aspectId: Scalars['String']['input'];
}>;


export type DeleteAspectStatusMutation = Pick<Mutation, 'deleteAspectStatus'>;

export type DeleteOrganizationAspectStatusMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  aspectId: Scalars['String']['input'];
}>;


export type DeleteOrganizationAspectStatusMutation = Pick<Mutation, 'deleteOrganizationAspectStatus'>;

export type EnableCategoryManagerMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type EnableCategoryManagerMutation = Pick<Mutation, 'enableCategoryManager'>;

export type RemoveOrganizationPackageAspectMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  packageId: Scalars['String']['input'];
  aspectId: Scalars['String']['input'];
  comment: Scalars['String']['input'];
  contextUrl: Scalars['String']['input'];
}>;


export type RemoveOrganizationPackageAspectMutation = Pick<Mutation, 'removeOrganizationPackageAspect'>;

export type UpdateAspectStatusMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  aspectId: Scalars['String']['input'];
  status: AspectStatusValue;
}>;


export type UpdateAspectStatusMutation = Pick<Mutation, 'updateAspectStatus'>;

export type UpdateOrganizationAspectStatusMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  aspectId: Scalars['String']['input'];
  status: AspectStatusValue;
}>;


export type UpdateOrganizationAspectStatusMutation = Pick<Mutation, 'updateOrganizationAspectStatus'>;

export type ListAspectRequestsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ListAspectRequestsQuery = { listAspectRequests: Array<(
    Pick<
      AspectRequest,
      | 'id'
      | 'legalEntityId'
      | 'legalEntityName'
      | 'createdAt'
    >
    & { aspect: Pick<
        Aspect,
        | 'id'
        | 'code'
        | 'name'
        | 'description'
        | 'defaultStatus'
        | 'admin'
        | 'oneWay'
        | 'propagation'
        | 'visibility'
        | 'createdAt'
        | 'updatedAt'
      > }
  )> };

export type ListAspectStatusesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ListAspectStatusesQuery = { listAspectStatuses: Array<(
    Pick<LegalEntityAspectStatus, 'legalEntityId' | 'legalEntityName'>
    & { statuses: Array<(
      Pick<AspectStatus, 'status' | 'source' | 'updatedAt'>
      & { aspect: Pick<
          Aspect,
          | 'id'
          | 'code'
          | 'name'
          | 'description'
          | 'defaultStatus'
          | 'admin'
          | 'oneWay'
          | 'propagation'
          | 'visibility'
          | 'createdAt'
          | 'updatedAt'
        > }
    )> }
  )> };

export type ListAspectsQueryVariables = Exact<{
  filter?: InputMaybe<Array<AspectFilter> | AspectFilter>;
}>;


export type ListAspectsQuery = { listAspects: Array<Pick<
      Aspect,
      | 'id'
      | 'code'
      | 'name'
      | 'description'
      | 'defaultStatus'
      | 'admin'
      | 'oneWay'
      | 'propagation'
      | 'visibility'
      | 'createdAt'
      | 'updatedAt'
    >> };

export type ListOrganizationAspectStatusesQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type ListOrganizationAspectStatusesQuery = { listOrganizationAspectStatuses: Array<(
    Pick<AspectStatus, 'status' | 'source' | 'updatedAt'>
    & { aspect: Pick<
        Aspect,
        | 'id'
        | 'code'
        | 'name'
        | 'description'
        | 'defaultStatus'
        | 'admin'
        | 'oneWay'
        | 'propagation'
        | 'visibility'
        | 'createdAt'
        | 'updatedAt'
      > }
  )> };

export type ListOrganizationPackageAspectsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  packageId: Scalars['String']['input'];
}>;


export type ListOrganizationPackageAspectsQuery = { listOrganizationPackageAspects: Array<{ aspect: Pick<
        Aspect,
        | 'id'
        | 'code'
        | 'name'
        | 'description'
        | 'defaultStatus'
        | 'admin'
        | 'oneWay'
        | 'propagation'
        | 'visibility'
        | 'createdAt'
        | 'updatedAt'
      > }> };

export type AdminBillingProductFieldsFragment = (
  Pick<AdminBillingProduct, 'isOrganizationEnabled'>
  & { product: Pick<
      BillingProduct,
      | 'id'
      | 'name'
      | 'displayName'
      | 'description'
      | 'callout'
      | 'trialPeriodDays'
      | 'availability'
      | 'listing'
      | 'billable'
    > }
);

export type CreateEnterpriseOrganizationMutationVariables = Exact<{
  name: Scalars['String']['input'];
  comment: Scalars['String']['input'];
  contextUrl: Scalars['String']['input'];
}>;


export type CreateEnterpriseOrganizationMutation = { createEnterpriseOrganization: Pick<CreateEnterpriseOrganizationResponse, 'organizationId' | 'organizationName' | 'packageId'> };

export type CreateOrganizationPackageMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  comment: Scalars['String']['input'];
  contextUrl: Scalars['String']['input'];
}>;


export type CreateOrganizationPackageMutation = Pick<Mutation, 'createOrganizationPackage'>;

export type CreateOrganizationPackageProductMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  packageId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  billable: Scalars['Boolean']['input'];
}>;


export type CreateOrganizationPackageProductMutation = Pick<Mutation, 'createOrganizationPackageProduct'>;

export type CreateOrganizationProductMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;


export type CreateOrganizationProductMutation = Pick<Mutation, 'createOrganizationProduct'>;

export type CreateOrganizationTierMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  couponId: Scalars['String']['input'];
  discountLevel: DiscountLevel;
}>;


export type CreateOrganizationTierMutation = Pick<Mutation, 'createOrganizationTier'>;

export type DeleteOrganizationPackageProductMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  packageId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  comment: Scalars['String']['input'];
  contextUrl: Scalars['String']['input'];
}>;


export type DeleteOrganizationPackageProductMutation = Pick<Mutation, 'deleteOrganizationPackageProduct'>;

export type DeleteOrganizationProductMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;


export type DeleteOrganizationProductMutation = Pick<Mutation, 'deleteOrganizationProduct'>;

export type DeleteOrganizationTierMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  couponId: Scalars['String']['input'];
}>;


export type DeleteOrganizationTierMutation = Pick<Mutation, 'deleteOrganizationTier'>;

export type ProvisionOperatorSubscriptionMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProvisionOperatorSubscriptionMutation = Pick<Mutation, 'provisionOperatorSubscription'>;

export type ResendClientPaysInvitationByOrganizationMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  firmOrganizationId: Scalars['String']['input'];
}>;


export type ResendClientPaysInvitationByOrganizationMutation = Pick<Mutation, 'resendClientPaysInvitationByOrganization'>;

export type ResumeSubscriptionMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  ticketLink: Scalars['String']['input'];
  comment: Scalars['String']['input'];
}>;


export type ResumeSubscriptionMutation = Pick<Mutation, 'resumeSubscription'>;

export type ReviveOperatorSubscriptionMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  ticketLink: Scalars['String']['input'];
  comment: Scalars['String']['input'];
}>;


export type ReviveOperatorSubscriptionMutation = Pick<Mutation, 'reviveOperatorSubscription'>;

export type UpdateAffiliatedSubscriptionPriceMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  affiliatedOrganizationId: Scalars['String']['input'];
  affiliatedLegalEntityId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  ticketLink: Scalars['String']['input'];
  comment: Scalars['String']['input'];
}>;


export type UpdateAffiliatedSubscriptionPriceMutation = Pick<Mutation, 'updateAffiliatedSubscriptionPrice'>;

export type UpdateOperatorSubscriptionMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  ticketLink: Scalars['String']['input'];
  comment: Scalars['String']['input'];
}>;


export type UpdateOperatorSubscriptionMutation = Pick<Mutation, 'updateOperatorSubscription'>;

export type UpdateOrganizationPackageProductMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  packageId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  billable: Scalars['Boolean']['input'];
}>;


export type UpdateOrganizationPackageProductMutation = Pick<Mutation, 'updateOrganizationPackageProduct'>;

export type UpdateOrganizationPackageProductModeMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  packageId: Scalars['String']['input'];
  customProducts: Scalars['Boolean']['input'];
}>;


export type UpdateOrganizationPackageProductModeMutation = Pick<Mutation, 'updateOrganizationPackageProductMode'>;

export type UpdateOrganizationTierMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  fromCouponId: Scalars['String']['input'];
  toCouponId: Scalars['String']['input'];
  discountLevel: DiscountLevel;
}>;


export type UpdateOrganizationTierMutation = Pick<Mutation, 'updateOrganizationTier'>;

export type BillingProductFieldsFragment = Pick<
    BillingProduct,
    | 'id'
    | 'name'
    | 'displayName'
    | 'description'
    | 'callout'
    | 'trialPeriodDays'
    | 'availability'
    | 'listing'
    | 'billable'
  >;

export type BillingPriceFieldsFragment = (
  Pick<BillingPrice, 'id' | 'interval' | 'intervalCount'>
  & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
);

export type BillingLegalEntityLimitFieldsFragment = Pick<BillingLegalEntityLimit, 'id' | 'minLegalEntityLimit' | 'maxLegalEntityLimit'>;

export type ListBillingSubscriptionHistoryQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type ListBillingSubscriptionHistoryQuery = { listBillingSubscriptionHistory: Array<(
    Pick<
      BillingSubscriptionHistory,
      | 'createdAt'
      | 'paidAt'
      | 'status'
      | 'invoiceURL'
    >
    & {
      prorationAmount: Pick<MonetaryValue, 'amount' | 'currencyMultiplier' | 'iso4217CurrencyCode'>,
      recurringAmount: Pick<MonetaryValue, 'amount' | 'currencyMultiplier' | 'iso4217CurrencyCode'>,
      totalAmount: Pick<MonetaryValue, 'amount' | 'currencyMultiplier' | 'iso4217CurrencyCode'>,
    }
  )> };

export type ListOrganizationProductsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type ListOrganizationProductsQuery = { listOrganizationProducts: Array<(
    Pick<AdminBillingProduct, 'isOrganizationEnabled'>
    & { product: Pick<
        BillingProduct,
        | 'id'
        | 'name'
        | 'displayName'
        | 'description'
        | 'callout'
        | 'trialPeriodDays'
        | 'availability'
        | 'listing'
        | 'billable'
      > }
  )> };

export type ListOrganizationTiersQueryVariables = Exact<{
  couponIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ListOrganizationTiersQuery = { listOrganizationTiers: Array<(
    Pick<AdminOrganization, 'createdAt' | 'deletedAt' | 'userCount'>
    & {
      organization: Pick<
          Organization,
          | 'id'
          | 'slug'
          | 'name'
          | 'iconUrl'
          | 'websiteUrl'
          | 'kind'
        >,
      legalEntities: Array<(
        Pick<AdminLegalEntity, 'createdAt' | 'userCount' | 'deletedAt'>
        & { legalEntity: (
          Pick<
            LegalEntity,
            | 'id'
            | 'slug'
            | 'name'
            | 'websiteUrl'
            | 'industry'
            | 'timezone'
            | 'fiscalYearStartMonth'
            | 'fiscalYearNumberOffset'
            | 'status'
            | 'organizationId'
            | 'sensitive'
            | 'phoneNumber'
            | 'iconUrl'
          >
          & {
            address: Pick<
                Address,
                | 'street'
                | 'streetAdditional'
                | 'city'
                | 'region'
                | 'postalCode'
                | 'countryCode'
                | 'lat'
                | 'long'
              >,
            incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
          }
        ) }
      )>,
      affiliateLegalEntities: Array<(
        Pick<AdminLegalEntity, 'createdAt' | 'userCount' | 'deletedAt'>
        & { legalEntity: (
          Pick<
            LegalEntity,
            | 'id'
            | 'slug'
            | 'name'
            | 'websiteUrl'
            | 'industry'
            | 'timezone'
            | 'fiscalYearStartMonth'
            | 'fiscalYearNumberOffset'
            | 'status'
            | 'organizationId'
            | 'sensitive'
            | 'phoneNumber'
            | 'iconUrl'
          >
          & {
            address: Pick<
                Address,
                | 'street'
                | 'streetAdditional'
                | 'city'
                | 'region'
                | 'postalCode'
                | 'countryCode'
                | 'lat'
                | 'long'
              >,
            incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
          }
        ) }
      )>,
    }
  )> };

export type ListPartnerCouponsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListPartnerCouponsQuery = { listPartnerCoupons: Array<(
    Pick<
      AdminCoupon,
      | 'coupon_id'
      | 'name'
      | 'stripe_coupon_id'
      | 'valid'
      | 'percentOff'
      | 'duration'
      | 'durationInMonths'
    >
    & { amountOff?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
  )> };

export type ListProductsQueryVariables = Exact<{
  target?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListProductsQuery = { listProducts: Array<Pick<
      BillingProduct,
      | 'id'
      | 'name'
      | 'displayName'
      | 'availability'
      | 'listing'
    >> };

export type ReadBillingQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type ReadBillingQuery = { readBilling:
    | (
      Pick<BillingAccountingFirm, 'organizationId' | 'subscriptionId' | 'activeSubscription'>
      & {
        product: Pick<
            BillingProduct,
            | 'id'
            | 'name'
            | 'displayName'
            | 'description'
            | 'callout'
            | 'trialPeriodDays'
            | 'availability'
            | 'listing'
            | 'billable'
          >,
        firmPaidClients: Array<(
          Pick<BillingFirmPayer, 'legalEntityId' | 'billed'>
          & {
            product: Pick<
                BillingProduct,
                | 'id'
                | 'name'
                | 'displayName'
                | 'description'
                | 'callout'
                | 'trialPeriodDays'
                | 'availability'
                | 'listing'
                | 'billable'
              >,
            availablePlans: Array<{
                product: Pick<
                    BillingProduct,
                    | 'id'
                    | 'name'
                    | 'displayName'
                    | 'description'
                    | 'callout'
                    | 'trialPeriodDays'
                    | 'availability'
                    | 'listing'
                    | 'billable'
                  >,
                price: (
                  Pick<BillingPrice, 'id' | 'interval' | 'intervalCount'>
                  & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ),
              }>,
          }
        )>,
        selfPaidClients: Array<(
          Pick<BillingClientPayer, 'legalEntityId'>
          & { operator: (
            Pick<BillingOperator, 'organizationId' | 'subscriptionId' | 'activeSubscription'>
            & {
              product: Pick<
                  BillingProduct,
                  | 'id'
                  | 'name'
                  | 'displayName'
                  | 'description'
                  | 'callout'
                  | 'trialPeriodDays'
                  | 'availability'
                  | 'listing'
                  | 'billable'
                >,
              subscriptionDetails?: Maybe<Pick<SubscriptionDetails, 'status' | 'cancelAt'>>,
              trial?: Maybe<Pick<BillingTrial, 'start' | 'end'>>,
            }
          ) }
        )>,
      }
    )
    | (
      Pick<BillingLegacyFirm, 'organizationId' | 'subscriptionId' | 'activeSubscription'>
      & { product: Pick<
          BillingProduct,
          | 'id'
          | 'name'
          | 'displayName'
          | 'description'
          | 'callout'
          | 'trialPeriodDays'
          | 'availability'
          | 'listing'
          | 'billable'
        > }
    )
    | Pick<BillingNone, 'unused'>
    | (
      Pick<BillingOperator, 'organizationId' | 'subscriptionId' | 'activeSubscription'>
      & {
        product: Pick<
            BillingProduct,
            | 'id'
            | 'name'
            | 'displayName'
            | 'description'
            | 'callout'
            | 'trialPeriodDays'
            | 'availability'
            | 'listing'
            | 'billable'
          >,
        subscriptionDetails?: Maybe<Pick<SubscriptionDetails, 'status' | 'cancelAt'>>,
        trial?: Maybe<Pick<BillingTrial, 'start' | 'end'>>,
        availablePlans: Array<{
            product: Pick<
                BillingProduct,
                | 'id'
                | 'name'
                | 'displayName'
                | 'description'
                | 'callout'
                | 'trialPeriodDays'
                | 'availability'
                | 'listing'
                | 'billable'
              >,
            price: (
              Pick<BillingPrice, 'id' | 'interval' | 'intervalCount'>
              & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            ),
          }>,
      }
    )
   };

export type ReadInvitationByOrganizationQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type ReadInvitationByOrganizationQuery = { readInvitationByOrganization: { invitation: (
      Pick<Invitation, 'id' | 'status' | 'createdAt'>
      & { recipient: Pick<Contact, 'givenName' | 'familyName' | 'emailAddress'> }
    ) } };

export type ReadOrganizationBillingPlanQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type ReadOrganizationBillingPlanQuery = { readOrganizationBillingPlan: {
      product: Pick<
          BillingProduct,
          | 'id'
          | 'name'
          | 'displayName'
          | 'description'
          | 'callout'
          | 'trialPeriodDays'
          | 'availability'
          | 'listing'
          | 'billable'
        >,
      price: (
        Pick<BillingPrice, 'id' | 'interval' | 'intervalCount'>
        & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
      ),
      legalEntityLimit?: Maybe<Pick<BillingLegalEntityLimit, 'id' | 'minLegalEntityLimit' | 'maxLegalEntityLimit'>>,
    } };

export type ReadOrganizationPackageQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type ReadOrganizationPackageQuery = { readOrganizationPackage: (
    Pick<AdminOrganizationPackage, 'hasPackage' | 'packageId' | 'customProducts'>
    & { products: Array<Pick<
        AdminOrganizationPackageProduct,
        | 'productId'
        | 'productName'
        | 'productDisplayName'
        | 'billable'
      >> }
  ) };

export type ReadOrganizationTierQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type ReadOrganizationTierQuery = { readOrganizationTier?: Maybe<(
    Pick<
      AdminCoupon,
      | 'coupon_id'
      | 'name'
      | 'stripe_coupon_id'
      | 'valid'
      | 'percentOff'
      | 'duration'
      | 'durationInMonths'
      | 'discountLevel'
    >
    & { amountOff?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
  )> };

export type ListAdminChartsOfAccountsQueryVariables = Exact<{
  global?: InputMaybe<Scalars['Boolean']['input']>;
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  accountingBasis?: InputMaybe<AccountingBasis>;
}>;


export type ListAdminChartsOfAccountsQuery = { listChartsOfAccounts: Array<Pick<
      ChartOfAccountsListEntry,
      | 'id'
      | 'name'
      | 'description'
      | 'accountingBasis'
      | 'legalEntityId'
    >> };

export type ListAdminChartOfAccountsTemplatesQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type ListAdminChartOfAccountsTemplatesQuery = { listChartOfAccountsTemplates: Array<Pick<
      ChartOfAccountsTemplateSummary,
      | 'organizationId'
      | 'templateId'
      | 'name'
      | 'description'
    >> };

export type ReadAdminChartOfAccountsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ReadAdminChartOfAccountsQuery = { readChartOfAccounts: { chart: (
      Pick<
        ChartOfAccounts,
        | 'id'
        | 'name'
        | 'description'
        | 'accountingBasis'
      >
      & { categories: Array<(
        Pick<
          Category,
          | 'id'
          | 'name'
          | 'description'
          | 'displayKey'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'displayNumber'
          | 'active'
          | 'categoryState'
          | 'productArea'
          | 'synthesized'
        >
        & { ancestors?: Maybe<Array<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>> }
      )> }
    ) } };

export type ReadAdminChartOfAccountsTemplateQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
}>;


export type ReadAdminChartOfAccountsTemplateQuery = { readChartOfAccountsTemplate: (
    Pick<
      ChartOfAccountsTemplate,
      | 'organizationId'
      | 'templateId'
      | 'name'
      | 'description'
    >
    & { categories: Array<Pick<
        TemplateCategory,
        | 'organizationId'
        | 'templateId'
        | 'categoryId'
        | 'parentCategoryId'
        | 'name'
        | 'description'
        | 'type'
        | 'subtype'
        | 'categoryState'
        | 'chartOfAccountsDisplayNumber'
        | 'externalAccountType'
        | 'externalAccountSubtype'
        | 'displayKey'
      >> }
  ) };

export type ReadAdminChartOfAccountsWithMappingQueryVariables = Exact<{
  fromId: Scalars['String']['input'];
  toId: Scalars['String']['input'];
  viewType: ViewType;
}>;


export type ReadAdminChartOfAccountsWithMappingQuery = { readMappedChartOfAccounts: (
    Pick<
      MappedChartOfAccounts,
      | 'fromUUID'
      | 'toUUID'
      | 'name'
      | 'description'
      | 'legalEntityId'
      | 'accountingBasis'
    >
    & { categories: Array<{
        fromCategory?: Maybe<(
          Pick<
            AdminCategory,
            | 'externalId'
            | 'subtype'
            | 'chartOfAccountsDisplayNumber'
            | 'externalAccountType'
            | 'externalAccountSubtype'
            | 'synthesized'
          >
          & { category: (
            Pick<
              Category,
              | 'id'
              | 'name'
              | 'description'
              | 'displayKey'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'displayNumber'
              | 'active'
              | 'categoryState'
              | 'productArea'
              | 'synthesized'
            >
            & { ancestors?: Maybe<Array<Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >>> }
          ) }
        )>,
        toCategory?: Maybe<(
          Pick<
            AdminCategory,
            | 'externalId'
            | 'subtype'
            | 'chartOfAccountsDisplayNumber'
            | 'externalAccountType'
            | 'externalAccountSubtype'
            | 'synthesized'
          >
          & { category: (
            Pick<
              Category,
              | 'id'
              | 'name'
              | 'description'
              | 'displayKey'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'displayNumber'
              | 'active'
              | 'categoryState'
              | 'productArea'
              | 'synthesized'
            >
            & { ancestors?: Maybe<Array<Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >>> }
          ) }
        )>,
      }> }
  ) };

export type TriggerClassificationManifestMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  boundaryDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type TriggerClassificationManifestMutation = { triggerClassificationManifest?: Maybe<Pick<TriggerClassificationManifestResponse, 'manifestId' | 'transactionCount'>> };

export type ListClassificationManifestsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ListClassificationManifestsQuery = { listClassificationManifests: Array<(
    Pick<
      ClassificationManifestSummary,
      | 'manifestId'
      | 'legalEntityId'
      | 'trigger'
      | 'boundaryDate'
      | 'transactionCount'
      | 'classifiedCount'
      | 'skippedCount'
      | 'createdAt'
      | 'completedAt'
    >
    & { skipReasonSummaries: Array<Pick<SkipReasonSummary, 'reason' | 'count'>> }
  )> };

export type ReadAssociatedThreadsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  kind: ObjectKind;
  allowResolved?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ReadAssociatedThreadsQuery = { response: {
      threads: Array<(
        { __typename: 'Thread' }
        & Pick<Thread, 'id'>
        & {
          details: (
            Pick<
              ThreadDetails,
              | 'id'
              | 'commentCount'
              | 'resolvedAt'
              | 'authorId'
              | 'commenterIds'
              | 'context'
              | 'pending'
            >
            & {
              targetObject: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
              tags: Array<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
            }
          ),
          comments: Array<(
            { __typename: 'Comment' }
            & Pick<
              Comment,
              | 'id'
              | 'authorId'
              | 'text'
              | 'timestamp'
              | 'editedAt'
              | 'deletedAt'
              | 'reactions'
            >
            & { layoutAttachment?: Maybe<Pick<LayoutAttachment, 'layoutId' | 'legalEntityId'>> }
          )>,
        }
      )>,
      entities?: Maybe<(
        { __typename: 'ObjectEntities' }
        & {
          users?: Maybe<Array<Pick<
              EntityUser,
              | 'id'
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >>>,
          transactions?: Maybe<Array<(
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          )>>,
          comments?: Maybe<Array<Pick<
              EntityComment,
              | 'id'
              | 'authorId'
              | 'text'
              | 'timestamp'
            >>>,
          reports?: Maybe<Array<(
            Pick<
              EntityReport,
              | 'id'
              | 'title'
              | 'authorId'
              | 'mimeType'
              | 'createdAt'
            >
            & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
          )>>,
          reportPackages?: Maybe<Array<(
            Pick<
              EntityReportPackage,
              | 'id'
              | 'title'
              | 'authorId'
              | 'interval'
              | 'periodStartedAt'
              | 'periodEndedAt'
              | 'createdAt'
              | 'updatedAt'
              | 'coverUrl'
            >
            & { documents: Array<Pick<
                SharedReportDocumentMetadata,
                | 'id'
                | 'documentObjectId'
                | 'documentObjectVersionId'
                | 'title'
                | 'mimeType'
              >> }
          )>>,
          parties?: Maybe<Array<Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >>>,
          datasources?: Maybe<Array<Pick<
              EntityDataSource,
              | 'id'
              | 'name'
              | 'url'
              | 'iconUrl'
            >>>,
          categories?: Maybe<Array<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>>,
          threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
          legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
          workItems?: Maybe<Array<(
            Pick<
              EntityWorkItem,
              | 'id'
              | 'time'
              | 'workItemState'
              | 'workItemType'
              | 'reviewCreatedById'
              | 'reviewState'
              | 'ledgerType'
            >
            & { objectTransaction: (
              Pick<
                EntityTransaction,
                | 'viewId'
                | 'factId'
                | 'timestamp'
                | 'description'
                | 'externalId'
                | 'displayEntry'
              >
              & {
                moneyFlow: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ),
                party?: Maybe<Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >>,
                displayCategory: Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >,
                splitCategory?: Maybe<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>,
              }
            ) }
          )>>,
          invoices?: Maybe<Array<(
            Pick<
              EntityInvoice,
              | 'id'
              | 'externalDisplayId'
              | 'createdAt'
              | 'dueAt'
            >
            & {
              amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              customer: (
                Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
                & { party: Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  > }
              ),
            }
          )>>,
          bills?: Maybe<Array<(
            Pick<
              EntityBill,
              | 'id'
              | 'billStatus'
              | 'vendorName'
              | 'billDescription'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
              format: (
                Pick<Format, 'id' | 'formatClass'>
                & { segments: Array<Pick<
                    Segment,
                    | 'collectionId'
                    | 'fileId'
                    | 'sequence'
                    | 'token'
                  >> }
              ),
              approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
            }
          )>>,
          identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
          departments?: Maybe<Array<(
            { __typename: 'EntityDepartment' }
            & Pick<
              EntityDepartment,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>>,
          locations?: Maybe<Array<(
            { __typename: 'EntityLocation' }
            & Pick<
              EntityLocation,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>>,
          reconciliations?: Maybe<Array<(
            { __typename: 'EntityReconciliation' }
            & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
            & {
              startDate: Pick<Date, 'year' | 'month' | 'day'>,
              endDate: Pick<Date, 'year' | 'month' | 'day'>,
            }
          )>>,
          ledgerTransactions?: Maybe<Array<(
            Pick<
              EntityLedgerTransaction,
              | 'id'
              | 'timestamp'
              | 'factIds'
              | 'name'
              | 'referenceNumber'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              parties: Array<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
            }
          )>>,
          schedules?: Maybe<Array<(
            { __typename: 'EntitySchedule' }
            & Pick<
              EntitySchedule,
              | 'id'
              | 'name'
              | 'scheduleNumber'
              | 'scheduleType'
              | 'scheduleTemplateId'
              | 'categoryId'
              | 'relatedCategoryId'
              | 'partyId'
              | 'startDate'
              | 'endDate'
            >
            & { amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
          )>>,
        }
      )>,
    } };

export type ReadThreadQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;


export type ReadThreadQuery = { thread: (
    { __typename: 'ThreadWithEntities' }
    & {
      thread: (
        { __typename: 'Thread' }
        & Pick<Thread, 'id'>
        & {
          details: (
            Pick<
              ThreadDetails,
              | 'id'
              | 'commentCount'
              | 'resolvedAt'
              | 'authorId'
              | 'commenterIds'
              | 'context'
              | 'pending'
            >
            & {
              targetObject: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
              tags: Array<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
            }
          ),
          comments: Array<(
            { __typename: 'Comment' }
            & Pick<
              Comment,
              | 'id'
              | 'authorId'
              | 'text'
              | 'timestamp'
              | 'editedAt'
              | 'deletedAt'
              | 'reactions'
            >
            & { layoutAttachment?: Maybe<Pick<LayoutAttachment, 'layoutId' | 'legalEntityId'>> }
          )>,
        }
      ),
      entities?: Maybe<(
        { __typename: 'ObjectEntities' }
        & {
          users?: Maybe<Array<Pick<
              EntityUser,
              | 'id'
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >>>,
          transactions?: Maybe<Array<(
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          )>>,
          comments?: Maybe<Array<Pick<
              EntityComment,
              | 'id'
              | 'authorId'
              | 'text'
              | 'timestamp'
            >>>,
          reports?: Maybe<Array<(
            Pick<
              EntityReport,
              | 'id'
              | 'title'
              | 'authorId'
              | 'mimeType'
              | 'createdAt'
            >
            & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
          )>>,
          reportPackages?: Maybe<Array<(
            Pick<
              EntityReportPackage,
              | 'id'
              | 'title'
              | 'authorId'
              | 'interval'
              | 'periodStartedAt'
              | 'periodEndedAt'
              | 'createdAt'
              | 'updatedAt'
              | 'coverUrl'
            >
            & { documents: Array<Pick<
                SharedReportDocumentMetadata,
                | 'id'
                | 'documentObjectId'
                | 'documentObjectVersionId'
                | 'title'
                | 'mimeType'
              >> }
          )>>,
          parties?: Maybe<Array<Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >>>,
          datasources?: Maybe<Array<Pick<
              EntityDataSource,
              | 'id'
              | 'name'
              | 'url'
              | 'iconUrl'
            >>>,
          categories?: Maybe<Array<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>>,
          threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
          legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
          workItems?: Maybe<Array<(
            Pick<
              EntityWorkItem,
              | 'id'
              | 'time'
              | 'workItemState'
              | 'workItemType'
              | 'reviewCreatedById'
              | 'reviewState'
              | 'ledgerType'
            >
            & { objectTransaction: (
              Pick<
                EntityTransaction,
                | 'viewId'
                | 'factId'
                | 'timestamp'
                | 'description'
                | 'externalId'
                | 'displayEntry'
              >
              & {
                moneyFlow: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ),
                party?: Maybe<Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >>,
                displayCategory: Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >,
                splitCategory?: Maybe<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>,
              }
            ) }
          )>>,
          invoices?: Maybe<Array<(
            Pick<
              EntityInvoice,
              | 'id'
              | 'externalDisplayId'
              | 'createdAt'
              | 'dueAt'
            >
            & {
              amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              customer: (
                Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
                & { party: Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  > }
              ),
            }
          )>>,
          bills?: Maybe<Array<(
            Pick<
              EntityBill,
              | 'id'
              | 'billStatus'
              | 'vendorName'
              | 'billDescription'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
              format: (
                Pick<Format, 'id' | 'formatClass'>
                & { segments: Array<Pick<
                    Segment,
                    | 'collectionId'
                    | 'fileId'
                    | 'sequence'
                    | 'token'
                  >> }
              ),
              approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
            }
          )>>,
          identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
          departments?: Maybe<Array<(
            { __typename: 'EntityDepartment' }
            & Pick<
              EntityDepartment,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>>,
          locations?: Maybe<Array<(
            { __typename: 'EntityLocation' }
            & Pick<
              EntityLocation,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>>,
          reconciliations?: Maybe<Array<(
            { __typename: 'EntityReconciliation' }
            & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
            & {
              startDate: Pick<Date, 'year' | 'month' | 'day'>,
              endDate: Pick<Date, 'year' | 'month' | 'day'>,
            }
          )>>,
          ledgerTransactions?: Maybe<Array<(
            Pick<
              EntityLedgerTransaction,
              | 'id'
              | 'timestamp'
              | 'factIds'
              | 'name'
              | 'referenceNumber'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              parties: Array<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
            }
          )>>,
          schedules?: Maybe<Array<(
            { __typename: 'EntitySchedule' }
            & Pick<
              EntitySchedule,
              | 'id'
              | 'name'
              | 'scheduleNumber'
              | 'scheduleType'
              | 'scheduleTemplateId'
              | 'categoryId'
              | 'relatedCategoryId'
              | 'partyId'
              | 'startDate'
              | 'endDate'
            >
            & { amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
          )>>,
        }
      )>,
    }
  ) };

export type AdminConnectionFieldsFragment = (
  Pick<
    AdminConnection,
    | 'id'
    | 'sourceName'
    | 'deletedAt'
    | 'legalEntityId'
    | 'connectorId'
    | 'dataSourceId'
    | 'createdAt'
    | 'status'
    | 'connectorClassName'
    | 'externalId'
    | 'consentedScopes'
    | 'supportedScopes'
  >
  & { sync?: Maybe<Pick<ConnectionSyncState, 'lastSuccessAt' | 'lastEventAt' | 'status'>> }
);

export type AdminConnectionTemplateFieldsFragment = (
  Pick<AdminConnectionTemplate, 'externalId'>
  & {
    connector: (
      Pick<
        Connector,
        | 'id'
        | 'name'
        | 'tagline'
        | 'description'
        | 'category'
        | 'iconObjectName'
        | 'className'
        | 'canInstall'
      >
      & { connectorProperties?: Maybe<
        | (
          { __typename: 'AppConnectorProperties' }
          & Pick<
            AppConnectorProperties,
            | 'organizationId'
            | 'visibility'
            | 'homepageURL'
            | 'supportEmail'
            | 'developerEmail'
            | 'privacyPolicyURL'
            | 'termsOfServiceURL'
            | 'scopes'
            | 'redirectUris'
            | 'installUri'
          >
        )
        | (
          { __typename: 'BillConnectorProperties' }
          & Pick<BillConnectorProperties, 'empty'>
        )
        | (
          { __typename: 'EmptyConnectorProperties' }
          & Pick<EmptyConnectorProperties, 'empty'>
        )
        | (
          { __typename: 'FinchConnectorProperties' }
          & Pick<FinchConnectorProperties, 'empty'>
        )
        | (
          { __typename: 'GustoConnectorProperties' }
          & Pick<GustoConnectorProperties, 'authorizationURL'>
        )
        | (
          { __typename: 'PlaidConnectorProperties' }
          & Pick<PlaidConnectorProperties, 'empty'>
        )
        | (
          { __typename: 'RampConnectorProperties' }
          & Pick<RampConnectorProperties, 'authorizationURL'>
        )
        | (
          { __typename: 'StripeConnectorProperties' }
          & Pick<StripeConnectorProperties, 'appLinkURL'>
        )
      > }
    ),
    institution: (
      Pick<
        ProductInstitution,
        | 'id'
        | 'name'
        | 'products'
        | 'routingNumber'
      >
      & { party?: Maybe<Pick<
          Party,
          | 'id'
          | 'legalEntityId'
          | 'name'
          | 'url'
          | 'supportUrl'
          | 'supportEmail'
          | 'supportPhone'
          | 'twitterUrl'
          | 'facebookUrl'
          | 'instagramUrl'
          | 'yelpUrl'
          | 'iconUrl'
          | 'shortDescription'
          | 'designation'
        >> }
    ),
  }
);

export type AdminConnectorFieldsFragment = (
  Pick<AdminConnector, 'installCount'>
  & { connector: (
    Pick<
      Connector,
      | 'id'
      | 'name'
      | 'tagline'
      | 'description'
      | 'category'
      | 'iconObjectName'
      | 'className'
      | 'canInstall'
    >
    & { connectorProperties?: Maybe<
      | (
        { __typename: 'AppConnectorProperties' }
        & Pick<
          AppConnectorProperties,
          | 'organizationId'
          | 'visibility'
          | 'homepageURL'
          | 'supportEmail'
          | 'developerEmail'
          | 'privacyPolicyURL'
          | 'termsOfServiceURL'
          | 'scopes'
          | 'redirectUris'
          | 'installUri'
        >
      )
      | (
        { __typename: 'BillConnectorProperties' }
        & Pick<BillConnectorProperties, 'empty'>
      )
      | (
        { __typename: 'EmptyConnectorProperties' }
        & Pick<EmptyConnectorProperties, 'empty'>
      )
      | (
        { __typename: 'FinchConnectorProperties' }
        & Pick<FinchConnectorProperties, 'empty'>
      )
      | (
        { __typename: 'GustoConnectorProperties' }
        & Pick<GustoConnectorProperties, 'authorizationURL'>
      )
      | (
        { __typename: 'PlaidConnectorProperties' }
        & Pick<PlaidConnectorProperties, 'empty'>
      )
      | (
        { __typename: 'RampConnectorProperties' }
        & Pick<RampConnectorProperties, 'authorizationURL'>
      )
      | (
        { __typename: 'StripeConnectorProperties' }
        & Pick<StripeConnectorProperties, 'appLinkURL'>
      )
    > }
  ) }
);

export type CreateConnectionTemplateMutationVariables = Exact<{
  connectorId: Scalars['String']['input'];
  institutionId: Scalars['String']['input'];
}>;


export type CreateConnectionTemplateMutation = Pick<Mutation, 'createConnectionTemplate'>;

export type DeleteConnectionMutationVariables = Exact<{
  id: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
}>;


export type DeleteConnectionMutation = Pick<Mutation, 'deleteConnection'>;

export type DeleteConnectionTemplateMutationVariables = Exact<{
  connectorId: Scalars['String']['input'];
  institutionId: Scalars['String']['input'];
}>;


export type DeleteConnectionTemplateMutation = Pick<Mutation, 'deleteConnectionTemplate'>;

export type DisableConnectionMutationVariables = Exact<{
  id: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
}>;


export type DisableConnectionMutation = Pick<Mutation, 'disableConnection'>;

export type EnableConnectionMutationVariables = Exact<{
  id: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
}>;


export type EnableConnectionMutation = Pick<Mutation, 'enableConnection'>;

export type PlaidRefreshStatementsMutationVariables = Exact<{
  id: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type PlaidRefreshStatementsMutation = { plaidRefreshStatements?: Maybe<Pick<RawResponse, 'rawBody'>> };

export type PlaidTriggerRefreshMutationVariables = Exact<{
  id: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
}>;


export type PlaidTriggerRefreshMutation = Pick<Mutation, 'plaidTriggerRefresh'>;

export type ResetConnectionMutationVariables = Exact<{
  id: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
}>;


export type ResetConnectionMutation = Pick<Mutation, 'resetConnection'>;

export type SetAppVisibilityMutationVariables = Exact<{
  connectorId: Scalars['String']['input'];
  visibility: ConnectorVisibility;
}>;


export type SetAppVisibilityMutation = Pick<Mutation, 'setAppVisibility'>;

export type SyncConnectionMutationVariables = Exact<{
  id: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
}>;


export type SyncConnectionMutation = Pick<Mutation, 'syncConnection'>;

export type UpdateConnectionFeatureFlagStatusMutationVariables = Exact<{
  connectorId: Scalars['String']['input'];
  connectionId: Scalars['String']['input'];
  featureFlagId: Scalars['String']['input'];
  status: ConnectionFeatureFlagStatusValue;
}>;


export type UpdateConnectionFeatureFlagStatusMutation = Pick<Mutation, 'updateConnectionFeatureFlagStatus'>;

export type UpdateConnectionTemplateMutationVariables = Exact<{
  connectorId: Scalars['String']['input'];
  institutionId: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
}>;


export type UpdateConnectionTemplateMutation = Pick<Mutation, 'updateConnectionTemplate'>;

export type ListConnectionEventsQueryVariables = Exact<{
  connectionId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  pagination: Pagination;
}>;


export type ListConnectionEventsQuery = { listConnectionEvents: Array<Pick<
      AdminConnectionEvent,
      | 'id'
      | 'connectionEventRef'
      | 'source'
      | 'status'
      | 'message'
      | 'failureReason'
      | 'affectedCount'
      | 'oldestSeen'
      | 'newestSeen'
      | 'dataUpdatedAt'
      | 'dataStatus'
      | 'userId'
      | 'superUserId'
      | 'createdAt'
    >> };

export type AdminConnectionEventFieldsFragment = Pick<
    AdminConnectionEvent,
    | 'id'
    | 'connectionEventRef'
    | 'source'
    | 'status'
    | 'message'
    | 'failureReason'
    | 'affectedCount'
    | 'oldestSeen'
    | 'newestSeen'
    | 'dataUpdatedAt'
    | 'dataStatus'
    | 'userId'
    | 'superUserId'
    | 'createdAt'
  >;

export type ListConnectionFeatureFlagsQueryVariables = Exact<{
  connectionId: Scalars['String']['input'];
}>;


export type ListConnectionFeatureFlagsQuery = { listConnectionFeatureFlags: Array<Pick<
      ConnectionFeatureFlag,
      | 'connectorId'
      | 'connectionId'
      | 'featureFlagId'
      | 'status'
      | 'code'
      | 'name'
      | 'description'
    >> };

export type ListConnectionTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListConnectionTemplatesQuery = { listConnectionTemplates: Array<(
    Pick<AdminConnectionTemplate, 'externalId'>
    & {
      connector: (
        Pick<
          Connector,
          | 'id'
          | 'name'
          | 'tagline'
          | 'description'
          | 'category'
          | 'iconObjectName'
          | 'className'
          | 'canInstall'
        >
        & { connectorProperties?: Maybe<
          | (
            { __typename: 'AppConnectorProperties' }
            & Pick<
              AppConnectorProperties,
              | 'organizationId'
              | 'visibility'
              | 'homepageURL'
              | 'supportEmail'
              | 'developerEmail'
              | 'privacyPolicyURL'
              | 'termsOfServiceURL'
              | 'scopes'
              | 'redirectUris'
              | 'installUri'
            >
          )
          | (
            { __typename: 'BillConnectorProperties' }
            & Pick<BillConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'EmptyConnectorProperties' }
            & Pick<EmptyConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'FinchConnectorProperties' }
            & Pick<FinchConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'GustoConnectorProperties' }
            & Pick<GustoConnectorProperties, 'authorizationURL'>
          )
          | (
            { __typename: 'PlaidConnectorProperties' }
            & Pick<PlaidConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'RampConnectorProperties' }
            & Pick<RampConnectorProperties, 'authorizationURL'>
          )
          | (
            { __typename: 'StripeConnectorProperties' }
            & Pick<StripeConnectorProperties, 'appLinkURL'>
          )
        > }
      ),
      institution: (
        Pick<
          ProductInstitution,
          | 'id'
          | 'name'
          | 'products'
          | 'routingNumber'
        >
        & { party?: Maybe<Pick<
            Party,
            | 'id'
            | 'legalEntityId'
            | 'name'
            | 'url'
            | 'supportUrl'
            | 'supportEmail'
            | 'supportPhone'
            | 'twitterUrl'
            | 'facebookUrl'
            | 'instagramUrl'
            | 'yelpUrl'
            | 'iconUrl'
            | 'shortDescription'
            | 'designation'
          >> }
      ),
    }
  )> };

export type ListConnectionsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ListConnectionsQuery = { listConnections: { connections: Array<(
      Pick<
        AdminConnection,
        | 'id'
        | 'sourceName'
        | 'deletedAt'
        | 'legalEntityId'
        | 'connectorId'
        | 'dataSourceId'
        | 'createdAt'
        | 'status'
        | 'connectorClassName'
        | 'externalId'
        | 'consentedScopes'
        | 'supportedScopes'
      >
      & { sync?: Maybe<Pick<ConnectionSyncState, 'lastSuccessAt' | 'lastEventAt' | 'status'>> }
    )> } };

export type AdminConnectionListFieldsFragment = { connections: Array<(
    Pick<
      AdminConnection,
      | 'id'
      | 'sourceName'
      | 'deletedAt'
      | 'legalEntityId'
      | 'connectorId'
      | 'dataSourceId'
      | 'createdAt'
      | 'status'
      | 'connectorClassName'
      | 'externalId'
      | 'consentedScopes'
      | 'supportedScopes'
    >
    & { sync?: Maybe<Pick<ConnectionSyncState, 'lastSuccessAt' | 'lastEventAt' | 'status'>> }
  )> };

export type ListConnectorInstallsQueryVariables = Exact<{
  connectorId: Scalars['String']['input'];
}>;


export type ListConnectorInstallsQuery = { listConnectorInstalls: Array<Pick<
      AdminConnectorInstall,
      | 'connectionId'
      | 'legalEntityId'
      | 'connectorId'
      | 'status'
      | 'deletedAt'
      | 'createdAt'
      | 'sourceName'
      | 'externalId'
    >> };

export type ListConnectorsQueryVariables = Exact<{
  institutionId?: InputMaybe<Scalars['String']['input']>;
  className?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<ConnectorVisibility>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<Pagination>;
}>;


export type ListConnectorsQuery = { listConnectors: Array<(
    Pick<AdminConnector, 'installCount'>
    & { connector: (
      Pick<
        Connector,
        | 'id'
        | 'name'
        | 'tagline'
        | 'description'
        | 'category'
        | 'iconObjectName'
        | 'className'
        | 'canInstall'
      >
      & { connectorProperties?: Maybe<
        | (
          { __typename: 'AppConnectorProperties' }
          & Pick<
            AppConnectorProperties,
            | 'organizationId'
            | 'visibility'
            | 'homepageURL'
            | 'supportEmail'
            | 'developerEmail'
            | 'privacyPolicyURL'
            | 'termsOfServiceURL'
            | 'scopes'
            | 'redirectUris'
            | 'installUri'
          >
        )
        | (
          { __typename: 'BillConnectorProperties' }
          & Pick<BillConnectorProperties, 'empty'>
        )
        | (
          { __typename: 'EmptyConnectorProperties' }
          & Pick<EmptyConnectorProperties, 'empty'>
        )
        | (
          { __typename: 'FinchConnectorProperties' }
          & Pick<FinchConnectorProperties, 'empty'>
        )
        | (
          { __typename: 'GustoConnectorProperties' }
          & Pick<GustoConnectorProperties, 'authorizationURL'>
        )
        | (
          { __typename: 'PlaidConnectorProperties' }
          & Pick<PlaidConnectorProperties, 'empty'>
        )
        | (
          { __typename: 'RampConnectorProperties' }
          & Pick<RampConnectorProperties, 'authorizationURL'>
        )
        | (
          { __typename: 'StripeConnectorProperties' }
          & Pick<StripeConnectorProperties, 'appLinkURL'>
        )
      > }
    ) }
  )> };

export type ReadConnectRecordingQueryVariables = Exact<{
  connectionId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  eventId: Scalars['String']['input'];
}>;


export type ReadConnectRecordingQuery = { readConnectRecording: { responses: Array<(
      Pick<HttpResponse, 'rawBody'>
      & { metadata?: Maybe<Pick<
          HttpResponseMetadata,
          | 'request_id'
          | 'url'
          | 'status'
          | 'status_code'
        >> }
    )> } };

export type ReadConnectionQueryVariables = Exact<{
  connectionId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
}>;


export type ReadConnectionQuery = { readConnection: (
    Pick<
      AdminConnection,
      | 'id'
      | 'sourceName'
      | 'deletedAt'
      | 'legalEntityId'
      | 'connectorId'
      | 'dataSourceId'
      | 'createdAt'
      | 'status'
      | 'connectorClassName'
      | 'externalId'
      | 'consentedScopes'
      | 'supportedScopes'
    >
    & {
      accounts?: Maybe<Array<Pick<
          AdminConnectionAccount,
          | 'id'
          | 'connectionId'
          | 'sourceAccountId'
          | 'name'
          | 'mask'
          | 'type'
          | 'subtype'
          | 'status'
          | 'deleted'
          | 'createdAt'
        >>>,
      sync?: Maybe<Pick<ConnectionSyncState, 'lastSuccessAt' | 'lastEventAt' | 'status'>>,
    }
  ) };

export type ReadConnectorQueryVariables = Exact<{
  connectorId: Scalars['String']['input'];
}>;


export type ReadConnectorQuery = { readConnector?: Maybe<(
    Pick<AdminConnector, 'installCount'>
    & { connector: (
      Pick<
        Connector,
        | 'id'
        | 'name'
        | 'tagline'
        | 'description'
        | 'category'
        | 'iconObjectName'
        | 'className'
        | 'canInstall'
      >
      & { connectorProperties?: Maybe<
        | (
          { __typename: 'AppConnectorProperties' }
          & Pick<
            AppConnectorProperties,
            | 'organizationId'
            | 'visibility'
            | 'homepageURL'
            | 'supportEmail'
            | 'developerEmail'
            | 'privacyPolicyURL'
            | 'termsOfServiceURL'
            | 'scopes'
            | 'redirectUris'
            | 'installUri'
          >
        )
        | (
          { __typename: 'BillConnectorProperties' }
          & Pick<BillConnectorProperties, 'empty'>
        )
        | (
          { __typename: 'EmptyConnectorProperties' }
          & Pick<EmptyConnectorProperties, 'empty'>
        )
        | (
          { __typename: 'FinchConnectorProperties' }
          & Pick<FinchConnectorProperties, 'empty'>
        )
        | (
          { __typename: 'GustoConnectorProperties' }
          & Pick<GustoConnectorProperties, 'authorizationURL'>
        )
        | (
          { __typename: 'PlaidConnectorProperties' }
          & Pick<PlaidConnectorProperties, 'empty'>
        )
        | (
          { __typename: 'RampConnectorProperties' }
          & Pick<RampConnectorProperties, 'authorizationURL'>
        )
        | (
          { __typename: 'StripeConnectorProperties' }
          & Pick<StripeConnectorProperties, 'appLinkURL'>
        )
      > }
    ) }
  )> };

export type ReadConnectorCredentialsQueryVariables = Exact<{
  connectorId: Scalars['String']['input'];
}>;


export type ReadConnectorCredentialsQuery = { readConnectorCredentials: Array<Pick<AdminAppCredential, 'environment' | 'clientId'>> };

export type ListCsvImportTransactionFactsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  csvImportId: Scalars['String']['input'];
  pagination?: InputMaybe<Pagination>;
}>;


export type ListCsvImportTransactionFactsQuery = Pick<Query, 'listCsvImportTransactionFacts'>;

export type ListCsvImportsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  pagination: Pagination;
  order?: InputMaybe<CsvImportSort>;
}>;


export type ListCsvImportsQuery = { listCsvImports: Array<Pick<
      CsvImport,
      | 'csvImportId'
      | 'dataSourceId'
      | 'fileName'
      | 'transactionCount'
      | 'source'
      | 'createdAt'
      | 'deletedAt'
    >> };

export type DenormalizedViewStatusFieldsFragment = Pick<
    DenormalizedViewStatus,
    | 'legalEntityId'
    | 'viewType'
    | 'activeViewCreatedAt'
    | 'ongoingViewStartedAt'
  >;

export type OnboardMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type OnboardMutation = Pick<Mutation, 'onboard'>;

export type TriggerDenormalizedViewGenerationMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type TriggerDenormalizedViewGenerationMutation = Pick<Mutation, 'triggerDenormalizedViewGeneration'>;

export type TriggerFraudCheckAccountingMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type TriggerFraudCheckAccountingMutation = Pick<Mutation, 'triggerFraudCheckAccounting'>;

export type ListAllDataProcessingStatusesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListAllDataProcessingStatusesQuery = { listAllDataProcessingStatuses: { entries: Array<Pick<
        DenormalizedViewStatus,
        | 'legalEntityId'
        | 'viewType'
        | 'activeViewCreatedAt'
        | 'ongoingViewStartedAt'
      >> } };

export type ReadEntityDataProcessingStatusesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ReadEntityDataProcessingStatusesQuery = { readEntityDataProcessingStatuses: { entries: Array<Pick<
        DenormalizedViewStatus,
        | 'legalEntityId'
        | 'viewType'
        | 'activeViewCreatedAt'
        | 'ongoingViewStartedAt'
      >> } };

export type BooksClosedFactFieldsFragment = Pick<
    BooksClosedFact,
    | 'legalEntityId'
    | 'dataSourceId'
    | 'userId'
    | 'booksClosedDate'
    | 'createdAt'
  >;

export type DataHealthFieldsFragment = Pick<
    DataHealthStatus,
    | 'anyDataSourceRequiresEngineering'
    | 'allDataSourcesLinked'
    | 'hasPlaidDataSource'
    | 'allDataSourcesHaveTransactions'
  >;

export type JobOwnerFieldsFragment = Pick<JobOwner, 'dataSourceId' | 'legalEntityId'>;

export type JobMetadataFieldsFragment = Pick<JobMetadata, 'consumer' | 'requestObjectId' | 'userId'>;

export type DeleteAdminDataSourceMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  dataSourceId: Scalars['String']['input'];
  providerType: ProviderType;
}>;


export type DeleteAdminDataSourceMutation = Pick<Mutation, 'deleteAdminDataSource'>;

export type TriggerDataSourceClassificationMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  dataSourceId: Scalars['String']['input'];
}>;


export type TriggerDataSourceClassificationMutation = Pick<Mutation, 'triggerDataSourceClassification'>;

export type ListAdminBooksClosedFactsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ListAdminBooksClosedFactsQuery = { listAdminBooksClosedFacts: Array<Pick<
      BooksClosedFact,
      | 'legalEntityId'
      | 'dataSourceId'
      | 'userId'
      | 'booksClosedDate'
      | 'createdAt'
    >> };

export type ListAdminOwnedDataSourcesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ListAdminOwnedDataSourcesQuery = { listAdminOwnedDataSources: Array<{
      dataSource: (
        Pick<
          EnrichedDataSource,
          | 'id'
          | 'legalEntityId'
          | 'status'
          | 'statusReason'
          | 'providerType'
          | 'accountAlias'
          | 'createdAt'
          | 'updatedAt'
          | 'lastActivityAt'
          | 'hasTransactions'
        >
        & {
          institution: Pick<
              Party,
              | 'id'
              | 'legalEntityId'
              | 'name'
              | 'url'
              | 'supportUrl'
              | 'supportEmail'
              | 'supportPhone'
              | 'twitterUrl'
              | 'facebookUrl'
              | 'instagramUrl'
              | 'yelpUrl'
              | 'iconUrl'
              | 'shortDescription'
              | 'designation'
            >,
          quickBooksConfig?: Maybe<Pick<
              QuickBooksConfig,
              | 'id'
              | 'realmId'
              | 'createdAt'
              | 'updatedAt'
            >>,
          plaidConfig?: Maybe<Pick<
              PlaidConfig,
              | 'id'
              | 'itemId'
              | 'externalInstitutionId'
              | 'createdAt'
              | 'updatedAt'
            >>,
          sourceAccounts?: Maybe<Array<Pick<
              SourceAccount,
              | 'id'
              | 'externalId'
              | 'externalName'
              | 'externalOwnerName'
              | 'externalOfficialName'
              | 'externalType'
              | 'externalSubtype'
              | 'mask'
              | 'status'
              | 'ownerEmployeeId'
            >>>,
        }
      ),
      ownedSourceAccounts?: Maybe<Array<{
          sourceAccount: Pick<
              SourceAccount,
              | 'id'
              | 'externalId'
              | 'externalName'
              | 'externalOwnerName'
              | 'externalOfficialName'
              | 'externalType'
              | 'externalSubtype'
              | 'mask'
              | 'status'
              | 'ownerEmployeeId'
            >,
          owner?: Maybe<(
            Pick<
              Employee,
              | 'id'
              | 'organizationId'
              | 'givenName'
              | 'familyName'
              | 'avatarUrl'
              | 'emailAddress'
              | 'jobTitle'
              | 'lastActivityAt'
              | 'status'
              | 'hiddenAt'
            >
            & {
              role?: Maybe<Pick<Role, 'id'>>,
              defaultEntityRole?: Maybe<Pick<Role, 'id'>>,
              user?: Maybe<(
                Pick<
                  User,
                  | 'id'
                  | 'givenName'
                  | 'familyName'
                  | 'primaryEmailAddress'
                  | 'passwordSet'
                  | 'avatarUrl'
                  | 'createdAt'
                  | 'lastActivityAt'
                >
                & {
                  employments?: Maybe<Array<(
                    Pick<OrganizationEmployment, 'employeeId'>
                    & {
                      role: Pick<Role, 'id'>,
                      organization: Pick<
                          Organization,
                          | 'id'
                          | 'slug'
                          | 'name'
                          | 'iconUrl'
                          | 'websiteUrl'
                          | 'kind'
                        >,
                      legalEntityRoles?: Maybe<Array<(
                        Pick<EmployeeLegalEntityRole, 'legalEntityId'>
                        & { role?: Maybe<Pick<Role, 'id'>> }
                      )>>,
                    }
                  )>>,
                  identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
                }
              )>,
              invitation?: Maybe<(
                Pick<
                  Invitation,
                  | 'id'
                  | 'invitationType'
                  | 'status'
                  | 'service'
                  | 'organizationTemplateId'
                  | 'createdAt'
                  | 'updatedAt'
                  | 'notifiedAt'
                >
                & {
                  recipient: Pick<
                      Contact,
                      | 'givenName'
                      | 'familyName'
                      | 'emailAddress'
                      | 'avatarUrl'
                    >,
                  sender?: Maybe<Pick<
                      Contact,
                      | 'givenName'
                      | 'familyName'
                      | 'emailAddress'
                      | 'avatarUrl'
                    >>,
                  organization?: Maybe<Pick<
                      Organization,
                      | 'id'
                      | 'slug'
                      | 'name'
                      | 'iconUrl'
                      | 'websiteUrl'
                      | 'kind'
                    >>,
                  role?: Maybe<Pick<Role, 'id'>>,
                }
              )>,
              legalEntityRoles?: Maybe<Array<(
                Pick<EmployeeLegalEntityRole, 'legalEntityId'>
                & { role?: Maybe<Pick<Role, 'id'>> }
              )>>,
            }
          )>,
        }>>,
      dataSourcePreference?: Maybe<Pick<
          DataSourcePreference,
          | 'dataSourceId'
          | 'accountingBasis'
          | 'taxForm'
          | 'providerType'
          | 'departmentTerminology'
        >>,
    }> };

export type ListDataSourceJobErrorsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  requestObjectId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListDataSourceJobErrorsQuery = { listDataSourceJobErrors?: Maybe<Array<(
    Pick<JobError, 'jobType' | 'errorMessage' | 'createdAt'>
    & {
      jobOwner: Pick<JobOwner, 'dataSourceId' | 'legalEntityId'>,
      jobMetadata: Pick<JobMetadata, 'consumer' | 'requestObjectId' | 'userId'>,
    }
  )>> };

export type ValidationHealthStatusFieldsFragment = (
  Pick<ValidationHealthStatus, 'balanceSheetConsistent' | 'startedAt'>
  & {
    cashAspectHealth: Pick<AspectDataHealth, 'closedViewDataStatus' | 'importedDataStatus' | 'overallDataStatus'>,
    expenseAspectHealth: Pick<AspectDataHealth, 'closedViewDataStatus' | 'importedDataStatus' | 'overallDataStatus'>,
    revenueAspectHealth: Pick<AspectDataHealth, 'closedViewDataStatus' | 'importedDataStatus' | 'overallDataStatus'>,
  }
);

export type ReadValidationHistoryQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ReadValidationHistoryQuery = { readValidationHistory?: Maybe<{ validationHistory: Array<(
      Pick<ValidationHealthStatus, 'balanceSheetConsistent' | 'startedAt'>
      & {
        cashAspectHealth: Pick<AspectDataHealth, 'closedViewDataStatus' | 'importedDataStatus' | 'overallDataStatus'>,
        expenseAspectHealth: Pick<AspectDataHealth, 'closedViewDataStatus' | 'importedDataStatus' | 'overallDataStatus'>,
        revenueAspectHealth: Pick<AspectDataHealth, 'closedViewDataStatus' | 'importedDataStatus' | 'overallDataStatus'>,
      }
    )> }> };

export type ValidationHistoryFieldsFragment = { validationHistory: Array<(
    Pick<ValidationHealthStatus, 'balanceSheetConsistent' | 'startedAt'>
    & {
      cashAspectHealth: Pick<AspectDataHealth, 'closedViewDataStatus' | 'importedDataStatus' | 'overallDataStatus'>,
      expenseAspectHealth: Pick<AspectDataHealth, 'closedViewDataStatus' | 'importedDataStatus' | 'overallDataStatus'>,
      revenueAspectHealth: Pick<AspectDataHealth, 'closedViewDataStatus' | 'importedDataStatus' | 'overallDataStatus'>,
    }
  )> };

export type DocumentSegmentsQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type DocumentSegmentsQuery = { documentSegments: Array<(
    Pick<Format, 'id' | 'formatClass' | 'mimeType'>
    & { segments: Array<Pick<
        Segment,
        | 'fileId'
        | 'fileName'
        | 'fileSize'
        | 'sequence'
        | 'collectionId'
      >> }
  )> };

export type SegmentUrlQueryVariables = Exact<{
  segmentId?: InputMaybe<Scalars['String']['input']>;
  collectionId?: InputMaybe<Scalars['String']['input']>;
  fileId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SegmentUrlQuery = Pick<Query, 'segmentURL'>;

export type CreateDoppelgangerPermitMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  justification?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateDoppelgangerPermitMutation = { createDoppelgangerPermit: (
    Pick<AdminDoppelgangerPermit, 'justification' | 'sessionStartedAt' | 'sessionEndedAt'>
    & {
      doppelgangerPermit: (
        Pick<DoppelgangerPermit, 'id' | 'expiresAt' | 'createdAt'>
        & { user: (
          Pick<
            User,
            | 'id'
            | 'givenName'
            | 'familyName'
            | 'primaryEmailAddress'
            | 'passwordSet'
            | 'avatarUrl'
            | 'createdAt'
            | 'lastActivityAt'
          >
          & {
            employments?: Maybe<Array<(
              Pick<OrganizationEmployment, 'employeeId'>
              & {
                role: Pick<Role, 'id'>,
                organization: Pick<
                    Organization,
                    | 'id'
                    | 'slug'
                    | 'name'
                    | 'iconUrl'
                    | 'websiteUrl'
                    | 'kind'
                  >,
                legalEntityRoles?: Maybe<Array<(
                  Pick<EmployeeLegalEntityRole, 'legalEntityId'>
                  & { role?: Maybe<Pick<Role, 'id'>> }
                )>>,
              }
            )>>,
            identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
          }
        ) }
      ),
      authorizer: (
        Pick<
          Superuser,
          | 'id'
          | 'givenName'
          | 'familyName'
          | 'emailAddress'
          | 'avatarUrl'
          | 'createdAt'
          | 'lastLoginAt'
        >
        & { roles: Array<Pick<SuperuserRole, 'identifier' | 'displayName' | 'description'>> }
      ),
    }
  ) };

export type ListDoppelgangerPermitsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListDoppelgangerPermitsQuery = { listDoppelgangerPermits: Array<Maybe<(
    Pick<AdminDoppelgangerPermit, 'justification' | 'sessionStartedAt' | 'sessionEndedAt'>
    & {
      doppelgangerPermit: (
        Pick<DoppelgangerPermit, 'id' | 'expiresAt' | 'createdAt'>
        & { user: (
          Pick<
            User,
            | 'id'
            | 'givenName'
            | 'familyName'
            | 'primaryEmailAddress'
            | 'passwordSet'
            | 'avatarUrl'
            | 'createdAt'
            | 'lastActivityAt'
          >
          & {
            employments?: Maybe<Array<(
              Pick<OrganizationEmployment, 'employeeId'>
              & {
                role: Pick<Role, 'id'>,
                organization: Pick<
                    Organization,
                    | 'id'
                    | 'slug'
                    | 'name'
                    | 'iconUrl'
                    | 'websiteUrl'
                    | 'kind'
                  >,
                legalEntityRoles?: Maybe<Array<(
                  Pick<EmployeeLegalEntityRole, 'legalEntityId'>
                  & { role?: Maybe<Pick<Role, 'id'>> }
                )>>,
              }
            )>>,
            identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
          }
        ) }
      ),
      authorizer: (
        Pick<
          Superuser,
          | 'id'
          | 'givenName'
          | 'familyName'
          | 'emailAddress'
          | 'avatarUrl'
          | 'createdAt'
          | 'lastLoginAt'
        >
        & { roles: Array<Pick<SuperuserRole, 'identifier' | 'displayName' | 'description'>> }
      ),
    }
  )>> };

export type AdminEmployeeFieldsFragment = (
  Pick<
    AdminEmployee,
    | 'provider'
    | 'externalId'
    | 'origin'
    | 'createdAt'
  >
  & { employee: (
    Pick<
      Employee,
      | 'id'
      | 'organizationId'
      | 'givenName'
      | 'familyName'
      | 'avatarUrl'
      | 'emailAddress'
      | 'jobTitle'
      | 'lastActivityAt'
      | 'status'
      | 'hiddenAt'
    >
    & {
      role?: Maybe<Pick<Role, 'id'>>,
      defaultEntityRole?: Maybe<Pick<Role, 'id'>>,
      user?: Maybe<(
        Pick<
          User,
          | 'id'
          | 'givenName'
          | 'familyName'
          | 'primaryEmailAddress'
          | 'passwordSet'
          | 'avatarUrl'
          | 'createdAt'
          | 'lastActivityAt'
        >
        & {
          employments?: Maybe<Array<(
            Pick<OrganizationEmployment, 'employeeId'>
            & {
              role: Pick<Role, 'id'>,
              organization: Pick<
                  Organization,
                  | 'id'
                  | 'slug'
                  | 'name'
                  | 'iconUrl'
                  | 'websiteUrl'
                  | 'kind'
                >,
              legalEntityRoles?: Maybe<Array<(
                Pick<EmployeeLegalEntityRole, 'legalEntityId'>
                & { role?: Maybe<Pick<Role, 'id'>> }
              )>>,
            }
          )>>,
          identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
        }
      )>,
      invitation?: Maybe<(
        Pick<
          Invitation,
          | 'id'
          | 'invitationType'
          | 'status'
          | 'service'
          | 'organizationTemplateId'
          | 'createdAt'
          | 'updatedAt'
          | 'notifiedAt'
        >
        & {
          recipient: Pick<
              Contact,
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >,
          sender?: Maybe<Pick<
              Contact,
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >>,
          organization?: Maybe<Pick<
              Organization,
              | 'id'
              | 'slug'
              | 'name'
              | 'iconUrl'
              | 'websiteUrl'
              | 'kind'
            >>,
          role?: Maybe<Pick<Role, 'id'>>,
        }
      )>,
      legalEntityRoles?: Maybe<Array<(
        Pick<EmployeeLegalEntityRole, 'legalEntityId'>
        & { role?: Maybe<Pick<Role, 'id'>> }
      )>>,
    }
  ) }
);

export type RemoveAffiliateEmploymentMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  employeeId: Scalars['String']['input'];
}>;


export type RemoveAffiliateEmploymentMutation = Pick<Mutation, 'removeAffiliateEmployment'>;

export type UpdateEmployeeHiddenMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  employeeId: Scalars['String']['input'];
  isHidden: Scalars['Boolean']['input'];
}>;


export type UpdateEmployeeHiddenMutation = Pick<Mutation, 'updateEmployeeHidden'>;

export type UpdateEmployeeStatusMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  employeeId: Scalars['String']['input'];
  status: EmployeeStatus;
}>;


export type UpdateEmployeeStatusMutation = { updateEmployeeStatus: (
    Pick<
      AdminEmployee,
      | 'provider'
      | 'externalId'
      | 'origin'
      | 'createdAt'
    >
    & { employee: (
      Pick<
        Employee,
        | 'id'
        | 'organizationId'
        | 'givenName'
        | 'familyName'
        | 'avatarUrl'
        | 'emailAddress'
        | 'jobTitle'
        | 'lastActivityAt'
        | 'status'
        | 'hiddenAt'
      >
      & {
        role?: Maybe<Pick<Role, 'id'>>,
        defaultEntityRole?: Maybe<Pick<Role, 'id'>>,
        user?: Maybe<(
          Pick<
            User,
            | 'id'
            | 'givenName'
            | 'familyName'
            | 'primaryEmailAddress'
            | 'passwordSet'
            | 'avatarUrl'
            | 'createdAt'
            | 'lastActivityAt'
          >
          & {
            employments?: Maybe<Array<(
              Pick<OrganizationEmployment, 'employeeId'>
              & {
                role: Pick<Role, 'id'>,
                organization: Pick<
                    Organization,
                    | 'id'
                    | 'slug'
                    | 'name'
                    | 'iconUrl'
                    | 'websiteUrl'
                    | 'kind'
                  >,
                legalEntityRoles?: Maybe<Array<(
                  Pick<EmployeeLegalEntityRole, 'legalEntityId'>
                  & { role?: Maybe<Pick<Role, 'id'>> }
                )>>,
              }
            )>>,
            identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
          }
        )>,
        invitation?: Maybe<(
          Pick<
            Invitation,
            | 'id'
            | 'invitationType'
            | 'status'
            | 'service'
            | 'organizationTemplateId'
            | 'createdAt'
            | 'updatedAt'
            | 'notifiedAt'
          >
          & {
            recipient: Pick<
                Contact,
                | 'givenName'
                | 'familyName'
                | 'emailAddress'
                | 'avatarUrl'
              >,
            sender?: Maybe<Pick<
                Contact,
                | 'givenName'
                | 'familyName'
                | 'emailAddress'
                | 'avatarUrl'
              >>,
            organization?: Maybe<Pick<
                Organization,
                | 'id'
                | 'slug'
                | 'name'
                | 'iconUrl'
                | 'websiteUrl'
                | 'kind'
              >>,
            role?: Maybe<Pick<Role, 'id'>>,
          }
        )>,
        legalEntityRoles?: Maybe<Array<(
          Pick<EmployeeLegalEntityRole, 'legalEntityId'>
          & { role?: Maybe<Pick<Role, 'id'>> }
        )>>,
      }
    ) }
  ) };

export type ListEmployeesQueryVariables = Exact<{
  filter: EmployeeFilter;
  pagination: Pagination;
}>;


export type ListEmployeesQuery = { listEmployees: Array<(
    Pick<
      AdminEmployee,
      | 'provider'
      | 'externalId'
      | 'origin'
      | 'createdAt'
    >
    & { employee: (
      Pick<
        Employee,
        | 'id'
        | 'organizationId'
        | 'givenName'
        | 'familyName'
        | 'avatarUrl'
        | 'emailAddress'
        | 'jobTitle'
        | 'lastActivityAt'
        | 'status'
        | 'hiddenAt'
      >
      & {
        role?: Maybe<Pick<Role, 'id'>>,
        defaultEntityRole?: Maybe<Pick<Role, 'id'>>,
        user?: Maybe<(
          Pick<
            User,
            | 'id'
            | 'givenName'
            | 'familyName'
            | 'primaryEmailAddress'
            | 'passwordSet'
            | 'avatarUrl'
            | 'createdAt'
            | 'lastActivityAt'
          >
          & {
            employments?: Maybe<Array<(
              Pick<OrganizationEmployment, 'employeeId'>
              & {
                role: Pick<Role, 'id'>,
                organization: Pick<
                    Organization,
                    | 'id'
                    | 'slug'
                    | 'name'
                    | 'iconUrl'
                    | 'websiteUrl'
                    | 'kind'
                  >,
                legalEntityRoles?: Maybe<Array<(
                  Pick<EmployeeLegalEntityRole, 'legalEntityId'>
                  & { role?: Maybe<Pick<Role, 'id'>> }
                )>>,
              }
            )>>,
            identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
          }
        )>,
        invitation?: Maybe<(
          Pick<
            Invitation,
            | 'id'
            | 'invitationType'
            | 'status'
            | 'service'
            | 'organizationTemplateId'
            | 'createdAt'
            | 'updatedAt'
            | 'notifiedAt'
          >
          & {
            recipient: Pick<
                Contact,
                | 'givenName'
                | 'familyName'
                | 'emailAddress'
                | 'avatarUrl'
              >,
            sender?: Maybe<Pick<
                Contact,
                | 'givenName'
                | 'familyName'
                | 'emailAddress'
                | 'avatarUrl'
              >>,
            organization?: Maybe<Pick<
                Organization,
                | 'id'
                | 'slug'
                | 'name'
                | 'iconUrl'
                | 'websiteUrl'
                | 'kind'
              >>,
            role?: Maybe<Pick<Role, 'id'>>,
          }
        )>,
        legalEntityRoles?: Maybe<Array<(
          Pick<EmployeeLegalEntityRole, 'legalEntityId'>
          & { role?: Maybe<Pick<Role, 'id'>> }
        )>>,
      }
    ) }
  )> };

export type AdminInstitutionFieldsFragment = (
  Pick<AdminInstitution, 'id' | 'products'>
  & {
    institution: Pick<
        Institution,
        | 'id'
        | 'name'
        | 'url'
        | 'routingNumber'
        | 'iconUrl'
        | 'partyId'
        | 'createdAt'
      >,
    party?: Maybe<Pick<
        Party,
        | 'id'
        | 'legalEntityId'
        | 'name'
        | 'url'
        | 'supportUrl'
        | 'supportEmail'
        | 'supportPhone'
        | 'twitterUrl'
        | 'facebookUrl'
        | 'instagramUrl'
        | 'yelpUrl'
        | 'iconUrl'
        | 'shortDescription'
        | 'designation'
      >>,
  }
);

export type CreateInstitutionMutationVariables = Exact<{
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
  routingNumber: Scalars['String']['input'];
  partyId: Scalars['String']['input'];
  kind: InstitutionKind;
}>;


export type CreateInstitutionMutation = { createInstitution: (
    Pick<AdminInstitution, 'id' | 'products'>
    & {
      institution: Pick<
          Institution,
          | 'id'
          | 'name'
          | 'url'
          | 'routingNumber'
          | 'iconUrl'
          | 'partyId'
          | 'createdAt'
        >,
      party?: Maybe<Pick<
          Party,
          | 'id'
          | 'legalEntityId'
          | 'name'
          | 'url'
          | 'supportUrl'
          | 'supportEmail'
          | 'supportPhone'
          | 'twitterUrl'
          | 'facebookUrl'
          | 'instagramUrl'
          | 'yelpUrl'
          | 'iconUrl'
          | 'shortDescription'
          | 'designation'
        >>,
    }
  ) };

export type UpdateInstitutionMutationVariables = Exact<{
  institution_id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
  routingNumber: Scalars['String']['input'];
}>;


export type UpdateInstitutionMutation = Pick<Mutation, 'updateInstitution'>;

export type UpdateInstitutionPartyMutationVariables = Exact<{
  institutionId: Scalars['String']['input'];
  partyId: Scalars['String']['input'];
}>;


export type UpdateInstitutionPartyMutation = Pick<Mutation, 'updateInstitutionParty'>;

export type UpdateInstitutionProductsMutationVariables = Exact<{
  institutionId: Scalars['String']['input'];
  products: Array<InstitutionProduct> | InstitutionProduct;
}>;


export type UpdateInstitutionProductsMutation = Pick<Mutation, 'updateInstitutionProducts'>;

export type GetInstitutionQueryVariables = Exact<{
  institutionId: Scalars['String']['input'];
}>;


export type GetInstitutionQuery = { getInstitution: (
    Pick<AdminInstitution, 'id' | 'products'>
    & {
      institution: Pick<
          Institution,
          | 'id'
          | 'name'
          | 'url'
          | 'routingNumber'
          | 'iconUrl'
          | 'partyId'
          | 'createdAt'
        >,
      party?: Maybe<Pick<
          Party,
          | 'id'
          | 'legalEntityId'
          | 'name'
          | 'url'
          | 'supportUrl'
          | 'supportEmail'
          | 'supportPhone'
          | 'twitterUrl'
          | 'facebookUrl'
          | 'instagramUrl'
          | 'yelpUrl'
          | 'iconUrl'
          | 'shortDescription'
          | 'designation'
        >>,
    }
  ) };

export type ListInstitutionsQueryVariables = Exact<{
  pagination: Pagination;
}>;


export type ListInstitutionsQuery = { listInstitutions: Array<(
    Pick<AdminInstitution, 'id' | 'products'>
    & {
      institution: Pick<
          Institution,
          | 'id'
          | 'name'
          | 'url'
          | 'routingNumber'
          | 'iconUrl'
          | 'partyId'
          | 'createdAt'
        >,
      party?: Maybe<Pick<
          Party,
          | 'id'
          | 'legalEntityId'
          | 'name'
          | 'url'
          | 'supportUrl'
          | 'supportEmail'
          | 'supportPhone'
          | 'twitterUrl'
          | 'facebookUrl'
          | 'instagramUrl'
          | 'yelpUrl'
          | 'iconUrl'
          | 'shortDescription'
          | 'designation'
        >>,
    }
  )> };

export type AdminInvitationFieldsFragment = {
    invitation: (
      Pick<
        Invitation,
        | 'acceptedAt'
        | 'id'
        | 'invitationType'
        | 'status'
        | 'service'
        | 'organizationTemplateId'
        | 'createdAt'
        | 'updatedAt'
        | 'notifiedAt'
      >
      & {
        recipient: Pick<
            Contact,
            | 'givenName'
            | 'familyName'
            | 'emailAddress'
            | 'avatarUrl'
          >,
        sender?: Maybe<Pick<
            Contact,
            | 'givenName'
            | 'familyName'
            | 'emailAddress'
            | 'avatarUrl'
          >>,
        organization?: Maybe<Pick<
            Organization,
            | 'id'
            | 'slug'
            | 'name'
            | 'iconUrl'
            | 'websiteUrl'
            | 'kind'
          >>,
        role?: Maybe<Pick<Role, 'id'>>,
      }
    ),
    senderSuperuser?: Maybe<(
      Pick<
        Superuser,
        | 'id'
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
        | 'createdAt'
        | 'lastLoginAt'
      >
      & { roles: Array<Pick<SuperuserRole, 'identifier' | 'displayName' | 'description'>> }
    )>,
    emailStatus?: Maybe<Pick<EmailStatus, 'rawStatus' | 'updatedAt'>>,
  };

export type SendManagedOperatorInvitationMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  affiliateUserId: Scalars['String']['input'];
  affiliateOrganizationId: Scalars['String']['input'];
  recipient: ContactInput;
  legalEntityId: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  redirectPath?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendManagedOperatorInvitationMutation = Pick<Mutation, 'sendManagedOperatorInvitation'>;

export type CancelInvitationMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type CancelInvitationMutation = Pick<Mutation, 'cancelInvitation'>;

export type ResendInvitationMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type ResendInvitationMutation = Pick<Mutation, 'resendInvitation'>;

export type AdminSendInvitationMutationVariables = Exact<{
  emailAddress: Scalars['String']['input'];
  givenName?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  destinationOrganizationId?: InputMaybe<Scalars['String']['input']>;
  destinationOrganizationRole?: InputMaybe<Scalars['String']['input']>;
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  invitationType: Scalars['String']['input'];
  proposalType?: InputMaybe<ProposalType>;
}>;


export type AdminSendInvitationMutation = Pick<Mutation, 'sendInvitation'>;

export type ListInvitationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListInvitationsQuery = { listInvitations: Array<{
      invitation: (
        Pick<
          Invitation,
          | 'acceptedAt'
          | 'id'
          | 'invitationType'
          | 'status'
          | 'service'
          | 'organizationTemplateId'
          | 'createdAt'
          | 'updatedAt'
          | 'notifiedAt'
        >
        & {
          recipient: Pick<
              Contact,
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >,
          sender?: Maybe<Pick<
              Contact,
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >>,
          organization?: Maybe<Pick<
              Organization,
              | 'id'
              | 'slug'
              | 'name'
              | 'iconUrl'
              | 'websiteUrl'
              | 'kind'
            >>,
          role?: Maybe<Pick<Role, 'id'>>,
        }
      ),
      senderSuperuser?: Maybe<(
        Pick<
          Superuser,
          | 'id'
          | 'givenName'
          | 'familyName'
          | 'emailAddress'
          | 'avatarUrl'
          | 'createdAt'
          | 'lastLoginAt'
        >
        & { roles: Array<Pick<SuperuserRole, 'identifier' | 'displayName' | 'description'>> }
      )>,
      emailStatus?: Maybe<Pick<EmailStatus, 'rawStatus' | 'updatedAt'>>,
    }> };

export type ListInvitationsByOrganizationQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type ListInvitationsByOrganizationQuery = { listInvitationsByOrganization: Array<{
      invitation: (
        Pick<
          Invitation,
          | 'acceptedAt'
          | 'id'
          | 'invitationType'
          | 'status'
          | 'service'
          | 'organizationTemplateId'
          | 'createdAt'
          | 'updatedAt'
          | 'notifiedAt'
        >
        & {
          recipient: Pick<
              Contact,
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >,
          sender?: Maybe<Pick<
              Contact,
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >>,
          organization?: Maybe<Pick<
              Organization,
              | 'id'
              | 'slug'
              | 'name'
              | 'iconUrl'
              | 'websiteUrl'
              | 'kind'
            >>,
          role?: Maybe<Pick<Role, 'id'>>,
        }
      ),
      senderSuperuser?: Maybe<(
        Pick<
          Superuser,
          | 'id'
          | 'givenName'
          | 'familyName'
          | 'emailAddress'
          | 'avatarUrl'
          | 'createdAt'
          | 'lastLoginAt'
        >
        & { roles: Array<Pick<SuperuserRole, 'identifier' | 'displayName' | 'description'>> }
      )>,
      emailStatus?: Maybe<Pick<EmailStatus, 'rawStatus' | 'updatedAt'>>,
    }> };

export type ReadInvitationQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type ReadInvitationQuery = { readInvitation: {
      invitation: (
        Pick<
          Invitation,
          | 'acceptedAt'
          | 'id'
          | 'invitationType'
          | 'status'
          | 'service'
          | 'organizationTemplateId'
          | 'createdAt'
          | 'updatedAt'
          | 'notifiedAt'
        >
        & {
          recipient: Pick<
              Contact,
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >,
          sender?: Maybe<Pick<
              Contact,
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >>,
          organization?: Maybe<Pick<
              Organization,
              | 'id'
              | 'slug'
              | 'name'
              | 'iconUrl'
              | 'websiteUrl'
              | 'kind'
            >>,
          role?: Maybe<Pick<Role, 'id'>>,
        }
      ),
      senderSuperuser?: Maybe<(
        Pick<
          Superuser,
          | 'id'
          | 'givenName'
          | 'familyName'
          | 'emailAddress'
          | 'avatarUrl'
          | 'createdAt'
          | 'lastLoginAt'
        >
        & { roles: Array<Pick<SuperuserRole, 'identifier' | 'displayName' | 'description'>> }
      )>,
      emailStatus?: Maybe<Pick<EmailStatus, 'rawStatus' | 'updatedAt'>>,
    } };

export type ReadInvitationBySignupQueryVariables = Exact<{
  signupId: Scalars['String']['input'];
}>;


export type ReadInvitationBySignupQuery = { readInvitationBySignup: {
      invitation: (
        Pick<
          Invitation,
          | 'acceptedAt'
          | 'id'
          | 'invitationType'
          | 'status'
          | 'service'
          | 'organizationTemplateId'
          | 'createdAt'
          | 'updatedAt'
          | 'notifiedAt'
        >
        & {
          recipient: Pick<
              Contact,
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >,
          sender?: Maybe<Pick<
              Contact,
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >>,
          organization?: Maybe<Pick<
              Organization,
              | 'id'
              | 'slug'
              | 'name'
              | 'iconUrl'
              | 'websiteUrl'
              | 'kind'
            >>,
          role?: Maybe<Pick<Role, 'id'>>,
        }
      ),
      senderSuperuser?: Maybe<(
        Pick<
          Superuser,
          | 'id'
          | 'givenName'
          | 'familyName'
          | 'emailAddress'
          | 'avatarUrl'
          | 'createdAt'
          | 'lastLoginAt'
        >
        & { roles: Array<Pick<SuperuserRole, 'identifier' | 'displayName' | 'description'>> }
      )>,
      emailStatus?: Maybe<Pick<EmailStatus, 'rawStatus' | 'updatedAt'>>,
    } };

export type GetInvoiceMigrationReportQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  type: InvoiceMigrationReportType;
  timestamp: Scalars['String']['input'];
}>;


export type GetInvoiceMigrationReportQuery = { invoiceMigrationReport: (
    Pick<InvoiceMigrationReport, 'markdown'>
    & { summary: Pick<
        InvoiceMigrationReportSummary,
        | 'legalEntityId'
        | 'type'
        | 'timestamp'
        | 'sizeBytes'
        | 'gcsObjectKey'
      > }
  ) };

export type ListInvoiceMigrationReportsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ListInvoiceMigrationReportsQuery = { listInvoiceMigrationReports: Array<Pick<
      InvoiceMigrationReportSummary,
      | 'legalEntityId'
      | 'type'
      | 'timestamp'
      | 'gcsObjectKey'
    >> };

export type BlockPaymentsMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  description: Scalars['String']['input'];
}>;


export type BlockPaymentsMutation = Pick<Mutation, 'blockPayments'>;

export type BootstrapSandboxAccountingOrganizationMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type BootstrapSandboxAccountingOrganizationMutation = Pick<Mutation, 'bootstrapSandboxAccountingOrganization'>;

export type CloseAdyenAccountHolderMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  description: Scalars['String']['input'];
}>;


export type CloseAdyenAccountHolderMutation = Pick<Mutation, 'closeAdyenAccountHolder'>;

export type ExportSandboxDataMutationVariables = Exact<{
  sandboxType: SandboxType;
  industry: SandboxIndustry;
}>;


export type ExportSandboxDataMutation = Pick<Mutation, 'exportSandboxData'>;

export type ReactivateAdyenAccountHolderMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  description: Scalars['String']['input'];
}>;


export type ReactivateAdyenAccountHolderMutation = Pick<Mutation, 'reactivateAdyenAccountHolder'>;

export type ResendActivationEmailMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  recipientId: Scalars['String']['input'];
}>;


export type ResendActivationEmailMutation = Pick<Mutation, 'resendActivationEmail'>;

export type SetLegalEntitySlugMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  newSlug: Scalars['String']['input'];
  updateOrganizationSlug: Scalars['Boolean']['input'];
}>;


export type SetLegalEntitySlugMutation = Pick<Mutation, 'setLegalEntitySlug'>;

export type ToggleRestrictedCapabilityMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  capability: RestrictedCapabilityName;
  enabled: Scalars['Boolean']['input'];
}>;


export type ToggleRestrictedCapabilityMutation = { toggleRestrictedCapability: Pick<RestrictedCapabilityToggleResult, 'legalEntityId' | 'capability' | 'enabled'> };

export type UpdateLegalEntityStatusMutationVariables = Exact<{
  id: Scalars['String']['input'];
  status: LegalEntityStatus;
}>;


export type UpdateLegalEntityStatusMutation = Pick<Mutation, 'updateLegalEntityStatus'>;

export type UploadAdyenDocumentMutationVariables = Exact<{
  accountHolderId: Scalars['String']['input'];
  documentType: Scalars['String']['input'];
  description: Scalars['String']['input'];
  fileContent: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  fileName?: InputMaybe<Scalars['String']['input']>;
}>;


export type UploadAdyenDocumentMutation = Pick<Mutation, 'uploadAdyenDocument'>;

export type GetFraudCheckResultQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type GetFraudCheckResultQuery = { getFraudCheckResult: Pick<
      FraudCheckResult,
      | 'legalEntityId'
      | 'hasResult'
      | 'riskFlag'
      | 'reasonsJson'
      | 'updatedAt'
    > };

export type LegalEntityValidationProgressQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type LegalEntityValidationProgressQuery = { legalEntityValidationProgress?: Maybe<{ mlProcessedTransactionsStatus: Array<Pick<MlProcessedTransactionsStatus, 'dataSourceId' | 'totalTransactionsCount' | 'mlProcessedTransactionsCount'>> }> };

export type ListAdyenVerificationStatusesQueryVariables = Exact<{
  statusFilter?: InputMaybe<BusinessVerificationStatus>;
}>;


export type ListAdyenVerificationStatusesQuery = { listAdyenVerificationStatuses: Array<(
    Pick<
      AdyenLegalEntityStatus,
      | 'legalEntityId'
      | 'legalEntityName'
      | 'overallStatus'
      | 'hasVerificationErrors'
      | 'hasUpcomingDeadlines'
      | 'statusAt'
      | 'accountHolderStatus'
      | 'checkbookStatus'
    >
    & { entityStatuses: Array<Pick<AdyenEntityVerificationStatus, 'externalLegalEntityId' | 'entityType' | 'verificationStatus'>> }
  )> };

export type ListLegalEntitiesQueryVariables = Exact<{
  pagination: Pagination;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  includedStatuses?: InputMaybe<Array<LegalEntityStatus> | LegalEntityStatus>;
  excludedStatuses?: InputMaybe<Array<LegalEntityStatus> | LegalEntityStatus>;
  legalEntityIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  includedBillingProductIDs?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  excludedBillingProductIDs?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  noEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  noAffiliations?: InputMaybe<Scalars['Boolean']['input']>;
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  kind?: InputMaybe<OrganizationKind>;
}>;


export type ListLegalEntitiesQuery = { listLegalEntities: Array<(
    Pick<AdminLegalEntity, 'createdAt' | 'userCount' | 'deletedAt'>
    & { legalEntity: (
      Pick<
        LegalEntity,
        | 'id'
        | 'slug'
        | 'name'
        | 'websiteUrl'
        | 'industry'
        | 'timezone'
        | 'fiscalYearStartMonth'
        | 'fiscalYearNumberOffset'
        | 'status'
        | 'organizationId'
        | 'sensitive'
        | 'phoneNumber'
        | 'iconUrl'
      >
      & {
        address: Pick<
            Address,
            | 'street'
            | 'streetAdditional'
            | 'city'
            | 'region'
            | 'postalCode'
            | 'countryCode'
            | 'lat'
            | 'long'
          >,
        incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
      }
    ) }
  )> };

export type ListLegalEntityTransfersQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  createdSince?: InputMaybe<Scalars['String']['input']>;
  createdUntil?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListLegalEntityTransfersQuery = { listLegalEntityTransfers: (
    Pick<LegalEntityTransfersResult, 'accountHolderId'>
    & { transfers: Array<(
      Pick<
        AdminTransferSummary,
        | 'transferId'
        | 'type'
        | 'category'
        | 'direction'
        | 'status'
        | 'description'
        | 'createdAt'
        | 'reference'
        | 'platformPaymentType'
        | 'pspReference'
      >
      & { amount: Pick<MonetaryValue, 'amount' | 'iso4217CurrencyCode' | 'currencyMultiplier'> }
    )> }
  ) };

export type ListRestrictedCapabilitiesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ListRestrictedCapabilitiesQuery = { listRestrictedCapabilities: (
    Pick<RestrictedCapabilitiesResult, 'legalEntityId'>
    & { capabilities: Array<Pick<RestrictedCapabilityStatus, 'capability' | 'enabled'>> }
  ) };

export type ReadAdyenAccountHolderStatusQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ReadAdyenAccountHolderStatusQuery = { readAdyenAccountHolderStatus?: Maybe<Pick<AdyenAccountHolderStatus, 'overallStatus' | 'accountHolderStatus' | 'checkbookStatus'>> };

export type ReadBusinessVerificationStatusQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ReadBusinessVerificationStatusQuery = { readBusinessVerificationStatus: Pick<BusinessVerificationStatusResult, 'status' | 'statusAt'> };

export type ReadDetailedAdyenStatusQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ReadDetailedAdyenStatusQuery = { readDetailedAdyenStatus?: Maybe<(
    Pick<
      DetailedAdyenStatus,
      | 'overallStatus'
      | 'statusAt'
      | 'externalOrganizationLegalEntityId'
      | 'externalPrimaryLegalEntityId'
      | 'accountHolderId'
      | 'accountHolderStatus'
      | 'checkbookStatus'
    >
    & {
      companyVerification?: Maybe<(
        Pick<
          AdyenEntityVerification,
          | 'entityId'
          | 'entityType'
          | 'name'
          | 'status'
        >
        & { problems: Array<Pick<
            AdyenVerificationProblem,
            | 'type'
            | 'code'
            | 'message'
            | 'remediationMessage'
          >> }
      )>,
      identityVerifications: Array<(
        Pick<
          AdyenEntityVerification,
          | 'entityId'
          | 'entityType'
          | 'name'
          | 'status'
        >
        & { problems: Array<Pick<
            AdyenVerificationProblem,
            | 'type'
            | 'code'
            | 'message'
            | 'remediationMessage'
          >> }
      )>,
      capabilities: Array<Pick<
          AdyenCapabilityStatus,
          | 'capabilityName'
          | 'allowed'
          | 'requested'
          | 'verificationStatus'
        >>,
      verificationErrors: Array<Pick<
          AdyenVerificationError,
          | 'code'
          | 'message'
          | 'remediationMessage'
          | 'entityType'
          | 'field'
        >>,
      deadlines: Array<Pick<AdyenVerificationDeadline, 'capability' | 'expiresAt'>>,
      documents: Array<Pick<
          AdyenDocumentDetail,
          | 'id'
          | 'documentType'
          | 'description'
          | 'fileName'
          | 'active'
          | 'modificationDate'
        >>,
    }
  )> };

export type ReadLegalEntityQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ReadLegalEntityQuery = { readLegalEntity: (
    Pick<AdminLegalEntity, 'createdAt' | 'userCount' | 'deletedAt'>
    & { legalEntity: (
      Pick<
        LegalEntity,
        | 'id'
        | 'slug'
        | 'name'
        | 'websiteUrl'
        | 'industry'
        | 'timezone'
        | 'fiscalYearStartMonth'
        | 'fiscalYearNumberOffset'
        | 'status'
        | 'organizationId'
        | 'sensitive'
        | 'phoneNumber'
        | 'iconUrl'
      >
      & {
        address: Pick<
            Address,
            | 'street'
            | 'streetAdditional'
            | 'city'
            | 'region'
            | 'postalCode'
            | 'countryCode'
            | 'lat'
            | 'long'
          >,
        incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
      }
    ) }
  ) };

export type ReadLegalEntityPreferencesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ReadLegalEntityPreferencesQuery = { readLegalEntityPreferences: Pick<
      LegalEntityPreferences,
      | 'legalEntityId'
      | 'isCogsInExpenses'
      | 'lineClassDisplayName'
      | 'lineClassPluralDisplayName'
      | 'bookkeeperAiCutoverAt'
    > };

export type PullRequestFieldsFragment = (
  Pick<
    PullRequest,
    | 'url'
    | 'title'
    | 'repo'
    | 'number'
    | 'branch'
    | 'prState'
  >
  & {
    labels?: Maybe<Array<Pick<PullRequestLabel, 'name' | 'hexColor'>>>,
    author: Pick<
        PullRequestAuthor,
        | 'id'
        | 'name'
        | 'login'
        | 'avatarUrl'
      >,
  }
);

export type MergeMigrationPullRequestMutationVariables = Exact<{
  repo: Scalars['String']['input'];
  prNumber: Scalars['Int']['input'];
}>;


export type MergeMigrationPullRequestMutation = Pick<Mutation, 'mergeMigrationPullRequest'>;

export type RunMigrationPullRequestMutationVariables = Exact<{
  repo: Scalars['String']['input'];
  prNumber: Scalars['Int']['input'];
  filename: Scalars['String']['input'];
  isPartitionableDML: Scalars['Boolean']['input'];
  overrideMigrationRecord?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RunMigrationPullRequestMutation = Pick<Mutation, 'runMigrationPullRequest'>;

export type ListMigrationPullRequestsQueryVariables = Exact<{
  repo: Scalars['String']['input'];
  anyLabel?: InputMaybe<Scalars['Boolean']['input']>;
  prState?: InputMaybe<PullRequestFilterState>;
}>;


export type ListMigrationPullRequestsQuery = { listMigrationPullRequests: Array<(
    Pick<
      PullRequest,
      | 'url'
      | 'title'
      | 'repo'
      | 'number'
      | 'branch'
      | 'prState'
    >
    & {
      labels?: Maybe<Array<Pick<PullRequestLabel, 'name' | 'hexColor'>>>,
      author: Pick<
          PullRequestAuthor,
          | 'id'
          | 'name'
          | 'login'
          | 'avatarUrl'
        >,
    }
  )> };

export type ReadMigrationPullRequestQueryVariables = Exact<{
  repo: Scalars['String']['input'];
  prNumber: Scalars['Int']['input'];
}>;


export type ReadMigrationPullRequestQuery = { readMigrationPullRequest: {
      pullRequestSummary: (
        Pick<PullRequestSummary, 'reviewStatus' | 'mergeableStatus' | 'merged'>
        & { pullRequest: (
          Pick<
            PullRequest,
            | 'url'
            | 'title'
            | 'repo'
            | 'number'
            | 'branch'
            | 'prState'
          >
          & {
            labels?: Maybe<Array<Pick<PullRequestLabel, 'name' | 'hexColor'>>>,
            author: Pick<
                PullRequestAuthor,
                | 'id'
                | 'name'
                | 'login'
                | 'avatarUrl'
              >,
          }
        ) }
      ),
      fileSummaries: Array<(
        Pick<MigrationFileSummary, 'hasRun'>
        & { file: Pick<PullRequestFile, 'name' | 'contents' | 'url'> }
      )>,
    } };

export type UpdateEmailDeliveryPreferencesMutationVariables = Exact<{
  emailAddress: Scalars['String']['input'];
  receiveEmails: Scalars['Boolean']['input'];
}>;


export type UpdateEmailDeliveryPreferencesMutation = Pick<Mutation, 'updateEmailDeliveryPreferences'>;

export type ReadEmailHtmlQueryVariables = Exact<{
  eventType: EventType;
}>;


export type ReadEmailHtmlQuery = Pick<Query, 'readEmailHTML'>;

export type ObjectMappingHierarchyNodeFieldsFragment = Pick<
    ObjectMappingHierarchyNode,
    | 'factId'
    | 'name'
    | 'parentId'
    | 'active'
    | 'transactionCount'
    | 'mappedTo'
    | 'depth'
    | 'fullyQualifiedName'
  >;

export type ListDepartmentFactHierarchyQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ListDepartmentFactHierarchyQuery = { listDepartmentFactHierarchy: Array<Pick<
      ObjectMappingHierarchyNode,
      | 'factId'
      | 'name'
      | 'parentId'
      | 'active'
      | 'transactionCount'
      | 'mappedTo'
      | 'depth'
      | 'fullyQualifiedName'
    >> };

export type ListLineClassFactHierarchyQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ListLineClassFactHierarchyQuery = { listLineClassFactHierarchy: Array<Pick<
      ObjectMappingHierarchyNode,
      | 'factId'
      | 'name'
      | 'parentId'
      | 'active'
      | 'transactionCount'
      | 'mappedTo'
      | 'depth'
      | 'fullyQualifiedName'
    >> };

export type SetOrganizationSlugMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  newSlug: Scalars['String']['input'];
}>;


export type SetOrganizationSlugMutation = Pick<Mutation, 'setOrganizationSlug'>;

export type ListAffiliatedOrganizationsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ListAffiliatedOrganizationsQuery = { listAffiliatedOrganizations: Array<(
    Pick<AdminOrganization, 'createdAt' | 'deletedAt' | 'userCount'>
    & {
      organization: Pick<
          Organization,
          | 'id'
          | 'slug'
          | 'name'
          | 'iconUrl'
          | 'websiteUrl'
          | 'kind'
        >,
      legalEntities: Array<(
        Pick<AdminLegalEntity, 'createdAt' | 'userCount' | 'deletedAt'>
        & { legalEntity: (
          Pick<
            LegalEntity,
            | 'id'
            | 'slug'
            | 'name'
            | 'websiteUrl'
            | 'industry'
            | 'timezone'
            | 'fiscalYearStartMonth'
            | 'fiscalYearNumberOffset'
            | 'status'
            | 'organizationId'
            | 'sensitive'
            | 'phoneNumber'
            | 'iconUrl'
          >
          & {
            address: Pick<
                Address,
                | 'street'
                | 'streetAdditional'
                | 'city'
                | 'region'
                | 'postalCode'
                | 'countryCode'
                | 'lat'
                | 'long'
              >,
            incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
          }
        ) }
      )>,
      affiliateLegalEntities: Array<(
        Pick<AdminLegalEntity, 'createdAt' | 'userCount' | 'deletedAt'>
        & { legalEntity: (
          Pick<
            LegalEntity,
            | 'id'
            | 'slug'
            | 'name'
            | 'websiteUrl'
            | 'industry'
            | 'timezone'
            | 'fiscalYearStartMonth'
            | 'fiscalYearNumberOffset'
            | 'status'
            | 'organizationId'
            | 'sensitive'
            | 'phoneNumber'
            | 'iconUrl'
          >
          & {
            address: Pick<
                Address,
                | 'street'
                | 'streetAdditional'
                | 'city'
                | 'region'
                | 'postalCode'
                | 'countryCode'
                | 'lat'
                | 'long'
              >,
            incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
          }
        ) }
      )>,
    }
  )> };

export type ListOrganizationsQueryVariables = Exact<{
  pagination?: InputMaybe<Pagination>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  affiliateType?: InputMaybe<AffiliateType>;
  kind?: InputMaybe<OrganizationKind>;
  organizationIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  onlyWithEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type ListOrganizationsQuery = { listOrganizations: Array<(
    Pick<AdminOrganization, 'createdAt' | 'deletedAt' | 'userCount'>
    & {
      organization: Pick<
          Organization,
          | 'id'
          | 'slug'
          | 'name'
          | 'iconUrl'
          | 'websiteUrl'
          | 'kind'
        >,
      legalEntities: Array<(
        Pick<AdminLegalEntity, 'createdAt' | 'userCount' | 'deletedAt'>
        & { legalEntity: (
          Pick<
            LegalEntity,
            | 'id'
            | 'slug'
            | 'name'
            | 'websiteUrl'
            | 'industry'
            | 'timezone'
            | 'fiscalYearStartMonth'
            | 'fiscalYearNumberOffset'
            | 'status'
            | 'organizationId'
            | 'sensitive'
            | 'phoneNumber'
            | 'iconUrl'
          >
          & {
            address: Pick<
                Address,
                | 'street'
                | 'streetAdditional'
                | 'city'
                | 'region'
                | 'postalCode'
                | 'countryCode'
                | 'lat'
                | 'long'
              >,
            incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
          }
        ) }
      )>,
      affiliateLegalEntities: Array<(
        Pick<AdminLegalEntity, 'createdAt' | 'userCount' | 'deletedAt'>
        & { legalEntity: (
          Pick<
            LegalEntity,
            | 'id'
            | 'slug'
            | 'name'
            | 'websiteUrl'
            | 'industry'
            | 'timezone'
            | 'fiscalYearStartMonth'
            | 'fiscalYearNumberOffset'
            | 'status'
            | 'organizationId'
            | 'sensitive'
            | 'phoneNumber'
            | 'iconUrl'
          >
          & {
            address: Pick<
                Address,
                | 'street'
                | 'streetAdditional'
                | 'city'
                | 'region'
                | 'postalCode'
                | 'countryCode'
                | 'lat'
                | 'long'
              >,
            incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
          }
        ) }
      )>,
    }
  )> };

export type ReadOrganizationQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ReadOrganizationQuery = { readOrganization: (
    Pick<AdminOrganization, 'createdAt' | 'deletedAt' | 'userCount'>
    & {
      organization: Pick<
          Organization,
          | 'id'
          | 'slug'
          | 'name'
          | 'iconUrl'
          | 'websiteUrl'
          | 'kind'
        >,
      legalEntities: Array<(
        Pick<AdminLegalEntity, 'createdAt' | 'userCount' | 'deletedAt'>
        & { legalEntity: (
          Pick<
            LegalEntity,
            | 'id'
            | 'slug'
            | 'name'
            | 'websiteUrl'
            | 'industry'
            | 'timezone'
            | 'fiscalYearStartMonth'
            | 'fiscalYearNumberOffset'
            | 'status'
            | 'organizationId'
            | 'sensitive'
            | 'phoneNumber'
            | 'iconUrl'
          >
          & {
            address: Pick<
                Address,
                | 'street'
                | 'streetAdditional'
                | 'city'
                | 'region'
                | 'postalCode'
                | 'countryCode'
                | 'lat'
                | 'long'
              >,
            incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
          }
        ) }
      )>,
      affiliateLegalEntities: Array<(
        Pick<AdminLegalEntity, 'createdAt' | 'userCount' | 'deletedAt'>
        & { legalEntity: (
          Pick<
            LegalEntity,
            | 'id'
            | 'slug'
            | 'name'
            | 'websiteUrl'
            | 'industry'
            | 'timezone'
            | 'fiscalYearStartMonth'
            | 'fiscalYearNumberOffset'
            | 'status'
            | 'organizationId'
            | 'sensitive'
            | 'phoneNumber'
            | 'iconUrl'
          >
          & {
            address: Pick<
                Address,
                | 'street'
                | 'streetAdditional'
                | 'city'
                | 'region'
                | 'postalCode'
                | 'countryCode'
                | 'lat'
                | 'long'
              >,
            incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
          }
        ) }
      )>,
    }
  ) };

export type AdminGlobalPartyFieldsFragment = (
  Pick<
    AdminGlobalParty,
    | 'transactionsCount'
    | 'aliases'
    | 'prefixes'
    | 'lastReviewedAt'
  >
  & { party: Pick<
      Party,
      | 'id'
      | 'legalEntityId'
      | 'name'
      | 'url'
      | 'supportUrl'
      | 'supportEmail'
      | 'supportPhone'
      | 'twitterUrl'
      | 'facebookUrl'
      | 'instagramUrl'
      | 'yelpUrl'
      | 'iconUrl'
      | 'shortDescription'
      | 'designation'
    > }
);

export type AdminPartyFieldsFragment = (
  Pick<AdminParty, 'transactionsCount' | 'lastTransactionOccurredAt'>
  & { party: Pick<
      Party,
      | 'id'
      | 'legalEntityId'
      | 'name'
      | 'url'
      | 'supportUrl'
      | 'supportEmail'
      | 'supportPhone'
      | 'twitterUrl'
      | 'facebookUrl'
      | 'instagramUrl'
      | 'yelpUrl'
      | 'iconUrl'
      | 'shortDescription'
      | 'designation'
    > }
);

export type PayrollProviderFieldsFragment = Pick<
    PayrollProvider,
    | 'legalEntityId'
    | 'partyId'
    | 'partyName'
    | 'payrollProviderType'
    | 'rangeStartedAt'
    | 'rangeEndedAt'
  >;

export type CreateAliasMutationVariables = Exact<{
  partyId: Scalars['String']['input'];
  alias: Scalars['String']['input'];
}>;


export type CreateAliasMutation = { createAlias: Pick<GlobalPartyAlias, 'partyId' | 'alias'> };

export type CreateGlobalPartyMutationVariables = Exact<{
  fields: NewParty;
  aliases: Array<Scalars['String']['input']> | Scalars['String']['input'];
  prefixes: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CreateGlobalPartyMutation = { createGlobalParty: (
    Pick<AdminParty, 'transactionsCount' | 'lastTransactionOccurredAt'>
    & { party: Pick<
        Party,
        | 'id'
        | 'legalEntityId'
        | 'name'
        | 'url'
        | 'supportUrl'
        | 'supportEmail'
        | 'supportPhone'
        | 'twitterUrl'
        | 'facebookUrl'
        | 'instagramUrl'
        | 'yelpUrl'
        | 'iconUrl'
        | 'shortDescription'
        | 'designation'
      > }
  ) };

export type CreatePrefixMappingMutationVariables = Exact<{
  prefix: Scalars['String']['input'];
  partyId: Scalars['String']['input'];
}>;


export type CreatePrefixMappingMutation = { createPrefixMapping: Pick<PrefixMapping, 'prefix' | 'partyId'> };

export type DeleteAliasMutationVariables = Exact<{
  partyId: Scalars['String']['input'];
  alias: Scalars['String']['input'];
}>;


export type DeleteAliasMutation = Pick<Mutation, 'deleteAlias'>;

export type DeleteGlobalPartyMutationVariables = Exact<{
  partyId: Scalars['String']['input'];
}>;


export type DeleteGlobalPartyMutation = Pick<Mutation, 'deleteGlobalParty'>;

export type DeletePartyExtractionMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  partyExtractionId: Scalars['String']['input'];
}>;


export type DeletePartyExtractionMutation = Pick<Mutation, 'deletePartyExtraction'>;

export type DesignatePartyMutationVariables = Exact<{
  partyId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  designation: PartyDesignation;
}>;


export type DesignatePartyMutation = Pick<Mutation, 'designateParty'>;

export type ResearchPartyMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  partyId: Scalars['String']['input'];
  partyName: Scalars['String']['input'];
}>;


export type ResearchPartyMutation = Pick<Mutation, 'researchParty'>;

export type UpdateGlobalPartyMutationVariables = Exact<{
  partyId: Scalars['String']['input'];
  fields: NewParty;
}>;


export type UpdateGlobalPartyMutation = Pick<Mutation, 'updateGlobalParty'>;

export type UpdatePartyMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  partyId: Scalars['String']['input'];
  details: NewParty;
}>;


export type UpdatePartyMutation = Pick<Mutation, 'updateParty'>;

export type ListAgentPartiesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  pagination: Pagination;
}>;


export type ListAgentPartiesQuery = { listAgentParties: Array<Pick<
      Party,
      | 'id'
      | 'legalEntityId'
      | 'name'
      | 'url'
      | 'supportUrl'
      | 'supportEmail'
      | 'supportPhone'
      | 'twitterUrl'
      | 'facebookUrl'
      | 'instagramUrl'
      | 'yelpUrl'
      | 'iconUrl'
      | 'shortDescription'
      | 'designation'
    >> };

export type ListGlobalPartiesQueryVariables = Exact<{
  filter?: InputMaybe<GlobalPartyFilter>;
  pagination: Pagination;
  order?: InputMaybe<GlobalPartySort>;
}>;


export type ListGlobalPartiesQuery = { listGlobalParties: Array<(
    Pick<
      AdminGlobalParty,
      | 'transactionsCount'
      | 'aliases'
      | 'prefixes'
      | 'lastReviewedAt'
    >
    & { party: Pick<
        Party,
        | 'id'
        | 'legalEntityId'
        | 'name'
        | 'url'
        | 'supportUrl'
        | 'supportEmail'
        | 'supportPhone'
        | 'twitterUrl'
        | 'facebookUrl'
        | 'instagramUrl'
        | 'yelpUrl'
        | 'iconUrl'
        | 'shortDescription'
        | 'designation'
      > }
  )> };

export type ListGlobalPartiesWithSummariesQueryVariables = Exact<{
  filter?: InputMaybe<GlobalPartyFilter>;
  pagination: Pagination;
  order?: InputMaybe<GlobalPartySort>;
}>;


export type ListGlobalPartiesWithSummariesQuery = { listGlobalPartiesWithSummaries: Array<(
    Pick<
      AdminGlobalParty,
      | 'transactionsCount'
      | 'aliases'
      | 'prefixes'
      | 'lastReviewedAt'
    >
    & { party: Pick<
        Party,
        | 'id'
        | 'legalEntityId'
        | 'name'
        | 'url'
        | 'supportUrl'
        | 'supportEmail'
        | 'supportPhone'
        | 'twitterUrl'
        | 'facebookUrl'
        | 'instagramUrl'
        | 'yelpUrl'
        | 'iconUrl'
        | 'shortDescription'
        | 'designation'
      > }
  )> };

export type ListPartiesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  pagination: Pagination;
  viewType: ViewType;
  partyType?: InputMaybe<PartyType>;
  designation?: InputMaybe<PartyDesignation>;
}>;


export type ListPartiesQuery = { listParties: Array<(
    Pick<AdminParty, 'transactionsCount' | 'lastTransactionOccurredAt'>
    & { party: Pick<
        Party,
        | 'id'
        | 'legalEntityId'
        | 'name'
        | 'url'
        | 'supportUrl'
        | 'supportEmail'
        | 'supportPhone'
        | 'twitterUrl'
        | 'facebookUrl'
        | 'instagramUrl'
        | 'yelpUrl'
        | 'iconUrl'
        | 'shortDescription'
        | 'designation'
      > }
  )> };

export type ListPartyExtractionsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  pagination: Pagination;
}>;


export type ListPartyExtractionsQuery = { listPartyExtractions: Array<(
    Pick<
      AdminPartyExtraction,
      | 'legalEntityId'
      | 'partyExtractionId'
      | 'partyExtractionKey'
      | 'transactionFactId'
    >
    & { party?: Maybe<Pick<
        Party,
        | 'id'
        | 'legalEntityId'
        | 'name'
        | 'url'
        | 'supportUrl'
        | 'supportEmail'
        | 'supportPhone'
        | 'twitterUrl'
        | 'facebookUrl'
        | 'instagramUrl'
        | 'yelpUrl'
        | 'iconUrl'
        | 'shortDescription'
        | 'designation'
      >> }
  )> };

export type ListPayrollPartiesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ListPayrollPartiesQuery = { listPayrollParties: Array<Pick<
      PayrollProvider,
      | 'legalEntityId'
      | 'partyId'
      | 'partyName'
      | 'payrollProviderType'
      | 'rangeStartedAt'
      | 'rangeEndedAt'
    >> };

export type SetPaymentSettlementConfigMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  additionalPaymentSettlementDays: Scalars['Int']['input'];
}>;


export type SetPaymentSettlementConfigMutation = { setPaymentSettlementConfig: Pick<PaymentSettlementConfig, 'legalEntityId' | 'additionalPaymentSettlementDays'> };

export type GetPaymentLifecycleJournalEntriesQueryVariables = Exact<{
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  payoutIntentId?: InputMaybe<Scalars['String']['input']>;
  payoutId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPaymentLifecycleJournalEntriesQuery = { getPaymentLifecycleJournalEntries: (
    Pick<
      PaymentLifecycleResult,
      | 'paymentIntentId'
      | 'payerLegalEntityId'
      | 'vendorLegalEntityId'
      | 'digitsLegalEntityId'
      | 'ownerType'
      | 'recipientType'
    >
    & { stages: Array<(
      Pick<PaymentLifecycleStage, 'stage' | 'entityId' | 'entityType'>
      & { journalEntries: Array<(
        Pick<
          PaymentJournalEntry,
          | 'journalEntryId'
          | 'chartOfAccountsId'
          | 'idempotenceKey'
          | 'commitTime'
          | 'ownerId'
          | 'ownerType'
        >
        & {
          tags: Array<Pick<JournalEntryTag, 'name' | 'value'>>,
          categoryEntries: Array<(
            Pick<
              JournalCategoryEntry,
              | 'canonicalCategoryLabel'
              | 'categoryName'
              | 'accountingType'
              | 'entryType'
            >
            & {
              debitAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              creditAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            }
          )>,
        }
      )> }
    )> }
  ) };

export type GetPaymentPayoutChainQueryVariables = Exact<{
  paymentId?: InputMaybe<Scalars['String']['input']>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  payoutId?: InputMaybe<Scalars['String']['input']>;
  payoutIntentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPaymentPayoutChainQuery = { getPaymentPayoutChain: {
      paymentIntents: Array<(
        Pick<
          PaymentIntentChainDetail,
          | 'paymentIntentId'
          | 'ownerId'
          | 'ownerType'
          | 'paymentType'
          | 'externalPaymentSource'
          | 'referenceId'
          | 'referenceType'
          | 'recipientId'
          | 'recipientType'
          | 'recipientName'
          | 'totalAmount'
          | 'isoCurrencyCode'
          | 'currencyMultiplier'
          | 'createdAt'
        >
        & { states: Array<Pick<PaymentIntentStateDetail, 'paymentIntentStateId' | 'paymentIntentState' | 'createdAt'>> }
      )>,
      payments: Array<(
        Pick<
          PaymentChainDetail,
          | 'paymentId'
          | 'paymentIntentId'
          | 'ownerId'
          | 'ownerType'
          | 'paymentType'
          | 'externalPaymentSource'
          | 'externalPaymentId'
          | 'referenceId'
          | 'referenceType'
          | 'recipientId'
          | 'recipientType'
          | 'recipientName'
          | 'totalAmount'
          | 'isoCurrencyCode'
          | 'currencyMultiplier'
          | 'digitsTransactionId'
          | 'createdAt'
        >
        & { states: Array<Pick<PaymentStateDetail, 'paymentStateId' | 'paymentState' | 'createdAt'>> }
      )>,
      payouts: Array<(
        Pick<
          PayoutChainDetail,
          | 'payoutIntentId'
          | 'payoutId'
          | 'ownerId'
          | 'ownerType'
          | 'payoutType'
          | 'externalSource'
          | 'externalPayoutId'
          | 'totalAmount'
          | 'isoCurrencyCode'
          | 'currencyMultiplier'
          | 'digitsTransactionId'
          | 'createdAt'
          | 'linkedPaymentIds'
        >
        & { statuses: Array<Pick<PayoutStatusDetail, 'payoutStatus' | 'createdAt'>> }
      )>,
      payoutIntents: Array<(
        Pick<
          PayoutIntentChainDetail,
          | 'payoutIntentId'
          | 'ownerId'
          | 'ownerType'
          | 'payoutType'
          | 'totalAmount'
          | 'isoCurrencyCode'
          | 'currencyMultiplier'
          | 'directPaymentId'
          | 'createdAt'
        >
        & { states: Array<Pick<PayoutIntentStateDetail, 'payoutIntentStateId' | 'payoutIntentState' | 'createdAt'>> }
      )>,
    } };

export type GetPaymentSettlementConfigQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type GetPaymentSettlementConfigQuery = { getPaymentSettlementConfig: Pick<PaymentSettlementConfig, 'legalEntityId' | 'additionalPaymentSettlementDays'> };

export type ListPaymentJournalEntriesByCoAAndTagValueQueryVariables = Exact<{
  chartOfAccountsId: Scalars['String']['input'];
  tagValue: Scalars['String']['input'];
}>;


export type ListPaymentJournalEntriesByCoAAndTagValueQuery = { listPaymentJournalEntriesByCoAAndTagValue: { journalEntries: Array<(
      Pick<
        PaymentJournalEntry,
        | 'journalEntryId'
        | 'chartOfAccountsId'
        | 'idempotenceKey'
        | 'commitTime'
        | 'ownerId'
        | 'ownerType'
      >
      & {
        tags: Array<Pick<JournalEntryTag, 'name' | 'value'>>,
        categoryEntries: Array<(
          Pick<
            JournalCategoryEntry,
            | 'canonicalCategoryLabel'
            | 'categoryName'
            | 'accountingType'
            | 'entryType'
          >
          & {
            debitAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            creditAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          }
        )>,
      }
    )> } };

export type ListPaymentsLedgerCategoryEntriesQueryVariables = Exact<{
  ownerId: Scalars['String']['input'];
  canonicalCategoryLabel: Scalars['String']['input'];
  pagination: Pagination;
}>;


export type ListPaymentsLedgerCategoryEntriesQuery = { listPaymentsLedgerCategoryEntries: Array<(
    Pick<
      PaymentJournalEntry,
      | 'journalEntryId'
      | 'chartOfAccountsId'
      | 'idempotenceKey'
      | 'commitTime'
      | 'ownerId'
      | 'ownerType'
    >
    & {
      tags: Array<Pick<JournalEntryTag, 'name' | 'value'>>,
      categoryEntries: Array<(
        Pick<
          JournalCategoryEntry,
          | 'canonicalCategoryLabel'
          | 'categoryName'
          | 'accountingType'
          | 'entryType'
        >
        & {
          debitAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          creditAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
        }
      )>,
    }
  )> };

export type ReadPaymentsLedgerCoAQueryVariables = Exact<{
  ownerId: Scalars['String']['input'];
}>;


export type ReadPaymentsLedgerCoAQuery = { readPaymentsLedgerCoA: (
    Pick<PaymentsLedgerCoA, 'chartOfAccountsId' | 'ownerId' | 'ownerType'>
    & { categories: Array<(
      Pick<
        PaymentsLedgerCategory,
        | 'categoryId'
        | 'canonicalCategoryLabel'
        | 'name'
        | 'description'
        | 'accountingType'
        | 'version'
        | 'nonNegativeBalanceInvariant'
      >
      & {
        sumDebit: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
        sumCredit: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
      }
    )> }
  ) };

export type PipelineDefinitionFieldsFragment = Pick<PipelineDefinition, 'pipelineName' | 'isActive' | 'updatedAt'>;

export type UpdatePipelineDefinitionStatusMutationVariables = Exact<{
  pipelineName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdatePipelineDefinitionStatusMutation = Pick<Mutation, 'updatePipelineDefinitionStatus'>;

export type ListPipelineDefinitionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListPipelineDefinitionsQuery = { listPipelineDefinitions: Array<Pick<PipelineDefinition, 'pipelineName' | 'isActive' | 'updatedAt'>> };

export type ClusteredPrefixFieldsFragment = Pick<ClusteredPrefix, 'prefix' | 'transactionCount'>;

export type PrefixMappingFieldsFragment = Pick<PrefixMapping, 'prefix' | 'partyId'>;

export type PrefixMappingSummaryFieldsFragment = (
  Pick<PrefixMappingSummary, 'prefix' | 'transactionCount'>
  & { party: Pick<
      Party,
      | 'id'
      | 'legalEntityId'
      | 'name'
      | 'url'
      | 'supportUrl'
      | 'supportEmail'
      | 'supportPhone'
      | 'twitterUrl'
      | 'facebookUrl'
      | 'instagramUrl'
      | 'yelpUrl'
      | 'iconUrl'
      | 'shortDescription'
      | 'designation'
    > }
);

export type SanitizedDescriptionFieldsFragment = Pick<SanitizedDescription, 'sanitizedDescription' | 'transactionCount' | 'exampleTransactionNameAndDescription'>;

export type DeletePrefixMappingMutationVariables = Exact<{
  prefix: Scalars['String']['input'];
  partyId: Scalars['String']['input'];
}>;


export type DeletePrefixMappingMutation = Pick<Mutation, 'deletePrefixMapping'>;

export type IgnorePrefixMutationVariables = Exact<{
  prefix: Scalars['String']['input'];
}>;


export type IgnorePrefixMutation = Pick<Mutation, 'ignorePrefix'>;

export type UnignorePrefixMutationVariables = Exact<{
  prefix: Scalars['String']['input'];
}>;


export type UnignorePrefixMutation = Pick<Mutation, 'unignorePrefix'>;

export type ListClusteredPrefixesQueryVariables = Exact<{
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListClusteredPrefixesQuery = { listClusteredPrefixes: Array<Pick<ClusteredPrefix, 'prefix' | 'transactionCount'>> };

export type ListIgnoredPrefixesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListIgnoredPrefixesQuery = Pick<Query, 'listIgnoredPrefixes'>;

export type ListPrefixMappingsQueryVariables = Exact<{
  filter: PrefixFilter;
}>;


export type ListPrefixMappingsQuery = { listPrefixMappings: Array<(
    Pick<PrefixMappingSummary, 'prefix' | 'transactionCount'>
    & { party: Pick<
        Party,
        | 'id'
        | 'legalEntityId'
        | 'name'
        | 'url'
        | 'supportUrl'
        | 'supportEmail'
        | 'supportPhone'
        | 'twitterUrl'
        | 'facebookUrl'
        | 'instagramUrl'
        | 'yelpUrl'
        | 'iconUrl'
        | 'shortDescription'
        | 'designation'
      > }
  )> };

export type ListSanitizedDescriptionsQueryVariables = Exact<{
  prefix: Scalars['String']['input'];
}>;


export type ListSanitizedDescriptionsQuery = { listSanitizedDescriptions: Array<Pick<SanitizedDescription, 'sanitizedDescription' | 'transactionCount' | 'exampleTransactionNameAndDescription'>> };

export type ListReconciliationAccountsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  reconciliationStates: Array<ReconciliationState> | ReconciliationState;
}>;


export type ListReconciliationAccountsQuery = { listReconciliationAccounts: Array<Pick<
      EntityCategory,
      | 'id'
      | 'name'
      | 'displayKey'
      | 'chartOfAccountsDisplayNumber'
      | 'type'
      | 'subtype'
      | 'parentCategoryId'
      | 'productArea'
      | 'active'
    >> };

export type ReadReconciliationDiffsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  accountId: Scalars['String']['input'];
}>;


export type ReadReconciliationDiffsQuery = { readReconciliationDiffs: Array<(
    Pick<ReconciliationDiff, 'reconciliationId'>
    & {
      toStartDate: Pick<Date, 'year' | 'month' | 'day'>,
      toEndDate: Pick<Date, 'year' | 'month' | 'day'>,
      transactions: Array<(
        Pick<
          ReconciliationDiffTransaction,
          | 'transactionFactId'
          | 'diffReasons'
          | 'fromStatus'
          | 'toStatus'
          | 'fromOccurredAt'
          | 'toOccurredAt'
          | 'fromEntryType'
          | 'toEntryType'
        >
        & {
          transaction?: Maybe<(
            Pick<
              Transaction,
              | 'viewId'
              | 'factId'
              | 'ledgerTransactionId'
              | 'supersededFactIds'
              | 'timestamp'
              | 'recordType'
              | 'name'
              | 'description'
              | 'digitsTransactionType'
              | 'partySource'
              | 'displayEntry'
              | 'displayCategorySource'
              | 'displayCanonicalCategoryName'
              | 'displayUncategorizedReason'
              | 'displayProductArea'
              | 'ownerSource'
              | 'transactionClassificationType'
              | 'compileSource'
              | 'reconciliationStatus'
              | 'referenceNumber'
              | 'taxStatus'
              | 'matchedLedgerTransactionIds'
              | 'providerTypes'
              | 'isSupersedingLedgerTransaction'
              | 'supersededLedgerTransactionIds'
            >
            & {
              party?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              facilitatorParty?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              product?: Maybe<Pick<Product, 'id' | 'name'>>,
              department?: Maybe<(
                { __typename: 'EntityDepartment' }
                & Pick<
                  EntityDepartment,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              splitDepartment?: Maybe<(
                { __typename: 'EntityDepartment' }
                & Pick<
                  EntityDepartment,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              location?: Maybe<(
                { __typename: 'EntityLocation' }
                & Pick<
                  EntityLocation,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              splitLocation?: Maybe<(
                { __typename: 'EntityLocation' }
                & Pick<
                  EntityLocation,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              providers: Array<Pick<Provider, 'name'>>,
              recurrence?: Maybe<Pick<
                  TransactionRecurrence,
                  | 'recurrenceThreadId'
                  | 'interval'
                  | 'intervalMultiplier'
                  | 'threadIndex'
                  | 'totalThreadCount'
                  | 'isHidden'
                  | 'firstOccurredAt'
                  | 'lastOccurredAt'
                >>,
              displayInstitution?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              displayCategory: (
                Pick<
                  Category,
                  | 'id'
                  | 'name'
                  | 'description'
                  | 'displayKey'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'displayNumber'
                  | 'active'
                  | 'categoryState'
                  | 'productArea'
                  | 'synthesized'
                >
                & { ancestors?: Maybe<Array<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>> }
              ),
              displayCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              splitCategory?: Maybe<(
                Pick<
                  Category,
                  | 'id'
                  | 'name'
                  | 'description'
                  | 'displayKey'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'displayNumber'
                  | 'active'
                  | 'categoryState'
                  | 'productArea'
                  | 'synthesized'
                >
                & { ancestors?: Maybe<Array<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>> }
              )>,
              splitCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              splitInstitution?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              creditCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              debitCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              runningTotal?: Maybe<(
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              )>,
              owner?: Maybe<Pick<
                  EntityEmployee,
                  | 'id'
                  | 'organizationId'
                  | 'givenName'
                  | 'familyName'
                  | 'avatarUrl'
                >>,
              sources: Array<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )>,
              creditSources: Array<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )>,
              debitSources: Array<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )>,
              invoiceLineItem?: Maybe<{ value:
                  | (
                    Pick<
                      TransactionDiscountLineItem,
                      | 'name'
                      | 'description'
                      | 'variablePercentage'
                      | 'appliesToTransactionFactId'
                    >
                    & {
                      fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                      discount?: Maybe<(
                        Pick<
                          TransactionInvoiceLineItemDiscount,
                          | 'discountId'
                          | 'name'
                          | 'description'
                          | 'variablePercentage'
                        >
                        & { fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
                      )>,
                    }
                  )
                  | (
                    Pick<TransactionProductLineItem, 'name' | 'description' | 'quantity'>
                    & {
                      unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                      product?: Maybe<(
                        Pick<TransactionInvoiceLineItemProduct, 'productId' | 'name' | 'description'>
                        & {
                          unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                          category?: Maybe<(
                            Pick<
                              Category,
                              | 'id'
                              | 'name'
                              | 'description'
                              | 'displayKey'
                              | 'type'
                              | 'subtype'
                              | 'parentCategoryId'
                              | 'displayNumber'
                              | 'active'
                              | 'categoryState'
                              | 'productArea'
                              | 'synthesized'
                            >
                            & { ancestors?: Maybe<Array<Pick<
                                EntityCategory,
                                | 'id'
                                | 'name'
                                | 'displayKey'
                                | 'chartOfAccountsDisplayNumber'
                                | 'type'
                                | 'subtype'
                                | 'parentCategoryId'
                                | 'productArea'
                                | 'active'
                              >>> }
                          )>,
                          department?: Maybe<(
                            { __typename: 'EntityDepartment' }
                            & Pick<
                              EntityDepartment,
                              | 'id'
                              | 'name'
                              | 'parentId'
                              | 'active'
                            >
                          )>,
                          location?: Maybe<(
                            { __typename: 'EntityLocation' }
                            & Pick<
                              EntityLocation,
                              | 'id'
                              | 'name'
                              | 'parentId'
                              | 'active'
                            >
                          )>,
                        }
                      )>,
                    }
                  )
                 }>,
              schedule?: Maybe<(
                { __typename: 'EntitySchedule' }
                & Pick<
                  EntitySchedule,
                  | 'id'
                  | 'name'
                  | 'scheduleNumber'
                  | 'scheduleType'
                  | 'scheduleTemplateId'
                  | 'categoryId'
                  | 'relatedCategoryId'
                  | 'partyId'
                  | 'startDate'
                  | 'endDate'
                >
                & { amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
              )>,
              splitSchedule?: Maybe<(
                { __typename: 'EntitySchedule' }
                & Pick<
                  EntitySchedule,
                  | 'id'
                  | 'name'
                  | 'scheduleNumber'
                  | 'scheduleType'
                  | 'scheduleTemplateId'
                  | 'categoryId'
                  | 'relatedCategoryId'
                  | 'partyId'
                  | 'startDate'
                  | 'endDate'
                >
                & { amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
              )>,
            }
          )>,
          fromAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          toAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
        }
      )>,
    }
  )> };

export type AdminReportPackageDocumentMetadataFieldsFragment = (
  Pick<
    AdminReportPackageDocumentMetadata,
    | 'id'
    | 'title'
    | 'documentObjectId'
    | 'documentObjectVersionId'
    | 'type'
    | 'status'
    | 'position'
  >
  & {
    reportFile?: Maybe<Pick<
        ReportFileMetadata,
        | 'id'
        | 'fileName'
        | 'mimeType'
        | 'fileSize'
        | 'source'
      >>,
    generationHistory?: Maybe<Pick<
        ReportGenerationHistory,
        | 'id'
        | 'requestId'
        | 'reportId'
        | 'versionId'
        | 'legalEntityId'
        | 'authorId'
        | 'viewVersion'
        | 'kind'
        | 'timezone'
        | 'periodStartedAt'
        | 'periodEndedAt'
        | 'generationStartedAt'
        | 'generationEndedAt'
        | 'error'
        | 'createdAt'
        | 'updatedAt'
      >>,
    validationHistories: Array<Pick<
        ReportValidationHistory,
        | 'reportId'
        | 'versionId'
        | 'legalEntityId'
        | 'validatedAt'
        | 'isValid'
        | 'errorMessage'
        | 'source'
      >>,
  }
);

export type AdminReportPackageMetadataFieldsFragment = (
  Pick<
    AdminReportPackageMetadata,
    | 'id'
    | 'versionId'
    | 'title'
    | 'status'
    | 'startedAt'
    | 'endedAt'
    | 'interval'
    | 'publishedAsDraft'
    | 'createdAt'
    | 'updatedAt'
  >
  & {
    viewKey: Pick<
        ViewIdentifier,
        | 'legalEntityId'
        | 'viewVersion'
        | 'mutationVersion'
        | 'viewType'
      >,
    author?: Maybe<Pick<
        Contact,
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      >>,
    documents: Array<(
      Pick<
        AdminReportPackageDocumentMetadata,
        | 'id'
        | 'title'
        | 'documentObjectId'
        | 'documentObjectVersionId'
        | 'type'
        | 'status'
        | 'position'
      >
      & {
        reportFile?: Maybe<Pick<
            ReportFileMetadata,
            | 'id'
            | 'fileName'
            | 'mimeType'
            | 'fileSize'
            | 'source'
          >>,
        generationHistory?: Maybe<Pick<
            ReportGenerationHistory,
            | 'id'
            | 'requestId'
            | 'reportId'
            | 'versionId'
            | 'legalEntityId'
            | 'authorId'
            | 'viewVersion'
            | 'kind'
            | 'timezone'
            | 'periodStartedAt'
            | 'periodEndedAt'
            | 'generationStartedAt'
            | 'generationEndedAt'
            | 'error'
            | 'createdAt'
            | 'updatedAt'
          >>,
        validationHistories: Array<Pick<
            ReportValidationHistory,
            | 'reportId'
            | 'versionId'
            | 'legalEntityId'
            | 'validatedAt'
            | 'isValid'
            | 'errorMessage'
            | 'source'
          >>,
      }
    )>,
  }
);

export type ReportValidationHistoryFieldsFragment = Pick<
    ReportValidationHistory,
    | 'reportId'
    | 'versionId'
    | 'legalEntityId'
    | 'validatedAt'
    | 'isValid'
    | 'errorMessage'
    | 'source'
  >;

export type DeleteReportPackageMutationVariables = Exact<{
  packageId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
}>;


export type DeleteReportPackageMutation = Pick<Mutation, 'deleteReportPackage'>;

export type TriggerReportValidationMutationVariables = Exact<{
  legalEntityIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  period: PeriodInput;
}>;


export type TriggerReportValidationMutation = Pick<Mutation, 'triggerReportValidation'>;

export type ListReportPackagesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  interval: Interval;
  intervalCount?: InputMaybe<Scalars['Int']['input']>;
  year: Scalars['Int']['input'];
  index: Scalars['Int']['input'];
  paginationLimit: Scalars['Int']['input'];
  paginationOffset: Scalars['Int']['input'];
}>;


export type ListReportPackagesQuery = { listReportPackages: Array<(
    Pick<
      AdminReportPackageMetadata,
      | 'id'
      | 'versionId'
      | 'title'
      | 'status'
      | 'startedAt'
      | 'endedAt'
      | 'interval'
      | 'publishedAsDraft'
      | 'createdAt'
      | 'updatedAt'
    >
    & {
      viewKey: Pick<
          ViewIdentifier,
          | 'legalEntityId'
          | 'viewVersion'
          | 'mutationVersion'
          | 'viewType'
        >,
      author?: Maybe<Pick<
          Contact,
          | 'givenName'
          | 'familyName'
          | 'emailAddress'
          | 'avatarUrl'
        >>,
      documents: Array<(
        Pick<
          AdminReportPackageDocumentMetadata,
          | 'id'
          | 'title'
          | 'documentObjectId'
          | 'documentObjectVersionId'
          | 'type'
          | 'status'
          | 'position'
        >
        & {
          reportFile?: Maybe<Pick<
              ReportFileMetadata,
              | 'id'
              | 'fileName'
              | 'mimeType'
              | 'fileSize'
              | 'source'
            >>,
          generationHistory?: Maybe<Pick<
              ReportGenerationHistory,
              | 'id'
              | 'requestId'
              | 'reportId'
              | 'versionId'
              | 'legalEntityId'
              | 'authorId'
              | 'viewVersion'
              | 'kind'
              | 'timezone'
              | 'periodStartedAt'
              | 'periodEndedAt'
              | 'generationStartedAt'
              | 'generationEndedAt'
              | 'error'
              | 'createdAt'
              | 'updatedAt'
            >>,
          validationHistories: Array<Pick<
              ReportValidationHistory,
              | 'reportId'
              | 'versionId'
              | 'legalEntityId'
              | 'validatedAt'
              | 'isValid'
              | 'errorMessage'
              | 'source'
            >>,
        }
      )>,
    }
  )> };

export type ReadReportValidationArchiveQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  reportId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
}>;


export type ReadReportValidationArchiveQuery = { readReportValidationArchive?: Maybe<Pick<ReportValidationArchive, 'quickbooks' | 'digits' | 'avs'>> };

export type SuperuserRoleFieldsFragment = Pick<SuperuserRole, 'identifier' | 'displayName' | 'description'>;

export type UpdateEmployeeRoleMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  employeeId: Scalars['String']['input'];
  role: Scalars['String']['input'];
  defaultEntityRole: Scalars['String']['input'];
}>;


export type UpdateEmployeeRoleMutation = Pick<Mutation, 'updateEmployeeRole'>;

export type ListAdminScheduleCategoryHintCatalogQueryVariables = Exact<{ [key: string]: never; }>;


export type ListAdminScheduleCategoryHintCatalogQuery = { listAdminScheduleCategoryHintCatalog: Array<Pick<
      AdminScheduleCategoryHint,
      | 'hint'
      | 'names'
      | 'type'
      | 'subtype'
      | 'strictSubtype'
      | 'excludeNames'
      | 'resolved'
    >> };

export type ListAdminScheduleCategoryHintsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  specializationId: Scalars['String']['input'];
}>;


export type ListAdminScheduleCategoryHintsQuery = { listAdminScheduleCategoryHints: Array<(
    Pick<
      AdminScheduleCategoryHintBinding,
      | 'eventTemplateId'
      | 'eventDisplayName'
      | 'variableTemplateId'
      | 'variableDisplayName'
    >
    & { hint: Pick<
        AdminScheduleCategoryHint,
        | 'hint'
        | 'names'
        | 'type'
        | 'subtype'
        | 'strictSubtype'
        | 'excludeNames'
        | 'resolved'
      > }
  )> };

export type ListAdminScheduleSpecializationsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  scheduleTemplateId: Scalars['String']['input'];
}>;


export type ListAdminScheduleSpecializationsQuery = { listAdminScheduleSpecializations: Array<Pick<
      AdminScheduleSpecialization,
      | 'specializationId'
      | 'scheduleTemplateId'
      | 'name'
      | 'displayKey'
      | 'description'
      | 'organizationId'
      | 'ownerOrganizationId'
      | 'legalEntityId'
      | 'createdAt'
      | 'updatedAt'
    >> };

export type ListAdminScheduleTemplatesQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type ListAdminScheduleTemplatesQuery = { listAdminScheduleTemplates: Array<Pick<
      AdminScheduleTemplateSummary,
      | 'scheduleTemplateId'
      | 'name'
      | 'description'
      | 'type'
      | 'displayKey'
      | 'organizationId'
      | 'createdAt'
      | 'updatedAt'
      | 'eventCount'
      | 'variableCount'
      | 'specializationCount'
      | 'formulaCount'
    >> };

export type ReadAdminScheduleSpecializationDetailQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  specializationId: Scalars['String']['input'];
}>;


export type ReadAdminScheduleSpecializationDetailQuery = { readAdminScheduleSpecializationDetail: {
      specialization: Pick<
          AdminScheduleSpecialization,
          | 'specializationId'
          | 'scheduleTemplateId'
          | 'name'
          | 'displayKey'
          | 'description'
          | 'organizationId'
          | 'ownerOrganizationId'
          | 'legalEntityId'
          | 'createdAt'
          | 'updatedAt'
        >,
      template: (
        Pick<
          AdminScheduleTemplate,
          | 'scheduleTemplateId'
          | 'name'
          | 'description'
          | 'type'
          | 'displayKey'
          | 'organizationId'
          | 'createdAt'
          | 'updatedAt'
        >
        & {
          events: Array<(
            Pick<
              AdminScheduleEventTemplate,
              | 'eventTemplateId'
              | 'name'
              | 'displayName'
              | 'description'
              | 'ordinal'
              | 'displayKey'
              | 'isInstantiating'
              | 'isTerminating'
              | 'isSingleton'
              | 'inCreateFlow'
              | 'generatorType'
              | 'generatedEventTemplateId'
              | 'skipConditionName'
              | 'skipConditionExpr'
              | 'dateSource'
            >
            & {
              variables: Array<(
                Pick<
                  AdminScheduleEventVariableTemplate,
                  | 'variableTemplateId'
                  | 'variableName'
                  | 'displayName'
                  | 'variableType'
                  | 'required'
                  | 'ordinal'
                  | 'displayMode'
                  | 'applyExpr'
                  | 'validationExpr'
                  | 'validationMessage'
                  | 'specializable'
                >
                & { defaultValue?: Maybe<(
                  Pick<
                    AdminScheduleVariableDefault,
                    | 'source'
                    | 'stringValue'
                    | 'intValue'
                    | 'floatValue'
                    | 'boolValue'
                    | 'dateValue'
                    | 'intervalValue'
                    | 'formulaId'
                    | 'formulaDisplayName'
                    | 'categoryHint'
                  >
                  & { amountValue?: Maybe<Pick<MonetaryValue, 'amount' | 'iso4217CurrencyCode' | 'currencyMultiplier'>> }
                )> }
              )>,
              supportedFormulas: Array<Pick<AdminScheduleFormulaBinding, 'formulaId' | 'displayName' | 'ordinal'>>,
              journalEntry?: Maybe<(
                Pick<AdminScheduleJournalEntryTemplate, 'journalEntryTemplateId' | 'memo' | 'skipCondition'>
                & { lines: Array<Pick<
                    AdminScheduleJournalEntryLineTemplate,
                    | 'lineTemplateId'
                    | 'ordinal'
                    | 'description'
                    | 'entryType'
                    | 'entryTypeExpression'
                    | 'categoryVariable'
                    | 'amountVariable'
                    | 'skipCondition'
                  >> }
              )>,
            }
          )>,
          formulas: Array<Pick<AdminScheduleFormula, 'formulaId' | 'displayName' | 'expression'>>,
        }
      ),
      overrides: Array<(
        Pick<AdminScheduleSpecializationVariableOverride, 'eventTemplateId' | 'variableTemplateId'>
        & { value: (
          Pick<
            AdminScheduleVariableDefault,
            | 'source'
            | 'stringValue'
            | 'intValue'
            | 'floatValue'
            | 'boolValue'
            | 'dateValue'
            | 'intervalValue'
            | 'formulaId'
            | 'formulaDisplayName'
            | 'categoryHint'
          >
          & { amountValue?: Maybe<Pick<MonetaryValue, 'amount' | 'iso4217CurrencyCode' | 'currencyMultiplier'>> }
        ) }
      )>,
    } };

export type ReadAdminScheduleTemplateQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  scheduleTemplateId: Scalars['String']['input'];
}>;


export type ReadAdminScheduleTemplateQuery = { readAdminScheduleTemplate: (
    Pick<
      AdminScheduleTemplate,
      | 'scheduleTemplateId'
      | 'name'
      | 'description'
      | 'type'
      | 'displayKey'
      | 'organizationId'
      | 'createdAt'
      | 'updatedAt'
    >
    & {
      events: Array<(
        Pick<
          AdminScheduleEventTemplate,
          | 'eventTemplateId'
          | 'name'
          | 'displayName'
          | 'description'
          | 'ordinal'
          | 'displayKey'
          | 'isInstantiating'
          | 'isTerminating'
          | 'isSingleton'
          | 'inCreateFlow'
          | 'generatorType'
          | 'generatedEventTemplateId'
          | 'skipConditionName'
          | 'skipConditionExpr'
          | 'dateSource'
        >
        & {
          variables: Array<(
            Pick<
              AdminScheduleEventVariableTemplate,
              | 'variableTemplateId'
              | 'variableName'
              | 'displayName'
              | 'variableType'
              | 'required'
              | 'ordinal'
              | 'displayMode'
              | 'applyExpr'
              | 'validationExpr'
              | 'validationMessage'
              | 'specializable'
            >
            & { defaultValue?: Maybe<(
              Pick<
                AdminScheduleVariableDefault,
                | 'source'
                | 'stringValue'
                | 'intValue'
                | 'floatValue'
                | 'boolValue'
                | 'dateValue'
                | 'intervalValue'
                | 'formulaId'
                | 'formulaDisplayName'
                | 'categoryHint'
              >
              & { amountValue?: Maybe<Pick<MonetaryValue, 'amount' | 'iso4217CurrencyCode' | 'currencyMultiplier'>> }
            )> }
          )>,
          supportedFormulas: Array<Pick<AdminScheduleFormulaBinding, 'formulaId' | 'displayName' | 'ordinal'>>,
          journalEntry?: Maybe<(
            Pick<AdminScheduleJournalEntryTemplate, 'journalEntryTemplateId' | 'memo' | 'skipCondition'>
            & { lines: Array<Pick<
                AdminScheduleJournalEntryLineTemplate,
                | 'lineTemplateId'
                | 'ordinal'
                | 'description'
                | 'entryType'
                | 'entryTypeExpression'
                | 'categoryVariable'
                | 'amountVariable'
                | 'skipCondition'
              >> }
          )>,
        }
      )>,
      formulas: Array<Pick<AdminScheduleFormula, 'formulaId' | 'displayName' | 'expression'>>,
    }
  ) };

export type SearchQueryVariables = Exact<{
  pagination: Pagination;
  searchTerm: Scalars['String']['input'];
}>;


export type SearchQuery = {
    organizations: Array<(
      Pick<AdminOrganization, 'createdAt' | 'deletedAt' | 'userCount'>
      & {
        organization: Pick<
            Organization,
            | 'id'
            | 'slug'
            | 'name'
            | 'iconUrl'
            | 'websiteUrl'
            | 'kind'
          >,
        legalEntities: Array<(
          Pick<AdminLegalEntity, 'createdAt' | 'userCount' | 'deletedAt'>
          & { legalEntity: (
            Pick<
              LegalEntity,
              | 'id'
              | 'slug'
              | 'name'
              | 'websiteUrl'
              | 'industry'
              | 'timezone'
              | 'fiscalYearStartMonth'
              | 'fiscalYearNumberOffset'
              | 'status'
              | 'organizationId'
              | 'sensitive'
              | 'phoneNumber'
              | 'iconUrl'
            >
            & {
              address: Pick<
                  Address,
                  | 'street'
                  | 'streetAdditional'
                  | 'city'
                  | 'region'
                  | 'postalCode'
                  | 'countryCode'
                  | 'lat'
                  | 'long'
                >,
              incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
            }
          ) }
        )>,
        affiliateLegalEntities: Array<(
          Pick<AdminLegalEntity, 'createdAt' | 'userCount' | 'deletedAt'>
          & { legalEntity: (
            Pick<
              LegalEntity,
              | 'id'
              | 'slug'
              | 'name'
              | 'websiteUrl'
              | 'industry'
              | 'timezone'
              | 'fiscalYearStartMonth'
              | 'fiscalYearNumberOffset'
              | 'status'
              | 'organizationId'
              | 'sensitive'
              | 'phoneNumber'
              | 'iconUrl'
            >
            & {
              address: Pick<
                  Address,
                  | 'street'
                  | 'streetAdditional'
                  | 'city'
                  | 'region'
                  | 'postalCode'
                  | 'countryCode'
                  | 'lat'
                  | 'long'
                >,
              incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
            }
          ) }
        )>,
      }
    )>,
    affiliations: Array<(
      Pick<AdminOrganization, 'createdAt' | 'deletedAt' | 'userCount'>
      & {
        organization: Pick<
            Organization,
            | 'id'
            | 'slug'
            | 'name'
            | 'iconUrl'
            | 'websiteUrl'
            | 'kind'
          >,
        legalEntities: Array<(
          Pick<AdminLegalEntity, 'createdAt' | 'userCount' | 'deletedAt'>
          & { legalEntity: (
            Pick<
              LegalEntity,
              | 'id'
              | 'slug'
              | 'name'
              | 'websiteUrl'
              | 'industry'
              | 'timezone'
              | 'fiscalYearStartMonth'
              | 'fiscalYearNumberOffset'
              | 'status'
              | 'organizationId'
              | 'sensitive'
              | 'phoneNumber'
              | 'iconUrl'
            >
            & {
              address: Pick<
                  Address,
                  | 'street'
                  | 'streetAdditional'
                  | 'city'
                  | 'region'
                  | 'postalCode'
                  | 'countryCode'
                  | 'lat'
                  | 'long'
                >,
              incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
            }
          ) }
        )>,
        affiliateLegalEntities: Array<(
          Pick<AdminLegalEntity, 'createdAt' | 'userCount' | 'deletedAt'>
          & { legalEntity: (
            Pick<
              LegalEntity,
              | 'id'
              | 'slug'
              | 'name'
              | 'websiteUrl'
              | 'industry'
              | 'timezone'
              | 'fiscalYearStartMonth'
              | 'fiscalYearNumberOffset'
              | 'status'
              | 'organizationId'
              | 'sensitive'
              | 'phoneNumber'
              | 'iconUrl'
            >
            & {
              address: Pick<
                  Address,
                  | 'street'
                  | 'streetAdditional'
                  | 'city'
                  | 'region'
                  | 'postalCode'
                  | 'countryCode'
                  | 'lat'
                  | 'long'
                >,
              incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
            }
          ) }
        )>,
      }
    )>,
    legalEntities: Array<(
      Pick<AdminLegalEntity, 'createdAt' | 'userCount' | 'deletedAt'>
      & { legalEntity: (
        Pick<
          LegalEntity,
          | 'id'
          | 'slug'
          | 'name'
          | 'websiteUrl'
          | 'industry'
          | 'timezone'
          | 'fiscalYearStartMonth'
          | 'fiscalYearNumberOffset'
          | 'status'
          | 'organizationId'
          | 'sensitive'
          | 'phoneNumber'
          | 'iconUrl'
        >
        & {
          address: Pick<
              Address,
              | 'street'
              | 'streetAdditional'
              | 'city'
              | 'region'
              | 'postalCode'
              | 'countryCode'
              | 'lat'
              | 'long'
            >,
          incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
        }
      ) }
    )>,
    users: Array<(
      Pick<
        AdminUser,
        | 'timezone'
        | 'invitationId'
        | 'accountLocked'
        | 'banned'
      >
      & {
        user: (
          Pick<
            User,
            | 'mfaEnforcedAt'
            | 'id'
            | 'givenName'
            | 'familyName'
            | 'primaryEmailAddress'
            | 'passwordSet'
            | 'avatarUrl'
            | 'createdAt'
            | 'lastActivityAt'
          >
          & {
            employments?: Maybe<Array<(
              Pick<OrganizationEmployment, 'employeeId'>
              & {
                role: Pick<Role, 'id'>,
                organization: Pick<
                    Organization,
                    | 'id'
                    | 'slug'
                    | 'name'
                    | 'iconUrl'
                    | 'websiteUrl'
                    | 'kind'
                  >,
                legalEntityRoles?: Maybe<Array<(
                  Pick<EmployeeLegalEntityRole, 'legalEntityId'>
                  & { role?: Maybe<Pick<Role, 'id'>> }
                )>>,
              }
            )>>,
            identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
          }
        ),
        employments?: Maybe<Array<(
          Pick<AdminUserEmployment, 'activatedAt' | 'status' | 'employeeId'>
          & {
            role: Pick<Role, 'id'>,
            organization: Pick<
                Organization,
                | 'id'
                | 'slug'
                | 'name'
                | 'iconUrl'
                | 'websiteUrl'
                | 'kind'
              >,
            legalEntityRoles?: Maybe<Array<(
              Pick<EmployeeLegalEntityRole, 'legalEntityId'>
              & { role?: Maybe<Pick<Role, 'id'>> }
            )>>,
          }
        )>>,
        affiliations?: Maybe<Array<{
            role: Pick<Role, 'id'>,
            userOrganization?: Maybe<Pick<
                Organization,
                | 'id'
                | 'slug'
                | 'name'
                | 'iconUrl'
                | 'websiteUrl'
                | 'kind'
              >>,
            affiliatedTo?: Maybe<(
              Pick<
                LegalEntity,
                | 'id'
                | 'slug'
                | 'name'
                | 'websiteUrl'
                | 'industry'
                | 'timezone'
                | 'fiscalYearStartMonth'
                | 'fiscalYearNumberOffset'
                | 'status'
                | 'organizationId'
                | 'sensitive'
                | 'phoneNumber'
                | 'iconUrl'
              >
              & {
                address: Pick<
                    Address,
                    | 'street'
                    | 'streetAdditional'
                    | 'city'
                    | 'region'
                    | 'postalCode'
                    | 'countryCode'
                    | 'lat'
                    | 'long'
                  >,
                incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
              }
            )>,
          }>>,
      }
    )>,
    signups: Array<(
      Pick<AdminSignup, 'createdAt' | 'updatedAt' | 'timezone'>
      & { signup: (
        Pick<
          Signup,
          | 'id'
          | 'status'
          | 'statusReason'
          | 'location'
          | 'industry'
          | 'companyName'
          | 'companyUrl'
          | 'companyLedger'
          | 'companyCurrency'
          | 'positionTitle'
          | 'profileURL'
          | 'oAuthEmailAddress'
          | 'oAuthService'
          | 'persona'
        >
        & { contact: Pick<
            Contact,
            | 'givenName'
            | 'familyName'
            | 'emailAddress'
            | 'avatarUrl'
          > }
      ) }
    )>,
    connectors: Array<(
      Pick<AdminConnector, 'installCount'>
      & { connector: (
        Pick<
          Connector,
          | 'id'
          | 'name'
          | 'tagline'
          | 'description'
          | 'category'
          | 'iconObjectName'
          | 'className'
          | 'canInstall'
        >
        & { connectorProperties?: Maybe<
          | (
            { __typename: 'AppConnectorProperties' }
            & Pick<
              AppConnectorProperties,
              | 'organizationId'
              | 'visibility'
              | 'homepageURL'
              | 'supportEmail'
              | 'developerEmail'
              | 'privacyPolicyURL'
              | 'termsOfServiceURL'
              | 'scopes'
              | 'redirectUris'
              | 'installUri'
            >
          )
          | (
            { __typename: 'BillConnectorProperties' }
            & Pick<BillConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'EmptyConnectorProperties' }
            & Pick<EmptyConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'FinchConnectorProperties' }
            & Pick<FinchConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'GustoConnectorProperties' }
            & Pick<GustoConnectorProperties, 'authorizationURL'>
          )
          | (
            { __typename: 'PlaidConnectorProperties' }
            & Pick<PlaidConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'RampConnectorProperties' }
            & Pick<RampConnectorProperties, 'authorizationURL'>
          )
          | (
            { __typename: 'StripeConnectorProperties' }
            & Pick<StripeConnectorProperties, 'appLinkURL'>
          )
        > }
      ) }
    )>,
  };

export type SearchByUuidQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type SearchByUuidQuery = { searchByUUID: Array<(
    Pick<UuidSearchResult, 'entityType'>
    & {
      user?: Maybe<(
        Pick<
          AdminUser,
          | 'timezone'
          | 'invitationId'
          | 'accountLocked'
          | 'banned'
        >
        & {
          user: (
            Pick<
              User,
              | 'mfaEnforcedAt'
              | 'id'
              | 'givenName'
              | 'familyName'
              | 'primaryEmailAddress'
              | 'passwordSet'
              | 'avatarUrl'
              | 'createdAt'
              | 'lastActivityAt'
            >
            & {
              employments?: Maybe<Array<(
                Pick<OrganizationEmployment, 'employeeId'>
                & {
                  role: Pick<Role, 'id'>,
                  organization: Pick<
                      Organization,
                      | 'id'
                      | 'slug'
                      | 'name'
                      | 'iconUrl'
                      | 'websiteUrl'
                      | 'kind'
                    >,
                  legalEntityRoles?: Maybe<Array<(
                    Pick<EmployeeLegalEntityRole, 'legalEntityId'>
                    & { role?: Maybe<Pick<Role, 'id'>> }
                  )>>,
                }
              )>>,
              identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
            }
          ),
          employments?: Maybe<Array<(
            Pick<AdminUserEmployment, 'activatedAt' | 'status' | 'employeeId'>
            & {
              role: Pick<Role, 'id'>,
              organization: Pick<
                  Organization,
                  | 'id'
                  | 'slug'
                  | 'name'
                  | 'iconUrl'
                  | 'websiteUrl'
                  | 'kind'
                >,
              legalEntityRoles?: Maybe<Array<(
                Pick<EmployeeLegalEntityRole, 'legalEntityId'>
                & { role?: Maybe<Pick<Role, 'id'>> }
              )>>,
            }
          )>>,
          affiliations?: Maybe<Array<{
              role: Pick<Role, 'id'>,
              userOrganization?: Maybe<Pick<
                  Organization,
                  | 'id'
                  | 'slug'
                  | 'name'
                  | 'iconUrl'
                  | 'websiteUrl'
                  | 'kind'
                >>,
              affiliatedTo?: Maybe<(
                Pick<
                  LegalEntity,
                  | 'id'
                  | 'slug'
                  | 'name'
                  | 'websiteUrl'
                  | 'industry'
                  | 'timezone'
                  | 'fiscalYearStartMonth'
                  | 'fiscalYearNumberOffset'
                  | 'status'
                  | 'organizationId'
                  | 'sensitive'
                  | 'phoneNumber'
                  | 'iconUrl'
                >
                & {
                  address: Pick<
                      Address,
                      | 'street'
                      | 'streetAdditional'
                      | 'city'
                      | 'region'
                      | 'postalCode'
                      | 'countryCode'
                      | 'lat'
                      | 'long'
                    >,
                  incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
                }
              )>,
            }>>,
        }
      )>,
      legalEntity?: Maybe<(
        Pick<AdminLegalEntity, 'createdAt' | 'userCount' | 'deletedAt'>
        & { legalEntity: (
          Pick<
            LegalEntity,
            | 'id'
            | 'slug'
            | 'name'
            | 'websiteUrl'
            | 'industry'
            | 'timezone'
            | 'fiscalYearStartMonth'
            | 'fiscalYearNumberOffset'
            | 'status'
            | 'organizationId'
            | 'sensitive'
            | 'phoneNumber'
            | 'iconUrl'
          >
          & {
            address: Pick<
                Address,
                | 'street'
                | 'streetAdditional'
                | 'city'
                | 'region'
                | 'postalCode'
                | 'countryCode'
                | 'lat'
                | 'long'
              >,
            incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
          }
        ) }
      )>,
      organization?: Maybe<(
        Pick<AdminOrganization, 'createdAt' | 'deletedAt' | 'userCount'>
        & {
          organization: Pick<
              Organization,
              | 'id'
              | 'slug'
              | 'name'
              | 'iconUrl'
              | 'websiteUrl'
              | 'kind'
            >,
          legalEntities: Array<(
            Pick<AdminLegalEntity, 'createdAt' | 'userCount' | 'deletedAt'>
            & { legalEntity: (
              Pick<
                LegalEntity,
                | 'id'
                | 'slug'
                | 'name'
                | 'websiteUrl'
                | 'industry'
                | 'timezone'
                | 'fiscalYearStartMonth'
                | 'fiscalYearNumberOffset'
                | 'status'
                | 'organizationId'
                | 'sensitive'
                | 'phoneNumber'
                | 'iconUrl'
              >
              & {
                address: Pick<
                    Address,
                    | 'street'
                    | 'streetAdditional'
                    | 'city'
                    | 'region'
                    | 'postalCode'
                    | 'countryCode'
                    | 'lat'
                    | 'long'
                  >,
                incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
              }
            ) }
          )>,
          affiliateLegalEntities: Array<(
            Pick<AdminLegalEntity, 'createdAt' | 'userCount' | 'deletedAt'>
            & { legalEntity: (
              Pick<
                LegalEntity,
                | 'id'
                | 'slug'
                | 'name'
                | 'websiteUrl'
                | 'industry'
                | 'timezone'
                | 'fiscalYearStartMonth'
                | 'fiscalYearNumberOffset'
                | 'status'
                | 'organizationId'
                | 'sensitive'
                | 'phoneNumber'
                | 'iconUrl'
              >
              & {
                address: Pick<
                    Address,
                    | 'street'
                    | 'streetAdditional'
                    | 'city'
                    | 'region'
                    | 'postalCode'
                    | 'countryCode'
                    | 'lat'
                    | 'long'
                  >,
                incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
              }
            ) }
          )>,
        }
      )>,
      connection?: Maybe<(
        Pick<
          AdminConnection,
          | 'id'
          | 'sourceName'
          | 'deletedAt'
          | 'legalEntityId'
          | 'connectorId'
          | 'dataSourceId'
          | 'createdAt'
          | 'status'
          | 'connectorClassName'
          | 'externalId'
          | 'consentedScopes'
          | 'supportedScopes'
        >
        & { sync?: Maybe<Pick<ConnectionSyncState, 'lastSuccessAt' | 'lastEventAt' | 'status'>> }
      )>,
      dataSource?: Maybe<{ dataSource: Pick<
            EnrichedDataSource,
            | 'id'
            | 'legalEntityId'
            | 'status'
            | 'statusReason'
            | 'providerType'
            | 'accountAlias'
            | 'createdAt'
            | 'updatedAt'
          > }>,
      connector?: Maybe<(
        Pick<AdminConnector, 'installCount'>
        & { connector: (
          Pick<
            Connector,
            | 'id'
            | 'name'
            | 'tagline'
            | 'description'
            | 'category'
            | 'iconObjectName'
            | 'className'
            | 'canInstall'
          >
          & { connectorProperties?: Maybe<
            | (
              { __typename: 'AppConnectorProperties' }
              & Pick<
                AppConnectorProperties,
                | 'organizationId'
                | 'visibility'
                | 'homepageURL'
                | 'supportEmail'
                | 'developerEmail'
                | 'privacyPolicyURL'
                | 'termsOfServiceURL'
                | 'scopes'
                | 'redirectUris'
                | 'installUri'
              >
            )
            | (
              { __typename: 'BillConnectorProperties' }
              & Pick<BillConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'EmptyConnectorProperties' }
              & Pick<EmptyConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'FinchConnectorProperties' }
              & Pick<FinchConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'GustoConnectorProperties' }
              & Pick<GustoConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'PlaidConnectorProperties' }
              & Pick<PlaidConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'RampConnectorProperties' }
              & Pick<RampConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'StripeConnectorProperties' }
              & Pick<StripeConnectorProperties, 'appLinkURL'>
            )
          > }
        ) }
      )>,
    }
  )> };

export type AdminCategoryFieldsFragment = (
  Pick<
    AdminCategory,
    | 'externalId'
    | 'subtype'
    | 'chartOfAccountsDisplayNumber'
    | 'externalAccountType'
    | 'externalAccountSubtype'
    | 'synthesized'
  >
  & { category: (
    Pick<
      Category,
      | 'id'
      | 'name'
      | 'description'
      | 'displayKey'
      | 'type'
      | 'subtype'
      | 'parentCategoryId'
      | 'displayNumber'
      | 'active'
      | 'categoryState'
      | 'productArea'
      | 'synthesized'
    >
    & { ancestors?: Maybe<Array<Pick<
        EntityCategory,
        | 'id'
        | 'name'
        | 'displayKey'
        | 'chartOfAccountsDisplayNumber'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'productArea'
        | 'active'
      >>> }
  ) }
);

export type AdminChartOfAccountsFieldsFragment = { chart: (
    Pick<
      ChartOfAccounts,
      | 'id'
      | 'name'
      | 'description'
      | 'accountingBasis'
    >
    & { categories: Array<(
      Pick<
        Category,
        | 'id'
        | 'name'
        | 'description'
        | 'displayKey'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'displayNumber'
        | 'active'
        | 'categoryState'
        | 'productArea'
        | 'synthesized'
      >
      & { ancestors?: Maybe<Array<Pick<
          EntityCategory,
          | 'id'
          | 'name'
          | 'displayKey'
          | 'chartOfAccountsDisplayNumber'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'productArea'
          | 'active'
        >>> }
    )> }
  ) };

export type AdminChartOfAccountsTemplateFieldsFragment = (
  Pick<
    ChartOfAccountsTemplate,
    | 'organizationId'
    | 'templateId'
    | 'name'
    | 'description'
  >
  & { categories: Array<Pick<
      TemplateCategory,
      | 'organizationId'
      | 'templateId'
      | 'categoryId'
      | 'parentCategoryId'
      | 'name'
      | 'description'
      | 'type'
      | 'subtype'
      | 'categoryState'
      | 'chartOfAccountsDisplayNumber'
      | 'externalAccountType'
      | 'externalAccountSubtype'
      | 'displayKey'
    >> }
);

export type TemplateCategoryFieldsFragment = Pick<
    TemplateCategory,
    | 'organizationId'
    | 'templateId'
    | 'categoryId'
    | 'parentCategoryId'
    | 'name'
    | 'description'
    | 'type'
    | 'subtype'
    | 'categoryState'
    | 'chartOfAccountsDisplayNumber'
    | 'externalAccountType'
    | 'externalAccountSubtype'
    | 'displayKey'
  >;

export type AdminChartOfAccountsTemplateSummaryFieldsFragment = Pick<
    ChartOfAccountsTemplateSummary,
    | 'organizationId'
    | 'templateId'
    | 'name'
    | 'description'
  >;

export type AdminDoppelgangerPermitFieldsFragment = (
  Pick<AdminDoppelgangerPermit, 'justification' | 'sessionStartedAt' | 'sessionEndedAt'>
  & {
    doppelgangerPermit: (
      Pick<DoppelgangerPermit, 'id' | 'expiresAt' | 'createdAt'>
      & { user: (
        Pick<
          User,
          | 'id'
          | 'givenName'
          | 'familyName'
          | 'primaryEmailAddress'
          | 'passwordSet'
          | 'avatarUrl'
          | 'createdAt'
          | 'lastActivityAt'
        >
        & {
          employments?: Maybe<Array<(
            Pick<OrganizationEmployment, 'employeeId'>
            & {
              role: Pick<Role, 'id'>,
              organization: Pick<
                  Organization,
                  | 'id'
                  | 'slug'
                  | 'name'
                  | 'iconUrl'
                  | 'websiteUrl'
                  | 'kind'
                >,
              legalEntityRoles?: Maybe<Array<(
                Pick<EmployeeLegalEntityRole, 'legalEntityId'>
                & { role?: Maybe<Pick<Role, 'id'>> }
              )>>,
            }
          )>>,
          identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
        }
      ) }
    ),
    authorizer: (
      Pick<
        Superuser,
        | 'id'
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
        | 'createdAt'
        | 'lastLoginAt'
      >
      & { roles: Array<Pick<SuperuserRole, 'identifier' | 'displayName' | 'description'>> }
    ),
  }
);

export type AdminLegalEntityFieldsFragment = (
  Pick<AdminLegalEntity, 'createdAt' | 'userCount' | 'deletedAt'>
  & { legalEntity: (
    Pick<
      LegalEntity,
      | 'id'
      | 'slug'
      | 'name'
      | 'websiteUrl'
      | 'industry'
      | 'timezone'
      | 'fiscalYearStartMonth'
      | 'fiscalYearNumberOffset'
      | 'status'
      | 'organizationId'
      | 'sensitive'
      | 'phoneNumber'
      | 'iconUrl'
    >
    & {
      address: Pick<
          Address,
          | 'street'
          | 'streetAdditional'
          | 'city'
          | 'region'
          | 'postalCode'
          | 'countryCode'
          | 'lat'
          | 'long'
        >,
      incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
    }
  ) }
);

export type AdminOrganizationFieldsFragment = (
  Pick<AdminOrganization, 'createdAt' | 'deletedAt' | 'userCount'>
  & {
    organization: Pick<
        Organization,
        | 'id'
        | 'slug'
        | 'name'
        | 'iconUrl'
        | 'websiteUrl'
        | 'kind'
      >,
    legalEntities: Array<(
      Pick<AdminLegalEntity, 'createdAt' | 'userCount' | 'deletedAt'>
      & { legalEntity: (
        Pick<
          LegalEntity,
          | 'id'
          | 'slug'
          | 'name'
          | 'websiteUrl'
          | 'industry'
          | 'timezone'
          | 'fiscalYearStartMonth'
          | 'fiscalYearNumberOffset'
          | 'status'
          | 'organizationId'
          | 'sensitive'
          | 'phoneNumber'
          | 'iconUrl'
        >
        & {
          address: Pick<
              Address,
              | 'street'
              | 'streetAdditional'
              | 'city'
              | 'region'
              | 'postalCode'
              | 'countryCode'
              | 'lat'
              | 'long'
            >,
          incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
        }
      ) }
    )>,
    affiliateLegalEntities: Array<(
      Pick<AdminLegalEntity, 'createdAt' | 'userCount' | 'deletedAt'>
      & { legalEntity: (
        Pick<
          LegalEntity,
          | 'id'
          | 'slug'
          | 'name'
          | 'websiteUrl'
          | 'industry'
          | 'timezone'
          | 'fiscalYearStartMonth'
          | 'fiscalYearNumberOffset'
          | 'status'
          | 'organizationId'
          | 'sensitive'
          | 'phoneNumber'
          | 'iconUrl'
        >
        & {
          address: Pick<
              Address,
              | 'street'
              | 'streetAdditional'
              | 'city'
              | 'region'
              | 'postalCode'
              | 'countryCode'
              | 'lat'
              | 'long'
            >,
          incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
        }
      ) }
    )>,
  }
);

export type AdminScheduleTemplateSummaryFieldsFragment = Pick<
    AdminScheduleTemplateSummary,
    | 'scheduleTemplateId'
    | 'name'
    | 'description'
    | 'type'
    | 'displayKey'
    | 'organizationId'
    | 'createdAt'
    | 'updatedAt'
    | 'eventCount'
    | 'variableCount'
    | 'specializationCount'
    | 'formulaCount'
  >;

export type AdminScheduleTemplateFieldsFragment = (
  Pick<
    AdminScheduleTemplate,
    | 'scheduleTemplateId'
    | 'name'
    | 'description'
    | 'type'
    | 'displayKey'
    | 'organizationId'
    | 'createdAt'
    | 'updatedAt'
  >
  & {
    events: Array<(
      Pick<
        AdminScheduleEventTemplate,
        | 'eventTemplateId'
        | 'name'
        | 'displayName'
        | 'description'
        | 'ordinal'
        | 'displayKey'
        | 'isInstantiating'
        | 'isTerminating'
        | 'isSingleton'
        | 'inCreateFlow'
        | 'generatorType'
        | 'generatedEventTemplateId'
        | 'skipConditionName'
        | 'skipConditionExpr'
        | 'dateSource'
      >
      & {
        variables: Array<(
          Pick<
            AdminScheduleEventVariableTemplate,
            | 'variableTemplateId'
            | 'variableName'
            | 'displayName'
            | 'variableType'
            | 'required'
            | 'ordinal'
            | 'displayMode'
            | 'applyExpr'
            | 'validationExpr'
            | 'validationMessage'
            | 'specializable'
          >
          & { defaultValue?: Maybe<(
            Pick<
              AdminScheduleVariableDefault,
              | 'source'
              | 'stringValue'
              | 'intValue'
              | 'floatValue'
              | 'boolValue'
              | 'dateValue'
              | 'intervalValue'
              | 'formulaId'
              | 'formulaDisplayName'
              | 'categoryHint'
            >
            & { amountValue?: Maybe<Pick<MonetaryValue, 'amount' | 'iso4217CurrencyCode' | 'currencyMultiplier'>> }
          )> }
        )>,
        supportedFormulas: Array<Pick<AdminScheduleFormulaBinding, 'formulaId' | 'displayName' | 'ordinal'>>,
        journalEntry?: Maybe<(
          Pick<AdminScheduleJournalEntryTemplate, 'journalEntryTemplateId' | 'memo' | 'skipCondition'>
          & { lines: Array<Pick<
              AdminScheduleJournalEntryLineTemplate,
              | 'lineTemplateId'
              | 'ordinal'
              | 'description'
              | 'entryType'
              | 'entryTypeExpression'
              | 'categoryVariable'
              | 'amountVariable'
              | 'skipCondition'
            >> }
        )>,
      }
    )>,
    formulas: Array<Pick<AdminScheduleFormula, 'formulaId' | 'displayName' | 'expression'>>,
  }
);

export type AdminScheduleEventTemplateFieldsFragment = (
  Pick<
    AdminScheduleEventTemplate,
    | 'eventTemplateId'
    | 'name'
    | 'displayName'
    | 'description'
    | 'ordinal'
    | 'displayKey'
    | 'isInstantiating'
    | 'isTerminating'
    | 'isSingleton'
    | 'inCreateFlow'
    | 'generatorType'
    | 'generatedEventTemplateId'
    | 'skipConditionName'
    | 'skipConditionExpr'
    | 'dateSource'
  >
  & {
    variables: Array<(
      Pick<
        AdminScheduleEventVariableTemplate,
        | 'variableTemplateId'
        | 'variableName'
        | 'displayName'
        | 'variableType'
        | 'required'
        | 'ordinal'
        | 'displayMode'
        | 'applyExpr'
        | 'validationExpr'
        | 'validationMessage'
        | 'specializable'
      >
      & { defaultValue?: Maybe<(
        Pick<
          AdminScheduleVariableDefault,
          | 'source'
          | 'stringValue'
          | 'intValue'
          | 'floatValue'
          | 'boolValue'
          | 'dateValue'
          | 'intervalValue'
          | 'formulaId'
          | 'formulaDisplayName'
          | 'categoryHint'
        >
        & { amountValue?: Maybe<Pick<MonetaryValue, 'amount' | 'iso4217CurrencyCode' | 'currencyMultiplier'>> }
      )> }
    )>,
    supportedFormulas: Array<Pick<AdminScheduleFormulaBinding, 'formulaId' | 'displayName' | 'ordinal'>>,
    journalEntry?: Maybe<(
      Pick<AdminScheduleJournalEntryTemplate, 'journalEntryTemplateId' | 'memo' | 'skipCondition'>
      & { lines: Array<Pick<
          AdminScheduleJournalEntryLineTemplate,
          | 'lineTemplateId'
          | 'ordinal'
          | 'description'
          | 'entryType'
          | 'entryTypeExpression'
          | 'categoryVariable'
          | 'amountVariable'
          | 'skipCondition'
        >> }
    )>,
  }
);

export type AdminScheduleEventVariableTemplateFieldsFragment = (
  Pick<
    AdminScheduleEventVariableTemplate,
    | 'variableTemplateId'
    | 'variableName'
    | 'displayName'
    | 'variableType'
    | 'required'
    | 'ordinal'
    | 'displayMode'
    | 'applyExpr'
    | 'validationExpr'
    | 'validationMessage'
    | 'specializable'
  >
  & { defaultValue?: Maybe<(
    Pick<
      AdminScheduleVariableDefault,
      | 'source'
      | 'stringValue'
      | 'intValue'
      | 'floatValue'
      | 'boolValue'
      | 'dateValue'
      | 'intervalValue'
      | 'formulaId'
      | 'formulaDisplayName'
      | 'categoryHint'
    >
    & { amountValue?: Maybe<Pick<MonetaryValue, 'amount' | 'iso4217CurrencyCode' | 'currencyMultiplier'>> }
  )> }
);

export type AdminScheduleVariableDefaultFieldsFragment = (
  Pick<
    AdminScheduleVariableDefault,
    | 'source'
    | 'stringValue'
    | 'intValue'
    | 'floatValue'
    | 'boolValue'
    | 'dateValue'
    | 'intervalValue'
    | 'formulaId'
    | 'formulaDisplayName'
    | 'categoryHint'
  >
  & { amountValue?: Maybe<Pick<MonetaryValue, 'amount' | 'iso4217CurrencyCode' | 'currencyMultiplier'>> }
);

export type AdminScheduleFormulaFieldsFragment = Pick<AdminScheduleFormula, 'formulaId' | 'displayName' | 'expression'>;

export type AdminScheduleFormulaBindingFieldsFragment = Pick<AdminScheduleFormulaBinding, 'formulaId' | 'displayName' | 'ordinal'>;

export type AdminScheduleJournalEntryTemplateFieldsFragment = (
  Pick<AdminScheduleJournalEntryTemplate, 'journalEntryTemplateId' | 'memo' | 'skipCondition'>
  & { lines: Array<Pick<
      AdminScheduleJournalEntryLineTemplate,
      | 'lineTemplateId'
      | 'ordinal'
      | 'description'
      | 'entryType'
      | 'entryTypeExpression'
      | 'categoryVariable'
      | 'amountVariable'
      | 'skipCondition'
    >> }
);

export type AdminScheduleJournalEntryLineTemplateFieldsFragment = Pick<
    AdminScheduleJournalEntryLineTemplate,
    | 'lineTemplateId'
    | 'ordinal'
    | 'description'
    | 'entryType'
    | 'entryTypeExpression'
    | 'categoryVariable'
    | 'amountVariable'
    | 'skipCondition'
  >;

export type AdminScheduleSpecializationFieldsFragment = Pick<
    AdminScheduleSpecialization,
    | 'specializationId'
    | 'scheduleTemplateId'
    | 'name'
    | 'displayKey'
    | 'description'
    | 'organizationId'
    | 'ownerOrganizationId'
    | 'legalEntityId'
    | 'createdAt'
    | 'updatedAt'
  >;

export type AdminScheduleSpecializationDetailFieldsFragment = {
    specialization: Pick<
        AdminScheduleSpecialization,
        | 'specializationId'
        | 'scheduleTemplateId'
        | 'name'
        | 'displayKey'
        | 'description'
        | 'organizationId'
        | 'ownerOrganizationId'
        | 'legalEntityId'
        | 'createdAt'
        | 'updatedAt'
      >,
    template: (
      Pick<
        AdminScheduleTemplate,
        | 'scheduleTemplateId'
        | 'name'
        | 'description'
        | 'type'
        | 'displayKey'
        | 'organizationId'
        | 'createdAt'
        | 'updatedAt'
      >
      & {
        events: Array<(
          Pick<
            AdminScheduleEventTemplate,
            | 'eventTemplateId'
            | 'name'
            | 'displayName'
            | 'description'
            | 'ordinal'
            | 'displayKey'
            | 'isInstantiating'
            | 'isTerminating'
            | 'isSingleton'
            | 'inCreateFlow'
            | 'generatorType'
            | 'generatedEventTemplateId'
            | 'skipConditionName'
            | 'skipConditionExpr'
            | 'dateSource'
          >
          & {
            variables: Array<(
              Pick<
                AdminScheduleEventVariableTemplate,
                | 'variableTemplateId'
                | 'variableName'
                | 'displayName'
                | 'variableType'
                | 'required'
                | 'ordinal'
                | 'displayMode'
                | 'applyExpr'
                | 'validationExpr'
                | 'validationMessage'
                | 'specializable'
              >
              & { defaultValue?: Maybe<(
                Pick<
                  AdminScheduleVariableDefault,
                  | 'source'
                  | 'stringValue'
                  | 'intValue'
                  | 'floatValue'
                  | 'boolValue'
                  | 'dateValue'
                  | 'intervalValue'
                  | 'formulaId'
                  | 'formulaDisplayName'
                  | 'categoryHint'
                >
                & { amountValue?: Maybe<Pick<MonetaryValue, 'amount' | 'iso4217CurrencyCode' | 'currencyMultiplier'>> }
              )> }
            )>,
            supportedFormulas: Array<Pick<AdminScheduleFormulaBinding, 'formulaId' | 'displayName' | 'ordinal'>>,
            journalEntry?: Maybe<(
              Pick<AdminScheduleJournalEntryTemplate, 'journalEntryTemplateId' | 'memo' | 'skipCondition'>
              & { lines: Array<Pick<
                  AdminScheduleJournalEntryLineTemplate,
                  | 'lineTemplateId'
                  | 'ordinal'
                  | 'description'
                  | 'entryType'
                  | 'entryTypeExpression'
                  | 'categoryVariable'
                  | 'amountVariable'
                  | 'skipCondition'
                >> }
            )>,
          }
        )>,
        formulas: Array<Pick<AdminScheduleFormula, 'formulaId' | 'displayName' | 'expression'>>,
      }
    ),
    overrides: Array<(
      Pick<AdminScheduleSpecializationVariableOverride, 'eventTemplateId' | 'variableTemplateId'>
      & { value: (
        Pick<
          AdminScheduleVariableDefault,
          | 'source'
          | 'stringValue'
          | 'intValue'
          | 'floatValue'
          | 'boolValue'
          | 'dateValue'
          | 'intervalValue'
          | 'formulaId'
          | 'formulaDisplayName'
          | 'categoryHint'
        >
        & { amountValue?: Maybe<Pick<MonetaryValue, 'amount' | 'iso4217CurrencyCode' | 'currencyMultiplier'>> }
      ) }
    )>,
  };

export type ChartOfAccountsFieldsFragment = (
  Pick<
    ChartOfAccounts,
    | 'id'
    | 'name'
    | 'description'
    | 'accountingBasis'
  >
  & { categories: Array<(
    Pick<
      Category,
      | 'id'
      | 'name'
      | 'description'
      | 'displayKey'
      | 'type'
      | 'subtype'
      | 'parentCategoryId'
      | 'displayNumber'
      | 'active'
      | 'categoryState'
      | 'productArea'
      | 'synthesized'
    >
    & { ancestors?: Maybe<Array<Pick<
        EntityCategory,
        | 'id'
        | 'name'
        | 'displayKey'
        | 'chartOfAccountsDisplayNumber'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'productArea'
        | 'active'
      >>> }
  )> }
);

export type ChartOfAccountsListEntryFieldsFragment = Pick<
    ChartOfAccountsListEntry,
    | 'id'
    | 'name'
    | 'description'
    | 'accountingBasis'
    | 'legalEntityId'
  >;

export type EmailStatusFieldsFragment = Pick<EmailStatus, 'rawStatus' | 'updatedAt'>;

export type MappedCategoryFieldsFragment = {
    fromCategory?: Maybe<(
      Pick<
        AdminCategory,
        | 'externalId'
        | 'subtype'
        | 'chartOfAccountsDisplayNumber'
        | 'externalAccountType'
        | 'externalAccountSubtype'
        | 'synthesized'
      >
      & { category: (
        Pick<
          Category,
          | 'id'
          | 'name'
          | 'description'
          | 'displayKey'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'displayNumber'
          | 'active'
          | 'categoryState'
          | 'productArea'
          | 'synthesized'
        >
        & { ancestors?: Maybe<Array<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>> }
      ) }
    )>,
    toCategory?: Maybe<(
      Pick<
        AdminCategory,
        | 'externalId'
        | 'subtype'
        | 'chartOfAccountsDisplayNumber'
        | 'externalAccountType'
        | 'externalAccountSubtype'
        | 'synthesized'
      >
      & { category: (
        Pick<
          Category,
          | 'id'
          | 'name'
          | 'description'
          | 'displayKey'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'displayNumber'
          | 'active'
          | 'categoryState'
          | 'productArea'
          | 'synthesized'
        >
        & { ancestors?: Maybe<Array<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>> }
      ) }
    )>,
  };

export type MappedChartOfAccountsFieldsFragment = (
  Pick<
    MappedChartOfAccounts,
    | 'fromUUID'
    | 'toUUID'
    | 'name'
    | 'description'
    | 'legalEntityId'
    | 'accountingBasis'
  >
  & { categories: Array<{
      fromCategory?: Maybe<(
        Pick<
          AdminCategory,
          | 'externalId'
          | 'subtype'
          | 'chartOfAccountsDisplayNumber'
          | 'externalAccountType'
          | 'externalAccountSubtype'
          | 'synthesized'
        >
        & { category: (
          Pick<
            Category,
            | 'id'
            | 'name'
            | 'description'
            | 'displayKey'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'displayNumber'
            | 'active'
            | 'categoryState'
            | 'productArea'
            | 'synthesized'
          >
          & { ancestors?: Maybe<Array<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>> }
        ) }
      )>,
      toCategory?: Maybe<(
        Pick<
          AdminCategory,
          | 'externalId'
          | 'subtype'
          | 'chartOfAccountsDisplayNumber'
          | 'externalAccountType'
          | 'externalAccountSubtype'
          | 'synthesized'
        >
        & { category: (
          Pick<
            Category,
            | 'id'
            | 'name'
            | 'description'
            | 'displayKey'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'displayNumber'
            | 'active'
            | 'categoryState'
            | 'productArea'
            | 'synthesized'
          >
          & { ancestors?: Maybe<Array<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>> }
        ) }
      )>,
    }> }
);

export type AdminSignupFieldsFragment = (
  Pick<AdminSignup, 'createdAt' | 'updatedAt' | 'timezone'>
  & { signup: (
    Pick<
      Signup,
      | 'id'
      | 'status'
      | 'statusReason'
      | 'location'
      | 'industry'
      | 'companyName'
      | 'companyUrl'
      | 'companyLedger'
      | 'companyCurrency'
      | 'positionTitle'
      | 'profileURL'
      | 'oAuthEmailAddress'
      | 'oAuthService'
      | 'persona'
    >
    & { contact: Pick<
        Contact,
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      > }
  ) }
);

export type SignupFieldsFragment = (
  Pick<
    Signup,
    | 'id'
    | 'status'
    | 'statusReason'
    | 'location'
    | 'industry'
    | 'companyName'
    | 'companyUrl'
    | 'companyLedger'
    | 'companyCurrency'
    | 'positionTitle'
    | 'profileURL'
    | 'oAuthEmailAddress'
    | 'oAuthService'
    | 'persona'
  >
  & { contact: Pick<
      Contact,
      | 'givenName'
      | 'familyName'
      | 'emailAddress'
      | 'avatarUrl'
    > }
);

export type UpdateSignupStatusMutationVariables = Exact<{
  id: Scalars['String']['input'];
  status: SignupStatus;
  statusReason?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateSignupStatusMutation = Pick<Mutation, 'updateSignupStatus'>;

export type ReadSignupQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ReadSignupQuery = { readSignup: (
    Pick<AdminSignup, 'createdAt' | 'updatedAt' | 'timezone'>
    & { signup: (
      Pick<
        Signup,
        | 'id'
        | 'status'
        | 'statusReason'
        | 'location'
        | 'industry'
        | 'companyName'
        | 'companyUrl'
        | 'companyLedger'
        | 'companyCurrency'
        | 'positionTitle'
        | 'profileURL'
        | 'oAuthEmailAddress'
        | 'oAuthService'
        | 'persona'
      >
      & { contact: Pick<
          Contact,
          | 'givenName'
          | 'familyName'
          | 'emailAddress'
          | 'avatarUrl'
        > }
    ) }
  ) };

export type SoftDeleteOrganizationMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  kind: OrganizationKind;
  deleteUsers: Scalars['Boolean']['input'];
}>;


export type SoftDeleteOrganizationMutation = Pick<Mutation, 'softDeleteOrganization'>;

export type SourceRecordedMatchSummaryEntryFieldsFragment = (
  Pick<
    SourceRecordedMatchSummaryEntry,
    | 'total'
    | 'matched'
    | 'unmatched'
    | 'unmatchedAndUncategorized'
  >
  & {
    period: Pick<
        Period,
        | 'name'
        | 'interval'
        | 'startedAt'
        | 'endedAt'
      >,
    institution: Pick<
        Institution,
        | 'id'
        | 'name'
        | 'url'
        | 'routingNumber'
        | 'iconUrl'
        | 'partyId'
        | 'createdAt'
      >,
  }
);

export type SourceRecordedMatchSummaryFieldsFragment = { entries: Array<(
    Pick<
      SourceRecordedMatchSummaryEntry,
      | 'total'
      | 'matched'
      | 'unmatched'
      | 'unmatchedAndUncategorized'
    >
    & {
      period: Pick<
          Period,
          | 'name'
          | 'interval'
          | 'startedAt'
          | 'endedAt'
        >,
      institution: Pick<
          Institution,
          | 'id'
          | 'name'
          | 'url'
          | 'routingNumber'
          | 'iconUrl'
          | 'partyId'
          | 'createdAt'
        >,
    }
  )> };

export type ReadSourceRecordedMatchSummaryQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ReadSourceRecordedMatchSummaryQuery = { readSourceRecordedMatchSummary: { entries: Array<(
      Pick<
        SourceRecordedMatchSummaryEntry,
        | 'total'
        | 'matched'
        | 'unmatched'
        | 'unmatchedAndUncategorized'
      >
      & {
        period: Pick<
            Period,
            | 'name'
            | 'interval'
            | 'startedAt'
            | 'endedAt'
          >,
        institution: Pick<
            Institution,
            | 'id'
            | 'name'
            | 'url'
            | 'routingNumber'
            | 'iconUrl'
            | 'partyId'
            | 'createdAt'
          >,
      }
    )> } };

export type TriggerDigitsLedgerReviewMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  ledgerType: LedgerType;
}>;


export type TriggerDigitsLedgerReviewMutation = Pick<Mutation, 'triggerDigitsLedgerReview'>;

export type DeleteCsvImportTransactionsMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  csvImportId: Scalars['String']['input'];
}>;


export type DeleteCsvImportTransactionsMutation = Pick<Mutation, 'deleteCsvImportTransactions'>;

export type TriggerSourceDataClassificationMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  dataSourceId: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
}>;


export type TriggerSourceDataClassificationMutation = Pick<Mutation, 'triggerSourceDataClassification'>;

export type AllTransactionFactMetadataQueryVariables = Exact<{
  transactionFactId: Scalars['String']['input'];
}>;


export type AllTransactionFactMetadataQuery = {
    readTransactionFact: (
      Pick<
        AdminTransactionFact,
        | 'transactionFactId'
        | 'legalEntityId'
        | 'externalId'
        | 'externalName'
        | 'externalDescription'
        | 'pending'
        | 'transactionType'
        | 'externalTimestamp'
        | 'externalCreatedAt'
        | 'externalModifiedAt'
        | 'createdAt'
        | 'updatedAt'
        | 'ledgerTransactionId'
        | 'supersedingLedgerTransactionId'
        | 'supersededLedgerTransactionIds'
      >
      & {
        dataSource: (
          Pick<
            EnrichedDataSource,
            | 'id'
            | 'legalEntityId'
            | 'status'
            | 'statusReason'
            | 'providerType'
            | 'accountAlias'
            | 'createdAt'
            | 'updatedAt'
            | 'lastActivityAt'
            | 'hasTransactions'
          >
          & {
            institution: Pick<
                Party,
                | 'id'
                | 'legalEntityId'
                | 'name'
                | 'url'
                | 'supportUrl'
                | 'supportEmail'
                | 'supportPhone'
                | 'twitterUrl'
                | 'facebookUrl'
                | 'instagramUrl'
                | 'yelpUrl'
                | 'iconUrl'
                | 'shortDescription'
                | 'designation'
              >,
            quickBooksConfig?: Maybe<Pick<
                QuickBooksConfig,
                | 'id'
                | 'realmId'
                | 'createdAt'
                | 'updatedAt'
              >>,
            plaidConfig?: Maybe<Pick<
                PlaidConfig,
                | 'id'
                | 'itemId'
                | 'externalInstitutionId'
                | 'createdAt'
                | 'updatedAt'
              >>,
            sourceAccounts?: Maybe<Array<Pick<
                SourceAccount,
                | 'id'
                | 'externalId'
                | 'externalName'
                | 'externalOwnerName'
                | 'externalOfficialName'
                | 'externalType'
                | 'externalSubtype'
                | 'mask'
                | 'status'
                | 'ownerEmployeeId'
              >>>,
          }
        ),
        sourceAccount?: Maybe<Pick<
            SourceAccount,
            | 'id'
            | 'externalId'
            | 'externalName'
            | 'externalOwnerName'
            | 'externalOfficialName'
            | 'externalType'
            | 'externalSubtype'
            | 'mask'
            | 'status'
            | 'ownerEmployeeId'
          >>,
        checkMetadata?: Maybe<Pick<AdminTransactionFactCheckMetadata, 'payer' | 'payee' | 'memo'>>,
      }
    ),
    readEntityExtractions: Array<Pick<
        AdminTransactionEntityExtraction,
        | 'classificationVersionId'
        | 'party'
        | 'partyScore'
        | 'phone'
        | 'phoneScore'
        | 'location'
        | 'locationScore'
        | 'proxy'
        | 'proxyScore'
        | 'person'
        | 'personScore'
        | 'url'
        | 'urlScore'
        | 'institution'
        | 'institutionScore'
        | 'date'
        | 'dateScore'
        | 'creditCard'
        | 'creditCardScore'
        | 'updatedAt'
      >>,
    listTransactionFactPartyClassifications: Array<(
      Pick<
        AdminPartyClassification,
        | 'prefix'
        | 'prefixDescription'
        | 'role'
        | 'overlayName'
      >
      & {
        party: Pick<
            Party,
            | 'id'
            | 'legalEntityId'
            | 'name'
            | 'url'
            | 'supportUrl'
            | 'supportEmail'
            | 'supportPhone'
            | 'twitterUrl'
            | 'facebookUrl'
            | 'instagramUrl'
            | 'yelpUrl'
            | 'iconUrl'
            | 'shortDescription'
            | 'designation'
          >,
        classification: Pick<
            AdminClassification,
            | 'version'
            | 'legalEntityId'
            | 'rule'
            | 'createdAt'
            | 'updatedAt'
          >,
      }
    )>,
    listTransactionFactCategoryClassifications: Array<(
      Pick<AdminCategoryClassification, 'entryType' | 'transactionFactId'>
      & {
        category: (
          Pick<
            Category,
            | 'id'
            | 'name'
            | 'description'
            | 'displayKey'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'displayNumber'
            | 'active'
            | 'categoryState'
            | 'productArea'
            | 'synthesized'
          >
          & { ancestors?: Maybe<Array<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>> }
        ),
        classification: Pick<
            AdminClassification,
            | 'version'
            | 'legalEntityId'
            | 'rule'
            | 'createdAt'
            | 'updatedAt'
          >,
      }
    )>,
    listTransactionFactLedgerPartyClassifications: Array<(
      Pick<
        AdminPartyClassification,
        | 'prefix'
        | 'prefixDescription'
        | 'role'
        | 'overlayName'
      >
      & {
        party: Pick<
            Party,
            | 'id'
            | 'legalEntityId'
            | 'name'
            | 'url'
            | 'supportUrl'
            | 'supportEmail'
            | 'supportPhone'
            | 'twitterUrl'
            | 'facebookUrl'
            | 'instagramUrl'
            | 'yelpUrl'
            | 'iconUrl'
            | 'shortDescription'
            | 'designation'
          >,
        classification: Pick<
            AdminClassification,
            | 'version'
            | 'legalEntityId'
            | 'rule'
            | 'createdAt'
            | 'updatedAt'
          >,
      }
    )>,
  };

export type AdminTransactionFactFieldsFragment = (
  Pick<
    AdminTransactionFact,
    | 'transactionFactId'
    | 'legalEntityId'
    | 'externalId'
    | 'externalName'
    | 'externalDescription'
    | 'pending'
    | 'transactionType'
    | 'externalTimestamp'
    | 'externalCreatedAt'
    | 'externalModifiedAt'
    | 'createdAt'
    | 'updatedAt'
    | 'ledgerTransactionId'
    | 'supersedingLedgerTransactionId'
    | 'supersededLedgerTransactionIds'
  >
  & {
    dataSource: (
      Pick<
        EnrichedDataSource,
        | 'id'
        | 'legalEntityId'
        | 'status'
        | 'statusReason'
        | 'providerType'
        | 'accountAlias'
        | 'createdAt'
        | 'updatedAt'
        | 'lastActivityAt'
        | 'hasTransactions'
      >
      & {
        institution: Pick<
            Party,
            | 'id'
            | 'legalEntityId'
            | 'name'
            | 'url'
            | 'supportUrl'
            | 'supportEmail'
            | 'supportPhone'
            | 'twitterUrl'
            | 'facebookUrl'
            | 'instagramUrl'
            | 'yelpUrl'
            | 'iconUrl'
            | 'shortDescription'
            | 'designation'
          >,
        quickBooksConfig?: Maybe<Pick<
            QuickBooksConfig,
            | 'id'
            | 'realmId'
            | 'createdAt'
            | 'updatedAt'
          >>,
        plaidConfig?: Maybe<Pick<
            PlaidConfig,
            | 'id'
            | 'itemId'
            | 'externalInstitutionId'
            | 'createdAt'
            | 'updatedAt'
          >>,
        sourceAccounts?: Maybe<Array<Pick<
            SourceAccount,
            | 'id'
            | 'externalId'
            | 'externalName'
            | 'externalOwnerName'
            | 'externalOfficialName'
            | 'externalType'
            | 'externalSubtype'
            | 'mask'
            | 'status'
            | 'ownerEmployeeId'
          >>>,
      }
    ),
    sourceAccount?: Maybe<Pick<
        SourceAccount,
        | 'id'
        | 'externalId'
        | 'externalName'
        | 'externalOwnerName'
        | 'externalOfficialName'
        | 'externalType'
        | 'externalSubtype'
        | 'mask'
        | 'status'
        | 'ownerEmployeeId'
      >>,
    checkMetadata?: Maybe<Pick<AdminTransactionFactCheckMetadata, 'payer' | 'payee' | 'memo'>>,
  }
);

export type AdminClassificationFieldsFragment = Pick<
    AdminClassification,
    | 'version'
    | 'legalEntityId'
    | 'rule'
    | 'createdAt'
    | 'updatedAt'
  >;

export type AdminTransactionEntityExtractionFieldsFragment = Pick<
    AdminTransactionEntityExtraction,
    | 'classificationVersionId'
    | 'party'
    | 'partyScore'
    | 'phone'
    | 'phoneScore'
    | 'location'
    | 'locationScore'
    | 'proxy'
    | 'proxyScore'
    | 'person'
    | 'personScore'
    | 'url'
    | 'urlScore'
    | 'institution'
    | 'institutionScore'
    | 'date'
    | 'dateScore'
    | 'creditCard'
    | 'creditCardScore'
    | 'updatedAt'
  >;

export type ListAssociatedTransactionFactsQueryVariables = Exact<{
  dataSourceId: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
}>;


export type ListAssociatedTransactionFactsQuery = { listAssociatedTransactionFacts: Array<(
    Pick<
      AdminTransactionFact,
      | 'transactionFactId'
      | 'legalEntityId'
      | 'externalId'
      | 'externalName'
      | 'externalDescription'
      | 'pending'
      | 'transactionType'
      | 'externalTimestamp'
      | 'externalCreatedAt'
      | 'externalModifiedAt'
      | 'createdAt'
      | 'updatedAt'
      | 'ledgerTransactionId'
      | 'supersedingLedgerTransactionId'
      | 'supersededLedgerTransactionIds'
    >
    & {
      dataSource: (
        Pick<
          EnrichedDataSource,
          | 'id'
          | 'legalEntityId'
          | 'status'
          | 'statusReason'
          | 'providerType'
          | 'accountAlias'
          | 'createdAt'
          | 'updatedAt'
          | 'lastActivityAt'
          | 'hasTransactions'
        >
        & {
          institution: Pick<
              Party,
              | 'id'
              | 'legalEntityId'
              | 'name'
              | 'url'
              | 'supportUrl'
              | 'supportEmail'
              | 'supportPhone'
              | 'twitterUrl'
              | 'facebookUrl'
              | 'instagramUrl'
              | 'yelpUrl'
              | 'iconUrl'
              | 'shortDescription'
              | 'designation'
            >,
          quickBooksConfig?: Maybe<Pick<
              QuickBooksConfig,
              | 'id'
              | 'realmId'
              | 'createdAt'
              | 'updatedAt'
            >>,
          plaidConfig?: Maybe<Pick<
              PlaidConfig,
              | 'id'
              | 'itemId'
              | 'externalInstitutionId'
              | 'createdAt'
              | 'updatedAt'
            >>,
          sourceAccounts?: Maybe<Array<Pick<
              SourceAccount,
              | 'id'
              | 'externalId'
              | 'externalName'
              | 'externalOwnerName'
              | 'externalOfficialName'
              | 'externalType'
              | 'externalSubtype'
              | 'mask'
              | 'status'
              | 'ownerEmployeeId'
            >>>,
        }
      ),
      sourceAccount?: Maybe<Pick<
          SourceAccount,
          | 'id'
          | 'externalId'
          | 'externalName'
          | 'externalOwnerName'
          | 'externalOfficialName'
          | 'externalType'
          | 'externalSubtype'
          | 'mask'
          | 'status'
          | 'ownerEmployeeId'
        >>,
      checkMetadata?: Maybe<Pick<AdminTransactionFactCheckMetadata, 'payer' | 'payee' | 'memo'>>,
    }
  )> };

export type AdminListLedgerTransactionFactsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  ledgerTransactionIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AdminListLedgerTransactionFactsQuery = { listLedgerTransactionFacts: Array<(
    Pick<
      AdminTransactionFact,
      | 'transactionFactId'
      | 'legalEntityId'
      | 'externalId'
      | 'externalName'
      | 'externalDescription'
      | 'pending'
      | 'transactionType'
      | 'externalTimestamp'
      | 'externalCreatedAt'
      | 'externalModifiedAt'
      | 'createdAt'
      | 'updatedAt'
      | 'ledgerTransactionId'
      | 'supersedingLedgerTransactionId'
      | 'supersededLedgerTransactionIds'
    >
    & {
      dataSource: (
        Pick<
          EnrichedDataSource,
          | 'id'
          | 'legalEntityId'
          | 'status'
          | 'statusReason'
          | 'providerType'
          | 'accountAlias'
          | 'createdAt'
          | 'updatedAt'
          | 'lastActivityAt'
          | 'hasTransactions'
        >
        & {
          institution: Pick<
              Party,
              | 'id'
              | 'legalEntityId'
              | 'name'
              | 'url'
              | 'supportUrl'
              | 'supportEmail'
              | 'supportPhone'
              | 'twitterUrl'
              | 'facebookUrl'
              | 'instagramUrl'
              | 'yelpUrl'
              | 'iconUrl'
              | 'shortDescription'
              | 'designation'
            >,
          quickBooksConfig?: Maybe<Pick<
              QuickBooksConfig,
              | 'id'
              | 'realmId'
              | 'createdAt'
              | 'updatedAt'
            >>,
          plaidConfig?: Maybe<Pick<
              PlaidConfig,
              | 'id'
              | 'itemId'
              | 'externalInstitutionId'
              | 'createdAt'
              | 'updatedAt'
            >>,
          sourceAccounts?: Maybe<Array<Pick<
              SourceAccount,
              | 'id'
              | 'externalId'
              | 'externalName'
              | 'externalOwnerName'
              | 'externalOfficialName'
              | 'externalType'
              | 'externalSubtype'
              | 'mask'
              | 'status'
              | 'ownerEmployeeId'
            >>>,
        }
      ),
      sourceAccount?: Maybe<Pick<
          SourceAccount,
          | 'id'
          | 'externalId'
          | 'externalName'
          | 'externalOwnerName'
          | 'externalOfficialName'
          | 'externalType'
          | 'externalSubtype'
          | 'mask'
          | 'status'
          | 'ownerEmployeeId'
        >>,
      checkMetadata?: Maybe<Pick<AdminTransactionFactCheckMetadata, 'payer' | 'payee' | 'memo'>>,
    }
  )> };

export type ListMatchSetTransactionFactsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  transactionFactId: Scalars['String']['input'];
}>;


export type ListMatchSetTransactionFactsQuery = { listMatchSetTransactionFacts: (
    Pick<AdminTransactionFactsWithMatchInfo, 'matchSetId' | 'matchAlgorithmDescription'>
    & { transactionFacts: Array<(
      Pick<
        AdminTransactionFact,
        | 'transactionFactId'
        | 'legalEntityId'
        | 'externalId'
        | 'externalName'
        | 'externalDescription'
        | 'pending'
        | 'transactionType'
        | 'externalTimestamp'
        | 'externalCreatedAt'
        | 'externalModifiedAt'
        | 'createdAt'
        | 'updatedAt'
        | 'ledgerTransactionId'
        | 'supersedingLedgerTransactionId'
        | 'supersededLedgerTransactionIds'
      >
      & {
        dataSource: (
          Pick<
            EnrichedDataSource,
            | 'id'
            | 'legalEntityId'
            | 'status'
            | 'statusReason'
            | 'providerType'
            | 'accountAlias'
            | 'createdAt'
            | 'updatedAt'
            | 'lastActivityAt'
            | 'hasTransactions'
          >
          & {
            institution: Pick<
                Party,
                | 'id'
                | 'legalEntityId'
                | 'name'
                | 'url'
                | 'supportUrl'
                | 'supportEmail'
                | 'supportPhone'
                | 'twitterUrl'
                | 'facebookUrl'
                | 'instagramUrl'
                | 'yelpUrl'
                | 'iconUrl'
                | 'shortDescription'
                | 'designation'
              >,
            quickBooksConfig?: Maybe<Pick<
                QuickBooksConfig,
                | 'id'
                | 'realmId'
                | 'createdAt'
                | 'updatedAt'
              >>,
            plaidConfig?: Maybe<Pick<
                PlaidConfig,
                | 'id'
                | 'itemId'
                | 'externalInstitutionId'
                | 'createdAt'
                | 'updatedAt'
              >>,
            sourceAccounts?: Maybe<Array<Pick<
                SourceAccount,
                | 'id'
                | 'externalId'
                | 'externalName'
                | 'externalOwnerName'
                | 'externalOfficialName'
                | 'externalType'
                | 'externalSubtype'
                | 'mask'
                | 'status'
                | 'ownerEmployeeId'
              >>>,
          }
        ),
        sourceAccount?: Maybe<Pick<
            SourceAccount,
            | 'id'
            | 'externalId'
            | 'externalName'
            | 'externalOwnerName'
            | 'externalOfficialName'
            | 'externalType'
            | 'externalSubtype'
            | 'mask'
            | 'status'
            | 'ownerEmployeeId'
          >>,
        checkMetadata?: Maybe<Pick<AdminTransactionFactCheckMetadata, 'payer' | 'payee' | 'memo'>>,
      }
    )> }
  ) };

export type ReadAdminTransactionFactQueryVariables = Exact<{
  transactionFactId: Scalars['String']['input'];
}>;


export type ReadAdminTransactionFactQuery = { readTransactionFact: (
    Pick<
      AdminTransactionFact,
      | 'transactionFactId'
      | 'legalEntityId'
      | 'externalId'
      | 'externalName'
      | 'externalDescription'
      | 'pending'
      | 'transactionType'
      | 'externalTimestamp'
      | 'externalCreatedAt'
      | 'externalModifiedAt'
      | 'createdAt'
      | 'updatedAt'
      | 'ledgerTransactionId'
      | 'supersedingLedgerTransactionId'
      | 'supersededLedgerTransactionIds'
    >
    & {
      dataSource: (
        Pick<
          EnrichedDataSource,
          | 'id'
          | 'legalEntityId'
          | 'status'
          | 'statusReason'
          | 'providerType'
          | 'accountAlias'
          | 'createdAt'
          | 'updatedAt'
          | 'lastActivityAt'
          | 'hasTransactions'
        >
        & {
          institution: Pick<
              Party,
              | 'id'
              | 'legalEntityId'
              | 'name'
              | 'url'
              | 'supportUrl'
              | 'supportEmail'
              | 'supportPhone'
              | 'twitterUrl'
              | 'facebookUrl'
              | 'instagramUrl'
              | 'yelpUrl'
              | 'iconUrl'
              | 'shortDescription'
              | 'designation'
            >,
          quickBooksConfig?: Maybe<Pick<
              QuickBooksConfig,
              | 'id'
              | 'realmId'
              | 'createdAt'
              | 'updatedAt'
            >>,
          plaidConfig?: Maybe<Pick<
              PlaidConfig,
              | 'id'
              | 'itemId'
              | 'externalInstitutionId'
              | 'createdAt'
              | 'updatedAt'
            >>,
          sourceAccounts?: Maybe<Array<Pick<
              SourceAccount,
              | 'id'
              | 'externalId'
              | 'externalName'
              | 'externalOwnerName'
              | 'externalOfficialName'
              | 'externalType'
              | 'externalSubtype'
              | 'mask'
              | 'status'
              | 'ownerEmployeeId'
            >>>,
        }
      ),
      sourceAccount?: Maybe<Pick<
          SourceAccount,
          | 'id'
          | 'externalId'
          | 'externalName'
          | 'externalOwnerName'
          | 'externalOfficialName'
          | 'externalType'
          | 'externalSubtype'
          | 'mask'
          | 'status'
          | 'ownerEmployeeId'
        >>,
      checkMetadata?: Maybe<Pick<AdminTransactionFactCheckMetadata, 'payer' | 'payee' | 'memo'>>,
    }
  ) };

export type AdminUserFieldsFragment = (
  Pick<
    AdminUser,
    | 'timezone'
    | 'invitationId'
    | 'accountLocked'
    | 'banned'
  >
  & {
    user: (
      Pick<
        User,
        | 'mfaEnforcedAt'
        | 'id'
        | 'givenName'
        | 'familyName'
        | 'primaryEmailAddress'
        | 'passwordSet'
        | 'avatarUrl'
        | 'createdAt'
        | 'lastActivityAt'
      >
      & {
        employments?: Maybe<Array<(
          Pick<OrganizationEmployment, 'employeeId'>
          & {
            role: Pick<Role, 'id'>,
            organization: Pick<
                Organization,
                | 'id'
                | 'slug'
                | 'name'
                | 'iconUrl'
                | 'websiteUrl'
                | 'kind'
              >,
            legalEntityRoles?: Maybe<Array<(
              Pick<EmployeeLegalEntityRole, 'legalEntityId'>
              & { role?: Maybe<Pick<Role, 'id'>> }
            )>>,
          }
        )>>,
        identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
      }
    ),
    employments?: Maybe<Array<(
      Pick<AdminUserEmployment, 'activatedAt' | 'status' | 'employeeId'>
      & {
        role: Pick<Role, 'id'>,
        organization: Pick<
            Organization,
            | 'id'
            | 'slug'
            | 'name'
            | 'iconUrl'
            | 'websiteUrl'
            | 'kind'
          >,
        legalEntityRoles?: Maybe<Array<(
          Pick<EmployeeLegalEntityRole, 'legalEntityId'>
          & { role?: Maybe<Pick<Role, 'id'>> }
        )>>,
      }
    )>>,
    affiliations?: Maybe<Array<{
        role: Pick<Role, 'id'>,
        userOrganization?: Maybe<Pick<
            Organization,
            | 'id'
            | 'slug'
            | 'name'
            | 'iconUrl'
            | 'websiteUrl'
            | 'kind'
          >>,
        affiliatedTo?: Maybe<(
          Pick<
            LegalEntity,
            | 'id'
            | 'slug'
            | 'name'
            | 'websiteUrl'
            | 'industry'
            | 'timezone'
            | 'fiscalYearStartMonth'
            | 'fiscalYearNumberOffset'
            | 'status'
            | 'organizationId'
            | 'sensitive'
            | 'phoneNumber'
            | 'iconUrl'
          >
          & {
            address: Pick<
                Address,
                | 'street'
                | 'streetAdditional'
                | 'city'
                | 'region'
                | 'postalCode'
                | 'countryCode'
                | 'lat'
                | 'long'
              >,
            incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
          }
        )>,
      }>>,
  }
);

export type SuperuserFieldsFragment = (
  Pick<
    Superuser,
    | 'id'
    | 'givenName'
    | 'familyName'
    | 'emailAddress'
    | 'avatarUrl'
    | 'createdAt'
    | 'lastLoginAt'
  >
  & { roles: Array<Pick<SuperuserRole, 'identifier' | 'displayName' | 'description'>> }
);

export type BanUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type BanUserMutation = Pick<Mutation, 'banUser'>;

export type CreateSuperuserMutationVariables = Exact<{
  emailAddress: Scalars['String']['input'];
  roleIdentifiers: Array<Scalars['String']['input']> | Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  familyName: Scalars['String']['input'];
}>;


export type CreateSuperuserMutation = { createSuperuser: (
    Pick<
      Superuser,
      | 'id'
      | 'givenName'
      | 'familyName'
      | 'emailAddress'
      | 'avatarUrl'
      | 'createdAt'
      | 'lastLoginAt'
    >
    & { roles: Array<Pick<SuperuserRole, 'identifier' | 'displayName' | 'description'>> }
  ) };

export type ResetLockoutMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  justification: Scalars['String']['input'];
}>;


export type ResetLockoutMutation = Pick<Mutation, 'resetLockout'>;

export type ResetMfaMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  justification: Scalars['String']['input'];
}>;


export type ResetMfaMutation = Pick<Mutation, 'resetMfa'>;

export type UnbanUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type UnbanUserMutation = Pick<Mutation, 'unbanUser'>;

export type UpdateUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  familyName: Scalars['String']['input'];
}>;


export type UpdateUserMutation = Pick<Mutation, 'updateUser'>;

export type ListSuperusersQueryVariables = Exact<{ [key: string]: never; }>;


export type ListSuperusersQuery = { listSuperusers: Array<(
    Pick<
      Superuser,
      | 'id'
      | 'givenName'
      | 'familyName'
      | 'emailAddress'
      | 'avatarUrl'
      | 'createdAt'
      | 'lastLoginAt'
    >
    & { roles: Array<Pick<SuperuserRole, 'identifier' | 'displayName' | 'description'>> }
  )> };

export type ListUsersQueryVariables = Exact<{
  pagination: Pagination;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  noEmployments?: InputMaybe<Scalars['Boolean']['input']>;
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListUsersQuery = { listUsers: Array<(
    Pick<
      AdminUser,
      | 'timezone'
      | 'invitationId'
      | 'accountLocked'
      | 'banned'
    >
    & {
      user: (
        Pick<
          User,
          | 'mfaEnforcedAt'
          | 'id'
          | 'givenName'
          | 'familyName'
          | 'primaryEmailAddress'
          | 'passwordSet'
          | 'avatarUrl'
          | 'createdAt'
          | 'lastActivityAt'
        >
        & {
          employments?: Maybe<Array<(
            Pick<OrganizationEmployment, 'employeeId'>
            & {
              role: Pick<Role, 'id'>,
              organization: Pick<
                  Organization,
                  | 'id'
                  | 'slug'
                  | 'name'
                  | 'iconUrl'
                  | 'websiteUrl'
                  | 'kind'
                >,
              legalEntityRoles?: Maybe<Array<(
                Pick<EmployeeLegalEntityRole, 'legalEntityId'>
                & { role?: Maybe<Pick<Role, 'id'>> }
              )>>,
            }
          )>>,
          identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
        }
      ),
      employments?: Maybe<Array<(
        Pick<AdminUserEmployment, 'activatedAt' | 'status' | 'employeeId'>
        & {
          role: Pick<Role, 'id'>,
          organization: Pick<
              Organization,
              | 'id'
              | 'slug'
              | 'name'
              | 'iconUrl'
              | 'websiteUrl'
              | 'kind'
            >,
          legalEntityRoles?: Maybe<Array<(
            Pick<EmployeeLegalEntityRole, 'legalEntityId'>
            & { role?: Maybe<Pick<Role, 'id'>> }
          )>>,
        }
      )>>,
      affiliations?: Maybe<Array<{
          role: Pick<Role, 'id'>,
          userOrganization?: Maybe<Pick<
              Organization,
              | 'id'
              | 'slug'
              | 'name'
              | 'iconUrl'
              | 'websiteUrl'
              | 'kind'
            >>,
          affiliatedTo?: Maybe<(
            Pick<
              LegalEntity,
              | 'id'
              | 'slug'
              | 'name'
              | 'websiteUrl'
              | 'industry'
              | 'timezone'
              | 'fiscalYearStartMonth'
              | 'fiscalYearNumberOffset'
              | 'status'
              | 'organizationId'
              | 'sensitive'
              | 'phoneNumber'
              | 'iconUrl'
            >
            & {
              address: Pick<
                  Address,
                  | 'street'
                  | 'streetAdditional'
                  | 'city'
                  | 'region'
                  | 'postalCode'
                  | 'countryCode'
                  | 'lat'
                  | 'long'
                >,
              incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
            }
          )>,
        }>>,
    }
  )> };

export type ReadUserQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ReadUserQuery = { readUser: (
    Pick<
      AdminUser,
      | 'timezone'
      | 'invitationId'
      | 'accountLocked'
      | 'banned'
    >
    & {
      user: (
        Pick<
          User,
          | 'mfaEnforcedAt'
          | 'id'
          | 'givenName'
          | 'familyName'
          | 'primaryEmailAddress'
          | 'passwordSet'
          | 'avatarUrl'
          | 'createdAt'
          | 'lastActivityAt'
        >
        & {
          employments?: Maybe<Array<(
            Pick<OrganizationEmployment, 'employeeId'>
            & {
              role: Pick<Role, 'id'>,
              organization: Pick<
                  Organization,
                  | 'id'
                  | 'slug'
                  | 'name'
                  | 'iconUrl'
                  | 'websiteUrl'
                  | 'kind'
                >,
              legalEntityRoles?: Maybe<Array<(
                Pick<EmployeeLegalEntityRole, 'legalEntityId'>
                & { role?: Maybe<Pick<Role, 'id'>> }
              )>>,
            }
          )>>,
          identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
        }
      ),
      employments?: Maybe<Array<(
        Pick<AdminUserEmployment, 'activatedAt' | 'status' | 'employeeId'>
        & {
          role: Pick<Role, 'id'>,
          organization: Pick<
              Organization,
              | 'id'
              | 'slug'
              | 'name'
              | 'iconUrl'
              | 'websiteUrl'
              | 'kind'
            >,
          legalEntityRoles?: Maybe<Array<(
            Pick<EmployeeLegalEntityRole, 'legalEntityId'>
            & { role?: Maybe<Pick<Role, 'id'>> }
          )>>,
        }
      )>>,
      affiliations?: Maybe<Array<{
          role: Pick<Role, 'id'>,
          userOrganization?: Maybe<Pick<
              Organization,
              | 'id'
              | 'slug'
              | 'name'
              | 'iconUrl'
              | 'websiteUrl'
              | 'kind'
            >>,
          affiliatedTo?: Maybe<(
            Pick<
              LegalEntity,
              | 'id'
              | 'slug'
              | 'name'
              | 'websiteUrl'
              | 'industry'
              | 'timezone'
              | 'fiscalYearStartMonth'
              | 'fiscalYearNumberOffset'
              | 'status'
              | 'organizationId'
              | 'sensitive'
              | 'phoneNumber'
              | 'iconUrl'
            >
            & {
              address: Pick<
                  Address,
                  | 'street'
                  | 'streetAdditional'
                  | 'city'
                  | 'region'
                  | 'postalCode'
                  | 'countryCode'
                  | 'lat'
                  | 'long'
                >,
              incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
            }
          )>,
        }>>,
    }
  ) };

export type ClassificationValidationExpectationFactFieldsFragment = Pick<ClassificationValidationExpectationFact, 'transactionFactId' | 'dataSourceId'>;

export type ClassificationValidationFailureDetailFieldsFragment = Pick<ClassificationValidationFailureDetail, 'expectationType' | 'expectedValue' | 'actualValue'>;

export type ClassificationValidationFailureFieldsFragment = {
    expectation: (
      Pick<
        ClassificationValidation,
        | 'legalEntityId'
        | 'partyName'
        | 'partyRole'
        | 'partyIconUrl'
        | 'debitCategoryName'
        | 'creditCategoryName'
        | 'employeeOwnerName'
        | 'expectationId'
        | 'status'
      >
      & { facts: Array<Pick<ClassificationValidationExpectationFact, 'transactionFactId' | 'dataSourceId'>> }
    ),
    failureDetails: Array<Pick<ClassificationValidationFailureDetail, 'expectationType' | 'expectedValue' | 'actualValue'>>,
  };

export type ClassificationValidationFieldsFragment = (
  Pick<
    ClassificationValidation,
    | 'legalEntityId'
    | 'partyName'
    | 'partyRole'
    | 'partyIconUrl'
    | 'debitCategoryName'
    | 'creditCategoryName'
    | 'employeeOwnerName'
    | 'expectationId'
    | 'status'
  >
  & { facts: Array<Pick<ClassificationValidationExpectationFact, 'transactionFactId' | 'dataSourceId'>> }
);

export type ClassificationValidationSummaryFieldsFragment = Pick<ClassificationValidationSummary, 'passingValidations' | 'totalValidations' | 'numberOfLegalEntities'>;

export type MismatchedQuickbooksBalanceSheetCategoryFieldsFragment = (
  Pick<
    MismatchedQuickbooksBalanceSheetCategory,
    | 'categoryName'
    | 'categoryType'
    | 'externalStartingBalance'
    | 'externalEndingBalance'
    | 'digitsStartingBalance'
    | 'digitsEndingBalance'
    | 'startingDelta'
    | 'endingDelta'
  >
  & { period: Pick<
      Period,
      | 'name'
      | 'interval'
      | 'startedAt'
      | 'endedAt'
    > }
);

export type MismatchedQuickbooksCategoryFieldsFragment = (
  Pick<
    MismatchedQuickbooksCategory,
    | 'categoryName'
    | 'categoryType'
    | 'externalValue'
    | 'digitsValue'
    | 'difference'
  >
  & { period: Pick<
      Period,
      | 'name'
      | 'interval'
      | 'startedAt'
      | 'endedAt'
    > }
);

export type SummarizeDataSourceFetchesFieldsFragment = { summaries?: Maybe<Array<(
    Pick<DataSourceFetchCountSummary, 'institutionName' | 'success'>
    & { statTimeBuckets?: Maybe<Pick<
        StatisticByTimeBuckets,
        | 'name'
        | 'total'
        | 'bucketOne'
        | 'bucketTwo'
        | 'bucketThree'
        | 'bucketFour'
        | 'bucketTimeMins'
      >> }
  )>> };

export type SummarizeViewGenerationFieldsFragment = Pick<
    ViewGenerationSummary,
    | 'bucketOne'
    | 'bucketTwo'
    | 'bucketThree'
    | 'bucketFour'
    | 'bucketTimeMins'
  >;

export type UnsupportedTransactionFieldsFragment = Pick<
    UnsupportedTransaction,
    | 'fetchId'
    | 'fetchType'
    | 'providerType'
    | 'accountAlias'
    | 'dataType'
    | 'transactionCount'
    | 'reason'
  >;

export type UnsupportedTransactionsFieldsFragment = {
    onboardUnsupportedTransactions: Array<Pick<
        UnsupportedTransaction,
        | 'fetchId'
        | 'fetchType'
        | 'providerType'
        | 'accountAlias'
        | 'dataType'
        | 'transactionCount'
        | 'reason'
      >>,
    otherUnsupportedTransactions: Array<Pick<
        UnsupportedTransaction,
        | 'fetchId'
        | 'fetchType'
        | 'providerType'
        | 'accountAlias'
        | 'dataType'
        | 'transactionCount'
        | 'reason'
      >>,
  };

export type ListFailingClassificationValidationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListFailingClassificationValidationsQuery = { listFailingClassificationValidations: Array<{
      expectation: (
        Pick<
          ClassificationValidation,
          | 'legalEntityId'
          | 'partyName'
          | 'partyRole'
          | 'partyIconUrl'
          | 'debitCategoryName'
          | 'creditCategoryName'
          | 'employeeOwnerName'
          | 'expectationId'
          | 'status'
        >
        & { facts: Array<Pick<ClassificationValidationExpectationFact, 'transactionFactId' | 'dataSourceId'>> }
      ),
      failureDetails: Array<Pick<ClassificationValidationFailureDetail, 'expectationType' | 'expectedValue' | 'actualValue'>>,
    }> };

export type ListMismatchedQuickbooksBalanceSheetCategoriesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ListMismatchedQuickbooksBalanceSheetCategoriesQuery = { listMismatchedQuickbooksBalanceSheetCategories: Array<(
    Pick<
      MismatchedQuickbooksBalanceSheetCategory,
      | 'categoryName'
      | 'categoryType'
      | 'externalStartingBalance'
      | 'externalEndingBalance'
      | 'digitsStartingBalance'
      | 'digitsEndingBalance'
      | 'startingDelta'
      | 'endingDelta'
    >
    & { period: Pick<
        Period,
        | 'name'
        | 'interval'
        | 'startedAt'
        | 'endedAt'
      > }
  )> };

export type ListMismatchedQuickbooksCategoriesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ListMismatchedQuickbooksCategoriesQuery = { listMismatchedQuickbooksCategories: Array<(
    Pick<
      MismatchedQuickbooksCategory,
      | 'categoryName'
      | 'categoryType'
      | 'externalValue'
      | 'digitsValue'
      | 'difference'
    >
    & { period: Pick<
        Period,
        | 'name'
        | 'interval'
        | 'startedAt'
        | 'endedAt'
      > }
  )> };

export type ListUnsupportedTransactionsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ListUnsupportedTransactionsQuery = { listUnsupportedTransactions: {
      onboardUnsupportedTransactions: Array<Pick<
          UnsupportedTransaction,
          | 'fetchId'
          | 'fetchType'
          | 'providerType'
          | 'accountAlias'
          | 'dataType'
          | 'transactionCount'
          | 'reason'
        >>,
      otherUnsupportedTransactions: Array<Pick<
          UnsupportedTransaction,
          | 'fetchId'
          | 'fetchType'
          | 'providerType'
          | 'accountAlias'
          | 'dataType'
          | 'transactionCount'
          | 'reason'
        >>,
    } };

export type SummarizeClassificationValidationsQueryVariables = Exact<{ [key: string]: never; }>;


export type SummarizeClassificationValidationsQuery = { summarizeClassificationValidations: Pick<ClassificationValidationSummary, 'passingValidations' | 'totalValidations' | 'numberOfLegalEntities'> };

export type SummarizeDataSourceFetchesQueryVariables = Exact<{ [key: string]: never; }>;


export type SummarizeDataSourceFetchesQuery = { summarizeDataSourceFetches: { summaries?: Maybe<Array<(
      Pick<DataSourceFetchCountSummary, 'institutionName' | 'success'>
      & { statTimeBuckets?: Maybe<Pick<
          StatisticByTimeBuckets,
          | 'name'
          | 'total'
          | 'bucketOne'
          | 'bucketTwo'
          | 'bucketThree'
          | 'bucketFour'
          | 'bucketTimeMins'
        >> }
    )>> } };

export type SummarizeViewGenerationQueryVariables = Exact<{ [key: string]: never; }>;


export type SummarizeViewGenerationQuery = { summarizeViewGeneration: Pick<
      ViewGenerationSummary,
      | 'bucketOne'
      | 'bucketTwo'
      | 'bucketThree'
      | 'bucketFour'
      | 'bucketTimeMins'
    > };

export type AdminGlobalVanityStatsFieldsFragment = (
  Pick<
    AdminGlobalVanityStats,
    | 'totalSignupsCount'
    | 'totalSignupsLast30Count'
    | 'qualifiedSignupsCount'
    | 'averageSignupQualifiedAt'
    | 'primedSignupsCount'
    | 'averageSignupPrimedAt'
    | 'invitedSignupsCount'
    | 'averageSignupInvitedAt'
    | 'appliedSignupsCount'
    | 'averageSignupAppliedAt'
    | 'approvedSignupsLast30Count'
    | 'lastSignupApprovedAt'
    | 'totalUsersCount'
    | 'activeUsersCount'
    | 'totalLegalEntitiesCount'
    | 'activeLegalEntitiesCount'
    | 'pendingLegalEntitiesCount'
    | 'totalPartiesCount'
    | 'globalPartiesCount'
    | 'globalPartiesLast30Count'
    | 'linkedPartiesCount'
    | 'unlinkedPartiesCount'
    | 'unlinkedRepeatPartiesCount'
    | 'hydratableUnlinkedRepeatPartiesCount'
    | 'hydratableUnlinkedPartiesCount'
    | 'totalTransactionsCount'
    | 'globalPartyTransactionsCount'
    | 'legalEntitiesWithValidQuickBooksCount'
    | 'legalEntitiesWithDataIssuesCount'
    | 'activeLegalEntitiesWithDataIssuesCount'
    | 'legalEntitiesWithQuickBooksConnectionIssuesCount'
    | 'activeLegalEntitiesWithQuickBooksConnectionIssuesCount'
    | 'activeLegalEntitiesWithPlaidConnectionIssuesCount'
    | 'legalEntitiesWithEngineeringRequiredCount'
    | 'supersedingRate'
    | 'dayOfInterest'
  >
  & {
    totalTransactionsValue: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
    reportValidations: Array<(
      Pick<ReportValidationGlobalPeriodSummary, 'packageValidCount' | 'packageInvalidCount'>
      & {
        period: Pick<
            Period,
            | 'name'
            | 'interval'
            | 'startedAt'
            | 'endedAt'
          >,
        byKind: Array<Pick<ReportValidationByKind, 'kind' | 'validCount' | 'invalidCount'>>,
      }
    )>,
  }
);

export type AdminVanityStatsFieldsFragment = (
  Pick<
    AdminVanityStats,
    | 'transactionsCount'
    | 'usersCount'
    | 'partiesCount'
    | 'categoriesCount'
  >
  & { totalValue: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
);

export type ReadAdminGlobalVanityStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadAdminGlobalVanityStatsQuery = { readGlobalVanityStats: (
    Pick<
      AdminGlobalVanityStats,
      | 'totalSignupsCount'
      | 'totalSignupsLast30Count'
      | 'qualifiedSignupsCount'
      | 'averageSignupQualifiedAt'
      | 'primedSignupsCount'
      | 'averageSignupPrimedAt'
      | 'invitedSignupsCount'
      | 'averageSignupInvitedAt'
      | 'appliedSignupsCount'
      | 'averageSignupAppliedAt'
      | 'approvedSignupsLast30Count'
      | 'lastSignupApprovedAt'
      | 'totalUsersCount'
      | 'activeUsersCount'
      | 'totalLegalEntitiesCount'
      | 'activeLegalEntitiesCount'
      | 'pendingLegalEntitiesCount'
      | 'totalPartiesCount'
      | 'globalPartiesCount'
      | 'globalPartiesLast30Count'
      | 'linkedPartiesCount'
      | 'unlinkedPartiesCount'
      | 'unlinkedRepeatPartiesCount'
      | 'hydratableUnlinkedRepeatPartiesCount'
      | 'hydratableUnlinkedPartiesCount'
      | 'totalTransactionsCount'
      | 'globalPartyTransactionsCount'
      | 'legalEntitiesWithValidQuickBooksCount'
      | 'legalEntitiesWithDataIssuesCount'
      | 'activeLegalEntitiesWithDataIssuesCount'
      | 'legalEntitiesWithQuickBooksConnectionIssuesCount'
      | 'activeLegalEntitiesWithQuickBooksConnectionIssuesCount'
      | 'activeLegalEntitiesWithPlaidConnectionIssuesCount'
      | 'legalEntitiesWithEngineeringRequiredCount'
      | 'supersedingRate'
      | 'dayOfInterest'
    >
    & {
      totalTransactionsValue: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
      reportValidations: Array<(
        Pick<ReportValidationGlobalPeriodSummary, 'packageValidCount' | 'packageInvalidCount'>
        & {
          period: Pick<
              Period,
              | 'name'
              | 'interval'
              | 'startedAt'
              | 'endedAt'
            >,
          byKind: Array<Pick<ReportValidationByKind, 'kind' | 'validCount' | 'invalidCount'>>,
        }
      )>,
    }
  ) };

export type ReadAdminVanityStatsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ReadAdminVanityStatsQuery = { readVanityStats: (
    Pick<
      AdminVanityStats,
      | 'transactionsCount'
      | 'usersCount'
      | 'partiesCount'
      | 'categoriesCount'
    >
    & { totalValue: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
  ) };

export type ExecuteFbqQueryQueryVariables = Exact<{
  viewKey: ViewKey;
  expression: Scalars['String']['input'];
}>;


export type ExecuteFbqQueryQuery = { executeFbqQuery: Pick<FbqQueryResult, 'resultJson'> };

export type ReadActiveViewVersionQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  viewType: ViewType;
}>;


export type ReadActiveViewVersionQuery = { readActiveViewVersion: Pick<ViewIdentifier, 'legalEntityId' | 'viewVersion' | 'viewType'> };

export type GetWorkflowQueryVariables = Exact<{
  legalEntityID: Scalars['String']['input'];
  workflowID: Scalars['String']['input'];
}>;


export type GetWorkflowQuery = { getWorkflow: {
      workflow: Pick<
          Workflow,
          | 'legalEntityID'
          | 'workflowID'
          | 'definitionName'
          | 'definitionVersion'
          | 'status'
          | 'error'
          | 'createdAt'
          | 'updatedAt'
          | 'completedAt'
          | 'inputTypeName'
          | 'outputTypeName'
        >,
      futures: Array<Pick<
          WorkflowFuture,
          | 'futureID'
          | 'kind'
          | 'regionPath'
          | 'status'
          | 'deadline'
          | 'createdAt'
          | 'resolvedAt'
          | 'deliveredAt'
        >>,
    } };

export type GetWorkflowHistoryQueryVariables = Exact<{
  legalEntityID: Scalars['String']['input'];
  workflowID: Scalars['String']['input'];
}>;


export type GetWorkflowHistoryQuery = { getWorkflowHistory: Array<Pick<
      WorkflowLogEntry,
      | 'legalEntityID'
      | 'workflowID'
      | 'workflowLogID'
      | 'regionPath'
      | 'eventKind'
      | 'actionID'
      | 'errorMessage'
      | 'createdAt'
      | 'resultTypeName'
    >> };

export type GetWorkflowInputQueryVariables = Exact<{
  legalEntityID: Scalars['String']['input'];
  workflowID: Scalars['String']['input'];
}>;


export type GetWorkflowInputQuery = { getWorkflowInput: Pick<
      WorkflowPayload,
      | 'json'
      | 'typeName'
      | 'bytesSize'
      | 'decodeError'
    > };

export type GetWorkflowOutputQueryVariables = Exact<{
  legalEntityID: Scalars['String']['input'];
  workflowID: Scalars['String']['input'];
}>;


export type GetWorkflowOutputQuery = { getWorkflowOutput: Pick<
      WorkflowPayload,
      | 'json'
      | 'typeName'
      | 'bytesSize'
      | 'decodeError'
    > };

export type GetWorkflowStepResultQueryVariables = Exact<{
  legalEntityID: Scalars['String']['input'];
  workflowID: Scalars['String']['input'];
  workflowLogID: Scalars['String']['input'];
}>;


export type GetWorkflowStepResultQuery = { getWorkflowStepResult: Pick<
      WorkflowPayload,
      | 'json'
      | 'typeName'
      | 'bytesSize'
      | 'decodeError'
    > };

export type ListAllWorkflowsQueryVariables = Exact<{
  status?: InputMaybe<WorkflowStatus>;
  definitionName?: InputMaybe<Scalars['String']['input']>;
  pagination: Pagination;
}>;


export type ListAllWorkflowsQuery = { listAllWorkflows: Array<Pick<
      Workflow,
      | 'legalEntityID'
      | 'workflowID'
      | 'definitionName'
      | 'status'
      | 'createdAt'
    >> };

export type ListWorkflowsQueryVariables = Exact<{
  legalEntityID: Scalars['String']['input'];
  status?: InputMaybe<WorkflowStatus>;
  definitionName?: InputMaybe<Scalars['String']['input']>;
  pagination: Pagination;
}>;


export type ListWorkflowsQuery = { listWorkflows: Array<Pick<
      Workflow,
      | 'legalEntityID'
      | 'workflowID'
      | 'definitionName'
      | 'definitionVersion'
      | 'status'
      | 'error'
      | 'createdAt'
      | 'updatedAt'
      | 'completedAt'
    >> };

export type WorkflowActivitySubscriptionVariables = Exact<{
  legalEntityID: Scalars['String']['input'];
}>;


export type WorkflowActivitySubscription = { workflowActivity: Pick<
      WorkflowLogEvent,
      | 'legalEntityID'
      | 'workflowID'
      | 'definitionName'
      | 'eventKind'
      | 'errorMessage'
      | 'timestamp'
    > };

export type WorkflowLogEventsSubscriptionVariables = Exact<{
  legalEntityID: Scalars['String']['input'];
  workflowID: Scalars['String']['input'];
}>;


export type WorkflowLogEventsSubscription = { workflowLogEvents: Pick<
      WorkflowLogEvent,
      | 'legalEntityID'
      | 'workflowID'
      | 'workflowLogID'
      | 'definitionName'
      | 'regionPath'
      | 'eventKind'
      | 'actionID'
      | 'errorMessage'
      | 'timestamp'
    > };

export type ResetWorkItemMutationVariables = Exact<{
  workItemId: Scalars['String']['input'];
}>;


export type ResetWorkItemMutation = Pick<Mutation, 'resetWorkItem'>;

export type TriggerTransactionAuditCheckMutationVariables = Exact<{
  transactionFactId: Scalars['String']['input'];
}>;


export type TriggerTransactionAuditCheckMutation = Pick<Mutation, 'triggerTransactionAuditCheck'>;

export type GetEmbeddingQueryVariables = Exact<{
  transactionFactId: Scalars['String']['input'];
  partyPrefix?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetEmbeddingQuery = { getEmbedding: Pick<EmbeddingResponse, 'embeddingValue' | 'deployedIndexId'> };

export type GetNeighborsQueryVariables = Exact<{
  deployedIndexId: Scalars['String']['input'];
  floatVal: Array<Scalars['Float']['input']> | Scalars['Float']['input'];
  numNeighbors?: InputMaybe<Scalars['Int']['input']>;
  restricts?: InputMaybe<Array<Namespace> | Namespace>;
  perCrowdingAttributeNumNeighbors?: InputMaybe<Scalars['Int']['input']>;
  approxNumNeighbors?: InputMaybe<Scalars['Int']['input']>;
  leafNodesToSearchPercentOverride?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetNeighborsQuery = { getNeighbors: { neighbor: Array<Pick<Neighbor, 'id' | 'distance'>> } };

export type GetTextEmbeddingQueryVariables = Exact<{
  text: Scalars['String']['input'];
}>;


export type GetTextEmbeddingQuery = { getTextEmbedding: Pick<EmbeddingResponse, 'embeddingValue' | 'deployedIndexId'> };

export type HighlightWorkItemQueryVariables = Exact<{
  similarityType: SimilarityType;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type HighlightWorkItemQuery = { highlightWorkItem: {
      description?: Maybe<Array<Pick<HighlightedToken, 'token' | 'score'>>>,
      name?: Maybe<Array<Pick<HighlightedToken, 'token' | 'score'>>>,
    } };

export type ReadWorkItemQueryVariables = Exact<{
  workItemId: Scalars['String']['input'];
}>;


export type ReadWorkItemQuery = { readWorkItem: (
    Pick<
      AdminWorkItem,
      | 'legalEntityId'
      | 'workItemId'
      | 'time'
      | 'itemType'
      | 'itemState'
      | 'ledgerType'
      | 'actionable'
      | 'createdAt'
      | 'updatedBy'
      | 'updatedAt'
      | 'transactionFactId'
      | 'defaultState'
      | 'userState'
      | 'transactionGcsUrl'
    >
    & {
      transactions: Array<(
        Pick<
          AdminWorkItemTransaction,
          | 'externalTransactionId'
          | 'externalTransactionLineId'
          | 'supportType'
          | 'description'
          | 'name'
          | 'displayEntry'
          | 'occurredAt'
          | 'dataSourceId'
        >
        & {
          creditCategory?: Maybe<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>,
          debitCategory?: Maybe<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>,
          party?: Maybe<Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >>,
          displayCategory?: Maybe<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>,
        }
      )>,
      generatedQuestions: Array<Pick<WorkItemGeneratedQuestion, 'question' | 'contextType' | 'active'>>,
      pushes: Array<Pick<
          WorkItemPush,
          | 'field'
          | 'pushState'
          | 'errorType'
          | 'updatedAt'
        >>,
    }
  ) };

export type AdminWorkItemFieldsFragment = (
  Pick<
    AdminWorkItem,
    | 'legalEntityId'
    | 'workItemId'
    | 'time'
    | 'itemType'
    | 'itemState'
    | 'ledgerType'
    | 'actionable'
    | 'createdAt'
    | 'updatedBy'
    | 'updatedAt'
    | 'transactionFactId'
    | 'defaultState'
    | 'userState'
    | 'transactionGcsUrl'
  >
  & {
    transactions: Array<(
      Pick<
        AdminWorkItemTransaction,
        | 'externalTransactionId'
        | 'externalTransactionLineId'
        | 'supportType'
        | 'description'
        | 'name'
        | 'displayEntry'
        | 'occurredAt'
        | 'dataSourceId'
      >
      & {
        creditCategory?: Maybe<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>,
        debitCategory?: Maybe<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>,
        party?: Maybe<Pick<
            EntityParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'shortDescription'
            | 'roles'
            | 'designation'
          >>,
        displayCategory?: Maybe<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>,
      }
    )>,
    generatedQuestions: Array<Pick<WorkItemGeneratedQuestion, 'question' | 'contextType' | 'active'>>,
    pushes: Array<Pick<
        WorkItemPush,
        | 'field'
        | 'pushState'
        | 'errorType'
        | 'updatedAt'
      >>,
  }
);

export type AdminWorkItemTransactionFieldsFragment = (
  Pick<
    AdminWorkItemTransaction,
    | 'externalTransactionId'
    | 'externalTransactionLineId'
    | 'supportType'
    | 'description'
    | 'name'
    | 'displayEntry'
    | 'occurredAt'
    | 'dataSourceId'
  >
  & {
    creditCategory?: Maybe<Pick<
        EntityCategory,
        | 'id'
        | 'name'
        | 'displayKey'
        | 'chartOfAccountsDisplayNumber'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'productArea'
        | 'active'
      >>,
    debitCategory?: Maybe<Pick<
        EntityCategory,
        | 'id'
        | 'name'
        | 'displayKey'
        | 'chartOfAccountsDisplayNumber'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'productArea'
        | 'active'
      >>,
    party?: Maybe<Pick<
        EntityParty,
        | 'id'
        | 'name'
        | 'iconUrl'
        | 'shortDescription'
        | 'roles'
        | 'designation'
      >>,
    displayCategory?: Maybe<Pick<
        EntityCategory,
        | 'id'
        | 'name'
        | 'displayKey'
        | 'chartOfAccountsDisplayNumber'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'productArea'
        | 'active'
      >>,
  }
);

export type ReadWorkItemValidationQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ReadWorkItemValidationQuery = { readWorkItemValidation: Pick<WorkItemValidation, 'status' | 'workItemCount'> };

export type AddressFieldsFragment = Pick<
    Address,
    | 'street'
    | 'streetAdditional'
    | 'city'
    | 'region'
    | 'postalCode'
    | 'countryCode'
    | 'lat'
    | 'long'
  >;

export type ArchiveIntervalOriginFieldsFragment = Pick<
    ArchiveIntervalOrigin,
    | 'interval'
    | 'year'
    | 'index'
    | 'intervalCount'
    | 'maxTime'
  >;

export type BooksClosedDateFieldsFragment = (
  Pick<BooksClosedDate, 'legalEntityId' | 'latestBooksClosedDateFact'>
  & { user?: Maybe<Pick<
      EntityUser,
      | 'id'
      | 'givenName'
      | 'familyName'
      | 'emailAddress'
      | 'avatarUrl'
    >> }
);

export type CategoryFieldsFragment = (
  Pick<
    Category,
    | 'id'
    | 'name'
    | 'description'
    | 'displayKey'
    | 'type'
    | 'subtype'
    | 'parentCategoryId'
    | 'displayNumber'
    | 'active'
    | 'categoryState'
    | 'productArea'
    | 'synthesized'
  >
  & { ancestors?: Maybe<Array<Pick<
      EntityCategory,
      | 'id'
      | 'name'
      | 'displayKey'
      | 'chartOfAccountsDisplayNumber'
      | 'type'
      | 'subtype'
      | 'parentCategoryId'
      | 'productArea'
      | 'active'
    >>> }
);

export type CategoryMappingFieldsFragment = (
  Pick<CategoryMapping, 'mappingValue' | 'mappingType' | 'product'>
  & { category: Pick<
      EntityCategory,
      | 'id'
      | 'name'
      | 'displayKey'
      | 'chartOfAccountsDisplayNumber'
      | 'type'
      | 'subtype'
      | 'parentCategoryId'
      | 'productArea'
      | 'active'
    > }
);

export type ClassificationProvenanceFieldsFragment = (
  Pick<
    ClassificationProvenance,
    | 'type'
    | 'changedAt'
    | 'confidenceLevel'
    | 'settingsName'
  >
  & { source?: Maybe<(
    Pick<
      TransactionSource,
      | 'timestamp'
      | 'name'
      | 'iconUrl'
      | 'externalDisplayId'
      | 'type'
    >
    & { account?: Maybe<Pick<
        TransactionSourceAccount,
        | 'sourceAccountId'
        | 'externalName'
        | 'mask'
        | 'externalOwnerName'
        | 'externalOfficialName'
      >> }
  )> }
);

export type CommentFieldsFragment = (
  { __typename: 'Comment' }
  & Pick<
    Comment,
    | 'id'
    | 'authorId'
    | 'text'
    | 'timestamp'
    | 'editedAt'
    | 'deletedAt'
    | 'reactions'
  >
  & { layoutAttachment?: Maybe<Pick<LayoutAttachment, 'layoutId' | 'legalEntityId'>> }
);

export type ConnectorFieldsFragment = (
  Pick<
    Connector,
    | 'id'
    | 'name'
    | 'tagline'
    | 'description'
    | 'category'
    | 'iconObjectName'
    | 'className'
    | 'canInstall'
  >
  & { connectorProperties?: Maybe<
    | (
      { __typename: 'AppConnectorProperties' }
      & Pick<
        AppConnectorProperties,
        | 'organizationId'
        | 'visibility'
        | 'homepageURL'
        | 'supportEmail'
        | 'developerEmail'
        | 'privacyPolicyURL'
        | 'termsOfServiceURL'
        | 'scopes'
        | 'redirectUris'
        | 'installUri'
      >
    )
    | (
      { __typename: 'BillConnectorProperties' }
      & Pick<BillConnectorProperties, 'empty'>
    )
    | (
      { __typename: 'EmptyConnectorProperties' }
      & Pick<EmptyConnectorProperties, 'empty'>
    )
    | (
      { __typename: 'FinchConnectorProperties' }
      & Pick<FinchConnectorProperties, 'empty'>
    )
    | (
      { __typename: 'GustoConnectorProperties' }
      & Pick<GustoConnectorProperties, 'authorizationURL'>
    )
    | (
      { __typename: 'PlaidConnectorProperties' }
      & Pick<PlaidConnectorProperties, 'empty'>
    )
    | (
      { __typename: 'RampConnectorProperties' }
      & Pick<RampConnectorProperties, 'authorizationURL'>
    )
    | (
      { __typename: 'StripeConnectorProperties' }
      & Pick<StripeConnectorProperties, 'appLinkURL'>
    )
  > }
);

export type ContactFieldsFragment = Pick<
    Contact,
    | 'givenName'
    | 'familyName'
    | 'emailAddress'
    | 'avatarUrl'
  >;

export type DataSourceFieldsFragment = (
  Pick<
    DataSource,
    | 'id'
    | 'legalEntityId'
    | 'status'
    | 'statusReason'
    | 'providerType'
    | 'accountAlias'
    | 'createdAt'
    | 'updatedAt'
  >
  & { institution: Pick<
      Institution,
      | 'id'
      | 'name'
      | 'url'
      | 'routingNumber'
      | 'iconUrl'
      | 'partyId'
      | 'createdAt'
    > }
);

export type EnrichedDataSourceFieldsFragment = (
  Pick<
    EnrichedDataSource,
    | 'id'
    | 'legalEntityId'
    | 'status'
    | 'statusReason'
    | 'providerType'
    | 'accountAlias'
    | 'createdAt'
    | 'updatedAt'
    | 'lastActivityAt'
    | 'hasTransactions'
  >
  & {
    institution: Pick<
        Party,
        | 'id'
        | 'legalEntityId'
        | 'name'
        | 'url'
        | 'supportUrl'
        | 'supportEmail'
        | 'supportPhone'
        | 'twitterUrl'
        | 'facebookUrl'
        | 'instagramUrl'
        | 'yelpUrl'
        | 'iconUrl'
        | 'shortDescription'
        | 'designation'
      >,
    quickBooksConfig?: Maybe<Pick<
        QuickBooksConfig,
        | 'id'
        | 'realmId'
        | 'createdAt'
        | 'updatedAt'
      >>,
    plaidConfig?: Maybe<Pick<
        PlaidConfig,
        | 'id'
        | 'itemId'
        | 'externalInstitutionId'
        | 'createdAt'
        | 'updatedAt'
      >>,
    sourceAccounts?: Maybe<Array<Pick<
        SourceAccount,
        | 'id'
        | 'externalId'
        | 'externalName'
        | 'externalOwnerName'
        | 'externalOfficialName'
        | 'externalType'
        | 'externalSubtype'
        | 'mask'
        | 'status'
        | 'ownerEmployeeId'
      >>>,
  }
);

export type QuickBooksConfigFieldsFragment = Pick<
    QuickBooksConfig,
    | 'id'
    | 'realmId'
    | 'createdAt'
    | 'updatedAt'
  >;

export type PlaidConfigFieldsFragment = Pick<
    PlaidConfig,
    | 'id'
    | 'itemId'
    | 'externalInstitutionId'
    | 'createdAt'
    | 'updatedAt'
  >;

export type DataSourcePreferenceFieldsFragment = Pick<
    DataSourcePreference,
    | 'dataSourceId'
    | 'accountingBasis'
    | 'taxForm'
    | 'providerType'
    | 'departmentTerminology'
  >;

export type DateFieldsFragment = Pick<Date, 'year' | 'month' | 'day'>;

export type DepartmentFieldsFragment = (
  Pick<
    Department,
    | 'id'
    | 'name'
    | 'parentId'
    | 'active'
    | 'description'
    | 'displayKey'
  >
  & {
    ancestors: Array<(
      { __typename: 'EntityDepartment' }
      & Pick<
        EntityDepartment,
        | 'id'
        | 'name'
        | 'parentId'
        | 'active'
      >
    )>,
    matches: Array<Pick<MatchedDepartment, 'id' | 'dataSourceId'>>,
    dataSource?: Maybe<Pick<
        EntityDataSource,
        | 'id'
        | 'name'
        | 'url'
        | 'iconUrl'
      >>,
  }
);

export type DocumentInitialSegmentFieldsFragment = Pick<DocumentInitialSegment, 'collectionId' | 'documentId' | 'downloadUrl'>;

export type DoppelgangerPermitFieldsFragment = (
  Pick<DoppelgangerPermit, 'id' | 'expiresAt' | 'createdAt'>
  & { user: (
    Pick<
      User,
      | 'id'
      | 'givenName'
      | 'familyName'
      | 'primaryEmailAddress'
      | 'passwordSet'
      | 'avatarUrl'
      | 'createdAt'
      | 'lastActivityAt'
    >
    & {
      employments?: Maybe<Array<(
        Pick<OrganizationEmployment, 'employeeId'>
        & {
          role: Pick<Role, 'id'>,
          organization: Pick<
              Organization,
              | 'id'
              | 'slug'
              | 'name'
              | 'iconUrl'
              | 'websiteUrl'
              | 'kind'
            >,
          legalEntityRoles?: Maybe<Array<(
            Pick<EmployeeLegalEntityRole, 'legalEntityId'>
            & { role?: Maybe<Pick<Role, 'id'>> }
          )>>,
        }
      )>>,
      identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
    }
  ) }
);

export type EmployeeAffiliationsFieldsFragment = {
    employee: (
      Pick<
        Employee,
        | 'id'
        | 'organizationId'
        | 'givenName'
        | 'familyName'
        | 'avatarUrl'
        | 'emailAddress'
        | 'jobTitle'
        | 'lastActivityAt'
        | 'status'
        | 'hiddenAt'
      >
      & {
        role?: Maybe<Pick<Role, 'id'>>,
        defaultEntityRole?: Maybe<Pick<Role, 'id'>>,
        user?: Maybe<(
          Pick<
            User,
            | 'id'
            | 'givenName'
            | 'familyName'
            | 'primaryEmailAddress'
            | 'passwordSet'
            | 'avatarUrl'
            | 'createdAt'
            | 'lastActivityAt'
          >
          & {
            employments?: Maybe<Array<(
              Pick<OrganizationEmployment, 'employeeId'>
              & {
                role: Pick<Role, 'id'>,
                organization: Pick<
                    Organization,
                    | 'id'
                    | 'slug'
                    | 'name'
                    | 'iconUrl'
                    | 'websiteUrl'
                    | 'kind'
                  >,
                legalEntityRoles?: Maybe<Array<(
                  Pick<EmployeeLegalEntityRole, 'legalEntityId'>
                  & { role?: Maybe<Pick<Role, 'id'>> }
                )>>,
              }
            )>>,
            identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
          }
        )>,
        invitation?: Maybe<(
          Pick<
            Invitation,
            | 'id'
            | 'invitationType'
            | 'status'
            | 'service'
            | 'organizationTemplateId'
            | 'createdAt'
            | 'updatedAt'
            | 'notifiedAt'
          >
          & {
            recipient: Pick<
                Contact,
                | 'givenName'
                | 'familyName'
                | 'emailAddress'
                | 'avatarUrl'
              >,
            sender?: Maybe<Pick<
                Contact,
                | 'givenName'
                | 'familyName'
                | 'emailAddress'
                | 'avatarUrl'
              >>,
            organization?: Maybe<Pick<
                Organization,
                | 'id'
                | 'slug'
                | 'name'
                | 'iconUrl'
                | 'websiteUrl'
                | 'kind'
              >>,
            role?: Maybe<Pick<Role, 'id'>>,
          }
        )>,
        legalEntityRoles?: Maybe<Array<(
          Pick<EmployeeLegalEntityRole, 'legalEntityId'>
          & { role?: Maybe<Pick<Role, 'id'>> }
        )>>,
      }
    ),
    affiliations: Array<{
        organization: Pick<
            EntityOrganization,
            | 'id'
            | 'name'
            | 'slug'
            | 'iconUrl'
          >,
        legalEntity: Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>,
        role: Pick<Role, 'id'>,
      }>,
  };

export type EmployeeFieldsFragment = (
  Pick<
    Employee,
    | 'id'
    | 'organizationId'
    | 'givenName'
    | 'familyName'
    | 'avatarUrl'
    | 'emailAddress'
    | 'jobTitle'
    | 'lastActivityAt'
    | 'status'
    | 'hiddenAt'
  >
  & {
    role?: Maybe<Pick<Role, 'id'>>,
    defaultEntityRole?: Maybe<Pick<Role, 'id'>>,
    user?: Maybe<(
      Pick<
        User,
        | 'id'
        | 'givenName'
        | 'familyName'
        | 'primaryEmailAddress'
        | 'passwordSet'
        | 'avatarUrl'
        | 'createdAt'
        | 'lastActivityAt'
      >
      & {
        employments?: Maybe<Array<(
          Pick<OrganizationEmployment, 'employeeId'>
          & {
            role: Pick<Role, 'id'>,
            organization: Pick<
                Organization,
                | 'id'
                | 'slug'
                | 'name'
                | 'iconUrl'
                | 'websiteUrl'
                | 'kind'
              >,
            legalEntityRoles?: Maybe<Array<(
              Pick<EmployeeLegalEntityRole, 'legalEntityId'>
              & { role?: Maybe<Pick<Role, 'id'>> }
            )>>,
          }
        )>>,
        identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
      }
    )>,
    invitation?: Maybe<(
      Pick<
        Invitation,
        | 'id'
        | 'invitationType'
        | 'status'
        | 'service'
        | 'organizationTemplateId'
        | 'createdAt'
        | 'updatedAt'
        | 'notifiedAt'
      >
      & {
        recipient: Pick<
            Contact,
            | 'givenName'
            | 'familyName'
            | 'emailAddress'
            | 'avatarUrl'
          >,
        sender?: Maybe<Pick<
            Contact,
            | 'givenName'
            | 'familyName'
            | 'emailAddress'
            | 'avatarUrl'
          >>,
        organization?: Maybe<Pick<
            Organization,
            | 'id'
            | 'slug'
            | 'name'
            | 'iconUrl'
            | 'websiteUrl'
            | 'kind'
          >>,
        role?: Maybe<Pick<Role, 'id'>>,
      }
    )>,
    legalEntityRoles?: Maybe<Array<(
      Pick<EmployeeLegalEntityRole, 'legalEntityId'>
      & { role?: Maybe<Pick<Role, 'id'>> }
    )>>,
  }
);

export type HighlightedTokenFieldsFragment = Pick<HighlightedToken, 'token' | 'score'>;

export type HighlightedTokensFieldsFragment = {
    description?: Maybe<Array<Pick<HighlightedToken, 'token' | 'score'>>>,
    name?: Maybe<Array<Pick<HighlightedToken, 'token' | 'score'>>>,
  };

export type IdentityFieldsFragment = Pick<Identity, 'identifier' | 'provider' | 'domain'>;

export type InsightFieldsFragment = (
  Pick<
    Insight,
    | 'score'
    | 'globalScore'
    | 'subjectType'
    | 'subjectId'
    | 'subjectDisplayKey'
    | 'comparisonIntervalOffset'
    | 'ruleType'
    | 'sentence'
    | 'subjectIconUrl'
    | 'designation'
    | 'type'
    | 'productArea'
  >
  & {
    periodValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
    absoluteDelta?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
    comparisonPeriodValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
  }
);

export type InstitutionFieldsFragment = Pick<
    Institution,
    | 'id'
    | 'name'
    | 'url'
    | 'routingNumber'
    | 'iconUrl'
    | 'partyId'
    | 'createdAt'
  >;

export type InvitationFieldsFragment = (
  Pick<
    Invitation,
    | 'id'
    | 'invitationType'
    | 'status'
    | 'service'
    | 'organizationTemplateId'
    | 'createdAt'
    | 'updatedAt'
    | 'notifiedAt'
  >
  & {
    recipient: Pick<
        Contact,
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      >,
    sender?: Maybe<Pick<
        Contact,
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      >>,
    organization?: Maybe<Pick<
        Organization,
        | 'id'
        | 'slug'
        | 'name'
        | 'iconUrl'
        | 'websiteUrl'
        | 'kind'
      >>,
    role?: Maybe<Pick<Role, 'id'>>,
  }
);

export type InvitationProposalFieldsFragment = (
  Pick<
    InvitationProposal,
    | 'proposalId'
    | 'proposalType'
    | 'status'
    | 'invitationId'
    | 'organizationTemplateId'
    | 'createdAt'
  >
  & {
    legalEntity?: Maybe<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>,
    organization?: Maybe<Pick<
        EntityOrganization,
        | 'id'
        | 'name'
        | 'slug'
        | 'iconUrl'
      >>,
    sender?: Maybe<Pick<
        EntityUser,
        | 'id'
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      >>,
    recipient?: Maybe<Pick<
        Contact,
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      >>,
  }
);

export type TransactionEntryLineFieldsFragment = (
  Pick<
    TransactionEntryLine,
    | 'lineId'
    | 'factId'
    | 'name'
    | 'description'
    | 'isCredit'
    | 'highlighted'
  >
  & {
    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
    category: (
      Pick<
        Category,
        | 'id'
        | 'name'
        | 'description'
        | 'displayKey'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'displayNumber'
        | 'active'
        | 'categoryState'
        | 'productArea'
        | 'synthesized'
      >
      & { ancestors?: Maybe<Array<Pick<
          EntityCategory,
          | 'id'
          | 'name'
          | 'displayKey'
          | 'chartOfAccountsDisplayNumber'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'productArea'
          | 'active'
        >>> }
    ),
    categoryClassificationProvenance?: Maybe<(
      Pick<
        ClassificationProvenance,
        | 'type'
        | 'changedAt'
        | 'confidenceLevel'
        | 'settingsName'
      >
      & { source?: Maybe<(
        Pick<
          TransactionSource,
          | 'timestamp'
          | 'name'
          | 'iconUrl'
          | 'externalDisplayId'
          | 'type'
        >
        & { account?: Maybe<Pick<
            TransactionSourceAccount,
            | 'sourceAccountId'
            | 'externalName'
            | 'mask'
            | 'externalOwnerName'
            | 'externalOfficialName'
          >> }
      )> }
    )>,
  }
);

export type LegalEntityFieldsFragment = (
  Pick<
    LegalEntity,
    | 'id'
    | 'slug'
    | 'name'
    | 'websiteUrl'
    | 'industry'
    | 'timezone'
    | 'fiscalYearStartMonth'
    | 'fiscalYearNumberOffset'
    | 'status'
    | 'organizationId'
    | 'sensitive'
    | 'phoneNumber'
    | 'iconUrl'
  >
  & {
    address: Pick<
        Address,
        | 'street'
        | 'streetAdditional'
        | 'city'
        | 'region'
        | 'postalCode'
        | 'countryCode'
        | 'lat'
        | 'long'
      >,
    incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
  }
);

export type LocationFieldsFragment = (
  Pick<
    Location,
    | 'id'
    | 'name'
    | 'parentId'
    | 'active'
    | 'description'
    | 'displayKey'
  >
  & {
    ancestors: Array<(
      { __typename: 'EntityLocation' }
      & Pick<
        EntityLocation,
        | 'id'
        | 'name'
        | 'parentId'
        | 'active'
      >
    )>,
    dataSource?: Maybe<Pick<
        EntityDataSource,
        | 'id'
        | 'name'
        | 'url'
        | 'iconUrl'
      >>,
  }
);

export type MonetaryValueFieldsFragment = Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>;

export type MoneyFlowFieldsFragment = (
  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
);

export type OrganizationFieldsFragment = Pick<
    Organization,
    | 'id'
    | 'slug'
    | 'name'
    | 'iconUrl'
    | 'websiteUrl'
    | 'kind'
  >;

export type OrganizationPreviewFieldsFragment = Pick<
    OrganizationPreview,
    | 'id'
    | 'slug'
    | 'name'
    | 'iconUrl'
  >;

export type OwnedSourceAccountFieldsFragment = {
    sourceAccount: Pick<
        SourceAccount,
        | 'id'
        | 'externalId'
        | 'externalName'
        | 'externalOwnerName'
        | 'externalOfficialName'
        | 'externalType'
        | 'externalSubtype'
        | 'mask'
        | 'status'
        | 'ownerEmployeeId'
      >,
    owner?: Maybe<(
      Pick<
        Employee,
        | 'id'
        | 'organizationId'
        | 'givenName'
        | 'familyName'
        | 'avatarUrl'
        | 'emailAddress'
        | 'jobTitle'
        | 'lastActivityAt'
        | 'status'
        | 'hiddenAt'
      >
      & {
        role?: Maybe<Pick<Role, 'id'>>,
        defaultEntityRole?: Maybe<Pick<Role, 'id'>>,
        user?: Maybe<(
          Pick<
            User,
            | 'id'
            | 'givenName'
            | 'familyName'
            | 'primaryEmailAddress'
            | 'passwordSet'
            | 'avatarUrl'
            | 'createdAt'
            | 'lastActivityAt'
          >
          & {
            employments?: Maybe<Array<(
              Pick<OrganizationEmployment, 'employeeId'>
              & {
                role: Pick<Role, 'id'>,
                organization: Pick<
                    Organization,
                    | 'id'
                    | 'slug'
                    | 'name'
                    | 'iconUrl'
                    | 'websiteUrl'
                    | 'kind'
                  >,
                legalEntityRoles?: Maybe<Array<(
                  Pick<EmployeeLegalEntityRole, 'legalEntityId'>
                  & { role?: Maybe<Pick<Role, 'id'>> }
                )>>,
              }
            )>>,
            identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
          }
        )>,
        invitation?: Maybe<(
          Pick<
            Invitation,
            | 'id'
            | 'invitationType'
            | 'status'
            | 'service'
            | 'organizationTemplateId'
            | 'createdAt'
            | 'updatedAt'
            | 'notifiedAt'
          >
          & {
            recipient: Pick<
                Contact,
                | 'givenName'
                | 'familyName'
                | 'emailAddress'
                | 'avatarUrl'
              >,
            sender?: Maybe<Pick<
                Contact,
                | 'givenName'
                | 'familyName'
                | 'emailAddress'
                | 'avatarUrl'
              >>,
            organization?: Maybe<Pick<
                Organization,
                | 'id'
                | 'slug'
                | 'name'
                | 'iconUrl'
                | 'websiteUrl'
                | 'kind'
              >>,
            role?: Maybe<Pick<Role, 'id'>>,
          }
        )>,
        legalEntityRoles?: Maybe<Array<(
          Pick<EmployeeLegalEntityRole, 'legalEntityId'>
          & { role?: Maybe<Pick<Role, 'id'>> }
        )>>,
      }
    )>,
  };

export type PartyFieldsFragment = Pick<
    Party,
    | 'id'
    | 'legalEntityId'
    | 'name'
    | 'url'
    | 'supportUrl'
    | 'supportEmail'
    | 'supportPhone'
    | 'twitterUrl'
    | 'facebookUrl'
    | 'instagramUrl'
    | 'yelpUrl'
    | 'iconUrl'
    | 'shortDescription'
    | 'designation'
  >;

export type PeriodFieldsFragment = Pick<
    Period,
    | 'name'
    | 'interval'
    | 'startedAt'
    | 'endedAt'
  >;

export type PeriodMonetaryValueFieldsFragment = (
  Pick<
    PeriodMonetaryValue,
    | 'transactionsCount'
    | 'deltaPrevious'
    | 'deltaYearAgo'
    | 'isFirstOccurrencePeriod'
  >
  & {
    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
    moneyFlow?: Maybe<(
      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
    )>,
    current?: Maybe<(
      Pick<SummaryTotal, 'count'>
      & { total: (
        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
      ) }
    )>,
    prior?: Maybe<(
      Pick<SummaryTotal, 'count'>
      & { total: (
        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
      ) }
    )>,
  }
);

export type ProductFieldsFragment = Pick<Product, 'id' | 'name'>;

export type ProductGroupFieldsFragment = Pick<
    ProductGroup,
    | 'id'
    | 'name'
    | 'description'
    | 'iconDisplayKey'
    | 'customIconObjectName'
    | 'createdAt'
    | 'updatedAt'
  >;

export type ProductInstitutionFieldsFragment = (
  Pick<
    ProductInstitution,
    | 'id'
    | 'name'
    | 'products'
    | 'routingNumber'
  >
  & { party?: Maybe<Pick<
      Party,
      | 'id'
      | 'legalEntityId'
      | 'name'
      | 'url'
      | 'supportUrl'
      | 'supportEmail'
      | 'supportPhone'
      | 'twitterUrl'
      | 'facebookUrl'
      | 'instagramUrl'
      | 'yelpUrl'
      | 'iconUrl'
      | 'shortDescription'
      | 'designation'
    >> }
);

export type ReconciliationDiffFieldsFragment = (
  Pick<ReconciliationDiff, 'reconciliationId'>
  & {
    toStartDate: Pick<Date, 'year' | 'month' | 'day'>,
    toEndDate: Pick<Date, 'year' | 'month' | 'day'>,
    transactions: Array<(
      Pick<
        ReconciliationDiffTransaction,
        | 'transactionFactId'
        | 'diffReasons'
        | 'fromStatus'
        | 'toStatus'
        | 'fromOccurredAt'
        | 'toOccurredAt'
        | 'fromEntryType'
        | 'toEntryType'
      >
      & {
        transaction?: Maybe<(
          Pick<
            Transaction,
            | 'viewId'
            | 'factId'
            | 'ledgerTransactionId'
            | 'supersededFactIds'
            | 'timestamp'
            | 'recordType'
            | 'name'
            | 'description'
            | 'digitsTransactionType'
            | 'partySource'
            | 'displayEntry'
            | 'displayCategorySource'
            | 'displayCanonicalCategoryName'
            | 'displayUncategorizedReason'
            | 'displayProductArea'
            | 'ownerSource'
            | 'transactionClassificationType'
            | 'compileSource'
            | 'reconciliationStatus'
            | 'referenceNumber'
            | 'taxStatus'
            | 'matchedLedgerTransactionIds'
            | 'providerTypes'
            | 'isSupersedingLedgerTransaction'
            | 'supersededLedgerTransactionIds'
          >
          & {
            party?: Maybe<Pick<
                TransactionParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'iconObjectName'
                | 'designation'
                | 'roles'
              >>,
            facilitatorParty?: Maybe<Pick<
                TransactionParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'iconObjectName'
                | 'designation'
                | 'roles'
              >>,
            product?: Maybe<Pick<Product, 'id' | 'name'>>,
            department?: Maybe<(
              { __typename: 'EntityDepartment' }
              & Pick<
                EntityDepartment,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            )>,
            splitDepartment?: Maybe<(
              { __typename: 'EntityDepartment' }
              & Pick<
                EntityDepartment,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            )>,
            location?: Maybe<(
              { __typename: 'EntityLocation' }
              & Pick<
                EntityLocation,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            )>,
            splitLocation?: Maybe<(
              { __typename: 'EntityLocation' }
              & Pick<
                EntityLocation,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            )>,
            providers: Array<Pick<Provider, 'name'>>,
            recurrence?: Maybe<Pick<
                TransactionRecurrence,
                | 'recurrenceThreadId'
                | 'interval'
                | 'intervalMultiplier'
                | 'threadIndex'
                | 'totalThreadCount'
                | 'isHidden'
                | 'firstOccurredAt'
                | 'lastOccurredAt'
              >>,
            displayInstitution?: Maybe<Pick<
                TransactionParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'iconObjectName'
                | 'designation'
                | 'roles'
              >>,
            displayCategory: (
              Pick<
                Category,
                | 'id'
                | 'name'
                | 'description'
                | 'displayKey'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'displayNumber'
                | 'active'
                | 'categoryState'
                | 'productArea'
                | 'synthesized'
              >
              & { ancestors?: Maybe<Array<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>> }
            ),
            displayCategoryClassificationProvenance?: Maybe<(
              Pick<
                ClassificationProvenance,
                | 'type'
                | 'changedAt'
                | 'confidenceLevel'
                | 'settingsName'
              >
              & { source?: Maybe<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )> }
            )>,
            splitCategory?: Maybe<(
              Pick<
                Category,
                | 'id'
                | 'name'
                | 'description'
                | 'displayKey'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'displayNumber'
                | 'active'
                | 'categoryState'
                | 'productArea'
                | 'synthesized'
              >
              & { ancestors?: Maybe<Array<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>> }
            )>,
            splitCategoryClassificationProvenance?: Maybe<(
              Pick<
                ClassificationProvenance,
                | 'type'
                | 'changedAt'
                | 'confidenceLevel'
                | 'settingsName'
              >
              & { source?: Maybe<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )> }
            )>,
            splitInstitution?: Maybe<Pick<
                TransactionParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'iconObjectName'
                | 'designation'
                | 'roles'
              >>,
            creditCategoryClassificationProvenance?: Maybe<(
              Pick<
                ClassificationProvenance,
                | 'type'
                | 'changedAt'
                | 'confidenceLevel'
                | 'settingsName'
              >
              & { source?: Maybe<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )> }
            )>,
            debitCategoryClassificationProvenance?: Maybe<(
              Pick<
                ClassificationProvenance,
                | 'type'
                | 'changedAt'
                | 'confidenceLevel'
                | 'settingsName'
              >
              & { source?: Maybe<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )> }
            )>,
            moneyFlow: (
              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            ),
            runningTotal?: Maybe<(
              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            )>,
            owner?: Maybe<Pick<
                EntityEmployee,
                | 'id'
                | 'organizationId'
                | 'givenName'
                | 'familyName'
                | 'avatarUrl'
              >>,
            sources: Array<(
              Pick<
                TransactionSource,
                | 'timestamp'
                | 'name'
                | 'iconUrl'
                | 'externalDisplayId'
                | 'type'
              >
              & { account?: Maybe<Pick<
                  TransactionSourceAccount,
                  | 'sourceAccountId'
                  | 'externalName'
                  | 'mask'
                  | 'externalOwnerName'
                  | 'externalOfficialName'
                >> }
            )>,
            creditSources: Array<(
              Pick<
                TransactionSource,
                | 'timestamp'
                | 'name'
                | 'iconUrl'
                | 'externalDisplayId'
                | 'type'
              >
              & { account?: Maybe<Pick<
                  TransactionSourceAccount,
                  | 'sourceAccountId'
                  | 'externalName'
                  | 'mask'
                  | 'externalOwnerName'
                  | 'externalOfficialName'
                >> }
            )>,
            debitSources: Array<(
              Pick<
                TransactionSource,
                | 'timestamp'
                | 'name'
                | 'iconUrl'
                | 'externalDisplayId'
                | 'type'
              >
              & { account?: Maybe<Pick<
                  TransactionSourceAccount,
                  | 'sourceAccountId'
                  | 'externalName'
                  | 'mask'
                  | 'externalOwnerName'
                  | 'externalOfficialName'
                >> }
            )>,
            invoiceLineItem?: Maybe<{ value:
                | (
                  Pick<
                    TransactionDiscountLineItem,
                    | 'name'
                    | 'description'
                    | 'variablePercentage'
                    | 'appliesToTransactionFactId'
                  >
                  & {
                    fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                    discount?: Maybe<(
                      Pick<
                        TransactionInvoiceLineItemDiscount,
                        | 'discountId'
                        | 'name'
                        | 'description'
                        | 'variablePercentage'
                      >
                      & { fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
                    )>,
                  }
                )
                | (
                  Pick<TransactionProductLineItem, 'name' | 'description' | 'quantity'>
                  & {
                    unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                    product?: Maybe<(
                      Pick<TransactionInvoiceLineItemProduct, 'productId' | 'name' | 'description'>
                      & {
                        unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                        category?: Maybe<(
                          Pick<
                            Category,
                            | 'id'
                            | 'name'
                            | 'description'
                            | 'displayKey'
                            | 'type'
                            | 'subtype'
                            | 'parentCategoryId'
                            | 'displayNumber'
                            | 'active'
                            | 'categoryState'
                            | 'productArea'
                            | 'synthesized'
                          >
                          & { ancestors?: Maybe<Array<Pick<
                              EntityCategory,
                              | 'id'
                              | 'name'
                              | 'displayKey'
                              | 'chartOfAccountsDisplayNumber'
                              | 'type'
                              | 'subtype'
                              | 'parentCategoryId'
                              | 'productArea'
                              | 'active'
                            >>> }
                        )>,
                        department?: Maybe<(
                          { __typename: 'EntityDepartment' }
                          & Pick<
                            EntityDepartment,
                            | 'id'
                            | 'name'
                            | 'parentId'
                            | 'active'
                          >
                        )>,
                        location?: Maybe<(
                          { __typename: 'EntityLocation' }
                          & Pick<
                            EntityLocation,
                            | 'id'
                            | 'name'
                            | 'parentId'
                            | 'active'
                          >
                        )>,
                      }
                    )>,
                  }
                )
               }>,
            schedule?: Maybe<(
              { __typename: 'EntitySchedule' }
              & Pick<
                EntitySchedule,
                | 'id'
                | 'name'
                | 'scheduleNumber'
                | 'scheduleType'
                | 'scheduleTemplateId'
                | 'categoryId'
                | 'relatedCategoryId'
                | 'partyId'
                | 'startDate'
                | 'endDate'
              >
              & { amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
            )>,
            splitSchedule?: Maybe<(
              { __typename: 'EntitySchedule' }
              & Pick<
                EntitySchedule,
                | 'id'
                | 'name'
                | 'scheduleNumber'
                | 'scheduleType'
                | 'scheduleTemplateId'
                | 'categoryId'
                | 'relatedCategoryId'
                | 'partyId'
                | 'startDate'
                | 'endDate'
              >
              & { amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
            )>,
          }
        )>,
        fromAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
        toAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
      }
    )>,
  }
);

export type ReconciliationDiffTransactionFieldsFragment = (
  Pick<
    ReconciliationDiffTransaction,
    | 'transactionFactId'
    | 'diffReasons'
    | 'fromStatus'
    | 'toStatus'
    | 'fromOccurredAt'
    | 'toOccurredAt'
    | 'fromEntryType'
    | 'toEntryType'
  >
  & {
    transaction?: Maybe<(
      Pick<
        Transaction,
        | 'viewId'
        | 'factId'
        | 'ledgerTransactionId'
        | 'supersededFactIds'
        | 'timestamp'
        | 'recordType'
        | 'name'
        | 'description'
        | 'digitsTransactionType'
        | 'partySource'
        | 'displayEntry'
        | 'displayCategorySource'
        | 'displayCanonicalCategoryName'
        | 'displayUncategorizedReason'
        | 'displayProductArea'
        | 'ownerSource'
        | 'transactionClassificationType'
        | 'compileSource'
        | 'reconciliationStatus'
        | 'referenceNumber'
        | 'taxStatus'
        | 'matchedLedgerTransactionIds'
        | 'providerTypes'
        | 'isSupersedingLedgerTransaction'
        | 'supersededLedgerTransactionIds'
      >
      & {
        party?: Maybe<Pick<
            TransactionParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'iconObjectName'
            | 'designation'
            | 'roles'
          >>,
        facilitatorParty?: Maybe<Pick<
            TransactionParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'iconObjectName'
            | 'designation'
            | 'roles'
          >>,
        product?: Maybe<Pick<Product, 'id' | 'name'>>,
        department?: Maybe<(
          { __typename: 'EntityDepartment' }
          & Pick<
            EntityDepartment,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>,
        splitDepartment?: Maybe<(
          { __typename: 'EntityDepartment' }
          & Pick<
            EntityDepartment,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>,
        location?: Maybe<(
          { __typename: 'EntityLocation' }
          & Pick<
            EntityLocation,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>,
        splitLocation?: Maybe<(
          { __typename: 'EntityLocation' }
          & Pick<
            EntityLocation,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>,
        providers: Array<Pick<Provider, 'name'>>,
        recurrence?: Maybe<Pick<
            TransactionRecurrence,
            | 'recurrenceThreadId'
            | 'interval'
            | 'intervalMultiplier'
            | 'threadIndex'
            | 'totalThreadCount'
            | 'isHidden'
            | 'firstOccurredAt'
            | 'lastOccurredAt'
          >>,
        displayInstitution?: Maybe<Pick<
            TransactionParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'iconObjectName'
            | 'designation'
            | 'roles'
          >>,
        displayCategory: (
          Pick<
            Category,
            | 'id'
            | 'name'
            | 'description'
            | 'displayKey'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'displayNumber'
            | 'active'
            | 'categoryState'
            | 'productArea'
            | 'synthesized'
          >
          & { ancestors?: Maybe<Array<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>> }
        ),
        displayCategoryClassificationProvenance?: Maybe<(
          Pick<
            ClassificationProvenance,
            | 'type'
            | 'changedAt'
            | 'confidenceLevel'
            | 'settingsName'
          >
          & { source?: Maybe<(
            Pick<
              TransactionSource,
              | 'timestamp'
              | 'name'
              | 'iconUrl'
              | 'externalDisplayId'
              | 'type'
            >
            & { account?: Maybe<Pick<
                TransactionSourceAccount,
                | 'sourceAccountId'
                | 'externalName'
                | 'mask'
                | 'externalOwnerName'
                | 'externalOfficialName'
              >> }
          )> }
        )>,
        splitCategory?: Maybe<(
          Pick<
            Category,
            | 'id'
            | 'name'
            | 'description'
            | 'displayKey'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'displayNumber'
            | 'active'
            | 'categoryState'
            | 'productArea'
            | 'synthesized'
          >
          & { ancestors?: Maybe<Array<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>> }
        )>,
        splitCategoryClassificationProvenance?: Maybe<(
          Pick<
            ClassificationProvenance,
            | 'type'
            | 'changedAt'
            | 'confidenceLevel'
            | 'settingsName'
          >
          & { source?: Maybe<(
            Pick<
              TransactionSource,
              | 'timestamp'
              | 'name'
              | 'iconUrl'
              | 'externalDisplayId'
              | 'type'
            >
            & { account?: Maybe<Pick<
                TransactionSourceAccount,
                | 'sourceAccountId'
                | 'externalName'
                | 'mask'
                | 'externalOwnerName'
                | 'externalOfficialName'
              >> }
          )> }
        )>,
        splitInstitution?: Maybe<Pick<
            TransactionParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'iconObjectName'
            | 'designation'
            | 'roles'
          >>,
        creditCategoryClassificationProvenance?: Maybe<(
          Pick<
            ClassificationProvenance,
            | 'type'
            | 'changedAt'
            | 'confidenceLevel'
            | 'settingsName'
          >
          & { source?: Maybe<(
            Pick<
              TransactionSource,
              | 'timestamp'
              | 'name'
              | 'iconUrl'
              | 'externalDisplayId'
              | 'type'
            >
            & { account?: Maybe<Pick<
                TransactionSourceAccount,
                | 'sourceAccountId'
                | 'externalName'
                | 'mask'
                | 'externalOwnerName'
                | 'externalOfficialName'
              >> }
          )> }
        )>,
        debitCategoryClassificationProvenance?: Maybe<(
          Pick<
            ClassificationProvenance,
            | 'type'
            | 'changedAt'
            | 'confidenceLevel'
            | 'settingsName'
          >
          & { source?: Maybe<(
            Pick<
              TransactionSource,
              | 'timestamp'
              | 'name'
              | 'iconUrl'
              | 'externalDisplayId'
              | 'type'
            >
            & { account?: Maybe<Pick<
                TransactionSourceAccount,
                | 'sourceAccountId'
                | 'externalName'
                | 'mask'
                | 'externalOwnerName'
                | 'externalOfficialName'
              >> }
          )> }
        )>,
        moneyFlow: (
          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        ),
        runningTotal?: Maybe<(
          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        )>,
        owner?: Maybe<Pick<
            EntityEmployee,
            | 'id'
            | 'organizationId'
            | 'givenName'
            | 'familyName'
            | 'avatarUrl'
          >>,
        sources: Array<(
          Pick<
            TransactionSource,
            | 'timestamp'
            | 'name'
            | 'iconUrl'
            | 'externalDisplayId'
            | 'type'
          >
          & { account?: Maybe<Pick<
              TransactionSourceAccount,
              | 'sourceAccountId'
              | 'externalName'
              | 'mask'
              | 'externalOwnerName'
              | 'externalOfficialName'
            >> }
        )>,
        creditSources: Array<(
          Pick<
            TransactionSource,
            | 'timestamp'
            | 'name'
            | 'iconUrl'
            | 'externalDisplayId'
            | 'type'
          >
          & { account?: Maybe<Pick<
              TransactionSourceAccount,
              | 'sourceAccountId'
              | 'externalName'
              | 'mask'
              | 'externalOwnerName'
              | 'externalOfficialName'
            >> }
        )>,
        debitSources: Array<(
          Pick<
            TransactionSource,
            | 'timestamp'
            | 'name'
            | 'iconUrl'
            | 'externalDisplayId'
            | 'type'
          >
          & { account?: Maybe<Pick<
              TransactionSourceAccount,
              | 'sourceAccountId'
              | 'externalName'
              | 'mask'
              | 'externalOwnerName'
              | 'externalOfficialName'
            >> }
        )>,
        invoiceLineItem?: Maybe<{ value:
            | (
              Pick<
                TransactionDiscountLineItem,
                | 'name'
                | 'description'
                | 'variablePercentage'
                | 'appliesToTransactionFactId'
              >
              & {
                fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                discount?: Maybe<(
                  Pick<
                    TransactionInvoiceLineItemDiscount,
                    | 'discountId'
                    | 'name'
                    | 'description'
                    | 'variablePercentage'
                  >
                  & { fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
                )>,
              }
            )
            | (
              Pick<TransactionProductLineItem, 'name' | 'description' | 'quantity'>
              & {
                unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                product?: Maybe<(
                  Pick<TransactionInvoiceLineItemProduct, 'productId' | 'name' | 'description'>
                  & {
                    unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                    category?: Maybe<(
                      Pick<
                        Category,
                        | 'id'
                        | 'name'
                        | 'description'
                        | 'displayKey'
                        | 'type'
                        | 'subtype'
                        | 'parentCategoryId'
                        | 'displayNumber'
                        | 'active'
                        | 'categoryState'
                        | 'productArea'
                        | 'synthesized'
                      >
                      & { ancestors?: Maybe<Array<Pick<
                          EntityCategory,
                          | 'id'
                          | 'name'
                          | 'displayKey'
                          | 'chartOfAccountsDisplayNumber'
                          | 'type'
                          | 'subtype'
                          | 'parentCategoryId'
                          | 'productArea'
                          | 'active'
                        >>> }
                    )>,
                    department?: Maybe<(
                      { __typename: 'EntityDepartment' }
                      & Pick<
                        EntityDepartment,
                        | 'id'
                        | 'name'
                        | 'parentId'
                        | 'active'
                      >
                    )>,
                    location?: Maybe<(
                      { __typename: 'EntityLocation' }
                      & Pick<
                        EntityLocation,
                        | 'id'
                        | 'name'
                        | 'parentId'
                        | 'active'
                      >
                    )>,
                  }
                )>,
              }
            )
           }>,
        schedule?: Maybe<(
          { __typename: 'EntitySchedule' }
          & Pick<
            EntitySchedule,
            | 'id'
            | 'name'
            | 'scheduleNumber'
            | 'scheduleType'
            | 'scheduleTemplateId'
            | 'categoryId'
            | 'relatedCategoryId'
            | 'partyId'
            | 'startDate'
            | 'endDate'
          >
          & { amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
        )>,
        splitSchedule?: Maybe<(
          { __typename: 'EntitySchedule' }
          & Pick<
            EntitySchedule,
            | 'id'
            | 'name'
            | 'scheduleNumber'
            | 'scheduleType'
            | 'scheduleTemplateId'
            | 'categoryId'
            | 'relatedCategoryId'
            | 'partyId'
            | 'startDate'
            | 'endDate'
          >
          & { amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
        )>,
      }
    )>,
    fromAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
    toAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
  }
);

export type ReportFileMetadataFieldsFragment = Pick<
    ReportFileMetadata,
    | 'id'
    | 'fileName'
    | 'mimeType'
    | 'fileSize'
    | 'source'
  >;

export type ReportGenerationHistoryFieldsFragment = Pick<
    ReportGenerationHistory,
    | 'id'
    | 'requestId'
    | 'reportId'
    | 'versionId'
    | 'legalEntityId'
    | 'authorId'
    | 'viewVersion'
    | 'kind'
    | 'timezone'
    | 'periodStartedAt'
    | 'periodEndedAt'
    | 'generationStartedAt'
    | 'generationEndedAt'
    | 'error'
    | 'createdAt'
    | 'updatedAt'
  >;

export type ReportPackageDocumentMetadataFieldsFragment = (
  Pick<
    ReportPackageDocumentMetadata,
    | 'id'
    | 'title'
    | 'documentObjectId'
    | 'documentObjectVersionId'
    | 'type'
    | 'status'
    | 'position'
  >
  & {
    reportFile?: Maybe<Pick<
        ReportFileMetadata,
        | 'id'
        | 'fileName'
        | 'mimeType'
        | 'fileSize'
        | 'source'
      >>,
    generationHistory?: Maybe<Pick<
        ReportGenerationHistory,
        | 'id'
        | 'requestId'
        | 'reportId'
        | 'versionId'
        | 'legalEntityId'
        | 'authorId'
        | 'viewVersion'
        | 'kind'
        | 'timezone'
        | 'periodStartedAt'
        | 'periodEndedAt'
        | 'generationStartedAt'
        | 'generationEndedAt'
        | 'error'
        | 'createdAt'
        | 'updatedAt'
      >>,
  }
);

export type ReportPackageMetadataFieldsFragment = (
  Pick<
    ReportPackageMetadata,
    | 'id'
    | 'versionId'
    | 'title'
    | 'status'
    | 'startedAt'
    | 'endedAt'
    | 'interval'
    | 'coverUrl'
    | 'publishedAsDraft'
    | 'createdAt'
    | 'updatedAt'
    | 'creationMethod'
  >
  & {
    viewKey: Pick<
        ViewIdentifier,
        | 'legalEntityId'
        | 'viewVersion'
        | 'mutationVersion'
        | 'viewType'
      >,
    author?: Maybe<Pick<
        Contact,
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      >>,
    documents: Array<(
      Pick<
        ReportPackageDocumentMetadata,
        | 'id'
        | 'title'
        | 'documentObjectId'
        | 'documentObjectVersionId'
        | 'type'
        | 'status'
        | 'position'
      >
      & {
        reportFile?: Maybe<Pick<
            ReportFileMetadata,
            | 'id'
            | 'fileName'
            | 'mimeType'
            | 'fileSize'
            | 'source'
          >>,
        generationHistory?: Maybe<Pick<
            ReportGenerationHistory,
            | 'id'
            | 'requestId'
            | 'reportId'
            | 'versionId'
            | 'legalEntityId'
            | 'authorId'
            | 'viewVersion'
            | 'kind'
            | 'timezone'
            | 'periodStartedAt'
            | 'periodEndedAt'
            | 'generationStartedAt'
            | 'generationEndedAt'
            | 'error'
            | 'createdAt'
            | 'updatedAt'
          >>,
      }
    )>,
    versions: Array<Pick<
        ReportPackageVersionMetadata,
        | 'id'
        | 'status'
        | 'createdAt'
        | 'updatedAt'
      >>,
  }
);

export type ReportPackageVersionMetadataFieldsFragment = Pick<
    ReportPackageVersionMetadata,
    | 'id'
    | 'status'
    | 'createdAt'
    | 'updatedAt'
  >;

export type RoleFieldsFragment = Pick<Role, 'id'>;

export type ScheduleEventFieldsFragment = (
  Pick<
    ScheduleEvent,
    | 'id'
    | 'displayName'
    | 'eventDate'
    | 'eventTemplateId'
    | 'isGenerated'
    | 'isInstantiating'
    | 'isTerminating'
    | 'isSingleton'
    | 'displayKey'
    | 'skipReason'
    | 'note'
    | 'createdAt'
    | 'updatedAt'
  >
  & {
    createdBy: Pick<
        EntityUser,
        | 'id'
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      >,
    updatedBy: Pick<
        EntityUser,
        | 'id'
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      >,
    variables: Array<(
      Pick<
        ScheduleEventVariable,
        | 'id'
        | 'displayName'
        | 'variableName'
        | 'variableTemplateId'
        | 'variableType'
      >
      & { value:
        | Pick<ScheduleBooleanValue, 'boolValue'>
        | { category: Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            > }
        | Pick<ScheduleDateValue, 'dateValue'>
        | Pick<ScheduleFloatValue, 'floatValue'>
        | Pick<ScheduleFormulaValue, 'formulaId' | 'formulaDisplayName'>
        | Pick<ScheduleIntervalValue, 'intervalValue'>
        | Pick<ScheduleLongValue, 'longValue'>
        | { monetaryValue: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        | { party: Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            > }
        | Pick<ScheduleStringValue, 'stringValue'>
        | Pick<ScheduleTermValue, 'intervalCount' | 'endDate'>
        | { transaction: (
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          ) }
       }
    )>,
  }
);

export type ScheduleEventTemplateFieldsFragment = (
  Pick<
    ScheduleEventTemplate,
    | 'id'
    | 'name'
    | 'description'
    | 'displayName'
    | 'ordinal'
    | 'isSingleton'
    | 'isTerminating'
    | 'isInstantiating'
    | 'inCreateFlow'
    | 'displayKey'
  >
  & { variables: Array<(
    Pick<
      ScheduleEventVariableTemplate,
      | 'id'
      | 'variableName'
      | 'displayName'
      | 'required'
      | 'ordinal'
      | 'variableType'
      | 'displayMode'
    >
    & { formulas?: Maybe<Array<Pick<ScheduleEventVariableTemplateFormula, 'id' | 'displayName'>>> }
  )> }
);

export type ScheduleEventVariableFieldsFragment = (
  Pick<
    ScheduleEventVariable,
    | 'id'
    | 'displayName'
    | 'variableName'
    | 'variableTemplateId'
    | 'variableType'
  >
  & { value:
    | Pick<ScheduleBooleanValue, 'boolValue'>
    | { category: Pick<
          EntityCategory,
          | 'id'
          | 'name'
          | 'displayKey'
          | 'chartOfAccountsDisplayNumber'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'productArea'
          | 'active'
        > }
    | Pick<ScheduleDateValue, 'dateValue'>
    | Pick<ScheduleFloatValue, 'floatValue'>
    | Pick<ScheduleFormulaValue, 'formulaId' | 'formulaDisplayName'>
    | Pick<ScheduleIntervalValue, 'intervalValue'>
    | Pick<ScheduleLongValue, 'longValue'>
    | { monetaryValue: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
    | { party: Pick<
          EntityParty,
          | 'id'
          | 'name'
          | 'iconUrl'
          | 'shortDescription'
          | 'roles'
          | 'designation'
        > }
    | Pick<ScheduleStringValue, 'stringValue'>
    | Pick<ScheduleTermValue, 'intervalCount' | 'endDate'>
    | { transaction: (
        Pick<
          EntityTransaction,
          | 'viewId'
          | 'factId'
          | 'timestamp'
          | 'description'
          | 'externalId'
          | 'displayEntry'
        >
        & {
          moneyFlow: (
            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          ),
          party?: Maybe<Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >>,
          displayCategory: Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >,
          splitCategory?: Maybe<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>,
        }
      ) }
   }
);

export type ScheduleEventVariableTemplateFieldsFragment = (
  Pick<
    ScheduleEventVariableTemplate,
    | 'id'
    | 'variableName'
    | 'displayName'
    | 'required'
    | 'ordinal'
    | 'variableType'
    | 'displayMode'
  >
  & { formulas?: Maybe<Array<Pick<ScheduleEventVariableTemplateFormula, 'id' | 'displayName'>>> }
);

export type ScheduleEventVariableTemplateFormulaFieldsFragment = Pick<ScheduleEventVariableTemplateFormula, 'id' | 'displayName'>;

export type ScheduleFieldsFragment = (
  Pick<
    Schedule,
    | 'id'
    | 'name'
    | 'description'
    | 'scheduleNumber'
    | 'scheduleTemplateId'
    | 'specializationId'
    | 'scheduleType'
    | 'createdAt'
    | 'updatedAt'
  >
  & {
    sourceTransaction?: Maybe<(
      Pick<
        EntityTransaction,
        | 'viewId'
        | 'factId'
        | 'timestamp'
        | 'description'
        | 'externalId'
        | 'displayEntry'
      >
      & {
        moneyFlow: (
          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        ),
        party?: Maybe<Pick<
            EntityParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'shortDescription'
            | 'roles'
            | 'designation'
          >>,
        displayCategory: Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >,
        splitCategory?: Maybe<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>,
      }
    )>,
    party?: Maybe<Pick<
        EntityParty,
        | 'id'
        | 'name'
        | 'iconUrl'
        | 'shortDescription'
        | 'roles'
        | 'designation'
      >>,
    createdBy: Pick<
        EntityUser,
        | 'id'
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      >,
    updatedBy: Pick<
        EntityUser,
        | 'id'
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      >,
    events: Array<(
      Pick<
        ScheduleEvent,
        | 'id'
        | 'displayName'
        | 'eventDate'
        | 'eventTemplateId'
        | 'isGenerated'
        | 'isInstantiating'
        | 'isTerminating'
        | 'isSingleton'
        | 'displayKey'
        | 'skipReason'
        | 'note'
        | 'createdAt'
        | 'updatedAt'
      >
      & {
        createdBy: Pick<
            EntityUser,
            | 'id'
            | 'givenName'
            | 'familyName'
            | 'emailAddress'
            | 'avatarUrl'
          >,
        updatedBy: Pick<
            EntityUser,
            | 'id'
            | 'givenName'
            | 'familyName'
            | 'emailAddress'
            | 'avatarUrl'
          >,
        variables: Array<(
          Pick<
            ScheduleEventVariable,
            | 'id'
            | 'displayName'
            | 'variableName'
            | 'variableTemplateId'
            | 'variableType'
          >
          & { value:
            | Pick<ScheduleBooleanValue, 'boolValue'>
            | { category: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                > }
            | Pick<ScheduleDateValue, 'dateValue'>
            | Pick<ScheduleFloatValue, 'floatValue'>
            | Pick<ScheduleFormulaValue, 'formulaId' | 'formulaDisplayName'>
            | Pick<ScheduleIntervalValue, 'intervalValue'>
            | Pick<ScheduleLongValue, 'longValue'>
            | { monetaryValue: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            | { party: Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                > }
            | Pick<ScheduleStringValue, 'stringValue'>
            | Pick<ScheduleTermValue, 'intervalCount' | 'endDate'>
            | { transaction: (
                Pick<
                  EntityTransaction,
                  | 'viewId'
                  | 'factId'
                  | 'timestamp'
                  | 'description'
                  | 'externalId'
                  | 'displayEntry'
                >
                & {
                  moneyFlow: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ),
                  party?: Maybe<Pick<
                      EntityParty,
                      | 'id'
                      | 'name'
                      | 'iconUrl'
                      | 'shortDescription'
                      | 'roles'
                      | 'designation'
                    >>,
                  displayCategory: Pick<
                      EntityCategory,
                      | 'id'
                      | 'name'
                      | 'displayKey'
                      | 'chartOfAccountsDisplayNumber'
                      | 'type'
                      | 'subtype'
                      | 'parentCategoryId'
                      | 'productArea'
                      | 'active'
                    >,
                  splitCategory?: Maybe<Pick<
                      EntityCategory,
                      | 'id'
                      | 'name'
                      | 'displayKey'
                      | 'chartOfAccountsDisplayNumber'
                      | 'type'
                      | 'subtype'
                      | 'parentCategoryId'
                      | 'productArea'
                      | 'active'
                    >>,
                }
              ) }
           }
        )>,
      }
    )>,
  }
);

export type ScheduleSnapshotFieldsFragment = (
  Pick<
    ScheduleSnapshot,
    | 'id'
    | 'name'
    | 'scheduleNumber'
    | 'scheduleType'
    | 'startDate'
    | 'endDate'
  >
  & {
    category?: Maybe<Pick<
        EntityCategory,
        | 'id'
        | 'name'
        | 'displayKey'
        | 'chartOfAccountsDisplayNumber'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'productArea'
        | 'active'
      >>,
    relatedCategory?: Maybe<Pick<
        EntityCategory,
        | 'id'
        | 'name'
        | 'displayKey'
        | 'chartOfAccountsDisplayNumber'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'productArea'
        | 'active'
      >>,
    party?: Maybe<Pick<
        EntityParty,
        | 'id'
        | 'name'
        | 'iconUrl'
        | 'shortDescription'
        | 'roles'
        | 'designation'
      >>,
    amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
    remainingAmount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
  }
);

export type ScheduleTemplateFieldsFragment = Pick<
    ScheduleTemplate,
    | 'id'
    | 'name'
    | 'description'
    | 'scheduleType'
    | 'displayKey'
  >;

export type SourceAccountFieldsFragment = Pick<
    SourceAccount,
    | 'id'
    | 'externalId'
    | 'externalName'
    | 'externalOwnerName'
    | 'externalOfficialName'
    | 'externalType'
    | 'externalSubtype'
    | 'mask'
    | 'status'
    | 'ownerEmployeeId'
  >;

export type SummaryTotalFieldsFragment = (
  Pick<SummaryTotal, 'count'>
  & { total: (
    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
  ) }
);

export type ThreadDetailsFieldsFragment = (
  Pick<
    ThreadDetails,
    | 'id'
    | 'commentCount'
    | 'resolvedAt'
    | 'authorId'
    | 'commenterIds'
    | 'context'
    | 'pending'
  >
  & {
    targetObject: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
    tags: Array<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
  }
);

export type ThreadFieldsFragment = (
  { __typename: 'Thread' }
  & Pick<Thread, 'id'>
  & {
    details: (
      Pick<
        ThreadDetails,
        | 'id'
        | 'commentCount'
        | 'resolvedAt'
        | 'authorId'
        | 'commenterIds'
        | 'context'
        | 'pending'
      >
      & {
        targetObject: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
        tags: Array<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
      }
    ),
    comments: Array<(
      { __typename: 'Comment' }
      & Pick<
        Comment,
        | 'id'
        | 'authorId'
        | 'text'
        | 'timestamp'
        | 'editedAt'
        | 'deletedAt'
        | 'reactions'
      >
      & { layoutAttachment?: Maybe<Pick<LayoutAttachment, 'layoutId' | 'legalEntityId'>> }
    )>,
  }
);

export type ThreadListFieldsFragment = {
    targetObject: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
    threads: Array<(
      Pick<
        ThreadDetails,
        | 'id'
        | 'commentCount'
        | 'resolvedAt'
        | 'authorId'
        | 'commenterIds'
        | 'context'
        | 'pending'
      >
      & {
        targetObject: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
        tags: Array<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
      }
    )>,
  };

export type ThreadWithEntitiesFieldsFragment = (
  { __typename: 'ThreadWithEntities' }
  & {
    thread: (
      { __typename: 'Thread' }
      & Pick<Thread, 'id'>
      & {
        details: (
          Pick<
            ThreadDetails,
            | 'id'
            | 'commentCount'
            | 'resolvedAt'
            | 'authorId'
            | 'commenterIds'
            | 'context'
            | 'pending'
          >
          & {
            targetObject: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
            tags: Array<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
          }
        ),
        comments: Array<(
          { __typename: 'Comment' }
          & Pick<
            Comment,
            | 'id'
            | 'authorId'
            | 'text'
            | 'timestamp'
            | 'editedAt'
            | 'deletedAt'
            | 'reactions'
          >
          & { layoutAttachment?: Maybe<Pick<LayoutAttachment, 'layoutId' | 'legalEntityId'>> }
        )>,
      }
    ),
    entities?: Maybe<(
      { __typename: 'ObjectEntities' }
      & {
        users?: Maybe<Array<Pick<
            EntityUser,
            | 'id'
            | 'givenName'
            | 'familyName'
            | 'emailAddress'
            | 'avatarUrl'
          >>>,
        transactions?: Maybe<Array<(
          Pick<
            EntityTransaction,
            | 'viewId'
            | 'factId'
            | 'timestamp'
            | 'description'
            | 'externalId'
            | 'displayEntry'
          >
          & {
            moneyFlow: (
              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            ),
            party?: Maybe<Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              >>,
            displayCategory: Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >,
            splitCategory?: Maybe<Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >>,
          }
        )>>,
        comments?: Maybe<Array<Pick<
            EntityComment,
            | 'id'
            | 'authorId'
            | 'text'
            | 'timestamp'
          >>>,
        reports?: Maybe<Array<(
          Pick<
            EntityReport,
            | 'id'
            | 'title'
            | 'authorId'
            | 'mimeType'
            | 'createdAt'
          >
          & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
        )>>,
        reportPackages?: Maybe<Array<(
          Pick<
            EntityReportPackage,
            | 'id'
            | 'title'
            | 'authorId'
            | 'interval'
            | 'periodStartedAt'
            | 'periodEndedAt'
            | 'createdAt'
            | 'updatedAt'
            | 'coverUrl'
          >
          & { documents: Array<Pick<
              SharedReportDocumentMetadata,
              | 'id'
              | 'documentObjectId'
              | 'documentObjectVersionId'
              | 'title'
              | 'mimeType'
            >> }
        )>>,
        parties?: Maybe<Array<Pick<
            EntityParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'shortDescription'
            | 'roles'
            | 'designation'
          >>>,
        datasources?: Maybe<Array<Pick<
            EntityDataSource,
            | 'id'
            | 'name'
            | 'url'
            | 'iconUrl'
          >>>,
        categories?: Maybe<Array<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>>,
        threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
        legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
        workItems?: Maybe<Array<(
          Pick<
            EntityWorkItem,
            | 'id'
            | 'time'
            | 'workItemState'
            | 'workItemType'
            | 'reviewCreatedById'
            | 'reviewState'
            | 'ledgerType'
          >
          & { objectTransaction: (
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          ) }
        )>>,
        invoices?: Maybe<Array<(
          Pick<
            EntityInvoice,
            | 'id'
            | 'externalDisplayId'
            | 'createdAt'
            | 'dueAt'
          >
          & {
            amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            customer: (
              Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
              & { party: Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                > }
            ),
          }
        )>>,
        bills?: Maybe<Array<(
          Pick<
            EntityBill,
            | 'id'
            | 'billStatus'
            | 'vendorName'
            | 'billDescription'
          >
          & {
            totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
            format: (
              Pick<Format, 'id' | 'formatClass'>
              & { segments: Array<Pick<
                  Segment,
                  | 'collectionId'
                  | 'fileId'
                  | 'sequence'
                  | 'token'
                >> }
            ),
            approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
          }
        )>>,
        identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
        departments?: Maybe<Array<(
          { __typename: 'EntityDepartment' }
          & Pick<
            EntityDepartment,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>>,
        locations?: Maybe<Array<(
          { __typename: 'EntityLocation' }
          & Pick<
            EntityLocation,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>>,
        reconciliations?: Maybe<Array<(
          { __typename: 'EntityReconciliation' }
          & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
          & {
            startDate: Pick<Date, 'year' | 'month' | 'day'>,
            endDate: Pick<Date, 'year' | 'month' | 'day'>,
          }
        )>>,
        ledgerTransactions?: Maybe<Array<(
          Pick<
            EntityLedgerTransaction,
            | 'id'
            | 'timestamp'
            | 'factIds'
            | 'name'
            | 'referenceNumber'
          >
          & {
            totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            parties: Array<Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              >>,
          }
        )>>,
        schedules?: Maybe<Array<(
          { __typename: 'EntitySchedule' }
          & Pick<
            EntitySchedule,
            | 'id'
            | 'name'
            | 'scheduleNumber'
            | 'scheduleType'
            | 'scheduleTemplateId'
            | 'categoryId'
            | 'relatedCategoryId'
            | 'partyId'
            | 'startDate'
            | 'endDate'
          >
          & { amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
        )>>,
      }
    )>,
  }
);

export type ThreadsFieldsFragment = {
    threads: Array<{
        targetObject: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
        threads: Array<(
          Pick<
            ThreadDetails,
            | 'id'
            | 'commentCount'
            | 'resolvedAt'
            | 'authorId'
            | 'commenterIds'
            | 'context'
            | 'pending'
          >
          & {
            targetObject: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
            tags: Array<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
          }
        )>,
      }>,
    entities?: Maybe<(
      { __typename: 'ObjectEntities' }
      & {
        users?: Maybe<Array<Pick<
            EntityUser,
            | 'id'
            | 'givenName'
            | 'familyName'
            | 'emailAddress'
            | 'avatarUrl'
          >>>,
        transactions?: Maybe<Array<(
          Pick<
            EntityTransaction,
            | 'viewId'
            | 'factId'
            | 'timestamp'
            | 'description'
            | 'externalId'
            | 'displayEntry'
          >
          & {
            moneyFlow: (
              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            ),
            party?: Maybe<Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              >>,
            displayCategory: Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >,
            splitCategory?: Maybe<Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >>,
          }
        )>>,
        comments?: Maybe<Array<Pick<
            EntityComment,
            | 'id'
            | 'authorId'
            | 'text'
            | 'timestamp'
          >>>,
        reports?: Maybe<Array<(
          Pick<
            EntityReport,
            | 'id'
            | 'title'
            | 'authorId'
            | 'mimeType'
            | 'createdAt'
          >
          & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
        )>>,
        reportPackages?: Maybe<Array<(
          Pick<
            EntityReportPackage,
            | 'id'
            | 'title'
            | 'authorId'
            | 'interval'
            | 'periodStartedAt'
            | 'periodEndedAt'
            | 'createdAt'
            | 'updatedAt'
            | 'coverUrl'
          >
          & { documents: Array<Pick<
              SharedReportDocumentMetadata,
              | 'id'
              | 'documentObjectId'
              | 'documentObjectVersionId'
              | 'title'
              | 'mimeType'
            >> }
        )>>,
        parties?: Maybe<Array<Pick<
            EntityParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'shortDescription'
            | 'roles'
            | 'designation'
          >>>,
        datasources?: Maybe<Array<Pick<
            EntityDataSource,
            | 'id'
            | 'name'
            | 'url'
            | 'iconUrl'
          >>>,
        categories?: Maybe<Array<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>>,
        threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
        legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
        workItems?: Maybe<Array<(
          Pick<
            EntityWorkItem,
            | 'id'
            | 'time'
            | 'workItemState'
            | 'workItemType'
            | 'reviewCreatedById'
            | 'reviewState'
            | 'ledgerType'
          >
          & { objectTransaction: (
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          ) }
        )>>,
        invoices?: Maybe<Array<(
          Pick<
            EntityInvoice,
            | 'id'
            | 'externalDisplayId'
            | 'createdAt'
            | 'dueAt'
          >
          & {
            amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            customer: (
              Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
              & { party: Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                > }
            ),
          }
        )>>,
        bills?: Maybe<Array<(
          Pick<
            EntityBill,
            | 'id'
            | 'billStatus'
            | 'vendorName'
            | 'billDescription'
          >
          & {
            totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
            format: (
              Pick<Format, 'id' | 'formatClass'>
              & { segments: Array<Pick<
                  Segment,
                  | 'collectionId'
                  | 'fileId'
                  | 'sequence'
                  | 'token'
                >> }
            ),
            approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
          }
        )>>,
        identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
        departments?: Maybe<Array<(
          { __typename: 'EntityDepartment' }
          & Pick<
            EntityDepartment,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>>,
        locations?: Maybe<Array<(
          { __typename: 'EntityLocation' }
          & Pick<
            EntityLocation,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>>,
        reconciliations?: Maybe<Array<(
          { __typename: 'EntityReconciliation' }
          & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
          & {
            startDate: Pick<Date, 'year' | 'month' | 'day'>,
            endDate: Pick<Date, 'year' | 'month' | 'day'>,
          }
        )>>,
        ledgerTransactions?: Maybe<Array<(
          Pick<
            EntityLedgerTransaction,
            | 'id'
            | 'timestamp'
            | 'factIds'
            | 'name'
            | 'referenceNumber'
          >
          & {
            totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            parties: Array<Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              >>,
          }
        )>>,
        schedules?: Maybe<Array<(
          { __typename: 'EntitySchedule' }
          & Pick<
            EntitySchedule,
            | 'id'
            | 'name'
            | 'scheduleNumber'
            | 'scheduleType'
            | 'scheduleTemplateId'
            | 'categoryId'
            | 'relatedCategoryId'
            | 'partyId'
            | 'startDate'
            | 'endDate'
          >
          & { amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
        )>>,
      }
    )>,
  };

export type TransactionFieldsFragment = (
  Pick<
    Transaction,
    | 'viewId'
    | 'factId'
    | 'ledgerTransactionId'
    | 'supersededFactIds'
    | 'timestamp'
    | 'recordType'
    | 'name'
    | 'description'
    | 'digitsTransactionType'
    | 'partySource'
    | 'displayEntry'
    | 'displayCategorySource'
    | 'displayCanonicalCategoryName'
    | 'displayUncategorizedReason'
    | 'displayProductArea'
    | 'ownerSource'
    | 'transactionClassificationType'
    | 'compileSource'
    | 'reconciliationStatus'
    | 'referenceNumber'
    | 'taxStatus'
    | 'matchedLedgerTransactionIds'
    | 'providerTypes'
    | 'isSupersedingLedgerTransaction'
    | 'supersededLedgerTransactionIds'
  >
  & {
    party?: Maybe<Pick<
        TransactionParty,
        | 'id'
        | 'name'
        | 'iconUrl'
        | 'iconObjectName'
        | 'designation'
        | 'roles'
      >>,
    facilitatorParty?: Maybe<Pick<
        TransactionParty,
        | 'id'
        | 'name'
        | 'iconUrl'
        | 'iconObjectName'
        | 'designation'
        | 'roles'
      >>,
    product?: Maybe<Pick<Product, 'id' | 'name'>>,
    department?: Maybe<(
      { __typename: 'EntityDepartment' }
      & Pick<
        EntityDepartment,
        | 'id'
        | 'name'
        | 'parentId'
        | 'active'
      >
    )>,
    splitDepartment?: Maybe<(
      { __typename: 'EntityDepartment' }
      & Pick<
        EntityDepartment,
        | 'id'
        | 'name'
        | 'parentId'
        | 'active'
      >
    )>,
    location?: Maybe<(
      { __typename: 'EntityLocation' }
      & Pick<
        EntityLocation,
        | 'id'
        | 'name'
        | 'parentId'
        | 'active'
      >
    )>,
    splitLocation?: Maybe<(
      { __typename: 'EntityLocation' }
      & Pick<
        EntityLocation,
        | 'id'
        | 'name'
        | 'parentId'
        | 'active'
      >
    )>,
    providers: Array<Pick<Provider, 'name'>>,
    recurrence?: Maybe<Pick<
        TransactionRecurrence,
        | 'recurrenceThreadId'
        | 'interval'
        | 'intervalMultiplier'
        | 'threadIndex'
        | 'totalThreadCount'
        | 'isHidden'
        | 'firstOccurredAt'
        | 'lastOccurredAt'
      >>,
    displayInstitution?: Maybe<Pick<
        TransactionParty,
        | 'id'
        | 'name'
        | 'iconUrl'
        | 'iconObjectName'
        | 'designation'
        | 'roles'
      >>,
    displayCategory: (
      Pick<
        Category,
        | 'id'
        | 'name'
        | 'description'
        | 'displayKey'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'displayNumber'
        | 'active'
        | 'categoryState'
        | 'productArea'
        | 'synthesized'
      >
      & { ancestors?: Maybe<Array<Pick<
          EntityCategory,
          | 'id'
          | 'name'
          | 'displayKey'
          | 'chartOfAccountsDisplayNumber'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'productArea'
          | 'active'
        >>> }
    ),
    displayCategoryClassificationProvenance?: Maybe<(
      Pick<
        ClassificationProvenance,
        | 'type'
        | 'changedAt'
        | 'confidenceLevel'
        | 'settingsName'
      >
      & { source?: Maybe<(
        Pick<
          TransactionSource,
          | 'timestamp'
          | 'name'
          | 'iconUrl'
          | 'externalDisplayId'
          | 'type'
        >
        & { account?: Maybe<Pick<
            TransactionSourceAccount,
            | 'sourceAccountId'
            | 'externalName'
            | 'mask'
            | 'externalOwnerName'
            | 'externalOfficialName'
          >> }
      )> }
    )>,
    splitCategory?: Maybe<(
      Pick<
        Category,
        | 'id'
        | 'name'
        | 'description'
        | 'displayKey'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'displayNumber'
        | 'active'
        | 'categoryState'
        | 'productArea'
        | 'synthesized'
      >
      & { ancestors?: Maybe<Array<Pick<
          EntityCategory,
          | 'id'
          | 'name'
          | 'displayKey'
          | 'chartOfAccountsDisplayNumber'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'productArea'
          | 'active'
        >>> }
    )>,
    splitCategoryClassificationProvenance?: Maybe<(
      Pick<
        ClassificationProvenance,
        | 'type'
        | 'changedAt'
        | 'confidenceLevel'
        | 'settingsName'
      >
      & { source?: Maybe<(
        Pick<
          TransactionSource,
          | 'timestamp'
          | 'name'
          | 'iconUrl'
          | 'externalDisplayId'
          | 'type'
        >
        & { account?: Maybe<Pick<
            TransactionSourceAccount,
            | 'sourceAccountId'
            | 'externalName'
            | 'mask'
            | 'externalOwnerName'
            | 'externalOfficialName'
          >> }
      )> }
    )>,
    splitInstitution?: Maybe<Pick<
        TransactionParty,
        | 'id'
        | 'name'
        | 'iconUrl'
        | 'iconObjectName'
        | 'designation'
        | 'roles'
      >>,
    creditCategoryClassificationProvenance?: Maybe<(
      Pick<
        ClassificationProvenance,
        | 'type'
        | 'changedAt'
        | 'confidenceLevel'
        | 'settingsName'
      >
      & { source?: Maybe<(
        Pick<
          TransactionSource,
          | 'timestamp'
          | 'name'
          | 'iconUrl'
          | 'externalDisplayId'
          | 'type'
        >
        & { account?: Maybe<Pick<
            TransactionSourceAccount,
            | 'sourceAccountId'
            | 'externalName'
            | 'mask'
            | 'externalOwnerName'
            | 'externalOfficialName'
          >> }
      )> }
    )>,
    debitCategoryClassificationProvenance?: Maybe<(
      Pick<
        ClassificationProvenance,
        | 'type'
        | 'changedAt'
        | 'confidenceLevel'
        | 'settingsName'
      >
      & { source?: Maybe<(
        Pick<
          TransactionSource,
          | 'timestamp'
          | 'name'
          | 'iconUrl'
          | 'externalDisplayId'
          | 'type'
        >
        & { account?: Maybe<Pick<
            TransactionSourceAccount,
            | 'sourceAccountId'
            | 'externalName'
            | 'mask'
            | 'externalOwnerName'
            | 'externalOfficialName'
          >> }
      )> }
    )>,
    moneyFlow: (
      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
    ),
    runningTotal?: Maybe<(
      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
    )>,
    owner?: Maybe<Pick<
        EntityEmployee,
        | 'id'
        | 'organizationId'
        | 'givenName'
        | 'familyName'
        | 'avatarUrl'
      >>,
    sources: Array<(
      Pick<
        TransactionSource,
        | 'timestamp'
        | 'name'
        | 'iconUrl'
        | 'externalDisplayId'
        | 'type'
      >
      & { account?: Maybe<Pick<
          TransactionSourceAccount,
          | 'sourceAccountId'
          | 'externalName'
          | 'mask'
          | 'externalOwnerName'
          | 'externalOfficialName'
        >> }
    )>,
    creditSources: Array<(
      Pick<
        TransactionSource,
        | 'timestamp'
        | 'name'
        | 'iconUrl'
        | 'externalDisplayId'
        | 'type'
      >
      & { account?: Maybe<Pick<
          TransactionSourceAccount,
          | 'sourceAccountId'
          | 'externalName'
          | 'mask'
          | 'externalOwnerName'
          | 'externalOfficialName'
        >> }
    )>,
    debitSources: Array<(
      Pick<
        TransactionSource,
        | 'timestamp'
        | 'name'
        | 'iconUrl'
        | 'externalDisplayId'
        | 'type'
      >
      & { account?: Maybe<Pick<
          TransactionSourceAccount,
          | 'sourceAccountId'
          | 'externalName'
          | 'mask'
          | 'externalOwnerName'
          | 'externalOfficialName'
        >> }
    )>,
    invoiceLineItem?: Maybe<{ value:
        | (
          Pick<
            TransactionDiscountLineItem,
            | 'name'
            | 'description'
            | 'variablePercentage'
            | 'appliesToTransactionFactId'
          >
          & {
            fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            discount?: Maybe<(
              Pick<
                TransactionInvoiceLineItemDiscount,
                | 'discountId'
                | 'name'
                | 'description'
                | 'variablePercentage'
              >
              & { fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
            )>,
          }
        )
        | (
          Pick<TransactionProductLineItem, 'name' | 'description' | 'quantity'>
          & {
            unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            product?: Maybe<(
              Pick<TransactionInvoiceLineItemProduct, 'productId' | 'name' | 'description'>
              & {
                unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                category?: Maybe<(
                  Pick<
                    Category,
                    | 'id'
                    | 'name'
                    | 'description'
                    | 'displayKey'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'displayNumber'
                    | 'active'
                    | 'categoryState'
                    | 'productArea'
                    | 'synthesized'
                  >
                  & { ancestors?: Maybe<Array<Pick<
                      EntityCategory,
                      | 'id'
                      | 'name'
                      | 'displayKey'
                      | 'chartOfAccountsDisplayNumber'
                      | 'type'
                      | 'subtype'
                      | 'parentCategoryId'
                      | 'productArea'
                      | 'active'
                    >>> }
                )>,
                department?: Maybe<(
                  { __typename: 'EntityDepartment' }
                  & Pick<
                    EntityDepartment,
                    | 'id'
                    | 'name'
                    | 'parentId'
                    | 'active'
                  >
                )>,
                location?: Maybe<(
                  { __typename: 'EntityLocation' }
                  & Pick<
                    EntityLocation,
                    | 'id'
                    | 'name'
                    | 'parentId'
                    | 'active'
                  >
                )>,
              }
            )>,
          }
        )
       }>,
    schedule?: Maybe<(
      { __typename: 'EntitySchedule' }
      & Pick<
        EntitySchedule,
        | 'id'
        | 'name'
        | 'scheduleNumber'
        | 'scheduleType'
        | 'scheduleTemplateId'
        | 'categoryId'
        | 'relatedCategoryId'
        | 'partyId'
        | 'startDate'
        | 'endDate'
      >
      & { amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
    )>,
    splitSchedule?: Maybe<(
      { __typename: 'EntitySchedule' }
      & Pick<
        EntitySchedule,
        | 'id'
        | 'name'
        | 'scheduleNumber'
        | 'scheduleType'
        | 'scheduleTemplateId'
        | 'categoryId'
        | 'relatedCategoryId'
        | 'partyId'
        | 'startDate'
        | 'endDate'
      >
      & { amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
    )>,
  }
);

export type TransactionLineFieldsFragment = (
  Pick<TransactionLine, 'entryType'>
  & {
    entry: (
      Pick<TransactionEntry, 'factId' | 'externalLineId' | 'description'>
      & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
    ),
    category: Pick<
        EntityCategory,
        | 'id'
        | 'name'
        | 'displayKey'
        | 'chartOfAccountsDisplayNumber'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'productArea'
        | 'active'
      >,
    categoryClassificationProvenance?: Maybe<(
      Pick<
        ClassificationProvenance,
        | 'type'
        | 'changedAt'
        | 'confidenceLevel'
        | 'settingsName'
      >
      & { source?: Maybe<(
        Pick<
          TransactionSource,
          | 'timestamp'
          | 'name'
          | 'iconUrl'
          | 'externalDisplayId'
          | 'type'
        >
        & { account?: Maybe<Pick<
            TransactionSourceAccount,
            | 'sourceAccountId'
            | 'externalName'
            | 'mask'
            | 'externalOwnerName'
            | 'externalOfficialName'
          >> }
      )> }
    )>,
    party?: Maybe<Pick<
        EntityParty,
        | 'id'
        | 'name'
        | 'iconUrl'
        | 'shortDescription'
        | 'roles'
        | 'designation'
      >>,
    department?: Maybe<(
      { __typename: 'EntityDepartment' }
      & Pick<
        EntityDepartment,
        | 'id'
        | 'name'
        | 'parentId'
        | 'active'
      >
    )>,
    location?: Maybe<(
      { __typename: 'EntityLocation' }
      & Pick<
        EntityLocation,
        | 'id'
        | 'name'
        | 'parentId'
        | 'active'
      >
    )>,
    schedule?: Maybe<(
      { __typename: 'EntitySchedule' }
      & Pick<
        EntitySchedule,
        | 'id'
        | 'name'
        | 'scheduleNumber'
        | 'scheduleType'
        | 'scheduleTemplateId'
        | 'categoryId'
        | 'relatedCategoryId'
        | 'partyId'
        | 'startDate'
        | 'endDate'
      >
      & { amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
    )>,
  }
);

export type TransactionEntryFieldsFragment = (
  Pick<TransactionEntry, 'factId' | 'externalLineId' | 'description'>
  & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
);

export type TransactionPartyFieldsFragment = Pick<
    TransactionParty,
    | 'id'
    | 'name'
    | 'iconUrl'
    | 'iconObjectName'
    | 'designation'
    | 'roles'
  >;

export type TransactionSourceFieldsFragment = (
  Pick<
    TransactionSource,
    | 'timestamp'
    | 'name'
    | 'iconUrl'
    | 'externalDisplayId'
    | 'type'
  >
  & { account?: Maybe<Pick<
      TransactionSourceAccount,
      | 'sourceAccountId'
      | 'externalName'
      | 'mask'
      | 'externalOwnerName'
      | 'externalOfficialName'
    >> }
);

export type TransactionSummaryFieldsFragment = (
  Pick<TransactionSummary, 'isPeriodBookClosed'>
  & {
    period: Pick<
        Period,
        | 'name'
        | 'interval'
        | 'startedAt'
        | 'endedAt'
      >,
    total: (
      Pick<
        PeriodMonetaryValue,
        | 'transactionsCount'
        | 'deltaPrevious'
        | 'deltaYearAgo'
        | 'isFirstOccurrencePeriod'
      >
      & {
        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
        moneyFlow?: Maybe<(
          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        )>,
        current?: Maybe<(
          Pick<SummaryTotal, 'count'>
          & { total: (
            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          ) }
        )>,
        prior?: Maybe<(
          Pick<SummaryTotal, 'count'>
          & { total: (
            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          ) }
        )>,
      }
    ),
  }
);

export type TransactionViewDetailFieldsFragment = (
  Pick<
    TransactionViewDetail,
    | 'id'
    | 'factId'
    | 'occurredAt'
    | 'externalCreatedAt'
    | 'externalId'
    | 'externalDisplayId'
    | 'quickbooksAppName'
    | 'name'
    | 'description'
    | 'recordType'
  >
  & {
    creditAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
    debitAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
    creditCategoryHierarchy: Array<(
      Pick<
        Category,
        | 'id'
        | 'name'
        | 'description'
        | 'displayKey'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'displayNumber'
        | 'active'
        | 'categoryState'
        | 'productArea'
        | 'synthesized'
      >
      & { ancestors?: Maybe<Array<Pick<
          EntityCategory,
          | 'id'
          | 'name'
          | 'displayKey'
          | 'chartOfAccountsDisplayNumber'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'productArea'
          | 'active'
        >>> }
    )>,
    debitCategoryHierarchy: Array<(
      Pick<
        Category,
        | 'id'
        | 'name'
        | 'description'
        | 'displayKey'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'displayNumber'
        | 'active'
        | 'categoryState'
        | 'productArea'
        | 'synthesized'
      >
      & { ancestors?: Maybe<Array<Pick<
          EntityCategory,
          | 'id'
          | 'name'
          | 'displayKey'
          | 'chartOfAccountsDisplayNumber'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'productArea'
          | 'active'
        >>> }
    )>,
    entryLines: Array<(
      Pick<
        TransactionEntryLine,
        | 'lineId'
        | 'factId'
        | 'name'
        | 'description'
        | 'isCredit'
        | 'highlighted'
      >
      & {
        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
        category: (
          Pick<
            Category,
            | 'id'
            | 'name'
            | 'description'
            | 'displayKey'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'displayNumber'
            | 'active'
            | 'categoryState'
            | 'productArea'
            | 'synthesized'
          >
          & { ancestors?: Maybe<Array<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>> }
        ),
        categoryClassificationProvenance?: Maybe<(
          Pick<
            ClassificationProvenance,
            | 'type'
            | 'changedAt'
            | 'confidenceLevel'
            | 'settingsName'
          >
          & { source?: Maybe<(
            Pick<
              TransactionSource,
              | 'timestamp'
              | 'name'
              | 'iconUrl'
              | 'externalDisplayId'
              | 'type'
            >
            & { account?: Maybe<Pick<
                TransactionSourceAccount,
                | 'sourceAccountId'
                | 'externalName'
                | 'mask'
                | 'externalOwnerName'
                | 'externalOfficialName'
              >> }
          )> }
        )>,
      }
    )>,
    party?: Maybe<Pick<
        TransactionParty,
        | 'id'
        | 'name'
        | 'iconUrl'
        | 'iconObjectName'
        | 'designation'
        | 'roles'
      >>,
    institution: Pick<
        Institution,
        | 'id'
        | 'name'
        | 'url'
        | 'routingNumber'
        | 'iconUrl'
        | 'partyId'
        | 'createdAt'
      >,
    sourceAccount?: Maybe<Pick<
        SourceAccount,
        | 'id'
        | 'externalId'
        | 'externalName'
        | 'externalOwnerName'
        | 'externalOfficialName'
        | 'externalType'
        | 'externalSubtype'
        | 'mask'
        | 'status'
        | 'ownerEmployeeId'
      >>,
  }
);

export type UserFieldsFragment = (
  Pick<
    User,
    | 'id'
    | 'givenName'
    | 'familyName'
    | 'primaryEmailAddress'
    | 'passwordSet'
    | 'avatarUrl'
    | 'createdAt'
    | 'lastActivityAt'
  >
  & {
    employments?: Maybe<Array<(
      Pick<OrganizationEmployment, 'employeeId'>
      & {
        role: Pick<Role, 'id'>,
        organization: Pick<
            Organization,
            | 'id'
            | 'slug'
            | 'name'
            | 'iconUrl'
            | 'websiteUrl'
            | 'kind'
          >,
        legalEntityRoles?: Maybe<Array<(
          Pick<EmployeeLegalEntityRole, 'legalEntityId'>
          & { role?: Maybe<Pick<Role, 'id'>> }
        )>>,
      }
    )>>,
    identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
  }
);

export type UserInfoFieldsFragment = Pick<UserInfo, 'givenName' | 'familyName' | 'emailAddress'>;

export type ViewIdentifierFieldsFragment = Pick<
    ViewIdentifier,
    | 'legalEntityId'
    | 'viewVersion'
    | 'mutationVersion'
    | 'viewType'
  >;

export type WorkItemFieldsFragment = (
  Pick<
    WorkItem,
    | 'legalEntityId'
    | 'workItemId'
    | 'time'
    | 'itemType'
    | 'itemState'
    | 'ledgerType'
    | 'createdAt'
    | 'updatedBy'
    | 'updatedAt'
    | 'actionable'
    | 'reviewState'
  >
  & {
    transactions: Array<(
      Pick<
        WorkItemTransaction,
        | 'externalTransactionId'
        | 'externalTransactionLineId'
        | 'supportType'
        | 'displayPartyRole'
        | 'displayEntry'
        | 'description'
        | 'name'
        | 'occurredAt'
        | 'dataSourceId'
        | 'quickbooksAppName'
        | 'ledgerTransactionId'
      >
      & {
        displayCategory?: Maybe<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>,
        splitCategory?: Maybe<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>,
        party?: Maybe<Pick<
            EntityParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'shortDescription'
            | 'roles'
            | 'designation'
          >>,
        creditValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
        debitValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
        displayValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
        moneyFlow?: Maybe<(
          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        )>,
      }
    )>,
    review?: Maybe<(
      Pick<WorkItemReview, 'createdAt' | 'updatedAt' | 'subject'>
      & { creator: Pick<
          EntityUser,
          | 'id'
          | 'givenName'
          | 'familyName'
          | 'emailAddress'
          | 'avatarUrl'
        > }
    )>,
    generatedQuestions: Array<Pick<WorkItemGeneratedQuestion, 'question' | 'contextType' | 'active'>>,
    pushes: Array<Pick<
        WorkItemPush,
        | 'field'
        | 'pushState'
        | 'errorType'
        | 'updatedAt'
      >>,
  }
);

export type WorkItemGeneratedQuestionFieldsFragment = Pick<WorkItemGeneratedQuestion, 'question' | 'contextType' | 'active'>;

export type WorkItemPushFieldsFragment = Pick<
    WorkItemPush,
    | 'field'
    | 'pushState'
    | 'errorType'
    | 'updatedAt'
  >;

export type WorkItemReviewFieldsFragment = (
  Pick<WorkItemReview, 'createdAt' | 'updatedAt' | 'subject'>
  & { creator: Pick<
      EntityUser,
      | 'id'
      | 'givenName'
      | 'familyName'
      | 'emailAddress'
      | 'avatarUrl'
    > }
);

export type WorkItemSummaryFieldsFragment = (
  Pick<WorkItemSummary, 'count'>
  & { period: Pick<
      Period,
      | 'name'
      | 'interval'
      | 'startedAt'
      | 'endedAt'
    > }
);

export type WorkItemTransactionFieldsFragment = (
  Pick<
    WorkItemTransaction,
    | 'externalTransactionId'
    | 'externalTransactionLineId'
    | 'supportType'
    | 'displayPartyRole'
    | 'displayEntry'
    | 'description'
    | 'name'
    | 'occurredAt'
    | 'dataSourceId'
    | 'quickbooksAppName'
    | 'ledgerTransactionId'
  >
  & {
    displayCategory?: Maybe<Pick<
        EntityCategory,
        | 'id'
        | 'name'
        | 'displayKey'
        | 'chartOfAccountsDisplayNumber'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'productArea'
        | 'active'
      >>,
    splitCategory?: Maybe<Pick<
        EntityCategory,
        | 'id'
        | 'name'
        | 'displayKey'
        | 'chartOfAccountsDisplayNumber'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'productArea'
        | 'active'
      >>,
    party?: Maybe<Pick<
        EntityParty,
        | 'id'
        | 'name'
        | 'iconUrl'
        | 'shortDescription'
        | 'roles'
        | 'designation'
      >>,
    creditValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
    debitValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
    displayValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
    moneyFlow?: Maybe<(
      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
    )>,
  }
);

export type ActivityObjectIdentifierFieldsFragment = Pick<ActivityObjectIdentifier, 'kind' | 'id' | 'context'>;

export type BillAccessFieldsFragment = Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>;

export type EntityBillFieldsFragment = (
  Pick<
    EntityBill,
    | 'id'
    | 'billStatus'
    | 'vendorName'
    | 'billDescription'
  >
  & {
    totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
    dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
    format: (
      Pick<Format, 'id' | 'formatClass'>
      & { segments: Array<Pick<
          Segment,
          | 'collectionId'
          | 'fileId'
          | 'sequence'
          | 'token'
        >> }
    ),
    approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
  }
);

export type EntityCategoryFieldsFragment = Pick<
    EntityCategory,
    | 'id'
    | 'name'
    | 'displayKey'
    | 'chartOfAccountsDisplayNumber'
    | 'type'
    | 'subtype'
    | 'parentCategoryId'
    | 'productArea'
    | 'active'
  >;

export type EntityCommentFieldsFragment = Pick<
    EntityComment,
    | 'id'
    | 'authorId'
    | 'text'
    | 'timestamp'
  >;

export type EntityConnectionFieldsFragment = Pick<EntityConnection, 'id' | 'connectorId' | 'dataSourceId'>;

export type EntityDataSourceFieldsFragment = Pick<
    EntityDataSource,
    | 'id'
    | 'name'
    | 'url'
    | 'iconUrl'
  >;

export type EntityDepartmentFieldsFragment = (
  { __typename: 'EntityDepartment' }
  & Pick<
    EntityDepartment,
    | 'id'
    | 'name'
    | 'parentId'
    | 'active'
  >
);

export type EntityEmployeeFieldsFragment = Pick<
    EntityEmployee,
    | 'id'
    | 'organizationId'
    | 'givenName'
    | 'familyName'
    | 'avatarUrl'
  >;

export type EntityIdentityVerificationFieldsFragment = Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>;

export type EntityInstitutionFieldsFragment = Pick<EntityInstitution, 'id' | 'name' | 'iconUrl'>;

export type EntityInvoiceCustomerFieldsFragment = (
  Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
  & { party: Pick<
      EntityParty,
      | 'id'
      | 'name'
      | 'iconUrl'
      | 'shortDescription'
      | 'roles'
      | 'designation'
    > }
);

export type EntityInvoiceFieldsFragment = (
  Pick<
    EntityInvoice,
    | 'id'
    | 'externalDisplayId'
    | 'createdAt'
    | 'dueAt'
  >
  & {
    amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
    customer: (
      Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
      & { party: Pick<
          EntityParty,
          | 'id'
          | 'name'
          | 'iconUrl'
          | 'shortDescription'
          | 'roles'
          | 'designation'
        > }
    ),
  }
);

export type EntityLedgerTransactionFieldsFragment = (
  Pick<
    EntityLedgerTransaction,
    | 'id'
    | 'timestamp'
    | 'factIds'
    | 'name'
    | 'referenceNumber'
  >
  & {
    totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
    parties: Array<Pick<
        EntityParty,
        | 'id'
        | 'name'
        | 'iconUrl'
        | 'shortDescription'
        | 'roles'
        | 'designation'
      >>,
  }
);

export type EntityLegalEntityFieldsFragment = Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>;

export type EntityLocationFieldsFragment = (
  { __typename: 'EntityLocation' }
  & Pick<
    EntityLocation,
    | 'id'
    | 'name'
    | 'parentId'
    | 'active'
  >
);

export type EntityMonetaryValueFieldsFragment = Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>;

export type EntityOrganizationFieldsFragment = Pick<
    EntityOrganization,
    | 'id'
    | 'name'
    | 'slug'
    | 'iconUrl'
  >;

export type EntityPartyFieldsFragment = Pick<
    EntityParty,
    | 'id'
    | 'name'
    | 'iconUrl'
    | 'shortDescription'
    | 'roles'
    | 'designation'
  >;

export type EntityReconciliationFieldsFragment = (
  { __typename: 'EntityReconciliation' }
  & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
  & {
    startDate: Pick<Date, 'year' | 'month' | 'day'>,
    endDate: Pick<Date, 'year' | 'month' | 'day'>,
  }
);

export type EntityReportFieldsFragment = (
  Pick<
    EntityReport,
    | 'id'
    | 'title'
    | 'authorId'
    | 'mimeType'
    | 'createdAt'
  >
  & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
);

export type EntityReportPackageFieldsFragment = (
  Pick<
    EntityReportPackage,
    | 'id'
    | 'title'
    | 'authorId'
    | 'interval'
    | 'periodStartedAt'
    | 'periodEndedAt'
    | 'createdAt'
    | 'updatedAt'
    | 'coverUrl'
  >
  & { documents: Array<Pick<
      SharedReportDocumentMetadata,
      | 'id'
      | 'documentObjectId'
      | 'documentObjectVersionId'
      | 'title'
      | 'mimeType'
    >> }
);

export type SharedReportDocumentMetadataFieldsFragment = Pick<
    SharedReportDocumentMetadata,
    | 'id'
    | 'documentObjectId'
    | 'documentObjectVersionId'
    | 'title'
    | 'mimeType'
  >;

export type EntityScheduleFieldsFragment = (
  { __typename: 'EntitySchedule' }
  & Pick<
    EntitySchedule,
    | 'id'
    | 'name'
    | 'scheduleNumber'
    | 'scheduleType'
    | 'scheduleTemplateId'
    | 'categoryId'
    | 'relatedCategoryId'
    | 'partyId'
    | 'startDate'
    | 'endDate'
  >
  & { amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
);

export type EntityThreadFieldsFragment = Pick<EntityThread, 'id' | 'resolvedAt'>;

export type EntityTransactionFieldsFragment = (
  Pick<
    EntityTransaction,
    | 'viewId'
    | 'factId'
    | 'timestamp'
    | 'description'
    | 'externalId'
    | 'displayEntry'
  >
  & {
    moneyFlow: (
      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
    ),
    party?: Maybe<Pick<
        EntityParty,
        | 'id'
        | 'name'
        | 'iconUrl'
        | 'shortDescription'
        | 'roles'
        | 'designation'
      >>,
    displayCategory: Pick<
        EntityCategory,
        | 'id'
        | 'name'
        | 'displayKey'
        | 'chartOfAccountsDisplayNumber'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'productArea'
        | 'active'
      >,
    splitCategory?: Maybe<Pick<
        EntityCategory,
        | 'id'
        | 'name'
        | 'displayKey'
        | 'chartOfAccountsDisplayNumber'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'productArea'
        | 'active'
      >>,
  }
);

export type EntityUserFieldsFragment = Pick<
    EntityUser,
    | 'id'
    | 'givenName'
    | 'familyName'
    | 'emailAddress'
    | 'avatarUrl'
  >;

export type EntityWorkItemFieldsFragment = (
  Pick<
    EntityWorkItem,
    | 'id'
    | 'time'
    | 'workItemState'
    | 'workItemType'
    | 'reviewCreatedById'
    | 'reviewState'
    | 'ledgerType'
  >
  & { objectTransaction: (
    Pick<
      EntityTransaction,
      | 'viewId'
      | 'factId'
      | 'timestamp'
      | 'description'
      | 'externalId'
      | 'displayEntry'
    >
    & {
      moneyFlow: (
        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
      ),
      party?: Maybe<Pick<
          EntityParty,
          | 'id'
          | 'name'
          | 'iconUrl'
          | 'shortDescription'
          | 'roles'
          | 'designation'
        >>,
      displayCategory: Pick<
          EntityCategory,
          | 'id'
          | 'name'
          | 'displayKey'
          | 'chartOfAccountsDisplayNumber'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'productArea'
          | 'active'
        >,
      splitCategory?: Maybe<Pick<
          EntityCategory,
          | 'id'
          | 'name'
          | 'displayKey'
          | 'chartOfAccountsDisplayNumber'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'productArea'
          | 'active'
        >>,
    }
  ) }
);

export type ObjectEntitiesFieldsFragment = (
  { __typename: 'ObjectEntities' }
  & {
    users?: Maybe<Array<Pick<
        EntityUser,
        | 'id'
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      >>>,
    transactions?: Maybe<Array<(
      Pick<
        EntityTransaction,
        | 'viewId'
        | 'factId'
        | 'timestamp'
        | 'description'
        | 'externalId'
        | 'displayEntry'
      >
      & {
        moneyFlow: (
          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        ),
        party?: Maybe<Pick<
            EntityParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'shortDescription'
            | 'roles'
            | 'designation'
          >>,
        displayCategory: Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >,
        splitCategory?: Maybe<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>,
      }
    )>>,
    comments?: Maybe<Array<Pick<
        EntityComment,
        | 'id'
        | 'authorId'
        | 'text'
        | 'timestamp'
      >>>,
    reports?: Maybe<Array<(
      Pick<
        EntityReport,
        | 'id'
        | 'title'
        | 'authorId'
        | 'mimeType'
        | 'createdAt'
      >
      & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
    )>>,
    reportPackages?: Maybe<Array<(
      Pick<
        EntityReportPackage,
        | 'id'
        | 'title'
        | 'authorId'
        | 'interval'
        | 'periodStartedAt'
        | 'periodEndedAt'
        | 'createdAt'
        | 'updatedAt'
        | 'coverUrl'
      >
      & { documents: Array<Pick<
          SharedReportDocumentMetadata,
          | 'id'
          | 'documentObjectId'
          | 'documentObjectVersionId'
          | 'title'
          | 'mimeType'
        >> }
    )>>,
    parties?: Maybe<Array<Pick<
        EntityParty,
        | 'id'
        | 'name'
        | 'iconUrl'
        | 'shortDescription'
        | 'roles'
        | 'designation'
      >>>,
    datasources?: Maybe<Array<Pick<
        EntityDataSource,
        | 'id'
        | 'name'
        | 'url'
        | 'iconUrl'
      >>>,
    categories?: Maybe<Array<Pick<
        EntityCategory,
        | 'id'
        | 'name'
        | 'displayKey'
        | 'chartOfAccountsDisplayNumber'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'productArea'
        | 'active'
      >>>,
    threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
    legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
    workItems?: Maybe<Array<(
      Pick<
        EntityWorkItem,
        | 'id'
        | 'time'
        | 'workItemState'
        | 'workItemType'
        | 'reviewCreatedById'
        | 'reviewState'
        | 'ledgerType'
      >
      & { objectTransaction: (
        Pick<
          EntityTransaction,
          | 'viewId'
          | 'factId'
          | 'timestamp'
          | 'description'
          | 'externalId'
          | 'displayEntry'
        >
        & {
          moneyFlow: (
            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          ),
          party?: Maybe<Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >>,
          displayCategory: Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >,
          splitCategory?: Maybe<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>,
        }
      ) }
    )>>,
    invoices?: Maybe<Array<(
      Pick<
        EntityInvoice,
        | 'id'
        | 'externalDisplayId'
        | 'createdAt'
        | 'dueAt'
      >
      & {
        amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
        customer: (
          Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
          & { party: Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            > }
        ),
      }
    )>>,
    bills?: Maybe<Array<(
      Pick<
        EntityBill,
        | 'id'
        | 'billStatus'
        | 'vendorName'
        | 'billDescription'
      >
      & {
        totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
        dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
        format: (
          Pick<Format, 'id' | 'formatClass'>
          & { segments: Array<Pick<
              Segment,
              | 'collectionId'
              | 'fileId'
              | 'sequence'
              | 'token'
            >> }
        ),
        approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
      }
    )>>,
    identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
    departments?: Maybe<Array<(
      { __typename: 'EntityDepartment' }
      & Pick<
        EntityDepartment,
        | 'id'
        | 'name'
        | 'parentId'
        | 'active'
      >
    )>>,
    locations?: Maybe<Array<(
      { __typename: 'EntityLocation' }
      & Pick<
        EntityLocation,
        | 'id'
        | 'name'
        | 'parentId'
        | 'active'
      >
    )>>,
    reconciliations?: Maybe<Array<(
      { __typename: 'EntityReconciliation' }
      & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
      & {
        startDate: Pick<Date, 'year' | 'month' | 'day'>,
        endDate: Pick<Date, 'year' | 'month' | 'day'>,
      }
    )>>,
    ledgerTransactions?: Maybe<Array<(
      Pick<
        EntityLedgerTransaction,
        | 'id'
        | 'timestamp'
        | 'factIds'
        | 'name'
        | 'referenceNumber'
      >
      & {
        totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
        parties: Array<Pick<
            EntityParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'shortDescription'
            | 'roles'
            | 'designation'
          >>,
      }
    )>>,
    schedules?: Maybe<Array<(
      { __typename: 'EntitySchedule' }
      & Pick<
        EntitySchedule,
        | 'id'
        | 'name'
        | 'scheduleNumber'
        | 'scheduleType'
        | 'scheduleTemplateId'
        | 'categoryId'
        | 'relatedCategoryId'
        | 'partyId'
        | 'startDate'
        | 'endDate'
      >
      & { amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
    )>>,
  }
);

export type ObjectIdentifierFieldsFragment = Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>;

export type SegmentFieldsFragment = Pick<
    Segment,
    | 'collectionId'
    | 'fileId'
    | 'sequence'
    | 'token'
  >;

export const AspectFieldsFragmentDoc = gql`
    fragment AspectFields on Aspect {
  id
  code
  name
  description
  defaultStatus
  admin
  oneWay
  propagation
  visibility
  createdAt
  updatedAt
}
    `;
export const AspectRequestFieldsFragmentDoc = gql`
    fragment AspectRequestFields on AspectRequest {
  id
  legalEntityId
  legalEntityName
  createdAt
  aspect {
    ...AspectFields
  }
}
    ${AspectFieldsFragmentDoc}`;
export const AspectStatusFieldsFragmentDoc = gql`
    fragment AspectStatusFields on AspectStatus {
  aspect {
    ...AspectFields
  }
  status
  source
  updatedAt
}
    ${AspectFieldsFragmentDoc}`;
export const LegalEntityAspectStatusFieldsFragmentDoc = gql`
    fragment LegalEntityAspectStatusFields on LegalEntityAspectStatus {
  legalEntityId
  legalEntityName
  statuses {
    ...AspectStatusFields
  }
}
    ${AspectStatusFieldsFragmentDoc}`;
export const BillingProductFieldsFragmentDoc = gql`
    fragment BillingProductFields on BillingProduct {
  id
  name
  displayName
  description
  callout
  trialPeriodDays
  availability
  listing
  billable
}
    `;
export const AdminBillingProductFieldsFragmentDoc = gql`
    fragment AdminBillingProductFields on AdminBillingProduct {
  product {
    ...BillingProductFields
  }
  isOrganizationEnabled
}
    ${BillingProductFieldsFragmentDoc}`;
export const MonetaryValueFieldsFragmentDoc = gql`
    fragment MonetaryValueFields on MonetaryValue {
  iso4217CurrencyCode
  currencyMultiplier
  amount
}
    `;
export const BillingPriceFieldsFragmentDoc = gql`
    fragment BillingPriceFields on BillingPrice {
  id
  amount {
    ...MonetaryValueFields
  }
  interval
  intervalCount
}
    ${MonetaryValueFieldsFragmentDoc}`;
export const BillingLegalEntityLimitFieldsFragmentDoc = gql`
    fragment BillingLegalEntityLimitFields on BillingLegalEntityLimit {
  id
  minLegalEntityLimit
  maxLegalEntityLimit
}
    `;
export const ConnectorFieldsFragmentDoc = gql`
    fragment ConnectorFields on Connector {
  id
  name
  tagline
  description
  category
  iconObjectName
  className
  canInstall
  connectorProperties {
    __typename
    ... on StripeConnectorProperties {
      __typename
      appLinkURL
    }
    ... on PlaidConnectorProperties {
      __typename
      empty
    }
    ... on RampConnectorProperties {
      __typename
      authorizationURL
    }
    ... on GustoConnectorProperties {
      __typename
      authorizationURL
    }
    ... on BillConnectorProperties {
      __typename
      empty
    }
    ... on FinchConnectorProperties {
      __typename
      empty
    }
    ... on AppConnectorProperties {
      __typename
      organizationId
      visibility
      homepageURL
      supportEmail
      developerEmail
      privacyPolicyURL
      termsOfServiceURL
      scopes
      redirectUris
      installUri
    }
    ... on EmptyConnectorProperties {
      __typename
      empty
    }
  }
}
    `;
export const PartyFieldsFragmentDoc = gql`
    fragment PartyFields on Party {
  id
  legalEntityId
  name
  url
  supportUrl
  supportEmail
  supportPhone
  twitterUrl
  facebookUrl
  instagramUrl
  yelpUrl
  iconUrl
  shortDescription
  designation
}
    `;
export const ProductInstitutionFieldsFragmentDoc = gql`
    fragment ProductInstitutionFields on ProductInstitution {
  id
  name
  party {
    ...PartyFields
  }
  products
  routingNumber
}
    ${PartyFieldsFragmentDoc}`;
export const AdminConnectionTemplateFieldsFragmentDoc = gql`
    fragment AdminConnectionTemplateFields on AdminConnectionTemplate {
  connector {
    ...ConnectorFields
  }
  institution {
    ...ProductInstitutionFields
  }
  externalId
}
    ${ConnectorFieldsFragmentDoc}
${ProductInstitutionFieldsFragmentDoc}`;
export const AdminConnectorFieldsFragmentDoc = gql`
    fragment AdminConnectorFields on AdminConnector {
  installCount
  connector {
    ...ConnectorFields
  }
}
    ${ConnectorFieldsFragmentDoc}`;
export const AdminConnectionEventFieldsFragmentDoc = gql`
    fragment AdminConnectionEventFields on AdminConnectionEvent {
  id
  connectionEventRef
  source
  status
  message
  failureReason
  affectedCount
  oldestSeen
  newestSeen
  dataUpdatedAt
  dataStatus
  userId
  superUserId
  createdAt
}
    `;
export const AdminConnectionFieldsFragmentDoc = gql`
    fragment AdminConnectionFields on AdminConnection {
  id
  sourceName
  deletedAt
  legalEntityId
  connectorId
  dataSourceId
  createdAt
  status
  connectorClassName
  externalId
  consentedScopes
  supportedScopes
  sync {
    lastSuccessAt
    lastEventAt
    status
  }
}
    `;
export const AdminConnectionListFieldsFragmentDoc = gql`
    fragment AdminConnectionListFields on AdminConnectionList {
  connections {
    ...AdminConnectionFields
  }
}
    ${AdminConnectionFieldsFragmentDoc}`;
export const DenormalizedViewStatusFieldsFragmentDoc = gql`
    fragment DenormalizedViewStatusFields on DenormalizedViewStatus {
  legalEntityId
  viewType
  activeViewCreatedAt
  ongoingViewStartedAt
}
    `;
export const BooksClosedFactFieldsFragmentDoc = gql`
    fragment BooksClosedFactFields on BooksClosedFact {
  legalEntityId
  dataSourceId
  userId
  booksClosedDate
  createdAt
}
    `;
export const DataHealthFieldsFragmentDoc = gql`
    fragment DataHealthFields on DataHealthStatus {
  anyDataSourceRequiresEngineering
  allDataSourcesLinked
  hasPlaidDataSource
  allDataSourcesHaveTransactions
}
    `;
export const JobOwnerFieldsFragmentDoc = gql`
    fragment JobOwnerFields on JobOwner {
  dataSourceId
  legalEntityId
}
    `;
export const JobMetadataFieldsFragmentDoc = gql`
    fragment JobMetadataFields on JobMetadata {
  consumer
  requestObjectId
  userId
}
    `;
export const ValidationHealthStatusFieldsFragmentDoc = gql`
    fragment ValidationHealthStatusFields on ValidationHealthStatus {
  balanceSheetConsistent
  cashAspectHealth {
    closedViewDataStatus
    importedDataStatus
    overallDataStatus
  }
  expenseAspectHealth {
    closedViewDataStatus
    importedDataStatus
    overallDataStatus
  }
  revenueAspectHealth {
    closedViewDataStatus
    importedDataStatus
    overallDataStatus
  }
  startedAt
}
    `;
export const ValidationHistoryFieldsFragmentDoc = gql`
    fragment ValidationHistoryFields on ValidationHistory {
  validationHistory {
    ...ValidationHealthStatusFields
  }
}
    ${ValidationHealthStatusFieldsFragmentDoc}`;
export const RoleFieldsFragmentDoc = gql`
    fragment RoleFields on Role {
  id
}
    `;
export const OrganizationFieldsFragmentDoc = gql`
    fragment OrganizationFields on Organization {
  id
  slug
  name
  iconUrl
  websiteUrl
  kind
}
    `;
export const IdentityFieldsFragmentDoc = gql`
    fragment IdentityFields on Identity {
  identifier
  provider
  domain
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on User {
  id
  givenName
  familyName
  primaryEmailAddress
  passwordSet
  avatarUrl
  createdAt
  lastActivityAt
  employments {
    employeeId
    role {
      ...RoleFields
    }
    organization {
      ...OrganizationFields
    }
    legalEntityRoles {
      legalEntityId
      role {
        id
      }
    }
  }
  identities {
    ...IdentityFields
  }
}
    ${RoleFieldsFragmentDoc}
${OrganizationFieldsFragmentDoc}
${IdentityFieldsFragmentDoc}`;
export const InvitationFieldsFragmentDoc = gql`
    fragment InvitationFields on Invitation {
  id
  invitationType
  recipient {
    givenName
    familyName
    emailAddress
    avatarUrl
  }
  sender {
    givenName
    familyName
    emailAddress
    avatarUrl
  }
  organization {
    ...OrganizationFields
  }
  role {
    ...RoleFields
  }
  status
  service
  organizationTemplateId
  createdAt
  updatedAt
  notifiedAt
}
    ${OrganizationFieldsFragmentDoc}
${RoleFieldsFragmentDoc}`;
export const EmployeeFieldsFragmentDoc = gql`
    fragment EmployeeFields on Employee {
  id
  organizationId
  givenName
  familyName
  avatarUrl
  emailAddress
  jobTitle
  lastActivityAt
  status
  role {
    ...RoleFields
  }
  defaultEntityRole {
    ...RoleFields
  }
  user {
    ...UserFields
  }
  invitation {
    ...InvitationFields
  }
  hiddenAt
  legalEntityRoles {
    legalEntityId
    role {
      ...RoleFields
    }
  }
}
    ${RoleFieldsFragmentDoc}
${UserFieldsFragmentDoc}
${InvitationFieldsFragmentDoc}`;
export const AdminEmployeeFieldsFragmentDoc = gql`
    fragment AdminEmployeeFields on AdminEmployee {
  employee {
    ...EmployeeFields
  }
  provider
  externalId
  origin
  createdAt
}
    ${EmployeeFieldsFragmentDoc}`;
export const InstitutionFieldsFragmentDoc = gql`
    fragment InstitutionFields on Institution {
  id
  name
  url
  routingNumber
  iconUrl
  partyId
  createdAt
}
    `;
export const AdminInstitutionFieldsFragmentDoc = gql`
    fragment AdminInstitutionFields on AdminInstitution {
  id
  institution {
    ...InstitutionFields
  }
  party {
    ...PartyFields
  }
  products
}
    ${InstitutionFieldsFragmentDoc}
${PartyFieldsFragmentDoc}`;
export const SuperuserRoleFieldsFragmentDoc = gql`
    fragment SuperuserRoleFields on SuperuserRole {
  identifier
  displayName
  description
}
    `;
export const SuperuserFieldsFragmentDoc = gql`
    fragment SuperuserFields on Superuser {
  id
  givenName
  familyName
  emailAddress
  avatarUrl
  createdAt
  lastLoginAt
  roles {
    ...SuperuserRoleFields
  }
}
    ${SuperuserRoleFieldsFragmentDoc}`;
export const EmailStatusFieldsFragmentDoc = gql`
    fragment EmailStatusFields on EmailStatus {
  rawStatus
  updatedAt
}
    `;
export const AdminInvitationFieldsFragmentDoc = gql`
    fragment AdminInvitationFields on AdminInvitation {
  invitation {
    ...InvitationFields
    acceptedAt
  }
  senderSuperuser {
    ...SuperuserFields
  }
  emailStatus {
    ...EmailStatusFields
  }
}
    ${InvitationFieldsFragmentDoc}
${SuperuserFieldsFragmentDoc}
${EmailStatusFieldsFragmentDoc}`;
export const PullRequestFieldsFragmentDoc = gql`
    fragment PullRequestFields on PullRequest {
  url
  title
  repo
  number
  branch
  prState
  labels {
    name
    hexColor
  }
  author {
    id
    name
    login
    avatarUrl
  }
}
    `;
export const ObjectMappingHierarchyNodeFieldsFragmentDoc = gql`
    fragment ObjectMappingHierarchyNodeFields on ObjectMappingHierarchyNode {
  factId
  name
  parentId
  active
  transactionCount
  mappedTo
  depth
  fullyQualifiedName
}
    `;
export const AdminGlobalPartyFieldsFragmentDoc = gql`
    fragment AdminGlobalPartyFields on AdminGlobalParty {
  party {
    ...PartyFields
  }
  transactionsCount
  aliases
  prefixes
  lastReviewedAt
}
    ${PartyFieldsFragmentDoc}`;
export const AdminPartyFieldsFragmentDoc = gql`
    fragment AdminPartyFields on AdminParty {
  party {
    ...PartyFields
  }
  transactionsCount
  lastTransactionOccurredAt
}
    ${PartyFieldsFragmentDoc}`;
export const PayrollProviderFieldsFragmentDoc = gql`
    fragment PayrollProviderFields on PayrollProvider {
  legalEntityId
  partyId
  partyName
  payrollProviderType
  rangeStartedAt
  rangeEndedAt
}
    `;
export const PipelineDefinitionFieldsFragmentDoc = gql`
    fragment PipelineDefinitionFields on PipelineDefinition {
  pipelineName
  isActive
  updatedAt
}
    `;
export const ClusteredPrefixFieldsFragmentDoc = gql`
    fragment ClusteredPrefixFields on ClusteredPrefix {
  prefix
  transactionCount
}
    `;
export const PrefixMappingFieldsFragmentDoc = gql`
    fragment PrefixMappingFields on PrefixMapping {
  prefix
  partyId
}
    `;
export const PrefixMappingSummaryFieldsFragmentDoc = gql`
    fragment PrefixMappingSummaryFields on PrefixMappingSummary {
  prefix
  transactionCount
  party {
    ...PartyFields
  }
}
    ${PartyFieldsFragmentDoc}`;
export const SanitizedDescriptionFieldsFragmentDoc = gql`
    fragment SanitizedDescriptionFields on SanitizedDescription {
  sanitizedDescription
  transactionCount
  exampleTransactionNameAndDescription
}
    `;
export const ViewIdentifierFieldsFragmentDoc = gql`
    fragment ViewIdentifierFields on ViewIdentifier {
  legalEntityId
  viewVersion
  mutationVersion
  viewType
}
    `;
export const ContactFieldsFragmentDoc = gql`
    fragment ContactFields on Contact {
  givenName
  familyName
  emailAddress
  avatarUrl
}
    `;
export const ReportFileMetadataFieldsFragmentDoc = gql`
    fragment ReportFileMetadataFields on ReportFileMetadata {
  id
  fileName
  mimeType
  fileSize
  source
}
    `;
export const ReportGenerationHistoryFieldsFragmentDoc = gql`
    fragment ReportGenerationHistoryFields on ReportGenerationHistory {
  id
  requestId
  reportId
  versionId
  legalEntityId
  authorId
  viewVersion
  kind
  timezone
  periodStartedAt
  periodEndedAt
  generationStartedAt
  generationEndedAt
  error
  createdAt
  updatedAt
}
    `;
export const ReportValidationHistoryFieldsFragmentDoc = gql`
    fragment ReportValidationHistoryFields on ReportValidationHistory {
  reportId
  versionId
  legalEntityId
  validatedAt
  isValid
  errorMessage
  source
}
    `;
export const AdminReportPackageDocumentMetadataFieldsFragmentDoc = gql`
    fragment AdminReportPackageDocumentMetadataFields on AdminReportPackageDocumentMetadata {
  id
  title
  documentObjectId
  documentObjectVersionId
  type
  reportFile {
    ...ReportFileMetadataFields
  }
  status
  generationHistory {
    ...ReportGenerationHistoryFields
  }
  validationHistories {
    ...ReportValidationHistoryFields
  }
  position
}
    ${ReportFileMetadataFieldsFragmentDoc}
${ReportGenerationHistoryFieldsFragmentDoc}
${ReportValidationHistoryFieldsFragmentDoc}`;
export const AdminReportPackageMetadataFieldsFragmentDoc = gql`
    fragment AdminReportPackageMetadataFields on AdminReportPackageMetadata {
  id
  versionId
  title
  status
  viewKey {
    ...ViewIdentifierFields
  }
  author {
    ...ContactFields
  }
  documents {
    ...AdminReportPackageDocumentMetadataFields
  }
  startedAt
  endedAt
  interval
  publishedAsDraft
  createdAt
  updatedAt
}
    ${ViewIdentifierFieldsFragmentDoc}
${ContactFieldsFragmentDoc}
${AdminReportPackageDocumentMetadataFieldsFragmentDoc}`;
export const EntityCategoryFieldsFragmentDoc = gql`
    fragment EntityCategoryFields on EntityCategory {
  id
  name
  displayKey
  chartOfAccountsDisplayNumber
  type
  subtype
  parentCategoryId
  productArea
  active
}
    `;
export const CategoryFieldsFragmentDoc = gql`
    fragment CategoryFields on Category {
  id
  name
  description
  displayKey
  type
  subtype
  parentCategoryId
  displayNumber
  active
  categoryState
  productArea
  synthesized
  ancestors {
    ...EntityCategoryFields
  }
}
    ${EntityCategoryFieldsFragmentDoc}`;
export const ChartOfAccountsFieldsFragmentDoc = gql`
    fragment ChartOfAccountsFields on ChartOfAccounts {
  id
  name
  description
  accountingBasis
  categories {
    ...CategoryFields
  }
}
    ${CategoryFieldsFragmentDoc}`;
export const AdminChartOfAccountsFieldsFragmentDoc = gql`
    fragment AdminChartOfAccountsFields on AdminChartOfAccounts {
  chart {
    ...ChartOfAccountsFields
  }
}
    ${ChartOfAccountsFieldsFragmentDoc}`;
export const TemplateCategoryFieldsFragmentDoc = gql`
    fragment TemplateCategoryFields on TemplateCategory {
  organizationId
  templateId
  categoryId
  parentCategoryId
  name
  description
  type
  subtype
  categoryState
  chartOfAccountsDisplayNumber
  externalAccountType
  externalAccountSubtype
  displayKey
}
    `;
export const AdminChartOfAccountsTemplateFieldsFragmentDoc = gql`
    fragment AdminChartOfAccountsTemplateFields on ChartOfAccountsTemplate {
  organizationId
  templateId
  name
  description
  categories {
    ...TemplateCategoryFields
  }
}
    ${TemplateCategoryFieldsFragmentDoc}`;
export const AdminChartOfAccountsTemplateSummaryFieldsFragmentDoc = gql`
    fragment AdminChartOfAccountsTemplateSummaryFields on ChartOfAccountsTemplateSummary {
  organizationId
  templateId
  name
  description
}
    `;
export const DoppelgangerPermitFieldsFragmentDoc = gql`
    fragment DoppelgangerPermitFields on DoppelgangerPermit {
  id
  user {
    ...UserFields
  }
  expiresAt
  createdAt
}
    ${UserFieldsFragmentDoc}`;
export const AdminDoppelgangerPermitFieldsFragmentDoc = gql`
    fragment AdminDoppelgangerPermitFields on AdminDoppelgangerPermit {
  doppelgangerPermit {
    ...DoppelgangerPermitFields
  }
  authorizer {
    ...SuperuserFields
  }
  justification
  sessionStartedAt
  sessionEndedAt
}
    ${DoppelgangerPermitFieldsFragmentDoc}
${SuperuserFieldsFragmentDoc}`;
export const AddressFieldsFragmentDoc = gql`
    fragment AddressFields on Address {
  street
  streetAdditional
  city
  region
  postalCode
  countryCode
  lat
  long
}
    `;
export const LegalEntityFieldsFragmentDoc = gql`
    fragment LegalEntityFields on LegalEntity {
  id
  slug
  name
  websiteUrl
  industry
  timezone
  fiscalYearStartMonth
  fiscalYearNumberOffset
  status
  organizationId
  address {
    ...AddressFields
  }
  incorporatedOn {
    year
    month
    day
  }
  sensitive
  phoneNumber
  iconUrl
}
    ${AddressFieldsFragmentDoc}`;
export const AdminLegalEntityFieldsFragmentDoc = gql`
    fragment AdminLegalEntityFields on AdminLegalEntity {
  legalEntity {
    ...LegalEntityFields
  }
  createdAt
  userCount
  deletedAt
}
    ${LegalEntityFieldsFragmentDoc}`;
export const AdminOrganizationFieldsFragmentDoc = gql`
    fragment AdminOrganizationFields on AdminOrganization {
  organization {
    ...OrganizationFields
  }
  createdAt
  deletedAt
  userCount
  legalEntities {
    ...AdminLegalEntityFields
  }
  affiliateLegalEntities {
    ...AdminLegalEntityFields
  }
}
    ${OrganizationFieldsFragmentDoc}
${AdminLegalEntityFieldsFragmentDoc}`;
export const AdminScheduleTemplateSummaryFieldsFragmentDoc = gql`
    fragment AdminScheduleTemplateSummaryFields on AdminScheduleTemplateSummary {
  scheduleTemplateId
  name
  description
  type
  displayKey
  organizationId
  createdAt
  updatedAt
  eventCount
  variableCount
  specializationCount
  formulaCount
}
    `;
export const AdminScheduleSpecializationFieldsFragmentDoc = gql`
    fragment AdminScheduleSpecializationFields on AdminScheduleSpecialization {
  specializationId
  scheduleTemplateId
  name
  displayKey
  description
  organizationId
  ownerOrganizationId
  legalEntityId
  createdAt
  updatedAt
}
    `;
export const AdminScheduleVariableDefaultFieldsFragmentDoc = gql`
    fragment AdminScheduleVariableDefaultFields on AdminScheduleVariableDefault {
  source
  stringValue
  intValue
  floatValue
  boolValue
  dateValue
  amountValue {
    amount
    iso4217CurrencyCode
    currencyMultiplier
  }
  intervalValue
  formulaId
  formulaDisplayName
  categoryHint
}
    `;
export const AdminScheduleEventVariableTemplateFieldsFragmentDoc = gql`
    fragment AdminScheduleEventVariableTemplateFields on AdminScheduleEventVariableTemplate {
  variableTemplateId
  variableName
  displayName
  variableType
  required
  ordinal
  displayMode
  applyExpr
  validationExpr
  validationMessage
  specializable
  defaultValue {
    ...AdminScheduleVariableDefaultFields
  }
}
    ${AdminScheduleVariableDefaultFieldsFragmentDoc}`;
export const AdminScheduleFormulaBindingFieldsFragmentDoc = gql`
    fragment AdminScheduleFormulaBindingFields on AdminScheduleFormulaBinding {
  formulaId
  displayName
  ordinal
}
    `;
export const AdminScheduleJournalEntryLineTemplateFieldsFragmentDoc = gql`
    fragment AdminScheduleJournalEntryLineTemplateFields on AdminScheduleJournalEntryLineTemplate {
  lineTemplateId
  ordinal
  description
  entryType
  entryTypeExpression
  categoryVariable
  amountVariable
  skipCondition
}
    `;
export const AdminScheduleJournalEntryTemplateFieldsFragmentDoc = gql`
    fragment AdminScheduleJournalEntryTemplateFields on AdminScheduleJournalEntryTemplate {
  journalEntryTemplateId
  memo
  skipCondition
  lines {
    ...AdminScheduleJournalEntryLineTemplateFields
  }
}
    ${AdminScheduleJournalEntryLineTemplateFieldsFragmentDoc}`;
export const AdminScheduleEventTemplateFieldsFragmentDoc = gql`
    fragment AdminScheduleEventTemplateFields on AdminScheduleEventTemplate {
  eventTemplateId
  name
  displayName
  description
  ordinal
  displayKey
  isInstantiating
  isTerminating
  isSingleton
  inCreateFlow
  generatorType
  generatedEventTemplateId
  skipConditionName
  skipConditionExpr
  dateSource
  variables {
    ...AdminScheduleEventVariableTemplateFields
  }
  supportedFormulas {
    ...AdminScheduleFormulaBindingFields
  }
  journalEntry {
    ...AdminScheduleJournalEntryTemplateFields
  }
}
    ${AdminScheduleEventVariableTemplateFieldsFragmentDoc}
${AdminScheduleFormulaBindingFieldsFragmentDoc}
${AdminScheduleJournalEntryTemplateFieldsFragmentDoc}`;
export const AdminScheduleFormulaFieldsFragmentDoc = gql`
    fragment AdminScheduleFormulaFields on AdminScheduleFormula {
  formulaId
  displayName
  expression
}
    `;
export const AdminScheduleTemplateFieldsFragmentDoc = gql`
    fragment AdminScheduleTemplateFields on AdminScheduleTemplate {
  scheduleTemplateId
  name
  description
  type
  displayKey
  organizationId
  createdAt
  updatedAt
  events {
    ...AdminScheduleEventTemplateFields
  }
  formulas {
    ...AdminScheduleFormulaFields
  }
}
    ${AdminScheduleEventTemplateFieldsFragmentDoc}
${AdminScheduleFormulaFieldsFragmentDoc}`;
export const AdminScheduleSpecializationDetailFieldsFragmentDoc = gql`
    fragment AdminScheduleSpecializationDetailFields on AdminScheduleSpecializationDetail {
  specialization {
    ...AdminScheduleSpecializationFields
  }
  template {
    ...AdminScheduleTemplateFields
  }
  overrides {
    eventTemplateId
    variableTemplateId
    value {
      ...AdminScheduleVariableDefaultFields
    }
  }
}
    ${AdminScheduleSpecializationFieldsFragmentDoc}
${AdminScheduleTemplateFieldsFragmentDoc}
${AdminScheduleVariableDefaultFieldsFragmentDoc}`;
export const ChartOfAccountsListEntryFieldsFragmentDoc = gql`
    fragment ChartOfAccountsListEntryFields on ChartOfAccountsListEntry {
  id
  name
  description
  accountingBasis
  legalEntityId
}
    `;
export const AdminCategoryFieldsFragmentDoc = gql`
    fragment AdminCategoryFields on AdminCategory {
  category {
    ...CategoryFields
  }
  externalId
  subtype
  chartOfAccountsDisplayNumber
  externalAccountType
  externalAccountSubtype
  synthesized
}
    ${CategoryFieldsFragmentDoc}`;
export const MappedCategoryFieldsFragmentDoc = gql`
    fragment MappedCategoryFields on MappedCategory {
  fromCategory {
    ...AdminCategoryFields
  }
  toCategory {
    ...AdminCategoryFields
  }
}
    ${AdminCategoryFieldsFragmentDoc}`;
export const MappedChartOfAccountsFieldsFragmentDoc = gql`
    fragment MappedChartOfAccountsFields on MappedChartOfAccounts {
  fromUUID
  toUUID
  name
  description
  legalEntityId
  accountingBasis
  categories {
    ...MappedCategoryFields
  }
}
    ${MappedCategoryFieldsFragmentDoc}`;
export const SignupFieldsFragmentDoc = gql`
    fragment SignupFields on Signup {
  id
  contact {
    ...ContactFields
  }
  status
  statusReason
  location
  industry
  companyName
  companyUrl
  companyLedger
  companyCurrency
  positionTitle
  profileURL
  oAuthEmailAddress
  oAuthService
  persona
}
    ${ContactFieldsFragmentDoc}`;
export const AdminSignupFieldsFragmentDoc = gql`
    fragment AdminSignupFields on AdminSignup {
  signup {
    ...SignupFields
  }
  createdAt
  updatedAt
  timezone
}
    ${SignupFieldsFragmentDoc}`;
export const PeriodFieldsFragmentDoc = gql`
    fragment PeriodFields on Period {
  name
  interval
  startedAt
  endedAt
}
    `;
export const SourceRecordedMatchSummaryEntryFieldsFragmentDoc = gql`
    fragment SourceRecordedMatchSummaryEntryFields on SourceRecordedMatchSummaryEntry {
  period {
    ...PeriodFields
  }
  institution {
    ...InstitutionFields
  }
  total
  matched
  unmatched
  unmatchedAndUncategorized
}
    ${PeriodFieldsFragmentDoc}
${InstitutionFieldsFragmentDoc}`;
export const SourceRecordedMatchSummaryFieldsFragmentDoc = gql`
    fragment SourceRecordedMatchSummaryFields on SourceRecordedMatchSummary {
  entries {
    ...SourceRecordedMatchSummaryEntryFields
  }
}
    ${SourceRecordedMatchSummaryEntryFieldsFragmentDoc}`;
export const QuickBooksConfigFieldsFragmentDoc = gql`
    fragment QuickBooksConfigFields on QuickBooksConfig {
  id
  realmId
  createdAt
  updatedAt
}
    `;
export const PlaidConfigFieldsFragmentDoc = gql`
    fragment PlaidConfigFields on PlaidConfig {
  id
  itemId
  externalInstitutionId
  createdAt
  updatedAt
}
    `;
export const SourceAccountFieldsFragmentDoc = gql`
    fragment SourceAccountFields on SourceAccount {
  id
  externalId
  externalName
  externalOwnerName
  externalOfficialName
  externalType
  externalSubtype
  mask
  status
  ownerEmployeeId
}
    `;
export const EnrichedDataSourceFieldsFragmentDoc = gql`
    fragment EnrichedDataSourceFields on EnrichedDataSource {
  id
  legalEntityId
  status
  statusReason
  institution {
    ...PartyFields
  }
  quickBooksConfig {
    ...QuickBooksConfigFields
  }
  plaidConfig {
    ...PlaidConfigFields
  }
  providerType
  accountAlias
  createdAt
  updatedAt
  lastActivityAt
  sourceAccounts {
    ...SourceAccountFields
  }
  hasTransactions
}
    ${PartyFieldsFragmentDoc}
${QuickBooksConfigFieldsFragmentDoc}
${PlaidConfigFieldsFragmentDoc}
${SourceAccountFieldsFragmentDoc}`;
export const AdminTransactionFactFieldsFragmentDoc = gql`
    fragment AdminTransactionFactFields on AdminTransactionFact {
  transactionFactId
  legalEntityId
  dataSource {
    ...EnrichedDataSourceFields
  }
  sourceAccount {
    ...SourceAccountFields
  }
  externalId
  externalName
  externalDescription
  pending
  transactionType
  externalTimestamp
  externalCreatedAt
  externalModifiedAt
  createdAt
  updatedAt
  ledgerTransactionId
  supersedingLedgerTransactionId
  supersededLedgerTransactionIds
  checkMetadata {
    payer
    payee
    memo
  }
}
    ${EnrichedDataSourceFieldsFragmentDoc}
${SourceAccountFieldsFragmentDoc}`;
export const AdminClassificationFieldsFragmentDoc = gql`
    fragment AdminClassificationFields on AdminClassification {
  version
  legalEntityId
  rule
  createdAt
  updatedAt
}
    `;
export const AdminTransactionEntityExtractionFieldsFragmentDoc = gql`
    fragment AdminTransactionEntityExtractionFields on AdminTransactionEntityExtraction {
  classificationVersionId
  party
  partyScore
  phone
  phoneScore
  location
  locationScore
  proxy
  proxyScore
  person
  personScore
  url
  urlScore
  institution
  institutionScore
  date
  dateScore
  creditCard
  creditCardScore
  updatedAt
}
    `;
export const AdminUserFieldsFragmentDoc = gql`
    fragment AdminUserFields on AdminUser {
  user {
    ...UserFields
    mfaEnforcedAt
  }
  timezone
  invitationId
  employments {
    role {
      id
    }
    organization {
      ...OrganizationFields
    }
    activatedAt
    status
    employeeId
    legalEntityRoles {
      legalEntityId
      role {
        id
      }
    }
  }
  affiliations {
    role {
      id
    }
    userOrganization {
      ...OrganizationFields
    }
    affiliatedTo {
      ...LegalEntityFields
    }
  }
  accountLocked
  banned
}
    ${UserFieldsFragmentDoc}
${OrganizationFieldsFragmentDoc}
${LegalEntityFieldsFragmentDoc}`;
export const ClassificationValidationExpectationFactFieldsFragmentDoc = gql`
    fragment ClassificationValidationExpectationFactFields on ClassificationValidationExpectationFact {
  transactionFactId
  dataSourceId
}
    `;
export const ClassificationValidationFieldsFragmentDoc = gql`
    fragment ClassificationValidationFields on ClassificationValidation {
  legalEntityId
  facts {
    ...ClassificationValidationExpectationFactFields
  }
  partyName
  partyRole
  partyIconUrl
  debitCategoryName
  creditCategoryName
  employeeOwnerName
  expectationId
  status
}
    ${ClassificationValidationExpectationFactFieldsFragmentDoc}`;
export const ClassificationValidationFailureDetailFieldsFragmentDoc = gql`
    fragment ClassificationValidationFailureDetailFields on ClassificationValidationFailureDetail {
  expectationType
  expectedValue
  actualValue
}
    `;
export const ClassificationValidationFailureFieldsFragmentDoc = gql`
    fragment ClassificationValidationFailureFields on ClassificationValidationFailure {
  expectation {
    ...ClassificationValidationFields
  }
  failureDetails {
    ...ClassificationValidationFailureDetailFields
  }
}
    ${ClassificationValidationFieldsFragmentDoc}
${ClassificationValidationFailureDetailFieldsFragmentDoc}`;
export const ClassificationValidationSummaryFieldsFragmentDoc = gql`
    fragment ClassificationValidationSummaryFields on ClassificationValidationSummary {
  passingValidations
  totalValidations
  numberOfLegalEntities
}
    `;
export const MismatchedQuickbooksBalanceSheetCategoryFieldsFragmentDoc = gql`
    fragment MismatchedQuickbooksBalanceSheetCategoryFields on MismatchedQuickbooksBalanceSheetCategory {
  period {
    ...PeriodFields
  }
  categoryName
  categoryType
  externalStartingBalance
  externalEndingBalance
  digitsStartingBalance
  digitsEndingBalance
  startingDelta
  endingDelta
}
    ${PeriodFieldsFragmentDoc}`;
export const MismatchedQuickbooksCategoryFieldsFragmentDoc = gql`
    fragment MismatchedQuickbooksCategoryFields on MismatchedQuickbooksCategory {
  period {
    ...PeriodFields
  }
  categoryName
  categoryType
  externalValue
  digitsValue
  difference
}
    ${PeriodFieldsFragmentDoc}`;
export const SummarizeDataSourceFetchesFieldsFragmentDoc = gql`
    fragment SummarizeDataSourceFetchesFields on DataSourceFetchStats {
  summaries {
    institutionName
    success
    statTimeBuckets {
      name
      total
      bucketOne
      bucketTwo
      bucketThree
      bucketFour
      bucketTimeMins
    }
  }
}
    `;
export const SummarizeViewGenerationFieldsFragmentDoc = gql`
    fragment SummarizeViewGenerationFields on ViewGenerationSummary {
  bucketOne
  bucketTwo
  bucketThree
  bucketFour
  bucketTimeMins
}
    `;
export const UnsupportedTransactionFieldsFragmentDoc = gql`
    fragment UnsupportedTransactionFields on UnsupportedTransaction {
  fetchId
  fetchType
  providerType
  accountAlias
  dataType
  transactionCount
  reason
}
    `;
export const UnsupportedTransactionsFieldsFragmentDoc = gql`
    fragment UnsupportedTransactionsFields on UnsupportedTransactions {
  onboardUnsupportedTransactions {
    ...UnsupportedTransactionFields
  }
  otherUnsupportedTransactions {
    ...UnsupportedTransactionFields
  }
}
    ${UnsupportedTransactionFieldsFragmentDoc}`;
export const AdminGlobalVanityStatsFieldsFragmentDoc = gql`
    fragment AdminGlobalVanityStatsFields on AdminGlobalVanityStats {
  totalSignupsCount
  totalSignupsLast30Count
  qualifiedSignupsCount
  averageSignupQualifiedAt
  primedSignupsCount
  averageSignupPrimedAt
  invitedSignupsCount
  averageSignupInvitedAt
  appliedSignupsCount
  averageSignupAppliedAt
  approvedSignupsLast30Count
  lastSignupApprovedAt
  totalUsersCount
  activeUsersCount
  totalLegalEntitiesCount
  activeLegalEntitiesCount
  pendingLegalEntitiesCount
  totalPartiesCount
  globalPartiesCount
  globalPartiesLast30Count
  linkedPartiesCount
  unlinkedPartiesCount
  unlinkedRepeatPartiesCount
  hydratableUnlinkedRepeatPartiesCount
  hydratableUnlinkedPartiesCount
  totalTransactionsCount
  totalTransactionsValue {
    ...MonetaryValueFields
  }
  globalPartyTransactionsCount
  legalEntitiesWithValidQuickBooksCount
  legalEntitiesWithDataIssuesCount
  activeLegalEntitiesWithDataIssuesCount
  legalEntitiesWithQuickBooksConnectionIssuesCount
  activeLegalEntitiesWithQuickBooksConnectionIssuesCount
  activeLegalEntitiesWithPlaidConnectionIssuesCount
  legalEntitiesWithEngineeringRequiredCount
  supersedingRate
  dayOfInterest
  reportValidations {
    period {
      ...PeriodFields
    }
    packageValidCount
    packageInvalidCount
    byKind {
      kind
      validCount
      invalidCount
    }
  }
}
    ${MonetaryValueFieldsFragmentDoc}
${PeriodFieldsFragmentDoc}`;
export const AdminVanityStatsFieldsFragmentDoc = gql`
    fragment AdminVanityStatsFields on AdminVanityStats {
  transactionsCount
  usersCount
  partiesCount
  categoriesCount
  totalValue {
    ...MonetaryValueFields
  }
}
    ${MonetaryValueFieldsFragmentDoc}`;
export const EntityPartyFieldsFragmentDoc = gql`
    fragment EntityPartyFields on EntityParty {
  id
  name
  iconUrl
  shortDescription
  roles
  designation
}
    `;
export const AdminWorkItemTransactionFieldsFragmentDoc = gql`
    fragment AdminWorkItemTransactionFields on AdminWorkItemTransaction {
  externalTransactionId
  externalTransactionLineId
  supportType
  creditCategory {
    ...EntityCategoryFields
  }
  debitCategory {
    ...EntityCategoryFields
  }
  description
  name
  party {
    ...EntityPartyFields
  }
  displayEntry
  displayCategory {
    ...EntityCategoryFields
  }
  occurredAt
  dataSourceId
}
    ${EntityCategoryFieldsFragmentDoc}
${EntityPartyFieldsFragmentDoc}`;
export const WorkItemGeneratedQuestionFieldsFragmentDoc = gql`
    fragment WorkItemGeneratedQuestionFields on WorkItemGeneratedQuestion {
  question
  contextType
  active
}
    `;
export const WorkItemPushFieldsFragmentDoc = gql`
    fragment WorkItemPushFields on WorkItemPush {
  field
  pushState
  errorType
  updatedAt
}
    `;
export const AdminWorkItemFieldsFragmentDoc = gql`
    fragment AdminWorkItemFields on AdminWorkItem {
  legalEntityId
  workItemId
  time
  itemType
  itemState
  ledgerType
  actionable
  createdAt
  updatedBy
  updatedAt
  transactions {
    ...AdminWorkItemTransactionFields
  }
  generatedQuestions {
    ...WorkItemGeneratedQuestionFields
  }
  pushes {
    ...WorkItemPushFields
  }
  transactionFactId
  defaultState
  userState
  transactionGcsUrl
}
    ${AdminWorkItemTransactionFieldsFragmentDoc}
${WorkItemGeneratedQuestionFieldsFragmentDoc}
${WorkItemPushFieldsFragmentDoc}`;
export const ArchiveIntervalOriginFieldsFragmentDoc = gql`
    fragment ArchiveIntervalOriginFields on ArchiveIntervalOrigin {
  interval
  year
  index
  intervalCount
  maxTime
}
    `;
export const EntityUserFieldsFragmentDoc = gql`
    fragment EntityUserFields on EntityUser {
  id
  givenName
  familyName
  emailAddress
  avatarUrl
}
    `;
export const BooksClosedDateFieldsFragmentDoc = gql`
    fragment BooksClosedDateFields on BooksClosedDate {
  legalEntityId
  latestBooksClosedDateFact
  user {
    ...EntityUserFields
  }
}
    ${EntityUserFieldsFragmentDoc}`;
export const CategoryMappingFieldsFragmentDoc = gql`
    fragment CategoryMappingFields on CategoryMapping {
  mappingValue
  mappingType
  product
  category {
    ...EntityCategoryFields
  }
}
    ${EntityCategoryFieldsFragmentDoc}`;
export const DataSourceFieldsFragmentDoc = gql`
    fragment DataSourceFields on DataSource {
  id
  legalEntityId
  status
  statusReason
  institution {
    ...InstitutionFields
  }
  providerType
  accountAlias
  createdAt
  updatedAt
}
    ${InstitutionFieldsFragmentDoc}`;
export const DataSourcePreferenceFieldsFragmentDoc = gql`
    fragment DataSourcePreferenceFields on DataSourcePreference {
  dataSourceId
  accountingBasis
  taxForm
  providerType
  departmentTerminology
}
    `;
export const EntityDepartmentFieldsFragmentDoc = gql`
    fragment EntityDepartmentFields on EntityDepartment {
  __typename
  id
  name
  parentId
  active
}
    `;
export const EntityDataSourceFieldsFragmentDoc = gql`
    fragment EntityDataSourceFields on EntityDataSource {
  id
  name
  url
  iconUrl
}
    `;
export const DepartmentFieldsFragmentDoc = gql`
    fragment DepartmentFields on Department {
  id
  name
  parentId
  active
  ancestors {
    ...EntityDepartmentFields
  }
  description
  displayKey
  matches {
    id
    dataSourceId
  }
  dataSource {
    ...EntityDataSourceFields
  }
}
    ${EntityDepartmentFieldsFragmentDoc}
${EntityDataSourceFieldsFragmentDoc}`;
export const DocumentInitialSegmentFieldsFragmentDoc = gql`
    fragment DocumentInitialSegmentFields on DocumentInitialSegment {
  collectionId
  documentId
  downloadUrl
}
    `;
export const EntityOrganizationFieldsFragmentDoc = gql`
    fragment EntityOrganizationFields on EntityOrganization {
  id
  name
  slug
  iconUrl
}
    `;
export const EntityLegalEntityFieldsFragmentDoc = gql`
    fragment EntityLegalEntityFields on EntityLegalEntity {
  id
  name
  slug
}
    `;
export const EmployeeAffiliationsFieldsFragmentDoc = gql`
    fragment EmployeeAffiliationsFields on EmployeeAffiliations {
  employee {
    ...EmployeeFields
  }
  affiliations {
    organization {
      ...EntityOrganizationFields
    }
    legalEntity {
      ...EntityLegalEntityFields
    }
    role {
      id
    }
  }
}
    ${EmployeeFieldsFragmentDoc}
${EntityOrganizationFieldsFragmentDoc}
${EntityLegalEntityFieldsFragmentDoc}`;
export const HighlightedTokenFieldsFragmentDoc = gql`
    fragment HighlightedTokenFields on HighlightedToken {
  token
  score
}
    `;
export const HighlightedTokensFieldsFragmentDoc = gql`
    fragment HighlightedTokensFields on HighlightedTokens {
  description {
    ...HighlightedTokenFields
  }
  name {
    ...HighlightedTokenFields
  }
}
    ${HighlightedTokenFieldsFragmentDoc}`;
export const InsightFieldsFragmentDoc = gql`
    fragment InsightFields on Insight {
  score
  globalScore
  subjectType
  subjectId
  subjectDisplayKey
  periodValue {
    ...MonetaryValueFields
  }
  absoluteDelta {
    ...MonetaryValueFields
  }
  comparisonPeriodValue {
    ...MonetaryValueFields
  }
  comparisonIntervalOffset
  ruleType
  sentence
  subjectIconUrl
  designation
  type
  productArea
}
    ${MonetaryValueFieldsFragmentDoc}`;
export const InvitationProposalFieldsFragmentDoc = gql`
    fragment InvitationProposalFields on InvitationProposal {
  proposalId
  proposalType
  status
  invitationId
  legalEntity {
    ...EntityLegalEntityFields
  }
  organization {
    ...EntityOrganizationFields
  }
  organizationTemplateId
  sender {
    ...EntityUserFields
  }
  createdAt
  recipient {
    ...ContactFields
  }
}
    ${EntityLegalEntityFieldsFragmentDoc}
${EntityOrganizationFieldsFragmentDoc}
${EntityUserFieldsFragmentDoc}
${ContactFieldsFragmentDoc}`;
export const EntityLocationFieldsFragmentDoc = gql`
    fragment EntityLocationFields on EntityLocation {
  __typename
  id
  name
  parentId
  active
}
    `;
export const LocationFieldsFragmentDoc = gql`
    fragment LocationFields on Location {
  id
  name
  parentId
  active
  ancestors {
    ...EntityLocationFields
  }
  description
  displayKey
  dataSource {
    ...EntityDataSourceFields
  }
}
    ${EntityLocationFieldsFragmentDoc}
${EntityDataSourceFieldsFragmentDoc}`;
export const OrganizationPreviewFieldsFragmentDoc = gql`
    fragment OrganizationPreviewFields on OrganizationPreview {
  id
  slug
  name
  iconUrl
}
    `;
export const OwnedSourceAccountFieldsFragmentDoc = gql`
    fragment OwnedSourceAccountFields on OwnedSourceAccount {
  sourceAccount {
    ...SourceAccountFields
  }
  owner {
    ...EmployeeFields
  }
}
    ${SourceAccountFieldsFragmentDoc}
${EmployeeFieldsFragmentDoc}`;
export const ProductGroupFieldsFragmentDoc = gql`
    fragment ProductGroupFields on ProductGroup {
  id
  name
  description
  iconDisplayKey
  customIconObjectName
  createdAt
  updatedAt
}
    `;
export const DateFieldsFragmentDoc = gql`
    fragment DateFields on Date {
  year
  month
  day
}
    `;
export const TransactionPartyFieldsFragmentDoc = gql`
    fragment TransactionPartyFields on TransactionParty {
  id
  name
  iconUrl
  iconObjectName
  designation
  roles
}
    `;
export const ProductFieldsFragmentDoc = gql`
    fragment ProductFields on Product {
  id
  name
}
    `;
export const TransactionSourceFieldsFragmentDoc = gql`
    fragment TransactionSourceFields on TransactionSource {
  timestamp
  name
  iconUrl
  externalDisplayId
  type
  account {
    sourceAccountId
    externalName
    mask
    externalOwnerName
    externalOfficialName
  }
}
    `;
export const ClassificationProvenanceFieldsFragmentDoc = gql`
    fragment ClassificationProvenanceFields on ClassificationProvenance {
  type
  changedAt
  confidenceLevel
  source {
    ...TransactionSourceFields
  }
  settingsName
}
    ${TransactionSourceFieldsFragmentDoc}`;
export const MoneyFlowFieldsFragmentDoc = gql`
    fragment MoneyFlowFields on MoneyFlow {
  value {
    ...MonetaryValueFields
  }
  isNormal
  businessFlow
}
    ${MonetaryValueFieldsFragmentDoc}`;
export const EntityEmployeeFieldsFragmentDoc = gql`
    fragment EntityEmployeeFields on EntityEmployee {
  id
  organizationId
  givenName
  familyName
  avatarUrl
}
    `;
export const EntityScheduleFieldsFragmentDoc = gql`
    fragment EntityScheduleFields on EntitySchedule {
  __typename
  id
  name
  scheduleNumber
  scheduleType
  scheduleTemplateId
  categoryId
  relatedCategoryId
  partyId
  startDate
  endDate
  amount {
    ...MonetaryValueFields
  }
}
    ${MonetaryValueFieldsFragmentDoc}`;
export const TransactionFieldsFragmentDoc = gql`
    fragment TransactionFields on Transaction {
  viewId
  factId
  ledgerTransactionId
  supersededFactIds
  timestamp
  recordType
  name
  description
  digitsTransactionType
  party {
    ...TransactionPartyFields
  }
  partySource
  facilitatorParty {
    ...TransactionPartyFields
  }
  product {
    ...ProductFields
  }
  department {
    ...EntityDepartmentFields
  }
  splitDepartment {
    ...EntityDepartmentFields
  }
  location {
    ...EntityLocationFields
  }
  splitLocation {
    ...EntityLocationFields
  }
  providers {
    name
  }
  recurrence {
    recurrenceThreadId
    interval
    intervalMultiplier
    threadIndex
    totalThreadCount
    isHidden
    firstOccurredAt
    lastOccurredAt
  }
  displayEntry
  displayInstitution {
    ...TransactionPartyFields
  }
  displayCategory {
    ...CategoryFields
  }
  displayCategorySource
  displayCategoryClassificationProvenance {
    ...ClassificationProvenanceFields
  }
  displayCanonicalCategoryName
  displayUncategorizedReason
  displayProductArea
  splitCategory {
    ...CategoryFields
  }
  splitCategoryClassificationProvenance {
    ...ClassificationProvenanceFields
  }
  splitInstitution {
    ...TransactionPartyFields
  }
  creditCategoryClassificationProvenance {
    ...ClassificationProvenanceFields
  }
  debitCategoryClassificationProvenance {
    ...ClassificationProvenanceFields
  }
  moneyFlow {
    ...MoneyFlowFields
  }
  runningTotal {
    ...MoneyFlowFields
  }
  owner {
    ...EntityEmployeeFields
  }
  ownerSource
  transactionClassificationType
  sources {
    ...TransactionSourceFields
  }
  creditSources {
    ...TransactionSourceFields
  }
  debitSources {
    ...TransactionSourceFields
  }
  compileSource
  reconciliationStatus
  referenceNumber
  taxStatus
  matchedLedgerTransactionIds
  providerTypes
  isSupersedingLedgerTransaction
  supersededLedgerTransactionIds
  invoiceLineItem {
    value {
      ... on TransactionProductLineItem {
        name
        description
        quantity
        unitPrice {
          ...MonetaryValueFields
        }
        product {
          productId
          name
          description
          unitPrice {
            ...MonetaryValueFields
          }
          category {
            ...CategoryFields
          }
          department {
            ...EntityDepartmentFields
          }
          location {
            ...EntityLocationFields
          }
        }
      }
      ... on TransactionDiscountLineItem {
        name
        description
        fixedAmount {
          ...MonetaryValueFields
        }
        variablePercentage
        appliesToTransactionFactId
        discount {
          discountId
          name
          description
          fixedAmount {
            ...MonetaryValueFields
          }
          variablePercentage
        }
      }
    }
  }
  schedule {
    ...EntityScheduleFields
  }
  splitSchedule {
    ...EntityScheduleFields
  }
}
    ${TransactionPartyFieldsFragmentDoc}
${ProductFieldsFragmentDoc}
${EntityDepartmentFieldsFragmentDoc}
${EntityLocationFieldsFragmentDoc}
${CategoryFieldsFragmentDoc}
${ClassificationProvenanceFieldsFragmentDoc}
${MoneyFlowFieldsFragmentDoc}
${EntityEmployeeFieldsFragmentDoc}
${TransactionSourceFieldsFragmentDoc}
${MonetaryValueFieldsFragmentDoc}
${EntityScheduleFieldsFragmentDoc}`;
export const ReconciliationDiffTransactionFieldsFragmentDoc = gql`
    fragment ReconciliationDiffTransactionFields on ReconciliationDiffTransaction {
  transactionFactId
  transaction {
    ...TransactionFields
  }
  diffReasons
  fromStatus
  toStatus
  fromOccurredAt
  toOccurredAt
  fromAmount {
    ...MonetaryValueFields
  }
  toAmount {
    ...MonetaryValueFields
  }
  fromEntryType
  toEntryType
}
    ${TransactionFieldsFragmentDoc}
${MonetaryValueFieldsFragmentDoc}`;
export const ReconciliationDiffFieldsFragmentDoc = gql`
    fragment ReconciliationDiffFields on ReconciliationDiff {
  reconciliationId
  toStartDate {
    ...DateFields
  }
  toEndDate {
    ...DateFields
  }
  transactions {
    ...ReconciliationDiffTransactionFields
  }
}
    ${DateFieldsFragmentDoc}
${ReconciliationDiffTransactionFieldsFragmentDoc}`;
export const ReportPackageDocumentMetadataFieldsFragmentDoc = gql`
    fragment ReportPackageDocumentMetadataFields on ReportPackageDocumentMetadata {
  id
  title
  documentObjectId
  documentObjectVersionId
  type
  reportFile {
    ...ReportFileMetadataFields
  }
  status
  generationHistory {
    ...ReportGenerationHistoryFields
  }
  position
}
    ${ReportFileMetadataFieldsFragmentDoc}
${ReportGenerationHistoryFieldsFragmentDoc}`;
export const ReportPackageVersionMetadataFieldsFragmentDoc = gql`
    fragment ReportPackageVersionMetadataFields on ReportPackageVersionMetadata {
  id
  status
  createdAt
  updatedAt
}
    `;
export const ReportPackageMetadataFieldsFragmentDoc = gql`
    fragment ReportPackageMetadataFields on ReportPackageMetadata {
  id
  versionId
  viewKey {
    ...ViewIdentifierFields
  }
  title
  status
  author {
    ...ContactFields
  }
  documents {
    ...ReportPackageDocumentMetadataFields
  }
  startedAt
  endedAt
  interval
  coverUrl
  publishedAsDraft
  createdAt
  updatedAt
  creationMethod
  versions {
    ...ReportPackageVersionMetadataFields
  }
}
    ${ViewIdentifierFieldsFragmentDoc}
${ContactFieldsFragmentDoc}
${ReportPackageDocumentMetadataFieldsFragmentDoc}
${ReportPackageVersionMetadataFieldsFragmentDoc}`;
export const ScheduleEventVariableTemplateFormulaFieldsFragmentDoc = gql`
    fragment ScheduleEventVariableTemplateFormulaFields on ScheduleEventVariableTemplateFormula {
  id
  displayName
}
    `;
export const ScheduleEventVariableTemplateFieldsFragmentDoc = gql`
    fragment ScheduleEventVariableTemplateFields on ScheduleEventVariableTemplate {
  id
  variableName
  displayName
  required
  ordinal
  formulas {
    ...ScheduleEventVariableTemplateFormulaFields
  }
  variableType
  displayMode
}
    ${ScheduleEventVariableTemplateFormulaFieldsFragmentDoc}`;
export const ScheduleEventTemplateFieldsFragmentDoc = gql`
    fragment ScheduleEventTemplateFields on ScheduleEventTemplate {
  id
  name
  description
  displayName
  ordinal
  isSingleton
  isTerminating
  isInstantiating
  inCreateFlow
  displayKey
  variables {
    ...ScheduleEventVariableTemplateFields
  }
}
    ${ScheduleEventVariableTemplateFieldsFragmentDoc}`;
export const EntityTransactionFieldsFragmentDoc = gql`
    fragment EntityTransactionFields on EntityTransaction {
  viewId
  factId
  timestamp
  description
  externalId
  moneyFlow {
    ...MoneyFlowFields
  }
  party {
    ...EntityPartyFields
  }
  displayCategory {
    ...EntityCategoryFields
  }
  splitCategory {
    ...EntityCategoryFields
  }
  displayEntry
}
    ${MoneyFlowFieldsFragmentDoc}
${EntityPartyFieldsFragmentDoc}
${EntityCategoryFieldsFragmentDoc}`;
export const ScheduleEventVariableFieldsFragmentDoc = gql`
    fragment ScheduleEventVariableFields on ScheduleEventVariable {
  id
  displayName
  variableName
  variableTemplateId
  variableType
  value {
    ... on ScheduleBooleanValue {
      boolValue
    }
    ... on ScheduleDateValue {
      dateValue
    }
    ... on ScheduleFloatValue {
      floatValue
    }
    ... on ScheduleFormulaValue {
      formulaId
      formulaDisplayName
    }
    ... on ScheduleIntervalValue {
      intervalValue
    }
    ... on ScheduleLongValue {
      longValue
    }
    ... on ScheduleMonetaryValue {
      monetaryValue {
        ...MonetaryValueFields
      }
    }
    ... on ScheduleStringValue {
      stringValue
    }
    ... on ScheduleCategoryValue {
      category {
        ...EntityCategoryFields
      }
    }
    ... on ScheduleTransactionValue {
      transaction {
        ...EntityTransactionFields
      }
    }
    ... on SchedulePartyValue {
      party {
        ...EntityPartyFields
      }
    }
    ... on ScheduleTermValue {
      intervalCount
      endDate
    }
  }
}
    ${MonetaryValueFieldsFragmentDoc}
${EntityCategoryFieldsFragmentDoc}
${EntityTransactionFieldsFragmentDoc}
${EntityPartyFieldsFragmentDoc}`;
export const ScheduleEventFieldsFragmentDoc = gql`
    fragment ScheduleEventFields on ScheduleEvent {
  id
  displayName
  eventDate
  eventTemplateId
  isGenerated
  isInstantiating
  isTerminating
  isSingleton
  displayKey
  skipReason
  note
  createdAt
  createdBy {
    ...EntityUserFields
  }
  updatedAt
  updatedBy {
    ...EntityUserFields
  }
  variables {
    ...ScheduleEventVariableFields
  }
}
    ${EntityUserFieldsFragmentDoc}
${ScheduleEventVariableFieldsFragmentDoc}`;
export const ScheduleFieldsFragmentDoc = gql`
    fragment ScheduleFields on Schedule {
  id
  name
  description
  scheduleNumber
  scheduleTemplateId
  specializationId
  scheduleType
  sourceTransaction {
    ...EntityTransactionFields
  }
  party {
    ...EntityPartyFields
  }
  createdAt
  createdBy {
    ...EntityUserFields
  }
  updatedAt
  updatedBy {
    ...EntityUserFields
  }
  events {
    ...ScheduleEventFields
  }
}
    ${EntityTransactionFieldsFragmentDoc}
${EntityPartyFieldsFragmentDoc}
${EntityUserFieldsFragmentDoc}
${ScheduleEventFieldsFragmentDoc}`;
export const ScheduleSnapshotFieldsFragmentDoc = gql`
    fragment ScheduleSnapshotFields on ScheduleSnapshot {
  id
  name
  scheduleNumber
  scheduleType
  category {
    ...EntityCategoryFields
  }
  relatedCategory {
    ...EntityCategoryFields
  }
  party {
    ...EntityPartyFields
  }
  startDate
  endDate
  amount {
    ...MonetaryValueFields
  }
  remainingAmount {
    ...MonetaryValueFields
  }
}
    ${EntityCategoryFieldsFragmentDoc}
${EntityPartyFieldsFragmentDoc}
${MonetaryValueFieldsFragmentDoc}`;
export const ScheduleTemplateFieldsFragmentDoc = gql`
    fragment ScheduleTemplateFields on ScheduleTemplate {
  id
  name
  description
  scheduleType
  displayKey
}
    `;
export const ObjectIdentifierFieldsFragmentDoc = gql`
    fragment ObjectIdentifierFields on ObjectIdentifier {
  legalEntityId
  id
  kind
}
    `;
export const ThreadDetailsFieldsFragmentDoc = gql`
    fragment ThreadDetailsFields on ThreadDetails {
  id
  commentCount
  resolvedAt
  targetObject {
    ...ObjectIdentifierFields
  }
  authorId
  commenterIds
  tags {
    ...ObjectIdentifierFields
  }
  context
  pending @client
}
    ${ObjectIdentifierFieldsFragmentDoc}`;
export const CommentFieldsFragmentDoc = gql`
    fragment CommentFields on Comment {
  __typename
  id
  authorId
  text
  timestamp
  editedAt
  deletedAt
  layoutAttachment {
    layoutId
    legalEntityId
  }
  reactions
}
    `;
export const ThreadFieldsFragmentDoc = gql`
    fragment ThreadFields on Thread {
  __typename
  id
  details {
    ...ThreadDetailsFields
  }
  comments {
    ...CommentFields
  }
}
    ${ThreadDetailsFieldsFragmentDoc}
${CommentFieldsFragmentDoc}`;
export const EntityCommentFieldsFragmentDoc = gql`
    fragment EntityCommentFields on EntityComment {
  id
  authorId
  text
  timestamp
}
    `;
export const EntityReportFieldsFragmentDoc = gql`
    fragment EntityReportFields on EntityReport {
  id
  title
  authorId
  mimeType
  reportFor {
    ...DateFields
  }
  createdAt
}
    ${DateFieldsFragmentDoc}`;
export const SharedReportDocumentMetadataFieldsFragmentDoc = gql`
    fragment SharedReportDocumentMetadataFields on SharedReportDocumentMetadata {
  id
  documentObjectId
  documentObjectVersionId
  title
  mimeType
}
    `;
export const EntityReportPackageFieldsFragmentDoc = gql`
    fragment EntityReportPackageFields on EntityReportPackage {
  id
  title
  authorId
  interval
  periodStartedAt
  periodEndedAt
  createdAt
  updatedAt
  documents {
    ...SharedReportDocumentMetadataFields
  }
  coverUrl
}
    ${SharedReportDocumentMetadataFieldsFragmentDoc}`;
export const EntityThreadFieldsFragmentDoc = gql`
    fragment EntityThreadFields on EntityThread {
  id
  resolvedAt
}
    `;
export const EntityWorkItemFieldsFragmentDoc = gql`
    fragment EntityWorkItemFields on EntityWorkItem {
  id
  time
  workItemState
  workItemType
  reviewCreatedById
  objectTransaction {
    ...EntityTransactionFields
  }
  reviewState
  ledgerType
}
    ${EntityTransactionFieldsFragmentDoc}`;
export const EntityMonetaryValueFieldsFragmentDoc = gql`
    fragment EntityMonetaryValueFields on EntityMonetaryValue {
  iso4217CurrencyCode
  currencyMultiplier
  amount
}
    `;
export const EntityInvoiceCustomerFieldsFragmentDoc = gql`
    fragment EntityInvoiceCustomerFields on EntityInvoiceCustomer {
  name
  phone
  email
  party {
    ...EntityPartyFields
  }
}
    ${EntityPartyFieldsFragmentDoc}`;
export const EntityInvoiceFieldsFragmentDoc = gql`
    fragment EntityInvoiceFields on EntityInvoice {
  id
  externalDisplayId
  amount {
    ...EntityMonetaryValueFields
  }
  customer {
    ...EntityInvoiceCustomerFields
  }
  createdAt
  dueAt
}
    ${EntityMonetaryValueFieldsFragmentDoc}
${EntityInvoiceCustomerFieldsFragmentDoc}`;
export const SegmentFieldsFragmentDoc = gql`
    fragment SegmentFields on Segment {
  collectionId
  fileId
  sequence
  token
}
    `;
export const BillAccessFieldsFragmentDoc = gql`
    fragment BillAccessFields on BillAccess {
  objectId
  objectKind
  role
}
    `;
export const EntityBillFieldsFragmentDoc = gql`
    fragment EntityBillFields on EntityBill {
  id
  billStatus
  vendorName
  totalAmount {
    ...EntityMonetaryValueFields
  }
  dueDate {
    ...DateFields
  }
  billDescription
  format {
    id
    formatClass
    segments {
      ...SegmentFields
    }
  }
  approvalAccess {
    ...BillAccessFields
  }
}
    ${EntityMonetaryValueFieldsFragmentDoc}
${DateFieldsFragmentDoc}
${SegmentFieldsFragmentDoc}
${BillAccessFieldsFragmentDoc}`;
export const EntityIdentityVerificationFieldsFragmentDoc = gql`
    fragment EntityIdentityVerificationFields on EntityIdentityVerification {
  legalEntityId
  status
}
    `;
export const EntityReconciliationFieldsFragmentDoc = gql`
    fragment EntityReconciliationFields on EntityReconciliation {
  __typename
  id
  categoryId
  reconciliationStatus
  startDate {
    ...DateFields
  }
  endDate {
    ...DateFields
  }
}
    ${DateFieldsFragmentDoc}`;
export const EntityLedgerTransactionFieldsFragmentDoc = gql`
    fragment EntityLedgerTransactionFields on EntityLedgerTransaction {
  id
  timestamp
  factIds
  name
  totalAmount {
    ...EntityMonetaryValueFields
  }
  referenceNumber
  parties {
    ...EntityPartyFields
  }
}
    ${EntityMonetaryValueFieldsFragmentDoc}
${EntityPartyFieldsFragmentDoc}`;
export const ObjectEntitiesFieldsFragmentDoc = gql`
    fragment ObjectEntitiesFields on ObjectEntities {
  __typename
  users {
    ...EntityUserFields
  }
  transactions {
    ...EntityTransactionFields
  }
  comments {
    ...EntityCommentFields
  }
  reports {
    ...EntityReportFields
  }
  reportPackages {
    ...EntityReportPackageFields
  }
  parties {
    ...EntityPartyFields
  }
  datasources {
    ...EntityDataSourceFields
  }
  categories {
    ...EntityCategoryFields
  }
  threads {
    ...EntityThreadFields
  }
  legalEntities {
    ...EntityLegalEntityFields
  }
  workItems {
    ...EntityWorkItemFields
  }
  invoices {
    ...EntityInvoiceFields
  }
  bills {
    ...EntityBillFields
  }
  identityVerifications {
    ...EntityIdentityVerificationFields
  }
  departments {
    ...EntityDepartmentFields
  }
  locations {
    ...EntityLocationFields
  }
  reconciliations {
    ...EntityReconciliationFields
  }
  ledgerTransactions {
    ...EntityLedgerTransactionFields
  }
  schedules {
    ...EntityScheduleFields
  }
}
    ${EntityUserFieldsFragmentDoc}
${EntityTransactionFieldsFragmentDoc}
${EntityCommentFieldsFragmentDoc}
${EntityReportFieldsFragmentDoc}
${EntityReportPackageFieldsFragmentDoc}
${EntityPartyFieldsFragmentDoc}
${EntityDataSourceFieldsFragmentDoc}
${EntityCategoryFieldsFragmentDoc}
${EntityThreadFieldsFragmentDoc}
${EntityLegalEntityFieldsFragmentDoc}
${EntityWorkItemFieldsFragmentDoc}
${EntityInvoiceFieldsFragmentDoc}
${EntityBillFieldsFragmentDoc}
${EntityIdentityVerificationFieldsFragmentDoc}
${EntityDepartmentFieldsFragmentDoc}
${EntityLocationFieldsFragmentDoc}
${EntityReconciliationFieldsFragmentDoc}
${EntityLedgerTransactionFieldsFragmentDoc}
${EntityScheduleFieldsFragmentDoc}`;
export const ThreadWithEntitiesFieldsFragmentDoc = gql`
    fragment ThreadWithEntitiesFields on ThreadWithEntities {
  __typename
  thread {
    ...ThreadFields
  }
  entities {
    ...ObjectEntitiesFields
  }
}
    ${ThreadFieldsFragmentDoc}
${ObjectEntitiesFieldsFragmentDoc}`;
export const ThreadListFieldsFragmentDoc = gql`
    fragment ThreadListFields on ThreadList {
  targetObject {
    ...ObjectIdentifierFields
  }
  threads {
    ...ThreadDetailsFields
  }
}
    ${ObjectIdentifierFieldsFragmentDoc}
${ThreadDetailsFieldsFragmentDoc}`;
export const ThreadsFieldsFragmentDoc = gql`
    fragment ThreadsFields on Threads {
  threads {
    ...ThreadListFields
  }
  entities {
    ...ObjectEntitiesFields
  }
}
    ${ThreadListFieldsFragmentDoc}
${ObjectEntitiesFieldsFragmentDoc}`;
export const TransactionEntryFieldsFragmentDoc = gql`
    fragment TransactionEntryFields on TransactionEntry {
  factId
  externalLineId
  description
  amount {
    ...MonetaryValueFields
  }
}
    ${MonetaryValueFieldsFragmentDoc}`;
export const TransactionLineFieldsFragmentDoc = gql`
    fragment TransactionLineFields on TransactionLine {
  entry {
    ...TransactionEntryFields
  }
  entryType
  category {
    ...EntityCategoryFields
  }
  categoryClassificationProvenance {
    ...ClassificationProvenanceFields
  }
  party {
    ...EntityPartyFields
  }
  department {
    ...EntityDepartmentFields
  }
  location {
    ...EntityLocationFields
  }
  schedule {
    ...EntityScheduleFields
  }
}
    ${TransactionEntryFieldsFragmentDoc}
${EntityCategoryFieldsFragmentDoc}
${ClassificationProvenanceFieldsFragmentDoc}
${EntityPartyFieldsFragmentDoc}
${EntityDepartmentFieldsFragmentDoc}
${EntityLocationFieldsFragmentDoc}
${EntityScheduleFieldsFragmentDoc}`;
export const SummaryTotalFieldsFragmentDoc = gql`
    fragment SummaryTotalFields on SummaryTotal {
  total {
    ...MoneyFlowFields
  }
  count
}
    ${MoneyFlowFieldsFragmentDoc}`;
export const PeriodMonetaryValueFieldsFragmentDoc = gql`
    fragment PeriodMonetaryValueFields on PeriodMonetaryValue {
  value {
    ...MonetaryValueFields
  }
  moneyFlow {
    ...MoneyFlowFields
  }
  current {
    ...SummaryTotalFields
  }
  prior {
    ...SummaryTotalFields
  }
  transactionsCount
  deltaPrevious
  deltaYearAgo
  isFirstOccurrencePeriod
}
    ${MonetaryValueFieldsFragmentDoc}
${MoneyFlowFieldsFragmentDoc}
${SummaryTotalFieldsFragmentDoc}`;
export const TransactionSummaryFieldsFragmentDoc = gql`
    fragment TransactionSummaryFields on TransactionSummary {
  period {
    ...PeriodFields
  }
  total {
    ...PeriodMonetaryValueFields
  }
  isPeriodBookClosed
}
    ${PeriodFieldsFragmentDoc}
${PeriodMonetaryValueFieldsFragmentDoc}`;
export const TransactionEntryLineFieldsFragmentDoc = gql`
    fragment TransactionEntryLineFields on TransactionEntryLine {
  lineId
  factId
  value {
    ...MonetaryValueFields
  }
  category {
    ...CategoryFields
  }
  categoryClassificationProvenance {
    ...ClassificationProvenanceFields
  }
  name
  description
  isCredit
  highlighted
}
    ${MonetaryValueFieldsFragmentDoc}
${CategoryFieldsFragmentDoc}
${ClassificationProvenanceFieldsFragmentDoc}`;
export const TransactionViewDetailFieldsFragmentDoc = gql`
    fragment TransactionViewDetailFields on TransactionViewDetail {
  id
  factId
  occurredAt
  externalCreatedAt
  externalId
  externalDisplayId
  quickbooksAppName
  name
  description
  creditAmount {
    ...MonetaryValueFields
  }
  debitAmount {
    ...MonetaryValueFields
  }
  creditCategoryHierarchy {
    ...CategoryFields
  }
  debitCategoryHierarchy {
    ...CategoryFields
  }
  entryLines {
    ...TransactionEntryLineFields
  }
  party {
    ...TransactionPartyFields
  }
  institution {
    ...InstitutionFields
  }
  sourceAccount {
    ...SourceAccountFields
  }
  recordType
}
    ${MonetaryValueFieldsFragmentDoc}
${CategoryFieldsFragmentDoc}
${TransactionEntryLineFieldsFragmentDoc}
${TransactionPartyFieldsFragmentDoc}
${InstitutionFieldsFragmentDoc}
${SourceAccountFieldsFragmentDoc}`;
export const UserInfoFieldsFragmentDoc = gql`
    fragment UserInfoFields on UserInfo {
  givenName
  familyName
  emailAddress
}
    `;
export const WorkItemTransactionFieldsFragmentDoc = gql`
    fragment WorkItemTransactionFields on WorkItemTransaction {
  externalTransactionId
  externalTransactionLineId
  supportType
  displayCategory {
    ...EntityCategoryFields
  }
  displayPartyRole
  displayEntry
  splitCategory {
    ...EntityCategoryFields
  }
  description
  name
  party {
    ...EntityPartyFields
  }
  creditValue {
    ...MonetaryValueFields
  }
  debitValue {
    ...MonetaryValueFields
  }
  displayValue {
    ...MonetaryValueFields
  }
  moneyFlow {
    ...MoneyFlowFields
  }
  occurredAt
  dataSourceId
  quickbooksAppName
  ledgerTransactionId
}
    ${EntityCategoryFieldsFragmentDoc}
${EntityPartyFieldsFragmentDoc}
${MonetaryValueFieldsFragmentDoc}
${MoneyFlowFieldsFragmentDoc}`;
export const WorkItemReviewFieldsFragmentDoc = gql`
    fragment WorkItemReviewFields on WorkItemReview {
  createdAt
  creator {
    ...EntityUserFields
  }
  updatedAt
  subject
}
    ${EntityUserFieldsFragmentDoc}`;
export const WorkItemFieldsFragmentDoc = gql`
    fragment WorkItemFields on WorkItem {
  legalEntityId
  workItemId
  time
  itemType
  itemState
  ledgerType
  createdAt
  updatedBy
  updatedAt
  actionable
  transactions {
    ...WorkItemTransactionFields
  }
  reviewState
  review {
    ...WorkItemReviewFields
  }
  generatedQuestions {
    ...WorkItemGeneratedQuestionFields
  }
  pushes {
    ...WorkItemPushFields
  }
}
    ${WorkItemTransactionFieldsFragmentDoc}
${WorkItemReviewFieldsFragmentDoc}
${WorkItemGeneratedQuestionFieldsFragmentDoc}
${WorkItemPushFieldsFragmentDoc}`;
export const WorkItemSummaryFieldsFragmentDoc = gql`
    fragment WorkItemSummaryFields on WorkItemSummary {
  period {
    ...PeriodFields
  }
  count
}
    ${PeriodFieldsFragmentDoc}`;
export const ActivityObjectIdentifierFieldsFragmentDoc = gql`
    fragment ActivityObjectIdentifierFields on ActivityObjectIdentifier {
  kind
  id
  context
}
    `;
export const EntityConnectionFieldsFragmentDoc = gql`
    fragment EntityConnectionFields on EntityConnection {
  id
  connectorId
  dataSourceId
}
    `;
export const EntityInstitutionFieldsFragmentDoc = gql`
    fragment EntityInstitutionFields on EntityInstitution {
  id
  name
  iconUrl
}
    `;
export const AddAffiliatedSubscriptionPriceDocument = gql`
    mutation AddAffiliatedSubscriptionPrice($organizationId: String!, $affiliatedOrganizationId: String!, $affiliatedLegalEntityId: String!, $priceId: String!) {
  addAffiliatedSubscriptionPrice(
    organizationId: $organizationId
    affiliatedOrganizationId: $affiliatedOrganizationId
    affiliatedLegalEntityId: $affiliatedLegalEntityId
    priceId: $priceId
  )
}
    `;
export type AddAffiliatedSubscriptionPriceMutationFn = Apollo.MutationFunction<AddAffiliatedSubscriptionPriceMutation, AddAffiliatedSubscriptionPriceMutationVariables>;

/**
 * __useAddAffiliatedSubscriptionPriceMutation__
 *
 * To run a mutation, you first call `useAddAffiliatedSubscriptionPriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAffiliatedSubscriptionPriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAffiliatedSubscriptionPriceMutation, { data, loading, error }] = useAddAffiliatedSubscriptionPriceMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      affiliatedOrganizationId: // value for 'affiliatedOrganizationId'
 *      affiliatedLegalEntityId: // value for 'affiliatedLegalEntityId'
 *      priceId: // value for 'priceId'
 *   },
 * });
 */
export function useAddAffiliatedSubscriptionPriceMutation(baseOptions?: Apollo.MutationHookOptions<AddAffiliatedSubscriptionPriceMutation, AddAffiliatedSubscriptionPriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAffiliatedSubscriptionPriceMutation, AddAffiliatedSubscriptionPriceMutationVariables>(AddAffiliatedSubscriptionPriceDocument, options);
      }
export type AddAffiliatedSubscriptionPriceMutationHookResult = ReturnType<typeof useAddAffiliatedSubscriptionPriceMutation>;
export type AddAffiliatedSubscriptionPriceMutationResult = Apollo.MutationResult<AddAffiliatedSubscriptionPriceMutation>;
export type AddAffiliatedSubscriptionPriceMutationOptions = Apollo.BaseMutationOptions<AddAffiliatedSubscriptionPriceMutation, AddAffiliatedSubscriptionPriceMutationVariables>;
export const AttachClientPaysLegalEntityDocument = gql`
    mutation AttachClientPaysLegalEntity($organizationId: String!, $legalEntityId: String!, $attachmentOrganizationId: String!) {
  attachClientPaysLegalEntity(
    organizationId: $organizationId
    legalEntityId: $legalEntityId
    attachmentOrganizationId: $attachmentOrganizationId
  )
}
    `;
export type AttachClientPaysLegalEntityMutationFn = Apollo.MutationFunction<AttachClientPaysLegalEntityMutation, AttachClientPaysLegalEntityMutationVariables>;

/**
 * __useAttachClientPaysLegalEntityMutation__
 *
 * To run a mutation, you first call `useAttachClientPaysLegalEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachClientPaysLegalEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachClientPaysLegalEntityMutation, { data, loading, error }] = useAttachClientPaysLegalEntityMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      legalEntityId: // value for 'legalEntityId'
 *      attachmentOrganizationId: // value for 'attachmentOrganizationId'
 *   },
 * });
 */
export function useAttachClientPaysLegalEntityMutation(baseOptions?: Apollo.MutationHookOptions<AttachClientPaysLegalEntityMutation, AttachClientPaysLegalEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AttachClientPaysLegalEntityMutation, AttachClientPaysLegalEntityMutationVariables>(AttachClientPaysLegalEntityDocument, options);
      }
export type AttachClientPaysLegalEntityMutationHookResult = ReturnType<typeof useAttachClientPaysLegalEntityMutation>;
export type AttachClientPaysLegalEntityMutationResult = Apollo.MutationResult<AttachClientPaysLegalEntityMutation>;
export type AttachClientPaysLegalEntityMutationOptions = Apollo.BaseMutationOptions<AttachClientPaysLegalEntityMutation, AttachClientPaysLegalEntityMutationVariables>;
export const AttachLegalEntityDocument = gql`
    mutation AttachLegalEntity($organizationId: String!, $legalEntityId: String!, $attachmentOrganizationId: String!) {
  attachLegalEntity(
    organizationId: $organizationId
    legalEntityId: $legalEntityId
    attachmentOrganizationId: $attachmentOrganizationId
  )
}
    `;
export type AttachLegalEntityMutationFn = Apollo.MutationFunction<AttachLegalEntityMutation, AttachLegalEntityMutationVariables>;

/**
 * __useAttachLegalEntityMutation__
 *
 * To run a mutation, you first call `useAttachLegalEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachLegalEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachLegalEntityMutation, { data, loading, error }] = useAttachLegalEntityMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      legalEntityId: // value for 'legalEntityId'
 *      attachmentOrganizationId: // value for 'attachmentOrganizationId'
 *   },
 * });
 */
export function useAttachLegalEntityMutation(baseOptions?: Apollo.MutationHookOptions<AttachLegalEntityMutation, AttachLegalEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AttachLegalEntityMutation, AttachLegalEntityMutationVariables>(AttachLegalEntityDocument, options);
      }
export type AttachLegalEntityMutationHookResult = ReturnType<typeof useAttachLegalEntityMutation>;
export type AttachLegalEntityMutationResult = Apollo.MutationResult<AttachLegalEntityMutation>;
export type AttachLegalEntityMutationOptions = Apollo.BaseMutationOptions<AttachLegalEntityMutation, AttachLegalEntityMutationVariables>;
export const DetachClientPaysClientDocument = gql`
    mutation DetachClientPaysClient($firmOrganizationId: String!, $clientLegalEntityId: String!, $clientOrganizationId: String!) {
  detachClientPaysClient(
    firmOrganizationId: $firmOrganizationId
    clientLegalEntityId: $clientLegalEntityId
    clientOrganizationId: $clientOrganizationId
  )
}
    `;
export type DetachClientPaysClientMutationFn = Apollo.MutationFunction<DetachClientPaysClientMutation, DetachClientPaysClientMutationVariables>;

/**
 * __useDetachClientPaysClientMutation__
 *
 * To run a mutation, you first call `useDetachClientPaysClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetachClientPaysClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detachClientPaysClientMutation, { data, loading, error }] = useDetachClientPaysClientMutation({
 *   variables: {
 *      firmOrganizationId: // value for 'firmOrganizationId'
 *      clientLegalEntityId: // value for 'clientLegalEntityId'
 *      clientOrganizationId: // value for 'clientOrganizationId'
 *   },
 * });
 */
export function useDetachClientPaysClientMutation(baseOptions?: Apollo.MutationHookOptions<DetachClientPaysClientMutation, DetachClientPaysClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DetachClientPaysClientMutation, DetachClientPaysClientMutationVariables>(DetachClientPaysClientDocument, options);
      }
export type DetachClientPaysClientMutationHookResult = ReturnType<typeof useDetachClientPaysClientMutation>;
export type DetachClientPaysClientMutationResult = Apollo.MutationResult<DetachClientPaysClientMutation>;
export type DetachClientPaysClientMutationOptions = Apollo.BaseMutationOptions<DetachClientPaysClientMutation, DetachClientPaysClientMutationVariables>;
export const DetachFirmClientDocument = gql`
    mutation DetachFirmClient($firmOrganizationId: String!, $clientLegalEntityId: String!) {
  detachFirmClient(
    firmOrganizationId: $firmOrganizationId
    clientLegalEntityId: $clientLegalEntityId
  )
}
    `;
export type DetachFirmClientMutationFn = Apollo.MutationFunction<DetachFirmClientMutation, DetachFirmClientMutationVariables>;

/**
 * __useDetachFirmClientMutation__
 *
 * To run a mutation, you first call `useDetachFirmClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetachFirmClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detachFirmClientMutation, { data, loading, error }] = useDetachFirmClientMutation({
 *   variables: {
 *      firmOrganizationId: // value for 'firmOrganizationId'
 *      clientLegalEntityId: // value for 'clientLegalEntityId'
 *   },
 * });
 */
export function useDetachFirmClientMutation(baseOptions?: Apollo.MutationHookOptions<DetachFirmClientMutation, DetachFirmClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DetachFirmClientMutation, DetachFirmClientMutationVariables>(DetachFirmClientDocument, options);
      }
export type DetachFirmClientMutationHookResult = ReturnType<typeof useDetachFirmClientMutation>;
export type DetachFirmClientMutationResult = Apollo.MutationResult<DetachFirmClientMutation>;
export type DetachFirmClientMutationOptions = Apollo.BaseMutationOptions<DetachFirmClientMutation, DetachFirmClientMutationVariables>;
export const MigrateFirmClientDocument = gql`
    mutation MigrateFirmClient($sourceFirmOrganizationId: String!, $targetFirmOrganizationId: String!, $clientLegalEntityId: String!) {
  migrateFirmClient(
    sourceFirmOrganizationId: $sourceFirmOrganizationId
    targetFirmOrganizationId: $targetFirmOrganizationId
    clientLegalEntityId: $clientLegalEntityId
  )
}
    `;
export type MigrateFirmClientMutationFn = Apollo.MutationFunction<MigrateFirmClientMutation, MigrateFirmClientMutationVariables>;

/**
 * __useMigrateFirmClientMutation__
 *
 * To run a mutation, you first call `useMigrateFirmClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMigrateFirmClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [migrateFirmClientMutation, { data, loading, error }] = useMigrateFirmClientMutation({
 *   variables: {
 *      sourceFirmOrganizationId: // value for 'sourceFirmOrganizationId'
 *      targetFirmOrganizationId: // value for 'targetFirmOrganizationId'
 *      clientLegalEntityId: // value for 'clientLegalEntityId'
 *   },
 * });
 */
export function useMigrateFirmClientMutation(baseOptions?: Apollo.MutationHookOptions<MigrateFirmClientMutation, MigrateFirmClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MigrateFirmClientMutation, MigrateFirmClientMutationVariables>(MigrateFirmClientDocument, options);
      }
export type MigrateFirmClientMutationHookResult = ReturnType<typeof useMigrateFirmClientMutation>;
export type MigrateFirmClientMutationResult = Apollo.MutationResult<MigrateFirmClientMutation>;
export type MigrateFirmClientMutationOptions = Apollo.BaseMutationOptions<MigrateFirmClientMutation, MigrateFirmClientMutationVariables>;
export const ListAvailablePlansDocument = gql`
    query ListAvailablePlans($organizationId: String!) {
  listAvailablePlans(organizationId: $organizationId) {
    product {
      id
      name
      displayName
      billable
    }
    price {
      id
    }
  }
}
    `;

/**
 * __useListAvailablePlansQuery__
 *
 * To run a query within a React component, call `useListAvailablePlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAvailablePlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAvailablePlansQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useListAvailablePlansQuery(baseOptions: Apollo.QueryHookOptions<ListAvailablePlansQuery, ListAvailablePlansQueryVariables> & ({ variables: ListAvailablePlansQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAvailablePlansQuery, ListAvailablePlansQueryVariables>(ListAvailablePlansDocument, options);
      }
export function useListAvailablePlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAvailablePlansQuery, ListAvailablePlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAvailablePlansQuery, ListAvailablePlansQueryVariables>(ListAvailablePlansDocument, options);
        }
export function useListAvailablePlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAvailablePlansQuery, ListAvailablePlansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAvailablePlansQuery, ListAvailablePlansQueryVariables>(ListAvailablePlansDocument, options);
        }
export type ListAvailablePlansQueryHookResult = ReturnType<typeof useListAvailablePlansQuery>;
export type ListAvailablePlansLazyQueryHookResult = ReturnType<typeof useListAvailablePlansLazyQuery>;
export type ListAvailablePlansSuspenseQueryHookResult = ReturnType<typeof useListAvailablePlansSuspenseQuery>;
export type ListAvailablePlansQueryResult = Apollo.QueryResult<ListAvailablePlansQuery, ListAvailablePlansQueryVariables>;
export const HydratePartyAgentDocument = gql`
    subscription HydratePartyAgent($value: String!) {
  hydratePartyAgent(value: $value) {
    agentEvent {
      runStatus
      message
    }
  }
}
    `;

/**
 * __useHydratePartyAgentSubscription__
 *
 * To run a query within a React component, call `useHydratePartyAgentSubscription` and pass it any options that fit your needs.
 * When your component renders, `useHydratePartyAgentSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHydratePartyAgentSubscription({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useHydratePartyAgentSubscription(baseOptions: Apollo.SubscriptionHookOptions<HydratePartyAgentSubscription, HydratePartyAgentSubscriptionVariables> & ({ variables: HydratePartyAgentSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<HydratePartyAgentSubscription, HydratePartyAgentSubscriptionVariables>(HydratePartyAgentDocument, options);
      }
export type HydratePartyAgentSubscriptionHookResult = ReturnType<typeof useHydratePartyAgentSubscription>;
export type HydratePartyAgentSubscriptionResult = Apollo.SubscriptionResult<HydratePartyAgentSubscription>;
export const AddOrganizationPackageAspectDocument = gql`
    mutation AddOrganizationPackageAspect($organizationId: String!, $packageId: String!, $aspectId: String!) {
  addOrganizationPackageAspect(
    organizationId: $organizationId
    packageId: $packageId
    aspectId: $aspectId
  )
}
    `;
export type AddOrganizationPackageAspectMutationFn = Apollo.MutationFunction<AddOrganizationPackageAspectMutation, AddOrganizationPackageAspectMutationVariables>;

/**
 * __useAddOrganizationPackageAspectMutation__
 *
 * To run a mutation, you first call `useAddOrganizationPackageAspectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrganizationPackageAspectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrganizationPackageAspectMutation, { data, loading, error }] = useAddOrganizationPackageAspectMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      packageId: // value for 'packageId'
 *      aspectId: // value for 'aspectId'
 *   },
 * });
 */
export function useAddOrganizationPackageAspectMutation(baseOptions?: Apollo.MutationHookOptions<AddOrganizationPackageAspectMutation, AddOrganizationPackageAspectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOrganizationPackageAspectMutation, AddOrganizationPackageAspectMutationVariables>(AddOrganizationPackageAspectDocument, options);
      }
export type AddOrganizationPackageAspectMutationHookResult = ReturnType<typeof useAddOrganizationPackageAspectMutation>;
export type AddOrganizationPackageAspectMutationResult = Apollo.MutationResult<AddOrganizationPackageAspectMutation>;
export type AddOrganizationPackageAspectMutationOptions = Apollo.BaseMutationOptions<AddOrganizationPackageAspectMutation, AddOrganizationPackageAspectMutationVariables>;
export const ApproveRequestDocument = gql`
    mutation ApproveRequest($id: String!) {
  approveRequest(id: $id)
}
    `;
export type ApproveRequestMutationFn = Apollo.MutationFunction<ApproveRequestMutation, ApproveRequestMutationVariables>;

/**
 * __useApproveRequestMutation__
 *
 * To run a mutation, you first call `useApproveRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveRequestMutation, { data, loading, error }] = useApproveRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveRequestMutation(baseOptions?: Apollo.MutationHookOptions<ApproveRequestMutation, ApproveRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveRequestMutation, ApproveRequestMutationVariables>(ApproveRequestDocument, options);
      }
export type ApproveRequestMutationHookResult = ReturnType<typeof useApproveRequestMutation>;
export type ApproveRequestMutationResult = Apollo.MutationResult<ApproveRequestMutation>;
export type ApproveRequestMutationOptions = Apollo.BaseMutationOptions<ApproveRequestMutation, ApproveRequestMutationVariables>;
export const DeleteAspectStatusDocument = gql`
    mutation DeleteAspectStatus($legalEntityId: String!, $aspectId: String!) {
  deleteAspectStatus(legalEntityId: $legalEntityId, aspectId: $aspectId)
}
    `;
export type DeleteAspectStatusMutationFn = Apollo.MutationFunction<DeleteAspectStatusMutation, DeleteAspectStatusMutationVariables>;

/**
 * __useDeleteAspectStatusMutation__
 *
 * To run a mutation, you first call `useDeleteAspectStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAspectStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAspectStatusMutation, { data, loading, error }] = useDeleteAspectStatusMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      aspectId: // value for 'aspectId'
 *   },
 * });
 */
export function useDeleteAspectStatusMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAspectStatusMutation, DeleteAspectStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAspectStatusMutation, DeleteAspectStatusMutationVariables>(DeleteAspectStatusDocument, options);
      }
export type DeleteAspectStatusMutationHookResult = ReturnType<typeof useDeleteAspectStatusMutation>;
export type DeleteAspectStatusMutationResult = Apollo.MutationResult<DeleteAspectStatusMutation>;
export type DeleteAspectStatusMutationOptions = Apollo.BaseMutationOptions<DeleteAspectStatusMutation, DeleteAspectStatusMutationVariables>;
export const DeleteOrganizationAspectStatusDocument = gql`
    mutation DeleteOrganizationAspectStatus($organizationId: String!, $aspectId: String!) {
  deleteOrganizationAspectStatus(
    organizationId: $organizationId
    aspectId: $aspectId
  )
}
    `;
export type DeleteOrganizationAspectStatusMutationFn = Apollo.MutationFunction<DeleteOrganizationAspectStatusMutation, DeleteOrganizationAspectStatusMutationVariables>;

/**
 * __useDeleteOrganizationAspectStatusMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationAspectStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationAspectStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationAspectStatusMutation, { data, loading, error }] = useDeleteOrganizationAspectStatusMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      aspectId: // value for 'aspectId'
 *   },
 * });
 */
export function useDeleteOrganizationAspectStatusMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationAspectStatusMutation, DeleteOrganizationAspectStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationAspectStatusMutation, DeleteOrganizationAspectStatusMutationVariables>(DeleteOrganizationAspectStatusDocument, options);
      }
export type DeleteOrganizationAspectStatusMutationHookResult = ReturnType<typeof useDeleteOrganizationAspectStatusMutation>;
export type DeleteOrganizationAspectStatusMutationResult = Apollo.MutationResult<DeleteOrganizationAspectStatusMutation>;
export type DeleteOrganizationAspectStatusMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationAspectStatusMutation, DeleteOrganizationAspectStatusMutationVariables>;
export const EnableCategoryManagerDocument = gql`
    mutation EnableCategoryManager($legalEntityId: String!) {
  enableCategoryManager(legalEntityId: $legalEntityId)
}
    `;
export type EnableCategoryManagerMutationFn = Apollo.MutationFunction<EnableCategoryManagerMutation, EnableCategoryManagerMutationVariables>;

/**
 * __useEnableCategoryManagerMutation__
 *
 * To run a mutation, you first call `useEnableCategoryManagerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableCategoryManagerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableCategoryManagerMutation, { data, loading, error }] = useEnableCategoryManagerMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useEnableCategoryManagerMutation(baseOptions?: Apollo.MutationHookOptions<EnableCategoryManagerMutation, EnableCategoryManagerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableCategoryManagerMutation, EnableCategoryManagerMutationVariables>(EnableCategoryManagerDocument, options);
      }
export type EnableCategoryManagerMutationHookResult = ReturnType<typeof useEnableCategoryManagerMutation>;
export type EnableCategoryManagerMutationResult = Apollo.MutationResult<EnableCategoryManagerMutation>;
export type EnableCategoryManagerMutationOptions = Apollo.BaseMutationOptions<EnableCategoryManagerMutation, EnableCategoryManagerMutationVariables>;
export const RemoveOrganizationPackageAspectDocument = gql`
    mutation RemoveOrganizationPackageAspect($organizationId: String!, $packageId: String!, $aspectId: String!, $comment: String!, $contextUrl: String!) {
  removeOrganizationPackageAspect(
    organizationId: $organizationId
    packageId: $packageId
    aspectId: $aspectId
    comment: $comment
    contextUrl: $contextUrl
  )
}
    `;
export type RemoveOrganizationPackageAspectMutationFn = Apollo.MutationFunction<RemoveOrganizationPackageAspectMutation, RemoveOrganizationPackageAspectMutationVariables>;

/**
 * __useRemoveOrganizationPackageAspectMutation__
 *
 * To run a mutation, you first call `useRemoveOrganizationPackageAspectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOrganizationPackageAspectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOrganizationPackageAspectMutation, { data, loading, error }] = useRemoveOrganizationPackageAspectMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      packageId: // value for 'packageId'
 *      aspectId: // value for 'aspectId'
 *      comment: // value for 'comment'
 *      contextUrl: // value for 'contextUrl'
 *   },
 * });
 */
export function useRemoveOrganizationPackageAspectMutation(baseOptions?: Apollo.MutationHookOptions<RemoveOrganizationPackageAspectMutation, RemoveOrganizationPackageAspectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveOrganizationPackageAspectMutation, RemoveOrganizationPackageAspectMutationVariables>(RemoveOrganizationPackageAspectDocument, options);
      }
export type RemoveOrganizationPackageAspectMutationHookResult = ReturnType<typeof useRemoveOrganizationPackageAspectMutation>;
export type RemoveOrganizationPackageAspectMutationResult = Apollo.MutationResult<RemoveOrganizationPackageAspectMutation>;
export type RemoveOrganizationPackageAspectMutationOptions = Apollo.BaseMutationOptions<RemoveOrganizationPackageAspectMutation, RemoveOrganizationPackageAspectMutationVariables>;
export const UpdateAspectStatusDocument = gql`
    mutation UpdateAspectStatus($legalEntityId: String!, $aspectId: String!, $status: AspectStatusValue!) {
  updateAspectStatus(
    legalEntityId: $legalEntityId
    aspectId: $aspectId
    status: $status
  )
}
    `;
export type UpdateAspectStatusMutationFn = Apollo.MutationFunction<UpdateAspectStatusMutation, UpdateAspectStatusMutationVariables>;

/**
 * __useUpdateAspectStatusMutation__
 *
 * To run a mutation, you first call `useUpdateAspectStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAspectStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAspectStatusMutation, { data, loading, error }] = useUpdateAspectStatusMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      aspectId: // value for 'aspectId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateAspectStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAspectStatusMutation, UpdateAspectStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAspectStatusMutation, UpdateAspectStatusMutationVariables>(UpdateAspectStatusDocument, options);
      }
export type UpdateAspectStatusMutationHookResult = ReturnType<typeof useUpdateAspectStatusMutation>;
export type UpdateAspectStatusMutationResult = Apollo.MutationResult<UpdateAspectStatusMutation>;
export type UpdateAspectStatusMutationOptions = Apollo.BaseMutationOptions<UpdateAspectStatusMutation, UpdateAspectStatusMutationVariables>;
export const UpdateOrganizationAspectStatusDocument = gql`
    mutation UpdateOrganizationAspectStatus($organizationId: String!, $aspectId: String!, $status: AspectStatusValue!) {
  updateOrganizationAspectStatus(
    organizationId: $organizationId
    aspectId: $aspectId
    status: $status
  )
}
    `;
export type UpdateOrganizationAspectStatusMutationFn = Apollo.MutationFunction<UpdateOrganizationAspectStatusMutation, UpdateOrganizationAspectStatusMutationVariables>;

/**
 * __useUpdateOrganizationAspectStatusMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationAspectStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationAspectStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationAspectStatusMutation, { data, loading, error }] = useUpdateOrganizationAspectStatusMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      aspectId: // value for 'aspectId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateOrganizationAspectStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationAspectStatusMutation, UpdateOrganizationAspectStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationAspectStatusMutation, UpdateOrganizationAspectStatusMutationVariables>(UpdateOrganizationAspectStatusDocument, options);
      }
export type UpdateOrganizationAspectStatusMutationHookResult = ReturnType<typeof useUpdateOrganizationAspectStatusMutation>;
export type UpdateOrganizationAspectStatusMutationResult = Apollo.MutationResult<UpdateOrganizationAspectStatusMutation>;
export type UpdateOrganizationAspectStatusMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationAspectStatusMutation, UpdateOrganizationAspectStatusMutationVariables>;
export const ListAspectRequestsDocument = gql`
    query ListAspectRequests($legalEntityId: String!) {
  listAspectRequests(legalEntityId: $legalEntityId) {
    ...AspectRequestFields
  }
}
    ${AspectRequestFieldsFragmentDoc}`;

/**
 * __useListAspectRequestsQuery__
 *
 * To run a query within a React component, call `useListAspectRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAspectRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAspectRequestsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListAspectRequestsQuery(baseOptions: Apollo.QueryHookOptions<ListAspectRequestsQuery, ListAspectRequestsQueryVariables> & ({ variables: ListAspectRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAspectRequestsQuery, ListAspectRequestsQueryVariables>(ListAspectRequestsDocument, options);
      }
export function useListAspectRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAspectRequestsQuery, ListAspectRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAspectRequestsQuery, ListAspectRequestsQueryVariables>(ListAspectRequestsDocument, options);
        }
export function useListAspectRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAspectRequestsQuery, ListAspectRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAspectRequestsQuery, ListAspectRequestsQueryVariables>(ListAspectRequestsDocument, options);
        }
export type ListAspectRequestsQueryHookResult = ReturnType<typeof useListAspectRequestsQuery>;
export type ListAspectRequestsLazyQueryHookResult = ReturnType<typeof useListAspectRequestsLazyQuery>;
export type ListAspectRequestsSuspenseQueryHookResult = ReturnType<typeof useListAspectRequestsSuspenseQuery>;
export type ListAspectRequestsQueryResult = Apollo.QueryResult<ListAspectRequestsQuery, ListAspectRequestsQueryVariables>;
export const ListAspectStatusesDocument = gql`
    query ListAspectStatuses($legalEntityId: String!) {
  listAspectStatuses(legalEntityId: $legalEntityId) {
    ...LegalEntityAspectStatusFields
  }
}
    ${LegalEntityAspectStatusFieldsFragmentDoc}`;

/**
 * __useListAspectStatusesQuery__
 *
 * To run a query within a React component, call `useListAspectStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAspectStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAspectStatusesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListAspectStatusesQuery(baseOptions: Apollo.QueryHookOptions<ListAspectStatusesQuery, ListAspectStatusesQueryVariables> & ({ variables: ListAspectStatusesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAspectStatusesQuery, ListAspectStatusesQueryVariables>(ListAspectStatusesDocument, options);
      }
export function useListAspectStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAspectStatusesQuery, ListAspectStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAspectStatusesQuery, ListAspectStatusesQueryVariables>(ListAspectStatusesDocument, options);
        }
export function useListAspectStatusesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAspectStatusesQuery, ListAspectStatusesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAspectStatusesQuery, ListAspectStatusesQueryVariables>(ListAspectStatusesDocument, options);
        }
export type ListAspectStatusesQueryHookResult = ReturnType<typeof useListAspectStatusesQuery>;
export type ListAspectStatusesLazyQueryHookResult = ReturnType<typeof useListAspectStatusesLazyQuery>;
export type ListAspectStatusesSuspenseQueryHookResult = ReturnType<typeof useListAspectStatusesSuspenseQuery>;
export type ListAspectStatusesQueryResult = Apollo.QueryResult<ListAspectStatusesQuery, ListAspectStatusesQueryVariables>;
export const ListAspectsDocument = gql`
    query ListAspects($filter: [AspectFilter!]) {
  listAspects(filter: $filter) {
    ...AspectFields
  }
}
    ${AspectFieldsFragmentDoc}`;

/**
 * __useListAspectsQuery__
 *
 * To run a query within a React component, call `useListAspectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAspectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAspectsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListAspectsQuery(baseOptions?: Apollo.QueryHookOptions<ListAspectsQuery, ListAspectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAspectsQuery, ListAspectsQueryVariables>(ListAspectsDocument, options);
      }
export function useListAspectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAspectsQuery, ListAspectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAspectsQuery, ListAspectsQueryVariables>(ListAspectsDocument, options);
        }
export function useListAspectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAspectsQuery, ListAspectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAspectsQuery, ListAspectsQueryVariables>(ListAspectsDocument, options);
        }
export type ListAspectsQueryHookResult = ReturnType<typeof useListAspectsQuery>;
export type ListAspectsLazyQueryHookResult = ReturnType<typeof useListAspectsLazyQuery>;
export type ListAspectsSuspenseQueryHookResult = ReturnType<typeof useListAspectsSuspenseQuery>;
export type ListAspectsQueryResult = Apollo.QueryResult<ListAspectsQuery, ListAspectsQueryVariables>;
export const ListOrganizationAspectStatusesDocument = gql`
    query ListOrganizationAspectStatuses($organizationId: String!) {
  listOrganizationAspectStatuses(organizationId: $organizationId) {
    ...AspectStatusFields
  }
}
    ${AspectStatusFieldsFragmentDoc}`;

/**
 * __useListOrganizationAspectStatusesQuery__
 *
 * To run a query within a React component, call `useListOrganizationAspectStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOrganizationAspectStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOrganizationAspectStatusesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useListOrganizationAspectStatusesQuery(baseOptions: Apollo.QueryHookOptions<ListOrganizationAspectStatusesQuery, ListOrganizationAspectStatusesQueryVariables> & ({ variables: ListOrganizationAspectStatusesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListOrganizationAspectStatusesQuery, ListOrganizationAspectStatusesQueryVariables>(ListOrganizationAspectStatusesDocument, options);
      }
export function useListOrganizationAspectStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListOrganizationAspectStatusesQuery, ListOrganizationAspectStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListOrganizationAspectStatusesQuery, ListOrganizationAspectStatusesQueryVariables>(ListOrganizationAspectStatusesDocument, options);
        }
export function useListOrganizationAspectStatusesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListOrganizationAspectStatusesQuery, ListOrganizationAspectStatusesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListOrganizationAspectStatusesQuery, ListOrganizationAspectStatusesQueryVariables>(ListOrganizationAspectStatusesDocument, options);
        }
export type ListOrganizationAspectStatusesQueryHookResult = ReturnType<typeof useListOrganizationAspectStatusesQuery>;
export type ListOrganizationAspectStatusesLazyQueryHookResult = ReturnType<typeof useListOrganizationAspectStatusesLazyQuery>;
export type ListOrganizationAspectStatusesSuspenseQueryHookResult = ReturnType<typeof useListOrganizationAspectStatusesSuspenseQuery>;
export type ListOrganizationAspectStatusesQueryResult = Apollo.QueryResult<ListOrganizationAspectStatusesQuery, ListOrganizationAspectStatusesQueryVariables>;
export const ListOrganizationPackageAspectsDocument = gql`
    query ListOrganizationPackageAspects($organizationId: String!, $packageId: String!) {
  listOrganizationPackageAspects(
    organizationId: $organizationId
    packageId: $packageId
  ) {
    aspect {
      ...AspectFields
    }
  }
}
    ${AspectFieldsFragmentDoc}`;

/**
 * __useListOrganizationPackageAspectsQuery__
 *
 * To run a query within a React component, call `useListOrganizationPackageAspectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOrganizationPackageAspectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOrganizationPackageAspectsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      packageId: // value for 'packageId'
 *   },
 * });
 */
export function useListOrganizationPackageAspectsQuery(baseOptions: Apollo.QueryHookOptions<ListOrganizationPackageAspectsQuery, ListOrganizationPackageAspectsQueryVariables> & ({ variables: ListOrganizationPackageAspectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListOrganizationPackageAspectsQuery, ListOrganizationPackageAspectsQueryVariables>(ListOrganizationPackageAspectsDocument, options);
      }
export function useListOrganizationPackageAspectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListOrganizationPackageAspectsQuery, ListOrganizationPackageAspectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListOrganizationPackageAspectsQuery, ListOrganizationPackageAspectsQueryVariables>(ListOrganizationPackageAspectsDocument, options);
        }
export function useListOrganizationPackageAspectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListOrganizationPackageAspectsQuery, ListOrganizationPackageAspectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListOrganizationPackageAspectsQuery, ListOrganizationPackageAspectsQueryVariables>(ListOrganizationPackageAspectsDocument, options);
        }
export type ListOrganizationPackageAspectsQueryHookResult = ReturnType<typeof useListOrganizationPackageAspectsQuery>;
export type ListOrganizationPackageAspectsLazyQueryHookResult = ReturnType<typeof useListOrganizationPackageAspectsLazyQuery>;
export type ListOrganizationPackageAspectsSuspenseQueryHookResult = ReturnType<typeof useListOrganizationPackageAspectsSuspenseQuery>;
export type ListOrganizationPackageAspectsQueryResult = Apollo.QueryResult<ListOrganizationPackageAspectsQuery, ListOrganizationPackageAspectsQueryVariables>;
export const CreateEnterpriseOrganizationDocument = gql`
    mutation CreateEnterpriseOrganization($name: String!, $comment: String!, $contextUrl: String!) {
  createEnterpriseOrganization(
    name: $name
    comment: $comment
    contextUrl: $contextUrl
  ) {
    organizationId
    organizationName
    packageId
  }
}
    `;
export type CreateEnterpriseOrganizationMutationFn = Apollo.MutationFunction<CreateEnterpriseOrganizationMutation, CreateEnterpriseOrganizationMutationVariables>;

/**
 * __useCreateEnterpriseOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateEnterpriseOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEnterpriseOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEnterpriseOrganizationMutation, { data, loading, error }] = useCreateEnterpriseOrganizationMutation({
 *   variables: {
 *      name: // value for 'name'
 *      comment: // value for 'comment'
 *      contextUrl: // value for 'contextUrl'
 *   },
 * });
 */
export function useCreateEnterpriseOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<CreateEnterpriseOrganizationMutation, CreateEnterpriseOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEnterpriseOrganizationMutation, CreateEnterpriseOrganizationMutationVariables>(CreateEnterpriseOrganizationDocument, options);
      }
export type CreateEnterpriseOrganizationMutationHookResult = ReturnType<typeof useCreateEnterpriseOrganizationMutation>;
export type CreateEnterpriseOrganizationMutationResult = Apollo.MutationResult<CreateEnterpriseOrganizationMutation>;
export type CreateEnterpriseOrganizationMutationOptions = Apollo.BaseMutationOptions<CreateEnterpriseOrganizationMutation, CreateEnterpriseOrganizationMutationVariables>;
export const CreateOrganizationPackageDocument = gql`
    mutation CreateOrganizationPackage($organizationId: String!, $comment: String!, $contextUrl: String!) {
  createOrganizationPackage(
    organizationId: $organizationId
    comment: $comment
    contextUrl: $contextUrl
  )
}
    `;
export type CreateOrganizationPackageMutationFn = Apollo.MutationFunction<CreateOrganizationPackageMutation, CreateOrganizationPackageMutationVariables>;

/**
 * __useCreateOrganizationPackageMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationPackageMutation, { data, loading, error }] = useCreateOrganizationPackageMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      comment: // value for 'comment'
 *      contextUrl: // value for 'contextUrl'
 *   },
 * });
 */
export function useCreateOrganizationPackageMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationPackageMutation, CreateOrganizationPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationPackageMutation, CreateOrganizationPackageMutationVariables>(CreateOrganizationPackageDocument, options);
      }
export type CreateOrganizationPackageMutationHookResult = ReturnType<typeof useCreateOrganizationPackageMutation>;
export type CreateOrganizationPackageMutationResult = Apollo.MutationResult<CreateOrganizationPackageMutation>;
export type CreateOrganizationPackageMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationPackageMutation, CreateOrganizationPackageMutationVariables>;
export const CreateOrganizationPackageProductDocument = gql`
    mutation CreateOrganizationPackageProduct($organizationId: String!, $packageId: String!, $productId: String!, $billable: Boolean!) {
  createOrganizationPackageProduct(
    organizationId: $organizationId
    packageId: $packageId
    productId: $productId
    billable: $billable
  )
}
    `;
export type CreateOrganizationPackageProductMutationFn = Apollo.MutationFunction<CreateOrganizationPackageProductMutation, CreateOrganizationPackageProductMutationVariables>;

/**
 * __useCreateOrganizationPackageProductMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationPackageProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationPackageProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationPackageProductMutation, { data, loading, error }] = useCreateOrganizationPackageProductMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      packageId: // value for 'packageId'
 *      productId: // value for 'productId'
 *      billable: // value for 'billable'
 *   },
 * });
 */
export function useCreateOrganizationPackageProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationPackageProductMutation, CreateOrganizationPackageProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationPackageProductMutation, CreateOrganizationPackageProductMutationVariables>(CreateOrganizationPackageProductDocument, options);
      }
export type CreateOrganizationPackageProductMutationHookResult = ReturnType<typeof useCreateOrganizationPackageProductMutation>;
export type CreateOrganizationPackageProductMutationResult = Apollo.MutationResult<CreateOrganizationPackageProductMutation>;
export type CreateOrganizationPackageProductMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationPackageProductMutation, CreateOrganizationPackageProductMutationVariables>;
export const CreateOrganizationProductDocument = gql`
    mutation CreateOrganizationProduct($organizationId: String!, $productId: String!) {
  createOrganizationProduct(
    organizationId: $organizationId
    productId: $productId
  )
}
    `;
export type CreateOrganizationProductMutationFn = Apollo.MutationFunction<CreateOrganizationProductMutation, CreateOrganizationProductMutationVariables>;

/**
 * __useCreateOrganizationProductMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationProductMutation, { data, loading, error }] = useCreateOrganizationProductMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useCreateOrganizationProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationProductMutation, CreateOrganizationProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationProductMutation, CreateOrganizationProductMutationVariables>(CreateOrganizationProductDocument, options);
      }
export type CreateOrganizationProductMutationHookResult = ReturnType<typeof useCreateOrganizationProductMutation>;
export type CreateOrganizationProductMutationResult = Apollo.MutationResult<CreateOrganizationProductMutation>;
export type CreateOrganizationProductMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationProductMutation, CreateOrganizationProductMutationVariables>;
export const CreateOrganizationTierDocument = gql`
    mutation CreateOrganizationTier($organizationId: String!, $couponId: String!, $discountLevel: DiscountLevel!) {
  createOrganizationTier(
    organizationId: $organizationId
    couponId: $couponId
    discountLevel: $discountLevel
  )
}
    `;
export type CreateOrganizationTierMutationFn = Apollo.MutationFunction<CreateOrganizationTierMutation, CreateOrganizationTierMutationVariables>;

/**
 * __useCreateOrganizationTierMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationTierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationTierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationTierMutation, { data, loading, error }] = useCreateOrganizationTierMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      couponId: // value for 'couponId'
 *      discountLevel: // value for 'discountLevel'
 *   },
 * });
 */
export function useCreateOrganizationTierMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationTierMutation, CreateOrganizationTierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationTierMutation, CreateOrganizationTierMutationVariables>(CreateOrganizationTierDocument, options);
      }
export type CreateOrganizationTierMutationHookResult = ReturnType<typeof useCreateOrganizationTierMutation>;
export type CreateOrganizationTierMutationResult = Apollo.MutationResult<CreateOrganizationTierMutation>;
export type CreateOrganizationTierMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationTierMutation, CreateOrganizationTierMutationVariables>;
export const DeleteOrganizationPackageProductDocument = gql`
    mutation DeleteOrganizationPackageProduct($organizationId: String!, $packageId: String!, $productId: String!, $comment: String!, $contextUrl: String!) {
  deleteOrganizationPackageProduct(
    organizationId: $organizationId
    packageId: $packageId
    productId: $productId
    comment: $comment
    contextUrl: $contextUrl
  )
}
    `;
export type DeleteOrganizationPackageProductMutationFn = Apollo.MutationFunction<DeleteOrganizationPackageProductMutation, DeleteOrganizationPackageProductMutationVariables>;

/**
 * __useDeleteOrganizationPackageProductMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationPackageProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationPackageProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationPackageProductMutation, { data, loading, error }] = useDeleteOrganizationPackageProductMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      packageId: // value for 'packageId'
 *      productId: // value for 'productId'
 *      comment: // value for 'comment'
 *      contextUrl: // value for 'contextUrl'
 *   },
 * });
 */
export function useDeleteOrganizationPackageProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationPackageProductMutation, DeleteOrganizationPackageProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationPackageProductMutation, DeleteOrganizationPackageProductMutationVariables>(DeleteOrganizationPackageProductDocument, options);
      }
export type DeleteOrganizationPackageProductMutationHookResult = ReturnType<typeof useDeleteOrganizationPackageProductMutation>;
export type DeleteOrganizationPackageProductMutationResult = Apollo.MutationResult<DeleteOrganizationPackageProductMutation>;
export type DeleteOrganizationPackageProductMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationPackageProductMutation, DeleteOrganizationPackageProductMutationVariables>;
export const DeleteOrganizationProductDocument = gql`
    mutation DeleteOrganizationProduct($organizationId: String!, $productId: String!) {
  deleteOrganizationProduct(
    organizationId: $organizationId
    productId: $productId
  )
}
    `;
export type DeleteOrganizationProductMutationFn = Apollo.MutationFunction<DeleteOrganizationProductMutation, DeleteOrganizationProductMutationVariables>;

/**
 * __useDeleteOrganizationProductMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationProductMutation, { data, loading, error }] = useDeleteOrganizationProductMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useDeleteOrganizationProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationProductMutation, DeleteOrganizationProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationProductMutation, DeleteOrganizationProductMutationVariables>(DeleteOrganizationProductDocument, options);
      }
export type DeleteOrganizationProductMutationHookResult = ReturnType<typeof useDeleteOrganizationProductMutation>;
export type DeleteOrganizationProductMutationResult = Apollo.MutationResult<DeleteOrganizationProductMutation>;
export type DeleteOrganizationProductMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationProductMutation, DeleteOrganizationProductMutationVariables>;
export const DeleteOrganizationTierDocument = gql`
    mutation DeleteOrganizationTier($organizationId: String!, $couponId: String!) {
  deleteOrganizationTier(organizationId: $organizationId, couponId: $couponId)
}
    `;
export type DeleteOrganizationTierMutationFn = Apollo.MutationFunction<DeleteOrganizationTierMutation, DeleteOrganizationTierMutationVariables>;

/**
 * __useDeleteOrganizationTierMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationTierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationTierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationTierMutation, { data, loading, error }] = useDeleteOrganizationTierMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      couponId: // value for 'couponId'
 *   },
 * });
 */
export function useDeleteOrganizationTierMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationTierMutation, DeleteOrganizationTierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationTierMutation, DeleteOrganizationTierMutationVariables>(DeleteOrganizationTierDocument, options);
      }
export type DeleteOrganizationTierMutationHookResult = ReturnType<typeof useDeleteOrganizationTierMutation>;
export type DeleteOrganizationTierMutationResult = Apollo.MutationResult<DeleteOrganizationTierMutation>;
export type DeleteOrganizationTierMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationTierMutation, DeleteOrganizationTierMutationVariables>;
export const ProvisionOperatorSubscriptionDocument = gql`
    mutation ProvisionOperatorSubscription($organizationId: String!, $priceId: String!, $productId: String!, $stripeCustomerId: String, $userId: String, $legalEntityId: String) {
  provisionOperatorSubscription(
    organizationId: $organizationId
    priceId: $priceId
    productId: $productId
    stripeCustomerId: $stripeCustomerId
    userId: $userId
    legalEntityId: $legalEntityId
  )
}
    `;
export type ProvisionOperatorSubscriptionMutationFn = Apollo.MutationFunction<ProvisionOperatorSubscriptionMutation, ProvisionOperatorSubscriptionMutationVariables>;

/**
 * __useProvisionOperatorSubscriptionMutation__
 *
 * To run a mutation, you first call `useProvisionOperatorSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProvisionOperatorSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [provisionOperatorSubscriptionMutation, { data, loading, error }] = useProvisionOperatorSubscriptionMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      priceId: // value for 'priceId'
 *      productId: // value for 'productId'
 *      stripeCustomerId: // value for 'stripeCustomerId'
 *      userId: // value for 'userId'
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useProvisionOperatorSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<ProvisionOperatorSubscriptionMutation, ProvisionOperatorSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProvisionOperatorSubscriptionMutation, ProvisionOperatorSubscriptionMutationVariables>(ProvisionOperatorSubscriptionDocument, options);
      }
export type ProvisionOperatorSubscriptionMutationHookResult = ReturnType<typeof useProvisionOperatorSubscriptionMutation>;
export type ProvisionOperatorSubscriptionMutationResult = Apollo.MutationResult<ProvisionOperatorSubscriptionMutation>;
export type ProvisionOperatorSubscriptionMutationOptions = Apollo.BaseMutationOptions<ProvisionOperatorSubscriptionMutation, ProvisionOperatorSubscriptionMutationVariables>;
export const ResendClientPaysInvitationByOrganizationDocument = gql`
    mutation ResendClientPaysInvitationByOrganization($organizationId: String!, $firmOrganizationId: String!) {
  resendClientPaysInvitationByOrganization(
    organizationId: $organizationId
    firmOrganizationId: $firmOrganizationId
  )
}
    `;
export type ResendClientPaysInvitationByOrganizationMutationFn = Apollo.MutationFunction<ResendClientPaysInvitationByOrganizationMutation, ResendClientPaysInvitationByOrganizationMutationVariables>;

/**
 * __useResendClientPaysInvitationByOrganizationMutation__
 *
 * To run a mutation, you first call `useResendClientPaysInvitationByOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendClientPaysInvitationByOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendClientPaysInvitationByOrganizationMutation, { data, loading, error }] = useResendClientPaysInvitationByOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      firmOrganizationId: // value for 'firmOrganizationId'
 *   },
 * });
 */
export function useResendClientPaysInvitationByOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<ResendClientPaysInvitationByOrganizationMutation, ResendClientPaysInvitationByOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendClientPaysInvitationByOrganizationMutation, ResendClientPaysInvitationByOrganizationMutationVariables>(ResendClientPaysInvitationByOrganizationDocument, options);
      }
export type ResendClientPaysInvitationByOrganizationMutationHookResult = ReturnType<typeof useResendClientPaysInvitationByOrganizationMutation>;
export type ResendClientPaysInvitationByOrganizationMutationResult = Apollo.MutationResult<ResendClientPaysInvitationByOrganizationMutation>;
export type ResendClientPaysInvitationByOrganizationMutationOptions = Apollo.BaseMutationOptions<ResendClientPaysInvitationByOrganizationMutation, ResendClientPaysInvitationByOrganizationMutationVariables>;
export const ResumeSubscriptionDocument = gql`
    mutation ResumeSubscription($organizationId: String!, $ticketLink: String!, $comment: String!) {
  resumeSubscription(
    organizationId: $organizationId
    ticketLink: $ticketLink
    comment: $comment
  )
}
    `;
export type ResumeSubscriptionMutationFn = Apollo.MutationFunction<ResumeSubscriptionMutation, ResumeSubscriptionMutationVariables>;

/**
 * __useResumeSubscriptionMutation__
 *
 * To run a mutation, you first call `useResumeSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeSubscriptionMutation, { data, loading, error }] = useResumeSubscriptionMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      ticketLink: // value for 'ticketLink'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useResumeSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<ResumeSubscriptionMutation, ResumeSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResumeSubscriptionMutation, ResumeSubscriptionMutationVariables>(ResumeSubscriptionDocument, options);
      }
export type ResumeSubscriptionMutationHookResult = ReturnType<typeof useResumeSubscriptionMutation>;
export type ResumeSubscriptionMutationResult = Apollo.MutationResult<ResumeSubscriptionMutation>;
export type ResumeSubscriptionMutationOptions = Apollo.BaseMutationOptions<ResumeSubscriptionMutation, ResumeSubscriptionMutationVariables>;
export const ReviveOperatorSubscriptionDocument = gql`
    mutation ReviveOperatorSubscription($organizationId: String!, $priceId: String!, $ticketLink: String!, $comment: String!) {
  reviveOperatorSubscription(
    organizationId: $organizationId
    priceId: $priceId
    ticketLink: $ticketLink
    comment: $comment
  )
}
    `;
export type ReviveOperatorSubscriptionMutationFn = Apollo.MutationFunction<ReviveOperatorSubscriptionMutation, ReviveOperatorSubscriptionMutationVariables>;

/**
 * __useReviveOperatorSubscriptionMutation__
 *
 * To run a mutation, you first call `useReviveOperatorSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviveOperatorSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviveOperatorSubscriptionMutation, { data, loading, error }] = useReviveOperatorSubscriptionMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      priceId: // value for 'priceId'
 *      ticketLink: // value for 'ticketLink'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useReviveOperatorSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<ReviveOperatorSubscriptionMutation, ReviveOperatorSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReviveOperatorSubscriptionMutation, ReviveOperatorSubscriptionMutationVariables>(ReviveOperatorSubscriptionDocument, options);
      }
export type ReviveOperatorSubscriptionMutationHookResult = ReturnType<typeof useReviveOperatorSubscriptionMutation>;
export type ReviveOperatorSubscriptionMutationResult = Apollo.MutationResult<ReviveOperatorSubscriptionMutation>;
export type ReviveOperatorSubscriptionMutationOptions = Apollo.BaseMutationOptions<ReviveOperatorSubscriptionMutation, ReviveOperatorSubscriptionMutationVariables>;
export const UpdateAffiliatedSubscriptionPriceDocument = gql`
    mutation UpdateAffiliatedSubscriptionPrice($organizationId: String!, $affiliatedOrganizationId: String!, $affiliatedLegalEntityId: String!, $productId: String!, $priceId: String!, $ticketLink: String!, $comment: String!) {
  updateAffiliatedSubscriptionPrice(
    organizationId: $organizationId
    affiliatedOrganizationId: $affiliatedOrganizationId
    affiliatedLegalEntityId: $affiliatedLegalEntityId
    productId: $productId
    priceId: $priceId
    ticketLink: $ticketLink
    comment: $comment
  )
}
    `;
export type UpdateAffiliatedSubscriptionPriceMutationFn = Apollo.MutationFunction<UpdateAffiliatedSubscriptionPriceMutation, UpdateAffiliatedSubscriptionPriceMutationVariables>;

/**
 * __useUpdateAffiliatedSubscriptionPriceMutation__
 *
 * To run a mutation, you first call `useUpdateAffiliatedSubscriptionPriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAffiliatedSubscriptionPriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAffiliatedSubscriptionPriceMutation, { data, loading, error }] = useUpdateAffiliatedSubscriptionPriceMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      affiliatedOrganizationId: // value for 'affiliatedOrganizationId'
 *      affiliatedLegalEntityId: // value for 'affiliatedLegalEntityId'
 *      productId: // value for 'productId'
 *      priceId: // value for 'priceId'
 *      ticketLink: // value for 'ticketLink'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useUpdateAffiliatedSubscriptionPriceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAffiliatedSubscriptionPriceMutation, UpdateAffiliatedSubscriptionPriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAffiliatedSubscriptionPriceMutation, UpdateAffiliatedSubscriptionPriceMutationVariables>(UpdateAffiliatedSubscriptionPriceDocument, options);
      }
export type UpdateAffiliatedSubscriptionPriceMutationHookResult = ReturnType<typeof useUpdateAffiliatedSubscriptionPriceMutation>;
export type UpdateAffiliatedSubscriptionPriceMutationResult = Apollo.MutationResult<UpdateAffiliatedSubscriptionPriceMutation>;
export type UpdateAffiliatedSubscriptionPriceMutationOptions = Apollo.BaseMutationOptions<UpdateAffiliatedSubscriptionPriceMutation, UpdateAffiliatedSubscriptionPriceMutationVariables>;
export const UpdateOperatorSubscriptionDocument = gql`
    mutation UpdateOperatorSubscription($organizationId: String!, $priceId: String!, $ticketLink: String!, $comment: String!) {
  updateOperatorSubscription(
    organizationId: $organizationId
    priceId: $priceId
    ticketLink: $ticketLink
    comment: $comment
  )
}
    `;
export type UpdateOperatorSubscriptionMutationFn = Apollo.MutationFunction<UpdateOperatorSubscriptionMutation, UpdateOperatorSubscriptionMutationVariables>;

/**
 * __useUpdateOperatorSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateOperatorSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOperatorSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOperatorSubscriptionMutation, { data, loading, error }] = useUpdateOperatorSubscriptionMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      priceId: // value for 'priceId'
 *      ticketLink: // value for 'ticketLink'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useUpdateOperatorSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOperatorSubscriptionMutation, UpdateOperatorSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOperatorSubscriptionMutation, UpdateOperatorSubscriptionMutationVariables>(UpdateOperatorSubscriptionDocument, options);
      }
export type UpdateOperatorSubscriptionMutationHookResult = ReturnType<typeof useUpdateOperatorSubscriptionMutation>;
export type UpdateOperatorSubscriptionMutationResult = Apollo.MutationResult<UpdateOperatorSubscriptionMutation>;
export type UpdateOperatorSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpdateOperatorSubscriptionMutation, UpdateOperatorSubscriptionMutationVariables>;
export const UpdateOrganizationPackageProductDocument = gql`
    mutation UpdateOrganizationPackageProduct($organizationId: String!, $packageId: String!, $productId: String!, $billable: Boolean!) {
  updateOrganizationPackageProduct(
    organizationId: $organizationId
    packageId: $packageId
    productId: $productId
    billable: $billable
  )
}
    `;
export type UpdateOrganizationPackageProductMutationFn = Apollo.MutationFunction<UpdateOrganizationPackageProductMutation, UpdateOrganizationPackageProductMutationVariables>;

/**
 * __useUpdateOrganizationPackageProductMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationPackageProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationPackageProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationPackageProductMutation, { data, loading, error }] = useUpdateOrganizationPackageProductMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      packageId: // value for 'packageId'
 *      productId: // value for 'productId'
 *      billable: // value for 'billable'
 *   },
 * });
 */
export function useUpdateOrganizationPackageProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationPackageProductMutation, UpdateOrganizationPackageProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationPackageProductMutation, UpdateOrganizationPackageProductMutationVariables>(UpdateOrganizationPackageProductDocument, options);
      }
export type UpdateOrganizationPackageProductMutationHookResult = ReturnType<typeof useUpdateOrganizationPackageProductMutation>;
export type UpdateOrganizationPackageProductMutationResult = Apollo.MutationResult<UpdateOrganizationPackageProductMutation>;
export type UpdateOrganizationPackageProductMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationPackageProductMutation, UpdateOrganizationPackageProductMutationVariables>;
export const UpdateOrganizationPackageProductModeDocument = gql`
    mutation UpdateOrganizationPackageProductMode($organizationId: String!, $packageId: String!, $customProducts: Boolean!) {
  updateOrganizationPackageProductMode(
    organizationId: $organizationId
    packageId: $packageId
    customProducts: $customProducts
  )
}
    `;
export type UpdateOrganizationPackageProductModeMutationFn = Apollo.MutationFunction<UpdateOrganizationPackageProductModeMutation, UpdateOrganizationPackageProductModeMutationVariables>;

/**
 * __useUpdateOrganizationPackageProductModeMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationPackageProductModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationPackageProductModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationPackageProductModeMutation, { data, loading, error }] = useUpdateOrganizationPackageProductModeMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      packageId: // value for 'packageId'
 *      customProducts: // value for 'customProducts'
 *   },
 * });
 */
export function useUpdateOrganizationPackageProductModeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationPackageProductModeMutation, UpdateOrganizationPackageProductModeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationPackageProductModeMutation, UpdateOrganizationPackageProductModeMutationVariables>(UpdateOrganizationPackageProductModeDocument, options);
      }
export type UpdateOrganizationPackageProductModeMutationHookResult = ReturnType<typeof useUpdateOrganizationPackageProductModeMutation>;
export type UpdateOrganizationPackageProductModeMutationResult = Apollo.MutationResult<UpdateOrganizationPackageProductModeMutation>;
export type UpdateOrganizationPackageProductModeMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationPackageProductModeMutation, UpdateOrganizationPackageProductModeMutationVariables>;
export const UpdateOrganizationTierDocument = gql`
    mutation UpdateOrganizationTier($organizationId: String!, $fromCouponId: String!, $toCouponId: String!, $discountLevel: DiscountLevel!) {
  updateOrganizationTier(
    organizationId: $organizationId
    fromCouponId: $fromCouponId
    toCouponId: $toCouponId
    discountLevel: $discountLevel
  )
}
    `;
export type UpdateOrganizationTierMutationFn = Apollo.MutationFunction<UpdateOrganizationTierMutation, UpdateOrganizationTierMutationVariables>;

/**
 * __useUpdateOrganizationTierMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationTierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationTierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationTierMutation, { data, loading, error }] = useUpdateOrganizationTierMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      fromCouponId: // value for 'fromCouponId'
 *      toCouponId: // value for 'toCouponId'
 *      discountLevel: // value for 'discountLevel'
 *   },
 * });
 */
export function useUpdateOrganizationTierMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationTierMutation, UpdateOrganizationTierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationTierMutation, UpdateOrganizationTierMutationVariables>(UpdateOrganizationTierDocument, options);
      }
export type UpdateOrganizationTierMutationHookResult = ReturnType<typeof useUpdateOrganizationTierMutation>;
export type UpdateOrganizationTierMutationResult = Apollo.MutationResult<UpdateOrganizationTierMutation>;
export type UpdateOrganizationTierMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationTierMutation, UpdateOrganizationTierMutationVariables>;
export const ListBillingSubscriptionHistoryDocument = gql`
    query ListBillingSubscriptionHistory($organizationId: String!) {
  listBillingSubscriptionHistory(organizationId: $organizationId) {
    createdAt
    paidAt
    status
    invoiceURL
    prorationAmount {
      amount
      currencyMultiplier
      iso4217CurrencyCode
    }
    recurringAmount {
      amount
      currencyMultiplier
      iso4217CurrencyCode
    }
    totalAmount {
      amount
      currencyMultiplier
      iso4217CurrencyCode
    }
  }
}
    `;

/**
 * __useListBillingSubscriptionHistoryQuery__
 *
 * To run a query within a React component, call `useListBillingSubscriptionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useListBillingSubscriptionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListBillingSubscriptionHistoryQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useListBillingSubscriptionHistoryQuery(baseOptions: Apollo.QueryHookOptions<ListBillingSubscriptionHistoryQuery, ListBillingSubscriptionHistoryQueryVariables> & ({ variables: ListBillingSubscriptionHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListBillingSubscriptionHistoryQuery, ListBillingSubscriptionHistoryQueryVariables>(ListBillingSubscriptionHistoryDocument, options);
      }
export function useListBillingSubscriptionHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListBillingSubscriptionHistoryQuery, ListBillingSubscriptionHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListBillingSubscriptionHistoryQuery, ListBillingSubscriptionHistoryQueryVariables>(ListBillingSubscriptionHistoryDocument, options);
        }
export function useListBillingSubscriptionHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListBillingSubscriptionHistoryQuery, ListBillingSubscriptionHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListBillingSubscriptionHistoryQuery, ListBillingSubscriptionHistoryQueryVariables>(ListBillingSubscriptionHistoryDocument, options);
        }
export type ListBillingSubscriptionHistoryQueryHookResult = ReturnType<typeof useListBillingSubscriptionHistoryQuery>;
export type ListBillingSubscriptionHistoryLazyQueryHookResult = ReturnType<typeof useListBillingSubscriptionHistoryLazyQuery>;
export type ListBillingSubscriptionHistorySuspenseQueryHookResult = ReturnType<typeof useListBillingSubscriptionHistorySuspenseQuery>;
export type ListBillingSubscriptionHistoryQueryResult = Apollo.QueryResult<ListBillingSubscriptionHistoryQuery, ListBillingSubscriptionHistoryQueryVariables>;
export const ListOrganizationProductsDocument = gql`
    query ListOrganizationProducts($organizationId: String!) {
  listOrganizationProducts(organizationId: $organizationId) {
    ...AdminBillingProductFields
  }
}
    ${AdminBillingProductFieldsFragmentDoc}`;

/**
 * __useListOrganizationProductsQuery__
 *
 * To run a query within a React component, call `useListOrganizationProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOrganizationProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOrganizationProductsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useListOrganizationProductsQuery(baseOptions: Apollo.QueryHookOptions<ListOrganizationProductsQuery, ListOrganizationProductsQueryVariables> & ({ variables: ListOrganizationProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListOrganizationProductsQuery, ListOrganizationProductsQueryVariables>(ListOrganizationProductsDocument, options);
      }
export function useListOrganizationProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListOrganizationProductsQuery, ListOrganizationProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListOrganizationProductsQuery, ListOrganizationProductsQueryVariables>(ListOrganizationProductsDocument, options);
        }
export function useListOrganizationProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListOrganizationProductsQuery, ListOrganizationProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListOrganizationProductsQuery, ListOrganizationProductsQueryVariables>(ListOrganizationProductsDocument, options);
        }
export type ListOrganizationProductsQueryHookResult = ReturnType<typeof useListOrganizationProductsQuery>;
export type ListOrganizationProductsLazyQueryHookResult = ReturnType<typeof useListOrganizationProductsLazyQuery>;
export type ListOrganizationProductsSuspenseQueryHookResult = ReturnType<typeof useListOrganizationProductsSuspenseQuery>;
export type ListOrganizationProductsQueryResult = Apollo.QueryResult<ListOrganizationProductsQuery, ListOrganizationProductsQueryVariables>;
export const ListOrganizationTiersDocument = gql`
    query ListOrganizationTiers($couponIds: [String!]) {
  listOrganizationTiers(couponIds: $couponIds) {
    ...AdminOrganizationFields
  }
}
    ${AdminOrganizationFieldsFragmentDoc}`;

/**
 * __useListOrganizationTiersQuery__
 *
 * To run a query within a React component, call `useListOrganizationTiersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOrganizationTiersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOrganizationTiersQuery({
 *   variables: {
 *      couponIds: // value for 'couponIds'
 *   },
 * });
 */
export function useListOrganizationTiersQuery(baseOptions?: Apollo.QueryHookOptions<ListOrganizationTiersQuery, ListOrganizationTiersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListOrganizationTiersQuery, ListOrganizationTiersQueryVariables>(ListOrganizationTiersDocument, options);
      }
export function useListOrganizationTiersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListOrganizationTiersQuery, ListOrganizationTiersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListOrganizationTiersQuery, ListOrganizationTiersQueryVariables>(ListOrganizationTiersDocument, options);
        }
export function useListOrganizationTiersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListOrganizationTiersQuery, ListOrganizationTiersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListOrganizationTiersQuery, ListOrganizationTiersQueryVariables>(ListOrganizationTiersDocument, options);
        }
export type ListOrganizationTiersQueryHookResult = ReturnType<typeof useListOrganizationTiersQuery>;
export type ListOrganizationTiersLazyQueryHookResult = ReturnType<typeof useListOrganizationTiersLazyQuery>;
export type ListOrganizationTiersSuspenseQueryHookResult = ReturnType<typeof useListOrganizationTiersSuspenseQuery>;
export type ListOrganizationTiersQueryResult = Apollo.QueryResult<ListOrganizationTiersQuery, ListOrganizationTiersQueryVariables>;
export const ListPartnerCouponsDocument = gql`
    query ListPartnerCoupons {
  listPartnerCoupons {
    coupon_id
    name
    stripe_coupon_id
    valid
    amountOff {
      ...MonetaryValueFields
    }
    percentOff
    duration
    durationInMonths
  }
}
    ${MonetaryValueFieldsFragmentDoc}`;

/**
 * __useListPartnerCouponsQuery__
 *
 * To run a query within a React component, call `useListPartnerCouponsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPartnerCouponsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPartnerCouponsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListPartnerCouponsQuery(baseOptions?: Apollo.QueryHookOptions<ListPartnerCouponsQuery, ListPartnerCouponsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPartnerCouponsQuery, ListPartnerCouponsQueryVariables>(ListPartnerCouponsDocument, options);
      }
export function useListPartnerCouponsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPartnerCouponsQuery, ListPartnerCouponsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPartnerCouponsQuery, ListPartnerCouponsQueryVariables>(ListPartnerCouponsDocument, options);
        }
export function useListPartnerCouponsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPartnerCouponsQuery, ListPartnerCouponsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListPartnerCouponsQuery, ListPartnerCouponsQueryVariables>(ListPartnerCouponsDocument, options);
        }
export type ListPartnerCouponsQueryHookResult = ReturnType<typeof useListPartnerCouponsQuery>;
export type ListPartnerCouponsLazyQueryHookResult = ReturnType<typeof useListPartnerCouponsLazyQuery>;
export type ListPartnerCouponsSuspenseQueryHookResult = ReturnType<typeof useListPartnerCouponsSuspenseQuery>;
export type ListPartnerCouponsQueryResult = Apollo.QueryResult<ListPartnerCouponsQuery, ListPartnerCouponsQueryVariables>;
export const ListProductsDocument = gql`
    query ListProducts($target: String) {
  listProducts(target: $target) {
    id
    name
    displayName
    availability
    listing
  }
}
    `;

/**
 * __useListProductsQuery__
 *
 * To run a query within a React component, call `useListProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProductsQuery({
 *   variables: {
 *      target: // value for 'target'
 *   },
 * });
 */
export function useListProductsQuery(baseOptions?: Apollo.QueryHookOptions<ListProductsQuery, ListProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListProductsQuery, ListProductsQueryVariables>(ListProductsDocument, options);
      }
export function useListProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListProductsQuery, ListProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListProductsQuery, ListProductsQueryVariables>(ListProductsDocument, options);
        }
export function useListProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListProductsQuery, ListProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListProductsQuery, ListProductsQueryVariables>(ListProductsDocument, options);
        }
export type ListProductsQueryHookResult = ReturnType<typeof useListProductsQuery>;
export type ListProductsLazyQueryHookResult = ReturnType<typeof useListProductsLazyQuery>;
export type ListProductsSuspenseQueryHookResult = ReturnType<typeof useListProductsSuspenseQuery>;
export type ListProductsQueryResult = Apollo.QueryResult<ListProductsQuery, ListProductsQueryVariables>;
export const ReadBillingDocument = gql`
    query ReadBilling($organizationId: String!) {
  readBilling(organizationId: $organizationId) {
    ... on BillingNone {
      unused
    }
    ... on BillingOperator {
      organizationId
      subscriptionId
      product {
        ...BillingProductFields
      }
      activeSubscription
      subscriptionDetails {
        status
        cancelAt
      }
      trial {
        start
        end
      }
      availablePlans {
        product {
          ...BillingProductFields
        }
        price {
          ...BillingPriceFields
        }
      }
    }
    ... on BillingLegacyFirm {
      organizationId
      subscriptionId
      product {
        ...BillingProductFields
      }
      activeSubscription
    }
    ... on BillingAccountingFirm {
      organizationId
      subscriptionId
      product {
        ...BillingProductFields
      }
      activeSubscription
      firmPaidClients {
        product {
          ...BillingProductFields
        }
        legalEntityId
        billed
        availablePlans {
          product {
            ...BillingProductFields
          }
          price {
            ...BillingPriceFields
          }
        }
      }
      selfPaidClients {
        operator {
          organizationId
          subscriptionId
          product {
            ...BillingProductFields
          }
          activeSubscription
          subscriptionDetails {
            status
            cancelAt
          }
          trial {
            start
            end
          }
        }
        legalEntityId
      }
    }
  }
}
    ${BillingProductFieldsFragmentDoc}
${BillingPriceFieldsFragmentDoc}`;

/**
 * __useReadBillingQuery__
 *
 * To run a query within a React component, call `useReadBillingQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadBillingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadBillingQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useReadBillingQuery(baseOptions: Apollo.QueryHookOptions<ReadBillingQuery, ReadBillingQueryVariables> & ({ variables: ReadBillingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadBillingQuery, ReadBillingQueryVariables>(ReadBillingDocument, options);
      }
export function useReadBillingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadBillingQuery, ReadBillingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadBillingQuery, ReadBillingQueryVariables>(ReadBillingDocument, options);
        }
export function useReadBillingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadBillingQuery, ReadBillingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadBillingQuery, ReadBillingQueryVariables>(ReadBillingDocument, options);
        }
export type ReadBillingQueryHookResult = ReturnType<typeof useReadBillingQuery>;
export type ReadBillingLazyQueryHookResult = ReturnType<typeof useReadBillingLazyQuery>;
export type ReadBillingSuspenseQueryHookResult = ReturnType<typeof useReadBillingSuspenseQuery>;
export type ReadBillingQueryResult = Apollo.QueryResult<ReadBillingQuery, ReadBillingQueryVariables>;
export const ReadInvitationByOrganizationDocument = gql`
    query ReadInvitationByOrganization($organizationId: String!) {
  readInvitationByOrganization(organizationId: $organizationId) {
    invitation {
      id
      status
      recipient {
        givenName
        familyName
        emailAddress
      }
      createdAt
    }
  }
}
    `;

/**
 * __useReadInvitationByOrganizationQuery__
 *
 * To run a query within a React component, call `useReadInvitationByOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadInvitationByOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadInvitationByOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useReadInvitationByOrganizationQuery(baseOptions: Apollo.QueryHookOptions<ReadInvitationByOrganizationQuery, ReadInvitationByOrganizationQueryVariables> & ({ variables: ReadInvitationByOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadInvitationByOrganizationQuery, ReadInvitationByOrganizationQueryVariables>(ReadInvitationByOrganizationDocument, options);
      }
export function useReadInvitationByOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadInvitationByOrganizationQuery, ReadInvitationByOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadInvitationByOrganizationQuery, ReadInvitationByOrganizationQueryVariables>(ReadInvitationByOrganizationDocument, options);
        }
export function useReadInvitationByOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadInvitationByOrganizationQuery, ReadInvitationByOrganizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadInvitationByOrganizationQuery, ReadInvitationByOrganizationQueryVariables>(ReadInvitationByOrganizationDocument, options);
        }
export type ReadInvitationByOrganizationQueryHookResult = ReturnType<typeof useReadInvitationByOrganizationQuery>;
export type ReadInvitationByOrganizationLazyQueryHookResult = ReturnType<typeof useReadInvitationByOrganizationLazyQuery>;
export type ReadInvitationByOrganizationSuspenseQueryHookResult = ReturnType<typeof useReadInvitationByOrganizationSuspenseQuery>;
export type ReadInvitationByOrganizationQueryResult = Apollo.QueryResult<ReadInvitationByOrganizationQuery, ReadInvitationByOrganizationQueryVariables>;
export const ReadOrganizationBillingPlanDocument = gql`
    query ReadOrganizationBillingPlan($organizationId: String!) {
  readOrganizationBillingPlan(organizationId: $organizationId) {
    product {
      ...BillingProductFields
    }
    price {
      ...BillingPriceFields
    }
    legalEntityLimit {
      ...BillingLegalEntityLimitFields
    }
  }
}
    ${BillingProductFieldsFragmentDoc}
${BillingPriceFieldsFragmentDoc}
${BillingLegalEntityLimitFieldsFragmentDoc}`;

/**
 * __useReadOrganizationBillingPlanQuery__
 *
 * To run a query within a React component, call `useReadOrganizationBillingPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadOrganizationBillingPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadOrganizationBillingPlanQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useReadOrganizationBillingPlanQuery(baseOptions: Apollo.QueryHookOptions<ReadOrganizationBillingPlanQuery, ReadOrganizationBillingPlanQueryVariables> & ({ variables: ReadOrganizationBillingPlanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadOrganizationBillingPlanQuery, ReadOrganizationBillingPlanQueryVariables>(ReadOrganizationBillingPlanDocument, options);
      }
export function useReadOrganizationBillingPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadOrganizationBillingPlanQuery, ReadOrganizationBillingPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadOrganizationBillingPlanQuery, ReadOrganizationBillingPlanQueryVariables>(ReadOrganizationBillingPlanDocument, options);
        }
export function useReadOrganizationBillingPlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadOrganizationBillingPlanQuery, ReadOrganizationBillingPlanQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadOrganizationBillingPlanQuery, ReadOrganizationBillingPlanQueryVariables>(ReadOrganizationBillingPlanDocument, options);
        }
export type ReadOrganizationBillingPlanQueryHookResult = ReturnType<typeof useReadOrganizationBillingPlanQuery>;
export type ReadOrganizationBillingPlanLazyQueryHookResult = ReturnType<typeof useReadOrganizationBillingPlanLazyQuery>;
export type ReadOrganizationBillingPlanSuspenseQueryHookResult = ReturnType<typeof useReadOrganizationBillingPlanSuspenseQuery>;
export type ReadOrganizationBillingPlanQueryResult = Apollo.QueryResult<ReadOrganizationBillingPlanQuery, ReadOrganizationBillingPlanQueryVariables>;
export const ReadOrganizationPackageDocument = gql`
    query ReadOrganizationPackage($organizationId: String!) {
  readOrganizationPackage(organizationId: $organizationId) {
    hasPackage
    packageId
    customProducts
    products {
      productId
      productName
      productDisplayName
      billable
    }
  }
}
    `;

/**
 * __useReadOrganizationPackageQuery__
 *
 * To run a query within a React component, call `useReadOrganizationPackageQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadOrganizationPackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadOrganizationPackageQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useReadOrganizationPackageQuery(baseOptions: Apollo.QueryHookOptions<ReadOrganizationPackageQuery, ReadOrganizationPackageQueryVariables> & ({ variables: ReadOrganizationPackageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadOrganizationPackageQuery, ReadOrganizationPackageQueryVariables>(ReadOrganizationPackageDocument, options);
      }
export function useReadOrganizationPackageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadOrganizationPackageQuery, ReadOrganizationPackageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadOrganizationPackageQuery, ReadOrganizationPackageQueryVariables>(ReadOrganizationPackageDocument, options);
        }
export function useReadOrganizationPackageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadOrganizationPackageQuery, ReadOrganizationPackageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadOrganizationPackageQuery, ReadOrganizationPackageQueryVariables>(ReadOrganizationPackageDocument, options);
        }
export type ReadOrganizationPackageQueryHookResult = ReturnType<typeof useReadOrganizationPackageQuery>;
export type ReadOrganizationPackageLazyQueryHookResult = ReturnType<typeof useReadOrganizationPackageLazyQuery>;
export type ReadOrganizationPackageSuspenseQueryHookResult = ReturnType<typeof useReadOrganizationPackageSuspenseQuery>;
export type ReadOrganizationPackageQueryResult = Apollo.QueryResult<ReadOrganizationPackageQuery, ReadOrganizationPackageQueryVariables>;
export const ReadOrganizationTierDocument = gql`
    query ReadOrganizationTier($organizationId: String!) {
  readOrganizationTier(organizationId: $organizationId) {
    coupon_id
    name
    stripe_coupon_id
    valid
    amountOff {
      ...MonetaryValueFields
    }
    percentOff
    duration
    durationInMonths
    discountLevel
  }
}
    ${MonetaryValueFieldsFragmentDoc}`;

/**
 * __useReadOrganizationTierQuery__
 *
 * To run a query within a React component, call `useReadOrganizationTierQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadOrganizationTierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadOrganizationTierQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useReadOrganizationTierQuery(baseOptions: Apollo.QueryHookOptions<ReadOrganizationTierQuery, ReadOrganizationTierQueryVariables> & ({ variables: ReadOrganizationTierQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadOrganizationTierQuery, ReadOrganizationTierQueryVariables>(ReadOrganizationTierDocument, options);
      }
export function useReadOrganizationTierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadOrganizationTierQuery, ReadOrganizationTierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadOrganizationTierQuery, ReadOrganizationTierQueryVariables>(ReadOrganizationTierDocument, options);
        }
export function useReadOrganizationTierSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadOrganizationTierQuery, ReadOrganizationTierQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadOrganizationTierQuery, ReadOrganizationTierQueryVariables>(ReadOrganizationTierDocument, options);
        }
export type ReadOrganizationTierQueryHookResult = ReturnType<typeof useReadOrganizationTierQuery>;
export type ReadOrganizationTierLazyQueryHookResult = ReturnType<typeof useReadOrganizationTierLazyQuery>;
export type ReadOrganizationTierSuspenseQueryHookResult = ReturnType<typeof useReadOrganizationTierSuspenseQuery>;
export type ReadOrganizationTierQueryResult = Apollo.QueryResult<ReadOrganizationTierQuery, ReadOrganizationTierQueryVariables>;
export const ListAdminChartsOfAccountsDocument = gql`
    query ListAdminChartsOfAccounts($global: Boolean, $legalEntityId: String, $accountingBasis: AccountingBasis) {
  listChartsOfAccounts(
    filter: {global: $global, legalEntityId: $legalEntityId, accountingBasis: $accountingBasis}
  ) {
    ...ChartOfAccountsListEntryFields
  }
}
    ${ChartOfAccountsListEntryFieldsFragmentDoc}`;

/**
 * __useListAdminChartsOfAccountsQuery__
 *
 * To run a query within a React component, call `useListAdminChartsOfAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAdminChartsOfAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAdminChartsOfAccountsQuery({
 *   variables: {
 *      global: // value for 'global'
 *      legalEntityId: // value for 'legalEntityId'
 *      accountingBasis: // value for 'accountingBasis'
 *   },
 * });
 */
export function useListAdminChartsOfAccountsQuery(baseOptions?: Apollo.QueryHookOptions<ListAdminChartsOfAccountsQuery, ListAdminChartsOfAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAdminChartsOfAccountsQuery, ListAdminChartsOfAccountsQueryVariables>(ListAdminChartsOfAccountsDocument, options);
      }
export function useListAdminChartsOfAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAdminChartsOfAccountsQuery, ListAdminChartsOfAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAdminChartsOfAccountsQuery, ListAdminChartsOfAccountsQueryVariables>(ListAdminChartsOfAccountsDocument, options);
        }
export function useListAdminChartsOfAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAdminChartsOfAccountsQuery, ListAdminChartsOfAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAdminChartsOfAccountsQuery, ListAdminChartsOfAccountsQueryVariables>(ListAdminChartsOfAccountsDocument, options);
        }
export type ListAdminChartsOfAccountsQueryHookResult = ReturnType<typeof useListAdminChartsOfAccountsQuery>;
export type ListAdminChartsOfAccountsLazyQueryHookResult = ReturnType<typeof useListAdminChartsOfAccountsLazyQuery>;
export type ListAdminChartsOfAccountsSuspenseQueryHookResult = ReturnType<typeof useListAdminChartsOfAccountsSuspenseQuery>;
export type ListAdminChartsOfAccountsQueryResult = Apollo.QueryResult<ListAdminChartsOfAccountsQuery, ListAdminChartsOfAccountsQueryVariables>;
export const ListAdminChartOfAccountsTemplatesDocument = gql`
    query ListAdminChartOfAccountsTemplates($organizationId: String!) {
  listChartOfAccountsTemplates(organizationId: $organizationId) {
    ...AdminChartOfAccountsTemplateSummaryFields
  }
}
    ${AdminChartOfAccountsTemplateSummaryFieldsFragmentDoc}`;

/**
 * __useListAdminChartOfAccountsTemplatesQuery__
 *
 * To run a query within a React component, call `useListAdminChartOfAccountsTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAdminChartOfAccountsTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAdminChartOfAccountsTemplatesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useListAdminChartOfAccountsTemplatesQuery(baseOptions: Apollo.QueryHookOptions<ListAdminChartOfAccountsTemplatesQuery, ListAdminChartOfAccountsTemplatesQueryVariables> & ({ variables: ListAdminChartOfAccountsTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAdminChartOfAccountsTemplatesQuery, ListAdminChartOfAccountsTemplatesQueryVariables>(ListAdminChartOfAccountsTemplatesDocument, options);
      }
export function useListAdminChartOfAccountsTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAdminChartOfAccountsTemplatesQuery, ListAdminChartOfAccountsTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAdminChartOfAccountsTemplatesQuery, ListAdminChartOfAccountsTemplatesQueryVariables>(ListAdminChartOfAccountsTemplatesDocument, options);
        }
export function useListAdminChartOfAccountsTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAdminChartOfAccountsTemplatesQuery, ListAdminChartOfAccountsTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAdminChartOfAccountsTemplatesQuery, ListAdminChartOfAccountsTemplatesQueryVariables>(ListAdminChartOfAccountsTemplatesDocument, options);
        }
export type ListAdminChartOfAccountsTemplatesQueryHookResult = ReturnType<typeof useListAdminChartOfAccountsTemplatesQuery>;
export type ListAdminChartOfAccountsTemplatesLazyQueryHookResult = ReturnType<typeof useListAdminChartOfAccountsTemplatesLazyQuery>;
export type ListAdminChartOfAccountsTemplatesSuspenseQueryHookResult = ReturnType<typeof useListAdminChartOfAccountsTemplatesSuspenseQuery>;
export type ListAdminChartOfAccountsTemplatesQueryResult = Apollo.QueryResult<ListAdminChartOfAccountsTemplatesQuery, ListAdminChartOfAccountsTemplatesQueryVariables>;
export const ReadAdminChartOfAccountsDocument = gql`
    query ReadAdminChartOfAccounts($id: String!) {
  readChartOfAccounts(id: $id) {
    ...AdminChartOfAccountsFields
  }
}
    ${AdminChartOfAccountsFieldsFragmentDoc}`;

/**
 * __useReadAdminChartOfAccountsQuery__
 *
 * To run a query within a React component, call `useReadAdminChartOfAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadAdminChartOfAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadAdminChartOfAccountsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReadAdminChartOfAccountsQuery(baseOptions: Apollo.QueryHookOptions<ReadAdminChartOfAccountsQuery, ReadAdminChartOfAccountsQueryVariables> & ({ variables: ReadAdminChartOfAccountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadAdminChartOfAccountsQuery, ReadAdminChartOfAccountsQueryVariables>(ReadAdminChartOfAccountsDocument, options);
      }
export function useReadAdminChartOfAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadAdminChartOfAccountsQuery, ReadAdminChartOfAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadAdminChartOfAccountsQuery, ReadAdminChartOfAccountsQueryVariables>(ReadAdminChartOfAccountsDocument, options);
        }
export function useReadAdminChartOfAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadAdminChartOfAccountsQuery, ReadAdminChartOfAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadAdminChartOfAccountsQuery, ReadAdminChartOfAccountsQueryVariables>(ReadAdminChartOfAccountsDocument, options);
        }
export type ReadAdminChartOfAccountsQueryHookResult = ReturnType<typeof useReadAdminChartOfAccountsQuery>;
export type ReadAdminChartOfAccountsLazyQueryHookResult = ReturnType<typeof useReadAdminChartOfAccountsLazyQuery>;
export type ReadAdminChartOfAccountsSuspenseQueryHookResult = ReturnType<typeof useReadAdminChartOfAccountsSuspenseQuery>;
export type ReadAdminChartOfAccountsQueryResult = Apollo.QueryResult<ReadAdminChartOfAccountsQuery, ReadAdminChartOfAccountsQueryVariables>;
export const ReadAdminChartOfAccountsTemplateDocument = gql`
    query ReadAdminChartOfAccountsTemplate($organizationId: String!, $templateId: String!) {
  readChartOfAccountsTemplate(
    organizationId: $organizationId
    templateId: $templateId
  ) {
    ...AdminChartOfAccountsTemplateFields
  }
}
    ${AdminChartOfAccountsTemplateFieldsFragmentDoc}`;

/**
 * __useReadAdminChartOfAccountsTemplateQuery__
 *
 * To run a query within a React component, call `useReadAdminChartOfAccountsTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadAdminChartOfAccountsTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadAdminChartOfAccountsTemplateQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useReadAdminChartOfAccountsTemplateQuery(baseOptions: Apollo.QueryHookOptions<ReadAdminChartOfAccountsTemplateQuery, ReadAdminChartOfAccountsTemplateQueryVariables> & ({ variables: ReadAdminChartOfAccountsTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadAdminChartOfAccountsTemplateQuery, ReadAdminChartOfAccountsTemplateQueryVariables>(ReadAdminChartOfAccountsTemplateDocument, options);
      }
export function useReadAdminChartOfAccountsTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadAdminChartOfAccountsTemplateQuery, ReadAdminChartOfAccountsTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadAdminChartOfAccountsTemplateQuery, ReadAdminChartOfAccountsTemplateQueryVariables>(ReadAdminChartOfAccountsTemplateDocument, options);
        }
export function useReadAdminChartOfAccountsTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadAdminChartOfAccountsTemplateQuery, ReadAdminChartOfAccountsTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadAdminChartOfAccountsTemplateQuery, ReadAdminChartOfAccountsTemplateQueryVariables>(ReadAdminChartOfAccountsTemplateDocument, options);
        }
export type ReadAdminChartOfAccountsTemplateQueryHookResult = ReturnType<typeof useReadAdminChartOfAccountsTemplateQuery>;
export type ReadAdminChartOfAccountsTemplateLazyQueryHookResult = ReturnType<typeof useReadAdminChartOfAccountsTemplateLazyQuery>;
export type ReadAdminChartOfAccountsTemplateSuspenseQueryHookResult = ReturnType<typeof useReadAdminChartOfAccountsTemplateSuspenseQuery>;
export type ReadAdminChartOfAccountsTemplateQueryResult = Apollo.QueryResult<ReadAdminChartOfAccountsTemplateQuery, ReadAdminChartOfAccountsTemplateQueryVariables>;
export const ReadAdminChartOfAccountsWithMappingDocument = gql`
    query ReadAdminChartOfAccountsWithMapping($fromId: String!, $toId: String!, $viewType: ViewType!) {
  readMappedChartOfAccounts(fromId: $fromId, toId: $toId, viewType: $viewType) {
    ...MappedChartOfAccountsFields
  }
}
    ${MappedChartOfAccountsFieldsFragmentDoc}`;

/**
 * __useReadAdminChartOfAccountsWithMappingQuery__
 *
 * To run a query within a React component, call `useReadAdminChartOfAccountsWithMappingQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadAdminChartOfAccountsWithMappingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadAdminChartOfAccountsWithMappingQuery({
 *   variables: {
 *      fromId: // value for 'fromId'
 *      toId: // value for 'toId'
 *      viewType: // value for 'viewType'
 *   },
 * });
 */
export function useReadAdminChartOfAccountsWithMappingQuery(baseOptions: Apollo.QueryHookOptions<ReadAdminChartOfAccountsWithMappingQuery, ReadAdminChartOfAccountsWithMappingQueryVariables> & ({ variables: ReadAdminChartOfAccountsWithMappingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadAdminChartOfAccountsWithMappingQuery, ReadAdminChartOfAccountsWithMappingQueryVariables>(ReadAdminChartOfAccountsWithMappingDocument, options);
      }
export function useReadAdminChartOfAccountsWithMappingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadAdminChartOfAccountsWithMappingQuery, ReadAdminChartOfAccountsWithMappingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadAdminChartOfAccountsWithMappingQuery, ReadAdminChartOfAccountsWithMappingQueryVariables>(ReadAdminChartOfAccountsWithMappingDocument, options);
        }
export function useReadAdminChartOfAccountsWithMappingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadAdminChartOfAccountsWithMappingQuery, ReadAdminChartOfAccountsWithMappingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadAdminChartOfAccountsWithMappingQuery, ReadAdminChartOfAccountsWithMappingQueryVariables>(ReadAdminChartOfAccountsWithMappingDocument, options);
        }
export type ReadAdminChartOfAccountsWithMappingQueryHookResult = ReturnType<typeof useReadAdminChartOfAccountsWithMappingQuery>;
export type ReadAdminChartOfAccountsWithMappingLazyQueryHookResult = ReturnType<typeof useReadAdminChartOfAccountsWithMappingLazyQuery>;
export type ReadAdminChartOfAccountsWithMappingSuspenseQueryHookResult = ReturnType<typeof useReadAdminChartOfAccountsWithMappingSuspenseQuery>;
export type ReadAdminChartOfAccountsWithMappingQueryResult = Apollo.QueryResult<ReadAdminChartOfAccountsWithMappingQuery, ReadAdminChartOfAccountsWithMappingQueryVariables>;
export const TriggerClassificationManifestDocument = gql`
    mutation TriggerClassificationManifest($legalEntityId: String!, $boundaryDate: DateTime) {
  triggerClassificationManifest(
    legalEntityId: $legalEntityId
    boundaryDate: $boundaryDate
  ) {
    manifestId
    transactionCount
  }
}
    `;
export type TriggerClassificationManifestMutationFn = Apollo.MutationFunction<TriggerClassificationManifestMutation, TriggerClassificationManifestMutationVariables>;

/**
 * __useTriggerClassificationManifestMutation__
 *
 * To run a mutation, you first call `useTriggerClassificationManifestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerClassificationManifestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerClassificationManifestMutation, { data, loading, error }] = useTriggerClassificationManifestMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      boundaryDate: // value for 'boundaryDate'
 *   },
 * });
 */
export function useTriggerClassificationManifestMutation(baseOptions?: Apollo.MutationHookOptions<TriggerClassificationManifestMutation, TriggerClassificationManifestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerClassificationManifestMutation, TriggerClassificationManifestMutationVariables>(TriggerClassificationManifestDocument, options);
      }
export type TriggerClassificationManifestMutationHookResult = ReturnType<typeof useTriggerClassificationManifestMutation>;
export type TriggerClassificationManifestMutationResult = Apollo.MutationResult<TriggerClassificationManifestMutation>;
export type TriggerClassificationManifestMutationOptions = Apollo.BaseMutationOptions<TriggerClassificationManifestMutation, TriggerClassificationManifestMutationVariables>;
export const ListClassificationManifestsDocument = gql`
    query ListClassificationManifests($legalEntityId: String!) {
  listClassificationManifests(legalEntityId: $legalEntityId) {
    manifestId
    legalEntityId
    trigger
    boundaryDate
    transactionCount
    classifiedCount
    skippedCount
    createdAt
    completedAt
    skipReasonSummaries {
      reason
      count
    }
  }
}
    `;

/**
 * __useListClassificationManifestsQuery__
 *
 * To run a query within a React component, call `useListClassificationManifestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListClassificationManifestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListClassificationManifestsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListClassificationManifestsQuery(baseOptions: Apollo.QueryHookOptions<ListClassificationManifestsQuery, ListClassificationManifestsQueryVariables> & ({ variables: ListClassificationManifestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListClassificationManifestsQuery, ListClassificationManifestsQueryVariables>(ListClassificationManifestsDocument, options);
      }
export function useListClassificationManifestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListClassificationManifestsQuery, ListClassificationManifestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListClassificationManifestsQuery, ListClassificationManifestsQueryVariables>(ListClassificationManifestsDocument, options);
        }
export function useListClassificationManifestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListClassificationManifestsQuery, ListClassificationManifestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListClassificationManifestsQuery, ListClassificationManifestsQueryVariables>(ListClassificationManifestsDocument, options);
        }
export type ListClassificationManifestsQueryHookResult = ReturnType<typeof useListClassificationManifestsQuery>;
export type ListClassificationManifestsLazyQueryHookResult = ReturnType<typeof useListClassificationManifestsLazyQuery>;
export type ListClassificationManifestsSuspenseQueryHookResult = ReturnType<typeof useListClassificationManifestsSuspenseQuery>;
export type ListClassificationManifestsQueryResult = Apollo.QueryResult<ListClassificationManifestsQuery, ListClassificationManifestsQueryVariables>;
export const ReadAssociatedThreadsDocument = gql`
    query ReadAssociatedThreads($id: String!, $legalEntityId: String!, $kind: ObjectKind!, $allowResolved: Boolean = true) {
  response: readAssociatedThreads(
    id: $id
    legalEntityId: $legalEntityId
    kind: $kind
    allowResolved: $allowResolved
  ) {
    threads {
      ...ThreadFields
    }
    entities {
      ...ObjectEntitiesFields
    }
  }
}
    ${ThreadFieldsFragmentDoc}
${ObjectEntitiesFieldsFragmentDoc}`;

/**
 * __useReadAssociatedThreadsQuery__
 *
 * To run a query within a React component, call `useReadAssociatedThreadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadAssociatedThreadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadAssociatedThreadsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      legalEntityId: // value for 'legalEntityId'
 *      kind: // value for 'kind'
 *      allowResolved: // value for 'allowResolved'
 *   },
 * });
 */
export function useReadAssociatedThreadsQuery(baseOptions: Apollo.QueryHookOptions<ReadAssociatedThreadsQuery, ReadAssociatedThreadsQueryVariables> & ({ variables: ReadAssociatedThreadsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadAssociatedThreadsQuery, ReadAssociatedThreadsQueryVariables>(ReadAssociatedThreadsDocument, options);
      }
export function useReadAssociatedThreadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadAssociatedThreadsQuery, ReadAssociatedThreadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadAssociatedThreadsQuery, ReadAssociatedThreadsQueryVariables>(ReadAssociatedThreadsDocument, options);
        }
export function useReadAssociatedThreadsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadAssociatedThreadsQuery, ReadAssociatedThreadsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadAssociatedThreadsQuery, ReadAssociatedThreadsQueryVariables>(ReadAssociatedThreadsDocument, options);
        }
export type ReadAssociatedThreadsQueryHookResult = ReturnType<typeof useReadAssociatedThreadsQuery>;
export type ReadAssociatedThreadsLazyQueryHookResult = ReturnType<typeof useReadAssociatedThreadsLazyQuery>;
export type ReadAssociatedThreadsSuspenseQueryHookResult = ReturnType<typeof useReadAssociatedThreadsSuspenseQuery>;
export type ReadAssociatedThreadsQueryResult = Apollo.QueryResult<ReadAssociatedThreadsQuery, ReadAssociatedThreadsQueryVariables>;
export const ReadThreadDocument = gql`
    query ReadThread($legalEntityId: String!, $id: String!) {
  thread: readThread(legalEntityId: $legalEntityId, threadId: $id) {
    ...ThreadWithEntitiesFields
  }
}
    ${ThreadWithEntitiesFieldsFragmentDoc}`;

/**
 * __useReadThreadQuery__
 *
 * To run a query within a React component, call `useReadThreadQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadThreadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadThreadQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReadThreadQuery(baseOptions: Apollo.QueryHookOptions<ReadThreadQuery, ReadThreadQueryVariables> & ({ variables: ReadThreadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadThreadQuery, ReadThreadQueryVariables>(ReadThreadDocument, options);
      }
export function useReadThreadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadThreadQuery, ReadThreadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadThreadQuery, ReadThreadQueryVariables>(ReadThreadDocument, options);
        }
export function useReadThreadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadThreadQuery, ReadThreadQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadThreadQuery, ReadThreadQueryVariables>(ReadThreadDocument, options);
        }
export type ReadThreadQueryHookResult = ReturnType<typeof useReadThreadQuery>;
export type ReadThreadLazyQueryHookResult = ReturnType<typeof useReadThreadLazyQuery>;
export type ReadThreadSuspenseQueryHookResult = ReturnType<typeof useReadThreadSuspenseQuery>;
export type ReadThreadQueryResult = Apollo.QueryResult<ReadThreadQuery, ReadThreadQueryVariables>;
export const CreateConnectionTemplateDocument = gql`
    mutation CreateConnectionTemplate($connectorId: String!, $institutionId: String!) {
  createConnectionTemplate(
    connectorId: $connectorId
    institutionId: $institutionId
  )
}
    `;
export type CreateConnectionTemplateMutationFn = Apollo.MutationFunction<CreateConnectionTemplateMutation, CreateConnectionTemplateMutationVariables>;

/**
 * __useCreateConnectionTemplateMutation__
 *
 * To run a mutation, you first call `useCreateConnectionTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConnectionTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConnectionTemplateMutation, { data, loading, error }] = useCreateConnectionTemplateMutation({
 *   variables: {
 *      connectorId: // value for 'connectorId'
 *      institutionId: // value for 'institutionId'
 *   },
 * });
 */
export function useCreateConnectionTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateConnectionTemplateMutation, CreateConnectionTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConnectionTemplateMutation, CreateConnectionTemplateMutationVariables>(CreateConnectionTemplateDocument, options);
      }
export type CreateConnectionTemplateMutationHookResult = ReturnType<typeof useCreateConnectionTemplateMutation>;
export type CreateConnectionTemplateMutationResult = Apollo.MutationResult<CreateConnectionTemplateMutation>;
export type CreateConnectionTemplateMutationOptions = Apollo.BaseMutationOptions<CreateConnectionTemplateMutation, CreateConnectionTemplateMutationVariables>;
export const DeleteConnectionDocument = gql`
    mutation DeleteConnection($id: String!, $legalEntityId: String!) {
  deleteConnection(id: $id, legalEntityId: $legalEntityId)
}
    `;
export type DeleteConnectionMutationFn = Apollo.MutationFunction<DeleteConnectionMutation, DeleteConnectionMutationVariables>;

/**
 * __useDeleteConnectionMutation__
 *
 * To run a mutation, you first call `useDeleteConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteConnectionMutation, { data, loading, error }] = useDeleteConnectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useDeleteConnectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteConnectionMutation, DeleteConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteConnectionMutation, DeleteConnectionMutationVariables>(DeleteConnectionDocument, options);
      }
export type DeleteConnectionMutationHookResult = ReturnType<typeof useDeleteConnectionMutation>;
export type DeleteConnectionMutationResult = Apollo.MutationResult<DeleteConnectionMutation>;
export type DeleteConnectionMutationOptions = Apollo.BaseMutationOptions<DeleteConnectionMutation, DeleteConnectionMutationVariables>;
export const DeleteConnectionTemplateDocument = gql`
    mutation DeleteConnectionTemplate($connectorId: String!, $institutionId: String!) {
  deleteConnectionTemplate(
    connectorId: $connectorId
    institutionId: $institutionId
  )
}
    `;
export type DeleteConnectionTemplateMutationFn = Apollo.MutationFunction<DeleteConnectionTemplateMutation, DeleteConnectionTemplateMutationVariables>;

/**
 * __useDeleteConnectionTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteConnectionTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteConnectionTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteConnectionTemplateMutation, { data, loading, error }] = useDeleteConnectionTemplateMutation({
 *   variables: {
 *      connectorId: // value for 'connectorId'
 *      institutionId: // value for 'institutionId'
 *   },
 * });
 */
export function useDeleteConnectionTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteConnectionTemplateMutation, DeleteConnectionTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteConnectionTemplateMutation, DeleteConnectionTemplateMutationVariables>(DeleteConnectionTemplateDocument, options);
      }
export type DeleteConnectionTemplateMutationHookResult = ReturnType<typeof useDeleteConnectionTemplateMutation>;
export type DeleteConnectionTemplateMutationResult = Apollo.MutationResult<DeleteConnectionTemplateMutation>;
export type DeleteConnectionTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteConnectionTemplateMutation, DeleteConnectionTemplateMutationVariables>;
export const DisableConnectionDocument = gql`
    mutation DisableConnection($id: String!, $legalEntityId: String!) {
  disableConnection(id: $id, legalEntityId: $legalEntityId)
}
    `;
export type DisableConnectionMutationFn = Apollo.MutationFunction<DisableConnectionMutation, DisableConnectionMutationVariables>;

/**
 * __useDisableConnectionMutation__
 *
 * To run a mutation, you first call `useDisableConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableConnectionMutation, { data, loading, error }] = useDisableConnectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useDisableConnectionMutation(baseOptions?: Apollo.MutationHookOptions<DisableConnectionMutation, DisableConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableConnectionMutation, DisableConnectionMutationVariables>(DisableConnectionDocument, options);
      }
export type DisableConnectionMutationHookResult = ReturnType<typeof useDisableConnectionMutation>;
export type DisableConnectionMutationResult = Apollo.MutationResult<DisableConnectionMutation>;
export type DisableConnectionMutationOptions = Apollo.BaseMutationOptions<DisableConnectionMutation, DisableConnectionMutationVariables>;
export const EnableConnectionDocument = gql`
    mutation EnableConnection($id: String!, $legalEntityId: String!) {
  enableConnection(id: $id, legalEntityId: $legalEntityId)
}
    `;
export type EnableConnectionMutationFn = Apollo.MutationFunction<EnableConnectionMutation, EnableConnectionMutationVariables>;

/**
 * __useEnableConnectionMutation__
 *
 * To run a mutation, you first call `useEnableConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableConnectionMutation, { data, loading, error }] = useEnableConnectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useEnableConnectionMutation(baseOptions?: Apollo.MutationHookOptions<EnableConnectionMutation, EnableConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableConnectionMutation, EnableConnectionMutationVariables>(EnableConnectionDocument, options);
      }
export type EnableConnectionMutationHookResult = ReturnType<typeof useEnableConnectionMutation>;
export type EnableConnectionMutationResult = Apollo.MutationResult<EnableConnectionMutation>;
export type EnableConnectionMutationOptions = Apollo.BaseMutationOptions<EnableConnectionMutation, EnableConnectionMutationVariables>;
export const PlaidRefreshStatementsDocument = gql`
    mutation PlaidRefreshStatements($id: String!, $legalEntityId: String!, $startDate: String!, $endDate: String!) {
  plaidRefreshStatements(
    id: $id
    legalEntityId: $legalEntityId
    startDate: $startDate
    endDate: $endDate
  ) {
    rawBody
  }
}
    `;
export type PlaidRefreshStatementsMutationFn = Apollo.MutationFunction<PlaidRefreshStatementsMutation, PlaidRefreshStatementsMutationVariables>;

/**
 * __usePlaidRefreshStatementsMutation__
 *
 * To run a mutation, you first call `usePlaidRefreshStatementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaidRefreshStatementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [plaidRefreshStatementsMutation, { data, loading, error }] = usePlaidRefreshStatementsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      legalEntityId: // value for 'legalEntityId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function usePlaidRefreshStatementsMutation(baseOptions?: Apollo.MutationHookOptions<PlaidRefreshStatementsMutation, PlaidRefreshStatementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlaidRefreshStatementsMutation, PlaidRefreshStatementsMutationVariables>(PlaidRefreshStatementsDocument, options);
      }
export type PlaidRefreshStatementsMutationHookResult = ReturnType<typeof usePlaidRefreshStatementsMutation>;
export type PlaidRefreshStatementsMutationResult = Apollo.MutationResult<PlaidRefreshStatementsMutation>;
export type PlaidRefreshStatementsMutationOptions = Apollo.BaseMutationOptions<PlaidRefreshStatementsMutation, PlaidRefreshStatementsMutationVariables>;
export const PlaidTriggerRefreshDocument = gql`
    mutation PlaidTriggerRefresh($id: String!, $legalEntityId: String!) {
  plaidTriggerRefresh(id: $id, legalEntityId: $legalEntityId)
}
    `;
export type PlaidTriggerRefreshMutationFn = Apollo.MutationFunction<PlaidTriggerRefreshMutation, PlaidTriggerRefreshMutationVariables>;

/**
 * __usePlaidTriggerRefreshMutation__
 *
 * To run a mutation, you first call `usePlaidTriggerRefreshMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaidTriggerRefreshMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [plaidTriggerRefreshMutation, { data, loading, error }] = usePlaidTriggerRefreshMutation({
 *   variables: {
 *      id: // value for 'id'
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function usePlaidTriggerRefreshMutation(baseOptions?: Apollo.MutationHookOptions<PlaidTriggerRefreshMutation, PlaidTriggerRefreshMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlaidTriggerRefreshMutation, PlaidTriggerRefreshMutationVariables>(PlaidTriggerRefreshDocument, options);
      }
export type PlaidTriggerRefreshMutationHookResult = ReturnType<typeof usePlaidTriggerRefreshMutation>;
export type PlaidTriggerRefreshMutationResult = Apollo.MutationResult<PlaidTriggerRefreshMutation>;
export type PlaidTriggerRefreshMutationOptions = Apollo.BaseMutationOptions<PlaidTriggerRefreshMutation, PlaidTriggerRefreshMutationVariables>;
export const ResetConnectionDocument = gql`
    mutation ResetConnection($id: String!, $legalEntityId: String!) {
  resetConnection(id: $id, legalEntityId: $legalEntityId)
}
    `;
export type ResetConnectionMutationFn = Apollo.MutationFunction<ResetConnectionMutation, ResetConnectionMutationVariables>;

/**
 * __useResetConnectionMutation__
 *
 * To run a mutation, you first call `useResetConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetConnectionMutation, { data, loading, error }] = useResetConnectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useResetConnectionMutation(baseOptions?: Apollo.MutationHookOptions<ResetConnectionMutation, ResetConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetConnectionMutation, ResetConnectionMutationVariables>(ResetConnectionDocument, options);
      }
export type ResetConnectionMutationHookResult = ReturnType<typeof useResetConnectionMutation>;
export type ResetConnectionMutationResult = Apollo.MutationResult<ResetConnectionMutation>;
export type ResetConnectionMutationOptions = Apollo.BaseMutationOptions<ResetConnectionMutation, ResetConnectionMutationVariables>;
export const SetAppVisibilityDocument = gql`
    mutation SetAppVisibility($connectorId: String!, $visibility: ConnectorVisibility!) {
  setAppVisibility(connectorId: $connectorId, visibility: $visibility)
}
    `;
export type SetAppVisibilityMutationFn = Apollo.MutationFunction<SetAppVisibilityMutation, SetAppVisibilityMutationVariables>;

/**
 * __useSetAppVisibilityMutation__
 *
 * To run a mutation, you first call `useSetAppVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAppVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAppVisibilityMutation, { data, loading, error }] = useSetAppVisibilityMutation({
 *   variables: {
 *      connectorId: // value for 'connectorId'
 *      visibility: // value for 'visibility'
 *   },
 * });
 */
export function useSetAppVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<SetAppVisibilityMutation, SetAppVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAppVisibilityMutation, SetAppVisibilityMutationVariables>(SetAppVisibilityDocument, options);
      }
export type SetAppVisibilityMutationHookResult = ReturnType<typeof useSetAppVisibilityMutation>;
export type SetAppVisibilityMutationResult = Apollo.MutationResult<SetAppVisibilityMutation>;
export type SetAppVisibilityMutationOptions = Apollo.BaseMutationOptions<SetAppVisibilityMutation, SetAppVisibilityMutationVariables>;
export const SyncConnectionDocument = gql`
    mutation SyncConnection($id: String!, $legalEntityId: String!) {
  syncConnection(id: $id, legalEntityId: $legalEntityId)
}
    `;
export type SyncConnectionMutationFn = Apollo.MutationFunction<SyncConnectionMutation, SyncConnectionMutationVariables>;

/**
 * __useSyncConnectionMutation__
 *
 * To run a mutation, you first call `useSyncConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncConnectionMutation, { data, loading, error }] = useSyncConnectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useSyncConnectionMutation(baseOptions?: Apollo.MutationHookOptions<SyncConnectionMutation, SyncConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncConnectionMutation, SyncConnectionMutationVariables>(SyncConnectionDocument, options);
      }
export type SyncConnectionMutationHookResult = ReturnType<typeof useSyncConnectionMutation>;
export type SyncConnectionMutationResult = Apollo.MutationResult<SyncConnectionMutation>;
export type SyncConnectionMutationOptions = Apollo.BaseMutationOptions<SyncConnectionMutation, SyncConnectionMutationVariables>;
export const UpdateConnectionFeatureFlagStatusDocument = gql`
    mutation UpdateConnectionFeatureFlagStatus($connectorId: String!, $connectionId: String!, $featureFlagId: String!, $status: ConnectionFeatureFlagStatusValue!) {
  updateConnectionFeatureFlagStatus(
    connectorId: $connectorId
    connectionId: $connectionId
    featureFlagId: $featureFlagId
    status: $status
  )
}
    `;
export type UpdateConnectionFeatureFlagStatusMutationFn = Apollo.MutationFunction<UpdateConnectionFeatureFlagStatusMutation, UpdateConnectionFeatureFlagStatusMutationVariables>;

/**
 * __useUpdateConnectionFeatureFlagStatusMutation__
 *
 * To run a mutation, you first call `useUpdateConnectionFeatureFlagStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConnectionFeatureFlagStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConnectionFeatureFlagStatusMutation, { data, loading, error }] = useUpdateConnectionFeatureFlagStatusMutation({
 *   variables: {
 *      connectorId: // value for 'connectorId'
 *      connectionId: // value for 'connectionId'
 *      featureFlagId: // value for 'featureFlagId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateConnectionFeatureFlagStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConnectionFeatureFlagStatusMutation, UpdateConnectionFeatureFlagStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateConnectionFeatureFlagStatusMutation, UpdateConnectionFeatureFlagStatusMutationVariables>(UpdateConnectionFeatureFlagStatusDocument, options);
      }
export type UpdateConnectionFeatureFlagStatusMutationHookResult = ReturnType<typeof useUpdateConnectionFeatureFlagStatusMutation>;
export type UpdateConnectionFeatureFlagStatusMutationResult = Apollo.MutationResult<UpdateConnectionFeatureFlagStatusMutation>;
export type UpdateConnectionFeatureFlagStatusMutationOptions = Apollo.BaseMutationOptions<UpdateConnectionFeatureFlagStatusMutation, UpdateConnectionFeatureFlagStatusMutationVariables>;
export const UpdateConnectionTemplateDocument = gql`
    mutation UpdateConnectionTemplate($connectorId: String!, $institutionId: String!, $externalId: String!) {
  updateConnectionTemplate(
    connectorId: $connectorId
    institutionId: $institutionId
    externalId: $externalId
  )
}
    `;
export type UpdateConnectionTemplateMutationFn = Apollo.MutationFunction<UpdateConnectionTemplateMutation, UpdateConnectionTemplateMutationVariables>;

/**
 * __useUpdateConnectionTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateConnectionTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConnectionTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConnectionTemplateMutation, { data, loading, error }] = useUpdateConnectionTemplateMutation({
 *   variables: {
 *      connectorId: // value for 'connectorId'
 *      institutionId: // value for 'institutionId'
 *      externalId: // value for 'externalId'
 *   },
 * });
 */
export function useUpdateConnectionTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConnectionTemplateMutation, UpdateConnectionTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateConnectionTemplateMutation, UpdateConnectionTemplateMutationVariables>(UpdateConnectionTemplateDocument, options);
      }
export type UpdateConnectionTemplateMutationHookResult = ReturnType<typeof useUpdateConnectionTemplateMutation>;
export type UpdateConnectionTemplateMutationResult = Apollo.MutationResult<UpdateConnectionTemplateMutation>;
export type UpdateConnectionTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateConnectionTemplateMutation, UpdateConnectionTemplateMutationVariables>;
export const ListConnectionEventsDocument = gql`
    query ListConnectionEvents($connectionId: String!, $legalEntityId: String!, $pagination: Pagination!) {
  listConnectionEvents(
    id: $connectionId
    legalEntityId: $legalEntityId
    pagination: $pagination
  ) {
    ...AdminConnectionEventFields
  }
}
    ${AdminConnectionEventFieldsFragmentDoc}`;

/**
 * __useListConnectionEventsQuery__
 *
 * To run a query within a React component, call `useListConnectionEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListConnectionEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListConnectionEventsQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *      legalEntityId: // value for 'legalEntityId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useListConnectionEventsQuery(baseOptions: Apollo.QueryHookOptions<ListConnectionEventsQuery, ListConnectionEventsQueryVariables> & ({ variables: ListConnectionEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListConnectionEventsQuery, ListConnectionEventsQueryVariables>(ListConnectionEventsDocument, options);
      }
export function useListConnectionEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListConnectionEventsQuery, ListConnectionEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListConnectionEventsQuery, ListConnectionEventsQueryVariables>(ListConnectionEventsDocument, options);
        }
export function useListConnectionEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListConnectionEventsQuery, ListConnectionEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListConnectionEventsQuery, ListConnectionEventsQueryVariables>(ListConnectionEventsDocument, options);
        }
export type ListConnectionEventsQueryHookResult = ReturnType<typeof useListConnectionEventsQuery>;
export type ListConnectionEventsLazyQueryHookResult = ReturnType<typeof useListConnectionEventsLazyQuery>;
export type ListConnectionEventsSuspenseQueryHookResult = ReturnType<typeof useListConnectionEventsSuspenseQuery>;
export type ListConnectionEventsQueryResult = Apollo.QueryResult<ListConnectionEventsQuery, ListConnectionEventsQueryVariables>;
export const ListConnectionFeatureFlagsDocument = gql`
    query ListConnectionFeatureFlags($connectionId: String!) {
  listConnectionFeatureFlags(connectionId: $connectionId) {
    connectorId
    connectionId
    featureFlagId
    status
    code
    name
    description
  }
}
    `;

/**
 * __useListConnectionFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useListConnectionFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListConnectionFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListConnectionFeatureFlagsQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useListConnectionFeatureFlagsQuery(baseOptions: Apollo.QueryHookOptions<ListConnectionFeatureFlagsQuery, ListConnectionFeatureFlagsQueryVariables> & ({ variables: ListConnectionFeatureFlagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListConnectionFeatureFlagsQuery, ListConnectionFeatureFlagsQueryVariables>(ListConnectionFeatureFlagsDocument, options);
      }
export function useListConnectionFeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListConnectionFeatureFlagsQuery, ListConnectionFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListConnectionFeatureFlagsQuery, ListConnectionFeatureFlagsQueryVariables>(ListConnectionFeatureFlagsDocument, options);
        }
export function useListConnectionFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListConnectionFeatureFlagsQuery, ListConnectionFeatureFlagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListConnectionFeatureFlagsQuery, ListConnectionFeatureFlagsQueryVariables>(ListConnectionFeatureFlagsDocument, options);
        }
export type ListConnectionFeatureFlagsQueryHookResult = ReturnType<typeof useListConnectionFeatureFlagsQuery>;
export type ListConnectionFeatureFlagsLazyQueryHookResult = ReturnType<typeof useListConnectionFeatureFlagsLazyQuery>;
export type ListConnectionFeatureFlagsSuspenseQueryHookResult = ReturnType<typeof useListConnectionFeatureFlagsSuspenseQuery>;
export type ListConnectionFeatureFlagsQueryResult = Apollo.QueryResult<ListConnectionFeatureFlagsQuery, ListConnectionFeatureFlagsQueryVariables>;
export const ListConnectionTemplatesDocument = gql`
    query ListConnectionTemplates {
  listConnectionTemplates {
    ...AdminConnectionTemplateFields
  }
}
    ${AdminConnectionTemplateFieldsFragmentDoc}`;

/**
 * __useListConnectionTemplatesQuery__
 *
 * To run a query within a React component, call `useListConnectionTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListConnectionTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListConnectionTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListConnectionTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<ListConnectionTemplatesQuery, ListConnectionTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListConnectionTemplatesQuery, ListConnectionTemplatesQueryVariables>(ListConnectionTemplatesDocument, options);
      }
export function useListConnectionTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListConnectionTemplatesQuery, ListConnectionTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListConnectionTemplatesQuery, ListConnectionTemplatesQueryVariables>(ListConnectionTemplatesDocument, options);
        }
export function useListConnectionTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListConnectionTemplatesQuery, ListConnectionTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListConnectionTemplatesQuery, ListConnectionTemplatesQueryVariables>(ListConnectionTemplatesDocument, options);
        }
export type ListConnectionTemplatesQueryHookResult = ReturnType<typeof useListConnectionTemplatesQuery>;
export type ListConnectionTemplatesLazyQueryHookResult = ReturnType<typeof useListConnectionTemplatesLazyQuery>;
export type ListConnectionTemplatesSuspenseQueryHookResult = ReturnType<typeof useListConnectionTemplatesSuspenseQuery>;
export type ListConnectionTemplatesQueryResult = Apollo.QueryResult<ListConnectionTemplatesQuery, ListConnectionTemplatesQueryVariables>;
export const ListConnectionsDocument = gql`
    query ListConnections($legalEntityId: String!) {
  listConnections(legalEntityId: $legalEntityId) {
    ...AdminConnectionListFields
  }
}
    ${AdminConnectionListFieldsFragmentDoc}`;

/**
 * __useListConnectionsQuery__
 *
 * To run a query within a React component, call `useListConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListConnectionsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListConnectionsQuery(baseOptions: Apollo.QueryHookOptions<ListConnectionsQuery, ListConnectionsQueryVariables> & ({ variables: ListConnectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListConnectionsQuery, ListConnectionsQueryVariables>(ListConnectionsDocument, options);
      }
export function useListConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListConnectionsQuery, ListConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListConnectionsQuery, ListConnectionsQueryVariables>(ListConnectionsDocument, options);
        }
export function useListConnectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListConnectionsQuery, ListConnectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListConnectionsQuery, ListConnectionsQueryVariables>(ListConnectionsDocument, options);
        }
export type ListConnectionsQueryHookResult = ReturnType<typeof useListConnectionsQuery>;
export type ListConnectionsLazyQueryHookResult = ReturnType<typeof useListConnectionsLazyQuery>;
export type ListConnectionsSuspenseQueryHookResult = ReturnType<typeof useListConnectionsSuspenseQuery>;
export type ListConnectionsQueryResult = Apollo.QueryResult<ListConnectionsQuery, ListConnectionsQueryVariables>;
export const ListConnectorInstallsDocument = gql`
    query ListConnectorInstalls($connectorId: String!) {
  listConnectorInstalls(connectorId: $connectorId) {
    connectionId
    legalEntityId
    connectorId
    status
    deletedAt
    createdAt
    sourceName
    externalId
  }
}
    `;

/**
 * __useListConnectorInstallsQuery__
 *
 * To run a query within a React component, call `useListConnectorInstallsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListConnectorInstallsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListConnectorInstallsQuery({
 *   variables: {
 *      connectorId: // value for 'connectorId'
 *   },
 * });
 */
export function useListConnectorInstallsQuery(baseOptions: Apollo.QueryHookOptions<ListConnectorInstallsQuery, ListConnectorInstallsQueryVariables> & ({ variables: ListConnectorInstallsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListConnectorInstallsQuery, ListConnectorInstallsQueryVariables>(ListConnectorInstallsDocument, options);
      }
export function useListConnectorInstallsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListConnectorInstallsQuery, ListConnectorInstallsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListConnectorInstallsQuery, ListConnectorInstallsQueryVariables>(ListConnectorInstallsDocument, options);
        }
export function useListConnectorInstallsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListConnectorInstallsQuery, ListConnectorInstallsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListConnectorInstallsQuery, ListConnectorInstallsQueryVariables>(ListConnectorInstallsDocument, options);
        }
export type ListConnectorInstallsQueryHookResult = ReturnType<typeof useListConnectorInstallsQuery>;
export type ListConnectorInstallsLazyQueryHookResult = ReturnType<typeof useListConnectorInstallsLazyQuery>;
export type ListConnectorInstallsSuspenseQueryHookResult = ReturnType<typeof useListConnectorInstallsSuspenseQuery>;
export type ListConnectorInstallsQueryResult = Apollo.QueryResult<ListConnectorInstallsQuery, ListConnectorInstallsQueryVariables>;
export const ListConnectorsDocument = gql`
    query ListConnectors($institutionId: String, $className: String, $visibility: ConnectorVisibility, $searchTerm: String, $pagination: Pagination) {
  listConnectors(
    institutionId: $institutionId
    className: $className
    visibility: $visibility
    searchTerm: $searchTerm
    pagination: $pagination
  ) {
    ...AdminConnectorFields
  }
}
    ${AdminConnectorFieldsFragmentDoc}`;

/**
 * __useListConnectorsQuery__
 *
 * To run a query within a React component, call `useListConnectorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListConnectorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListConnectorsQuery({
 *   variables: {
 *      institutionId: // value for 'institutionId'
 *      className: // value for 'className'
 *      visibility: // value for 'visibility'
 *      searchTerm: // value for 'searchTerm'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useListConnectorsQuery(baseOptions?: Apollo.QueryHookOptions<ListConnectorsQuery, ListConnectorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListConnectorsQuery, ListConnectorsQueryVariables>(ListConnectorsDocument, options);
      }
export function useListConnectorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListConnectorsQuery, ListConnectorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListConnectorsQuery, ListConnectorsQueryVariables>(ListConnectorsDocument, options);
        }
export function useListConnectorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListConnectorsQuery, ListConnectorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListConnectorsQuery, ListConnectorsQueryVariables>(ListConnectorsDocument, options);
        }
export type ListConnectorsQueryHookResult = ReturnType<typeof useListConnectorsQuery>;
export type ListConnectorsLazyQueryHookResult = ReturnType<typeof useListConnectorsLazyQuery>;
export type ListConnectorsSuspenseQueryHookResult = ReturnType<typeof useListConnectorsSuspenseQuery>;
export type ListConnectorsQueryResult = Apollo.QueryResult<ListConnectorsQuery, ListConnectorsQueryVariables>;
export const ReadConnectRecordingDocument = gql`
    query ReadConnectRecording($connectionId: String!, $legalEntityId: String!, $eventId: String!) {
  readConnectRecording(
    connectionId: $connectionId
    legalEntityId: $legalEntityId
    eventId: $eventId
  ) {
    responses {
      rawBody
      metadata {
        request_id
        url
        status
        status_code
      }
    }
  }
}
    `;

/**
 * __useReadConnectRecordingQuery__
 *
 * To run a query within a React component, call `useReadConnectRecordingQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadConnectRecordingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadConnectRecordingQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *      legalEntityId: // value for 'legalEntityId'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useReadConnectRecordingQuery(baseOptions: Apollo.QueryHookOptions<ReadConnectRecordingQuery, ReadConnectRecordingQueryVariables> & ({ variables: ReadConnectRecordingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadConnectRecordingQuery, ReadConnectRecordingQueryVariables>(ReadConnectRecordingDocument, options);
      }
export function useReadConnectRecordingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadConnectRecordingQuery, ReadConnectRecordingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadConnectRecordingQuery, ReadConnectRecordingQueryVariables>(ReadConnectRecordingDocument, options);
        }
export function useReadConnectRecordingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadConnectRecordingQuery, ReadConnectRecordingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadConnectRecordingQuery, ReadConnectRecordingQueryVariables>(ReadConnectRecordingDocument, options);
        }
export type ReadConnectRecordingQueryHookResult = ReturnType<typeof useReadConnectRecordingQuery>;
export type ReadConnectRecordingLazyQueryHookResult = ReturnType<typeof useReadConnectRecordingLazyQuery>;
export type ReadConnectRecordingSuspenseQueryHookResult = ReturnType<typeof useReadConnectRecordingSuspenseQuery>;
export type ReadConnectRecordingQueryResult = Apollo.QueryResult<ReadConnectRecordingQuery, ReadConnectRecordingQueryVariables>;
export const ReadConnectionDocument = gql`
    query ReadConnection($connectionId: String!, $legalEntityId: String!) {
  readConnection(id: $connectionId, legalEntityId: $legalEntityId) {
    ...AdminConnectionFields
    accounts {
      id
      connectionId
      sourceAccountId
      name
      mask
      type
      subtype
      status
      deleted
      createdAt
    }
  }
}
    ${AdminConnectionFieldsFragmentDoc}`;

/**
 * __useReadConnectionQuery__
 *
 * To run a query within a React component, call `useReadConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadConnectionQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useReadConnectionQuery(baseOptions: Apollo.QueryHookOptions<ReadConnectionQuery, ReadConnectionQueryVariables> & ({ variables: ReadConnectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadConnectionQuery, ReadConnectionQueryVariables>(ReadConnectionDocument, options);
      }
export function useReadConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadConnectionQuery, ReadConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadConnectionQuery, ReadConnectionQueryVariables>(ReadConnectionDocument, options);
        }
export function useReadConnectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadConnectionQuery, ReadConnectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadConnectionQuery, ReadConnectionQueryVariables>(ReadConnectionDocument, options);
        }
export type ReadConnectionQueryHookResult = ReturnType<typeof useReadConnectionQuery>;
export type ReadConnectionLazyQueryHookResult = ReturnType<typeof useReadConnectionLazyQuery>;
export type ReadConnectionSuspenseQueryHookResult = ReturnType<typeof useReadConnectionSuspenseQuery>;
export type ReadConnectionQueryResult = Apollo.QueryResult<ReadConnectionQuery, ReadConnectionQueryVariables>;
export const ReadConnectorDocument = gql`
    query ReadConnector($connectorId: String!) {
  readConnector(connectorId: $connectorId) {
    ...AdminConnectorFields
  }
}
    ${AdminConnectorFieldsFragmentDoc}`;

/**
 * __useReadConnectorQuery__
 *
 * To run a query within a React component, call `useReadConnectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadConnectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadConnectorQuery({
 *   variables: {
 *      connectorId: // value for 'connectorId'
 *   },
 * });
 */
export function useReadConnectorQuery(baseOptions: Apollo.QueryHookOptions<ReadConnectorQuery, ReadConnectorQueryVariables> & ({ variables: ReadConnectorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadConnectorQuery, ReadConnectorQueryVariables>(ReadConnectorDocument, options);
      }
export function useReadConnectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadConnectorQuery, ReadConnectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadConnectorQuery, ReadConnectorQueryVariables>(ReadConnectorDocument, options);
        }
export function useReadConnectorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadConnectorQuery, ReadConnectorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadConnectorQuery, ReadConnectorQueryVariables>(ReadConnectorDocument, options);
        }
export type ReadConnectorQueryHookResult = ReturnType<typeof useReadConnectorQuery>;
export type ReadConnectorLazyQueryHookResult = ReturnType<typeof useReadConnectorLazyQuery>;
export type ReadConnectorSuspenseQueryHookResult = ReturnType<typeof useReadConnectorSuspenseQuery>;
export type ReadConnectorQueryResult = Apollo.QueryResult<ReadConnectorQuery, ReadConnectorQueryVariables>;
export const ReadConnectorCredentialsDocument = gql`
    query ReadConnectorCredentials($connectorId: String!) {
  readConnectorCredentials(connectorId: $connectorId) {
    environment
    clientId
  }
}
    `;

/**
 * __useReadConnectorCredentialsQuery__
 *
 * To run a query within a React component, call `useReadConnectorCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadConnectorCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadConnectorCredentialsQuery({
 *   variables: {
 *      connectorId: // value for 'connectorId'
 *   },
 * });
 */
export function useReadConnectorCredentialsQuery(baseOptions: Apollo.QueryHookOptions<ReadConnectorCredentialsQuery, ReadConnectorCredentialsQueryVariables> & ({ variables: ReadConnectorCredentialsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadConnectorCredentialsQuery, ReadConnectorCredentialsQueryVariables>(ReadConnectorCredentialsDocument, options);
      }
export function useReadConnectorCredentialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadConnectorCredentialsQuery, ReadConnectorCredentialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadConnectorCredentialsQuery, ReadConnectorCredentialsQueryVariables>(ReadConnectorCredentialsDocument, options);
        }
export function useReadConnectorCredentialsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadConnectorCredentialsQuery, ReadConnectorCredentialsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadConnectorCredentialsQuery, ReadConnectorCredentialsQueryVariables>(ReadConnectorCredentialsDocument, options);
        }
export type ReadConnectorCredentialsQueryHookResult = ReturnType<typeof useReadConnectorCredentialsQuery>;
export type ReadConnectorCredentialsLazyQueryHookResult = ReturnType<typeof useReadConnectorCredentialsLazyQuery>;
export type ReadConnectorCredentialsSuspenseQueryHookResult = ReturnType<typeof useReadConnectorCredentialsSuspenseQuery>;
export type ReadConnectorCredentialsQueryResult = Apollo.QueryResult<ReadConnectorCredentialsQuery, ReadConnectorCredentialsQueryVariables>;
export const ListCsvImportTransactionFactsDocument = gql`
    query ListCsvImportTransactionFacts($legalEntityId: String!, $csvImportId: String!, $pagination: Pagination) {
  listCsvImportTransactionFacts(
    legalEntityId: $legalEntityId
    csvImportId: $csvImportId
    pagination: $pagination
  )
}
    `;

/**
 * __useListCsvImportTransactionFactsQuery__
 *
 * To run a query within a React component, call `useListCsvImportTransactionFactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCsvImportTransactionFactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCsvImportTransactionFactsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      csvImportId: // value for 'csvImportId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useListCsvImportTransactionFactsQuery(baseOptions: Apollo.QueryHookOptions<ListCsvImportTransactionFactsQuery, ListCsvImportTransactionFactsQueryVariables> & ({ variables: ListCsvImportTransactionFactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCsvImportTransactionFactsQuery, ListCsvImportTransactionFactsQueryVariables>(ListCsvImportTransactionFactsDocument, options);
      }
export function useListCsvImportTransactionFactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCsvImportTransactionFactsQuery, ListCsvImportTransactionFactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCsvImportTransactionFactsQuery, ListCsvImportTransactionFactsQueryVariables>(ListCsvImportTransactionFactsDocument, options);
        }
export function useListCsvImportTransactionFactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListCsvImportTransactionFactsQuery, ListCsvImportTransactionFactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListCsvImportTransactionFactsQuery, ListCsvImportTransactionFactsQueryVariables>(ListCsvImportTransactionFactsDocument, options);
        }
export type ListCsvImportTransactionFactsQueryHookResult = ReturnType<typeof useListCsvImportTransactionFactsQuery>;
export type ListCsvImportTransactionFactsLazyQueryHookResult = ReturnType<typeof useListCsvImportTransactionFactsLazyQuery>;
export type ListCsvImportTransactionFactsSuspenseQueryHookResult = ReturnType<typeof useListCsvImportTransactionFactsSuspenseQuery>;
export type ListCsvImportTransactionFactsQueryResult = Apollo.QueryResult<ListCsvImportTransactionFactsQuery, ListCsvImportTransactionFactsQueryVariables>;
export const ListCsvImportsDocument = gql`
    query ListCsvImports($legalEntityId: String!, $pagination: Pagination!, $order: CsvImportSort) {
  listCsvImports(
    legalEntityId: $legalEntityId
    pagination: $pagination
    order: $order
  ) {
    csvImportId
    dataSourceId
    fileName
    transactionCount
    source
    createdAt
    deletedAt
  }
}
    `;

/**
 * __useListCsvImportsQuery__
 *
 * To run a query within a React component, call `useListCsvImportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCsvImportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCsvImportsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListCsvImportsQuery(baseOptions: Apollo.QueryHookOptions<ListCsvImportsQuery, ListCsvImportsQueryVariables> & ({ variables: ListCsvImportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCsvImportsQuery, ListCsvImportsQueryVariables>(ListCsvImportsDocument, options);
      }
export function useListCsvImportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCsvImportsQuery, ListCsvImportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCsvImportsQuery, ListCsvImportsQueryVariables>(ListCsvImportsDocument, options);
        }
export function useListCsvImportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListCsvImportsQuery, ListCsvImportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListCsvImportsQuery, ListCsvImportsQueryVariables>(ListCsvImportsDocument, options);
        }
export type ListCsvImportsQueryHookResult = ReturnType<typeof useListCsvImportsQuery>;
export type ListCsvImportsLazyQueryHookResult = ReturnType<typeof useListCsvImportsLazyQuery>;
export type ListCsvImportsSuspenseQueryHookResult = ReturnType<typeof useListCsvImportsSuspenseQuery>;
export type ListCsvImportsQueryResult = Apollo.QueryResult<ListCsvImportsQuery, ListCsvImportsQueryVariables>;
export const OnboardDocument = gql`
    mutation Onboard($legalEntityId: String!) {
  onboard(legalEntityId: $legalEntityId)
}
    `;
export type OnboardMutationFn = Apollo.MutationFunction<OnboardMutation, OnboardMutationVariables>;

/**
 * __useOnboardMutation__
 *
 * To run a mutation, you first call `useOnboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardMutation, { data, loading, error }] = useOnboardMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useOnboardMutation(baseOptions?: Apollo.MutationHookOptions<OnboardMutation, OnboardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OnboardMutation, OnboardMutationVariables>(OnboardDocument, options);
      }
export type OnboardMutationHookResult = ReturnType<typeof useOnboardMutation>;
export type OnboardMutationResult = Apollo.MutationResult<OnboardMutation>;
export type OnboardMutationOptions = Apollo.BaseMutationOptions<OnboardMutation, OnboardMutationVariables>;
export const TriggerDenormalizedViewGenerationDocument = gql`
    mutation TriggerDenormalizedViewGeneration($legalEntityId: String!) {
  triggerDenormalizedViewGeneration(legalEntityId: $legalEntityId)
}
    `;
export type TriggerDenormalizedViewGenerationMutationFn = Apollo.MutationFunction<TriggerDenormalizedViewGenerationMutation, TriggerDenormalizedViewGenerationMutationVariables>;

/**
 * __useTriggerDenormalizedViewGenerationMutation__
 *
 * To run a mutation, you first call `useTriggerDenormalizedViewGenerationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerDenormalizedViewGenerationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerDenormalizedViewGenerationMutation, { data, loading, error }] = useTriggerDenormalizedViewGenerationMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useTriggerDenormalizedViewGenerationMutation(baseOptions?: Apollo.MutationHookOptions<TriggerDenormalizedViewGenerationMutation, TriggerDenormalizedViewGenerationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerDenormalizedViewGenerationMutation, TriggerDenormalizedViewGenerationMutationVariables>(TriggerDenormalizedViewGenerationDocument, options);
      }
export type TriggerDenormalizedViewGenerationMutationHookResult = ReturnType<typeof useTriggerDenormalizedViewGenerationMutation>;
export type TriggerDenormalizedViewGenerationMutationResult = Apollo.MutationResult<TriggerDenormalizedViewGenerationMutation>;
export type TriggerDenormalizedViewGenerationMutationOptions = Apollo.BaseMutationOptions<TriggerDenormalizedViewGenerationMutation, TriggerDenormalizedViewGenerationMutationVariables>;
export const TriggerFraudCheckAccountingDocument = gql`
    mutation TriggerFraudCheckAccounting($legalEntityId: String!) {
  triggerFraudCheckAccounting(legalEntityId: $legalEntityId)
}
    `;
export type TriggerFraudCheckAccountingMutationFn = Apollo.MutationFunction<TriggerFraudCheckAccountingMutation, TriggerFraudCheckAccountingMutationVariables>;

/**
 * __useTriggerFraudCheckAccountingMutation__
 *
 * To run a mutation, you first call `useTriggerFraudCheckAccountingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerFraudCheckAccountingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerFraudCheckAccountingMutation, { data, loading, error }] = useTriggerFraudCheckAccountingMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useTriggerFraudCheckAccountingMutation(baseOptions?: Apollo.MutationHookOptions<TriggerFraudCheckAccountingMutation, TriggerFraudCheckAccountingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerFraudCheckAccountingMutation, TriggerFraudCheckAccountingMutationVariables>(TriggerFraudCheckAccountingDocument, options);
      }
export type TriggerFraudCheckAccountingMutationHookResult = ReturnType<typeof useTriggerFraudCheckAccountingMutation>;
export type TriggerFraudCheckAccountingMutationResult = Apollo.MutationResult<TriggerFraudCheckAccountingMutation>;
export type TriggerFraudCheckAccountingMutationOptions = Apollo.BaseMutationOptions<TriggerFraudCheckAccountingMutation, TriggerFraudCheckAccountingMutationVariables>;
export const ListAllDataProcessingStatusesDocument = gql`
    query ListAllDataProcessingStatuses {
  listAllDataProcessingStatuses {
    entries {
      ...DenormalizedViewStatusFields
    }
  }
}
    ${DenormalizedViewStatusFieldsFragmentDoc}`;

/**
 * __useListAllDataProcessingStatusesQuery__
 *
 * To run a query within a React component, call `useListAllDataProcessingStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAllDataProcessingStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAllDataProcessingStatusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListAllDataProcessingStatusesQuery(baseOptions?: Apollo.QueryHookOptions<ListAllDataProcessingStatusesQuery, ListAllDataProcessingStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAllDataProcessingStatusesQuery, ListAllDataProcessingStatusesQueryVariables>(ListAllDataProcessingStatusesDocument, options);
      }
export function useListAllDataProcessingStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAllDataProcessingStatusesQuery, ListAllDataProcessingStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAllDataProcessingStatusesQuery, ListAllDataProcessingStatusesQueryVariables>(ListAllDataProcessingStatusesDocument, options);
        }
export function useListAllDataProcessingStatusesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAllDataProcessingStatusesQuery, ListAllDataProcessingStatusesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAllDataProcessingStatusesQuery, ListAllDataProcessingStatusesQueryVariables>(ListAllDataProcessingStatusesDocument, options);
        }
export type ListAllDataProcessingStatusesQueryHookResult = ReturnType<typeof useListAllDataProcessingStatusesQuery>;
export type ListAllDataProcessingStatusesLazyQueryHookResult = ReturnType<typeof useListAllDataProcessingStatusesLazyQuery>;
export type ListAllDataProcessingStatusesSuspenseQueryHookResult = ReturnType<typeof useListAllDataProcessingStatusesSuspenseQuery>;
export type ListAllDataProcessingStatusesQueryResult = Apollo.QueryResult<ListAllDataProcessingStatusesQuery, ListAllDataProcessingStatusesQueryVariables>;
export const ReadEntityDataProcessingStatusesDocument = gql`
    query ReadEntityDataProcessingStatuses($legalEntityId: String!) {
  readEntityDataProcessingStatuses(legalEntityId: $legalEntityId) {
    entries {
      ...DenormalizedViewStatusFields
    }
  }
}
    ${DenormalizedViewStatusFieldsFragmentDoc}`;

/**
 * __useReadEntityDataProcessingStatusesQuery__
 *
 * To run a query within a React component, call `useReadEntityDataProcessingStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadEntityDataProcessingStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadEntityDataProcessingStatusesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useReadEntityDataProcessingStatusesQuery(baseOptions: Apollo.QueryHookOptions<ReadEntityDataProcessingStatusesQuery, ReadEntityDataProcessingStatusesQueryVariables> & ({ variables: ReadEntityDataProcessingStatusesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadEntityDataProcessingStatusesQuery, ReadEntityDataProcessingStatusesQueryVariables>(ReadEntityDataProcessingStatusesDocument, options);
      }
export function useReadEntityDataProcessingStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadEntityDataProcessingStatusesQuery, ReadEntityDataProcessingStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadEntityDataProcessingStatusesQuery, ReadEntityDataProcessingStatusesQueryVariables>(ReadEntityDataProcessingStatusesDocument, options);
        }
export function useReadEntityDataProcessingStatusesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadEntityDataProcessingStatusesQuery, ReadEntityDataProcessingStatusesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadEntityDataProcessingStatusesQuery, ReadEntityDataProcessingStatusesQueryVariables>(ReadEntityDataProcessingStatusesDocument, options);
        }
export type ReadEntityDataProcessingStatusesQueryHookResult = ReturnType<typeof useReadEntityDataProcessingStatusesQuery>;
export type ReadEntityDataProcessingStatusesLazyQueryHookResult = ReturnType<typeof useReadEntityDataProcessingStatusesLazyQuery>;
export type ReadEntityDataProcessingStatusesSuspenseQueryHookResult = ReturnType<typeof useReadEntityDataProcessingStatusesSuspenseQuery>;
export type ReadEntityDataProcessingStatusesQueryResult = Apollo.QueryResult<ReadEntityDataProcessingStatusesQuery, ReadEntityDataProcessingStatusesQueryVariables>;
export const DeleteAdminDataSourceDocument = gql`
    mutation DeleteAdminDataSource($legalEntityId: String!, $dataSourceId: String!, $providerType: ProviderType!) {
  deleteAdminDataSource(
    legalEntityId: $legalEntityId
    dataSourceId: $dataSourceId
    providerType: $providerType
  )
}
    `;
export type DeleteAdminDataSourceMutationFn = Apollo.MutationFunction<DeleteAdminDataSourceMutation, DeleteAdminDataSourceMutationVariables>;

/**
 * __useDeleteAdminDataSourceMutation__
 *
 * To run a mutation, you first call `useDeleteAdminDataSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdminDataSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAdminDataSourceMutation, { data, loading, error }] = useDeleteAdminDataSourceMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      dataSourceId: // value for 'dataSourceId'
 *      providerType: // value for 'providerType'
 *   },
 * });
 */
export function useDeleteAdminDataSourceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAdminDataSourceMutation, DeleteAdminDataSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAdminDataSourceMutation, DeleteAdminDataSourceMutationVariables>(DeleteAdminDataSourceDocument, options);
      }
export type DeleteAdminDataSourceMutationHookResult = ReturnType<typeof useDeleteAdminDataSourceMutation>;
export type DeleteAdminDataSourceMutationResult = Apollo.MutationResult<DeleteAdminDataSourceMutation>;
export type DeleteAdminDataSourceMutationOptions = Apollo.BaseMutationOptions<DeleteAdminDataSourceMutation, DeleteAdminDataSourceMutationVariables>;
export const TriggerDataSourceClassificationDocument = gql`
    mutation TriggerDataSourceClassification($legalEntityId: String!, $dataSourceId: String!) {
  triggerDataSourceClassification(
    legalEntityId: $legalEntityId
    dataSourceId: $dataSourceId
  )
}
    `;
export type TriggerDataSourceClassificationMutationFn = Apollo.MutationFunction<TriggerDataSourceClassificationMutation, TriggerDataSourceClassificationMutationVariables>;

/**
 * __useTriggerDataSourceClassificationMutation__
 *
 * To run a mutation, you first call `useTriggerDataSourceClassificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerDataSourceClassificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerDataSourceClassificationMutation, { data, loading, error }] = useTriggerDataSourceClassificationMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      dataSourceId: // value for 'dataSourceId'
 *   },
 * });
 */
export function useTriggerDataSourceClassificationMutation(baseOptions?: Apollo.MutationHookOptions<TriggerDataSourceClassificationMutation, TriggerDataSourceClassificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerDataSourceClassificationMutation, TriggerDataSourceClassificationMutationVariables>(TriggerDataSourceClassificationDocument, options);
      }
export type TriggerDataSourceClassificationMutationHookResult = ReturnType<typeof useTriggerDataSourceClassificationMutation>;
export type TriggerDataSourceClassificationMutationResult = Apollo.MutationResult<TriggerDataSourceClassificationMutation>;
export type TriggerDataSourceClassificationMutationOptions = Apollo.BaseMutationOptions<TriggerDataSourceClassificationMutation, TriggerDataSourceClassificationMutationVariables>;
export const ListAdminBooksClosedFactsDocument = gql`
    query ListAdminBooksClosedFacts($legalEntityId: String!) {
  listAdminBooksClosedFacts(legalEntityId: $legalEntityId) {
    ...BooksClosedFactFields
  }
}
    ${BooksClosedFactFieldsFragmentDoc}`;

/**
 * __useListAdminBooksClosedFactsQuery__
 *
 * To run a query within a React component, call `useListAdminBooksClosedFactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAdminBooksClosedFactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAdminBooksClosedFactsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListAdminBooksClosedFactsQuery(baseOptions: Apollo.QueryHookOptions<ListAdminBooksClosedFactsQuery, ListAdminBooksClosedFactsQueryVariables> & ({ variables: ListAdminBooksClosedFactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAdminBooksClosedFactsQuery, ListAdminBooksClosedFactsQueryVariables>(ListAdminBooksClosedFactsDocument, options);
      }
export function useListAdminBooksClosedFactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAdminBooksClosedFactsQuery, ListAdminBooksClosedFactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAdminBooksClosedFactsQuery, ListAdminBooksClosedFactsQueryVariables>(ListAdminBooksClosedFactsDocument, options);
        }
export function useListAdminBooksClosedFactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAdminBooksClosedFactsQuery, ListAdminBooksClosedFactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAdminBooksClosedFactsQuery, ListAdminBooksClosedFactsQueryVariables>(ListAdminBooksClosedFactsDocument, options);
        }
export type ListAdminBooksClosedFactsQueryHookResult = ReturnType<typeof useListAdminBooksClosedFactsQuery>;
export type ListAdminBooksClosedFactsLazyQueryHookResult = ReturnType<typeof useListAdminBooksClosedFactsLazyQuery>;
export type ListAdminBooksClosedFactsSuspenseQueryHookResult = ReturnType<typeof useListAdminBooksClosedFactsSuspenseQuery>;
export type ListAdminBooksClosedFactsQueryResult = Apollo.QueryResult<ListAdminBooksClosedFactsQuery, ListAdminBooksClosedFactsQueryVariables>;
export const ListAdminOwnedDataSourcesDocument = gql`
    query ListAdminOwnedDataSources($legalEntityId: String!) {
  listAdminOwnedDataSources(legalEntityId: $legalEntityId) {
    dataSource {
      ...EnrichedDataSourceFields
    }
    ownedSourceAccounts {
      ...OwnedSourceAccountFields
    }
    dataSourcePreference {
      ...DataSourcePreferenceFields
    }
  }
}
    ${EnrichedDataSourceFieldsFragmentDoc}
${OwnedSourceAccountFieldsFragmentDoc}
${DataSourcePreferenceFieldsFragmentDoc}`;

/**
 * __useListAdminOwnedDataSourcesQuery__
 *
 * To run a query within a React component, call `useListAdminOwnedDataSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAdminOwnedDataSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAdminOwnedDataSourcesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListAdminOwnedDataSourcesQuery(baseOptions: Apollo.QueryHookOptions<ListAdminOwnedDataSourcesQuery, ListAdminOwnedDataSourcesQueryVariables> & ({ variables: ListAdminOwnedDataSourcesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAdminOwnedDataSourcesQuery, ListAdminOwnedDataSourcesQueryVariables>(ListAdminOwnedDataSourcesDocument, options);
      }
export function useListAdminOwnedDataSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAdminOwnedDataSourcesQuery, ListAdminOwnedDataSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAdminOwnedDataSourcesQuery, ListAdminOwnedDataSourcesQueryVariables>(ListAdminOwnedDataSourcesDocument, options);
        }
export function useListAdminOwnedDataSourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAdminOwnedDataSourcesQuery, ListAdminOwnedDataSourcesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAdminOwnedDataSourcesQuery, ListAdminOwnedDataSourcesQueryVariables>(ListAdminOwnedDataSourcesDocument, options);
        }
export type ListAdminOwnedDataSourcesQueryHookResult = ReturnType<typeof useListAdminOwnedDataSourcesQuery>;
export type ListAdminOwnedDataSourcesLazyQueryHookResult = ReturnType<typeof useListAdminOwnedDataSourcesLazyQuery>;
export type ListAdminOwnedDataSourcesSuspenseQueryHookResult = ReturnType<typeof useListAdminOwnedDataSourcesSuspenseQuery>;
export type ListAdminOwnedDataSourcesQueryResult = Apollo.QueryResult<ListAdminOwnedDataSourcesQuery, ListAdminOwnedDataSourcesQueryVariables>;
export const ListDataSourceJobErrorsDocument = gql`
    query ListDataSourceJobErrors($legalEntityId: String!, $requestObjectId: String) {
  listDataSourceJobErrors(
    legalEntityId: $legalEntityId
    requestObjectId: $requestObjectId
  ) {
    jobOwner {
      ...JobOwnerFields
    }
    jobMetadata {
      ...JobMetadataFields
    }
    jobType
    errorMessage
    createdAt
  }
}
    ${JobOwnerFieldsFragmentDoc}
${JobMetadataFieldsFragmentDoc}`;

/**
 * __useListDataSourceJobErrorsQuery__
 *
 * To run a query within a React component, call `useListDataSourceJobErrorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDataSourceJobErrorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDataSourceJobErrorsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      requestObjectId: // value for 'requestObjectId'
 *   },
 * });
 */
export function useListDataSourceJobErrorsQuery(baseOptions: Apollo.QueryHookOptions<ListDataSourceJobErrorsQuery, ListDataSourceJobErrorsQueryVariables> & ({ variables: ListDataSourceJobErrorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDataSourceJobErrorsQuery, ListDataSourceJobErrorsQueryVariables>(ListDataSourceJobErrorsDocument, options);
      }
export function useListDataSourceJobErrorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDataSourceJobErrorsQuery, ListDataSourceJobErrorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDataSourceJobErrorsQuery, ListDataSourceJobErrorsQueryVariables>(ListDataSourceJobErrorsDocument, options);
        }
export function useListDataSourceJobErrorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListDataSourceJobErrorsQuery, ListDataSourceJobErrorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListDataSourceJobErrorsQuery, ListDataSourceJobErrorsQueryVariables>(ListDataSourceJobErrorsDocument, options);
        }
export type ListDataSourceJobErrorsQueryHookResult = ReturnType<typeof useListDataSourceJobErrorsQuery>;
export type ListDataSourceJobErrorsLazyQueryHookResult = ReturnType<typeof useListDataSourceJobErrorsLazyQuery>;
export type ListDataSourceJobErrorsSuspenseQueryHookResult = ReturnType<typeof useListDataSourceJobErrorsSuspenseQuery>;
export type ListDataSourceJobErrorsQueryResult = Apollo.QueryResult<ListDataSourceJobErrorsQuery, ListDataSourceJobErrorsQueryVariables>;
export const ReadValidationHistoryDocument = gql`
    query ReadValidationHistory($legalEntityId: String!) {
  readValidationHistory(legalEntityId: $legalEntityId) {
    ...ValidationHistoryFields
  }
}
    ${ValidationHistoryFieldsFragmentDoc}`;

/**
 * __useReadValidationHistoryQuery__
 *
 * To run a query within a React component, call `useReadValidationHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadValidationHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadValidationHistoryQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useReadValidationHistoryQuery(baseOptions: Apollo.QueryHookOptions<ReadValidationHistoryQuery, ReadValidationHistoryQueryVariables> & ({ variables: ReadValidationHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadValidationHistoryQuery, ReadValidationHistoryQueryVariables>(ReadValidationHistoryDocument, options);
      }
export function useReadValidationHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadValidationHistoryQuery, ReadValidationHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadValidationHistoryQuery, ReadValidationHistoryQueryVariables>(ReadValidationHistoryDocument, options);
        }
export function useReadValidationHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadValidationHistoryQuery, ReadValidationHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadValidationHistoryQuery, ReadValidationHistoryQueryVariables>(ReadValidationHistoryDocument, options);
        }
export type ReadValidationHistoryQueryHookResult = ReturnType<typeof useReadValidationHistoryQuery>;
export type ReadValidationHistoryLazyQueryHookResult = ReturnType<typeof useReadValidationHistoryLazyQuery>;
export type ReadValidationHistorySuspenseQueryHookResult = ReturnType<typeof useReadValidationHistorySuspenseQuery>;
export type ReadValidationHistoryQueryResult = Apollo.QueryResult<ReadValidationHistoryQuery, ReadValidationHistoryQueryVariables>;
export const DocumentSegmentsDocument = gql`
    query DocumentSegments($documentId: String!) {
  documentSegments(documentId: $documentId) {
    id
    formatClass
    mimeType
    segments {
      fileId
      fileName
      fileSize
      sequence
      collectionId
    }
  }
}
    `;

/**
 * __useDocumentSegmentsQuery__
 *
 * To run a query within a React component, call `useDocumentSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentSegmentsQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDocumentSegmentsQuery(baseOptions: Apollo.QueryHookOptions<DocumentSegmentsQuery, DocumentSegmentsQueryVariables> & ({ variables: DocumentSegmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentSegmentsQuery, DocumentSegmentsQueryVariables>(DocumentSegmentsDocument, options);
      }
export function useDocumentSegmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentSegmentsQuery, DocumentSegmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentSegmentsQuery, DocumentSegmentsQueryVariables>(DocumentSegmentsDocument, options);
        }
export function useDocumentSegmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DocumentSegmentsQuery, DocumentSegmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DocumentSegmentsQuery, DocumentSegmentsQueryVariables>(DocumentSegmentsDocument, options);
        }
export type DocumentSegmentsQueryHookResult = ReturnType<typeof useDocumentSegmentsQuery>;
export type DocumentSegmentsLazyQueryHookResult = ReturnType<typeof useDocumentSegmentsLazyQuery>;
export type DocumentSegmentsSuspenseQueryHookResult = ReturnType<typeof useDocumentSegmentsSuspenseQuery>;
export type DocumentSegmentsQueryResult = Apollo.QueryResult<DocumentSegmentsQuery, DocumentSegmentsQueryVariables>;
export const SegmentUrlDocument = gql`
    query SegmentURL($segmentId: String, $collectionId: String, $fileId: String) {
  segmentURL(segmentId: $segmentId, collectionId: $collectionId, fileId: $fileId)
}
    `;

/**
 * __useSegmentUrlQuery__
 *
 * To run a query within a React component, call `useSegmentUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentUrlQuery({
 *   variables: {
 *      segmentId: // value for 'segmentId'
 *      collectionId: // value for 'collectionId'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useSegmentUrlQuery(baseOptions?: Apollo.QueryHookOptions<SegmentUrlQuery, SegmentUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SegmentUrlQuery, SegmentUrlQueryVariables>(SegmentUrlDocument, options);
      }
export function useSegmentUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SegmentUrlQuery, SegmentUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SegmentUrlQuery, SegmentUrlQueryVariables>(SegmentUrlDocument, options);
        }
export function useSegmentUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SegmentUrlQuery, SegmentUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SegmentUrlQuery, SegmentUrlQueryVariables>(SegmentUrlDocument, options);
        }
export type SegmentUrlQueryHookResult = ReturnType<typeof useSegmentUrlQuery>;
export type SegmentUrlLazyQueryHookResult = ReturnType<typeof useSegmentUrlLazyQuery>;
export type SegmentUrlSuspenseQueryHookResult = ReturnType<typeof useSegmentUrlSuspenseQuery>;
export type SegmentUrlQueryResult = Apollo.QueryResult<SegmentUrlQuery, SegmentUrlQueryVariables>;
export const CreateDoppelgangerPermitDocument = gql`
    mutation CreateDoppelgangerPermit($userId: String!, $justification: String) {
  createDoppelgangerPermit(targetUserId: $userId, justification: $justification) {
    ...AdminDoppelgangerPermitFields
  }
}
    ${AdminDoppelgangerPermitFieldsFragmentDoc}`;
export type CreateDoppelgangerPermitMutationFn = Apollo.MutationFunction<CreateDoppelgangerPermitMutation, CreateDoppelgangerPermitMutationVariables>;

/**
 * __useCreateDoppelgangerPermitMutation__
 *
 * To run a mutation, you first call `useCreateDoppelgangerPermitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDoppelgangerPermitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDoppelgangerPermitMutation, { data, loading, error }] = useCreateDoppelgangerPermitMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      justification: // value for 'justification'
 *   },
 * });
 */
export function useCreateDoppelgangerPermitMutation(baseOptions?: Apollo.MutationHookOptions<CreateDoppelgangerPermitMutation, CreateDoppelgangerPermitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDoppelgangerPermitMutation, CreateDoppelgangerPermitMutationVariables>(CreateDoppelgangerPermitDocument, options);
      }
export type CreateDoppelgangerPermitMutationHookResult = ReturnType<typeof useCreateDoppelgangerPermitMutation>;
export type CreateDoppelgangerPermitMutationResult = Apollo.MutationResult<CreateDoppelgangerPermitMutation>;
export type CreateDoppelgangerPermitMutationOptions = Apollo.BaseMutationOptions<CreateDoppelgangerPermitMutation, CreateDoppelgangerPermitMutationVariables>;
export const ListDoppelgangerPermitsDocument = gql`
    query ListDoppelgangerPermits {
  listDoppelgangerPermits {
    ...AdminDoppelgangerPermitFields
  }
}
    ${AdminDoppelgangerPermitFieldsFragmentDoc}`;

/**
 * __useListDoppelgangerPermitsQuery__
 *
 * To run a query within a React component, call `useListDoppelgangerPermitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDoppelgangerPermitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDoppelgangerPermitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListDoppelgangerPermitsQuery(baseOptions?: Apollo.QueryHookOptions<ListDoppelgangerPermitsQuery, ListDoppelgangerPermitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDoppelgangerPermitsQuery, ListDoppelgangerPermitsQueryVariables>(ListDoppelgangerPermitsDocument, options);
      }
export function useListDoppelgangerPermitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDoppelgangerPermitsQuery, ListDoppelgangerPermitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDoppelgangerPermitsQuery, ListDoppelgangerPermitsQueryVariables>(ListDoppelgangerPermitsDocument, options);
        }
export function useListDoppelgangerPermitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListDoppelgangerPermitsQuery, ListDoppelgangerPermitsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListDoppelgangerPermitsQuery, ListDoppelgangerPermitsQueryVariables>(ListDoppelgangerPermitsDocument, options);
        }
export type ListDoppelgangerPermitsQueryHookResult = ReturnType<typeof useListDoppelgangerPermitsQuery>;
export type ListDoppelgangerPermitsLazyQueryHookResult = ReturnType<typeof useListDoppelgangerPermitsLazyQuery>;
export type ListDoppelgangerPermitsSuspenseQueryHookResult = ReturnType<typeof useListDoppelgangerPermitsSuspenseQuery>;
export type ListDoppelgangerPermitsQueryResult = Apollo.QueryResult<ListDoppelgangerPermitsQuery, ListDoppelgangerPermitsQueryVariables>;
export const RemoveAffiliateEmploymentDocument = gql`
    mutation RemoveAffiliateEmployment($organizationId: String!, $employeeId: String!) {
  removeAffiliateEmployment(
    organizationId: $organizationId
    employeeId: $employeeId
  )
}
    `;
export type RemoveAffiliateEmploymentMutationFn = Apollo.MutationFunction<RemoveAffiliateEmploymentMutation, RemoveAffiliateEmploymentMutationVariables>;

/**
 * __useRemoveAffiliateEmploymentMutation__
 *
 * To run a mutation, you first call `useRemoveAffiliateEmploymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAffiliateEmploymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAffiliateEmploymentMutation, { data, loading, error }] = useRemoveAffiliateEmploymentMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useRemoveAffiliateEmploymentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAffiliateEmploymentMutation, RemoveAffiliateEmploymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAffiliateEmploymentMutation, RemoveAffiliateEmploymentMutationVariables>(RemoveAffiliateEmploymentDocument, options);
      }
export type RemoveAffiliateEmploymentMutationHookResult = ReturnType<typeof useRemoveAffiliateEmploymentMutation>;
export type RemoveAffiliateEmploymentMutationResult = Apollo.MutationResult<RemoveAffiliateEmploymentMutation>;
export type RemoveAffiliateEmploymentMutationOptions = Apollo.BaseMutationOptions<RemoveAffiliateEmploymentMutation, RemoveAffiliateEmploymentMutationVariables>;
export const UpdateEmployeeHiddenDocument = gql`
    mutation UpdateEmployeeHidden($organizationId: String!, $employeeId: String!, $isHidden: Boolean!) {
  updateEmployeeHidden(
    organizationId: $organizationId
    employeeId: $employeeId
    isHidden: $isHidden
  )
}
    `;
export type UpdateEmployeeHiddenMutationFn = Apollo.MutationFunction<UpdateEmployeeHiddenMutation, UpdateEmployeeHiddenMutationVariables>;

/**
 * __useUpdateEmployeeHiddenMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeHiddenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeHiddenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeHiddenMutation, { data, loading, error }] = useUpdateEmployeeHiddenMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      employeeId: // value for 'employeeId'
 *      isHidden: // value for 'isHidden'
 *   },
 * });
 */
export function useUpdateEmployeeHiddenMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeHiddenMutation, UpdateEmployeeHiddenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeeHiddenMutation, UpdateEmployeeHiddenMutationVariables>(UpdateEmployeeHiddenDocument, options);
      }
export type UpdateEmployeeHiddenMutationHookResult = ReturnType<typeof useUpdateEmployeeHiddenMutation>;
export type UpdateEmployeeHiddenMutationResult = Apollo.MutationResult<UpdateEmployeeHiddenMutation>;
export type UpdateEmployeeHiddenMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeHiddenMutation, UpdateEmployeeHiddenMutationVariables>;
export const UpdateEmployeeStatusDocument = gql`
    mutation UpdateEmployeeStatus($organizationId: String!, $employeeId: String!, $status: EmployeeStatus!) {
  updateEmployeeStatus(
    organizationId: $organizationId
    employeeId: $employeeId
    status: $status
  ) {
    ...AdminEmployeeFields
  }
}
    ${AdminEmployeeFieldsFragmentDoc}`;
export type UpdateEmployeeStatusMutationFn = Apollo.MutationFunction<UpdateEmployeeStatusMutation, UpdateEmployeeStatusMutationVariables>;

/**
 * __useUpdateEmployeeStatusMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeStatusMutation, { data, loading, error }] = useUpdateEmployeeStatusMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      employeeId: // value for 'employeeId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateEmployeeStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeStatusMutation, UpdateEmployeeStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeeStatusMutation, UpdateEmployeeStatusMutationVariables>(UpdateEmployeeStatusDocument, options);
      }
export type UpdateEmployeeStatusMutationHookResult = ReturnType<typeof useUpdateEmployeeStatusMutation>;
export type UpdateEmployeeStatusMutationResult = Apollo.MutationResult<UpdateEmployeeStatusMutation>;
export type UpdateEmployeeStatusMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeStatusMutation, UpdateEmployeeStatusMutationVariables>;
export const ListEmployeesDocument = gql`
    query ListEmployees($filter: EmployeeFilter!, $pagination: Pagination!) {
  listEmployees(filter: $filter, pagination: $pagination) {
    ...AdminEmployeeFields
  }
}
    ${AdminEmployeeFieldsFragmentDoc}`;

/**
 * __useListEmployeesQuery__
 *
 * To run a query within a React component, call `useListEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEmployeesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useListEmployeesQuery(baseOptions: Apollo.QueryHookOptions<ListEmployeesQuery, ListEmployeesQueryVariables> & ({ variables: ListEmployeesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListEmployeesQuery, ListEmployeesQueryVariables>(ListEmployeesDocument, options);
      }
export function useListEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListEmployeesQuery, ListEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListEmployeesQuery, ListEmployeesQueryVariables>(ListEmployeesDocument, options);
        }
export function useListEmployeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListEmployeesQuery, ListEmployeesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListEmployeesQuery, ListEmployeesQueryVariables>(ListEmployeesDocument, options);
        }
export type ListEmployeesQueryHookResult = ReturnType<typeof useListEmployeesQuery>;
export type ListEmployeesLazyQueryHookResult = ReturnType<typeof useListEmployeesLazyQuery>;
export type ListEmployeesSuspenseQueryHookResult = ReturnType<typeof useListEmployeesSuspenseQuery>;
export type ListEmployeesQueryResult = Apollo.QueryResult<ListEmployeesQuery, ListEmployeesQueryVariables>;
export const CreateInstitutionDocument = gql`
    mutation CreateInstitution($name: String!, $url: String!, $routingNumber: String!, $partyId: String!, $kind: InstitutionKind!) {
  createInstitution(
    name: $name
    url: $url
    routingNumber: $routingNumber
    partyId: $partyId
    kind: $kind
  ) {
    ...AdminInstitutionFields
  }
}
    ${AdminInstitutionFieldsFragmentDoc}`;
export type CreateInstitutionMutationFn = Apollo.MutationFunction<CreateInstitutionMutation, CreateInstitutionMutationVariables>;

/**
 * __useCreateInstitutionMutation__
 *
 * To run a mutation, you first call `useCreateInstitutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInstitutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInstitutionMutation, { data, loading, error }] = useCreateInstitutionMutation({
 *   variables: {
 *      name: // value for 'name'
 *      url: // value for 'url'
 *      routingNumber: // value for 'routingNumber'
 *      partyId: // value for 'partyId'
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useCreateInstitutionMutation(baseOptions?: Apollo.MutationHookOptions<CreateInstitutionMutation, CreateInstitutionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInstitutionMutation, CreateInstitutionMutationVariables>(CreateInstitutionDocument, options);
      }
export type CreateInstitutionMutationHookResult = ReturnType<typeof useCreateInstitutionMutation>;
export type CreateInstitutionMutationResult = Apollo.MutationResult<CreateInstitutionMutation>;
export type CreateInstitutionMutationOptions = Apollo.BaseMutationOptions<CreateInstitutionMutation, CreateInstitutionMutationVariables>;
export const UpdateInstitutionDocument = gql`
    mutation UpdateInstitution($institution_id: String!, $name: String!, $url: String!, $routingNumber: String!) {
  updateInstitution(
    institution_id: $institution_id
    name: $name
    url: $url
    routingNumber: $routingNumber
  )
}
    `;
export type UpdateInstitutionMutationFn = Apollo.MutationFunction<UpdateInstitutionMutation, UpdateInstitutionMutationVariables>;

/**
 * __useUpdateInstitutionMutation__
 *
 * To run a mutation, you first call `useUpdateInstitutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInstitutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInstitutionMutation, { data, loading, error }] = useUpdateInstitutionMutation({
 *   variables: {
 *      institution_id: // value for 'institution_id'
 *      name: // value for 'name'
 *      url: // value for 'url'
 *      routingNumber: // value for 'routingNumber'
 *   },
 * });
 */
export function useUpdateInstitutionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInstitutionMutation, UpdateInstitutionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInstitutionMutation, UpdateInstitutionMutationVariables>(UpdateInstitutionDocument, options);
      }
export type UpdateInstitutionMutationHookResult = ReturnType<typeof useUpdateInstitutionMutation>;
export type UpdateInstitutionMutationResult = Apollo.MutationResult<UpdateInstitutionMutation>;
export type UpdateInstitutionMutationOptions = Apollo.BaseMutationOptions<UpdateInstitutionMutation, UpdateInstitutionMutationVariables>;
export const UpdateInstitutionPartyDocument = gql`
    mutation UpdateInstitutionParty($institutionId: String!, $partyId: String!) {
  updateInstitutionParty(institutionId: $institutionId, partyId: $partyId)
}
    `;
export type UpdateInstitutionPartyMutationFn = Apollo.MutationFunction<UpdateInstitutionPartyMutation, UpdateInstitutionPartyMutationVariables>;

/**
 * __useUpdateInstitutionPartyMutation__
 *
 * To run a mutation, you first call `useUpdateInstitutionPartyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInstitutionPartyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInstitutionPartyMutation, { data, loading, error }] = useUpdateInstitutionPartyMutation({
 *   variables: {
 *      institutionId: // value for 'institutionId'
 *      partyId: // value for 'partyId'
 *   },
 * });
 */
export function useUpdateInstitutionPartyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInstitutionPartyMutation, UpdateInstitutionPartyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInstitutionPartyMutation, UpdateInstitutionPartyMutationVariables>(UpdateInstitutionPartyDocument, options);
      }
export type UpdateInstitutionPartyMutationHookResult = ReturnType<typeof useUpdateInstitutionPartyMutation>;
export type UpdateInstitutionPartyMutationResult = Apollo.MutationResult<UpdateInstitutionPartyMutation>;
export type UpdateInstitutionPartyMutationOptions = Apollo.BaseMutationOptions<UpdateInstitutionPartyMutation, UpdateInstitutionPartyMutationVariables>;
export const UpdateInstitutionProductsDocument = gql`
    mutation UpdateInstitutionProducts($institutionId: String!, $products: [InstitutionProduct!]!) {
  updateInstitutionProducts(institutionId: $institutionId, products: $products)
}
    `;
export type UpdateInstitutionProductsMutationFn = Apollo.MutationFunction<UpdateInstitutionProductsMutation, UpdateInstitutionProductsMutationVariables>;

/**
 * __useUpdateInstitutionProductsMutation__
 *
 * To run a mutation, you first call `useUpdateInstitutionProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInstitutionProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInstitutionProductsMutation, { data, loading, error }] = useUpdateInstitutionProductsMutation({
 *   variables: {
 *      institutionId: // value for 'institutionId'
 *      products: // value for 'products'
 *   },
 * });
 */
export function useUpdateInstitutionProductsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInstitutionProductsMutation, UpdateInstitutionProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInstitutionProductsMutation, UpdateInstitutionProductsMutationVariables>(UpdateInstitutionProductsDocument, options);
      }
export type UpdateInstitutionProductsMutationHookResult = ReturnType<typeof useUpdateInstitutionProductsMutation>;
export type UpdateInstitutionProductsMutationResult = Apollo.MutationResult<UpdateInstitutionProductsMutation>;
export type UpdateInstitutionProductsMutationOptions = Apollo.BaseMutationOptions<UpdateInstitutionProductsMutation, UpdateInstitutionProductsMutationVariables>;
export const GetInstitutionDocument = gql`
    query GetInstitution($institutionId: String!) {
  getInstitution(institutionId: $institutionId) {
    ...AdminInstitutionFields
  }
}
    ${AdminInstitutionFieldsFragmentDoc}`;

/**
 * __useGetInstitutionQuery__
 *
 * To run a query within a React component, call `useGetInstitutionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstitutionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstitutionQuery({
 *   variables: {
 *      institutionId: // value for 'institutionId'
 *   },
 * });
 */
export function useGetInstitutionQuery(baseOptions: Apollo.QueryHookOptions<GetInstitutionQuery, GetInstitutionQueryVariables> & ({ variables: GetInstitutionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstitutionQuery, GetInstitutionQueryVariables>(GetInstitutionDocument, options);
      }
export function useGetInstitutionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstitutionQuery, GetInstitutionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstitutionQuery, GetInstitutionQueryVariables>(GetInstitutionDocument, options);
        }
export function useGetInstitutionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInstitutionQuery, GetInstitutionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInstitutionQuery, GetInstitutionQueryVariables>(GetInstitutionDocument, options);
        }
export type GetInstitutionQueryHookResult = ReturnType<typeof useGetInstitutionQuery>;
export type GetInstitutionLazyQueryHookResult = ReturnType<typeof useGetInstitutionLazyQuery>;
export type GetInstitutionSuspenseQueryHookResult = ReturnType<typeof useGetInstitutionSuspenseQuery>;
export type GetInstitutionQueryResult = Apollo.QueryResult<GetInstitutionQuery, GetInstitutionQueryVariables>;
export const ListInstitutionsDocument = gql`
    query ListInstitutions($pagination: Pagination!) {
  listInstitutions(pagination: $pagination) {
    ...AdminInstitutionFields
  }
}
    ${AdminInstitutionFieldsFragmentDoc}`;

/**
 * __useListInstitutionsQuery__
 *
 * To run a query within a React component, call `useListInstitutionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListInstitutionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListInstitutionsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useListInstitutionsQuery(baseOptions: Apollo.QueryHookOptions<ListInstitutionsQuery, ListInstitutionsQueryVariables> & ({ variables: ListInstitutionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListInstitutionsQuery, ListInstitutionsQueryVariables>(ListInstitutionsDocument, options);
      }
export function useListInstitutionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListInstitutionsQuery, ListInstitutionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListInstitutionsQuery, ListInstitutionsQueryVariables>(ListInstitutionsDocument, options);
        }
export function useListInstitutionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListInstitutionsQuery, ListInstitutionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListInstitutionsQuery, ListInstitutionsQueryVariables>(ListInstitutionsDocument, options);
        }
export type ListInstitutionsQueryHookResult = ReturnType<typeof useListInstitutionsQuery>;
export type ListInstitutionsLazyQueryHookResult = ReturnType<typeof useListInstitutionsLazyQuery>;
export type ListInstitutionsSuspenseQueryHookResult = ReturnType<typeof useListInstitutionsSuspenseQuery>;
export type ListInstitutionsQueryResult = Apollo.QueryResult<ListInstitutionsQuery, ListInstitutionsQueryVariables>;
export const SendManagedOperatorInvitationDocument = gql`
    mutation SendManagedOperatorInvitation($organizationId: String!, $affiliateUserId: String!, $affiliateOrganizationId: String!, $recipient: ContactInput!, $legalEntityId: String!, $message: String, $redirectPath: String) {
  sendManagedOperatorInvitation(
    organizationId: $organizationId
    affiliateUserId: $affiliateUserId
    affiliateOrganizationId: $affiliateOrganizationId
    recipient: $recipient
    legalEntityId: $legalEntityId
    message: $message
    redirectPath: $redirectPath
  )
}
    `;
export type SendManagedOperatorInvitationMutationFn = Apollo.MutationFunction<SendManagedOperatorInvitationMutation, SendManagedOperatorInvitationMutationVariables>;

/**
 * __useSendManagedOperatorInvitationMutation__
 *
 * To run a mutation, you first call `useSendManagedOperatorInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendManagedOperatorInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendManagedOperatorInvitationMutation, { data, loading, error }] = useSendManagedOperatorInvitationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      affiliateUserId: // value for 'affiliateUserId'
 *      affiliateOrganizationId: // value for 'affiliateOrganizationId'
 *      recipient: // value for 'recipient'
 *      legalEntityId: // value for 'legalEntityId'
 *      message: // value for 'message'
 *      redirectPath: // value for 'redirectPath'
 *   },
 * });
 */
export function useSendManagedOperatorInvitationMutation(baseOptions?: Apollo.MutationHookOptions<SendManagedOperatorInvitationMutation, SendManagedOperatorInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendManagedOperatorInvitationMutation, SendManagedOperatorInvitationMutationVariables>(SendManagedOperatorInvitationDocument, options);
      }
export type SendManagedOperatorInvitationMutationHookResult = ReturnType<typeof useSendManagedOperatorInvitationMutation>;
export type SendManagedOperatorInvitationMutationResult = Apollo.MutationResult<SendManagedOperatorInvitationMutation>;
export type SendManagedOperatorInvitationMutationOptions = Apollo.BaseMutationOptions<SendManagedOperatorInvitationMutation, SendManagedOperatorInvitationMutationVariables>;
export const CancelInvitationDocument = gql`
    mutation CancelInvitation($token: String!) {
  cancelInvitation(token: $token)
}
    `;
export type CancelInvitationMutationFn = Apollo.MutationFunction<CancelInvitationMutation, CancelInvitationMutationVariables>;

/**
 * __useCancelInvitationMutation__
 *
 * To run a mutation, you first call `useCancelInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelInvitationMutation, { data, loading, error }] = useCancelInvitationMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useCancelInvitationMutation(baseOptions?: Apollo.MutationHookOptions<CancelInvitationMutation, CancelInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelInvitationMutation, CancelInvitationMutationVariables>(CancelInvitationDocument, options);
      }
export type CancelInvitationMutationHookResult = ReturnType<typeof useCancelInvitationMutation>;
export type CancelInvitationMutationResult = Apollo.MutationResult<CancelInvitationMutation>;
export type CancelInvitationMutationOptions = Apollo.BaseMutationOptions<CancelInvitationMutation, CancelInvitationMutationVariables>;
export const ResendInvitationDocument = gql`
    mutation ResendInvitation($token: String!) {
  resendInvitation(token: $token)
}
    `;
export type ResendInvitationMutationFn = Apollo.MutationFunction<ResendInvitationMutation, ResendInvitationMutationVariables>;

/**
 * __useResendInvitationMutation__
 *
 * To run a mutation, you first call `useResendInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInvitationMutation, { data, loading, error }] = useResendInvitationMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useResendInvitationMutation(baseOptions?: Apollo.MutationHookOptions<ResendInvitationMutation, ResendInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendInvitationMutation, ResendInvitationMutationVariables>(ResendInvitationDocument, options);
      }
export type ResendInvitationMutationHookResult = ReturnType<typeof useResendInvitationMutation>;
export type ResendInvitationMutationResult = Apollo.MutationResult<ResendInvitationMutation>;
export type ResendInvitationMutationOptions = Apollo.BaseMutationOptions<ResendInvitationMutation, ResendInvitationMutationVariables>;
export const AdminSendInvitationDocument = gql`
    mutation AdminSendInvitation($emailAddress: String!, $givenName: String, $familyName: String, $destinationOrganizationId: String, $destinationOrganizationRole: String, $legalEntityId: String, $invitationType: String!, $proposalType: ProposalType) {
  sendInvitation(
    recipient: {emailAddress: $emailAddress, givenName: $givenName, familyName: $familyName}
    destinationOrganizationId: $destinationOrganizationId
    destinationOrganizationRole: $destinationOrganizationRole
    legalEntityId: $legalEntityId
    invitationType: $invitationType
    proposalType: $proposalType
  )
}
    `;
export type AdminSendInvitationMutationFn = Apollo.MutationFunction<AdminSendInvitationMutation, AdminSendInvitationMutationVariables>;

/**
 * __useAdminSendInvitationMutation__
 *
 * To run a mutation, you first call `useAdminSendInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSendInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSendInvitationMutation, { data, loading, error }] = useAdminSendInvitationMutation({
 *   variables: {
 *      emailAddress: // value for 'emailAddress'
 *      givenName: // value for 'givenName'
 *      familyName: // value for 'familyName'
 *      destinationOrganizationId: // value for 'destinationOrganizationId'
 *      destinationOrganizationRole: // value for 'destinationOrganizationRole'
 *      legalEntityId: // value for 'legalEntityId'
 *      invitationType: // value for 'invitationType'
 *      proposalType: // value for 'proposalType'
 *   },
 * });
 */
export function useAdminSendInvitationMutation(baseOptions?: Apollo.MutationHookOptions<AdminSendInvitationMutation, AdminSendInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminSendInvitationMutation, AdminSendInvitationMutationVariables>(AdminSendInvitationDocument, options);
      }
export type AdminSendInvitationMutationHookResult = ReturnType<typeof useAdminSendInvitationMutation>;
export type AdminSendInvitationMutationResult = Apollo.MutationResult<AdminSendInvitationMutation>;
export type AdminSendInvitationMutationOptions = Apollo.BaseMutationOptions<AdminSendInvitationMutation, AdminSendInvitationMutationVariables>;
export const ListInvitationsDocument = gql`
    query ListInvitations {
  listInvitations {
    ...AdminInvitationFields
  }
}
    ${AdminInvitationFieldsFragmentDoc}`;

/**
 * __useListInvitationsQuery__
 *
 * To run a query within a React component, call `useListInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListInvitationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListInvitationsQuery(baseOptions?: Apollo.QueryHookOptions<ListInvitationsQuery, ListInvitationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListInvitationsQuery, ListInvitationsQueryVariables>(ListInvitationsDocument, options);
      }
export function useListInvitationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListInvitationsQuery, ListInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListInvitationsQuery, ListInvitationsQueryVariables>(ListInvitationsDocument, options);
        }
export function useListInvitationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListInvitationsQuery, ListInvitationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListInvitationsQuery, ListInvitationsQueryVariables>(ListInvitationsDocument, options);
        }
export type ListInvitationsQueryHookResult = ReturnType<typeof useListInvitationsQuery>;
export type ListInvitationsLazyQueryHookResult = ReturnType<typeof useListInvitationsLazyQuery>;
export type ListInvitationsSuspenseQueryHookResult = ReturnType<typeof useListInvitationsSuspenseQuery>;
export type ListInvitationsQueryResult = Apollo.QueryResult<ListInvitationsQuery, ListInvitationsQueryVariables>;
export const ListInvitationsByOrganizationDocument = gql`
    query ListInvitationsByOrganization($organizationId: String!) {
  listInvitationsByOrganization(organizationId: $organizationId) {
    ...AdminInvitationFields
  }
}
    ${AdminInvitationFieldsFragmentDoc}`;

/**
 * __useListInvitationsByOrganizationQuery__
 *
 * To run a query within a React component, call `useListInvitationsByOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useListInvitationsByOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListInvitationsByOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useListInvitationsByOrganizationQuery(baseOptions: Apollo.QueryHookOptions<ListInvitationsByOrganizationQuery, ListInvitationsByOrganizationQueryVariables> & ({ variables: ListInvitationsByOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListInvitationsByOrganizationQuery, ListInvitationsByOrganizationQueryVariables>(ListInvitationsByOrganizationDocument, options);
      }
export function useListInvitationsByOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListInvitationsByOrganizationQuery, ListInvitationsByOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListInvitationsByOrganizationQuery, ListInvitationsByOrganizationQueryVariables>(ListInvitationsByOrganizationDocument, options);
        }
export function useListInvitationsByOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListInvitationsByOrganizationQuery, ListInvitationsByOrganizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListInvitationsByOrganizationQuery, ListInvitationsByOrganizationQueryVariables>(ListInvitationsByOrganizationDocument, options);
        }
export type ListInvitationsByOrganizationQueryHookResult = ReturnType<typeof useListInvitationsByOrganizationQuery>;
export type ListInvitationsByOrganizationLazyQueryHookResult = ReturnType<typeof useListInvitationsByOrganizationLazyQuery>;
export type ListInvitationsByOrganizationSuspenseQueryHookResult = ReturnType<typeof useListInvitationsByOrganizationSuspenseQuery>;
export type ListInvitationsByOrganizationQueryResult = Apollo.QueryResult<ListInvitationsByOrganizationQuery, ListInvitationsByOrganizationQueryVariables>;
export const ReadInvitationDocument = gql`
    query ReadInvitation($token: String!) {
  readInvitation(token: $token) {
    ...AdminInvitationFields
  }
}
    ${AdminInvitationFieldsFragmentDoc}`;

/**
 * __useReadInvitationQuery__
 *
 * To run a query within a React component, call `useReadInvitationQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadInvitationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadInvitationQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useReadInvitationQuery(baseOptions: Apollo.QueryHookOptions<ReadInvitationQuery, ReadInvitationQueryVariables> & ({ variables: ReadInvitationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadInvitationQuery, ReadInvitationQueryVariables>(ReadInvitationDocument, options);
      }
export function useReadInvitationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadInvitationQuery, ReadInvitationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadInvitationQuery, ReadInvitationQueryVariables>(ReadInvitationDocument, options);
        }
export function useReadInvitationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadInvitationQuery, ReadInvitationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadInvitationQuery, ReadInvitationQueryVariables>(ReadInvitationDocument, options);
        }
export type ReadInvitationQueryHookResult = ReturnType<typeof useReadInvitationQuery>;
export type ReadInvitationLazyQueryHookResult = ReturnType<typeof useReadInvitationLazyQuery>;
export type ReadInvitationSuspenseQueryHookResult = ReturnType<typeof useReadInvitationSuspenseQuery>;
export type ReadInvitationQueryResult = Apollo.QueryResult<ReadInvitationQuery, ReadInvitationQueryVariables>;
export const ReadInvitationBySignupDocument = gql`
    query ReadInvitationBySignup($signupId: String!) {
  readInvitationBySignup(signupId: $signupId) {
    ...AdminInvitationFields
  }
}
    ${AdminInvitationFieldsFragmentDoc}`;

/**
 * __useReadInvitationBySignupQuery__
 *
 * To run a query within a React component, call `useReadInvitationBySignupQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadInvitationBySignupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadInvitationBySignupQuery({
 *   variables: {
 *      signupId: // value for 'signupId'
 *   },
 * });
 */
export function useReadInvitationBySignupQuery(baseOptions: Apollo.QueryHookOptions<ReadInvitationBySignupQuery, ReadInvitationBySignupQueryVariables> & ({ variables: ReadInvitationBySignupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadInvitationBySignupQuery, ReadInvitationBySignupQueryVariables>(ReadInvitationBySignupDocument, options);
      }
export function useReadInvitationBySignupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadInvitationBySignupQuery, ReadInvitationBySignupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadInvitationBySignupQuery, ReadInvitationBySignupQueryVariables>(ReadInvitationBySignupDocument, options);
        }
export function useReadInvitationBySignupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadInvitationBySignupQuery, ReadInvitationBySignupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadInvitationBySignupQuery, ReadInvitationBySignupQueryVariables>(ReadInvitationBySignupDocument, options);
        }
export type ReadInvitationBySignupQueryHookResult = ReturnType<typeof useReadInvitationBySignupQuery>;
export type ReadInvitationBySignupLazyQueryHookResult = ReturnType<typeof useReadInvitationBySignupLazyQuery>;
export type ReadInvitationBySignupSuspenseQueryHookResult = ReturnType<typeof useReadInvitationBySignupSuspenseQuery>;
export type ReadInvitationBySignupQueryResult = Apollo.QueryResult<ReadInvitationBySignupQuery, ReadInvitationBySignupQueryVariables>;
export const GetInvoiceMigrationReportDocument = gql`
    query GetInvoiceMigrationReport($legalEntityId: String!, $type: InvoiceMigrationReportType!, $timestamp: String!) {
  invoiceMigrationReport(
    legalEntityId: $legalEntityId
    type: $type
    timestamp: $timestamp
  ) {
    summary {
      legalEntityId
      type
      timestamp
      sizeBytes
      gcsObjectKey
    }
    markdown
  }
}
    `;

/**
 * __useGetInvoiceMigrationReportQuery__
 *
 * To run a query within a React component, call `useGetInvoiceMigrationReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceMigrationReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceMigrationReportQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      type: // value for 'type'
 *      timestamp: // value for 'timestamp'
 *   },
 * });
 */
export function useGetInvoiceMigrationReportQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceMigrationReportQuery, GetInvoiceMigrationReportQueryVariables> & ({ variables: GetInvoiceMigrationReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceMigrationReportQuery, GetInvoiceMigrationReportQueryVariables>(GetInvoiceMigrationReportDocument, options);
      }
export function useGetInvoiceMigrationReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceMigrationReportQuery, GetInvoiceMigrationReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceMigrationReportQuery, GetInvoiceMigrationReportQueryVariables>(GetInvoiceMigrationReportDocument, options);
        }
export function useGetInvoiceMigrationReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvoiceMigrationReportQuery, GetInvoiceMigrationReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInvoiceMigrationReportQuery, GetInvoiceMigrationReportQueryVariables>(GetInvoiceMigrationReportDocument, options);
        }
export type GetInvoiceMigrationReportQueryHookResult = ReturnType<typeof useGetInvoiceMigrationReportQuery>;
export type GetInvoiceMigrationReportLazyQueryHookResult = ReturnType<typeof useGetInvoiceMigrationReportLazyQuery>;
export type GetInvoiceMigrationReportSuspenseQueryHookResult = ReturnType<typeof useGetInvoiceMigrationReportSuspenseQuery>;
export type GetInvoiceMigrationReportQueryResult = Apollo.QueryResult<GetInvoiceMigrationReportQuery, GetInvoiceMigrationReportQueryVariables>;
export const ListInvoiceMigrationReportsDocument = gql`
    query ListInvoiceMigrationReports($legalEntityId: String!) {
  listInvoiceMigrationReports(legalEntityId: $legalEntityId) {
    legalEntityId
    type
    timestamp
    gcsObjectKey
  }
}
    `;

/**
 * __useListInvoiceMigrationReportsQuery__
 *
 * To run a query within a React component, call `useListInvoiceMigrationReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListInvoiceMigrationReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListInvoiceMigrationReportsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListInvoiceMigrationReportsQuery(baseOptions: Apollo.QueryHookOptions<ListInvoiceMigrationReportsQuery, ListInvoiceMigrationReportsQueryVariables> & ({ variables: ListInvoiceMigrationReportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListInvoiceMigrationReportsQuery, ListInvoiceMigrationReportsQueryVariables>(ListInvoiceMigrationReportsDocument, options);
      }
export function useListInvoiceMigrationReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListInvoiceMigrationReportsQuery, ListInvoiceMigrationReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListInvoiceMigrationReportsQuery, ListInvoiceMigrationReportsQueryVariables>(ListInvoiceMigrationReportsDocument, options);
        }
export function useListInvoiceMigrationReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListInvoiceMigrationReportsQuery, ListInvoiceMigrationReportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListInvoiceMigrationReportsQuery, ListInvoiceMigrationReportsQueryVariables>(ListInvoiceMigrationReportsDocument, options);
        }
export type ListInvoiceMigrationReportsQueryHookResult = ReturnType<typeof useListInvoiceMigrationReportsQuery>;
export type ListInvoiceMigrationReportsLazyQueryHookResult = ReturnType<typeof useListInvoiceMigrationReportsLazyQuery>;
export type ListInvoiceMigrationReportsSuspenseQueryHookResult = ReturnType<typeof useListInvoiceMigrationReportsSuspenseQuery>;
export type ListInvoiceMigrationReportsQueryResult = Apollo.QueryResult<ListInvoiceMigrationReportsQuery, ListInvoiceMigrationReportsQueryVariables>;
export const BlockPaymentsDocument = gql`
    mutation BlockPayments($legalEntityId: String!, $description: String!) {
  blockPayments(legalEntityId: $legalEntityId, description: $description)
}
    `;
export type BlockPaymentsMutationFn = Apollo.MutationFunction<BlockPaymentsMutation, BlockPaymentsMutationVariables>;

/**
 * __useBlockPaymentsMutation__
 *
 * To run a mutation, you first call `useBlockPaymentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockPaymentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockPaymentsMutation, { data, loading, error }] = useBlockPaymentsMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useBlockPaymentsMutation(baseOptions?: Apollo.MutationHookOptions<BlockPaymentsMutation, BlockPaymentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BlockPaymentsMutation, BlockPaymentsMutationVariables>(BlockPaymentsDocument, options);
      }
export type BlockPaymentsMutationHookResult = ReturnType<typeof useBlockPaymentsMutation>;
export type BlockPaymentsMutationResult = Apollo.MutationResult<BlockPaymentsMutation>;
export type BlockPaymentsMutationOptions = Apollo.BaseMutationOptions<BlockPaymentsMutation, BlockPaymentsMutationVariables>;
export const BootstrapSandboxAccountingOrganizationDocument = gql`
    mutation BootstrapSandboxAccountingOrganization($userId: String!) {
  bootstrapSandboxAccountingOrganization(userId: $userId)
}
    `;
export type BootstrapSandboxAccountingOrganizationMutationFn = Apollo.MutationFunction<BootstrapSandboxAccountingOrganizationMutation, BootstrapSandboxAccountingOrganizationMutationVariables>;

/**
 * __useBootstrapSandboxAccountingOrganizationMutation__
 *
 * To run a mutation, you first call `useBootstrapSandboxAccountingOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBootstrapSandboxAccountingOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bootstrapSandboxAccountingOrganizationMutation, { data, loading, error }] = useBootstrapSandboxAccountingOrganizationMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useBootstrapSandboxAccountingOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<BootstrapSandboxAccountingOrganizationMutation, BootstrapSandboxAccountingOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BootstrapSandboxAccountingOrganizationMutation, BootstrapSandboxAccountingOrganizationMutationVariables>(BootstrapSandboxAccountingOrganizationDocument, options);
      }
export type BootstrapSandboxAccountingOrganizationMutationHookResult = ReturnType<typeof useBootstrapSandboxAccountingOrganizationMutation>;
export type BootstrapSandboxAccountingOrganizationMutationResult = Apollo.MutationResult<BootstrapSandboxAccountingOrganizationMutation>;
export type BootstrapSandboxAccountingOrganizationMutationOptions = Apollo.BaseMutationOptions<BootstrapSandboxAccountingOrganizationMutation, BootstrapSandboxAccountingOrganizationMutationVariables>;
export const CloseAdyenAccountHolderDocument = gql`
    mutation CloseAdyenAccountHolder($legalEntityId: String!, $description: String!) {
  closeAdyenAccountHolder(
    legalEntityId: $legalEntityId
    description: $description
  )
}
    `;
export type CloseAdyenAccountHolderMutationFn = Apollo.MutationFunction<CloseAdyenAccountHolderMutation, CloseAdyenAccountHolderMutationVariables>;

/**
 * __useCloseAdyenAccountHolderMutation__
 *
 * To run a mutation, you first call `useCloseAdyenAccountHolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseAdyenAccountHolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeAdyenAccountHolderMutation, { data, loading, error }] = useCloseAdyenAccountHolderMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCloseAdyenAccountHolderMutation(baseOptions?: Apollo.MutationHookOptions<CloseAdyenAccountHolderMutation, CloseAdyenAccountHolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseAdyenAccountHolderMutation, CloseAdyenAccountHolderMutationVariables>(CloseAdyenAccountHolderDocument, options);
      }
export type CloseAdyenAccountHolderMutationHookResult = ReturnType<typeof useCloseAdyenAccountHolderMutation>;
export type CloseAdyenAccountHolderMutationResult = Apollo.MutationResult<CloseAdyenAccountHolderMutation>;
export type CloseAdyenAccountHolderMutationOptions = Apollo.BaseMutationOptions<CloseAdyenAccountHolderMutation, CloseAdyenAccountHolderMutationVariables>;
export const ExportSandboxDataDocument = gql`
    mutation ExportSandboxData($sandboxType: SandboxType!, $industry: SandboxIndustry!) {
  exportSandboxData(sandboxType: $sandboxType, industry: $industry)
}
    `;
export type ExportSandboxDataMutationFn = Apollo.MutationFunction<ExportSandboxDataMutation, ExportSandboxDataMutationVariables>;

/**
 * __useExportSandboxDataMutation__
 *
 * To run a mutation, you first call `useExportSandboxDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportSandboxDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportSandboxDataMutation, { data, loading, error }] = useExportSandboxDataMutation({
 *   variables: {
 *      sandboxType: // value for 'sandboxType'
 *      industry: // value for 'industry'
 *   },
 * });
 */
export function useExportSandboxDataMutation(baseOptions?: Apollo.MutationHookOptions<ExportSandboxDataMutation, ExportSandboxDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportSandboxDataMutation, ExportSandboxDataMutationVariables>(ExportSandboxDataDocument, options);
      }
export type ExportSandboxDataMutationHookResult = ReturnType<typeof useExportSandboxDataMutation>;
export type ExportSandboxDataMutationResult = Apollo.MutationResult<ExportSandboxDataMutation>;
export type ExportSandboxDataMutationOptions = Apollo.BaseMutationOptions<ExportSandboxDataMutation, ExportSandboxDataMutationVariables>;
export const ReactivateAdyenAccountHolderDocument = gql`
    mutation ReactivateAdyenAccountHolder($legalEntityId: String!, $description: String!) {
  reactivateAdyenAccountHolder(
    legalEntityId: $legalEntityId
    description: $description
  )
}
    `;
export type ReactivateAdyenAccountHolderMutationFn = Apollo.MutationFunction<ReactivateAdyenAccountHolderMutation, ReactivateAdyenAccountHolderMutationVariables>;

/**
 * __useReactivateAdyenAccountHolderMutation__
 *
 * To run a mutation, you first call `useReactivateAdyenAccountHolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateAdyenAccountHolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateAdyenAccountHolderMutation, { data, loading, error }] = useReactivateAdyenAccountHolderMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useReactivateAdyenAccountHolderMutation(baseOptions?: Apollo.MutationHookOptions<ReactivateAdyenAccountHolderMutation, ReactivateAdyenAccountHolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactivateAdyenAccountHolderMutation, ReactivateAdyenAccountHolderMutationVariables>(ReactivateAdyenAccountHolderDocument, options);
      }
export type ReactivateAdyenAccountHolderMutationHookResult = ReturnType<typeof useReactivateAdyenAccountHolderMutation>;
export type ReactivateAdyenAccountHolderMutationResult = Apollo.MutationResult<ReactivateAdyenAccountHolderMutation>;
export type ReactivateAdyenAccountHolderMutationOptions = Apollo.BaseMutationOptions<ReactivateAdyenAccountHolderMutation, ReactivateAdyenAccountHolderMutationVariables>;
export const ResendActivationEmailDocument = gql`
    mutation ResendActivationEmail($legalEntityId: String!, $recipientId: String!) {
  resendActivationEmail(legalEntityId: $legalEntityId, recipientId: $recipientId)
}
    `;
export type ResendActivationEmailMutationFn = Apollo.MutationFunction<ResendActivationEmailMutation, ResendActivationEmailMutationVariables>;

/**
 * __useResendActivationEmailMutation__
 *
 * To run a mutation, you first call `useResendActivationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendActivationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendActivationEmailMutation, { data, loading, error }] = useResendActivationEmailMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      recipientId: // value for 'recipientId'
 *   },
 * });
 */
export function useResendActivationEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendActivationEmailMutation, ResendActivationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendActivationEmailMutation, ResendActivationEmailMutationVariables>(ResendActivationEmailDocument, options);
      }
export type ResendActivationEmailMutationHookResult = ReturnType<typeof useResendActivationEmailMutation>;
export type ResendActivationEmailMutationResult = Apollo.MutationResult<ResendActivationEmailMutation>;
export type ResendActivationEmailMutationOptions = Apollo.BaseMutationOptions<ResendActivationEmailMutation, ResendActivationEmailMutationVariables>;
export const SetLegalEntitySlugDocument = gql`
    mutation SetLegalEntitySlug($legalEntityId: String!, $newSlug: String!, $updateOrganizationSlug: Boolean!) {
  setLegalEntitySlug(
    legalEntityId: $legalEntityId
    newSlug: $newSlug
    updateOrganizationSlug: $updateOrganizationSlug
  )
}
    `;
export type SetLegalEntitySlugMutationFn = Apollo.MutationFunction<SetLegalEntitySlugMutation, SetLegalEntitySlugMutationVariables>;

/**
 * __useSetLegalEntitySlugMutation__
 *
 * To run a mutation, you first call `useSetLegalEntitySlugMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetLegalEntitySlugMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setLegalEntitySlugMutation, { data, loading, error }] = useSetLegalEntitySlugMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      newSlug: // value for 'newSlug'
 *      updateOrganizationSlug: // value for 'updateOrganizationSlug'
 *   },
 * });
 */
export function useSetLegalEntitySlugMutation(baseOptions?: Apollo.MutationHookOptions<SetLegalEntitySlugMutation, SetLegalEntitySlugMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetLegalEntitySlugMutation, SetLegalEntitySlugMutationVariables>(SetLegalEntitySlugDocument, options);
      }
export type SetLegalEntitySlugMutationHookResult = ReturnType<typeof useSetLegalEntitySlugMutation>;
export type SetLegalEntitySlugMutationResult = Apollo.MutationResult<SetLegalEntitySlugMutation>;
export type SetLegalEntitySlugMutationOptions = Apollo.BaseMutationOptions<SetLegalEntitySlugMutation, SetLegalEntitySlugMutationVariables>;
export const ToggleRestrictedCapabilityDocument = gql`
    mutation ToggleRestrictedCapability($legalEntityId: String!, $capability: RestrictedCapabilityName!, $enabled: Boolean!) {
  toggleRestrictedCapability(
    legalEntityId: $legalEntityId
    capability: $capability
    enabled: $enabled
  ) {
    legalEntityId
    capability
    enabled
  }
}
    `;
export type ToggleRestrictedCapabilityMutationFn = Apollo.MutationFunction<ToggleRestrictedCapabilityMutation, ToggleRestrictedCapabilityMutationVariables>;

/**
 * __useToggleRestrictedCapabilityMutation__
 *
 * To run a mutation, you first call `useToggleRestrictedCapabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleRestrictedCapabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleRestrictedCapabilityMutation, { data, loading, error }] = useToggleRestrictedCapabilityMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      capability: // value for 'capability'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useToggleRestrictedCapabilityMutation(baseOptions?: Apollo.MutationHookOptions<ToggleRestrictedCapabilityMutation, ToggleRestrictedCapabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleRestrictedCapabilityMutation, ToggleRestrictedCapabilityMutationVariables>(ToggleRestrictedCapabilityDocument, options);
      }
export type ToggleRestrictedCapabilityMutationHookResult = ReturnType<typeof useToggleRestrictedCapabilityMutation>;
export type ToggleRestrictedCapabilityMutationResult = Apollo.MutationResult<ToggleRestrictedCapabilityMutation>;
export type ToggleRestrictedCapabilityMutationOptions = Apollo.BaseMutationOptions<ToggleRestrictedCapabilityMutation, ToggleRestrictedCapabilityMutationVariables>;
export const UpdateLegalEntityStatusDocument = gql`
    mutation UpdateLegalEntityStatus($id: String!, $status: LegalEntityStatus!) {
  updateLegalEntityStatus(id: $id, status: $status)
}
    `;
export type UpdateLegalEntityStatusMutationFn = Apollo.MutationFunction<UpdateLegalEntityStatusMutation, UpdateLegalEntityStatusMutationVariables>;

/**
 * __useUpdateLegalEntityStatusMutation__
 *
 * To run a mutation, you first call `useUpdateLegalEntityStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLegalEntityStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLegalEntityStatusMutation, { data, loading, error }] = useUpdateLegalEntityStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateLegalEntityStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLegalEntityStatusMutation, UpdateLegalEntityStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLegalEntityStatusMutation, UpdateLegalEntityStatusMutationVariables>(UpdateLegalEntityStatusDocument, options);
      }
export type UpdateLegalEntityStatusMutationHookResult = ReturnType<typeof useUpdateLegalEntityStatusMutation>;
export type UpdateLegalEntityStatusMutationResult = Apollo.MutationResult<UpdateLegalEntityStatusMutation>;
export type UpdateLegalEntityStatusMutationOptions = Apollo.BaseMutationOptions<UpdateLegalEntityStatusMutation, UpdateLegalEntityStatusMutationVariables>;
export const UploadAdyenDocumentDocument = gql`
    mutation UploadAdyenDocument($accountHolderId: String!, $documentType: String!, $description: String!, $fileContent: String!, $contentType: String!, $fileName: String) {
  uploadAdyenDocument(
    accountHolderId: $accountHolderId
    documentType: $documentType
    description: $description
    fileContent: $fileContent
    contentType: $contentType
    fileName: $fileName
  )
}
    `;
export type UploadAdyenDocumentMutationFn = Apollo.MutationFunction<UploadAdyenDocumentMutation, UploadAdyenDocumentMutationVariables>;

/**
 * __useUploadAdyenDocumentMutation__
 *
 * To run a mutation, you first call `useUploadAdyenDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAdyenDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAdyenDocumentMutation, { data, loading, error }] = useUploadAdyenDocumentMutation({
 *   variables: {
 *      accountHolderId: // value for 'accountHolderId'
 *      documentType: // value for 'documentType'
 *      description: // value for 'description'
 *      fileContent: // value for 'fileContent'
 *      contentType: // value for 'contentType'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useUploadAdyenDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UploadAdyenDocumentMutation, UploadAdyenDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadAdyenDocumentMutation, UploadAdyenDocumentMutationVariables>(UploadAdyenDocumentDocument, options);
      }
export type UploadAdyenDocumentMutationHookResult = ReturnType<typeof useUploadAdyenDocumentMutation>;
export type UploadAdyenDocumentMutationResult = Apollo.MutationResult<UploadAdyenDocumentMutation>;
export type UploadAdyenDocumentMutationOptions = Apollo.BaseMutationOptions<UploadAdyenDocumentMutation, UploadAdyenDocumentMutationVariables>;
export const GetFraudCheckResultDocument = gql`
    query GetFraudCheckResult($legalEntityId: String!) {
  getFraudCheckResult(legalEntityId: $legalEntityId) {
    legalEntityId
    hasResult
    riskFlag
    reasonsJson
    updatedAt
  }
}
    `;

/**
 * __useGetFraudCheckResultQuery__
 *
 * To run a query within a React component, call `useGetFraudCheckResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFraudCheckResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFraudCheckResultQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useGetFraudCheckResultQuery(baseOptions: Apollo.QueryHookOptions<GetFraudCheckResultQuery, GetFraudCheckResultQueryVariables> & ({ variables: GetFraudCheckResultQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFraudCheckResultQuery, GetFraudCheckResultQueryVariables>(GetFraudCheckResultDocument, options);
      }
export function useGetFraudCheckResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFraudCheckResultQuery, GetFraudCheckResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFraudCheckResultQuery, GetFraudCheckResultQueryVariables>(GetFraudCheckResultDocument, options);
        }
export function useGetFraudCheckResultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFraudCheckResultQuery, GetFraudCheckResultQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFraudCheckResultQuery, GetFraudCheckResultQueryVariables>(GetFraudCheckResultDocument, options);
        }
export type GetFraudCheckResultQueryHookResult = ReturnType<typeof useGetFraudCheckResultQuery>;
export type GetFraudCheckResultLazyQueryHookResult = ReturnType<typeof useGetFraudCheckResultLazyQuery>;
export type GetFraudCheckResultSuspenseQueryHookResult = ReturnType<typeof useGetFraudCheckResultSuspenseQuery>;
export type GetFraudCheckResultQueryResult = Apollo.QueryResult<GetFraudCheckResultQuery, GetFraudCheckResultQueryVariables>;
export const LegalEntityValidationProgressDocument = gql`
    query LegalEntityValidationProgress($id: String!) {
  legalEntityValidationProgress(id: $id) {
    mlProcessedTransactionsStatus {
      dataSourceId
      totalTransactionsCount
      mlProcessedTransactionsCount
    }
  }
}
    `;

/**
 * __useLegalEntityValidationProgressQuery__
 *
 * To run a query within a React component, call `useLegalEntityValidationProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useLegalEntityValidationProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLegalEntityValidationProgressQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLegalEntityValidationProgressQuery(baseOptions: Apollo.QueryHookOptions<LegalEntityValidationProgressQuery, LegalEntityValidationProgressQueryVariables> & ({ variables: LegalEntityValidationProgressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LegalEntityValidationProgressQuery, LegalEntityValidationProgressQueryVariables>(LegalEntityValidationProgressDocument, options);
      }
export function useLegalEntityValidationProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LegalEntityValidationProgressQuery, LegalEntityValidationProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LegalEntityValidationProgressQuery, LegalEntityValidationProgressQueryVariables>(LegalEntityValidationProgressDocument, options);
        }
export function useLegalEntityValidationProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LegalEntityValidationProgressQuery, LegalEntityValidationProgressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LegalEntityValidationProgressQuery, LegalEntityValidationProgressQueryVariables>(LegalEntityValidationProgressDocument, options);
        }
export type LegalEntityValidationProgressQueryHookResult = ReturnType<typeof useLegalEntityValidationProgressQuery>;
export type LegalEntityValidationProgressLazyQueryHookResult = ReturnType<typeof useLegalEntityValidationProgressLazyQuery>;
export type LegalEntityValidationProgressSuspenseQueryHookResult = ReturnType<typeof useLegalEntityValidationProgressSuspenseQuery>;
export type LegalEntityValidationProgressQueryResult = Apollo.QueryResult<LegalEntityValidationProgressQuery, LegalEntityValidationProgressQueryVariables>;
export const ListAdyenVerificationStatusesDocument = gql`
    query ListAdyenVerificationStatuses($statusFilter: BusinessVerificationStatus) {
  listAdyenVerificationStatuses(statusFilter: $statusFilter) {
    legalEntityId
    legalEntityName
    overallStatus
    entityStatuses {
      externalLegalEntityId
      entityType
      verificationStatus
    }
    hasVerificationErrors
    hasUpcomingDeadlines
    statusAt
    accountHolderStatus
    checkbookStatus
  }
}
    `;

/**
 * __useListAdyenVerificationStatusesQuery__
 *
 * To run a query within a React component, call `useListAdyenVerificationStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAdyenVerificationStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAdyenVerificationStatusesQuery({
 *   variables: {
 *      statusFilter: // value for 'statusFilter'
 *   },
 * });
 */
export function useListAdyenVerificationStatusesQuery(baseOptions?: Apollo.QueryHookOptions<ListAdyenVerificationStatusesQuery, ListAdyenVerificationStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAdyenVerificationStatusesQuery, ListAdyenVerificationStatusesQueryVariables>(ListAdyenVerificationStatusesDocument, options);
      }
export function useListAdyenVerificationStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAdyenVerificationStatusesQuery, ListAdyenVerificationStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAdyenVerificationStatusesQuery, ListAdyenVerificationStatusesQueryVariables>(ListAdyenVerificationStatusesDocument, options);
        }
export function useListAdyenVerificationStatusesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAdyenVerificationStatusesQuery, ListAdyenVerificationStatusesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAdyenVerificationStatusesQuery, ListAdyenVerificationStatusesQueryVariables>(ListAdyenVerificationStatusesDocument, options);
        }
export type ListAdyenVerificationStatusesQueryHookResult = ReturnType<typeof useListAdyenVerificationStatusesQuery>;
export type ListAdyenVerificationStatusesLazyQueryHookResult = ReturnType<typeof useListAdyenVerificationStatusesLazyQuery>;
export type ListAdyenVerificationStatusesSuspenseQueryHookResult = ReturnType<typeof useListAdyenVerificationStatusesSuspenseQuery>;
export type ListAdyenVerificationStatusesQueryResult = Apollo.QueryResult<ListAdyenVerificationStatusesQuery, ListAdyenVerificationStatusesQueryVariables>;
export const ListLegalEntitiesDocument = gql`
    query ListLegalEntities($pagination: Pagination!, $searchTerm: String, $includedStatuses: [LegalEntityStatus!], $excludedStatuses: [LegalEntityStatus!], $legalEntityIds: [String!], $includedBillingProductIDs: [String!], $excludedBillingProductIDs: [String!], $noEmployees: Boolean, $noAffiliations: Boolean, $createdBefore: DateTime, $createdAfter: DateTime, $kind: OrganizationKind) {
  listLegalEntities(
    pagination: $pagination
    searchTerm: $searchTerm
    includedStatuses: $includedStatuses
    excludedStatuses: $excludedStatuses
    legalEntityIds: $legalEntityIds
    includedBillingProductIDs: $includedBillingProductIDs
    excludedBillingProductIDs: $excludedBillingProductIDs
    noEmployees: $noEmployees
    noAffiliations: $noAffiliations
    createdBefore: $createdBefore
    createdAfter: $createdAfter
    kind: $kind
  ) {
    ...AdminLegalEntityFields
  }
}
    ${AdminLegalEntityFieldsFragmentDoc}`;

/**
 * __useListLegalEntitiesQuery__
 *
 * To run a query within a React component, call `useListLegalEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLegalEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLegalEntitiesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      searchTerm: // value for 'searchTerm'
 *      includedStatuses: // value for 'includedStatuses'
 *      excludedStatuses: // value for 'excludedStatuses'
 *      legalEntityIds: // value for 'legalEntityIds'
 *      includedBillingProductIDs: // value for 'includedBillingProductIDs'
 *      excludedBillingProductIDs: // value for 'excludedBillingProductIDs'
 *      noEmployees: // value for 'noEmployees'
 *      noAffiliations: // value for 'noAffiliations'
 *      createdBefore: // value for 'createdBefore'
 *      createdAfter: // value for 'createdAfter'
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useListLegalEntitiesQuery(baseOptions: Apollo.QueryHookOptions<ListLegalEntitiesQuery, ListLegalEntitiesQueryVariables> & ({ variables: ListLegalEntitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListLegalEntitiesQuery, ListLegalEntitiesQueryVariables>(ListLegalEntitiesDocument, options);
      }
export function useListLegalEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListLegalEntitiesQuery, ListLegalEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListLegalEntitiesQuery, ListLegalEntitiesQueryVariables>(ListLegalEntitiesDocument, options);
        }
export function useListLegalEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListLegalEntitiesQuery, ListLegalEntitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListLegalEntitiesQuery, ListLegalEntitiesQueryVariables>(ListLegalEntitiesDocument, options);
        }
export type ListLegalEntitiesQueryHookResult = ReturnType<typeof useListLegalEntitiesQuery>;
export type ListLegalEntitiesLazyQueryHookResult = ReturnType<typeof useListLegalEntitiesLazyQuery>;
export type ListLegalEntitiesSuspenseQueryHookResult = ReturnType<typeof useListLegalEntitiesSuspenseQuery>;
export type ListLegalEntitiesQueryResult = Apollo.QueryResult<ListLegalEntitiesQuery, ListLegalEntitiesQueryVariables>;
export const ListLegalEntityTransfersDocument = gql`
    query ListLegalEntityTransfers($legalEntityId: String!, $limit: Int!, $createdSince: String, $createdUntil: String) {
  listLegalEntityTransfers(
    legalEntityId: $legalEntityId
    limit: $limit
    createdSince: $createdSince
    createdUntil: $createdUntil
  ) {
    transfers {
      transferId
      type
      category
      direction
      amount {
        amount
        iso4217CurrencyCode
        currencyMultiplier
      }
      status
      description
      createdAt
      reference
      platformPaymentType
      pspReference
    }
    accountHolderId
  }
}
    `;

/**
 * __useListLegalEntityTransfersQuery__
 *
 * To run a query within a React component, call `useListLegalEntityTransfersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLegalEntityTransfersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLegalEntityTransfersQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      limit: // value for 'limit'
 *      createdSince: // value for 'createdSince'
 *      createdUntil: // value for 'createdUntil'
 *   },
 * });
 */
export function useListLegalEntityTransfersQuery(baseOptions: Apollo.QueryHookOptions<ListLegalEntityTransfersQuery, ListLegalEntityTransfersQueryVariables> & ({ variables: ListLegalEntityTransfersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListLegalEntityTransfersQuery, ListLegalEntityTransfersQueryVariables>(ListLegalEntityTransfersDocument, options);
      }
export function useListLegalEntityTransfersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListLegalEntityTransfersQuery, ListLegalEntityTransfersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListLegalEntityTransfersQuery, ListLegalEntityTransfersQueryVariables>(ListLegalEntityTransfersDocument, options);
        }
export function useListLegalEntityTransfersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListLegalEntityTransfersQuery, ListLegalEntityTransfersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListLegalEntityTransfersQuery, ListLegalEntityTransfersQueryVariables>(ListLegalEntityTransfersDocument, options);
        }
export type ListLegalEntityTransfersQueryHookResult = ReturnType<typeof useListLegalEntityTransfersQuery>;
export type ListLegalEntityTransfersLazyQueryHookResult = ReturnType<typeof useListLegalEntityTransfersLazyQuery>;
export type ListLegalEntityTransfersSuspenseQueryHookResult = ReturnType<typeof useListLegalEntityTransfersSuspenseQuery>;
export type ListLegalEntityTransfersQueryResult = Apollo.QueryResult<ListLegalEntityTransfersQuery, ListLegalEntityTransfersQueryVariables>;
export const ListRestrictedCapabilitiesDocument = gql`
    query ListRestrictedCapabilities($legalEntityId: String!) {
  listRestrictedCapabilities(legalEntityId: $legalEntityId) {
    legalEntityId
    capabilities {
      capability
      enabled
    }
  }
}
    `;

/**
 * __useListRestrictedCapabilitiesQuery__
 *
 * To run a query within a React component, call `useListRestrictedCapabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRestrictedCapabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRestrictedCapabilitiesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListRestrictedCapabilitiesQuery(baseOptions: Apollo.QueryHookOptions<ListRestrictedCapabilitiesQuery, ListRestrictedCapabilitiesQueryVariables> & ({ variables: ListRestrictedCapabilitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListRestrictedCapabilitiesQuery, ListRestrictedCapabilitiesQueryVariables>(ListRestrictedCapabilitiesDocument, options);
      }
export function useListRestrictedCapabilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListRestrictedCapabilitiesQuery, ListRestrictedCapabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListRestrictedCapabilitiesQuery, ListRestrictedCapabilitiesQueryVariables>(ListRestrictedCapabilitiesDocument, options);
        }
export function useListRestrictedCapabilitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListRestrictedCapabilitiesQuery, ListRestrictedCapabilitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListRestrictedCapabilitiesQuery, ListRestrictedCapabilitiesQueryVariables>(ListRestrictedCapabilitiesDocument, options);
        }
export type ListRestrictedCapabilitiesQueryHookResult = ReturnType<typeof useListRestrictedCapabilitiesQuery>;
export type ListRestrictedCapabilitiesLazyQueryHookResult = ReturnType<typeof useListRestrictedCapabilitiesLazyQuery>;
export type ListRestrictedCapabilitiesSuspenseQueryHookResult = ReturnType<typeof useListRestrictedCapabilitiesSuspenseQuery>;
export type ListRestrictedCapabilitiesQueryResult = Apollo.QueryResult<ListRestrictedCapabilitiesQuery, ListRestrictedCapabilitiesQueryVariables>;
export const ReadAdyenAccountHolderStatusDocument = gql`
    query ReadAdyenAccountHolderStatus($legalEntityId: String!) {
  readAdyenAccountHolderStatus(legalEntityId: $legalEntityId) {
    overallStatus
    accountHolderStatus
    checkbookStatus
  }
}
    `;

/**
 * __useReadAdyenAccountHolderStatusQuery__
 *
 * To run a query within a React component, call `useReadAdyenAccountHolderStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadAdyenAccountHolderStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadAdyenAccountHolderStatusQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useReadAdyenAccountHolderStatusQuery(baseOptions: Apollo.QueryHookOptions<ReadAdyenAccountHolderStatusQuery, ReadAdyenAccountHolderStatusQueryVariables> & ({ variables: ReadAdyenAccountHolderStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadAdyenAccountHolderStatusQuery, ReadAdyenAccountHolderStatusQueryVariables>(ReadAdyenAccountHolderStatusDocument, options);
      }
export function useReadAdyenAccountHolderStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadAdyenAccountHolderStatusQuery, ReadAdyenAccountHolderStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadAdyenAccountHolderStatusQuery, ReadAdyenAccountHolderStatusQueryVariables>(ReadAdyenAccountHolderStatusDocument, options);
        }
export function useReadAdyenAccountHolderStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadAdyenAccountHolderStatusQuery, ReadAdyenAccountHolderStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadAdyenAccountHolderStatusQuery, ReadAdyenAccountHolderStatusQueryVariables>(ReadAdyenAccountHolderStatusDocument, options);
        }
export type ReadAdyenAccountHolderStatusQueryHookResult = ReturnType<typeof useReadAdyenAccountHolderStatusQuery>;
export type ReadAdyenAccountHolderStatusLazyQueryHookResult = ReturnType<typeof useReadAdyenAccountHolderStatusLazyQuery>;
export type ReadAdyenAccountHolderStatusSuspenseQueryHookResult = ReturnType<typeof useReadAdyenAccountHolderStatusSuspenseQuery>;
export type ReadAdyenAccountHolderStatusQueryResult = Apollo.QueryResult<ReadAdyenAccountHolderStatusQuery, ReadAdyenAccountHolderStatusQueryVariables>;
export const ReadBusinessVerificationStatusDocument = gql`
    query ReadBusinessVerificationStatus($legalEntityId: String!) {
  readBusinessVerificationStatus(legalEntityId: $legalEntityId) {
    status
    statusAt
  }
}
    `;

/**
 * __useReadBusinessVerificationStatusQuery__
 *
 * To run a query within a React component, call `useReadBusinessVerificationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadBusinessVerificationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadBusinessVerificationStatusQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useReadBusinessVerificationStatusQuery(baseOptions: Apollo.QueryHookOptions<ReadBusinessVerificationStatusQuery, ReadBusinessVerificationStatusQueryVariables> & ({ variables: ReadBusinessVerificationStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadBusinessVerificationStatusQuery, ReadBusinessVerificationStatusQueryVariables>(ReadBusinessVerificationStatusDocument, options);
      }
export function useReadBusinessVerificationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadBusinessVerificationStatusQuery, ReadBusinessVerificationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadBusinessVerificationStatusQuery, ReadBusinessVerificationStatusQueryVariables>(ReadBusinessVerificationStatusDocument, options);
        }
export function useReadBusinessVerificationStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadBusinessVerificationStatusQuery, ReadBusinessVerificationStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadBusinessVerificationStatusQuery, ReadBusinessVerificationStatusQueryVariables>(ReadBusinessVerificationStatusDocument, options);
        }
export type ReadBusinessVerificationStatusQueryHookResult = ReturnType<typeof useReadBusinessVerificationStatusQuery>;
export type ReadBusinessVerificationStatusLazyQueryHookResult = ReturnType<typeof useReadBusinessVerificationStatusLazyQuery>;
export type ReadBusinessVerificationStatusSuspenseQueryHookResult = ReturnType<typeof useReadBusinessVerificationStatusSuspenseQuery>;
export type ReadBusinessVerificationStatusQueryResult = Apollo.QueryResult<ReadBusinessVerificationStatusQuery, ReadBusinessVerificationStatusQueryVariables>;
export const ReadDetailedAdyenStatusDocument = gql`
    query ReadDetailedAdyenStatus($legalEntityId: String!) {
  readDetailedAdyenStatus(legalEntityId: $legalEntityId) {
    overallStatus
    statusAt
    externalOrganizationLegalEntityId
    externalPrimaryLegalEntityId
    accountHolderId
    accountHolderStatus
    checkbookStatus
    companyVerification {
      entityId
      entityType
      name
      status
      problems {
        type
        code
        message
        remediationMessage
      }
    }
    identityVerifications {
      entityId
      entityType
      name
      status
      problems {
        type
        code
        message
        remediationMessage
      }
    }
    capabilities {
      capabilityName
      allowed
      requested
      verificationStatus
    }
    verificationErrors {
      code
      message
      remediationMessage
      entityType
      field
    }
    deadlines {
      capability
      expiresAt
    }
    documents {
      id
      documentType
      description
      fileName
      active
      modificationDate
    }
  }
}
    `;

/**
 * __useReadDetailedAdyenStatusQuery__
 *
 * To run a query within a React component, call `useReadDetailedAdyenStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadDetailedAdyenStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadDetailedAdyenStatusQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useReadDetailedAdyenStatusQuery(baseOptions: Apollo.QueryHookOptions<ReadDetailedAdyenStatusQuery, ReadDetailedAdyenStatusQueryVariables> & ({ variables: ReadDetailedAdyenStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadDetailedAdyenStatusQuery, ReadDetailedAdyenStatusQueryVariables>(ReadDetailedAdyenStatusDocument, options);
      }
export function useReadDetailedAdyenStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadDetailedAdyenStatusQuery, ReadDetailedAdyenStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadDetailedAdyenStatusQuery, ReadDetailedAdyenStatusQueryVariables>(ReadDetailedAdyenStatusDocument, options);
        }
export function useReadDetailedAdyenStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadDetailedAdyenStatusQuery, ReadDetailedAdyenStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadDetailedAdyenStatusQuery, ReadDetailedAdyenStatusQueryVariables>(ReadDetailedAdyenStatusDocument, options);
        }
export type ReadDetailedAdyenStatusQueryHookResult = ReturnType<typeof useReadDetailedAdyenStatusQuery>;
export type ReadDetailedAdyenStatusLazyQueryHookResult = ReturnType<typeof useReadDetailedAdyenStatusLazyQuery>;
export type ReadDetailedAdyenStatusSuspenseQueryHookResult = ReturnType<typeof useReadDetailedAdyenStatusSuspenseQuery>;
export type ReadDetailedAdyenStatusQueryResult = Apollo.QueryResult<ReadDetailedAdyenStatusQuery, ReadDetailedAdyenStatusQueryVariables>;
export const ReadLegalEntityDocument = gql`
    query ReadLegalEntity($id: String!) {
  readLegalEntity(id: $id) {
    ...AdminLegalEntityFields
  }
}
    ${AdminLegalEntityFieldsFragmentDoc}`;

/**
 * __useReadLegalEntityQuery__
 *
 * To run a query within a React component, call `useReadLegalEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadLegalEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadLegalEntityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReadLegalEntityQuery(baseOptions: Apollo.QueryHookOptions<ReadLegalEntityQuery, ReadLegalEntityQueryVariables> & ({ variables: ReadLegalEntityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadLegalEntityQuery, ReadLegalEntityQueryVariables>(ReadLegalEntityDocument, options);
      }
export function useReadLegalEntityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadLegalEntityQuery, ReadLegalEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadLegalEntityQuery, ReadLegalEntityQueryVariables>(ReadLegalEntityDocument, options);
        }
export function useReadLegalEntitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadLegalEntityQuery, ReadLegalEntityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadLegalEntityQuery, ReadLegalEntityQueryVariables>(ReadLegalEntityDocument, options);
        }
export type ReadLegalEntityQueryHookResult = ReturnType<typeof useReadLegalEntityQuery>;
export type ReadLegalEntityLazyQueryHookResult = ReturnType<typeof useReadLegalEntityLazyQuery>;
export type ReadLegalEntitySuspenseQueryHookResult = ReturnType<typeof useReadLegalEntitySuspenseQuery>;
export type ReadLegalEntityQueryResult = Apollo.QueryResult<ReadLegalEntityQuery, ReadLegalEntityQueryVariables>;
export const ReadLegalEntityPreferencesDocument = gql`
    query ReadLegalEntityPreferences($legalEntityId: String!) {
  readLegalEntityPreferences(legalEntityId: $legalEntityId) {
    legalEntityId
    isCogsInExpenses
    lineClassDisplayName
    lineClassPluralDisplayName
    bookkeeperAiCutoverAt
  }
}
    `;

/**
 * __useReadLegalEntityPreferencesQuery__
 *
 * To run a query within a React component, call `useReadLegalEntityPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadLegalEntityPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadLegalEntityPreferencesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useReadLegalEntityPreferencesQuery(baseOptions: Apollo.QueryHookOptions<ReadLegalEntityPreferencesQuery, ReadLegalEntityPreferencesQueryVariables> & ({ variables: ReadLegalEntityPreferencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadLegalEntityPreferencesQuery, ReadLegalEntityPreferencesQueryVariables>(ReadLegalEntityPreferencesDocument, options);
      }
export function useReadLegalEntityPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadLegalEntityPreferencesQuery, ReadLegalEntityPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadLegalEntityPreferencesQuery, ReadLegalEntityPreferencesQueryVariables>(ReadLegalEntityPreferencesDocument, options);
        }
export function useReadLegalEntityPreferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadLegalEntityPreferencesQuery, ReadLegalEntityPreferencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadLegalEntityPreferencesQuery, ReadLegalEntityPreferencesQueryVariables>(ReadLegalEntityPreferencesDocument, options);
        }
export type ReadLegalEntityPreferencesQueryHookResult = ReturnType<typeof useReadLegalEntityPreferencesQuery>;
export type ReadLegalEntityPreferencesLazyQueryHookResult = ReturnType<typeof useReadLegalEntityPreferencesLazyQuery>;
export type ReadLegalEntityPreferencesSuspenseQueryHookResult = ReturnType<typeof useReadLegalEntityPreferencesSuspenseQuery>;
export type ReadLegalEntityPreferencesQueryResult = Apollo.QueryResult<ReadLegalEntityPreferencesQuery, ReadLegalEntityPreferencesQueryVariables>;
export const MergeMigrationPullRequestDocument = gql`
    mutation MergeMigrationPullRequest($repo: String!, $prNumber: Int!) {
  mergeMigrationPullRequest(repo: $repo, prNumber: $prNumber)
}
    `;
export type MergeMigrationPullRequestMutationFn = Apollo.MutationFunction<MergeMigrationPullRequestMutation, MergeMigrationPullRequestMutationVariables>;

/**
 * __useMergeMigrationPullRequestMutation__
 *
 * To run a mutation, you first call `useMergeMigrationPullRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeMigrationPullRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeMigrationPullRequestMutation, { data, loading, error }] = useMergeMigrationPullRequestMutation({
 *   variables: {
 *      repo: // value for 'repo'
 *      prNumber: // value for 'prNumber'
 *   },
 * });
 */
export function useMergeMigrationPullRequestMutation(baseOptions?: Apollo.MutationHookOptions<MergeMigrationPullRequestMutation, MergeMigrationPullRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeMigrationPullRequestMutation, MergeMigrationPullRequestMutationVariables>(MergeMigrationPullRequestDocument, options);
      }
export type MergeMigrationPullRequestMutationHookResult = ReturnType<typeof useMergeMigrationPullRequestMutation>;
export type MergeMigrationPullRequestMutationResult = Apollo.MutationResult<MergeMigrationPullRequestMutation>;
export type MergeMigrationPullRequestMutationOptions = Apollo.BaseMutationOptions<MergeMigrationPullRequestMutation, MergeMigrationPullRequestMutationVariables>;
export const RunMigrationPullRequestDocument = gql`
    mutation RunMigrationPullRequest($repo: String!, $prNumber: Int!, $filename: String!, $isPartitionableDML: Boolean!, $overrideMigrationRecord: Boolean) {
  runMigrationPullRequest(
    repo: $repo
    prNumber: $prNumber
    filename: $filename
    isPartitionableDML: $isPartitionableDML
    overrideMigrationRecord: $overrideMigrationRecord
  )
}
    `;
export type RunMigrationPullRequestMutationFn = Apollo.MutationFunction<RunMigrationPullRequestMutation, RunMigrationPullRequestMutationVariables>;

/**
 * __useRunMigrationPullRequestMutation__
 *
 * To run a mutation, you first call `useRunMigrationPullRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunMigrationPullRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runMigrationPullRequestMutation, { data, loading, error }] = useRunMigrationPullRequestMutation({
 *   variables: {
 *      repo: // value for 'repo'
 *      prNumber: // value for 'prNumber'
 *      filename: // value for 'filename'
 *      isPartitionableDML: // value for 'isPartitionableDML'
 *      overrideMigrationRecord: // value for 'overrideMigrationRecord'
 *   },
 * });
 */
export function useRunMigrationPullRequestMutation(baseOptions?: Apollo.MutationHookOptions<RunMigrationPullRequestMutation, RunMigrationPullRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RunMigrationPullRequestMutation, RunMigrationPullRequestMutationVariables>(RunMigrationPullRequestDocument, options);
      }
export type RunMigrationPullRequestMutationHookResult = ReturnType<typeof useRunMigrationPullRequestMutation>;
export type RunMigrationPullRequestMutationResult = Apollo.MutationResult<RunMigrationPullRequestMutation>;
export type RunMigrationPullRequestMutationOptions = Apollo.BaseMutationOptions<RunMigrationPullRequestMutation, RunMigrationPullRequestMutationVariables>;
export const ListMigrationPullRequestsDocument = gql`
    query ListMigrationPullRequests($repo: String!, $anyLabel: Boolean, $prState: PullRequestFilterState) {
  listMigrationPullRequests(repo: $repo, anyLabel: $anyLabel, prState: $prState) {
    ...PullRequestFields
  }
}
    ${PullRequestFieldsFragmentDoc}`;

/**
 * __useListMigrationPullRequestsQuery__
 *
 * To run a query within a React component, call `useListMigrationPullRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMigrationPullRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMigrationPullRequestsQuery({
 *   variables: {
 *      repo: // value for 'repo'
 *      anyLabel: // value for 'anyLabel'
 *      prState: // value for 'prState'
 *   },
 * });
 */
export function useListMigrationPullRequestsQuery(baseOptions: Apollo.QueryHookOptions<ListMigrationPullRequestsQuery, ListMigrationPullRequestsQueryVariables> & ({ variables: ListMigrationPullRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMigrationPullRequestsQuery, ListMigrationPullRequestsQueryVariables>(ListMigrationPullRequestsDocument, options);
      }
export function useListMigrationPullRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMigrationPullRequestsQuery, ListMigrationPullRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMigrationPullRequestsQuery, ListMigrationPullRequestsQueryVariables>(ListMigrationPullRequestsDocument, options);
        }
export function useListMigrationPullRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListMigrationPullRequestsQuery, ListMigrationPullRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListMigrationPullRequestsQuery, ListMigrationPullRequestsQueryVariables>(ListMigrationPullRequestsDocument, options);
        }
export type ListMigrationPullRequestsQueryHookResult = ReturnType<typeof useListMigrationPullRequestsQuery>;
export type ListMigrationPullRequestsLazyQueryHookResult = ReturnType<typeof useListMigrationPullRequestsLazyQuery>;
export type ListMigrationPullRequestsSuspenseQueryHookResult = ReturnType<typeof useListMigrationPullRequestsSuspenseQuery>;
export type ListMigrationPullRequestsQueryResult = Apollo.QueryResult<ListMigrationPullRequestsQuery, ListMigrationPullRequestsQueryVariables>;
export const ReadMigrationPullRequestDocument = gql`
    query ReadMigrationPullRequest($repo: String!, $prNumber: Int!) {
  readMigrationPullRequest(repo: $repo, prNumber: $prNumber) {
    pullRequestSummary {
      pullRequest {
        ...PullRequestFields
      }
      reviewStatus
      mergeableStatus
      merged
    }
    fileSummaries {
      file {
        name
        contents
        url
      }
      hasRun
    }
  }
}
    ${PullRequestFieldsFragmentDoc}`;

/**
 * __useReadMigrationPullRequestQuery__
 *
 * To run a query within a React component, call `useReadMigrationPullRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadMigrationPullRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadMigrationPullRequestQuery({
 *   variables: {
 *      repo: // value for 'repo'
 *      prNumber: // value for 'prNumber'
 *   },
 * });
 */
export function useReadMigrationPullRequestQuery(baseOptions: Apollo.QueryHookOptions<ReadMigrationPullRequestQuery, ReadMigrationPullRequestQueryVariables> & ({ variables: ReadMigrationPullRequestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadMigrationPullRequestQuery, ReadMigrationPullRequestQueryVariables>(ReadMigrationPullRequestDocument, options);
      }
export function useReadMigrationPullRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadMigrationPullRequestQuery, ReadMigrationPullRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadMigrationPullRequestQuery, ReadMigrationPullRequestQueryVariables>(ReadMigrationPullRequestDocument, options);
        }
export function useReadMigrationPullRequestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadMigrationPullRequestQuery, ReadMigrationPullRequestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadMigrationPullRequestQuery, ReadMigrationPullRequestQueryVariables>(ReadMigrationPullRequestDocument, options);
        }
export type ReadMigrationPullRequestQueryHookResult = ReturnType<typeof useReadMigrationPullRequestQuery>;
export type ReadMigrationPullRequestLazyQueryHookResult = ReturnType<typeof useReadMigrationPullRequestLazyQuery>;
export type ReadMigrationPullRequestSuspenseQueryHookResult = ReturnType<typeof useReadMigrationPullRequestSuspenseQuery>;
export type ReadMigrationPullRequestQueryResult = Apollo.QueryResult<ReadMigrationPullRequestQuery, ReadMigrationPullRequestQueryVariables>;
export const UpdateEmailDeliveryPreferencesDocument = gql`
    mutation UpdateEmailDeliveryPreferences($emailAddress: String!, $receiveEmails: Boolean!) {
  updateEmailDeliveryPreferences(
    emailAddress: $emailAddress
    receiveEmails: $receiveEmails
  )
}
    `;
export type UpdateEmailDeliveryPreferencesMutationFn = Apollo.MutationFunction<UpdateEmailDeliveryPreferencesMutation, UpdateEmailDeliveryPreferencesMutationVariables>;

/**
 * __useUpdateEmailDeliveryPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateEmailDeliveryPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailDeliveryPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailDeliveryPreferencesMutation, { data, loading, error }] = useUpdateEmailDeliveryPreferencesMutation({
 *   variables: {
 *      emailAddress: // value for 'emailAddress'
 *      receiveEmails: // value for 'receiveEmails'
 *   },
 * });
 */
export function useUpdateEmailDeliveryPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmailDeliveryPreferencesMutation, UpdateEmailDeliveryPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmailDeliveryPreferencesMutation, UpdateEmailDeliveryPreferencesMutationVariables>(UpdateEmailDeliveryPreferencesDocument, options);
      }
export type UpdateEmailDeliveryPreferencesMutationHookResult = ReturnType<typeof useUpdateEmailDeliveryPreferencesMutation>;
export type UpdateEmailDeliveryPreferencesMutationResult = Apollo.MutationResult<UpdateEmailDeliveryPreferencesMutation>;
export type UpdateEmailDeliveryPreferencesMutationOptions = Apollo.BaseMutationOptions<UpdateEmailDeliveryPreferencesMutation, UpdateEmailDeliveryPreferencesMutationVariables>;
export const ReadEmailHtmlDocument = gql`
    query ReadEmailHTML($eventType: EventType!) {
  readEmailHTML(eventType: $eventType)
}
    `;

/**
 * __useReadEmailHtmlQuery__
 *
 * To run a query within a React component, call `useReadEmailHtmlQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadEmailHtmlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadEmailHtmlQuery({
 *   variables: {
 *      eventType: // value for 'eventType'
 *   },
 * });
 */
export function useReadEmailHtmlQuery(baseOptions: Apollo.QueryHookOptions<ReadEmailHtmlQuery, ReadEmailHtmlQueryVariables> & ({ variables: ReadEmailHtmlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadEmailHtmlQuery, ReadEmailHtmlQueryVariables>(ReadEmailHtmlDocument, options);
      }
export function useReadEmailHtmlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadEmailHtmlQuery, ReadEmailHtmlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadEmailHtmlQuery, ReadEmailHtmlQueryVariables>(ReadEmailHtmlDocument, options);
        }
export function useReadEmailHtmlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadEmailHtmlQuery, ReadEmailHtmlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadEmailHtmlQuery, ReadEmailHtmlQueryVariables>(ReadEmailHtmlDocument, options);
        }
export type ReadEmailHtmlQueryHookResult = ReturnType<typeof useReadEmailHtmlQuery>;
export type ReadEmailHtmlLazyQueryHookResult = ReturnType<typeof useReadEmailHtmlLazyQuery>;
export type ReadEmailHtmlSuspenseQueryHookResult = ReturnType<typeof useReadEmailHtmlSuspenseQuery>;
export type ReadEmailHtmlQueryResult = Apollo.QueryResult<ReadEmailHtmlQuery, ReadEmailHtmlQueryVariables>;
export const ListDepartmentFactHierarchyDocument = gql`
    query ListDepartmentFactHierarchy($legalEntityId: String!) {
  listDepartmentFactHierarchy(legalEntityId: $legalEntityId) {
    ...ObjectMappingHierarchyNodeFields
  }
}
    ${ObjectMappingHierarchyNodeFieldsFragmentDoc}`;

/**
 * __useListDepartmentFactHierarchyQuery__
 *
 * To run a query within a React component, call `useListDepartmentFactHierarchyQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDepartmentFactHierarchyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDepartmentFactHierarchyQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListDepartmentFactHierarchyQuery(baseOptions: Apollo.QueryHookOptions<ListDepartmentFactHierarchyQuery, ListDepartmentFactHierarchyQueryVariables> & ({ variables: ListDepartmentFactHierarchyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDepartmentFactHierarchyQuery, ListDepartmentFactHierarchyQueryVariables>(ListDepartmentFactHierarchyDocument, options);
      }
export function useListDepartmentFactHierarchyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDepartmentFactHierarchyQuery, ListDepartmentFactHierarchyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDepartmentFactHierarchyQuery, ListDepartmentFactHierarchyQueryVariables>(ListDepartmentFactHierarchyDocument, options);
        }
export function useListDepartmentFactHierarchySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListDepartmentFactHierarchyQuery, ListDepartmentFactHierarchyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListDepartmentFactHierarchyQuery, ListDepartmentFactHierarchyQueryVariables>(ListDepartmentFactHierarchyDocument, options);
        }
export type ListDepartmentFactHierarchyQueryHookResult = ReturnType<typeof useListDepartmentFactHierarchyQuery>;
export type ListDepartmentFactHierarchyLazyQueryHookResult = ReturnType<typeof useListDepartmentFactHierarchyLazyQuery>;
export type ListDepartmentFactHierarchySuspenseQueryHookResult = ReturnType<typeof useListDepartmentFactHierarchySuspenseQuery>;
export type ListDepartmentFactHierarchyQueryResult = Apollo.QueryResult<ListDepartmentFactHierarchyQuery, ListDepartmentFactHierarchyQueryVariables>;
export const ListLineClassFactHierarchyDocument = gql`
    query ListLineClassFactHierarchy($legalEntityId: String!) {
  listLineClassFactHierarchy(legalEntityId: $legalEntityId) {
    ...ObjectMappingHierarchyNodeFields
  }
}
    ${ObjectMappingHierarchyNodeFieldsFragmentDoc}`;

/**
 * __useListLineClassFactHierarchyQuery__
 *
 * To run a query within a React component, call `useListLineClassFactHierarchyQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLineClassFactHierarchyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLineClassFactHierarchyQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListLineClassFactHierarchyQuery(baseOptions: Apollo.QueryHookOptions<ListLineClassFactHierarchyQuery, ListLineClassFactHierarchyQueryVariables> & ({ variables: ListLineClassFactHierarchyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListLineClassFactHierarchyQuery, ListLineClassFactHierarchyQueryVariables>(ListLineClassFactHierarchyDocument, options);
      }
export function useListLineClassFactHierarchyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListLineClassFactHierarchyQuery, ListLineClassFactHierarchyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListLineClassFactHierarchyQuery, ListLineClassFactHierarchyQueryVariables>(ListLineClassFactHierarchyDocument, options);
        }
export function useListLineClassFactHierarchySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListLineClassFactHierarchyQuery, ListLineClassFactHierarchyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListLineClassFactHierarchyQuery, ListLineClassFactHierarchyQueryVariables>(ListLineClassFactHierarchyDocument, options);
        }
export type ListLineClassFactHierarchyQueryHookResult = ReturnType<typeof useListLineClassFactHierarchyQuery>;
export type ListLineClassFactHierarchyLazyQueryHookResult = ReturnType<typeof useListLineClassFactHierarchyLazyQuery>;
export type ListLineClassFactHierarchySuspenseQueryHookResult = ReturnType<typeof useListLineClassFactHierarchySuspenseQuery>;
export type ListLineClassFactHierarchyQueryResult = Apollo.QueryResult<ListLineClassFactHierarchyQuery, ListLineClassFactHierarchyQueryVariables>;
export const SetOrganizationSlugDocument = gql`
    mutation SetOrganizationSlug($organizationId: String!, $newSlug: String!) {
  setOrganizationSlug(organizationId: $organizationId, newSlug: $newSlug)
}
    `;
export type SetOrganizationSlugMutationFn = Apollo.MutationFunction<SetOrganizationSlugMutation, SetOrganizationSlugMutationVariables>;

/**
 * __useSetOrganizationSlugMutation__
 *
 * To run a mutation, you first call `useSetOrganizationSlugMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOrganizationSlugMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOrganizationSlugMutation, { data, loading, error }] = useSetOrganizationSlugMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      newSlug: // value for 'newSlug'
 *   },
 * });
 */
export function useSetOrganizationSlugMutation(baseOptions?: Apollo.MutationHookOptions<SetOrganizationSlugMutation, SetOrganizationSlugMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetOrganizationSlugMutation, SetOrganizationSlugMutationVariables>(SetOrganizationSlugDocument, options);
      }
export type SetOrganizationSlugMutationHookResult = ReturnType<typeof useSetOrganizationSlugMutation>;
export type SetOrganizationSlugMutationResult = Apollo.MutationResult<SetOrganizationSlugMutation>;
export type SetOrganizationSlugMutationOptions = Apollo.BaseMutationOptions<SetOrganizationSlugMutation, SetOrganizationSlugMutationVariables>;
export const ListAffiliatedOrganizationsDocument = gql`
    query ListAffiliatedOrganizations($legalEntityId: String!) {
  listAffiliatedOrganizations(legalEntityId: $legalEntityId) {
    ...AdminOrganizationFields
  }
}
    ${AdminOrganizationFieldsFragmentDoc}`;

/**
 * __useListAffiliatedOrganizationsQuery__
 *
 * To run a query within a React component, call `useListAffiliatedOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAffiliatedOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAffiliatedOrganizationsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListAffiliatedOrganizationsQuery(baseOptions: Apollo.QueryHookOptions<ListAffiliatedOrganizationsQuery, ListAffiliatedOrganizationsQueryVariables> & ({ variables: ListAffiliatedOrganizationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAffiliatedOrganizationsQuery, ListAffiliatedOrganizationsQueryVariables>(ListAffiliatedOrganizationsDocument, options);
      }
export function useListAffiliatedOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAffiliatedOrganizationsQuery, ListAffiliatedOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAffiliatedOrganizationsQuery, ListAffiliatedOrganizationsQueryVariables>(ListAffiliatedOrganizationsDocument, options);
        }
export function useListAffiliatedOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAffiliatedOrganizationsQuery, ListAffiliatedOrganizationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAffiliatedOrganizationsQuery, ListAffiliatedOrganizationsQueryVariables>(ListAffiliatedOrganizationsDocument, options);
        }
export type ListAffiliatedOrganizationsQueryHookResult = ReturnType<typeof useListAffiliatedOrganizationsQuery>;
export type ListAffiliatedOrganizationsLazyQueryHookResult = ReturnType<typeof useListAffiliatedOrganizationsLazyQuery>;
export type ListAffiliatedOrganizationsSuspenseQueryHookResult = ReturnType<typeof useListAffiliatedOrganizationsSuspenseQuery>;
export type ListAffiliatedOrganizationsQueryResult = Apollo.QueryResult<ListAffiliatedOrganizationsQuery, ListAffiliatedOrganizationsQueryVariables>;
export const ListOrganizationsDocument = gql`
    query ListOrganizations($pagination: Pagination, $searchTerm: String, $affiliateType: AffiliateType, $kind: OrganizationKind, $organizationIds: [String!], $onlyWithEmployees: Boolean, $createdBefore: DateTime, $createdAfter: DateTime) {
  listOrganizations(
    pagination: $pagination
    searchTerm: $searchTerm
    affiliateType: $affiliateType
    kind: $kind
    organizationIds: $organizationIds
    onlyWithEmployees: $onlyWithEmployees
    createdBefore: $createdBefore
    createdAfter: $createdAfter
  ) {
    ...AdminOrganizationFields
  }
}
    ${AdminOrganizationFieldsFragmentDoc}`;

/**
 * __useListOrganizationsQuery__
 *
 * To run a query within a React component, call `useListOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOrganizationsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      searchTerm: // value for 'searchTerm'
 *      affiliateType: // value for 'affiliateType'
 *      kind: // value for 'kind'
 *      organizationIds: // value for 'organizationIds'
 *      onlyWithEmployees: // value for 'onlyWithEmployees'
 *      createdBefore: // value for 'createdBefore'
 *      createdAfter: // value for 'createdAfter'
 *   },
 * });
 */
export function useListOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<ListOrganizationsQuery, ListOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListOrganizationsQuery, ListOrganizationsQueryVariables>(ListOrganizationsDocument, options);
      }
export function useListOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListOrganizationsQuery, ListOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListOrganizationsQuery, ListOrganizationsQueryVariables>(ListOrganizationsDocument, options);
        }
export function useListOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListOrganizationsQuery, ListOrganizationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListOrganizationsQuery, ListOrganizationsQueryVariables>(ListOrganizationsDocument, options);
        }
export type ListOrganizationsQueryHookResult = ReturnType<typeof useListOrganizationsQuery>;
export type ListOrganizationsLazyQueryHookResult = ReturnType<typeof useListOrganizationsLazyQuery>;
export type ListOrganizationsSuspenseQueryHookResult = ReturnType<typeof useListOrganizationsSuspenseQuery>;
export type ListOrganizationsQueryResult = Apollo.QueryResult<ListOrganizationsQuery, ListOrganizationsQueryVariables>;
export const ReadOrganizationDocument = gql`
    query ReadOrganization($id: String!) {
  readOrganization(id: $id) {
    ...AdminOrganizationFields
  }
}
    ${AdminOrganizationFieldsFragmentDoc}`;

/**
 * __useReadOrganizationQuery__
 *
 * To run a query within a React component, call `useReadOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadOrganizationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReadOrganizationQuery(baseOptions: Apollo.QueryHookOptions<ReadOrganizationQuery, ReadOrganizationQueryVariables> & ({ variables: ReadOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadOrganizationQuery, ReadOrganizationQueryVariables>(ReadOrganizationDocument, options);
      }
export function useReadOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadOrganizationQuery, ReadOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadOrganizationQuery, ReadOrganizationQueryVariables>(ReadOrganizationDocument, options);
        }
export function useReadOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadOrganizationQuery, ReadOrganizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadOrganizationQuery, ReadOrganizationQueryVariables>(ReadOrganizationDocument, options);
        }
export type ReadOrganizationQueryHookResult = ReturnType<typeof useReadOrganizationQuery>;
export type ReadOrganizationLazyQueryHookResult = ReturnType<typeof useReadOrganizationLazyQuery>;
export type ReadOrganizationSuspenseQueryHookResult = ReturnType<typeof useReadOrganizationSuspenseQuery>;
export type ReadOrganizationQueryResult = Apollo.QueryResult<ReadOrganizationQuery, ReadOrganizationQueryVariables>;
export const CreateAliasDocument = gql`
    mutation CreateAlias($partyId: String!, $alias: String!) {
  createAlias(partyId: $partyId, alias: $alias) {
    partyId
    alias
  }
}
    `;
export type CreateAliasMutationFn = Apollo.MutationFunction<CreateAliasMutation, CreateAliasMutationVariables>;

/**
 * __useCreateAliasMutation__
 *
 * To run a mutation, you first call `useCreateAliasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAliasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAliasMutation, { data, loading, error }] = useCreateAliasMutation({
 *   variables: {
 *      partyId: // value for 'partyId'
 *      alias: // value for 'alias'
 *   },
 * });
 */
export function useCreateAliasMutation(baseOptions?: Apollo.MutationHookOptions<CreateAliasMutation, CreateAliasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAliasMutation, CreateAliasMutationVariables>(CreateAliasDocument, options);
      }
export type CreateAliasMutationHookResult = ReturnType<typeof useCreateAliasMutation>;
export type CreateAliasMutationResult = Apollo.MutationResult<CreateAliasMutation>;
export type CreateAliasMutationOptions = Apollo.BaseMutationOptions<CreateAliasMutation, CreateAliasMutationVariables>;
export const CreateGlobalPartyDocument = gql`
    mutation CreateGlobalParty($fields: NewParty!, $aliases: [String!]!, $prefixes: [String!]!) {
  createGlobalParty(fields: $fields, aliases: $aliases, prefixes: $prefixes) {
    ...AdminPartyFields
  }
}
    ${AdminPartyFieldsFragmentDoc}`;
export type CreateGlobalPartyMutationFn = Apollo.MutationFunction<CreateGlobalPartyMutation, CreateGlobalPartyMutationVariables>;

/**
 * __useCreateGlobalPartyMutation__
 *
 * To run a mutation, you first call `useCreateGlobalPartyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGlobalPartyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGlobalPartyMutation, { data, loading, error }] = useCreateGlobalPartyMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *      aliases: // value for 'aliases'
 *      prefixes: // value for 'prefixes'
 *   },
 * });
 */
export function useCreateGlobalPartyMutation(baseOptions?: Apollo.MutationHookOptions<CreateGlobalPartyMutation, CreateGlobalPartyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGlobalPartyMutation, CreateGlobalPartyMutationVariables>(CreateGlobalPartyDocument, options);
      }
export type CreateGlobalPartyMutationHookResult = ReturnType<typeof useCreateGlobalPartyMutation>;
export type CreateGlobalPartyMutationResult = Apollo.MutationResult<CreateGlobalPartyMutation>;
export type CreateGlobalPartyMutationOptions = Apollo.BaseMutationOptions<CreateGlobalPartyMutation, CreateGlobalPartyMutationVariables>;
export const CreatePrefixMappingDocument = gql`
    mutation CreatePrefixMapping($prefix: String!, $partyId: String!) {
  createPrefixMapping(prefix: $prefix, partyId: $partyId) {
    ...PrefixMappingFields
  }
}
    ${PrefixMappingFieldsFragmentDoc}`;
export type CreatePrefixMappingMutationFn = Apollo.MutationFunction<CreatePrefixMappingMutation, CreatePrefixMappingMutationVariables>;

/**
 * __useCreatePrefixMappingMutation__
 *
 * To run a mutation, you first call `useCreatePrefixMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePrefixMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPrefixMappingMutation, { data, loading, error }] = useCreatePrefixMappingMutation({
 *   variables: {
 *      prefix: // value for 'prefix'
 *      partyId: // value for 'partyId'
 *   },
 * });
 */
export function useCreatePrefixMappingMutation(baseOptions?: Apollo.MutationHookOptions<CreatePrefixMappingMutation, CreatePrefixMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePrefixMappingMutation, CreatePrefixMappingMutationVariables>(CreatePrefixMappingDocument, options);
      }
export type CreatePrefixMappingMutationHookResult = ReturnType<typeof useCreatePrefixMappingMutation>;
export type CreatePrefixMappingMutationResult = Apollo.MutationResult<CreatePrefixMappingMutation>;
export type CreatePrefixMappingMutationOptions = Apollo.BaseMutationOptions<CreatePrefixMappingMutation, CreatePrefixMappingMutationVariables>;
export const DeleteAliasDocument = gql`
    mutation DeleteAlias($partyId: String!, $alias: String!) {
  deleteAlias(partyId: $partyId, alias: $alias)
}
    `;
export type DeleteAliasMutationFn = Apollo.MutationFunction<DeleteAliasMutation, DeleteAliasMutationVariables>;

/**
 * __useDeleteAliasMutation__
 *
 * To run a mutation, you first call `useDeleteAliasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAliasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAliasMutation, { data, loading, error }] = useDeleteAliasMutation({
 *   variables: {
 *      partyId: // value for 'partyId'
 *      alias: // value for 'alias'
 *   },
 * });
 */
export function useDeleteAliasMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAliasMutation, DeleteAliasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAliasMutation, DeleteAliasMutationVariables>(DeleteAliasDocument, options);
      }
export type DeleteAliasMutationHookResult = ReturnType<typeof useDeleteAliasMutation>;
export type DeleteAliasMutationResult = Apollo.MutationResult<DeleteAliasMutation>;
export type DeleteAliasMutationOptions = Apollo.BaseMutationOptions<DeleteAliasMutation, DeleteAliasMutationVariables>;
export const DeleteGlobalPartyDocument = gql`
    mutation DeleteGlobalParty($partyId: String!) {
  deleteGlobalParty(partyId: $partyId)
}
    `;
export type DeleteGlobalPartyMutationFn = Apollo.MutationFunction<DeleteGlobalPartyMutation, DeleteGlobalPartyMutationVariables>;

/**
 * __useDeleteGlobalPartyMutation__
 *
 * To run a mutation, you first call `useDeleteGlobalPartyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGlobalPartyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGlobalPartyMutation, { data, loading, error }] = useDeleteGlobalPartyMutation({
 *   variables: {
 *      partyId: // value for 'partyId'
 *   },
 * });
 */
export function useDeleteGlobalPartyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGlobalPartyMutation, DeleteGlobalPartyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGlobalPartyMutation, DeleteGlobalPartyMutationVariables>(DeleteGlobalPartyDocument, options);
      }
export type DeleteGlobalPartyMutationHookResult = ReturnType<typeof useDeleteGlobalPartyMutation>;
export type DeleteGlobalPartyMutationResult = Apollo.MutationResult<DeleteGlobalPartyMutation>;
export type DeleteGlobalPartyMutationOptions = Apollo.BaseMutationOptions<DeleteGlobalPartyMutation, DeleteGlobalPartyMutationVariables>;
export const DeletePartyExtractionDocument = gql`
    mutation DeletePartyExtraction($legalEntityId: String!, $partyExtractionId: String!) {
  deletePartyExtraction(
    legalEntityId: $legalEntityId
    partyExtractionId: $partyExtractionId
  )
}
    `;
export type DeletePartyExtractionMutationFn = Apollo.MutationFunction<DeletePartyExtractionMutation, DeletePartyExtractionMutationVariables>;

/**
 * __useDeletePartyExtractionMutation__
 *
 * To run a mutation, you first call `useDeletePartyExtractionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePartyExtractionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePartyExtractionMutation, { data, loading, error }] = useDeletePartyExtractionMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      partyExtractionId: // value for 'partyExtractionId'
 *   },
 * });
 */
export function useDeletePartyExtractionMutation(baseOptions?: Apollo.MutationHookOptions<DeletePartyExtractionMutation, DeletePartyExtractionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePartyExtractionMutation, DeletePartyExtractionMutationVariables>(DeletePartyExtractionDocument, options);
      }
export type DeletePartyExtractionMutationHookResult = ReturnType<typeof useDeletePartyExtractionMutation>;
export type DeletePartyExtractionMutationResult = Apollo.MutationResult<DeletePartyExtractionMutation>;
export type DeletePartyExtractionMutationOptions = Apollo.BaseMutationOptions<DeletePartyExtractionMutation, DeletePartyExtractionMutationVariables>;
export const DesignatePartyDocument = gql`
    mutation DesignateParty($partyId: String!, $legalEntityId: String!, $designation: PartyDesignation!) {
  designateParty(
    partyId: $partyId
    legalEntityId: $legalEntityId
    designation: $designation
  )
}
    `;
export type DesignatePartyMutationFn = Apollo.MutationFunction<DesignatePartyMutation, DesignatePartyMutationVariables>;

/**
 * __useDesignatePartyMutation__
 *
 * To run a mutation, you first call `useDesignatePartyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDesignatePartyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [designatePartyMutation, { data, loading, error }] = useDesignatePartyMutation({
 *   variables: {
 *      partyId: // value for 'partyId'
 *      legalEntityId: // value for 'legalEntityId'
 *      designation: // value for 'designation'
 *   },
 * });
 */
export function useDesignatePartyMutation(baseOptions?: Apollo.MutationHookOptions<DesignatePartyMutation, DesignatePartyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DesignatePartyMutation, DesignatePartyMutationVariables>(DesignatePartyDocument, options);
      }
export type DesignatePartyMutationHookResult = ReturnType<typeof useDesignatePartyMutation>;
export type DesignatePartyMutationResult = Apollo.MutationResult<DesignatePartyMutation>;
export type DesignatePartyMutationOptions = Apollo.BaseMutationOptions<DesignatePartyMutation, DesignatePartyMutationVariables>;
export const ResearchPartyDocument = gql`
    mutation ResearchParty($legalEntityId: String!, $partyId: String!, $partyName: String!) {
  researchParty(
    legalEntityId: $legalEntityId
    partyId: $partyId
    partyName: $partyName
  )
}
    `;
export type ResearchPartyMutationFn = Apollo.MutationFunction<ResearchPartyMutation, ResearchPartyMutationVariables>;

/**
 * __useResearchPartyMutation__
 *
 * To run a mutation, you first call `useResearchPartyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResearchPartyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [researchPartyMutation, { data, loading, error }] = useResearchPartyMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      partyId: // value for 'partyId'
 *      partyName: // value for 'partyName'
 *   },
 * });
 */
export function useResearchPartyMutation(baseOptions?: Apollo.MutationHookOptions<ResearchPartyMutation, ResearchPartyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResearchPartyMutation, ResearchPartyMutationVariables>(ResearchPartyDocument, options);
      }
export type ResearchPartyMutationHookResult = ReturnType<typeof useResearchPartyMutation>;
export type ResearchPartyMutationResult = Apollo.MutationResult<ResearchPartyMutation>;
export type ResearchPartyMutationOptions = Apollo.BaseMutationOptions<ResearchPartyMutation, ResearchPartyMutationVariables>;
export const UpdateGlobalPartyDocument = gql`
    mutation UpdateGlobalParty($partyId: String!, $fields: NewParty!) {
  updateGlobalParty(partyId: $partyId, fields: $fields)
}
    `;
export type UpdateGlobalPartyMutationFn = Apollo.MutationFunction<UpdateGlobalPartyMutation, UpdateGlobalPartyMutationVariables>;

/**
 * __useUpdateGlobalPartyMutation__
 *
 * To run a mutation, you first call `useUpdateGlobalPartyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGlobalPartyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGlobalPartyMutation, { data, loading, error }] = useUpdateGlobalPartyMutation({
 *   variables: {
 *      partyId: // value for 'partyId'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useUpdateGlobalPartyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGlobalPartyMutation, UpdateGlobalPartyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGlobalPartyMutation, UpdateGlobalPartyMutationVariables>(UpdateGlobalPartyDocument, options);
      }
export type UpdateGlobalPartyMutationHookResult = ReturnType<typeof useUpdateGlobalPartyMutation>;
export type UpdateGlobalPartyMutationResult = Apollo.MutationResult<UpdateGlobalPartyMutation>;
export type UpdateGlobalPartyMutationOptions = Apollo.BaseMutationOptions<UpdateGlobalPartyMutation, UpdateGlobalPartyMutationVariables>;
export const UpdatePartyDocument = gql`
    mutation UpdateParty($legalEntityId: String!, $partyId: String!, $details: NewParty!) {
  updateParty(legalEntityId: $legalEntityId, partyId: $partyId, details: $details)
}
    `;
export type UpdatePartyMutationFn = Apollo.MutationFunction<UpdatePartyMutation, UpdatePartyMutationVariables>;

/**
 * __useUpdatePartyMutation__
 *
 * To run a mutation, you first call `useUpdatePartyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartyMutation, { data, loading, error }] = useUpdatePartyMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      partyId: // value for 'partyId'
 *      details: // value for 'details'
 *   },
 * });
 */
export function useUpdatePartyMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePartyMutation, UpdatePartyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePartyMutation, UpdatePartyMutationVariables>(UpdatePartyDocument, options);
      }
export type UpdatePartyMutationHookResult = ReturnType<typeof useUpdatePartyMutation>;
export type UpdatePartyMutationResult = Apollo.MutationResult<UpdatePartyMutation>;
export type UpdatePartyMutationOptions = Apollo.BaseMutationOptions<UpdatePartyMutation, UpdatePartyMutationVariables>;
export const ListAgentPartiesDocument = gql`
    query ListAgentParties($legalEntityId: String!, $pagination: Pagination!) {
  listAgentParties(legalEntityId: $legalEntityId, pagination: $pagination) {
    ...PartyFields
  }
}
    ${PartyFieldsFragmentDoc}`;

/**
 * __useListAgentPartiesQuery__
 *
 * To run a query within a React component, call `useListAgentPartiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAgentPartiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAgentPartiesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useListAgentPartiesQuery(baseOptions: Apollo.QueryHookOptions<ListAgentPartiesQuery, ListAgentPartiesQueryVariables> & ({ variables: ListAgentPartiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAgentPartiesQuery, ListAgentPartiesQueryVariables>(ListAgentPartiesDocument, options);
      }
export function useListAgentPartiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAgentPartiesQuery, ListAgentPartiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAgentPartiesQuery, ListAgentPartiesQueryVariables>(ListAgentPartiesDocument, options);
        }
export function useListAgentPartiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAgentPartiesQuery, ListAgentPartiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAgentPartiesQuery, ListAgentPartiesQueryVariables>(ListAgentPartiesDocument, options);
        }
export type ListAgentPartiesQueryHookResult = ReturnType<typeof useListAgentPartiesQuery>;
export type ListAgentPartiesLazyQueryHookResult = ReturnType<typeof useListAgentPartiesLazyQuery>;
export type ListAgentPartiesSuspenseQueryHookResult = ReturnType<typeof useListAgentPartiesSuspenseQuery>;
export type ListAgentPartiesQueryResult = Apollo.QueryResult<ListAgentPartiesQuery, ListAgentPartiesQueryVariables>;
export const ListGlobalPartiesDocument = gql`
    query ListGlobalParties($filter: GlobalPartyFilter, $pagination: Pagination!, $order: GlobalPartySort) {
  listGlobalParties(filter: $filter, pagination: $pagination, order: $order) {
    ...AdminGlobalPartyFields
  }
}
    ${AdminGlobalPartyFieldsFragmentDoc}`;

/**
 * __useListGlobalPartiesQuery__
 *
 * To run a query within a React component, call `useListGlobalPartiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListGlobalPartiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListGlobalPartiesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListGlobalPartiesQuery(baseOptions: Apollo.QueryHookOptions<ListGlobalPartiesQuery, ListGlobalPartiesQueryVariables> & ({ variables: ListGlobalPartiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListGlobalPartiesQuery, ListGlobalPartiesQueryVariables>(ListGlobalPartiesDocument, options);
      }
export function useListGlobalPartiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListGlobalPartiesQuery, ListGlobalPartiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListGlobalPartiesQuery, ListGlobalPartiesQueryVariables>(ListGlobalPartiesDocument, options);
        }
export function useListGlobalPartiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListGlobalPartiesQuery, ListGlobalPartiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListGlobalPartiesQuery, ListGlobalPartiesQueryVariables>(ListGlobalPartiesDocument, options);
        }
export type ListGlobalPartiesQueryHookResult = ReturnType<typeof useListGlobalPartiesQuery>;
export type ListGlobalPartiesLazyQueryHookResult = ReturnType<typeof useListGlobalPartiesLazyQuery>;
export type ListGlobalPartiesSuspenseQueryHookResult = ReturnType<typeof useListGlobalPartiesSuspenseQuery>;
export type ListGlobalPartiesQueryResult = Apollo.QueryResult<ListGlobalPartiesQuery, ListGlobalPartiesQueryVariables>;
export const ListGlobalPartiesWithSummariesDocument = gql`
    query ListGlobalPartiesWithSummaries($filter: GlobalPartyFilter, $pagination: Pagination!, $order: GlobalPartySort) {
  listGlobalPartiesWithSummaries(
    filter: $filter
    pagination: $pagination
    order: $order
  ) {
    ...AdminGlobalPartyFields
  }
}
    ${AdminGlobalPartyFieldsFragmentDoc}`;

/**
 * __useListGlobalPartiesWithSummariesQuery__
 *
 * To run a query within a React component, call `useListGlobalPartiesWithSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListGlobalPartiesWithSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListGlobalPartiesWithSummariesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListGlobalPartiesWithSummariesQuery(baseOptions: Apollo.QueryHookOptions<ListGlobalPartiesWithSummariesQuery, ListGlobalPartiesWithSummariesQueryVariables> & ({ variables: ListGlobalPartiesWithSummariesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListGlobalPartiesWithSummariesQuery, ListGlobalPartiesWithSummariesQueryVariables>(ListGlobalPartiesWithSummariesDocument, options);
      }
export function useListGlobalPartiesWithSummariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListGlobalPartiesWithSummariesQuery, ListGlobalPartiesWithSummariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListGlobalPartiesWithSummariesQuery, ListGlobalPartiesWithSummariesQueryVariables>(ListGlobalPartiesWithSummariesDocument, options);
        }
export function useListGlobalPartiesWithSummariesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListGlobalPartiesWithSummariesQuery, ListGlobalPartiesWithSummariesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListGlobalPartiesWithSummariesQuery, ListGlobalPartiesWithSummariesQueryVariables>(ListGlobalPartiesWithSummariesDocument, options);
        }
export type ListGlobalPartiesWithSummariesQueryHookResult = ReturnType<typeof useListGlobalPartiesWithSummariesQuery>;
export type ListGlobalPartiesWithSummariesLazyQueryHookResult = ReturnType<typeof useListGlobalPartiesWithSummariesLazyQuery>;
export type ListGlobalPartiesWithSummariesSuspenseQueryHookResult = ReturnType<typeof useListGlobalPartiesWithSummariesSuspenseQuery>;
export type ListGlobalPartiesWithSummariesQueryResult = Apollo.QueryResult<ListGlobalPartiesWithSummariesQuery, ListGlobalPartiesWithSummariesQueryVariables>;
export const ListPartiesDocument = gql`
    query ListParties($legalEntityId: String!, $pagination: Pagination!, $viewType: ViewType!, $partyType: PartyType, $designation: PartyDesignation) {
  listParties(
    legalEntityId: $legalEntityId
    pagination: $pagination
    viewType: $viewType
    partyType: $partyType
    designation: $designation
  ) {
    ...AdminPartyFields
  }
}
    ${AdminPartyFieldsFragmentDoc}`;

/**
 * __useListPartiesQuery__
 *
 * To run a query within a React component, call `useListPartiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPartiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPartiesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      pagination: // value for 'pagination'
 *      viewType: // value for 'viewType'
 *      partyType: // value for 'partyType'
 *      designation: // value for 'designation'
 *   },
 * });
 */
export function useListPartiesQuery(baseOptions: Apollo.QueryHookOptions<ListPartiesQuery, ListPartiesQueryVariables> & ({ variables: ListPartiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPartiesQuery, ListPartiesQueryVariables>(ListPartiesDocument, options);
      }
export function useListPartiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPartiesQuery, ListPartiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPartiesQuery, ListPartiesQueryVariables>(ListPartiesDocument, options);
        }
export function useListPartiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPartiesQuery, ListPartiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListPartiesQuery, ListPartiesQueryVariables>(ListPartiesDocument, options);
        }
export type ListPartiesQueryHookResult = ReturnType<typeof useListPartiesQuery>;
export type ListPartiesLazyQueryHookResult = ReturnType<typeof useListPartiesLazyQuery>;
export type ListPartiesSuspenseQueryHookResult = ReturnType<typeof useListPartiesSuspenseQuery>;
export type ListPartiesQueryResult = Apollo.QueryResult<ListPartiesQuery, ListPartiesQueryVariables>;
export const ListPartyExtractionsDocument = gql`
    query ListPartyExtractions($legalEntityId: String!, $pagination: Pagination!) {
  listPartyExtractions(legalEntityId: $legalEntityId, pagination: $pagination) {
    legalEntityId
    partyExtractionId
    partyExtractionKey
    transactionFactId
    party {
      ...PartyFields
    }
  }
}
    ${PartyFieldsFragmentDoc}`;

/**
 * __useListPartyExtractionsQuery__
 *
 * To run a query within a React component, call `useListPartyExtractionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPartyExtractionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPartyExtractionsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useListPartyExtractionsQuery(baseOptions: Apollo.QueryHookOptions<ListPartyExtractionsQuery, ListPartyExtractionsQueryVariables> & ({ variables: ListPartyExtractionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPartyExtractionsQuery, ListPartyExtractionsQueryVariables>(ListPartyExtractionsDocument, options);
      }
export function useListPartyExtractionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPartyExtractionsQuery, ListPartyExtractionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPartyExtractionsQuery, ListPartyExtractionsQueryVariables>(ListPartyExtractionsDocument, options);
        }
export function useListPartyExtractionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPartyExtractionsQuery, ListPartyExtractionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListPartyExtractionsQuery, ListPartyExtractionsQueryVariables>(ListPartyExtractionsDocument, options);
        }
export type ListPartyExtractionsQueryHookResult = ReturnType<typeof useListPartyExtractionsQuery>;
export type ListPartyExtractionsLazyQueryHookResult = ReturnType<typeof useListPartyExtractionsLazyQuery>;
export type ListPartyExtractionsSuspenseQueryHookResult = ReturnType<typeof useListPartyExtractionsSuspenseQuery>;
export type ListPartyExtractionsQueryResult = Apollo.QueryResult<ListPartyExtractionsQuery, ListPartyExtractionsQueryVariables>;
export const ListPayrollPartiesDocument = gql`
    query ListPayrollParties($legalEntityId: String!) {
  listPayrollParties(legalEntityId: $legalEntityId) {
    ...PayrollProviderFields
  }
}
    ${PayrollProviderFieldsFragmentDoc}`;

/**
 * __useListPayrollPartiesQuery__
 *
 * To run a query within a React component, call `useListPayrollPartiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPayrollPartiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPayrollPartiesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListPayrollPartiesQuery(baseOptions: Apollo.QueryHookOptions<ListPayrollPartiesQuery, ListPayrollPartiesQueryVariables> & ({ variables: ListPayrollPartiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPayrollPartiesQuery, ListPayrollPartiesQueryVariables>(ListPayrollPartiesDocument, options);
      }
export function useListPayrollPartiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPayrollPartiesQuery, ListPayrollPartiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPayrollPartiesQuery, ListPayrollPartiesQueryVariables>(ListPayrollPartiesDocument, options);
        }
export function useListPayrollPartiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPayrollPartiesQuery, ListPayrollPartiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListPayrollPartiesQuery, ListPayrollPartiesQueryVariables>(ListPayrollPartiesDocument, options);
        }
export type ListPayrollPartiesQueryHookResult = ReturnType<typeof useListPayrollPartiesQuery>;
export type ListPayrollPartiesLazyQueryHookResult = ReturnType<typeof useListPayrollPartiesLazyQuery>;
export type ListPayrollPartiesSuspenseQueryHookResult = ReturnType<typeof useListPayrollPartiesSuspenseQuery>;
export type ListPayrollPartiesQueryResult = Apollo.QueryResult<ListPayrollPartiesQuery, ListPayrollPartiesQueryVariables>;
export const SetPaymentSettlementConfigDocument = gql`
    mutation SetPaymentSettlementConfig($legalEntityId: String!, $additionalPaymentSettlementDays: Int!) {
  setPaymentSettlementConfig(
    legalEntityId: $legalEntityId
    additionalPaymentSettlementDays: $additionalPaymentSettlementDays
  ) {
    legalEntityId
    additionalPaymentSettlementDays
  }
}
    `;
export type SetPaymentSettlementConfigMutationFn = Apollo.MutationFunction<SetPaymentSettlementConfigMutation, SetPaymentSettlementConfigMutationVariables>;

/**
 * __useSetPaymentSettlementConfigMutation__
 *
 * To run a mutation, you first call `useSetPaymentSettlementConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPaymentSettlementConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPaymentSettlementConfigMutation, { data, loading, error }] = useSetPaymentSettlementConfigMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      additionalPaymentSettlementDays: // value for 'additionalPaymentSettlementDays'
 *   },
 * });
 */
export function useSetPaymentSettlementConfigMutation(baseOptions?: Apollo.MutationHookOptions<SetPaymentSettlementConfigMutation, SetPaymentSettlementConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPaymentSettlementConfigMutation, SetPaymentSettlementConfigMutationVariables>(SetPaymentSettlementConfigDocument, options);
      }
export type SetPaymentSettlementConfigMutationHookResult = ReturnType<typeof useSetPaymentSettlementConfigMutation>;
export type SetPaymentSettlementConfigMutationResult = Apollo.MutationResult<SetPaymentSettlementConfigMutation>;
export type SetPaymentSettlementConfigMutationOptions = Apollo.BaseMutationOptions<SetPaymentSettlementConfigMutation, SetPaymentSettlementConfigMutationVariables>;
export const GetPaymentLifecycleJournalEntriesDocument = gql`
    query GetPaymentLifecycleJournalEntries($paymentIntentId: String, $paymentId: String, $payoutIntentId: String, $payoutId: String) {
  getPaymentLifecycleJournalEntries(
    paymentIntentId: $paymentIntentId
    paymentId: $paymentId
    payoutIntentId: $payoutIntentId
    payoutId: $payoutId
  ) {
    paymentIntentId
    payerLegalEntityId
    vendorLegalEntityId
    digitsLegalEntityId
    ownerType
    recipientType
    stages {
      stage
      entityId
      entityType
      journalEntries {
        journalEntryId
        chartOfAccountsId
        idempotenceKey
        commitTime
        ownerId
        ownerType
        tags {
          name
          value
        }
        categoryEntries {
          canonicalCategoryLabel
          categoryName
          accountingType
          entryType
          debitAmount {
            iso4217CurrencyCode
            currencyMultiplier
            amount
          }
          creditAmount {
            iso4217CurrencyCode
            currencyMultiplier
            amount
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPaymentLifecycleJournalEntriesQuery__
 *
 * To run a query within a React component, call `useGetPaymentLifecycleJournalEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentLifecycleJournalEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentLifecycleJournalEntriesQuery({
 *   variables: {
 *      paymentIntentId: // value for 'paymentIntentId'
 *      paymentId: // value for 'paymentId'
 *      payoutIntentId: // value for 'payoutIntentId'
 *      payoutId: // value for 'payoutId'
 *   },
 * });
 */
export function useGetPaymentLifecycleJournalEntriesQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentLifecycleJournalEntriesQuery, GetPaymentLifecycleJournalEntriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentLifecycleJournalEntriesQuery, GetPaymentLifecycleJournalEntriesQueryVariables>(GetPaymentLifecycleJournalEntriesDocument, options);
      }
export function useGetPaymentLifecycleJournalEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentLifecycleJournalEntriesQuery, GetPaymentLifecycleJournalEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentLifecycleJournalEntriesQuery, GetPaymentLifecycleJournalEntriesQueryVariables>(GetPaymentLifecycleJournalEntriesDocument, options);
        }
export function useGetPaymentLifecycleJournalEntriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentLifecycleJournalEntriesQuery, GetPaymentLifecycleJournalEntriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentLifecycleJournalEntriesQuery, GetPaymentLifecycleJournalEntriesQueryVariables>(GetPaymentLifecycleJournalEntriesDocument, options);
        }
export type GetPaymentLifecycleJournalEntriesQueryHookResult = ReturnType<typeof useGetPaymentLifecycleJournalEntriesQuery>;
export type GetPaymentLifecycleJournalEntriesLazyQueryHookResult = ReturnType<typeof useGetPaymentLifecycleJournalEntriesLazyQuery>;
export type GetPaymentLifecycleJournalEntriesSuspenseQueryHookResult = ReturnType<typeof useGetPaymentLifecycleJournalEntriesSuspenseQuery>;
export type GetPaymentLifecycleJournalEntriesQueryResult = Apollo.QueryResult<GetPaymentLifecycleJournalEntriesQuery, GetPaymentLifecycleJournalEntriesQueryVariables>;
export const GetPaymentPayoutChainDocument = gql`
    query GetPaymentPayoutChain($paymentId: String, $paymentIntentId: String, $payoutId: String, $payoutIntentId: String) {
  getPaymentPayoutChain(
    paymentId: $paymentId
    paymentIntentId: $paymentIntentId
    payoutId: $payoutId
    payoutIntentId: $payoutIntentId
  ) {
    paymentIntents {
      paymentIntentId
      ownerId
      ownerType
      paymentType
      externalPaymentSource
      referenceId
      referenceType
      recipientId
      recipientType
      recipientName
      totalAmount
      isoCurrencyCode
      currencyMultiplier
      createdAt
      states {
        paymentIntentStateId
        paymentIntentState
        createdAt
      }
    }
    payments {
      paymentId
      paymentIntentId
      ownerId
      ownerType
      paymentType
      externalPaymentSource
      externalPaymentId
      referenceId
      referenceType
      recipientId
      recipientType
      recipientName
      totalAmount
      isoCurrencyCode
      currencyMultiplier
      digitsTransactionId
      createdAt
      states {
        paymentStateId
        paymentState
        createdAt
      }
    }
    payouts {
      payoutIntentId
      payoutId
      ownerId
      ownerType
      payoutType
      externalSource
      externalPayoutId
      totalAmount
      isoCurrencyCode
      currencyMultiplier
      digitsTransactionId
      createdAt
      statuses {
        payoutStatus
        createdAt
      }
      linkedPaymentIds
    }
    payoutIntents {
      payoutIntentId
      ownerId
      ownerType
      payoutType
      totalAmount
      isoCurrencyCode
      currencyMultiplier
      directPaymentId
      createdAt
      states {
        payoutIntentStateId
        payoutIntentState
        createdAt
      }
    }
  }
}
    `;

/**
 * __useGetPaymentPayoutChainQuery__
 *
 * To run a query within a React component, call `useGetPaymentPayoutChainQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentPayoutChainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentPayoutChainQuery({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *      paymentIntentId: // value for 'paymentIntentId'
 *      payoutId: // value for 'payoutId'
 *      payoutIntentId: // value for 'payoutIntentId'
 *   },
 * });
 */
export function useGetPaymentPayoutChainQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentPayoutChainQuery, GetPaymentPayoutChainQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentPayoutChainQuery, GetPaymentPayoutChainQueryVariables>(GetPaymentPayoutChainDocument, options);
      }
export function useGetPaymentPayoutChainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentPayoutChainQuery, GetPaymentPayoutChainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentPayoutChainQuery, GetPaymentPayoutChainQueryVariables>(GetPaymentPayoutChainDocument, options);
        }
export function useGetPaymentPayoutChainSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentPayoutChainQuery, GetPaymentPayoutChainQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentPayoutChainQuery, GetPaymentPayoutChainQueryVariables>(GetPaymentPayoutChainDocument, options);
        }
export type GetPaymentPayoutChainQueryHookResult = ReturnType<typeof useGetPaymentPayoutChainQuery>;
export type GetPaymentPayoutChainLazyQueryHookResult = ReturnType<typeof useGetPaymentPayoutChainLazyQuery>;
export type GetPaymentPayoutChainSuspenseQueryHookResult = ReturnType<typeof useGetPaymentPayoutChainSuspenseQuery>;
export type GetPaymentPayoutChainQueryResult = Apollo.QueryResult<GetPaymentPayoutChainQuery, GetPaymentPayoutChainQueryVariables>;
export const GetPaymentSettlementConfigDocument = gql`
    query GetPaymentSettlementConfig($legalEntityId: String!) {
  getPaymentSettlementConfig(legalEntityId: $legalEntityId) {
    legalEntityId
    additionalPaymentSettlementDays
  }
}
    `;

/**
 * __useGetPaymentSettlementConfigQuery__
 *
 * To run a query within a React component, call `useGetPaymentSettlementConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentSettlementConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentSettlementConfigQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useGetPaymentSettlementConfigQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentSettlementConfigQuery, GetPaymentSettlementConfigQueryVariables> & ({ variables: GetPaymentSettlementConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentSettlementConfigQuery, GetPaymentSettlementConfigQueryVariables>(GetPaymentSettlementConfigDocument, options);
      }
export function useGetPaymentSettlementConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentSettlementConfigQuery, GetPaymentSettlementConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentSettlementConfigQuery, GetPaymentSettlementConfigQueryVariables>(GetPaymentSettlementConfigDocument, options);
        }
export function useGetPaymentSettlementConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentSettlementConfigQuery, GetPaymentSettlementConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentSettlementConfigQuery, GetPaymentSettlementConfigQueryVariables>(GetPaymentSettlementConfigDocument, options);
        }
export type GetPaymentSettlementConfigQueryHookResult = ReturnType<typeof useGetPaymentSettlementConfigQuery>;
export type GetPaymentSettlementConfigLazyQueryHookResult = ReturnType<typeof useGetPaymentSettlementConfigLazyQuery>;
export type GetPaymentSettlementConfigSuspenseQueryHookResult = ReturnType<typeof useGetPaymentSettlementConfigSuspenseQuery>;
export type GetPaymentSettlementConfigQueryResult = Apollo.QueryResult<GetPaymentSettlementConfigQuery, GetPaymentSettlementConfigQueryVariables>;
export const ListPaymentJournalEntriesByCoAAndTagValueDocument = gql`
    query ListPaymentJournalEntriesByCoAAndTagValue($chartOfAccountsId: String!, $tagValue: String!) {
  listPaymentJournalEntriesByCoAAndTagValue(
    chartOfAccountsId: $chartOfAccountsId
    tagValue: $tagValue
  ) {
    journalEntries {
      journalEntryId
      chartOfAccountsId
      idempotenceKey
      commitTime
      ownerId
      ownerType
      tags {
        name
        value
      }
      categoryEntries {
        canonicalCategoryLabel
        categoryName
        accountingType
        entryType
        debitAmount {
          iso4217CurrencyCode
          currencyMultiplier
          amount
        }
        creditAmount {
          iso4217CurrencyCode
          currencyMultiplier
          amount
        }
      }
    }
  }
}
    `;

/**
 * __useListPaymentJournalEntriesByCoAAndTagValueQuery__
 *
 * To run a query within a React component, call `useListPaymentJournalEntriesByCoAAndTagValueQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPaymentJournalEntriesByCoAAndTagValueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPaymentJournalEntriesByCoAAndTagValueQuery({
 *   variables: {
 *      chartOfAccountsId: // value for 'chartOfAccountsId'
 *      tagValue: // value for 'tagValue'
 *   },
 * });
 */
export function useListPaymentJournalEntriesByCoAAndTagValueQuery(baseOptions: Apollo.QueryHookOptions<ListPaymentJournalEntriesByCoAAndTagValueQuery, ListPaymentJournalEntriesByCoAAndTagValueQueryVariables> & ({ variables: ListPaymentJournalEntriesByCoAAndTagValueQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPaymentJournalEntriesByCoAAndTagValueQuery, ListPaymentJournalEntriesByCoAAndTagValueQueryVariables>(ListPaymentJournalEntriesByCoAAndTagValueDocument, options);
      }
export function useListPaymentJournalEntriesByCoAAndTagValueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPaymentJournalEntriesByCoAAndTagValueQuery, ListPaymentJournalEntriesByCoAAndTagValueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPaymentJournalEntriesByCoAAndTagValueQuery, ListPaymentJournalEntriesByCoAAndTagValueQueryVariables>(ListPaymentJournalEntriesByCoAAndTagValueDocument, options);
        }
export function useListPaymentJournalEntriesByCoAAndTagValueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPaymentJournalEntriesByCoAAndTagValueQuery, ListPaymentJournalEntriesByCoAAndTagValueQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListPaymentJournalEntriesByCoAAndTagValueQuery, ListPaymentJournalEntriesByCoAAndTagValueQueryVariables>(ListPaymentJournalEntriesByCoAAndTagValueDocument, options);
        }
export type ListPaymentJournalEntriesByCoAAndTagValueQueryHookResult = ReturnType<typeof useListPaymentJournalEntriesByCoAAndTagValueQuery>;
export type ListPaymentJournalEntriesByCoAAndTagValueLazyQueryHookResult = ReturnType<typeof useListPaymentJournalEntriesByCoAAndTagValueLazyQuery>;
export type ListPaymentJournalEntriesByCoAAndTagValueSuspenseQueryHookResult = ReturnType<typeof useListPaymentJournalEntriesByCoAAndTagValueSuspenseQuery>;
export type ListPaymentJournalEntriesByCoAAndTagValueQueryResult = Apollo.QueryResult<ListPaymentJournalEntriesByCoAAndTagValueQuery, ListPaymentJournalEntriesByCoAAndTagValueQueryVariables>;
export const ListPaymentsLedgerCategoryEntriesDocument = gql`
    query ListPaymentsLedgerCategoryEntries($ownerId: String!, $canonicalCategoryLabel: String!, $pagination: Pagination!) {
  listPaymentsLedgerCategoryEntries(
    ownerId: $ownerId
    canonicalCategoryLabel: $canonicalCategoryLabel
    pagination: $pagination
  ) {
    journalEntryId
    chartOfAccountsId
    idempotenceKey
    commitTime
    ownerId
    ownerType
    tags {
      name
      value
    }
    categoryEntries {
      canonicalCategoryLabel
      categoryName
      accountingType
      entryType
      debitAmount {
        iso4217CurrencyCode
        currencyMultiplier
        amount
      }
      creditAmount {
        iso4217CurrencyCode
        currencyMultiplier
        amount
      }
    }
  }
}
    `;

/**
 * __useListPaymentsLedgerCategoryEntriesQuery__
 *
 * To run a query within a React component, call `useListPaymentsLedgerCategoryEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPaymentsLedgerCategoryEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPaymentsLedgerCategoryEntriesQuery({
 *   variables: {
 *      ownerId: // value for 'ownerId'
 *      canonicalCategoryLabel: // value for 'canonicalCategoryLabel'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useListPaymentsLedgerCategoryEntriesQuery(baseOptions: Apollo.QueryHookOptions<ListPaymentsLedgerCategoryEntriesQuery, ListPaymentsLedgerCategoryEntriesQueryVariables> & ({ variables: ListPaymentsLedgerCategoryEntriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPaymentsLedgerCategoryEntriesQuery, ListPaymentsLedgerCategoryEntriesQueryVariables>(ListPaymentsLedgerCategoryEntriesDocument, options);
      }
export function useListPaymentsLedgerCategoryEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPaymentsLedgerCategoryEntriesQuery, ListPaymentsLedgerCategoryEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPaymentsLedgerCategoryEntriesQuery, ListPaymentsLedgerCategoryEntriesQueryVariables>(ListPaymentsLedgerCategoryEntriesDocument, options);
        }
export function useListPaymentsLedgerCategoryEntriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPaymentsLedgerCategoryEntriesQuery, ListPaymentsLedgerCategoryEntriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListPaymentsLedgerCategoryEntriesQuery, ListPaymentsLedgerCategoryEntriesQueryVariables>(ListPaymentsLedgerCategoryEntriesDocument, options);
        }
export type ListPaymentsLedgerCategoryEntriesQueryHookResult = ReturnType<typeof useListPaymentsLedgerCategoryEntriesQuery>;
export type ListPaymentsLedgerCategoryEntriesLazyQueryHookResult = ReturnType<typeof useListPaymentsLedgerCategoryEntriesLazyQuery>;
export type ListPaymentsLedgerCategoryEntriesSuspenseQueryHookResult = ReturnType<typeof useListPaymentsLedgerCategoryEntriesSuspenseQuery>;
export type ListPaymentsLedgerCategoryEntriesQueryResult = Apollo.QueryResult<ListPaymentsLedgerCategoryEntriesQuery, ListPaymentsLedgerCategoryEntriesQueryVariables>;
export const ReadPaymentsLedgerCoADocument = gql`
    query ReadPaymentsLedgerCoA($ownerId: String!) {
  readPaymentsLedgerCoA(ownerId: $ownerId) {
    chartOfAccountsId
    ownerId
    ownerType
    categories {
      categoryId
      canonicalCategoryLabel
      name
      description
      accountingType
      sumDebit {
        iso4217CurrencyCode
        currencyMultiplier
        amount
      }
      sumCredit {
        iso4217CurrencyCode
        currencyMultiplier
        amount
      }
      version
      nonNegativeBalanceInvariant
    }
  }
}
    `;

/**
 * __useReadPaymentsLedgerCoAQuery__
 *
 * To run a query within a React component, call `useReadPaymentsLedgerCoAQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadPaymentsLedgerCoAQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadPaymentsLedgerCoAQuery({
 *   variables: {
 *      ownerId: // value for 'ownerId'
 *   },
 * });
 */
export function useReadPaymentsLedgerCoAQuery(baseOptions: Apollo.QueryHookOptions<ReadPaymentsLedgerCoAQuery, ReadPaymentsLedgerCoAQueryVariables> & ({ variables: ReadPaymentsLedgerCoAQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadPaymentsLedgerCoAQuery, ReadPaymentsLedgerCoAQueryVariables>(ReadPaymentsLedgerCoADocument, options);
      }
export function useReadPaymentsLedgerCoALazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadPaymentsLedgerCoAQuery, ReadPaymentsLedgerCoAQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadPaymentsLedgerCoAQuery, ReadPaymentsLedgerCoAQueryVariables>(ReadPaymentsLedgerCoADocument, options);
        }
export function useReadPaymentsLedgerCoASuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadPaymentsLedgerCoAQuery, ReadPaymentsLedgerCoAQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadPaymentsLedgerCoAQuery, ReadPaymentsLedgerCoAQueryVariables>(ReadPaymentsLedgerCoADocument, options);
        }
export type ReadPaymentsLedgerCoAQueryHookResult = ReturnType<typeof useReadPaymentsLedgerCoAQuery>;
export type ReadPaymentsLedgerCoALazyQueryHookResult = ReturnType<typeof useReadPaymentsLedgerCoALazyQuery>;
export type ReadPaymentsLedgerCoASuspenseQueryHookResult = ReturnType<typeof useReadPaymentsLedgerCoASuspenseQuery>;
export type ReadPaymentsLedgerCoAQueryResult = Apollo.QueryResult<ReadPaymentsLedgerCoAQuery, ReadPaymentsLedgerCoAQueryVariables>;
export const UpdatePipelineDefinitionStatusDocument = gql`
    mutation UpdatePipelineDefinitionStatus($pipelineName: String!, $isActive: Boolean!, $reason: String) {
  updatePipelineDefinitionStatus(
    pipelineName: $pipelineName
    isActive: $isActive
    reason: $reason
  )
}
    `;
export type UpdatePipelineDefinitionStatusMutationFn = Apollo.MutationFunction<UpdatePipelineDefinitionStatusMutation, UpdatePipelineDefinitionStatusMutationVariables>;

/**
 * __useUpdatePipelineDefinitionStatusMutation__
 *
 * To run a mutation, you first call `useUpdatePipelineDefinitionStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePipelineDefinitionStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePipelineDefinitionStatusMutation, { data, loading, error }] = useUpdatePipelineDefinitionStatusMutation({
 *   variables: {
 *      pipelineName: // value for 'pipelineName'
 *      isActive: // value for 'isActive'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useUpdatePipelineDefinitionStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePipelineDefinitionStatusMutation, UpdatePipelineDefinitionStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePipelineDefinitionStatusMutation, UpdatePipelineDefinitionStatusMutationVariables>(UpdatePipelineDefinitionStatusDocument, options);
      }
export type UpdatePipelineDefinitionStatusMutationHookResult = ReturnType<typeof useUpdatePipelineDefinitionStatusMutation>;
export type UpdatePipelineDefinitionStatusMutationResult = Apollo.MutationResult<UpdatePipelineDefinitionStatusMutation>;
export type UpdatePipelineDefinitionStatusMutationOptions = Apollo.BaseMutationOptions<UpdatePipelineDefinitionStatusMutation, UpdatePipelineDefinitionStatusMutationVariables>;
export const ListPipelineDefinitionsDocument = gql`
    query ListPipelineDefinitions {
  listPipelineDefinitions {
    ...PipelineDefinitionFields
  }
}
    ${PipelineDefinitionFieldsFragmentDoc}`;

/**
 * __useListPipelineDefinitionsQuery__
 *
 * To run a query within a React component, call `useListPipelineDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPipelineDefinitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPipelineDefinitionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListPipelineDefinitionsQuery(baseOptions?: Apollo.QueryHookOptions<ListPipelineDefinitionsQuery, ListPipelineDefinitionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPipelineDefinitionsQuery, ListPipelineDefinitionsQueryVariables>(ListPipelineDefinitionsDocument, options);
      }
export function useListPipelineDefinitionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPipelineDefinitionsQuery, ListPipelineDefinitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPipelineDefinitionsQuery, ListPipelineDefinitionsQueryVariables>(ListPipelineDefinitionsDocument, options);
        }
export function useListPipelineDefinitionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPipelineDefinitionsQuery, ListPipelineDefinitionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListPipelineDefinitionsQuery, ListPipelineDefinitionsQueryVariables>(ListPipelineDefinitionsDocument, options);
        }
export type ListPipelineDefinitionsQueryHookResult = ReturnType<typeof useListPipelineDefinitionsQuery>;
export type ListPipelineDefinitionsLazyQueryHookResult = ReturnType<typeof useListPipelineDefinitionsLazyQuery>;
export type ListPipelineDefinitionsSuspenseQueryHookResult = ReturnType<typeof useListPipelineDefinitionsSuspenseQuery>;
export type ListPipelineDefinitionsQueryResult = Apollo.QueryResult<ListPipelineDefinitionsQuery, ListPipelineDefinitionsQueryVariables>;
export const DeletePrefixMappingDocument = gql`
    mutation DeletePrefixMapping($prefix: String!, $partyId: String!) {
  deletePrefixMapping(prefix: $prefix, partyId: $partyId)
}
    `;
export type DeletePrefixMappingMutationFn = Apollo.MutationFunction<DeletePrefixMappingMutation, DeletePrefixMappingMutationVariables>;

/**
 * __useDeletePrefixMappingMutation__
 *
 * To run a mutation, you first call `useDeletePrefixMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePrefixMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePrefixMappingMutation, { data, loading, error }] = useDeletePrefixMappingMutation({
 *   variables: {
 *      prefix: // value for 'prefix'
 *      partyId: // value for 'partyId'
 *   },
 * });
 */
export function useDeletePrefixMappingMutation(baseOptions?: Apollo.MutationHookOptions<DeletePrefixMappingMutation, DeletePrefixMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePrefixMappingMutation, DeletePrefixMappingMutationVariables>(DeletePrefixMappingDocument, options);
      }
export type DeletePrefixMappingMutationHookResult = ReturnType<typeof useDeletePrefixMappingMutation>;
export type DeletePrefixMappingMutationResult = Apollo.MutationResult<DeletePrefixMappingMutation>;
export type DeletePrefixMappingMutationOptions = Apollo.BaseMutationOptions<DeletePrefixMappingMutation, DeletePrefixMappingMutationVariables>;
export const IgnorePrefixDocument = gql`
    mutation IgnorePrefix($prefix: String!) {
  ignorePrefix(prefix: $prefix)
}
    `;
export type IgnorePrefixMutationFn = Apollo.MutationFunction<IgnorePrefixMutation, IgnorePrefixMutationVariables>;

/**
 * __useIgnorePrefixMutation__
 *
 * To run a mutation, you first call `useIgnorePrefixMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIgnorePrefixMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ignorePrefixMutation, { data, loading, error }] = useIgnorePrefixMutation({
 *   variables: {
 *      prefix: // value for 'prefix'
 *   },
 * });
 */
export function useIgnorePrefixMutation(baseOptions?: Apollo.MutationHookOptions<IgnorePrefixMutation, IgnorePrefixMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IgnorePrefixMutation, IgnorePrefixMutationVariables>(IgnorePrefixDocument, options);
      }
export type IgnorePrefixMutationHookResult = ReturnType<typeof useIgnorePrefixMutation>;
export type IgnorePrefixMutationResult = Apollo.MutationResult<IgnorePrefixMutation>;
export type IgnorePrefixMutationOptions = Apollo.BaseMutationOptions<IgnorePrefixMutation, IgnorePrefixMutationVariables>;
export const UnignorePrefixDocument = gql`
    mutation UnignorePrefix($prefix: String!) {
  unignorePrefix(prefix: $prefix)
}
    `;
export type UnignorePrefixMutationFn = Apollo.MutationFunction<UnignorePrefixMutation, UnignorePrefixMutationVariables>;

/**
 * __useUnignorePrefixMutation__
 *
 * To run a mutation, you first call `useUnignorePrefixMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnignorePrefixMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unignorePrefixMutation, { data, loading, error }] = useUnignorePrefixMutation({
 *   variables: {
 *      prefix: // value for 'prefix'
 *   },
 * });
 */
export function useUnignorePrefixMutation(baseOptions?: Apollo.MutationHookOptions<UnignorePrefixMutation, UnignorePrefixMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnignorePrefixMutation, UnignorePrefixMutationVariables>(UnignorePrefixDocument, options);
      }
export type UnignorePrefixMutationHookResult = ReturnType<typeof useUnignorePrefixMutation>;
export type UnignorePrefixMutationResult = Apollo.MutationResult<UnignorePrefixMutation>;
export type UnignorePrefixMutationOptions = Apollo.BaseMutationOptions<UnignorePrefixMutation, UnignorePrefixMutationVariables>;
export const ListClusteredPrefixesDocument = gql`
    query ListClusteredPrefixes($legalEntityId: String) {
  listClusteredPrefixes(legalEntityId: $legalEntityId) {
    ...ClusteredPrefixFields
  }
}
    ${ClusteredPrefixFieldsFragmentDoc}`;

/**
 * __useListClusteredPrefixesQuery__
 *
 * To run a query within a React component, call `useListClusteredPrefixesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListClusteredPrefixesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListClusteredPrefixesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListClusteredPrefixesQuery(baseOptions?: Apollo.QueryHookOptions<ListClusteredPrefixesQuery, ListClusteredPrefixesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListClusteredPrefixesQuery, ListClusteredPrefixesQueryVariables>(ListClusteredPrefixesDocument, options);
      }
export function useListClusteredPrefixesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListClusteredPrefixesQuery, ListClusteredPrefixesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListClusteredPrefixesQuery, ListClusteredPrefixesQueryVariables>(ListClusteredPrefixesDocument, options);
        }
export function useListClusteredPrefixesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListClusteredPrefixesQuery, ListClusteredPrefixesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListClusteredPrefixesQuery, ListClusteredPrefixesQueryVariables>(ListClusteredPrefixesDocument, options);
        }
export type ListClusteredPrefixesQueryHookResult = ReturnType<typeof useListClusteredPrefixesQuery>;
export type ListClusteredPrefixesLazyQueryHookResult = ReturnType<typeof useListClusteredPrefixesLazyQuery>;
export type ListClusteredPrefixesSuspenseQueryHookResult = ReturnType<typeof useListClusteredPrefixesSuspenseQuery>;
export type ListClusteredPrefixesQueryResult = Apollo.QueryResult<ListClusteredPrefixesQuery, ListClusteredPrefixesQueryVariables>;
export const ListIgnoredPrefixesDocument = gql`
    query ListIgnoredPrefixes {
  listIgnoredPrefixes
}
    `;

/**
 * __useListIgnoredPrefixesQuery__
 *
 * To run a query within a React component, call `useListIgnoredPrefixesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListIgnoredPrefixesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListIgnoredPrefixesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListIgnoredPrefixesQuery(baseOptions?: Apollo.QueryHookOptions<ListIgnoredPrefixesQuery, ListIgnoredPrefixesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListIgnoredPrefixesQuery, ListIgnoredPrefixesQueryVariables>(ListIgnoredPrefixesDocument, options);
      }
export function useListIgnoredPrefixesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListIgnoredPrefixesQuery, ListIgnoredPrefixesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListIgnoredPrefixesQuery, ListIgnoredPrefixesQueryVariables>(ListIgnoredPrefixesDocument, options);
        }
export function useListIgnoredPrefixesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListIgnoredPrefixesQuery, ListIgnoredPrefixesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListIgnoredPrefixesQuery, ListIgnoredPrefixesQueryVariables>(ListIgnoredPrefixesDocument, options);
        }
export type ListIgnoredPrefixesQueryHookResult = ReturnType<typeof useListIgnoredPrefixesQuery>;
export type ListIgnoredPrefixesLazyQueryHookResult = ReturnType<typeof useListIgnoredPrefixesLazyQuery>;
export type ListIgnoredPrefixesSuspenseQueryHookResult = ReturnType<typeof useListIgnoredPrefixesSuspenseQuery>;
export type ListIgnoredPrefixesQueryResult = Apollo.QueryResult<ListIgnoredPrefixesQuery, ListIgnoredPrefixesQueryVariables>;
export const ListPrefixMappingsDocument = gql`
    query ListPrefixMappings($filter: PrefixFilter!) {
  listPrefixMappings(filter: $filter) {
    ...PrefixMappingSummaryFields
  }
}
    ${PrefixMappingSummaryFieldsFragmentDoc}`;

/**
 * __useListPrefixMappingsQuery__
 *
 * To run a query within a React component, call `useListPrefixMappingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPrefixMappingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPrefixMappingsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListPrefixMappingsQuery(baseOptions: Apollo.QueryHookOptions<ListPrefixMappingsQuery, ListPrefixMappingsQueryVariables> & ({ variables: ListPrefixMappingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPrefixMappingsQuery, ListPrefixMappingsQueryVariables>(ListPrefixMappingsDocument, options);
      }
export function useListPrefixMappingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPrefixMappingsQuery, ListPrefixMappingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPrefixMappingsQuery, ListPrefixMappingsQueryVariables>(ListPrefixMappingsDocument, options);
        }
export function useListPrefixMappingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPrefixMappingsQuery, ListPrefixMappingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListPrefixMappingsQuery, ListPrefixMappingsQueryVariables>(ListPrefixMappingsDocument, options);
        }
export type ListPrefixMappingsQueryHookResult = ReturnType<typeof useListPrefixMappingsQuery>;
export type ListPrefixMappingsLazyQueryHookResult = ReturnType<typeof useListPrefixMappingsLazyQuery>;
export type ListPrefixMappingsSuspenseQueryHookResult = ReturnType<typeof useListPrefixMappingsSuspenseQuery>;
export type ListPrefixMappingsQueryResult = Apollo.QueryResult<ListPrefixMappingsQuery, ListPrefixMappingsQueryVariables>;
export const ListSanitizedDescriptionsDocument = gql`
    query ListSanitizedDescriptions($prefix: String!) {
  listSanitizedDescriptions(prefix: $prefix) {
    ...SanitizedDescriptionFields
  }
}
    ${SanitizedDescriptionFieldsFragmentDoc}`;

/**
 * __useListSanitizedDescriptionsQuery__
 *
 * To run a query within a React component, call `useListSanitizedDescriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSanitizedDescriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSanitizedDescriptionsQuery({
 *   variables: {
 *      prefix: // value for 'prefix'
 *   },
 * });
 */
export function useListSanitizedDescriptionsQuery(baseOptions: Apollo.QueryHookOptions<ListSanitizedDescriptionsQuery, ListSanitizedDescriptionsQueryVariables> & ({ variables: ListSanitizedDescriptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSanitizedDescriptionsQuery, ListSanitizedDescriptionsQueryVariables>(ListSanitizedDescriptionsDocument, options);
      }
export function useListSanitizedDescriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSanitizedDescriptionsQuery, ListSanitizedDescriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSanitizedDescriptionsQuery, ListSanitizedDescriptionsQueryVariables>(ListSanitizedDescriptionsDocument, options);
        }
export function useListSanitizedDescriptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListSanitizedDescriptionsQuery, ListSanitizedDescriptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListSanitizedDescriptionsQuery, ListSanitizedDescriptionsQueryVariables>(ListSanitizedDescriptionsDocument, options);
        }
export type ListSanitizedDescriptionsQueryHookResult = ReturnType<typeof useListSanitizedDescriptionsQuery>;
export type ListSanitizedDescriptionsLazyQueryHookResult = ReturnType<typeof useListSanitizedDescriptionsLazyQuery>;
export type ListSanitizedDescriptionsSuspenseQueryHookResult = ReturnType<typeof useListSanitizedDescriptionsSuspenseQuery>;
export type ListSanitizedDescriptionsQueryResult = Apollo.QueryResult<ListSanitizedDescriptionsQuery, ListSanitizedDescriptionsQueryVariables>;
export const ListReconciliationAccountsDocument = gql`
    query ListReconciliationAccounts($legalEntityId: String!, $reconciliationStates: [ReconciliationState!]!) {
  listReconciliationAccounts(
    legalEntityId: $legalEntityId
    reconciliationStates: $reconciliationStates
  ) {
    ...EntityCategoryFields
  }
}
    ${EntityCategoryFieldsFragmentDoc}`;

/**
 * __useListReconciliationAccountsQuery__
 *
 * To run a query within a React component, call `useListReconciliationAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListReconciliationAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListReconciliationAccountsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      reconciliationStates: // value for 'reconciliationStates'
 *   },
 * });
 */
export function useListReconciliationAccountsQuery(baseOptions: Apollo.QueryHookOptions<ListReconciliationAccountsQuery, ListReconciliationAccountsQueryVariables> & ({ variables: ListReconciliationAccountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListReconciliationAccountsQuery, ListReconciliationAccountsQueryVariables>(ListReconciliationAccountsDocument, options);
      }
export function useListReconciliationAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListReconciliationAccountsQuery, ListReconciliationAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListReconciliationAccountsQuery, ListReconciliationAccountsQueryVariables>(ListReconciliationAccountsDocument, options);
        }
export function useListReconciliationAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListReconciliationAccountsQuery, ListReconciliationAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListReconciliationAccountsQuery, ListReconciliationAccountsQueryVariables>(ListReconciliationAccountsDocument, options);
        }
export type ListReconciliationAccountsQueryHookResult = ReturnType<typeof useListReconciliationAccountsQuery>;
export type ListReconciliationAccountsLazyQueryHookResult = ReturnType<typeof useListReconciliationAccountsLazyQuery>;
export type ListReconciliationAccountsSuspenseQueryHookResult = ReturnType<typeof useListReconciliationAccountsSuspenseQuery>;
export type ListReconciliationAccountsQueryResult = Apollo.QueryResult<ListReconciliationAccountsQuery, ListReconciliationAccountsQueryVariables>;
export const ReadReconciliationDiffsDocument = gql`
    query ReadReconciliationDiffs($legalEntityId: String!, $accountId: String!) {
  readReconciliationDiffs(legalEntityId: $legalEntityId, accountId: $accountId) {
    ...ReconciliationDiffFields
  }
}
    ${ReconciliationDiffFieldsFragmentDoc}`;

/**
 * __useReadReconciliationDiffsQuery__
 *
 * To run a query within a React component, call `useReadReconciliationDiffsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadReconciliationDiffsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadReconciliationDiffsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useReadReconciliationDiffsQuery(baseOptions: Apollo.QueryHookOptions<ReadReconciliationDiffsQuery, ReadReconciliationDiffsQueryVariables> & ({ variables: ReadReconciliationDiffsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadReconciliationDiffsQuery, ReadReconciliationDiffsQueryVariables>(ReadReconciliationDiffsDocument, options);
      }
export function useReadReconciliationDiffsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadReconciliationDiffsQuery, ReadReconciliationDiffsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadReconciliationDiffsQuery, ReadReconciliationDiffsQueryVariables>(ReadReconciliationDiffsDocument, options);
        }
export function useReadReconciliationDiffsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadReconciliationDiffsQuery, ReadReconciliationDiffsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadReconciliationDiffsQuery, ReadReconciliationDiffsQueryVariables>(ReadReconciliationDiffsDocument, options);
        }
export type ReadReconciliationDiffsQueryHookResult = ReturnType<typeof useReadReconciliationDiffsQuery>;
export type ReadReconciliationDiffsLazyQueryHookResult = ReturnType<typeof useReadReconciliationDiffsLazyQuery>;
export type ReadReconciliationDiffsSuspenseQueryHookResult = ReturnType<typeof useReadReconciliationDiffsSuspenseQuery>;
export type ReadReconciliationDiffsQueryResult = Apollo.QueryResult<ReadReconciliationDiffsQuery, ReadReconciliationDiffsQueryVariables>;
export const DeleteReportPackageDocument = gql`
    mutation DeleteReportPackage($packageId: String!, $legalEntityId: String!) {
  deleteReportPackage(packageId: $packageId, legalEntityId: $legalEntityId)
}
    `;
export type DeleteReportPackageMutationFn = Apollo.MutationFunction<DeleteReportPackageMutation, DeleteReportPackageMutationVariables>;

/**
 * __useDeleteReportPackageMutation__
 *
 * To run a mutation, you first call `useDeleteReportPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportPackageMutation, { data, loading, error }] = useDeleteReportPackageMutation({
 *   variables: {
 *      packageId: // value for 'packageId'
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useDeleteReportPackageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReportPackageMutation, DeleteReportPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReportPackageMutation, DeleteReportPackageMutationVariables>(DeleteReportPackageDocument, options);
      }
export type DeleteReportPackageMutationHookResult = ReturnType<typeof useDeleteReportPackageMutation>;
export type DeleteReportPackageMutationResult = Apollo.MutationResult<DeleteReportPackageMutation>;
export type DeleteReportPackageMutationOptions = Apollo.BaseMutationOptions<DeleteReportPackageMutation, DeleteReportPackageMutationVariables>;
export const TriggerReportValidationDocument = gql`
    mutation TriggerReportValidation($legalEntityIds: [String!]!, $period: PeriodInput!) {
  triggerReportValidation(legalEntityIds: $legalEntityIds, period: $period)
}
    `;
export type TriggerReportValidationMutationFn = Apollo.MutationFunction<TriggerReportValidationMutation, TriggerReportValidationMutationVariables>;

/**
 * __useTriggerReportValidationMutation__
 *
 * To run a mutation, you first call `useTriggerReportValidationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerReportValidationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerReportValidationMutation, { data, loading, error }] = useTriggerReportValidationMutation({
 *   variables: {
 *      legalEntityIds: // value for 'legalEntityIds'
 *      period: // value for 'period'
 *   },
 * });
 */
export function useTriggerReportValidationMutation(baseOptions?: Apollo.MutationHookOptions<TriggerReportValidationMutation, TriggerReportValidationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerReportValidationMutation, TriggerReportValidationMutationVariables>(TriggerReportValidationDocument, options);
      }
export type TriggerReportValidationMutationHookResult = ReturnType<typeof useTriggerReportValidationMutation>;
export type TriggerReportValidationMutationResult = Apollo.MutationResult<TriggerReportValidationMutation>;
export type TriggerReportValidationMutationOptions = Apollo.BaseMutationOptions<TriggerReportValidationMutation, TriggerReportValidationMutationVariables>;
export const ListReportPackagesDocument = gql`
    query ListReportPackages($legalEntityId: String!, $interval: Interval!, $intervalCount: Int, $year: Int!, $index: Int!, $paginationLimit: Int!, $paginationOffset: Int!) {
  listReportPackages(
    legalEntityId: $legalEntityId
    origin: {interval: $interval, year: $year, index: $index, intervalCount: $intervalCount}
    pagination: {limit: $paginationLimit, offset: $paginationOffset}
  ) {
    ...AdminReportPackageMetadataFields
  }
}
    ${AdminReportPackageMetadataFieldsFragmentDoc}`;

/**
 * __useListReportPackagesQuery__
 *
 * To run a query within a React component, call `useListReportPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListReportPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListReportPackagesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      interval: // value for 'interval'
 *      intervalCount: // value for 'intervalCount'
 *      year: // value for 'year'
 *      index: // value for 'index'
 *      paginationLimit: // value for 'paginationLimit'
 *      paginationOffset: // value for 'paginationOffset'
 *   },
 * });
 */
export function useListReportPackagesQuery(baseOptions: Apollo.QueryHookOptions<ListReportPackagesQuery, ListReportPackagesQueryVariables> & ({ variables: ListReportPackagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListReportPackagesQuery, ListReportPackagesQueryVariables>(ListReportPackagesDocument, options);
      }
export function useListReportPackagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListReportPackagesQuery, ListReportPackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListReportPackagesQuery, ListReportPackagesQueryVariables>(ListReportPackagesDocument, options);
        }
export function useListReportPackagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListReportPackagesQuery, ListReportPackagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListReportPackagesQuery, ListReportPackagesQueryVariables>(ListReportPackagesDocument, options);
        }
export type ListReportPackagesQueryHookResult = ReturnType<typeof useListReportPackagesQuery>;
export type ListReportPackagesLazyQueryHookResult = ReturnType<typeof useListReportPackagesLazyQuery>;
export type ListReportPackagesSuspenseQueryHookResult = ReturnType<typeof useListReportPackagesSuspenseQuery>;
export type ListReportPackagesQueryResult = Apollo.QueryResult<ListReportPackagesQuery, ListReportPackagesQueryVariables>;
export const ReadReportValidationArchiveDocument = gql`
    query ReadReportValidationArchive($legalEntityId: String!, $reportId: String!, $versionId: String!) {
  readReportValidationArchive(
    legalEntityId: $legalEntityId
    reportId: $reportId
    versionId: $versionId
  ) {
    quickbooks
    digits
    avs
  }
}
    `;

/**
 * __useReadReportValidationArchiveQuery__
 *
 * To run a query within a React component, call `useReadReportValidationArchiveQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadReportValidationArchiveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadReportValidationArchiveQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      reportId: // value for 'reportId'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useReadReportValidationArchiveQuery(baseOptions: Apollo.QueryHookOptions<ReadReportValidationArchiveQuery, ReadReportValidationArchiveQueryVariables> & ({ variables: ReadReportValidationArchiveQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadReportValidationArchiveQuery, ReadReportValidationArchiveQueryVariables>(ReadReportValidationArchiveDocument, options);
      }
export function useReadReportValidationArchiveLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadReportValidationArchiveQuery, ReadReportValidationArchiveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadReportValidationArchiveQuery, ReadReportValidationArchiveQueryVariables>(ReadReportValidationArchiveDocument, options);
        }
export function useReadReportValidationArchiveSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadReportValidationArchiveQuery, ReadReportValidationArchiveQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadReportValidationArchiveQuery, ReadReportValidationArchiveQueryVariables>(ReadReportValidationArchiveDocument, options);
        }
export type ReadReportValidationArchiveQueryHookResult = ReturnType<typeof useReadReportValidationArchiveQuery>;
export type ReadReportValidationArchiveLazyQueryHookResult = ReturnType<typeof useReadReportValidationArchiveLazyQuery>;
export type ReadReportValidationArchiveSuspenseQueryHookResult = ReturnType<typeof useReadReportValidationArchiveSuspenseQuery>;
export type ReadReportValidationArchiveQueryResult = Apollo.QueryResult<ReadReportValidationArchiveQuery, ReadReportValidationArchiveQueryVariables>;
export const UpdateEmployeeRoleDocument = gql`
    mutation UpdateEmployeeRole($organizationId: String!, $employeeId: String!, $role: String!, $defaultEntityRole: String!) {
  updateEmployeeRole(
    organizationId: $organizationId
    employeeId: $employeeId
    role: $role
    defaultEntityRole: $defaultEntityRole
  )
}
    `;
export type UpdateEmployeeRoleMutationFn = Apollo.MutationFunction<UpdateEmployeeRoleMutation, UpdateEmployeeRoleMutationVariables>;

/**
 * __useUpdateEmployeeRoleMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeRoleMutation, { data, loading, error }] = useUpdateEmployeeRoleMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      employeeId: // value for 'employeeId'
 *      role: // value for 'role'
 *      defaultEntityRole: // value for 'defaultEntityRole'
 *   },
 * });
 */
export function useUpdateEmployeeRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeRoleMutation, UpdateEmployeeRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeeRoleMutation, UpdateEmployeeRoleMutationVariables>(UpdateEmployeeRoleDocument, options);
      }
export type UpdateEmployeeRoleMutationHookResult = ReturnType<typeof useUpdateEmployeeRoleMutation>;
export type UpdateEmployeeRoleMutationResult = Apollo.MutationResult<UpdateEmployeeRoleMutation>;
export type UpdateEmployeeRoleMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeRoleMutation, UpdateEmployeeRoleMutationVariables>;
export const ListAdminScheduleCategoryHintCatalogDocument = gql`
    query ListAdminScheduleCategoryHintCatalog {
  listAdminScheduleCategoryHintCatalog {
    hint
    names
    type
    subtype
    strictSubtype
    excludeNames
    resolved
  }
}
    `;

/**
 * __useListAdminScheduleCategoryHintCatalogQuery__
 *
 * To run a query within a React component, call `useListAdminScheduleCategoryHintCatalogQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAdminScheduleCategoryHintCatalogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAdminScheduleCategoryHintCatalogQuery({
 *   variables: {
 *   },
 * });
 */
export function useListAdminScheduleCategoryHintCatalogQuery(baseOptions?: Apollo.QueryHookOptions<ListAdminScheduleCategoryHintCatalogQuery, ListAdminScheduleCategoryHintCatalogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAdminScheduleCategoryHintCatalogQuery, ListAdminScheduleCategoryHintCatalogQueryVariables>(ListAdminScheduleCategoryHintCatalogDocument, options);
      }
export function useListAdminScheduleCategoryHintCatalogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAdminScheduleCategoryHintCatalogQuery, ListAdminScheduleCategoryHintCatalogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAdminScheduleCategoryHintCatalogQuery, ListAdminScheduleCategoryHintCatalogQueryVariables>(ListAdminScheduleCategoryHintCatalogDocument, options);
        }
export function useListAdminScheduleCategoryHintCatalogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAdminScheduleCategoryHintCatalogQuery, ListAdminScheduleCategoryHintCatalogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAdminScheduleCategoryHintCatalogQuery, ListAdminScheduleCategoryHintCatalogQueryVariables>(ListAdminScheduleCategoryHintCatalogDocument, options);
        }
export type ListAdminScheduleCategoryHintCatalogQueryHookResult = ReturnType<typeof useListAdminScheduleCategoryHintCatalogQuery>;
export type ListAdminScheduleCategoryHintCatalogLazyQueryHookResult = ReturnType<typeof useListAdminScheduleCategoryHintCatalogLazyQuery>;
export type ListAdminScheduleCategoryHintCatalogSuspenseQueryHookResult = ReturnType<typeof useListAdminScheduleCategoryHintCatalogSuspenseQuery>;
export type ListAdminScheduleCategoryHintCatalogQueryResult = Apollo.QueryResult<ListAdminScheduleCategoryHintCatalogQuery, ListAdminScheduleCategoryHintCatalogQueryVariables>;
export const ListAdminScheduleCategoryHintsDocument = gql`
    query ListAdminScheduleCategoryHints($organizationId: String!, $specializationId: String!) {
  listAdminScheduleCategoryHints(
    organizationId: $organizationId
    specializationId: $specializationId
  ) {
    eventTemplateId
    eventDisplayName
    variableTemplateId
    variableDisplayName
    hint {
      hint
      names
      type
      subtype
      strictSubtype
      excludeNames
      resolved
    }
  }
}
    `;

/**
 * __useListAdminScheduleCategoryHintsQuery__
 *
 * To run a query within a React component, call `useListAdminScheduleCategoryHintsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAdminScheduleCategoryHintsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAdminScheduleCategoryHintsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      specializationId: // value for 'specializationId'
 *   },
 * });
 */
export function useListAdminScheduleCategoryHintsQuery(baseOptions: Apollo.QueryHookOptions<ListAdminScheduleCategoryHintsQuery, ListAdminScheduleCategoryHintsQueryVariables> & ({ variables: ListAdminScheduleCategoryHintsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAdminScheduleCategoryHintsQuery, ListAdminScheduleCategoryHintsQueryVariables>(ListAdminScheduleCategoryHintsDocument, options);
      }
export function useListAdminScheduleCategoryHintsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAdminScheduleCategoryHintsQuery, ListAdminScheduleCategoryHintsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAdminScheduleCategoryHintsQuery, ListAdminScheduleCategoryHintsQueryVariables>(ListAdminScheduleCategoryHintsDocument, options);
        }
export function useListAdminScheduleCategoryHintsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAdminScheduleCategoryHintsQuery, ListAdminScheduleCategoryHintsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAdminScheduleCategoryHintsQuery, ListAdminScheduleCategoryHintsQueryVariables>(ListAdminScheduleCategoryHintsDocument, options);
        }
export type ListAdminScheduleCategoryHintsQueryHookResult = ReturnType<typeof useListAdminScheduleCategoryHintsQuery>;
export type ListAdminScheduleCategoryHintsLazyQueryHookResult = ReturnType<typeof useListAdminScheduleCategoryHintsLazyQuery>;
export type ListAdminScheduleCategoryHintsSuspenseQueryHookResult = ReturnType<typeof useListAdminScheduleCategoryHintsSuspenseQuery>;
export type ListAdminScheduleCategoryHintsQueryResult = Apollo.QueryResult<ListAdminScheduleCategoryHintsQuery, ListAdminScheduleCategoryHintsQueryVariables>;
export const ListAdminScheduleSpecializationsDocument = gql`
    query ListAdminScheduleSpecializations($organizationId: String!, $scheduleTemplateId: String!) {
  listAdminScheduleSpecializations(
    organizationId: $organizationId
    scheduleTemplateId: $scheduleTemplateId
  ) {
    ...AdminScheduleSpecializationFields
  }
}
    ${AdminScheduleSpecializationFieldsFragmentDoc}`;

/**
 * __useListAdminScheduleSpecializationsQuery__
 *
 * To run a query within a React component, call `useListAdminScheduleSpecializationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAdminScheduleSpecializationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAdminScheduleSpecializationsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      scheduleTemplateId: // value for 'scheduleTemplateId'
 *   },
 * });
 */
export function useListAdminScheduleSpecializationsQuery(baseOptions: Apollo.QueryHookOptions<ListAdminScheduleSpecializationsQuery, ListAdminScheduleSpecializationsQueryVariables> & ({ variables: ListAdminScheduleSpecializationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAdminScheduleSpecializationsQuery, ListAdminScheduleSpecializationsQueryVariables>(ListAdminScheduleSpecializationsDocument, options);
      }
export function useListAdminScheduleSpecializationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAdminScheduleSpecializationsQuery, ListAdminScheduleSpecializationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAdminScheduleSpecializationsQuery, ListAdminScheduleSpecializationsQueryVariables>(ListAdminScheduleSpecializationsDocument, options);
        }
export function useListAdminScheduleSpecializationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAdminScheduleSpecializationsQuery, ListAdminScheduleSpecializationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAdminScheduleSpecializationsQuery, ListAdminScheduleSpecializationsQueryVariables>(ListAdminScheduleSpecializationsDocument, options);
        }
export type ListAdminScheduleSpecializationsQueryHookResult = ReturnType<typeof useListAdminScheduleSpecializationsQuery>;
export type ListAdminScheduleSpecializationsLazyQueryHookResult = ReturnType<typeof useListAdminScheduleSpecializationsLazyQuery>;
export type ListAdminScheduleSpecializationsSuspenseQueryHookResult = ReturnType<typeof useListAdminScheduleSpecializationsSuspenseQuery>;
export type ListAdminScheduleSpecializationsQueryResult = Apollo.QueryResult<ListAdminScheduleSpecializationsQuery, ListAdminScheduleSpecializationsQueryVariables>;
export const ListAdminScheduleTemplatesDocument = gql`
    query ListAdminScheduleTemplates($organizationId: String!) {
  listAdminScheduleTemplates(organizationId: $organizationId) {
    ...AdminScheduleTemplateSummaryFields
  }
}
    ${AdminScheduleTemplateSummaryFieldsFragmentDoc}`;

/**
 * __useListAdminScheduleTemplatesQuery__
 *
 * To run a query within a React component, call `useListAdminScheduleTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAdminScheduleTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAdminScheduleTemplatesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useListAdminScheduleTemplatesQuery(baseOptions: Apollo.QueryHookOptions<ListAdminScheduleTemplatesQuery, ListAdminScheduleTemplatesQueryVariables> & ({ variables: ListAdminScheduleTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAdminScheduleTemplatesQuery, ListAdminScheduleTemplatesQueryVariables>(ListAdminScheduleTemplatesDocument, options);
      }
export function useListAdminScheduleTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAdminScheduleTemplatesQuery, ListAdminScheduleTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAdminScheduleTemplatesQuery, ListAdminScheduleTemplatesQueryVariables>(ListAdminScheduleTemplatesDocument, options);
        }
export function useListAdminScheduleTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAdminScheduleTemplatesQuery, ListAdminScheduleTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAdminScheduleTemplatesQuery, ListAdminScheduleTemplatesQueryVariables>(ListAdminScheduleTemplatesDocument, options);
        }
export type ListAdminScheduleTemplatesQueryHookResult = ReturnType<typeof useListAdminScheduleTemplatesQuery>;
export type ListAdminScheduleTemplatesLazyQueryHookResult = ReturnType<typeof useListAdminScheduleTemplatesLazyQuery>;
export type ListAdminScheduleTemplatesSuspenseQueryHookResult = ReturnType<typeof useListAdminScheduleTemplatesSuspenseQuery>;
export type ListAdminScheduleTemplatesQueryResult = Apollo.QueryResult<ListAdminScheduleTemplatesQuery, ListAdminScheduleTemplatesQueryVariables>;
export const ReadAdminScheduleSpecializationDetailDocument = gql`
    query ReadAdminScheduleSpecializationDetail($organizationId: String!, $specializationId: String!) {
  readAdminScheduleSpecializationDetail(
    organizationId: $organizationId
    specializationId: $specializationId
  ) {
    ...AdminScheduleSpecializationDetailFields
  }
}
    ${AdminScheduleSpecializationDetailFieldsFragmentDoc}`;

/**
 * __useReadAdminScheduleSpecializationDetailQuery__
 *
 * To run a query within a React component, call `useReadAdminScheduleSpecializationDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadAdminScheduleSpecializationDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadAdminScheduleSpecializationDetailQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      specializationId: // value for 'specializationId'
 *   },
 * });
 */
export function useReadAdminScheduleSpecializationDetailQuery(baseOptions: Apollo.QueryHookOptions<ReadAdminScheduleSpecializationDetailQuery, ReadAdminScheduleSpecializationDetailQueryVariables> & ({ variables: ReadAdminScheduleSpecializationDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadAdminScheduleSpecializationDetailQuery, ReadAdminScheduleSpecializationDetailQueryVariables>(ReadAdminScheduleSpecializationDetailDocument, options);
      }
export function useReadAdminScheduleSpecializationDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadAdminScheduleSpecializationDetailQuery, ReadAdminScheduleSpecializationDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadAdminScheduleSpecializationDetailQuery, ReadAdminScheduleSpecializationDetailQueryVariables>(ReadAdminScheduleSpecializationDetailDocument, options);
        }
export function useReadAdminScheduleSpecializationDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadAdminScheduleSpecializationDetailQuery, ReadAdminScheduleSpecializationDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadAdminScheduleSpecializationDetailQuery, ReadAdminScheduleSpecializationDetailQueryVariables>(ReadAdminScheduleSpecializationDetailDocument, options);
        }
export type ReadAdminScheduleSpecializationDetailQueryHookResult = ReturnType<typeof useReadAdminScheduleSpecializationDetailQuery>;
export type ReadAdminScheduleSpecializationDetailLazyQueryHookResult = ReturnType<typeof useReadAdminScheduleSpecializationDetailLazyQuery>;
export type ReadAdminScheduleSpecializationDetailSuspenseQueryHookResult = ReturnType<typeof useReadAdminScheduleSpecializationDetailSuspenseQuery>;
export type ReadAdminScheduleSpecializationDetailQueryResult = Apollo.QueryResult<ReadAdminScheduleSpecializationDetailQuery, ReadAdminScheduleSpecializationDetailQueryVariables>;
export const ReadAdminScheduleTemplateDocument = gql`
    query ReadAdminScheduleTemplate($organizationId: String!, $scheduleTemplateId: String!) {
  readAdminScheduleTemplate(
    organizationId: $organizationId
    scheduleTemplateId: $scheduleTemplateId
  ) {
    ...AdminScheduleTemplateFields
  }
}
    ${AdminScheduleTemplateFieldsFragmentDoc}`;

/**
 * __useReadAdminScheduleTemplateQuery__
 *
 * To run a query within a React component, call `useReadAdminScheduleTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadAdminScheduleTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadAdminScheduleTemplateQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      scheduleTemplateId: // value for 'scheduleTemplateId'
 *   },
 * });
 */
export function useReadAdminScheduleTemplateQuery(baseOptions: Apollo.QueryHookOptions<ReadAdminScheduleTemplateQuery, ReadAdminScheduleTemplateQueryVariables> & ({ variables: ReadAdminScheduleTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadAdminScheduleTemplateQuery, ReadAdminScheduleTemplateQueryVariables>(ReadAdminScheduleTemplateDocument, options);
      }
export function useReadAdminScheduleTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadAdminScheduleTemplateQuery, ReadAdminScheduleTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadAdminScheduleTemplateQuery, ReadAdminScheduleTemplateQueryVariables>(ReadAdminScheduleTemplateDocument, options);
        }
export function useReadAdminScheduleTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadAdminScheduleTemplateQuery, ReadAdminScheduleTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadAdminScheduleTemplateQuery, ReadAdminScheduleTemplateQueryVariables>(ReadAdminScheduleTemplateDocument, options);
        }
export type ReadAdminScheduleTemplateQueryHookResult = ReturnType<typeof useReadAdminScheduleTemplateQuery>;
export type ReadAdminScheduleTemplateLazyQueryHookResult = ReturnType<typeof useReadAdminScheduleTemplateLazyQuery>;
export type ReadAdminScheduleTemplateSuspenseQueryHookResult = ReturnType<typeof useReadAdminScheduleTemplateSuspenseQuery>;
export type ReadAdminScheduleTemplateQueryResult = Apollo.QueryResult<ReadAdminScheduleTemplateQuery, ReadAdminScheduleTemplateQueryVariables>;
export const SearchDocument = gql`
    query Search($pagination: Pagination!, $searchTerm: String!) {
  organizations: listOrganizations(
    pagination: $pagination
    searchTerm: $searchTerm
  ) {
    ...AdminOrganizationFields
  }
  affiliations: listAffiliatedOrganizations(searchTerm: $searchTerm) {
    ...AdminOrganizationFields
  }
  legalEntities: listLegalEntities(
    pagination: $pagination
    searchTerm: $searchTerm
  ) {
    ...AdminLegalEntityFields
  }
  users: listUsers(pagination: $pagination, searchTerm: $searchTerm) {
    ...AdminUserFields
  }
  signups: listSignups(
    status: AllSignups
    pagination: $pagination
    searchTerm: $searchTerm
  ) {
    ...AdminSignupFields
  }
  connectors: listConnectors(
    className: "app"
    pagination: $pagination
    searchTerm: $searchTerm
  ) {
    ...AdminConnectorFields
  }
}
    ${AdminOrganizationFieldsFragmentDoc}
${AdminLegalEntityFieldsFragmentDoc}
${AdminUserFieldsFragmentDoc}
${AdminSignupFieldsFragmentDoc}
${AdminConnectorFieldsFragmentDoc}`;

/**
 * __useSearchQuery__
 *
 * To run a query within a React component, call `useSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useSearchQuery(baseOptions: Apollo.QueryHookOptions<SearchQuery, SearchQueryVariables> & ({ variables: SearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
      }
export function useSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQuery, SearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
        }
export function useSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQuery, SearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
        }
export type SearchQueryHookResult = ReturnType<typeof useSearchQuery>;
export type SearchLazyQueryHookResult = ReturnType<typeof useSearchLazyQuery>;
export type SearchSuspenseQueryHookResult = ReturnType<typeof useSearchSuspenseQuery>;
export type SearchQueryResult = Apollo.QueryResult<SearchQuery, SearchQueryVariables>;
export const SearchByUuidDocument = gql`
    query SearchByUUID($uuid: String!) {
  searchByUUID(uuid: $uuid) {
    entityType
    user {
      ...AdminUserFields
    }
    legalEntity {
      ...AdminLegalEntityFields
    }
    organization {
      ...AdminOrganizationFields
    }
    connection {
      ...AdminConnectionFields
    }
    dataSource {
      dataSource {
        id
        legalEntityId
        status
        statusReason
        providerType
        accountAlias
        createdAt
        updatedAt
      }
    }
    connector {
      ...AdminConnectorFields
    }
  }
}
    ${AdminUserFieldsFragmentDoc}
${AdminLegalEntityFieldsFragmentDoc}
${AdminOrganizationFieldsFragmentDoc}
${AdminConnectionFieldsFragmentDoc}
${AdminConnectorFieldsFragmentDoc}`;

/**
 * __useSearchByUuidQuery__
 *
 * To run a query within a React component, call `useSearchByUuidQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchByUuidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchByUuidQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useSearchByUuidQuery(baseOptions: Apollo.QueryHookOptions<SearchByUuidQuery, SearchByUuidQueryVariables> & ({ variables: SearchByUuidQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchByUuidQuery, SearchByUuidQueryVariables>(SearchByUuidDocument, options);
      }
export function useSearchByUuidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchByUuidQuery, SearchByUuidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchByUuidQuery, SearchByUuidQueryVariables>(SearchByUuidDocument, options);
        }
export function useSearchByUuidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchByUuidQuery, SearchByUuidQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchByUuidQuery, SearchByUuidQueryVariables>(SearchByUuidDocument, options);
        }
export type SearchByUuidQueryHookResult = ReturnType<typeof useSearchByUuidQuery>;
export type SearchByUuidLazyQueryHookResult = ReturnType<typeof useSearchByUuidLazyQuery>;
export type SearchByUuidSuspenseQueryHookResult = ReturnType<typeof useSearchByUuidSuspenseQuery>;
export type SearchByUuidQueryResult = Apollo.QueryResult<SearchByUuidQuery, SearchByUuidQueryVariables>;
export const UpdateSignupStatusDocument = gql`
    mutation UpdateSignupStatus($id: String!, $status: SignupStatus!, $statusReason: String) {
  updateSignupStatus(id: $id, status: $status, statusReason: $statusReason)
}
    `;
export type UpdateSignupStatusMutationFn = Apollo.MutationFunction<UpdateSignupStatusMutation, UpdateSignupStatusMutationVariables>;

/**
 * __useUpdateSignupStatusMutation__
 *
 * To run a mutation, you first call `useUpdateSignupStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSignupStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSignupStatusMutation, { data, loading, error }] = useUpdateSignupStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      statusReason: // value for 'statusReason'
 *   },
 * });
 */
export function useUpdateSignupStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSignupStatusMutation, UpdateSignupStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSignupStatusMutation, UpdateSignupStatusMutationVariables>(UpdateSignupStatusDocument, options);
      }
export type UpdateSignupStatusMutationHookResult = ReturnType<typeof useUpdateSignupStatusMutation>;
export type UpdateSignupStatusMutationResult = Apollo.MutationResult<UpdateSignupStatusMutation>;
export type UpdateSignupStatusMutationOptions = Apollo.BaseMutationOptions<UpdateSignupStatusMutation, UpdateSignupStatusMutationVariables>;
export const ReadSignupDocument = gql`
    query ReadSignup($id: String!) {
  readSignup(id: $id) {
    ...AdminSignupFields
  }
}
    ${AdminSignupFieldsFragmentDoc}`;

/**
 * __useReadSignupQuery__
 *
 * To run a query within a React component, call `useReadSignupQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadSignupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadSignupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReadSignupQuery(baseOptions: Apollo.QueryHookOptions<ReadSignupQuery, ReadSignupQueryVariables> & ({ variables: ReadSignupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadSignupQuery, ReadSignupQueryVariables>(ReadSignupDocument, options);
      }
export function useReadSignupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadSignupQuery, ReadSignupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadSignupQuery, ReadSignupQueryVariables>(ReadSignupDocument, options);
        }
export function useReadSignupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadSignupQuery, ReadSignupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadSignupQuery, ReadSignupQueryVariables>(ReadSignupDocument, options);
        }
export type ReadSignupQueryHookResult = ReturnType<typeof useReadSignupQuery>;
export type ReadSignupLazyQueryHookResult = ReturnType<typeof useReadSignupLazyQuery>;
export type ReadSignupSuspenseQueryHookResult = ReturnType<typeof useReadSignupSuspenseQuery>;
export type ReadSignupQueryResult = Apollo.QueryResult<ReadSignupQuery, ReadSignupQueryVariables>;
export const SoftDeleteOrganizationDocument = gql`
    mutation SoftDeleteOrganization($organizationId: String!, $kind: OrganizationKind!, $deleteUsers: Boolean!) {
  softDeleteOrganization(
    id: $organizationId
    kind: $kind
    deleteUsers: $deleteUsers
  )
}
    `;
export type SoftDeleteOrganizationMutationFn = Apollo.MutationFunction<SoftDeleteOrganizationMutation, SoftDeleteOrganizationMutationVariables>;

/**
 * __useSoftDeleteOrganizationMutation__
 *
 * To run a mutation, you first call `useSoftDeleteOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftDeleteOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softDeleteOrganizationMutation, { data, loading, error }] = useSoftDeleteOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      kind: // value for 'kind'
 *      deleteUsers: // value for 'deleteUsers'
 *   },
 * });
 */
export function useSoftDeleteOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<SoftDeleteOrganizationMutation, SoftDeleteOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftDeleteOrganizationMutation, SoftDeleteOrganizationMutationVariables>(SoftDeleteOrganizationDocument, options);
      }
export type SoftDeleteOrganizationMutationHookResult = ReturnType<typeof useSoftDeleteOrganizationMutation>;
export type SoftDeleteOrganizationMutationResult = Apollo.MutationResult<SoftDeleteOrganizationMutation>;
export type SoftDeleteOrganizationMutationOptions = Apollo.BaseMutationOptions<SoftDeleteOrganizationMutation, SoftDeleteOrganizationMutationVariables>;
export const ReadSourceRecordedMatchSummaryDocument = gql`
    query ReadSourceRecordedMatchSummary($legalEntityId: String!) {
  readSourceRecordedMatchSummary(legalEntityId: $legalEntityId) {
    ...SourceRecordedMatchSummaryFields
  }
}
    ${SourceRecordedMatchSummaryFieldsFragmentDoc}`;

/**
 * __useReadSourceRecordedMatchSummaryQuery__
 *
 * To run a query within a React component, call `useReadSourceRecordedMatchSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadSourceRecordedMatchSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadSourceRecordedMatchSummaryQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useReadSourceRecordedMatchSummaryQuery(baseOptions: Apollo.QueryHookOptions<ReadSourceRecordedMatchSummaryQuery, ReadSourceRecordedMatchSummaryQueryVariables> & ({ variables: ReadSourceRecordedMatchSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadSourceRecordedMatchSummaryQuery, ReadSourceRecordedMatchSummaryQueryVariables>(ReadSourceRecordedMatchSummaryDocument, options);
      }
export function useReadSourceRecordedMatchSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadSourceRecordedMatchSummaryQuery, ReadSourceRecordedMatchSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadSourceRecordedMatchSummaryQuery, ReadSourceRecordedMatchSummaryQueryVariables>(ReadSourceRecordedMatchSummaryDocument, options);
        }
export function useReadSourceRecordedMatchSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadSourceRecordedMatchSummaryQuery, ReadSourceRecordedMatchSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadSourceRecordedMatchSummaryQuery, ReadSourceRecordedMatchSummaryQueryVariables>(ReadSourceRecordedMatchSummaryDocument, options);
        }
export type ReadSourceRecordedMatchSummaryQueryHookResult = ReturnType<typeof useReadSourceRecordedMatchSummaryQuery>;
export type ReadSourceRecordedMatchSummaryLazyQueryHookResult = ReturnType<typeof useReadSourceRecordedMatchSummaryLazyQuery>;
export type ReadSourceRecordedMatchSummarySuspenseQueryHookResult = ReturnType<typeof useReadSourceRecordedMatchSummarySuspenseQuery>;
export type ReadSourceRecordedMatchSummaryQueryResult = Apollo.QueryResult<ReadSourceRecordedMatchSummaryQuery, ReadSourceRecordedMatchSummaryQueryVariables>;
export const TriggerDigitsLedgerReviewDocument = gql`
    mutation TriggerDigitsLedgerReview($legalEntityId: String!, $ledgerType: LedgerType!) {
  triggerDigitsLedgerReview(
    legalEntityId: $legalEntityId
    ledgerType: $ledgerType
  )
}
    `;
export type TriggerDigitsLedgerReviewMutationFn = Apollo.MutationFunction<TriggerDigitsLedgerReviewMutation, TriggerDigitsLedgerReviewMutationVariables>;

/**
 * __useTriggerDigitsLedgerReviewMutation__
 *
 * To run a mutation, you first call `useTriggerDigitsLedgerReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerDigitsLedgerReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerDigitsLedgerReviewMutation, { data, loading, error }] = useTriggerDigitsLedgerReviewMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      ledgerType: // value for 'ledgerType'
 *   },
 * });
 */
export function useTriggerDigitsLedgerReviewMutation(baseOptions?: Apollo.MutationHookOptions<TriggerDigitsLedgerReviewMutation, TriggerDigitsLedgerReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerDigitsLedgerReviewMutation, TriggerDigitsLedgerReviewMutationVariables>(TriggerDigitsLedgerReviewDocument, options);
      }
export type TriggerDigitsLedgerReviewMutationHookResult = ReturnType<typeof useTriggerDigitsLedgerReviewMutation>;
export type TriggerDigitsLedgerReviewMutationResult = Apollo.MutationResult<TriggerDigitsLedgerReviewMutation>;
export type TriggerDigitsLedgerReviewMutationOptions = Apollo.BaseMutationOptions<TriggerDigitsLedgerReviewMutation, TriggerDigitsLedgerReviewMutationVariables>;
export const DeleteCsvImportTransactionsDocument = gql`
    mutation DeleteCsvImportTransactions($legalEntityId: String!, $csvImportId: String!) {
  deleteCsvImportTransactions(
    legalEntityId: $legalEntityId
    csvImportId: $csvImportId
  )
}
    `;
export type DeleteCsvImportTransactionsMutationFn = Apollo.MutationFunction<DeleteCsvImportTransactionsMutation, DeleteCsvImportTransactionsMutationVariables>;

/**
 * __useDeleteCsvImportTransactionsMutation__
 *
 * To run a mutation, you first call `useDeleteCsvImportTransactionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCsvImportTransactionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCsvImportTransactionsMutation, { data, loading, error }] = useDeleteCsvImportTransactionsMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      csvImportId: // value for 'csvImportId'
 *   },
 * });
 */
export function useDeleteCsvImportTransactionsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCsvImportTransactionsMutation, DeleteCsvImportTransactionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCsvImportTransactionsMutation, DeleteCsvImportTransactionsMutationVariables>(DeleteCsvImportTransactionsDocument, options);
      }
export type DeleteCsvImportTransactionsMutationHookResult = ReturnType<typeof useDeleteCsvImportTransactionsMutation>;
export type DeleteCsvImportTransactionsMutationResult = Apollo.MutationResult<DeleteCsvImportTransactionsMutation>;
export type DeleteCsvImportTransactionsMutationOptions = Apollo.BaseMutationOptions<DeleteCsvImportTransactionsMutation, DeleteCsvImportTransactionsMutationVariables>;
export const TriggerSourceDataClassificationDocument = gql`
    mutation TriggerSourceDataClassification($legalEntityId: String!, $dataSourceId: String!, $externalId: String!) {
  triggerSourceDataClassification(
    legalEntityId: $legalEntityId
    dataSourceId: $dataSourceId
    externalId: $externalId
  )
}
    `;
export type TriggerSourceDataClassificationMutationFn = Apollo.MutationFunction<TriggerSourceDataClassificationMutation, TriggerSourceDataClassificationMutationVariables>;

/**
 * __useTriggerSourceDataClassificationMutation__
 *
 * To run a mutation, you first call `useTriggerSourceDataClassificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerSourceDataClassificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerSourceDataClassificationMutation, { data, loading, error }] = useTriggerSourceDataClassificationMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      dataSourceId: // value for 'dataSourceId'
 *      externalId: // value for 'externalId'
 *   },
 * });
 */
export function useTriggerSourceDataClassificationMutation(baseOptions?: Apollo.MutationHookOptions<TriggerSourceDataClassificationMutation, TriggerSourceDataClassificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerSourceDataClassificationMutation, TriggerSourceDataClassificationMutationVariables>(TriggerSourceDataClassificationDocument, options);
      }
export type TriggerSourceDataClassificationMutationHookResult = ReturnType<typeof useTriggerSourceDataClassificationMutation>;
export type TriggerSourceDataClassificationMutationResult = Apollo.MutationResult<TriggerSourceDataClassificationMutation>;
export type TriggerSourceDataClassificationMutationOptions = Apollo.BaseMutationOptions<TriggerSourceDataClassificationMutation, TriggerSourceDataClassificationMutationVariables>;
export const AllTransactionFactMetadataDocument = gql`
    query AllTransactionFactMetadata($transactionFactId: String!) {
  readTransactionFact(transactionFactId: $transactionFactId) {
    ...AdminTransactionFactFields
  }
  readEntityExtractions(transactionFactId: $transactionFactId) {
    ...AdminTransactionEntityExtractionFields
  }
  listTransactionFactPartyClassifications(transactionFactId: $transactionFactId) {
    party {
      ...PartyFields
    }
    classification {
      ...AdminClassificationFields
    }
    prefix
    prefixDescription
    role
    overlayName
  }
  listTransactionFactCategoryClassifications(
    transactionFactId: $transactionFactId
  ) {
    category {
      ...CategoryFields
    }
    entryType
    transactionFactId
    classification {
      ...AdminClassificationFields
    }
  }
  listTransactionFactLedgerPartyClassifications(
    transactionFactId: $transactionFactId
  ) {
    party {
      ...PartyFields
    }
    classification {
      ...AdminClassificationFields
    }
    prefix
    prefixDescription
    role
    overlayName
  }
}
    ${AdminTransactionFactFieldsFragmentDoc}
${AdminTransactionEntityExtractionFieldsFragmentDoc}
${PartyFieldsFragmentDoc}
${AdminClassificationFieldsFragmentDoc}
${CategoryFieldsFragmentDoc}`;

/**
 * __useAllTransactionFactMetadataQuery__
 *
 * To run a query within a React component, call `useAllTransactionFactMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTransactionFactMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTransactionFactMetadataQuery({
 *   variables: {
 *      transactionFactId: // value for 'transactionFactId'
 *   },
 * });
 */
export function useAllTransactionFactMetadataQuery(baseOptions: Apollo.QueryHookOptions<AllTransactionFactMetadataQuery, AllTransactionFactMetadataQueryVariables> & ({ variables: AllTransactionFactMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllTransactionFactMetadataQuery, AllTransactionFactMetadataQueryVariables>(AllTransactionFactMetadataDocument, options);
      }
export function useAllTransactionFactMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllTransactionFactMetadataQuery, AllTransactionFactMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllTransactionFactMetadataQuery, AllTransactionFactMetadataQueryVariables>(AllTransactionFactMetadataDocument, options);
        }
export function useAllTransactionFactMetadataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllTransactionFactMetadataQuery, AllTransactionFactMetadataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllTransactionFactMetadataQuery, AllTransactionFactMetadataQueryVariables>(AllTransactionFactMetadataDocument, options);
        }
export type AllTransactionFactMetadataQueryHookResult = ReturnType<typeof useAllTransactionFactMetadataQuery>;
export type AllTransactionFactMetadataLazyQueryHookResult = ReturnType<typeof useAllTransactionFactMetadataLazyQuery>;
export type AllTransactionFactMetadataSuspenseQueryHookResult = ReturnType<typeof useAllTransactionFactMetadataSuspenseQuery>;
export type AllTransactionFactMetadataQueryResult = Apollo.QueryResult<AllTransactionFactMetadataQuery, AllTransactionFactMetadataQueryVariables>;
export const ListAssociatedTransactionFactsDocument = gql`
    query ListAssociatedTransactionFacts($dataSourceId: String!, $externalId: String!) {
  listAssociatedTransactionFacts(
    dataSourceId: $dataSourceId
    externalId: $externalId
  ) {
    ...AdminTransactionFactFields
  }
}
    ${AdminTransactionFactFieldsFragmentDoc}`;

/**
 * __useListAssociatedTransactionFactsQuery__
 *
 * To run a query within a React component, call `useListAssociatedTransactionFactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAssociatedTransactionFactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAssociatedTransactionFactsQuery({
 *   variables: {
 *      dataSourceId: // value for 'dataSourceId'
 *      externalId: // value for 'externalId'
 *   },
 * });
 */
export function useListAssociatedTransactionFactsQuery(baseOptions: Apollo.QueryHookOptions<ListAssociatedTransactionFactsQuery, ListAssociatedTransactionFactsQueryVariables> & ({ variables: ListAssociatedTransactionFactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAssociatedTransactionFactsQuery, ListAssociatedTransactionFactsQueryVariables>(ListAssociatedTransactionFactsDocument, options);
      }
export function useListAssociatedTransactionFactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAssociatedTransactionFactsQuery, ListAssociatedTransactionFactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAssociatedTransactionFactsQuery, ListAssociatedTransactionFactsQueryVariables>(ListAssociatedTransactionFactsDocument, options);
        }
export function useListAssociatedTransactionFactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAssociatedTransactionFactsQuery, ListAssociatedTransactionFactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAssociatedTransactionFactsQuery, ListAssociatedTransactionFactsQueryVariables>(ListAssociatedTransactionFactsDocument, options);
        }
export type ListAssociatedTransactionFactsQueryHookResult = ReturnType<typeof useListAssociatedTransactionFactsQuery>;
export type ListAssociatedTransactionFactsLazyQueryHookResult = ReturnType<typeof useListAssociatedTransactionFactsLazyQuery>;
export type ListAssociatedTransactionFactsSuspenseQueryHookResult = ReturnType<typeof useListAssociatedTransactionFactsSuspenseQuery>;
export type ListAssociatedTransactionFactsQueryResult = Apollo.QueryResult<ListAssociatedTransactionFactsQuery, ListAssociatedTransactionFactsQueryVariables>;
export const AdminListLedgerTransactionFactsDocument = gql`
    query AdminListLedgerTransactionFacts($legalEntityId: String!, $ledgerTransactionIds: [String!]!) {
  listLedgerTransactionFacts(
    legalEntityId: $legalEntityId
    ledgerTransactionIds: $ledgerTransactionIds
  ) {
    ...AdminTransactionFactFields
  }
}
    ${AdminTransactionFactFieldsFragmentDoc}`;

/**
 * __useAdminListLedgerTransactionFactsQuery__
 *
 * To run a query within a React component, call `useAdminListLedgerTransactionFactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminListLedgerTransactionFactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminListLedgerTransactionFactsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      ledgerTransactionIds: // value for 'ledgerTransactionIds'
 *   },
 * });
 */
export function useAdminListLedgerTransactionFactsQuery(baseOptions: Apollo.QueryHookOptions<AdminListLedgerTransactionFactsQuery, AdminListLedgerTransactionFactsQueryVariables> & ({ variables: AdminListLedgerTransactionFactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminListLedgerTransactionFactsQuery, AdminListLedgerTransactionFactsQueryVariables>(AdminListLedgerTransactionFactsDocument, options);
      }
export function useAdminListLedgerTransactionFactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminListLedgerTransactionFactsQuery, AdminListLedgerTransactionFactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminListLedgerTransactionFactsQuery, AdminListLedgerTransactionFactsQueryVariables>(AdminListLedgerTransactionFactsDocument, options);
        }
export function useAdminListLedgerTransactionFactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminListLedgerTransactionFactsQuery, AdminListLedgerTransactionFactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminListLedgerTransactionFactsQuery, AdminListLedgerTransactionFactsQueryVariables>(AdminListLedgerTransactionFactsDocument, options);
        }
export type AdminListLedgerTransactionFactsQueryHookResult = ReturnType<typeof useAdminListLedgerTransactionFactsQuery>;
export type AdminListLedgerTransactionFactsLazyQueryHookResult = ReturnType<typeof useAdminListLedgerTransactionFactsLazyQuery>;
export type AdminListLedgerTransactionFactsSuspenseQueryHookResult = ReturnType<typeof useAdminListLedgerTransactionFactsSuspenseQuery>;
export type AdminListLedgerTransactionFactsQueryResult = Apollo.QueryResult<AdminListLedgerTransactionFactsQuery, AdminListLedgerTransactionFactsQueryVariables>;
export const ListMatchSetTransactionFactsDocument = gql`
    query ListMatchSetTransactionFacts($legalEntityId: String!, $transactionFactId: String!) {
  listMatchSetTransactionFacts(
    legalEntityId: $legalEntityId
    transactionFactId: $transactionFactId
  ) {
    transactionFacts {
      ...AdminTransactionFactFields
    }
    matchSetId
    matchAlgorithmDescription
  }
}
    ${AdminTransactionFactFieldsFragmentDoc}`;

/**
 * __useListMatchSetTransactionFactsQuery__
 *
 * To run a query within a React component, call `useListMatchSetTransactionFactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMatchSetTransactionFactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMatchSetTransactionFactsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      transactionFactId: // value for 'transactionFactId'
 *   },
 * });
 */
export function useListMatchSetTransactionFactsQuery(baseOptions: Apollo.QueryHookOptions<ListMatchSetTransactionFactsQuery, ListMatchSetTransactionFactsQueryVariables> & ({ variables: ListMatchSetTransactionFactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMatchSetTransactionFactsQuery, ListMatchSetTransactionFactsQueryVariables>(ListMatchSetTransactionFactsDocument, options);
      }
export function useListMatchSetTransactionFactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMatchSetTransactionFactsQuery, ListMatchSetTransactionFactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMatchSetTransactionFactsQuery, ListMatchSetTransactionFactsQueryVariables>(ListMatchSetTransactionFactsDocument, options);
        }
export function useListMatchSetTransactionFactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListMatchSetTransactionFactsQuery, ListMatchSetTransactionFactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListMatchSetTransactionFactsQuery, ListMatchSetTransactionFactsQueryVariables>(ListMatchSetTransactionFactsDocument, options);
        }
export type ListMatchSetTransactionFactsQueryHookResult = ReturnType<typeof useListMatchSetTransactionFactsQuery>;
export type ListMatchSetTransactionFactsLazyQueryHookResult = ReturnType<typeof useListMatchSetTransactionFactsLazyQuery>;
export type ListMatchSetTransactionFactsSuspenseQueryHookResult = ReturnType<typeof useListMatchSetTransactionFactsSuspenseQuery>;
export type ListMatchSetTransactionFactsQueryResult = Apollo.QueryResult<ListMatchSetTransactionFactsQuery, ListMatchSetTransactionFactsQueryVariables>;
export const ReadAdminTransactionFactDocument = gql`
    query ReadAdminTransactionFact($transactionFactId: String!) {
  readTransactionFact(transactionFactId: $transactionFactId) {
    ...AdminTransactionFactFields
  }
}
    ${AdminTransactionFactFieldsFragmentDoc}`;

/**
 * __useReadAdminTransactionFactQuery__
 *
 * To run a query within a React component, call `useReadAdminTransactionFactQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadAdminTransactionFactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadAdminTransactionFactQuery({
 *   variables: {
 *      transactionFactId: // value for 'transactionFactId'
 *   },
 * });
 */
export function useReadAdminTransactionFactQuery(baseOptions: Apollo.QueryHookOptions<ReadAdminTransactionFactQuery, ReadAdminTransactionFactQueryVariables> & ({ variables: ReadAdminTransactionFactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadAdminTransactionFactQuery, ReadAdminTransactionFactQueryVariables>(ReadAdminTransactionFactDocument, options);
      }
export function useReadAdminTransactionFactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadAdminTransactionFactQuery, ReadAdminTransactionFactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadAdminTransactionFactQuery, ReadAdminTransactionFactQueryVariables>(ReadAdminTransactionFactDocument, options);
        }
export function useReadAdminTransactionFactSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadAdminTransactionFactQuery, ReadAdminTransactionFactQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadAdminTransactionFactQuery, ReadAdminTransactionFactQueryVariables>(ReadAdminTransactionFactDocument, options);
        }
export type ReadAdminTransactionFactQueryHookResult = ReturnType<typeof useReadAdminTransactionFactQuery>;
export type ReadAdminTransactionFactLazyQueryHookResult = ReturnType<typeof useReadAdminTransactionFactLazyQuery>;
export type ReadAdminTransactionFactSuspenseQueryHookResult = ReturnType<typeof useReadAdminTransactionFactSuspenseQuery>;
export type ReadAdminTransactionFactQueryResult = Apollo.QueryResult<ReadAdminTransactionFactQuery, ReadAdminTransactionFactQueryVariables>;
export const BanUserDocument = gql`
    mutation BanUser($userId: String!) {
  banUser(userId: $userId)
}
    `;
export type BanUserMutationFn = Apollo.MutationFunction<BanUserMutation, BanUserMutationVariables>;

/**
 * __useBanUserMutation__
 *
 * To run a mutation, you first call `useBanUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBanUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [banUserMutation, { data, loading, error }] = useBanUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useBanUserMutation(baseOptions?: Apollo.MutationHookOptions<BanUserMutation, BanUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BanUserMutation, BanUserMutationVariables>(BanUserDocument, options);
      }
export type BanUserMutationHookResult = ReturnType<typeof useBanUserMutation>;
export type BanUserMutationResult = Apollo.MutationResult<BanUserMutation>;
export type BanUserMutationOptions = Apollo.BaseMutationOptions<BanUserMutation, BanUserMutationVariables>;
export const CreateSuperuserDocument = gql`
    mutation CreateSuperuser($emailAddress: String!, $roleIdentifiers: [String!]!, $givenName: String!, $familyName: String!) {
  createSuperuser(
    emailAddress: $emailAddress
    roleIdentifiers: $roleIdentifiers
    givenName: $givenName
    familyName: $familyName
  ) {
    ...SuperuserFields
  }
}
    ${SuperuserFieldsFragmentDoc}`;
export type CreateSuperuserMutationFn = Apollo.MutationFunction<CreateSuperuserMutation, CreateSuperuserMutationVariables>;

/**
 * __useCreateSuperuserMutation__
 *
 * To run a mutation, you first call `useCreateSuperuserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSuperuserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSuperuserMutation, { data, loading, error }] = useCreateSuperuserMutation({
 *   variables: {
 *      emailAddress: // value for 'emailAddress'
 *      roleIdentifiers: // value for 'roleIdentifiers'
 *      givenName: // value for 'givenName'
 *      familyName: // value for 'familyName'
 *   },
 * });
 */
export function useCreateSuperuserMutation(baseOptions?: Apollo.MutationHookOptions<CreateSuperuserMutation, CreateSuperuserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSuperuserMutation, CreateSuperuserMutationVariables>(CreateSuperuserDocument, options);
      }
export type CreateSuperuserMutationHookResult = ReturnType<typeof useCreateSuperuserMutation>;
export type CreateSuperuserMutationResult = Apollo.MutationResult<CreateSuperuserMutation>;
export type CreateSuperuserMutationOptions = Apollo.BaseMutationOptions<CreateSuperuserMutation, CreateSuperuserMutationVariables>;
export const ResetLockoutDocument = gql`
    mutation ResetLockout($userId: String!, $justification: String!) {
  resetLockout(userId: $userId, justification: $justification)
}
    `;
export type ResetLockoutMutationFn = Apollo.MutationFunction<ResetLockoutMutation, ResetLockoutMutationVariables>;

/**
 * __useResetLockoutMutation__
 *
 * To run a mutation, you first call `useResetLockoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetLockoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetLockoutMutation, { data, loading, error }] = useResetLockoutMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      justification: // value for 'justification'
 *   },
 * });
 */
export function useResetLockoutMutation(baseOptions?: Apollo.MutationHookOptions<ResetLockoutMutation, ResetLockoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetLockoutMutation, ResetLockoutMutationVariables>(ResetLockoutDocument, options);
      }
export type ResetLockoutMutationHookResult = ReturnType<typeof useResetLockoutMutation>;
export type ResetLockoutMutationResult = Apollo.MutationResult<ResetLockoutMutation>;
export type ResetLockoutMutationOptions = Apollo.BaseMutationOptions<ResetLockoutMutation, ResetLockoutMutationVariables>;
export const ResetMfaDocument = gql`
    mutation ResetMfa($userId: String!, $justification: String!) {
  resetMfa(userId: $userId, justification: $justification)
}
    `;
export type ResetMfaMutationFn = Apollo.MutationFunction<ResetMfaMutation, ResetMfaMutationVariables>;

/**
 * __useResetMfaMutation__
 *
 * To run a mutation, you first call `useResetMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetMfaMutation, { data, loading, error }] = useResetMfaMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      justification: // value for 'justification'
 *   },
 * });
 */
export function useResetMfaMutation(baseOptions?: Apollo.MutationHookOptions<ResetMfaMutation, ResetMfaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetMfaMutation, ResetMfaMutationVariables>(ResetMfaDocument, options);
      }
export type ResetMfaMutationHookResult = ReturnType<typeof useResetMfaMutation>;
export type ResetMfaMutationResult = Apollo.MutationResult<ResetMfaMutation>;
export type ResetMfaMutationOptions = Apollo.BaseMutationOptions<ResetMfaMutation, ResetMfaMutationVariables>;
export const UnbanUserDocument = gql`
    mutation UnbanUser($userId: String!) {
  unbanUser(userId: $userId)
}
    `;
export type UnbanUserMutationFn = Apollo.MutationFunction<UnbanUserMutation, UnbanUserMutationVariables>;

/**
 * __useUnbanUserMutation__
 *
 * To run a mutation, you first call `useUnbanUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnbanUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unbanUserMutation, { data, loading, error }] = useUnbanUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUnbanUserMutation(baseOptions?: Apollo.MutationHookOptions<UnbanUserMutation, UnbanUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnbanUserMutation, UnbanUserMutationVariables>(UnbanUserDocument, options);
      }
export type UnbanUserMutationHookResult = ReturnType<typeof useUnbanUserMutation>;
export type UnbanUserMutationResult = Apollo.MutationResult<UnbanUserMutation>;
export type UnbanUserMutationOptions = Apollo.BaseMutationOptions<UnbanUserMutation, UnbanUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($userId: String!, $givenName: String!, $familyName: String!) {
  updateUser(userId: $userId, givenName: $givenName, familyName: $familyName)
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      givenName: // value for 'givenName'
 *      familyName: // value for 'familyName'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const ListSuperusersDocument = gql`
    query ListSuperusers {
  listSuperusers {
    ...SuperuserFields
  }
}
    ${SuperuserFieldsFragmentDoc}`;

/**
 * __useListSuperusersQuery__
 *
 * To run a query within a React component, call `useListSuperusersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSuperusersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSuperusersQuery({
 *   variables: {
 *   },
 * });
 */
export function useListSuperusersQuery(baseOptions?: Apollo.QueryHookOptions<ListSuperusersQuery, ListSuperusersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSuperusersQuery, ListSuperusersQueryVariables>(ListSuperusersDocument, options);
      }
export function useListSuperusersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSuperusersQuery, ListSuperusersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSuperusersQuery, ListSuperusersQueryVariables>(ListSuperusersDocument, options);
        }
export function useListSuperusersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListSuperusersQuery, ListSuperusersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListSuperusersQuery, ListSuperusersQueryVariables>(ListSuperusersDocument, options);
        }
export type ListSuperusersQueryHookResult = ReturnType<typeof useListSuperusersQuery>;
export type ListSuperusersLazyQueryHookResult = ReturnType<typeof useListSuperusersLazyQuery>;
export type ListSuperusersSuspenseQueryHookResult = ReturnType<typeof useListSuperusersSuspenseQuery>;
export type ListSuperusersQueryResult = Apollo.QueryResult<ListSuperusersQuery, ListSuperusersQueryVariables>;
export const ListUsersDocument = gql`
    query ListUsers($pagination: Pagination!, $searchTerm: String, $noEmployments: Boolean, $createdBefore: DateTime, $createdAfter: DateTime, $ids: [String!], $organizationId: String, $legalEntityId: String) {
  listUsers(
    pagination: $pagination
    searchTerm: $searchTerm
    noEmployments: $noEmployments
    createdBefore: $createdBefore
    createdAfter: $createdAfter
    ids: $ids
    organizationId: $organizationId
    legalEntityId: $legalEntityId
  ) {
    ...AdminUserFields
  }
}
    ${AdminUserFieldsFragmentDoc}`;

/**
 * __useListUsersQuery__
 *
 * To run a query within a React component, call `useListUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUsersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      searchTerm: // value for 'searchTerm'
 *      noEmployments: // value for 'noEmployments'
 *      createdBefore: // value for 'createdBefore'
 *      createdAfter: // value for 'createdAfter'
 *      ids: // value for 'ids'
 *      organizationId: // value for 'organizationId'
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListUsersQuery(baseOptions: Apollo.QueryHookOptions<ListUsersQuery, ListUsersQueryVariables> & ({ variables: ListUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
      }
export function useListUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
        }
export function useListUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
        }
export type ListUsersQueryHookResult = ReturnType<typeof useListUsersQuery>;
export type ListUsersLazyQueryHookResult = ReturnType<typeof useListUsersLazyQuery>;
export type ListUsersSuspenseQueryHookResult = ReturnType<typeof useListUsersSuspenseQuery>;
export type ListUsersQueryResult = Apollo.QueryResult<ListUsersQuery, ListUsersQueryVariables>;
export const ReadUserDocument = gql`
    query ReadUser($id: String!) {
  readUser(id: $id) {
    ...AdminUserFields
  }
}
    ${AdminUserFieldsFragmentDoc}`;

/**
 * __useReadUserQuery__
 *
 * To run a query within a React component, call `useReadUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReadUserQuery(baseOptions: Apollo.QueryHookOptions<ReadUserQuery, ReadUserQueryVariables> & ({ variables: ReadUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadUserQuery, ReadUserQueryVariables>(ReadUserDocument, options);
      }
export function useReadUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadUserQuery, ReadUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadUserQuery, ReadUserQueryVariables>(ReadUserDocument, options);
        }
export function useReadUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadUserQuery, ReadUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadUserQuery, ReadUserQueryVariables>(ReadUserDocument, options);
        }
export type ReadUserQueryHookResult = ReturnType<typeof useReadUserQuery>;
export type ReadUserLazyQueryHookResult = ReturnType<typeof useReadUserLazyQuery>;
export type ReadUserSuspenseQueryHookResult = ReturnType<typeof useReadUserSuspenseQuery>;
export type ReadUserQueryResult = Apollo.QueryResult<ReadUserQuery, ReadUserQueryVariables>;
export const ListFailingClassificationValidationsDocument = gql`
    query ListFailingClassificationValidations {
  listFailingClassificationValidations {
    ...ClassificationValidationFailureFields
  }
}
    ${ClassificationValidationFailureFieldsFragmentDoc}`;

/**
 * __useListFailingClassificationValidationsQuery__
 *
 * To run a query within a React component, call `useListFailingClassificationValidationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListFailingClassificationValidationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListFailingClassificationValidationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListFailingClassificationValidationsQuery(baseOptions?: Apollo.QueryHookOptions<ListFailingClassificationValidationsQuery, ListFailingClassificationValidationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListFailingClassificationValidationsQuery, ListFailingClassificationValidationsQueryVariables>(ListFailingClassificationValidationsDocument, options);
      }
export function useListFailingClassificationValidationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListFailingClassificationValidationsQuery, ListFailingClassificationValidationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListFailingClassificationValidationsQuery, ListFailingClassificationValidationsQueryVariables>(ListFailingClassificationValidationsDocument, options);
        }
export function useListFailingClassificationValidationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListFailingClassificationValidationsQuery, ListFailingClassificationValidationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListFailingClassificationValidationsQuery, ListFailingClassificationValidationsQueryVariables>(ListFailingClassificationValidationsDocument, options);
        }
export type ListFailingClassificationValidationsQueryHookResult = ReturnType<typeof useListFailingClassificationValidationsQuery>;
export type ListFailingClassificationValidationsLazyQueryHookResult = ReturnType<typeof useListFailingClassificationValidationsLazyQuery>;
export type ListFailingClassificationValidationsSuspenseQueryHookResult = ReturnType<typeof useListFailingClassificationValidationsSuspenseQuery>;
export type ListFailingClassificationValidationsQueryResult = Apollo.QueryResult<ListFailingClassificationValidationsQuery, ListFailingClassificationValidationsQueryVariables>;
export const ListMismatchedQuickbooksBalanceSheetCategoriesDocument = gql`
    query ListMismatchedQuickbooksBalanceSheetCategories($legalEntityId: String!) {
  listMismatchedQuickbooksBalanceSheetCategories(legalEntityId: $legalEntityId) {
    ...MismatchedQuickbooksBalanceSheetCategoryFields
  }
}
    ${MismatchedQuickbooksBalanceSheetCategoryFieldsFragmentDoc}`;

/**
 * __useListMismatchedQuickbooksBalanceSheetCategoriesQuery__
 *
 * To run a query within a React component, call `useListMismatchedQuickbooksBalanceSheetCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMismatchedQuickbooksBalanceSheetCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMismatchedQuickbooksBalanceSheetCategoriesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListMismatchedQuickbooksBalanceSheetCategoriesQuery(baseOptions: Apollo.QueryHookOptions<ListMismatchedQuickbooksBalanceSheetCategoriesQuery, ListMismatchedQuickbooksBalanceSheetCategoriesQueryVariables> & ({ variables: ListMismatchedQuickbooksBalanceSheetCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMismatchedQuickbooksBalanceSheetCategoriesQuery, ListMismatchedQuickbooksBalanceSheetCategoriesQueryVariables>(ListMismatchedQuickbooksBalanceSheetCategoriesDocument, options);
      }
export function useListMismatchedQuickbooksBalanceSheetCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMismatchedQuickbooksBalanceSheetCategoriesQuery, ListMismatchedQuickbooksBalanceSheetCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMismatchedQuickbooksBalanceSheetCategoriesQuery, ListMismatchedQuickbooksBalanceSheetCategoriesQueryVariables>(ListMismatchedQuickbooksBalanceSheetCategoriesDocument, options);
        }
export function useListMismatchedQuickbooksBalanceSheetCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListMismatchedQuickbooksBalanceSheetCategoriesQuery, ListMismatchedQuickbooksBalanceSheetCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListMismatchedQuickbooksBalanceSheetCategoriesQuery, ListMismatchedQuickbooksBalanceSheetCategoriesQueryVariables>(ListMismatchedQuickbooksBalanceSheetCategoriesDocument, options);
        }
export type ListMismatchedQuickbooksBalanceSheetCategoriesQueryHookResult = ReturnType<typeof useListMismatchedQuickbooksBalanceSheetCategoriesQuery>;
export type ListMismatchedQuickbooksBalanceSheetCategoriesLazyQueryHookResult = ReturnType<typeof useListMismatchedQuickbooksBalanceSheetCategoriesLazyQuery>;
export type ListMismatchedQuickbooksBalanceSheetCategoriesSuspenseQueryHookResult = ReturnType<typeof useListMismatchedQuickbooksBalanceSheetCategoriesSuspenseQuery>;
export type ListMismatchedQuickbooksBalanceSheetCategoriesQueryResult = Apollo.QueryResult<ListMismatchedQuickbooksBalanceSheetCategoriesQuery, ListMismatchedQuickbooksBalanceSheetCategoriesQueryVariables>;
export const ListMismatchedQuickbooksCategoriesDocument = gql`
    query ListMismatchedQuickbooksCategories($legalEntityId: String!) {
  listMismatchedQuickbooksCategories(legalEntityId: $legalEntityId) {
    ...MismatchedQuickbooksCategoryFields
  }
}
    ${MismatchedQuickbooksCategoryFieldsFragmentDoc}`;

/**
 * __useListMismatchedQuickbooksCategoriesQuery__
 *
 * To run a query within a React component, call `useListMismatchedQuickbooksCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMismatchedQuickbooksCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMismatchedQuickbooksCategoriesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListMismatchedQuickbooksCategoriesQuery(baseOptions: Apollo.QueryHookOptions<ListMismatchedQuickbooksCategoriesQuery, ListMismatchedQuickbooksCategoriesQueryVariables> & ({ variables: ListMismatchedQuickbooksCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMismatchedQuickbooksCategoriesQuery, ListMismatchedQuickbooksCategoriesQueryVariables>(ListMismatchedQuickbooksCategoriesDocument, options);
      }
export function useListMismatchedQuickbooksCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMismatchedQuickbooksCategoriesQuery, ListMismatchedQuickbooksCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMismatchedQuickbooksCategoriesQuery, ListMismatchedQuickbooksCategoriesQueryVariables>(ListMismatchedQuickbooksCategoriesDocument, options);
        }
export function useListMismatchedQuickbooksCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListMismatchedQuickbooksCategoriesQuery, ListMismatchedQuickbooksCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListMismatchedQuickbooksCategoriesQuery, ListMismatchedQuickbooksCategoriesQueryVariables>(ListMismatchedQuickbooksCategoriesDocument, options);
        }
export type ListMismatchedQuickbooksCategoriesQueryHookResult = ReturnType<typeof useListMismatchedQuickbooksCategoriesQuery>;
export type ListMismatchedQuickbooksCategoriesLazyQueryHookResult = ReturnType<typeof useListMismatchedQuickbooksCategoriesLazyQuery>;
export type ListMismatchedQuickbooksCategoriesSuspenseQueryHookResult = ReturnType<typeof useListMismatchedQuickbooksCategoriesSuspenseQuery>;
export type ListMismatchedQuickbooksCategoriesQueryResult = Apollo.QueryResult<ListMismatchedQuickbooksCategoriesQuery, ListMismatchedQuickbooksCategoriesQueryVariables>;
export const ListUnsupportedTransactionsDocument = gql`
    query ListUnsupportedTransactions($legalEntityId: String!) {
  listUnsupportedTransactions(legalEntityId: $legalEntityId) {
    ...UnsupportedTransactionsFields
  }
}
    ${UnsupportedTransactionsFieldsFragmentDoc}`;

/**
 * __useListUnsupportedTransactionsQuery__
 *
 * To run a query within a React component, call `useListUnsupportedTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUnsupportedTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUnsupportedTransactionsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListUnsupportedTransactionsQuery(baseOptions: Apollo.QueryHookOptions<ListUnsupportedTransactionsQuery, ListUnsupportedTransactionsQueryVariables> & ({ variables: ListUnsupportedTransactionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUnsupportedTransactionsQuery, ListUnsupportedTransactionsQueryVariables>(ListUnsupportedTransactionsDocument, options);
      }
export function useListUnsupportedTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUnsupportedTransactionsQuery, ListUnsupportedTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUnsupportedTransactionsQuery, ListUnsupportedTransactionsQueryVariables>(ListUnsupportedTransactionsDocument, options);
        }
export function useListUnsupportedTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListUnsupportedTransactionsQuery, ListUnsupportedTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListUnsupportedTransactionsQuery, ListUnsupportedTransactionsQueryVariables>(ListUnsupportedTransactionsDocument, options);
        }
export type ListUnsupportedTransactionsQueryHookResult = ReturnType<typeof useListUnsupportedTransactionsQuery>;
export type ListUnsupportedTransactionsLazyQueryHookResult = ReturnType<typeof useListUnsupportedTransactionsLazyQuery>;
export type ListUnsupportedTransactionsSuspenseQueryHookResult = ReturnType<typeof useListUnsupportedTransactionsSuspenseQuery>;
export type ListUnsupportedTransactionsQueryResult = Apollo.QueryResult<ListUnsupportedTransactionsQuery, ListUnsupportedTransactionsQueryVariables>;
export const SummarizeClassificationValidationsDocument = gql`
    query SummarizeClassificationValidations {
  summarizeClassificationValidations {
    ...ClassificationValidationSummaryFields
  }
}
    ${ClassificationValidationSummaryFieldsFragmentDoc}`;

/**
 * __useSummarizeClassificationValidationsQuery__
 *
 * To run a query within a React component, call `useSummarizeClassificationValidationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummarizeClassificationValidationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummarizeClassificationValidationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSummarizeClassificationValidationsQuery(baseOptions?: Apollo.QueryHookOptions<SummarizeClassificationValidationsQuery, SummarizeClassificationValidationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummarizeClassificationValidationsQuery, SummarizeClassificationValidationsQueryVariables>(SummarizeClassificationValidationsDocument, options);
      }
export function useSummarizeClassificationValidationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummarizeClassificationValidationsQuery, SummarizeClassificationValidationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummarizeClassificationValidationsQuery, SummarizeClassificationValidationsQueryVariables>(SummarizeClassificationValidationsDocument, options);
        }
export function useSummarizeClassificationValidationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SummarizeClassificationValidationsQuery, SummarizeClassificationValidationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SummarizeClassificationValidationsQuery, SummarizeClassificationValidationsQueryVariables>(SummarizeClassificationValidationsDocument, options);
        }
export type SummarizeClassificationValidationsQueryHookResult = ReturnType<typeof useSummarizeClassificationValidationsQuery>;
export type SummarizeClassificationValidationsLazyQueryHookResult = ReturnType<typeof useSummarizeClassificationValidationsLazyQuery>;
export type SummarizeClassificationValidationsSuspenseQueryHookResult = ReturnType<typeof useSummarizeClassificationValidationsSuspenseQuery>;
export type SummarizeClassificationValidationsQueryResult = Apollo.QueryResult<SummarizeClassificationValidationsQuery, SummarizeClassificationValidationsQueryVariables>;
export const SummarizeDataSourceFetchesDocument = gql`
    query SummarizeDataSourceFetches {
  summarizeDataSourceFetches {
    ...SummarizeDataSourceFetchesFields
  }
}
    ${SummarizeDataSourceFetchesFieldsFragmentDoc}`;

/**
 * __useSummarizeDataSourceFetchesQuery__
 *
 * To run a query within a React component, call `useSummarizeDataSourceFetchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummarizeDataSourceFetchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummarizeDataSourceFetchesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSummarizeDataSourceFetchesQuery(baseOptions?: Apollo.QueryHookOptions<SummarizeDataSourceFetchesQuery, SummarizeDataSourceFetchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummarizeDataSourceFetchesQuery, SummarizeDataSourceFetchesQueryVariables>(SummarizeDataSourceFetchesDocument, options);
      }
export function useSummarizeDataSourceFetchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummarizeDataSourceFetchesQuery, SummarizeDataSourceFetchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummarizeDataSourceFetchesQuery, SummarizeDataSourceFetchesQueryVariables>(SummarizeDataSourceFetchesDocument, options);
        }
export function useSummarizeDataSourceFetchesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SummarizeDataSourceFetchesQuery, SummarizeDataSourceFetchesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SummarizeDataSourceFetchesQuery, SummarizeDataSourceFetchesQueryVariables>(SummarizeDataSourceFetchesDocument, options);
        }
export type SummarizeDataSourceFetchesQueryHookResult = ReturnType<typeof useSummarizeDataSourceFetchesQuery>;
export type SummarizeDataSourceFetchesLazyQueryHookResult = ReturnType<typeof useSummarizeDataSourceFetchesLazyQuery>;
export type SummarizeDataSourceFetchesSuspenseQueryHookResult = ReturnType<typeof useSummarizeDataSourceFetchesSuspenseQuery>;
export type SummarizeDataSourceFetchesQueryResult = Apollo.QueryResult<SummarizeDataSourceFetchesQuery, SummarizeDataSourceFetchesQueryVariables>;
export const SummarizeViewGenerationDocument = gql`
    query SummarizeViewGeneration {
  summarizeViewGeneration {
    ...SummarizeViewGenerationFields
  }
}
    ${SummarizeViewGenerationFieldsFragmentDoc}`;

/**
 * __useSummarizeViewGenerationQuery__
 *
 * To run a query within a React component, call `useSummarizeViewGenerationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummarizeViewGenerationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummarizeViewGenerationQuery({
 *   variables: {
 *   },
 * });
 */
export function useSummarizeViewGenerationQuery(baseOptions?: Apollo.QueryHookOptions<SummarizeViewGenerationQuery, SummarizeViewGenerationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummarizeViewGenerationQuery, SummarizeViewGenerationQueryVariables>(SummarizeViewGenerationDocument, options);
      }
export function useSummarizeViewGenerationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummarizeViewGenerationQuery, SummarizeViewGenerationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummarizeViewGenerationQuery, SummarizeViewGenerationQueryVariables>(SummarizeViewGenerationDocument, options);
        }
export function useSummarizeViewGenerationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SummarizeViewGenerationQuery, SummarizeViewGenerationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SummarizeViewGenerationQuery, SummarizeViewGenerationQueryVariables>(SummarizeViewGenerationDocument, options);
        }
export type SummarizeViewGenerationQueryHookResult = ReturnType<typeof useSummarizeViewGenerationQuery>;
export type SummarizeViewGenerationLazyQueryHookResult = ReturnType<typeof useSummarizeViewGenerationLazyQuery>;
export type SummarizeViewGenerationSuspenseQueryHookResult = ReturnType<typeof useSummarizeViewGenerationSuspenseQuery>;
export type SummarizeViewGenerationQueryResult = Apollo.QueryResult<SummarizeViewGenerationQuery, SummarizeViewGenerationQueryVariables>;
export const ReadAdminGlobalVanityStatsDocument = gql`
    query ReadAdminGlobalVanityStats {
  readGlobalVanityStats {
    ...AdminGlobalVanityStatsFields
  }
}
    ${AdminGlobalVanityStatsFieldsFragmentDoc}`;

/**
 * __useReadAdminGlobalVanityStatsQuery__
 *
 * To run a query within a React component, call `useReadAdminGlobalVanityStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadAdminGlobalVanityStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadAdminGlobalVanityStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useReadAdminGlobalVanityStatsQuery(baseOptions?: Apollo.QueryHookOptions<ReadAdminGlobalVanityStatsQuery, ReadAdminGlobalVanityStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadAdminGlobalVanityStatsQuery, ReadAdminGlobalVanityStatsQueryVariables>(ReadAdminGlobalVanityStatsDocument, options);
      }
export function useReadAdminGlobalVanityStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadAdminGlobalVanityStatsQuery, ReadAdminGlobalVanityStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadAdminGlobalVanityStatsQuery, ReadAdminGlobalVanityStatsQueryVariables>(ReadAdminGlobalVanityStatsDocument, options);
        }
export function useReadAdminGlobalVanityStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadAdminGlobalVanityStatsQuery, ReadAdminGlobalVanityStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadAdminGlobalVanityStatsQuery, ReadAdminGlobalVanityStatsQueryVariables>(ReadAdminGlobalVanityStatsDocument, options);
        }
export type ReadAdminGlobalVanityStatsQueryHookResult = ReturnType<typeof useReadAdminGlobalVanityStatsQuery>;
export type ReadAdminGlobalVanityStatsLazyQueryHookResult = ReturnType<typeof useReadAdminGlobalVanityStatsLazyQuery>;
export type ReadAdminGlobalVanityStatsSuspenseQueryHookResult = ReturnType<typeof useReadAdminGlobalVanityStatsSuspenseQuery>;
export type ReadAdminGlobalVanityStatsQueryResult = Apollo.QueryResult<ReadAdminGlobalVanityStatsQuery, ReadAdminGlobalVanityStatsQueryVariables>;
export const ReadAdminVanityStatsDocument = gql`
    query ReadAdminVanityStats($legalEntityId: String!) {
  readVanityStats(legalEntityId: $legalEntityId) {
    ...AdminVanityStatsFields
  }
}
    ${AdminVanityStatsFieldsFragmentDoc}`;

/**
 * __useReadAdminVanityStatsQuery__
 *
 * To run a query within a React component, call `useReadAdminVanityStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadAdminVanityStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadAdminVanityStatsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useReadAdminVanityStatsQuery(baseOptions: Apollo.QueryHookOptions<ReadAdminVanityStatsQuery, ReadAdminVanityStatsQueryVariables> & ({ variables: ReadAdminVanityStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadAdminVanityStatsQuery, ReadAdminVanityStatsQueryVariables>(ReadAdminVanityStatsDocument, options);
      }
export function useReadAdminVanityStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadAdminVanityStatsQuery, ReadAdminVanityStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadAdminVanityStatsQuery, ReadAdminVanityStatsQueryVariables>(ReadAdminVanityStatsDocument, options);
        }
export function useReadAdminVanityStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadAdminVanityStatsQuery, ReadAdminVanityStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadAdminVanityStatsQuery, ReadAdminVanityStatsQueryVariables>(ReadAdminVanityStatsDocument, options);
        }
export type ReadAdminVanityStatsQueryHookResult = ReturnType<typeof useReadAdminVanityStatsQuery>;
export type ReadAdminVanityStatsLazyQueryHookResult = ReturnType<typeof useReadAdminVanityStatsLazyQuery>;
export type ReadAdminVanityStatsSuspenseQueryHookResult = ReturnType<typeof useReadAdminVanityStatsSuspenseQuery>;
export type ReadAdminVanityStatsQueryResult = Apollo.QueryResult<ReadAdminVanityStatsQuery, ReadAdminVanityStatsQueryVariables>;
export const ExecuteFbqQueryDocument = gql`
    query ExecuteFbqQuery($viewKey: ViewKey!, $expression: String!) {
  executeFbqQuery(viewKey: $viewKey, expression: $expression) {
    resultJson
  }
}
    `;

/**
 * __useExecuteFbqQueryQuery__
 *
 * To run a query within a React component, call `useExecuteFbqQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useExecuteFbqQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExecuteFbqQueryQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      expression: // value for 'expression'
 *   },
 * });
 */
export function useExecuteFbqQueryQuery(baseOptions: Apollo.QueryHookOptions<ExecuteFbqQueryQuery, ExecuteFbqQueryQueryVariables> & ({ variables: ExecuteFbqQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExecuteFbqQueryQuery, ExecuteFbqQueryQueryVariables>(ExecuteFbqQueryDocument, options);
      }
export function useExecuteFbqQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExecuteFbqQueryQuery, ExecuteFbqQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExecuteFbqQueryQuery, ExecuteFbqQueryQueryVariables>(ExecuteFbqQueryDocument, options);
        }
export function useExecuteFbqQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExecuteFbqQueryQuery, ExecuteFbqQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExecuteFbqQueryQuery, ExecuteFbqQueryQueryVariables>(ExecuteFbqQueryDocument, options);
        }
export type ExecuteFbqQueryQueryHookResult = ReturnType<typeof useExecuteFbqQueryQuery>;
export type ExecuteFbqQueryLazyQueryHookResult = ReturnType<typeof useExecuteFbqQueryLazyQuery>;
export type ExecuteFbqQuerySuspenseQueryHookResult = ReturnType<typeof useExecuteFbqQuerySuspenseQuery>;
export type ExecuteFbqQueryQueryResult = Apollo.QueryResult<ExecuteFbqQueryQuery, ExecuteFbqQueryQueryVariables>;
export const ReadActiveViewVersionDocument = gql`
    query ReadActiveViewVersion($legalEntityId: String!, $viewType: ViewType!) {
  readActiveViewVersion(legalEntityId: $legalEntityId, viewType: $viewType) {
    legalEntityId
    viewVersion
    viewType
  }
}
    `;

/**
 * __useReadActiveViewVersionQuery__
 *
 * To run a query within a React component, call `useReadActiveViewVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadActiveViewVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadActiveViewVersionQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      viewType: // value for 'viewType'
 *   },
 * });
 */
export function useReadActiveViewVersionQuery(baseOptions: Apollo.QueryHookOptions<ReadActiveViewVersionQuery, ReadActiveViewVersionQueryVariables> & ({ variables: ReadActiveViewVersionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadActiveViewVersionQuery, ReadActiveViewVersionQueryVariables>(ReadActiveViewVersionDocument, options);
      }
export function useReadActiveViewVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadActiveViewVersionQuery, ReadActiveViewVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadActiveViewVersionQuery, ReadActiveViewVersionQueryVariables>(ReadActiveViewVersionDocument, options);
        }
export function useReadActiveViewVersionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadActiveViewVersionQuery, ReadActiveViewVersionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadActiveViewVersionQuery, ReadActiveViewVersionQueryVariables>(ReadActiveViewVersionDocument, options);
        }
export type ReadActiveViewVersionQueryHookResult = ReturnType<typeof useReadActiveViewVersionQuery>;
export type ReadActiveViewVersionLazyQueryHookResult = ReturnType<typeof useReadActiveViewVersionLazyQuery>;
export type ReadActiveViewVersionSuspenseQueryHookResult = ReturnType<typeof useReadActiveViewVersionSuspenseQuery>;
export type ReadActiveViewVersionQueryResult = Apollo.QueryResult<ReadActiveViewVersionQuery, ReadActiveViewVersionQueryVariables>;
export const GetWorkflowDocument = gql`
    query GetWorkflow($legalEntityID: String!, $workflowID: String!) {
  getWorkflow(legalEntityID: $legalEntityID, workflowID: $workflowID) {
    workflow {
      legalEntityID
      workflowID
      definitionName
      definitionVersion
      status
      error
      createdAt
      updatedAt
      completedAt
      inputTypeName
      outputTypeName
    }
    futures {
      futureID
      kind
      regionPath
      status
      deadline
      createdAt
      resolvedAt
      deliveredAt
    }
  }
}
    `;

/**
 * __useGetWorkflowQuery__
 *
 * To run a query within a React component, call `useGetWorkflowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowQuery({
 *   variables: {
 *      legalEntityID: // value for 'legalEntityID'
 *      workflowID: // value for 'workflowID'
 *   },
 * });
 */
export function useGetWorkflowQuery(baseOptions: Apollo.QueryHookOptions<GetWorkflowQuery, GetWorkflowQueryVariables> & ({ variables: GetWorkflowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkflowQuery, GetWorkflowQueryVariables>(GetWorkflowDocument, options);
      }
export function useGetWorkflowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkflowQuery, GetWorkflowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkflowQuery, GetWorkflowQueryVariables>(GetWorkflowDocument, options);
        }
export function useGetWorkflowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkflowQuery, GetWorkflowQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkflowQuery, GetWorkflowQueryVariables>(GetWorkflowDocument, options);
        }
export type GetWorkflowQueryHookResult = ReturnType<typeof useGetWorkflowQuery>;
export type GetWorkflowLazyQueryHookResult = ReturnType<typeof useGetWorkflowLazyQuery>;
export type GetWorkflowSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowSuspenseQuery>;
export type GetWorkflowQueryResult = Apollo.QueryResult<GetWorkflowQuery, GetWorkflowQueryVariables>;
export const GetWorkflowHistoryDocument = gql`
    query GetWorkflowHistory($legalEntityID: String!, $workflowID: String!) {
  getWorkflowHistory(legalEntityID: $legalEntityID, workflowID: $workflowID) {
    legalEntityID
    workflowID
    workflowLogID
    regionPath
    eventKind
    actionID
    errorMessage
    createdAt
    resultTypeName
  }
}
    `;

/**
 * __useGetWorkflowHistoryQuery__
 *
 * To run a query within a React component, call `useGetWorkflowHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowHistoryQuery({
 *   variables: {
 *      legalEntityID: // value for 'legalEntityID'
 *      workflowID: // value for 'workflowID'
 *   },
 * });
 */
export function useGetWorkflowHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetWorkflowHistoryQuery, GetWorkflowHistoryQueryVariables> & ({ variables: GetWorkflowHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkflowHistoryQuery, GetWorkflowHistoryQueryVariables>(GetWorkflowHistoryDocument, options);
      }
export function useGetWorkflowHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkflowHistoryQuery, GetWorkflowHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkflowHistoryQuery, GetWorkflowHistoryQueryVariables>(GetWorkflowHistoryDocument, options);
        }
export function useGetWorkflowHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkflowHistoryQuery, GetWorkflowHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkflowHistoryQuery, GetWorkflowHistoryQueryVariables>(GetWorkflowHistoryDocument, options);
        }
export type GetWorkflowHistoryQueryHookResult = ReturnType<typeof useGetWorkflowHistoryQuery>;
export type GetWorkflowHistoryLazyQueryHookResult = ReturnType<typeof useGetWorkflowHistoryLazyQuery>;
export type GetWorkflowHistorySuspenseQueryHookResult = ReturnType<typeof useGetWorkflowHistorySuspenseQuery>;
export type GetWorkflowHistoryQueryResult = Apollo.QueryResult<GetWorkflowHistoryQuery, GetWorkflowHistoryQueryVariables>;
export const GetWorkflowInputDocument = gql`
    query GetWorkflowInput($legalEntityID: String!, $workflowID: String!) {
  getWorkflowInput(legalEntityID: $legalEntityID, workflowID: $workflowID) {
    json
    typeName
    bytesSize
    decodeError
  }
}
    `;

/**
 * __useGetWorkflowInputQuery__
 *
 * To run a query within a React component, call `useGetWorkflowInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowInputQuery({
 *   variables: {
 *      legalEntityID: // value for 'legalEntityID'
 *      workflowID: // value for 'workflowID'
 *   },
 * });
 */
export function useGetWorkflowInputQuery(baseOptions: Apollo.QueryHookOptions<GetWorkflowInputQuery, GetWorkflowInputQueryVariables> & ({ variables: GetWorkflowInputQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkflowInputQuery, GetWorkflowInputQueryVariables>(GetWorkflowInputDocument, options);
      }
export function useGetWorkflowInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkflowInputQuery, GetWorkflowInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkflowInputQuery, GetWorkflowInputQueryVariables>(GetWorkflowInputDocument, options);
        }
export function useGetWorkflowInputSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkflowInputQuery, GetWorkflowInputQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkflowInputQuery, GetWorkflowInputQueryVariables>(GetWorkflowInputDocument, options);
        }
export type GetWorkflowInputQueryHookResult = ReturnType<typeof useGetWorkflowInputQuery>;
export type GetWorkflowInputLazyQueryHookResult = ReturnType<typeof useGetWorkflowInputLazyQuery>;
export type GetWorkflowInputSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowInputSuspenseQuery>;
export type GetWorkflowInputQueryResult = Apollo.QueryResult<GetWorkflowInputQuery, GetWorkflowInputQueryVariables>;
export const GetWorkflowOutputDocument = gql`
    query GetWorkflowOutput($legalEntityID: String!, $workflowID: String!) {
  getWorkflowOutput(legalEntityID: $legalEntityID, workflowID: $workflowID) {
    json
    typeName
    bytesSize
    decodeError
  }
}
    `;

/**
 * __useGetWorkflowOutputQuery__
 *
 * To run a query within a React component, call `useGetWorkflowOutputQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowOutputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowOutputQuery({
 *   variables: {
 *      legalEntityID: // value for 'legalEntityID'
 *      workflowID: // value for 'workflowID'
 *   },
 * });
 */
export function useGetWorkflowOutputQuery(baseOptions: Apollo.QueryHookOptions<GetWorkflowOutputQuery, GetWorkflowOutputQueryVariables> & ({ variables: GetWorkflowOutputQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkflowOutputQuery, GetWorkflowOutputQueryVariables>(GetWorkflowOutputDocument, options);
      }
export function useGetWorkflowOutputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkflowOutputQuery, GetWorkflowOutputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkflowOutputQuery, GetWorkflowOutputQueryVariables>(GetWorkflowOutputDocument, options);
        }
export function useGetWorkflowOutputSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkflowOutputQuery, GetWorkflowOutputQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkflowOutputQuery, GetWorkflowOutputQueryVariables>(GetWorkflowOutputDocument, options);
        }
export type GetWorkflowOutputQueryHookResult = ReturnType<typeof useGetWorkflowOutputQuery>;
export type GetWorkflowOutputLazyQueryHookResult = ReturnType<typeof useGetWorkflowOutputLazyQuery>;
export type GetWorkflowOutputSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowOutputSuspenseQuery>;
export type GetWorkflowOutputQueryResult = Apollo.QueryResult<GetWorkflowOutputQuery, GetWorkflowOutputQueryVariables>;
export const GetWorkflowStepResultDocument = gql`
    query GetWorkflowStepResult($legalEntityID: String!, $workflowID: String!, $workflowLogID: String!) {
  getWorkflowStepResult(
    legalEntityID: $legalEntityID
    workflowID: $workflowID
    workflowLogID: $workflowLogID
  ) {
    json
    typeName
    bytesSize
    decodeError
  }
}
    `;

/**
 * __useGetWorkflowStepResultQuery__
 *
 * To run a query within a React component, call `useGetWorkflowStepResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowStepResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowStepResultQuery({
 *   variables: {
 *      legalEntityID: // value for 'legalEntityID'
 *      workflowID: // value for 'workflowID'
 *      workflowLogID: // value for 'workflowLogID'
 *   },
 * });
 */
export function useGetWorkflowStepResultQuery(baseOptions: Apollo.QueryHookOptions<GetWorkflowStepResultQuery, GetWorkflowStepResultQueryVariables> & ({ variables: GetWorkflowStepResultQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkflowStepResultQuery, GetWorkflowStepResultQueryVariables>(GetWorkflowStepResultDocument, options);
      }
export function useGetWorkflowStepResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkflowStepResultQuery, GetWorkflowStepResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkflowStepResultQuery, GetWorkflowStepResultQueryVariables>(GetWorkflowStepResultDocument, options);
        }
export function useGetWorkflowStepResultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkflowStepResultQuery, GetWorkflowStepResultQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkflowStepResultQuery, GetWorkflowStepResultQueryVariables>(GetWorkflowStepResultDocument, options);
        }
export type GetWorkflowStepResultQueryHookResult = ReturnType<typeof useGetWorkflowStepResultQuery>;
export type GetWorkflowStepResultLazyQueryHookResult = ReturnType<typeof useGetWorkflowStepResultLazyQuery>;
export type GetWorkflowStepResultSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowStepResultSuspenseQuery>;
export type GetWorkflowStepResultQueryResult = Apollo.QueryResult<GetWorkflowStepResultQuery, GetWorkflowStepResultQueryVariables>;
export const ListAllWorkflowsDocument = gql`
    query ListAllWorkflows($status: WorkflowStatus, $definitionName: String, $pagination: Pagination!) {
  listAllWorkflows(
    status: $status
    definitionName: $definitionName
    pagination: $pagination
  ) {
    legalEntityID
    workflowID
    definitionName
    status
    createdAt
  }
}
    `;

/**
 * __useListAllWorkflowsQuery__
 *
 * To run a query within a React component, call `useListAllWorkflowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAllWorkflowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAllWorkflowsQuery({
 *   variables: {
 *      status: // value for 'status'
 *      definitionName: // value for 'definitionName'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useListAllWorkflowsQuery(baseOptions: Apollo.QueryHookOptions<ListAllWorkflowsQuery, ListAllWorkflowsQueryVariables> & ({ variables: ListAllWorkflowsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAllWorkflowsQuery, ListAllWorkflowsQueryVariables>(ListAllWorkflowsDocument, options);
      }
export function useListAllWorkflowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAllWorkflowsQuery, ListAllWorkflowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAllWorkflowsQuery, ListAllWorkflowsQueryVariables>(ListAllWorkflowsDocument, options);
        }
export function useListAllWorkflowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAllWorkflowsQuery, ListAllWorkflowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAllWorkflowsQuery, ListAllWorkflowsQueryVariables>(ListAllWorkflowsDocument, options);
        }
export type ListAllWorkflowsQueryHookResult = ReturnType<typeof useListAllWorkflowsQuery>;
export type ListAllWorkflowsLazyQueryHookResult = ReturnType<typeof useListAllWorkflowsLazyQuery>;
export type ListAllWorkflowsSuspenseQueryHookResult = ReturnType<typeof useListAllWorkflowsSuspenseQuery>;
export type ListAllWorkflowsQueryResult = Apollo.QueryResult<ListAllWorkflowsQuery, ListAllWorkflowsQueryVariables>;
export const ListWorkflowsDocument = gql`
    query ListWorkflows($legalEntityID: String!, $status: WorkflowStatus, $definitionName: String, $pagination: Pagination!) {
  listWorkflows(
    legalEntityID: $legalEntityID
    status: $status
    definitionName: $definitionName
    pagination: $pagination
  ) {
    legalEntityID
    workflowID
    definitionName
    definitionVersion
    status
    error
    createdAt
    updatedAt
    completedAt
  }
}
    `;

/**
 * __useListWorkflowsQuery__
 *
 * To run a query within a React component, call `useListWorkflowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListWorkflowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListWorkflowsQuery({
 *   variables: {
 *      legalEntityID: // value for 'legalEntityID'
 *      status: // value for 'status'
 *      definitionName: // value for 'definitionName'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useListWorkflowsQuery(baseOptions: Apollo.QueryHookOptions<ListWorkflowsQuery, ListWorkflowsQueryVariables> & ({ variables: ListWorkflowsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListWorkflowsQuery, ListWorkflowsQueryVariables>(ListWorkflowsDocument, options);
      }
export function useListWorkflowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListWorkflowsQuery, ListWorkflowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListWorkflowsQuery, ListWorkflowsQueryVariables>(ListWorkflowsDocument, options);
        }
export function useListWorkflowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListWorkflowsQuery, ListWorkflowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListWorkflowsQuery, ListWorkflowsQueryVariables>(ListWorkflowsDocument, options);
        }
export type ListWorkflowsQueryHookResult = ReturnType<typeof useListWorkflowsQuery>;
export type ListWorkflowsLazyQueryHookResult = ReturnType<typeof useListWorkflowsLazyQuery>;
export type ListWorkflowsSuspenseQueryHookResult = ReturnType<typeof useListWorkflowsSuspenseQuery>;
export type ListWorkflowsQueryResult = Apollo.QueryResult<ListWorkflowsQuery, ListWorkflowsQueryVariables>;
export const WorkflowActivityDocument = gql`
    subscription WorkflowActivity($legalEntityID: String!) {
  workflowActivity(legalEntityID: $legalEntityID) {
    legalEntityID
    workflowID
    definitionName
    eventKind
    errorMessage
    timestamp
  }
}
    `;

/**
 * __useWorkflowActivitySubscription__
 *
 * To run a query within a React component, call `useWorkflowActivitySubscription` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowActivitySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowActivitySubscription({
 *   variables: {
 *      legalEntityID: // value for 'legalEntityID'
 *   },
 * });
 */
export function useWorkflowActivitySubscription(baseOptions: Apollo.SubscriptionHookOptions<WorkflowActivitySubscription, WorkflowActivitySubscriptionVariables> & ({ variables: WorkflowActivitySubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WorkflowActivitySubscription, WorkflowActivitySubscriptionVariables>(WorkflowActivityDocument, options);
      }
export type WorkflowActivitySubscriptionHookResult = ReturnType<typeof useWorkflowActivitySubscription>;
export type WorkflowActivitySubscriptionResult = Apollo.SubscriptionResult<WorkflowActivitySubscription>;
export const WorkflowLogEventsDocument = gql`
    subscription WorkflowLogEvents($legalEntityID: String!, $workflowID: String!) {
  workflowLogEvents(legalEntityID: $legalEntityID, workflowID: $workflowID) {
    legalEntityID
    workflowID
    workflowLogID
    definitionName
    regionPath
    eventKind
    actionID
    errorMessage
    timestamp
  }
}
    `;

/**
 * __useWorkflowLogEventsSubscription__
 *
 * To run a query within a React component, call `useWorkflowLogEventsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowLogEventsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowLogEventsSubscription({
 *   variables: {
 *      legalEntityID: // value for 'legalEntityID'
 *      workflowID: // value for 'workflowID'
 *   },
 * });
 */
export function useWorkflowLogEventsSubscription(baseOptions: Apollo.SubscriptionHookOptions<WorkflowLogEventsSubscription, WorkflowLogEventsSubscriptionVariables> & ({ variables: WorkflowLogEventsSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WorkflowLogEventsSubscription, WorkflowLogEventsSubscriptionVariables>(WorkflowLogEventsDocument, options);
      }
export type WorkflowLogEventsSubscriptionHookResult = ReturnType<typeof useWorkflowLogEventsSubscription>;
export type WorkflowLogEventsSubscriptionResult = Apollo.SubscriptionResult<WorkflowLogEventsSubscription>;
export const ResetWorkItemDocument = gql`
    mutation ResetWorkItem($workItemId: String!) {
  resetWorkItem(workItemId: $workItemId)
}
    `;
export type ResetWorkItemMutationFn = Apollo.MutationFunction<ResetWorkItemMutation, ResetWorkItemMutationVariables>;

/**
 * __useResetWorkItemMutation__
 *
 * To run a mutation, you first call `useResetWorkItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetWorkItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetWorkItemMutation, { data, loading, error }] = useResetWorkItemMutation({
 *   variables: {
 *      workItemId: // value for 'workItemId'
 *   },
 * });
 */
export function useResetWorkItemMutation(baseOptions?: Apollo.MutationHookOptions<ResetWorkItemMutation, ResetWorkItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetWorkItemMutation, ResetWorkItemMutationVariables>(ResetWorkItemDocument, options);
      }
export type ResetWorkItemMutationHookResult = ReturnType<typeof useResetWorkItemMutation>;
export type ResetWorkItemMutationResult = Apollo.MutationResult<ResetWorkItemMutation>;
export type ResetWorkItemMutationOptions = Apollo.BaseMutationOptions<ResetWorkItemMutation, ResetWorkItemMutationVariables>;
export const TriggerTransactionAuditCheckDocument = gql`
    mutation TriggerTransactionAuditCheck($transactionFactId: String!) {
  triggerTransactionAuditCheck(transactionFactId: $transactionFactId)
}
    `;
export type TriggerTransactionAuditCheckMutationFn = Apollo.MutationFunction<TriggerTransactionAuditCheckMutation, TriggerTransactionAuditCheckMutationVariables>;

/**
 * __useTriggerTransactionAuditCheckMutation__
 *
 * To run a mutation, you first call `useTriggerTransactionAuditCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerTransactionAuditCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerTransactionAuditCheckMutation, { data, loading, error }] = useTriggerTransactionAuditCheckMutation({
 *   variables: {
 *      transactionFactId: // value for 'transactionFactId'
 *   },
 * });
 */
export function useTriggerTransactionAuditCheckMutation(baseOptions?: Apollo.MutationHookOptions<TriggerTransactionAuditCheckMutation, TriggerTransactionAuditCheckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerTransactionAuditCheckMutation, TriggerTransactionAuditCheckMutationVariables>(TriggerTransactionAuditCheckDocument, options);
      }
export type TriggerTransactionAuditCheckMutationHookResult = ReturnType<typeof useTriggerTransactionAuditCheckMutation>;
export type TriggerTransactionAuditCheckMutationResult = Apollo.MutationResult<TriggerTransactionAuditCheckMutation>;
export type TriggerTransactionAuditCheckMutationOptions = Apollo.BaseMutationOptions<TriggerTransactionAuditCheckMutation, TriggerTransactionAuditCheckMutationVariables>;
export const GetEmbeddingDocument = gql`
    query GetEmbedding($transactionFactId: String!, $partyPrefix: String) {
  getEmbedding(transactionFactId: $transactionFactId, partyPrefix: $partyPrefix) {
    embeddingValue
    deployedIndexId
  }
}
    `;

/**
 * __useGetEmbeddingQuery__
 *
 * To run a query within a React component, call `useGetEmbeddingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmbeddingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmbeddingQuery({
 *   variables: {
 *      transactionFactId: // value for 'transactionFactId'
 *      partyPrefix: // value for 'partyPrefix'
 *   },
 * });
 */
export function useGetEmbeddingQuery(baseOptions: Apollo.QueryHookOptions<GetEmbeddingQuery, GetEmbeddingQueryVariables> & ({ variables: GetEmbeddingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmbeddingQuery, GetEmbeddingQueryVariables>(GetEmbeddingDocument, options);
      }
export function useGetEmbeddingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmbeddingQuery, GetEmbeddingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmbeddingQuery, GetEmbeddingQueryVariables>(GetEmbeddingDocument, options);
        }
export function useGetEmbeddingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmbeddingQuery, GetEmbeddingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmbeddingQuery, GetEmbeddingQueryVariables>(GetEmbeddingDocument, options);
        }
export type GetEmbeddingQueryHookResult = ReturnType<typeof useGetEmbeddingQuery>;
export type GetEmbeddingLazyQueryHookResult = ReturnType<typeof useGetEmbeddingLazyQuery>;
export type GetEmbeddingSuspenseQueryHookResult = ReturnType<typeof useGetEmbeddingSuspenseQuery>;
export type GetEmbeddingQueryResult = Apollo.QueryResult<GetEmbeddingQuery, GetEmbeddingQueryVariables>;
export const GetNeighborsDocument = gql`
    query GetNeighbors($deployedIndexId: String!, $floatVal: [Float!]!, $numNeighbors: Int, $restricts: [Namespace!], $perCrowdingAttributeNumNeighbors: Int, $approxNumNeighbors: Int, $leafNodesToSearchPercentOverride: Int) {
  getNeighbors(
    deployedIndexId: $deployedIndexId
    floatVal: $floatVal
    numNeighbors: $numNeighbors
    restricts: $restricts
    perCrowdingAttributeNumNeighbors: $perCrowdingAttributeNumNeighbors
    approxNumNeighbors: $approxNumNeighbors
    leafNodesToSearchPercentOverride: $leafNodesToSearchPercentOverride
  ) {
    neighbor {
      id
      distance
    }
  }
}
    `;

/**
 * __useGetNeighborsQuery__
 *
 * To run a query within a React component, call `useGetNeighborsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNeighborsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNeighborsQuery({
 *   variables: {
 *      deployedIndexId: // value for 'deployedIndexId'
 *      floatVal: // value for 'floatVal'
 *      numNeighbors: // value for 'numNeighbors'
 *      restricts: // value for 'restricts'
 *      perCrowdingAttributeNumNeighbors: // value for 'perCrowdingAttributeNumNeighbors'
 *      approxNumNeighbors: // value for 'approxNumNeighbors'
 *      leafNodesToSearchPercentOverride: // value for 'leafNodesToSearchPercentOverride'
 *   },
 * });
 */
export function useGetNeighborsQuery(baseOptions: Apollo.QueryHookOptions<GetNeighborsQuery, GetNeighborsQueryVariables> & ({ variables: GetNeighborsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNeighborsQuery, GetNeighborsQueryVariables>(GetNeighborsDocument, options);
      }
export function useGetNeighborsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNeighborsQuery, GetNeighborsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNeighborsQuery, GetNeighborsQueryVariables>(GetNeighborsDocument, options);
        }
export function useGetNeighborsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNeighborsQuery, GetNeighborsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNeighborsQuery, GetNeighborsQueryVariables>(GetNeighborsDocument, options);
        }
export type GetNeighborsQueryHookResult = ReturnType<typeof useGetNeighborsQuery>;
export type GetNeighborsLazyQueryHookResult = ReturnType<typeof useGetNeighborsLazyQuery>;
export type GetNeighborsSuspenseQueryHookResult = ReturnType<typeof useGetNeighborsSuspenseQuery>;
export type GetNeighborsQueryResult = Apollo.QueryResult<GetNeighborsQuery, GetNeighborsQueryVariables>;
export const GetTextEmbeddingDocument = gql`
    query GetTextEmbedding($text: String!) {
  getTextEmbedding(text: $text) {
    embeddingValue
    deployedIndexId
  }
}
    `;

/**
 * __useGetTextEmbeddingQuery__
 *
 * To run a query within a React component, call `useGetTextEmbeddingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTextEmbeddingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTextEmbeddingQuery({
 *   variables: {
 *      text: // value for 'text'
 *   },
 * });
 */
export function useGetTextEmbeddingQuery(baseOptions: Apollo.QueryHookOptions<GetTextEmbeddingQuery, GetTextEmbeddingQueryVariables> & ({ variables: GetTextEmbeddingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTextEmbeddingQuery, GetTextEmbeddingQueryVariables>(GetTextEmbeddingDocument, options);
      }
export function useGetTextEmbeddingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTextEmbeddingQuery, GetTextEmbeddingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTextEmbeddingQuery, GetTextEmbeddingQueryVariables>(GetTextEmbeddingDocument, options);
        }
export function useGetTextEmbeddingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTextEmbeddingQuery, GetTextEmbeddingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTextEmbeddingQuery, GetTextEmbeddingQueryVariables>(GetTextEmbeddingDocument, options);
        }
export type GetTextEmbeddingQueryHookResult = ReturnType<typeof useGetTextEmbeddingQuery>;
export type GetTextEmbeddingLazyQueryHookResult = ReturnType<typeof useGetTextEmbeddingLazyQuery>;
export type GetTextEmbeddingSuspenseQueryHookResult = ReturnType<typeof useGetTextEmbeddingSuspenseQuery>;
export type GetTextEmbeddingQueryResult = Apollo.QueryResult<GetTextEmbeddingQuery, GetTextEmbeddingQueryVariables>;
export const HighlightWorkItemDocument = gql`
    query HighlightWorkItem($similarityType: SimilarityType!, $description: String, $name: String) {
  highlightWorkItem(
    similarityType: $similarityType
    description: $description
    name: $name
  ) {
    ...HighlightedTokensFields
  }
}
    ${HighlightedTokensFieldsFragmentDoc}`;

/**
 * __useHighlightWorkItemQuery__
 *
 * To run a query within a React component, call `useHighlightWorkItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useHighlightWorkItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHighlightWorkItemQuery({
 *   variables: {
 *      similarityType: // value for 'similarityType'
 *      description: // value for 'description'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useHighlightWorkItemQuery(baseOptions: Apollo.QueryHookOptions<HighlightWorkItemQuery, HighlightWorkItemQueryVariables> & ({ variables: HighlightWorkItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HighlightWorkItemQuery, HighlightWorkItemQueryVariables>(HighlightWorkItemDocument, options);
      }
export function useHighlightWorkItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HighlightWorkItemQuery, HighlightWorkItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HighlightWorkItemQuery, HighlightWorkItemQueryVariables>(HighlightWorkItemDocument, options);
        }
export function useHighlightWorkItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HighlightWorkItemQuery, HighlightWorkItemQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HighlightWorkItemQuery, HighlightWorkItemQueryVariables>(HighlightWorkItemDocument, options);
        }
export type HighlightWorkItemQueryHookResult = ReturnType<typeof useHighlightWorkItemQuery>;
export type HighlightWorkItemLazyQueryHookResult = ReturnType<typeof useHighlightWorkItemLazyQuery>;
export type HighlightWorkItemSuspenseQueryHookResult = ReturnType<typeof useHighlightWorkItemSuspenseQuery>;
export type HighlightWorkItemQueryResult = Apollo.QueryResult<HighlightWorkItemQuery, HighlightWorkItemQueryVariables>;
export const ReadWorkItemDocument = gql`
    query ReadWorkItem($workItemId: String!) {
  readWorkItem(workItemId: $workItemId) {
    ...AdminWorkItemFields
  }
}
    ${AdminWorkItemFieldsFragmentDoc}`;

/**
 * __useReadWorkItemQuery__
 *
 * To run a query within a React component, call `useReadWorkItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadWorkItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadWorkItemQuery({
 *   variables: {
 *      workItemId: // value for 'workItemId'
 *   },
 * });
 */
export function useReadWorkItemQuery(baseOptions: Apollo.QueryHookOptions<ReadWorkItemQuery, ReadWorkItemQueryVariables> & ({ variables: ReadWorkItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadWorkItemQuery, ReadWorkItemQueryVariables>(ReadWorkItemDocument, options);
      }
export function useReadWorkItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadWorkItemQuery, ReadWorkItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadWorkItemQuery, ReadWorkItemQueryVariables>(ReadWorkItemDocument, options);
        }
export function useReadWorkItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadWorkItemQuery, ReadWorkItemQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadWorkItemQuery, ReadWorkItemQueryVariables>(ReadWorkItemDocument, options);
        }
export type ReadWorkItemQueryHookResult = ReturnType<typeof useReadWorkItemQuery>;
export type ReadWorkItemLazyQueryHookResult = ReturnType<typeof useReadWorkItemLazyQuery>;
export type ReadWorkItemSuspenseQueryHookResult = ReturnType<typeof useReadWorkItemSuspenseQuery>;
export type ReadWorkItemQueryResult = Apollo.QueryResult<ReadWorkItemQuery, ReadWorkItemQueryVariables>;
export const ReadWorkItemValidationDocument = gql`
    query ReadWorkItemValidation($legalEntityId: String!) {
  readWorkItemValidation(legalEntityId: $legalEntityId) {
    status
    workItemCount
  }
}
    `;

/**
 * __useReadWorkItemValidationQuery__
 *
 * To run a query within a React component, call `useReadWorkItemValidationQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadWorkItemValidationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadWorkItemValidationQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useReadWorkItemValidationQuery(baseOptions: Apollo.QueryHookOptions<ReadWorkItemValidationQuery, ReadWorkItemValidationQueryVariables> & ({ variables: ReadWorkItemValidationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadWorkItemValidationQuery, ReadWorkItemValidationQueryVariables>(ReadWorkItemValidationDocument, options);
      }
export function useReadWorkItemValidationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadWorkItemValidationQuery, ReadWorkItemValidationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadWorkItemValidationQuery, ReadWorkItemValidationQueryVariables>(ReadWorkItemValidationDocument, options);
        }
export function useReadWorkItemValidationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadWorkItemValidationQuery, ReadWorkItemValidationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadWorkItemValidationQuery, ReadWorkItemValidationQueryVariables>(ReadWorkItemValidationDocument, options);
        }
export type ReadWorkItemValidationQueryHookResult = ReturnType<typeof useReadWorkItemValidationQuery>;
export type ReadWorkItemValidationLazyQueryHookResult = ReturnType<typeof useReadWorkItemValidationLazyQuery>;
export type ReadWorkItemValidationSuspenseQueryHookResult = ReturnType<typeof useReadWorkItemValidationSuspenseQuery>;
export type ReadWorkItemValidationQueryResult = Apollo.QueryResult<ReadWorkItemValidationQuery, ReadWorkItemValidationQueryVariables>;